

if (function(t, e) {
		"object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.moment = e()
	}(this, function() {
		"use strict";
		var t, e;

		function i() {
			return t.apply(null, arguments)
		}

		function s(t) {
			return t instanceof Array || "[object Array]" === Object.prototype.toString.call(t)
		}

		function n(t) {
			return null != t && "[object Object]" === Object.prototype.toString.call(t)
		}

		function a(t) {
			return void 0 === t
		}

		function o(t) {
			return "number" == typeof t || "[object Number]" === Object.prototype.toString.call(t)
		}

		function r(t) {
			return t instanceof Date || "[object Date]" === Object.prototype.toString.call(t)
		}

		function l(t, e) {
			var i, s = [];
			for (i = 0; i < t.length; ++i) s.push(e(t[i], i));
			return s
		}

		function d(t, e) {
			return Object.prototype.hasOwnProperty.call(t, e)
		}

		function c(t, e) {
			for (var i in e) d(e, i) && (t[i] = e[i]);
			return d(e, "toString") && (t.toString = e.toString), d(e, "valueOf") && (t.valueOf = e.valueOf), t
		}

		function h(t, e, i, s) {
			return _e(t, e, i, s, !0).utc()
		}

		function u(t) {
			return null == t._pf && (t._pf = {
				empty: !1,
				unusedTokens: [],
				unusedInput: [],
				overflow: -2,
				charsLeftOver: 0,
				nullInput: !1,
				invalidMonth: null,
				invalidFormat: !1,
				userInvalidated: !1,
				iso: !1,
				parsedDateParts: [],
				meridiem: null,
				rfc2822: !1,
				weekdayMismatch: !1
			}), t._pf
		}

		function p(t) {
			if (null == t._isValid) {
				var i = u(t),
					s = e.call(i.parsedDateParts, function(t) {
						return null != t
					}),
					n = !isNaN(t._d.getTime()) && i.overflow < 0 && !i.empty && !i.invalidMonth && !i.invalidWeekday && !i.weekdayMismatch && !i.nullInput && !i.invalidFormat && !i.userInvalidated && (!i.meridiem || i.meridiem && s);
				if (t._strict && (n = n && 0 === i.charsLeftOver && 0 === i.unusedTokens.length && void 0 === i.bigHour), null != Object.isFrozen && Object.isFrozen(t)) return n;
				t._isValid = n
			}
			return t._isValid
		}

		function f(t) {
			var e = h(NaN);
			return null != t ? c(u(e), t) : u(e).userInvalidated = !0, e
		}
		e = Array.prototype.some ? Array.prototype.some : function(t) {
			for (var e = Object(this), i = e.length >>> 0, s = 0; s < i; s++)
				if (s in e && t.call(this, e[s], s, e)) return !0;
			return !1
		};
		var m = i.momentProperties = [];

		function g(t, e) {
			var i, s, n;
			if (a(e._isAMomentObject) || (t._isAMomentObject = e._isAMomentObject), a(e._i) || (t._i = e._i), a(e._f) || (t._f = e._f), a(e._l) || (t._l = e._l), a(e._strict) || (t._strict = e._strict), a(e._tzm) || (t._tzm = e._tzm), a(e._isUTC) || (t._isUTC = e._isUTC), a(e._offset) || (t._offset = e._offset), a(e._pf) || (t._pf = u(e)), a(e._locale) || (t._locale = e._locale), 0 < m.length)
				for (i = 0; i < m.length; i++) a(n = e[s = m[i]]) || (t[s] = n);
			return t
		}
		var v = !1;

		function y(t) {
			g(this, t), this._d = new Date(null != t._d ? t._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === v && (v = !0, i.updateOffset(this), v = !1)
		}

		function b(t) {
			return t instanceof y || null != t && null != t._isAMomentObject
		}

		function w(t) {
			return t < 0 ? Math.ceil(t) || 0 : Math.floor(t)
		}

		function S(t) {
			var e = +t,
				i = 0;
			return 0 !== e && isFinite(e) && (i = w(e)), i
		}

		function x(t, e, i) {
			var s, n = Math.min(t.length, e.length),
				a = Math.abs(t.length - e.length),
				o = 0;
			for (s = 0; s < n; s++)(i && t[s] !== e[s] || !i && S(t[s]) !== S(e[s])) && o++;
			return o + a
		}

		function T(t) {
			!1 === i.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + t)
		}

		function C(t, e) {
			var s = !0;
			return c(function() {
				if (null != i.deprecationHandler && i.deprecationHandler(null, t), s) {
					for (var n, a = [], o = 0; o < arguments.length; o++) {
						if (n = "", "object" == typeof arguments[o]) {
							for (var r in n += "\n[" + o + "] ", arguments[0]) n += r + ": " + arguments[0][r] + ", ";
							n = n.slice(0, -2)
						} else n = arguments[o];
						a.push(n)
					}
					T(t + "\nArguments: " + Array.prototype.slice.call(a).join("") + "\n" + (new Error).stack), s = !1
				}
				return e.apply(this, arguments)
			}, e)
		}
		var _, E = {};

		function P(t, e) {
			null != i.deprecationHandler && i.deprecationHandler(t, e), E[t] || (T(e), E[t] = !0)
		}

		function k(t) {
			return t instanceof Function || "[object Function]" === Object.prototype.toString.call(t)
		}

		function $(t, e) {
			var i, s = c({}, t);
			for (i in e) d(e, i) && (n(t[i]) && n(e[i]) ? (s[i] = {}, c(s[i], t[i]), c(s[i], e[i])) : null != e[i] ? s[i] = e[i] : delete s[i]);
			for (i in t) d(t, i) && !d(e, i) && n(t[i]) && (s[i] = c({}, s[i]));
			return s
		}

		function M(t) {
			null != t && this.set(t)
		}
		i.suppressDeprecationWarnings = !1, i.deprecationHandler = null, _ = Object.keys ? Object.keys : function(t) {
			var e, i = [];
			for (e in t) d(t, e) && i.push(e);
			return i
		};
		var D = {};

		function O(t, e) {
			var i = t.toLowerCase();
			D[i] = D[i + "s"] = D[e] = t
		}

		function z(t) {
			return "string" == typeof t ? D[t] || D[t.toLowerCase()] : void 0
		}

		function A(t) {
			var e, i, s = {};
			for (i in t) d(t, i) && (e = z(i)) && (s[e] = t[i]);
			return s
		}
		var I = {};

		function L(t, e) {
			I[t] = e
		}

		function N(t, e, i) {
			var s = "" + Math.abs(t),
				n = e - s.length;
			return (0 <= t ? i ? "+" : "" : "-") + Math.pow(10, Math.max(0, n)).toString().substr(1) + s
		}
		var Y = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
			R = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
			j = {},
			H = {};

		function B(t, e, i, s) {
			var n = s;
			"string" == typeof s && (n = function() {
				return this[s]()
			}), t && (H[t] = n), e && (H[e[0]] = function() {
				return N(n.apply(this, arguments), e[1], e[2])
			}), i && (H[i] = function() {
				return this.localeData().ordinal(n.apply(this, arguments), t)
			})
		}

		function F(t, e) {
			return t.isValid() ? (e = W(e, t.localeData()), j[e] = j[e] || function(t) {
				var e, i, s, n = t.match(Y);
				for (e = 0, i = n.length; e < i; e++) H[n[e]] ? n[e] = H[n[e]] : n[e] = (s = n[e]).match(/\[[\s\S]/) ? s.replace(/^\[|\]$/g, "") : s.replace(/\\/g, "");
				return function(e) {
					var s, a = "";
					for (s = 0; s < i; s++) a += k(n[s]) ? n[s].call(e, t) : n[s];
					return a
				}
			}(e), j[e](t)) : t.localeData().invalidDate()
		}

		function W(t, e) {
			var i = 5;

			function s(t) {
				return e.longDateFormat(t) || t
			}
			for (R.lastIndex = 0; 0 <= i && R.test(t);) t = t.replace(R, s), R.lastIndex = 0, i -= 1;
			return t
		}
		var V = /\d/,
			q = /\d\d/,
			U = /\d{3}/,
			G = /\d{4}/,
			X = /[+-]?\d{6}/,
			Q = /\d\d?/,
			Z = /\d\d\d\d?/,
			K = /\d\d\d\d\d\d?/,
			J = /\d{1,3}/,
			tt = /\d{1,4}/,
			et = /[+-]?\d{1,6}/,
			it = /\d+/,
			st = /[+-]?\d+/,
			nt = /Z|[+-]\d\d:?\d\d/gi,
			at = /Z|[+-]\d\d(?::?\d\d)?/gi,
			ot = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
			rt = {};

		function lt(t, e, i) {
			rt[t] = k(e) ? e : function(t, s) {
				return t && i ? i : e
			}
		}

		function dt(t, e) {
			return d(rt, t) ? rt[t](e._strict, e._locale) : new RegExp(ct(t.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(t, e, i, s, n) {
				return e || i || s || n
			})))
		}

		function ct(t) {
			return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")
		}
		var ht = {};

		function ut(t, e) {
			var i, s = e;
			for ("string" == typeof t && (t = [t]), o(e) && (s = function(t, i) {
					i[e] = S(t)
				}), i = 0; i < t.length; i++) ht[t[i]] = s
		}

		function pt(t, e) {
			ut(t, function(t, i, s, n) {
				s._w = s._w || {}, e(t, s._w, s, n)
			})
		}
		var ft = 0,
			mt = 1,
			gt = 2,
			vt = 3,
			yt = 4,
			bt = 5,
			wt = 6,
			St = 7,
			xt = 8;

		function Tt(t) {
			return Ct(t) ? 366 : 365
		}

		function Ct(t) {
			return t % 4 == 0 && t % 100 != 0 || t % 400 == 0
		}
		B("Y", 0, 0, function() {
			var t = this.year();
			return t <= 9999 ? "" + t : "+" + t
		}), B(0, ["YY", 2], 0, function() {
			return this.year() % 100
		}), B(0, ["YYYY", 4], 0, "year"), B(0, ["YYYYY", 5], 0, "year"), B(0, ["YYYYYY", 6, !0], 0, "year"), O("year", "y"), L("year", 1), lt("Y", st), lt("YY", Q, q), lt("YYYY", tt, G), lt("YYYYY", et, X), lt("YYYYYY", et, X), ut(["YYYYY", "YYYYYY"], ft), ut("YYYY", function(t, e) {
			e[ft] = 2 === t.length ? i.parseTwoDigitYear(t) : S(t)
		}), ut("YY", function(t, e) {
			e[ft] = i.parseTwoDigitYear(t)
		}), ut("Y", function(t, e) {
			e[ft] = parseInt(t, 10)
		}), i.parseTwoDigitYear = function(t) {
			return S(t) + (68 < S(t) ? 1900 : 2e3)
		};
		var _t, Et = Pt("FullYear", !0);

		function Pt(t, e) {
			return function(s) {
				return null != s ? ($t(this, t, s), i.updateOffset(this, e), this) : kt(this, t)
			}
		}

		function kt(t, e) {
			return t.isValid() ? t._d["get" + (t._isUTC ? "UTC" : "") + e]() : NaN
		}

		function $t(t, e, i) {
			t.isValid() && !isNaN(i) && ("FullYear" === e && Ct(t.year()) && 1 === t.month() && 29 === t.date() ? t._d["set" + (t._isUTC ? "UTC" : "") + e](i, t.month(), Mt(i, t.month())) : t._d["set" + (t._isUTC ? "UTC" : "") + e](i))
		}

		function Mt(t, e) {
			if (isNaN(t) || isNaN(e)) return NaN;
			var i = (e % 12 + 12) % 12;
			return t += (e - i) / 12, 1 === i ? Ct(t) ? 29 : 28 : 31 - i % 7 % 2
		}
		_t = Array.prototype.indexOf ? Array.prototype.indexOf : function(t) {
			var e;
			for (e = 0; e < this.length; ++e)
				if (this[e] === t) return e;
			return -1
		}, B("M", ["MM", 2], "Mo", function() {
			return this.month() + 1
		}), B("MMM", 0, 0, function(t) {
			return this.localeData().monthsShort(this, t)
		}), B("MMMM", 0, 0, function(t) {
			return this.localeData().months(this, t)
		}), O("month", "M"), L("month", 8), lt("M", Q), lt("MM", Q, q), lt("MMM", function(t, e) {
			return e.monthsShortRegex(t)
		}), lt("MMMM", function(t, e) {
			return e.monthsRegex(t)
		}), ut(["M", "MM"], function(t, e) {
			e[mt] = S(t) - 1
		}), ut(["MMM", "MMMM"], function(t, e, i, s) {
			var n = i._locale.monthsParse(t, s, i._strict);
			null != n ? e[mt] = n : u(i).invalidMonth = t
		});
		var Dt = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
			Ot = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
			zt = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_");

		function At(t, e) {
			var i;
			if (!t.isValid()) return t;
			if ("string" == typeof e)
				if (/^\d+$/.test(e)) e = S(e);
				else if (!o(e = t.localeData().monthsParse(e))) return t;
			return i = Math.min(t.date(), Mt(t.year(), e)), t._d["set" + (t._isUTC ? "UTC" : "") + "Month"](e, i), t
		}

		function It(t) {
			return null != t ? (At(this, t), i.updateOffset(this, !0), this) : kt(this, "Month")
		}
		var Lt = ot,
			Nt = ot;

		function Yt() {
			function t(t, e) {
				return e.length - t.length
			}
			var e, i, s = [],
				n = [],
				a = [];
			for (e = 0; e < 12; e++) i = h([2e3, e]), s.push(this.monthsShort(i, "")), n.push(this.months(i, "")), a.push(this.months(i, "")), a.push(this.monthsShort(i, ""));
			for (s.sort(t), n.sort(t), a.sort(t), e = 0; e < 12; e++) s[e] = ct(s[e]), n[e] = ct(n[e]);
			for (e = 0; e < 24; e++) a[e] = ct(a[e]);
			this._monthsRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + s.join("|") + ")", "i")
		}

		function Rt(t) {
			var e = new Date(Date.UTC.apply(null, arguments));
			return t < 100 && 0 <= t && isFinite(e.getUTCFullYear()) && e.setUTCFullYear(t), e
		}

		function jt(t, e, i) {
			var s = 7 + e - i;
			return -(7 + Rt(t, 0, s).getUTCDay() - e) % 7 + s - 1
		}

		function Ht(t, e, i, s, n) {
			var a, o, r = 1 + 7 * (e - 1) + (7 + i - s) % 7 + jt(t, s, n);
			return r <= 0 ? o = Tt(a = t - 1) + r : r > Tt(t) ? (a = t + 1, o = r - Tt(t)) : (a = t, o = r), {
				year: a,
				dayOfYear: o
			}
		}

		function Bt(t, e, i) {
			var s, n, a = jt(t.year(), e, i),
				o = Math.floor((t.dayOfYear() - a - 1) / 7) + 1;
			return o < 1 ? s = o + Ft(n = t.year() - 1, e, i) : o > Ft(t.year(), e, i) ? (s = o - Ft(t.year(), e, i), n = t.year() + 1) : (n = t.year(), s = o), {
				week: s,
				year: n
			}
		}

		function Ft(t, e, i) {
			var s = jt(t, e, i),
				n = jt(t + 1, e, i);
			return (Tt(t) - s + n) / 7
		}
		B("w", ["ww", 2], "wo", "week"), B("W", ["WW", 2], "Wo", "isoWeek"), O("week", "w"), O("isoWeek", "W"), L("week", 5), L("isoWeek", 5), lt("w", Q), lt("ww", Q, q), lt("W", Q), lt("WW", Q, q), pt(["w", "ww", "W", "WW"], function(t, e, i, s) {
			e[s.substr(0, 1)] = S(t)
		}), B("d", 0, "do", "day"), B("dd", 0, 0, function(t) {
			return this.localeData().weekdaysMin(this, t)
		}), B("ddd", 0, 0, function(t) {
			return this.localeData().weekdaysShort(this, t)
		}), B("dddd", 0, 0, function(t) {
			return this.localeData().weekdays(this, t)
		}), B("e", 0, 0, "weekday"), B("E", 0, 0, "isoWeekday"), O("day", "d"), O("weekday", "e"), O("isoWeekday", "E"), L("day", 11), L("weekday", 11), L("isoWeekday", 11), lt("d", Q), lt("e", Q), lt("E", Q), lt("dd", function(t, e) {
			return e.weekdaysMinRegex(t)
		}), lt("ddd", function(t, e) {
			return e.weekdaysShortRegex(t)
		}), lt("dddd", function(t, e) {
			return e.weekdaysRegex(t)
		}), pt(["dd", "ddd", "dddd"], function(t, e, i, s) {
			var n = i._locale.weekdaysParse(t, s, i._strict);
			null != n ? e.d = n : u(i).invalidWeekday = t
		}), pt(["d", "e", "E"], function(t, e, i, s) {
			e[s] = S(t)
		});
		var Wt = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			Vt = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
			qt = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
			Ut = ot,
			Gt = ot,
			Xt = ot;

		function Qt() {
			function t(t, e) {
				return e.length - t.length
			}
			var e, i, s, n, a, o = [],
				r = [],
				l = [],
				d = [];
			for (e = 0; e < 7; e++) i = h([2e3, 1]).day(e), s = this.weekdaysMin(i, ""), n = this.weekdaysShort(i, ""), a = this.weekdays(i, ""), o.push(s), r.push(n), l.push(a), d.push(s), d.push(n), d.push(a);
			for (o.sort(t), r.sort(t), l.sort(t), d.sort(t), e = 0; e < 7; e++) r[e] = ct(r[e]), l[e] = ct(l[e]), d[e] = ct(d[e]);
			this._weekdaysRegex = new RegExp("^(" + d.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + l.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + o.join("|") + ")", "i")
		}

		function Zt() {
			return this.hours() % 12 || 12
		}

		function Kt(t, e) {
			B(t, 0, 0, function() {
				return this.localeData().meridiem(this.hours(), this.minutes(), e)
			})
		}

		function Jt(t, e) {
			return e._meridiemParse
		}
		B("H", ["HH", 2], 0, "hour"), B("h", ["hh", 2], 0, Zt), B("k", ["kk", 2], 0, function() {
			return this.hours() || 24
		}), B("hmm", 0, 0, function() {
			return "" + Zt.apply(this) + N(this.minutes(), 2)
		}), B("hmmss", 0, 0, function() {
			return "" + Zt.apply(this) + N(this.minutes(), 2) + N(this.seconds(), 2)
		}), B("Hmm", 0, 0, function() {
			return "" + this.hours() + N(this.minutes(), 2)
		}), B("Hmmss", 0, 0, function() {
			return "" + this.hours() + N(this.minutes(), 2) + N(this.seconds(), 2)
		}), Kt("a", !0), Kt("A", !1), O("hour", "h"), L("hour", 13), lt("a", Jt), lt("A", Jt), lt("H", Q), lt("h", Q), lt("k", Q), lt("HH", Q, q), lt("hh", Q, q), lt("kk", Q, q), lt("hmm", Z), lt("hmmss", K), lt("Hmm", Z), lt("Hmmss", K), ut(["H", "HH"], vt), ut(["k", "kk"], function(t, e, i) {
			var s = S(t);
			e[vt] = 24 === s ? 0 : s
		}), ut(["a", "A"], function(t, e, i) {
			i._isPm = i._locale.isPM(t), i._meridiem = t
		}), ut(["h", "hh"], function(t, e, i) {
			e[vt] = S(t), u(i).bigHour = !0
		}), ut("hmm", function(t, e, i) {
			var s = t.length - 2;
			e[vt] = S(t.substr(0, s)), e[yt] = S(t.substr(s)), u(i).bigHour = !0
		}), ut("hmmss", function(t, e, i) {
			var s = t.length - 4,
				n = t.length - 2;
			e[vt] = S(t.substr(0, s)), e[yt] = S(t.substr(s, 2)), e[bt] = S(t.substr(n)), u(i).bigHour = !0
		}), ut("Hmm", function(t, e, i) {
			var s = t.length - 2;
			e[vt] = S(t.substr(0, s)), e[yt] = S(t.substr(s))
		}), ut("Hmmss", function(t, e, i) {
			var s = t.length - 4,
				n = t.length - 2;
			e[vt] = S(t.substr(0, s)), e[yt] = S(t.substr(s, 2)), e[bt] = S(t.substr(n))
		});
		var te, ee = Pt("Hours", !0),
			ie = {
				calendar: {
					sameDay: "[Today at] LT",
					nextDay: "[Tomorrow at] LT",
					nextWeek: "dddd [at] LT",
					lastDay: "[Yesterday at] LT",
					lastWeek: "[Last] dddd [at] LT",
					sameElse: "L"
				},
				longDateFormat: {
					LTS: "h:mm:ss A",
					LT: "h:mm A",
					L: "MM/DD/YYYY",
					LL: "MMMM D, YYYY",
					LLL: "MMMM D, YYYY h:mm A",
					LLLL: "dddd, MMMM D, YYYY h:mm A"
				},
				invalidDate: "Invalid date",
				ordinal: "%d",
				dayOfMonthOrdinalParse: /\d{1,2}/,
				relativeTime: {
					future: "in %s",
					past: "%s ago",
					s: "a few seconds",
					ss: "%d seconds",
					m: "a minute",
					mm: "%d minutes",
					h: "an hour",
					hh: "%d hours",
					d: "a day",
					dd: "%d days",
					M: "a month",
					MM: "%d months",
					y: "a year",
					yy: "%d years"
				},
				months: Ot,
				monthsShort: zt,
				week: {
					dow: 0,
					doy: 6
				},
				weekdays: Wt,
				weekdaysMin: qt,
				weekdaysShort: Vt,
				meridiemParse: /[ap]\.?m?\.?/i
			},
			se = {},
			ne = {};

		function ae(t) {
			return t ? t.toLowerCase().replace("_", "-") : t
		}

		function oe(t) {
			var e = null;
			if (!se[t] && "undefined" != typeof module && module && module.exports) try {
				e = te._abbr, require("./locale/" + t), re(e)
			} catch (t) {}
			return se[t]
		}

		function re(t, e) {
			var i;
			return t && ((i = a(e) ? de(t) : le(t, e)) ? te = i : "undefined" != typeof console && console.warn && console.warn("Locale " + t + " not found. Did you forget to load it?")), te._abbr
		}

		function le(t, e) {
			if (null !== e) {
				var i, s = ie;
				if (e.abbr = t, null != se[t]) P("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), s = se[t]._config;
				else if (null != e.parentLocale)
					if (null != se[e.parentLocale]) s = se[e.parentLocale]._config;
					else {
						if (null == (i = oe(e.parentLocale))) return ne[e.parentLocale] || (ne[e.parentLocale] = []), ne[e.parentLocale].push({
							name: t,
							config: e
						}), null;
						s = i._config
					} return se[t] = new M($(s, e)), ne[t] && ne[t].forEach(function(t) {
					le(t.name, t.config)
				}), re(t), se[t]
			}
			return delete se[t], null
		}

		function de(t) {
			var e;
			if (t && t._locale && t._locale._abbr && (t = t._locale._abbr), !t) return te;
			if (!s(t)) {
				if (e = oe(t)) return e;
				t = [t]
			}
			return function(t) {
				for (var e, i, s, n, a = 0; a < t.length;) {
					for (e = (n = ae(t[a]).split("-")).length, i = (i = ae(t[a + 1])) ? i.split("-") : null; 0 < e;) {
						if (s = oe(n.slice(0, e).join("-"))) return s;
						if (i && i.length >= e && x(n, i, !0) >= e - 1) break;
						e--
					}
					a++
				}
				return te
			}(t)
		}

		function ce(t) {
			var e, i = t._a;
			return i && -2 === u(t).overflow && (e = i[mt] < 0 || 11 < i[mt] ? mt : i[gt] < 1 || i[gt] > Mt(i[ft], i[mt]) ? gt : i[vt] < 0 || 24 < i[vt] || 24 === i[vt] && (0 !== i[yt] || 0 !== i[bt] || 0 !== i[wt]) ? vt : i[yt] < 0 || 59 < i[yt] ? yt : i[bt] < 0 || 59 < i[bt] ? bt : i[wt] < 0 || 999 < i[wt] ? wt : -1, u(t)._overflowDayOfYear && (e < ft || gt < e) && (e = gt), u(t)._overflowWeeks && -1 === e && (e = St), u(t)._overflowWeekday && -1 === e && (e = xt), u(t).overflow = e), t
		}

		function he(t, e, i) {
			return null != t ? t : null != e ? e : i
		}

		function ue(t) {
			var e, s, n, a, o, r = [];
			if (!t._d) {
				var l, d;
				for (l = t, d = new Date(i.now()), n = l._useUTC ? [d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()] : [d.getFullYear(), d.getMonth(), d.getDate()], t._w && null == t._a[gt] && null == t._a[mt] && function(t) {
						var e, i, s, n, a, o, r, l;
						if (null != (e = t._w).GG || null != e.W || null != e.E) a = 1, o = 4, i = he(e.GG, t._a[ft], Bt(Ee(), 1, 4).year), s = he(e.W, 1), ((n = he(e.E, 1)) < 1 || 7 < n) && (l = !0);
						else {
							a = t._locale._week.dow, o = t._locale._week.doy;
							var d = Bt(Ee(), a, o);
							i = he(e.gg, t._a[ft], d.year), s = he(e.w, d.week), null != e.d ? ((n = e.d) < 0 || 6 < n) && (l = !0) : null != e.e ? (n = e.e + a, (e.e < 0 || 6 < e.e) && (l = !0)) : n = a
						}
						s < 1 || s > Ft(i, a, o) ? u(t)._overflowWeeks = !0 : null != l ? u(t)._overflowWeekday = !0 : (r = Ht(i, s, n, a, o), t._a[ft] = r.year, t._dayOfYear = r.dayOfYear)
					}(t), null != t._dayOfYear && (o = he(t._a[ft], n[ft]), (t._dayOfYear > Tt(o) || 0 === t._dayOfYear) && (u(t)._overflowDayOfYear = !0), s = Rt(o, 0, t._dayOfYear), t._a[mt] = s.getUTCMonth(), t._a[gt] = s.getUTCDate()), e = 0; e < 3 && null == t._a[e]; ++e) t._a[e] = r[e] = n[e];
				for (; e < 7; e++) t._a[e] = r[e] = null == t._a[e] ? 2 === e ? 1 : 0 : t._a[e];
				24 === t._a[vt] && 0 === t._a[yt] && 0 === t._a[bt] && 0 === t._a[wt] && (t._nextDay = !0, t._a[vt] = 0), t._d = (t._useUTC ? Rt : function(t, e, i, s, n, a, o) {
					var r = new Date(t, e, i, s, n, a, o);
					return t < 100 && 0 <= t && isFinite(r.getFullYear()) && r.setFullYear(t), r
				}).apply(null, r), a = t._useUTC ? t._d.getUTCDay() : t._d.getDay(), null != t._tzm && t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), t._nextDay && (t._a[vt] = 24), t._w && void 0 !== t._w.d && t._w.d !== a && (u(t).weekdayMismatch = !0)
			}
		}
		var pe = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
			fe = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
			me = /Z|[+-]\d\d(?::?\d\d)?/,
			ge = [
				["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
				["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
				["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
				["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
				["YYYY-DDD", /\d{4}-\d{3}/],
				["YYYY-MM", /\d{4}-\d\d/, !1],
				["YYYYYYMMDD", /[+-]\d{10}/],
				["YYYYMMDD", /\d{8}/],
				["GGGG[W]WWE", /\d{4}W\d{3}/],
				["GGGG[W]WW", /\d{4}W\d{2}/, !1],
				["YYYYDDD", /\d{7}/]
			],
			ve = [
				["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
				["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
				["HH:mm:ss", /\d\d:\d\d:\d\d/],
				["HH:mm", /\d\d:\d\d/],
				["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
				["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
				["HHmmss", /\d\d\d\d\d\d/],
				["HHmm", /\d\d\d\d/],
				["HH", /\d\d/]
			],
			ye = /^\/?Date\((\-?\d+)/i;

		function be(t) {
			var e, i, s, n, a, o, r = t._i,
				l = pe.exec(r) || fe.exec(r);
			if (l) {
				for (u(t).iso = !0, e = 0, i = ge.length; e < i; e++)
					if (ge[e][1].exec(l[1])) {
						n = ge[e][0], s = !1 !== ge[e][2];
						break
					} if (null == n) return void(t._isValid = !1);
				if (l[3]) {
					for (e = 0, i = ve.length; e < i; e++)
						if (ve[e][1].exec(l[3])) {
							a = (l[2] || " ") + ve[e][0];
							break
						} if (null == a) return void(t._isValid = !1)
				}
				if (!s && null != a) return void(t._isValid = !1);
				if (l[4]) {
					if (!me.exec(l[4])) return void(t._isValid = !1);
					o = "Z"
				}
				t._f = n + (a || "") + (o || ""), Te(t)
			} else t._isValid = !1
		}
		var we = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
		var Se = {
			UT: 0,
			GMT: 0,
			EDT: -240,
			EST: -300,
			CDT: -300,
			CST: -360,
			MDT: -360,
			MST: -420,
			PDT: -420,
			PST: -480
		};

		function xe(t) {
			var e, i, s, n = we.exec(t._i.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, ""));
			if (n) {
				var a = function(t, e, i, s, n, a) {
					var o = [function(t) {
						var e = parseInt(t, 10);
						return e <= 49 ? 2e3 + e : e <= 999 ? 1900 + e : e
					}(t), zt.indexOf(e), parseInt(i, 10), parseInt(s, 10), parseInt(n, 10)];
					return a && o.push(parseInt(a, 10)), o
				}(n[4], n[3], n[2], n[5], n[6], n[7]);
				if (i = a, s = t, (e = n[1]) && Vt.indexOf(e) !== new Date(i[0], i[1], i[2]).getDay() && (u(s).weekdayMismatch = !0, !(s._isValid = !1))) return;
				t._a = a, t._tzm = function(t, e, i) {
					if (t) return Se[t];
					if (e) return 0;
					var s = parseInt(i, 10),
						n = s % 100;
					return (s - n) / 100 * 60 + n
				}(n[8], n[9], n[10]), t._d = Rt.apply(null, t._a), t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), u(t).rfc2822 = !0
			} else t._isValid = !1
		}

		function Te(t) {
			if (t._f !== i.ISO_8601)
				if (t._f !== i.RFC_2822) {
					t._a = [], u(t).empty = !0;
					var e, s, n, a, o, r, l, c, h = "" + t._i,
						p = h.length,
						f = 0;
					for (n = W(t._f, t._locale).match(Y) || [], e = 0; e < n.length; e++) a = n[e], (s = (h.match(dt(a, t)) || [])[0]) && (0 < (o = h.substr(0, h.indexOf(s))).length && u(t).unusedInput.push(o), h = h.slice(h.indexOf(s) + s.length), f += s.length), H[a] ? (s ? u(t).empty = !1 : u(t).unusedTokens.push(a), r = a, c = t, null != (l = s) && d(ht, r) && ht[r](l, c._a, c, r)) : t._strict && !s && u(t).unusedTokens.push(a);
					u(t).charsLeftOver = p - f, 0 < h.length && u(t).unusedInput.push(h), t._a[vt] <= 12 && !0 === u(t).bigHour && 0 < t._a[vt] && (u(t).bigHour = void 0), u(t).parsedDateParts = t._a.slice(0), u(t).meridiem = t._meridiem, t._a[vt] = function(t, e, i) {
						var s;
						return null == i ? e : null != t.meridiemHour ? t.meridiemHour(e, i) : (null != t.isPM && ((s = t.isPM(i)) && e < 12 && (e += 12), s || 12 !== e || (e = 0)), e)
					}(t._locale, t._a[vt], t._meridiem), ue(t), ce(t)
				} else xe(t);
			else be(t)
		}

		function Ce(t) {
			var e, d, h, m, v = t._i,
				w = t._f;
			return t._locale = t._locale || de(t._l), null === v || void 0 === w && "" === v ? f({
				nullInput: !0
			}) : ("string" == typeof v && (t._i = v = t._locale.preparse(v)), b(v) ? new y(ce(v)) : (r(v) ? t._d = v : s(w) ? function(t) {
				var e, i, s, n, a;
				if (0 === t._f.length) return u(t).invalidFormat = !0, t._d = new Date(NaN);
				for (n = 0; n < t._f.length; n++) a = 0, e = g({}, t), null != t._useUTC && (e._useUTC = t._useUTC), e._f = t._f[n], Te(e), p(e) && (a += u(e).charsLeftOver, a += 10 * u(e).unusedTokens.length, u(e).score = a, (null == s || a < s) && (s = a, i = e));
				c(t, i || e)
			}(t) : w ? Te(t) : a(d = (e = t)._i) ? e._d = new Date(i.now()) : r(d) ? e._d = new Date(d.valueOf()) : "string" == typeof d ? (h = e, null === (m = ye.exec(h._i)) ? (be(h), !1 === h._isValid && (delete h._isValid, xe(h), !1 === h._isValid && (delete h._isValid, i.createFromInputFallback(h)))) : h._d = new Date(+m[1])) : s(d) ? (e._a = l(d.slice(0), function(t) {
				return parseInt(t, 10)
			}), ue(e)) : n(d) ? function(t) {
				if (!t._d) {
					var e = A(t._i);
					t._a = l([e.year, e.month, e.day || e.date, e.hour, e.minute, e.second, e.millisecond], function(t) {
						return t && parseInt(t, 10)
					}), ue(t)
				}
			}(e) : o(d) ? e._d = new Date(d) : i.createFromInputFallback(e), p(t) || (t._d = null), t))
		}

		function _e(t, e, i, a, o) {
			var r, l = {};
			return !0 !== i && !1 !== i || (a = i, i = void 0), (n(t) && function(t) {
				if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(t).length;
				var e;
				for (e in t)
					if (t.hasOwnProperty(e)) return !1;
				return !0
			}(t) || s(t) && 0 === t.length) && (t = void 0), l._isAMomentObject = !0, l._useUTC = l._isUTC = o, l._l = i, l._i = t, l._f = e, l._strict = a, (r = new y(ce(Ce(l))))._nextDay && (r.add(1, "d"), r._nextDay = void 0), r
		}

		function Ee(t, e, i, s) {
			return _e(t, e, i, s, !1)
		}
		i.createFromInputFallback = C("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(t) {
			t._d = new Date(t._i + (t._useUTC ? " UTC" : ""))
		}), i.ISO_8601 = function() {}, i.RFC_2822 = function() {};
		var Pe = C("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
				var t = Ee.apply(null, arguments);
				return this.isValid() && t.isValid() ? t < this ? this : t : f()
			}),
			ke = C("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
				var t = Ee.apply(null, arguments);
				return this.isValid() && t.isValid() ? this < t ? this : t : f()
			});

		function $e(t, e) {
			var i, n;
			if (1 === e.length && s(e[0]) && (e = e[0]), !e.length) return Ee();
			for (i = e[0], n = 1; n < e.length; ++n) e[n].isValid() && !e[n][t](i) || (i = e[n]);
			return i
		}
		var Me = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];

		function De(t) {
			var e = A(t),
				i = e.year || 0,
				s = e.quarter || 0,
				n = e.month || 0,
				a = e.week || 0,
				o = e.day || 0,
				r = e.hour || 0,
				l = e.minute || 0,
				d = e.second || 0,
				c = e.millisecond || 0;
			this._isValid = function(t) {
				for (var e in t)
					if (-1 === _t.call(Me, e) || null != t[e] && isNaN(t[e])) return !1;
				for (var i = !1, s = 0; s < Me.length; ++s)
					if (t[Me[s]]) {
						if (i) return !1;
						parseFloat(t[Me[s]]) !== S(t[Me[s]]) && (i = !0)
					} return !0
			}(e), this._milliseconds = +c + 1e3 * d + 6e4 * l + 1e3 * r * 60 * 60, this._days = +o + 7 * a, this._months = +n + 3 * s + 12 * i, this._data = {}, this._locale = de(), this._bubble()
		}

		function Oe(t) {
			return t instanceof De
		}

		function ze(t) {
			return t < 0 ? -1 * Math.round(-1 * t) : Math.round(t)
		}

		function Ae(t, e) {
			B(t, 0, 0, function() {
				var t = this.utcOffset(),
					i = "+";
				return t < 0 && (t = -t, i = "-"), i + N(~~(t / 60), 2) + e + N(~~t % 60, 2)
			})
		}
		Ae("Z", ":"), Ae("ZZ", ""), lt("Z", at), lt("ZZ", at), ut(["Z", "ZZ"], function(t, e, i) {
			i._useUTC = !0, i._tzm = Le(at, t)
		});
		var Ie = /([\+\-]|\d\d)/gi;

		function Le(t, e) {
			var i = (e || "").match(t);
			if (null === i) return null;
			var s = ((i[i.length - 1] || []) + "").match(Ie) || ["-", 0, 0],
				n = 60 * s[1] + S(s[2]);
			return 0 === n ? 0 : "+" === s[0] ? n : -n
		}

		function Ne(t, e) {
			var s, n;
			return e._isUTC ? (s = e.clone(), n = (b(t) || r(t) ? t.valueOf() : Ee(t).valueOf()) - s.valueOf(), s._d.setTime(s._d.valueOf() + n), i.updateOffset(s, !1), s) : Ee(t).local()
		}

		function Ye(t) {
			return 15 * -Math.round(t._d.getTimezoneOffset() / 15)
		}

		function Re() {
			return !!this.isValid() && this._isUTC && 0 === this._offset
		}
		i.updateOffset = function() {};
		var je = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/,
			He = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

		function Be(t, e) {
			var i, s, n, a = t,
				r = null;
			return Oe(t) ? a = {
				ms: t._milliseconds,
				d: t._days,
				M: t._months
			} : o(t) ? (a = {}, e ? a[e] = t : a.milliseconds = t) : (r = je.exec(t)) ? (i = "-" === r[1] ? -1 : 1, a = {
				y: 0,
				d: S(r[gt]) * i,
				h: S(r[vt]) * i,
				m: S(r[yt]) * i,
				s: S(r[bt]) * i,
				ms: S(ze(1e3 * r[wt])) * i
			}) : (r = He.exec(t)) ? (i = "-" === r[1] ? -1 : (r[1], 1), a = {
				y: Fe(r[2], i),
				M: Fe(r[3], i),
				w: Fe(r[4], i),
				d: Fe(r[5], i),
				h: Fe(r[6], i),
				m: Fe(r[7], i),
				s: Fe(r[8], i)
			}) : null == a ? a = {} : "object" == typeof a && ("from" in a || "to" in a) && (n = function(t, e) {
				var i;
				return t.isValid() && e.isValid() ? (e = Ne(e, t), t.isBefore(e) ? i = We(t, e) : ((i = We(e, t)).milliseconds = -i.milliseconds, i.months = -i.months), i) : {
					milliseconds: 0,
					months: 0
				}
			}(Ee(a.from), Ee(a.to)), (a = {}).ms = n.milliseconds, a.M = n.months), s = new De(a), Oe(t) && d(t, "_locale") && (s._locale = t._locale), s
		}

		function Fe(t, e) {
			var i = t && parseFloat(t.replace(",", "."));
			return (isNaN(i) ? 0 : i) * e
		}

		function We(t, e) {
			var i = {
				milliseconds: 0,
				months: 0
			};
			return i.months = e.month() - t.month() + 12 * (e.year() - t.year()), t.clone().add(i.months, "M").isAfter(e) && --i.months, i.milliseconds = +e - +t.clone().add(i.months, "M"), i
		}

		function Ve(t, e) {
			return function(i, s) {
				var n;
				return null === s || isNaN(+s) || (P(e, "moment()." + e + "(period, number) is deprecated. Please use moment()." + e + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), n = i, i = s, s = n), qe(this, Be(i = "string" == typeof i ? +i : i, s), t), this
			}
		}

		function qe(t, e, s, n) {
			var a = e._milliseconds,
				o = ze(e._days),
				r = ze(e._months);
			t.isValid() && (n = null == n || n, r && At(t, kt(t, "Month") + r * s), o && $t(t, "Date", kt(t, "Date") + o * s), a && t._d.setTime(t._d.valueOf() + a * s), n && i.updateOffset(t, o || r))
		}
		Be.fn = De.prototype, Be.invalid = function() {
			return Be(NaN)
		};
		var Ue = Ve(1, "add"),
			Ge = Ve(-1, "subtract");

		function Xe(t, e) {
			var i = 12 * (e.year() - t.year()) + (e.month() - t.month()),
				s = t.clone().add(i, "months");
			return -(i + (e - s < 0 ? (e - s) / (s - t.clone().add(i - 1, "months")) : (e - s) / (t.clone().add(i + 1, "months") - s))) || 0
		}

		function Qe(t) {
			var e;
			return void 0 === t ? this._locale._abbr : (null != (e = de(t)) && (this._locale = e), this)
		}
		i.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", i.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
		var Ze = C("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(t) {
			return void 0 === t ? this.localeData() : this.locale(t)
		});

		function Ke() {
			return this._locale
		}

		function Je(t, e) {
			B(0, [t, t.length], 0, e)
		}

		function ti(t, e, i, s, n) {
			var a;
			return null == t ? Bt(this, s, n).year : ((a = Ft(t, s, n)) < e && (e = a), function(t, e, i, s, n) {
				var a = Ht(t, e, i, s, n),
					o = Rt(a.year, 0, a.dayOfYear);
				return this.year(o.getUTCFullYear()), this.month(o.getUTCMonth()), this.date(o.getUTCDate()), this
			}.call(this, t, e, i, s, n))
		}
		B(0, ["gg", 2], 0, function() {
			return this.weekYear() % 100
		}), B(0, ["GG", 2], 0, function() {
			return this.isoWeekYear() % 100
		}), Je("gggg", "weekYear"), Je("ggggg", "weekYear"), Je("GGGG", "isoWeekYear"), Je("GGGGG", "isoWeekYear"), O("weekYear", "gg"), O("isoWeekYear", "GG"), L("weekYear", 1), L("isoWeekYear", 1), lt("G", st), lt("g", st), lt("GG", Q, q), lt("gg", Q, q), lt("GGGG", tt, G), lt("gggg", tt, G), lt("GGGGG", et, X), lt("ggggg", et, X), pt(["gggg", "ggggg", "GGGG", "GGGGG"], function(t, e, i, s) {
			e[s.substr(0, 2)] = S(t)
		}), pt(["gg", "GG"], function(t, e, s, n) {
			e[n] = i.parseTwoDigitYear(t)
		}), B("Q", 0, "Qo", "quarter"), O("quarter", "Q"), L("quarter", 7), lt("Q", V), ut("Q", function(t, e) {
			e[mt] = 3 * (S(t) - 1)
		}), B("D", ["DD", 2], "Do", "date"), O("date", "D"), L("date", 9), lt("D", Q), lt("DD", Q, q), lt("Do", function(t, e) {
			return t ? e._dayOfMonthOrdinalParse || e._ordinalParse : e._dayOfMonthOrdinalParseLenient
		}), ut(["D", "DD"], gt), ut("Do", function(t, e) {
			e[gt] = S(t.match(Q)[0])
		});
		var ei = Pt("Date", !0);
		B("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), O("dayOfYear", "DDD"), L("dayOfYear", 4), lt("DDD", J), lt("DDDD", U), ut(["DDD", "DDDD"], function(t, e, i) {
			i._dayOfYear = S(t)
		}), B("m", ["mm", 2], 0, "minute"), O("minute", "m"), L("minute", 14), lt("m", Q), lt("mm", Q, q), ut(["m", "mm"], yt);
		var ii = Pt("Minutes", !1);
		B("s", ["ss", 2], 0, "second"), O("second", "s"), L("second", 15), lt("s", Q), lt("ss", Q, q), ut(["s", "ss"], bt);
		var si, ni = Pt("Seconds", !1);
		for (B("S", 0, 0, function() {
				return ~~(this.millisecond() / 100)
			}), B(0, ["SS", 2], 0, function() {
				return ~~(this.millisecond() / 10)
			}), B(0, ["SSS", 3], 0, "millisecond"), B(0, ["SSSS", 4], 0, function() {
				return 10 * this.millisecond()
			}), B(0, ["SSSSS", 5], 0, function() {
				return 100 * this.millisecond()
			}), B(0, ["SSSSSS", 6], 0, function() {
				return 1e3 * this.millisecond()
			}), B(0, ["SSSSSSS", 7], 0, function() {
				return 1e4 * this.millisecond()
			}), B(0, ["SSSSSSSS", 8], 0, function() {
				return 1e5 * this.millisecond()
			}), B(0, ["SSSSSSSSS", 9], 0, function() {
				return 1e6 * this.millisecond()
			}), O("millisecond", "ms"), L("millisecond", 16), lt("S", J, V), lt("SS", J, q), lt("SSS", J, U), si = "SSSS"; si.length <= 9; si += "S") lt(si, it);

		function ai(t, e) {
			e[wt] = S(1e3 * ("0." + t))
		}
		for (si = "S"; si.length <= 9; si += "S") ut(si, ai);
		var oi = Pt("Milliseconds", !1);
		B("z", 0, 0, "zoneAbbr"), B("zz", 0, 0, "zoneName");
		var ri = y.prototype;

		function li(t) {
			return t
		}
		ri.add = Ue, ri.calendar = function(t, e) {
			var s = t || Ee(),
				n = Ne(s, this).startOf("day"),
				a = i.calendarFormat(this, n) || "sameElse",
				o = e && (k(e[a]) ? e[a].call(this, s) : e[a]);
			return this.format(o || this.localeData().calendar(a, this, Ee(s)))
		}, ri.clone = function() {
			return new y(this)
		}, ri.diff = function(t, e, i) {
			var s, n, a;
			if (!this.isValid()) return NaN;
			if (!(s = Ne(t, this)).isValid()) return NaN;
			switch (n = 6e4 * (s.utcOffset() - this.utcOffset()), e = z(e)) {
				case "year":
					a = Xe(this, s) / 12;
					break;
				case "month":
					a = Xe(this, s);
					break;
				case "quarter":
					a = Xe(this, s) / 3;
					break;
				case "second":
					a = (this - s) / 1e3;
					break;
				case "minute":
					a = (this - s) / 6e4;
					break;
				case "hour":
					a = (this - s) / 36e5;
					break;
				case "day":
					a = (this - s - n) / 864e5;
					break;
				case "week":
					a = (this - s - n) / 6048e5;
					break;
				default:
					a = this - s
			}
			return i ? a : w(a)
		}, ri.endOf = function(t) {
			return void 0 === (t = z(t)) || "millisecond" === t ? this : ("date" === t && (t = "day"), this.startOf(t).add(1, "isoWeek" === t ? "week" : t).subtract(1, "ms"))
		}, ri.format = function(t) {
			t || (t = this.isUtc() ? i.defaultFormatUtc : i.defaultFormat);
			var e = F(this, t);
			return this.localeData().postformat(e)
		}, ri.from = function(t, e) {
			return this.isValid() && (b(t) && t.isValid() || Ee(t).isValid()) ? Be({
				to: this,
				from: t
			}).locale(this.locale()).humanize(!e) : this.localeData().invalidDate()
		}, ri.fromNow = function(t) {
			return this.from(Ee(), t)
		}, ri.to = function(t, e) {
			return this.isValid() && (b(t) && t.isValid() || Ee(t).isValid()) ? Be({
				from: this,
				to: t
			}).locale(this.locale()).humanize(!e) : this.localeData().invalidDate()
		}, ri.toNow = function(t) {
			return this.to(Ee(), t)
		}, ri.get = function(t) {
			return k(this[t = z(t)]) ? this[t]() : this
		}, ri.invalidAt = function() {
			return u(this).overflow
		}, ri.isAfter = function(t, e) {
			var i = b(t) ? t : Ee(t);
			return !(!this.isValid() || !i.isValid()) && ("millisecond" === (e = z(a(e) ? "millisecond" : e)) ? this.valueOf() > i.valueOf() : i.valueOf() < this.clone().startOf(e).valueOf())
		}, ri.isBefore = function(t, e) {
			var i = b(t) ? t : Ee(t);
			return !(!this.isValid() || !i.isValid()) && ("millisecond" === (e = z(a(e) ? "millisecond" : e)) ? this.valueOf() < i.valueOf() : this.clone().endOf(e).valueOf() < i.valueOf())
		}, ri.isBetween = function(t, e, i, s) {
			return ("(" === (s = s || "()")[0] ? this.isAfter(t, i) : !this.isBefore(t, i)) && (")" === s[1] ? this.isBefore(e, i) : !this.isAfter(e, i))
		}, ri.isSame = function(t, e) {
			var i, s = b(t) ? t : Ee(t);
			return !(!this.isValid() || !s.isValid()) && ("millisecond" === (e = z(e || "millisecond")) ? this.valueOf() === s.valueOf() : (i = s.valueOf(), this.clone().startOf(e).valueOf() <= i && i <= this.clone().endOf(e).valueOf()))
		}, ri.isSameOrAfter = function(t, e) {
			return this.isSame(t, e) || this.isAfter(t, e)
		}, ri.isSameOrBefore = function(t, e) {
			return this.isSame(t, e) || this.isBefore(t, e)
		}, ri.isValid = function() {
			return p(this)
		}, ri.lang = Ze, ri.locale = Qe, ri.localeData = Ke, ri.max = ke, ri.min = Pe, ri.parsingFlags = function() {
			return c({}, u(this))
		}, ri.set = function(t, e) {
			if ("object" == typeof t)
				for (var i = function(t) {
						var e = [];
						for (var i in t) e.push({
							unit: i,
							priority: I[i]
						});
						return e.sort(function(t, e) {
							return t.priority - e.priority
						}), e
					}(t = A(t)), s = 0; s < i.length; s++) this[i[s].unit](t[i[s].unit]);
			else if (k(this[t = z(t)])) return this[t](e);
			return this
		}, ri.startOf = function(t) {
			switch (t = z(t)) {
				case "year":
					this.month(0);
				case "quarter":
				case "month":
					this.date(1);
				case "week":
				case "isoWeek":
				case "day":
				case "date":
					this.hours(0);
				case "hour":
					this.minutes(0);
				case "minute":
					this.seconds(0);
				case "second":
					this.milliseconds(0)
			}
			return "week" === t && this.weekday(0), "isoWeek" === t && this.isoWeekday(1), "quarter" === t && this.month(3 * Math.floor(this.month() / 3)), this
		}, ri.subtract = Ge, ri.toArray = function() {
			var t = this;
			return [t.year(), t.month(), t.date(), t.hour(), t.minute(), t.second(), t.millisecond()]
		}, ri.toObject = function() {
			var t = this;
			return {
				years: t.year(),
				months: t.month(),
				date: t.date(),
				hours: t.hours(),
				minutes: t.minutes(),
				seconds: t.seconds(),
				milliseconds: t.milliseconds()
			}
		}, ri.toDate = function() {
			return new Date(this.valueOf())
		}, ri.toISOString = function(t) {
			if (!this.isValid()) return null;
			var e = !0 !== t,
				i = e ? this.clone().utc() : this;
			return i.year() < 0 || 9999 < i.year() ? F(i, e ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : k(Date.prototype.toISOString) ? e ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", F(i, "Z")) : F(i, e ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ")
		}, ri.inspect = function() {
			if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
			var t = "moment",
				e = "";
			this.isLocal() || (t = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", e = "Z");
			var i = "[" + t + '("]',
				s = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY",
				n = e + '[")]';
			return this.format(i + s + "-MM-DD[T]HH:mm:ss.SSS" + n)
		}, ri.toJSON = function() {
			return this.isValid() ? this.toISOString() : null
		}, ri.toString = function() {
			return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")
		}, ri.unix = function() {
			return Math.floor(this.valueOf() / 1e3)
		}, ri.valueOf = function() {
			return this._d.valueOf() - 6e4 * (this._offset || 0)
		}, ri.creationData = function() {
			return {
				input: this._i,
				format: this._f,
				locale: this._locale,
				isUTC: this._isUTC,
				strict: this._strict
			}
		}, ri.year = Et, ri.isLeapYear = function() {
			return Ct(this.year())
		}, ri.weekYear = function(t) {
			return ti.call(this, t, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy)
		}, ri.isoWeekYear = function(t) {
			return ti.call(this, t, this.isoWeek(), this.isoWeekday(), 1, 4)
		}, ri.quarter = ri.quarters = function(t) {
			return null == t ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (t - 1) + this.month() % 3)
		}, ri.month = It, ri.daysInMonth = function() {
			return Mt(this.year(), this.month())
		}, ri.week = ri.weeks = function(t) {
			var e = this.localeData().week(this);
			return null == t ? e : this.add(7 * (t - e), "d")
		}, ri.isoWeek = ri.isoWeeks = function(t) {
			var e = Bt(this, 1, 4).week;
			return null == t ? e : this.add(7 * (t - e), "d")
		}, ri.weeksInYear = function() {
			var t = this.localeData()._week;
			return Ft(this.year(), t.dow, t.doy)
		}, ri.isoWeeksInYear = function() {
			return Ft(this.year(), 1, 4)
		}, ri.date = ei, ri.day = ri.days = function(t) {
			if (!this.isValid()) return null != t ? this : NaN;
			var e, i, s = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
			return null != t ? (e = t, i = this.localeData(), t = "string" != typeof e ? e : isNaN(e) ? "number" == typeof(e = i.weekdaysParse(e)) ? e : null : parseInt(e, 10), this.add(t - s, "d")) : s
		}, ri.weekday = function(t) {
			if (!this.isValid()) return null != t ? this : NaN;
			var e = (this.day() + 7 - this.localeData()._week.dow) % 7;
			return null == t ? e : this.add(t - e, "d")
		}, ri.isoWeekday = function(t) {
			if (!this.isValid()) return null != t ? this : NaN;
			if (null != t) {
				var e = (i = t, s = this.localeData(), "string" == typeof i ? s.weekdaysParse(i) % 7 || 7 : isNaN(i) ? null : i);
				return this.day(this.day() % 7 ? e : e - 7)
			}
			return this.day() || 7;
			var i, s
		}, ri.dayOfYear = function(t) {
			var e = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
			return null == t ? e : this.add(t - e, "d")
		}, ri.hour = ri.hours = ee, ri.minute = ri.minutes = ii, ri.second = ri.seconds = ni, ri.millisecond = ri.milliseconds = oi, ri.utcOffset = function(t, e, s) {
			var n, a = this._offset || 0;
			if (!this.isValid()) return null != t ? this : NaN;
			if (null != t) {
				if ("string" == typeof t) {
					if (null === (t = Le(at, t))) return this
				} else Math.abs(t) < 16 && !s && (t *= 60);
				return !this._isUTC && e && (n = Ye(this)), this._offset = t, this._isUTC = !0, null != n && this.add(n, "m"), a !== t && (!e || this._changeInProgress ? qe(this, Be(t - a, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, i.updateOffset(this, !0), this._changeInProgress = null)), this
			}
			return this._isUTC ? a : Ye(this)
		}, ri.utc = function(t) {
			return this.utcOffset(0, t)
		}, ri.local = function(t) {
			return this._isUTC && (this.utcOffset(0, t), this._isUTC = !1, t && this.subtract(Ye(this), "m")), this
		}, ri.parseZone = function() {
			if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);
			else if ("string" == typeof this._i) {
				var t = Le(nt, this._i);
				null != t ? this.utcOffset(t) : this.utcOffset(0, !0)
			}
			return this
		}, ri.hasAlignedHourOffset = function(t) {
			return !!this.isValid() && (t = t ? Ee(t).utcOffset() : 0, (this.utcOffset() - t) % 60 == 0)
		}, ri.isDST = function() {
			return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset()
		}, ri.isLocal = function() {
			return !!this.isValid() && !this._isUTC
		}, ri.isUtcOffset = function() {
			return !!this.isValid() && this._isUTC
		}, ri.isUtc = Re, ri.isUTC = Re, ri.zoneAbbr = function() {
			return this._isUTC ? "UTC" : ""
		}, ri.zoneName = function() {
			return this._isUTC ? "Coordinated Universal Time" : ""
		}, ri.dates = C("dates accessor is deprecated. Use date instead.", ei), ri.months = C("months accessor is deprecated. Use month instead", It), ri.years = C("years accessor is deprecated. Use year instead", Et), ri.zone = C("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", function(t, e) {
			return null != t ? ("string" != typeof t && (t = -t), this.utcOffset(t, e), this) : -this.utcOffset()
		}), ri.isDSTShifted = C("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", function() {
			if (!a(this._isDSTShifted)) return this._isDSTShifted;
			var t = {};
			if (g(t, this), (t = Ce(t))._a) {
				var e = t._isUTC ? h(t._a) : Ee(t._a);
				this._isDSTShifted = this.isValid() && 0 < x(t._a, e.toArray())
			} else this._isDSTShifted = !1;
			return this._isDSTShifted
		});
		var di = M.prototype;

		function ci(t, e, i, s) {
			var n = de(),
				a = h().set(s, e);
			return n[i](a, t)
		}

		function hi(t, e, i) {
			if (o(t) && (e = t, t = void 0), t = t || "", null != e) return ci(t, e, i, "month");
			var s, n = [];
			for (s = 0; s < 12; s++) n[s] = ci(t, s, i, "month");
			return n
		}

		function ui(t, e, i, s) {
			"boolean" == typeof t ? o(e) && (i = e, e = void 0) : (e = t, t = !1, o(i = e) && (i = e, e = void 0)), e = e || "";
			var n, a = de(),
				r = t ? a._week.dow : 0;
			if (null != i) return ci(e, (i + r) % 7, s, "day");
			var l = [];
			for (n = 0; n < 7; n++) l[n] = ci(e, (n + r) % 7, s, "day");
			return l
		}
		di.calendar = function(t, e, i) {
			var s = this._calendar[t] || this._calendar.sameElse;
			return k(s) ? s.call(e, i) : s
		}, di.longDateFormat = function(t) {
			var e = this._longDateFormat[t],
				i = this._longDateFormat[t.toUpperCase()];
			return e || !i ? e : (this._longDateFormat[t] = i.replace(/MMMM|MM|DD|dddd/g, function(t) {
				return t.slice(1)
			}), this._longDateFormat[t])
		}, di.invalidDate = function() {
			return this._invalidDate
		}, di.ordinal = function(t) {
			return this._ordinal.replace("%d", t)
		}, di.preparse = li, di.postformat = li, di.relativeTime = function(t, e, i, s) {
			var n = this._relativeTime[i];
			return k(n) ? n(t, e, i, s) : n.replace(/%d/i, t)
		}, di.pastFuture = function(t, e) {
			var i = this._relativeTime[0 < t ? "future" : "past"];
			return k(i) ? i(e) : i.replace(/%s/i, e)
		}, di.set = function(t) {
			var e, i;
			for (i in t) k(e = t[i]) ? this[i] = e : this["_" + i] = e;
			this._config = t, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source)
		}, di.months = function(t, e) {
			return t ? s(this._months) ? this._months[t.month()] : this._months[(this._months.isFormat || Dt).test(e) ? "format" : "standalone"][t.month()] : s(this._months) ? this._months : this._months.standalone
		}, di.monthsShort = function(t, e) {
			return t ? s(this._monthsShort) ? this._monthsShort[t.month()] : this._monthsShort[Dt.test(e) ? "format" : "standalone"][t.month()] : s(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone
		}, di.monthsParse = function(t, e, i) {
			var s, n, a;
			if (this._monthsParseExact) return function(t, e, i) {
				var s, n, a, o = t.toLocaleLowerCase();
				if (!this._monthsParse)
					for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], s = 0; s < 12; ++s) a = h([2e3, s]), this._shortMonthsParse[s] = this.monthsShort(a, "").toLocaleLowerCase(), this._longMonthsParse[s] = this.months(a, "").toLocaleLowerCase();
				return i ? "MMM" === e ? -1 !== (n = _t.call(this._shortMonthsParse, o)) ? n : null : -1 !== (n = _t.call(this._longMonthsParse, o)) ? n : null : "MMM" === e ? -1 !== (n = _t.call(this._shortMonthsParse, o)) ? n : -1 !== (n = _t.call(this._longMonthsParse, o)) ? n : null : -1 !== (n = _t.call(this._longMonthsParse, o)) ? n : -1 !== (n = _t.call(this._shortMonthsParse, o)) ? n : null
			}.call(this, t, e, i);
			for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), s = 0; s < 12; s++) {
				if (n = h([2e3, s]), i && !this._longMonthsParse[s] && (this._longMonthsParse[s] = new RegExp("^" + this.months(n, "").replace(".", "") + "$", "i"), this._shortMonthsParse[s] = new RegExp("^" + this.monthsShort(n, "").replace(".", "") + "$", "i")), i || this._monthsParse[s] || (a = "^" + this.months(n, "") + "|^" + this.monthsShort(n, ""), this._monthsParse[s] = new RegExp(a.replace(".", ""), "i")), i && "MMMM" === e && this._longMonthsParse[s].test(t)) return s;
				if (i && "MMM" === e && this._shortMonthsParse[s].test(t)) return s;
				if (!i && this._monthsParse[s].test(t)) return s
			}
		}, di.monthsRegex = function(t) {
			return this._monthsParseExact ? (d(this, "_monthsRegex") || Yt.call(this), t ? this._monthsStrictRegex : this._monthsRegex) : (d(this, "_monthsRegex") || (this._monthsRegex = Nt), this._monthsStrictRegex && t ? this._monthsStrictRegex : this._monthsRegex)
		}, di.monthsShortRegex = function(t) {
			return this._monthsParseExact ? (d(this, "_monthsRegex") || Yt.call(this), t ? this._monthsShortStrictRegex : this._monthsShortRegex) : (d(this, "_monthsShortRegex") || (this._monthsShortRegex = Lt), this._monthsShortStrictRegex && t ? this._monthsShortStrictRegex : this._monthsShortRegex)
		}, di.week = function(t) {
			return Bt(t, this._week.dow, this._week.doy).week
		}, di.firstDayOfYear = function() {
			return this._week.doy
		}, di.firstDayOfWeek = function() {
			return this._week.dow
		}, di.weekdays = function(t, e) {
			return t ? s(this._weekdays) ? this._weekdays[t.day()] : this._weekdays[this._weekdays.isFormat.test(e) ? "format" : "standalone"][t.day()] : s(this._weekdays) ? this._weekdays : this._weekdays.standalone
		}, di.weekdaysMin = function(t) {
			return t ? this._weekdaysMin[t.day()] : this._weekdaysMin
		}, di.weekdaysShort = function(t) {
			return t ? this._weekdaysShort[t.day()] : this._weekdaysShort
		}, di.weekdaysParse = function(t, e, i) {
			var s, n, a;
			if (this._weekdaysParseExact) return function(t, e, i) {
				var s, n, a, o = t.toLocaleLowerCase();
				if (!this._weekdaysParse)
					for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], s = 0; s < 7; ++s) a = h([2e3, 1]).day(s), this._minWeekdaysParse[s] = this.weekdaysMin(a, "").toLocaleLowerCase(), this._shortWeekdaysParse[s] = this.weekdaysShort(a, "").toLocaleLowerCase(), this._weekdaysParse[s] = this.weekdays(a, "").toLocaleLowerCase();
				return i ? "dddd" === e ? -1 !== (n = _t.call(this._weekdaysParse, o)) ? n : null : "ddd" === e ? -1 !== (n = _t.call(this._shortWeekdaysParse, o)) ? n : null : -1 !== (n = _t.call(this._minWeekdaysParse, o)) ? n : null : "dddd" === e ? -1 !== (n = _t.call(this._weekdaysParse, o)) ? n : -1 !== (n = _t.call(this._shortWeekdaysParse, o)) ? n : -1 !== (n = _t.call(this._minWeekdaysParse, o)) ? n : null : "ddd" === e ? -1 !== (n = _t.call(this._shortWeekdaysParse, o)) ? n : -1 !== (n = _t.call(this._weekdaysParse, o)) ? n : -1 !== (n = _t.call(this._minWeekdaysParse, o)) ? n : null : -1 !== (n = _t.call(this._minWeekdaysParse, o)) ? n : -1 !== (n = _t.call(this._weekdaysParse, o)) ? n : -1 !== (n = _t.call(this._shortWeekdaysParse, o)) ? n : null
			}.call(this, t, e, i);
			for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), s = 0; s < 7; s++) {
				if (n = h([2e3, 1]).day(s), i && !this._fullWeekdaysParse[s] && (this._fullWeekdaysParse[s] = new RegExp("^" + this.weekdays(n, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[s] = new RegExp("^" + this.weekdaysShort(n, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[s] = new RegExp("^" + this.weekdaysMin(n, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[s] || (a = "^" + this.weekdays(n, "") + "|^" + this.weekdaysShort(n, "") + "|^" + this.weekdaysMin(n, ""), this._weekdaysParse[s] = new RegExp(a.replace(".", ""), "i")), i && "dddd" === e && this._fullWeekdaysParse[s].test(t)) return s;
				if (i && "ddd" === e && this._shortWeekdaysParse[s].test(t)) return s;
				if (i && "dd" === e && this._minWeekdaysParse[s].test(t)) return s;
				if (!i && this._weekdaysParse[s].test(t)) return s
			}
		}, di.weekdaysRegex = function(t) {
			return this._weekdaysParseExact ? (d(this, "_weekdaysRegex") || Qt.call(this), t ? this._weekdaysStrictRegex : this._weekdaysRegex) : (d(this, "_weekdaysRegex") || (this._weekdaysRegex = Ut), this._weekdaysStrictRegex && t ? this._weekdaysStrictRegex : this._weekdaysRegex)
		}, di.weekdaysShortRegex = function(t) {
			return this._weekdaysParseExact ? (d(this, "_weekdaysRegex") || Qt.call(this), t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (d(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Gt), this._weekdaysShortStrictRegex && t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex)
		}, di.weekdaysMinRegex = function(t) {
			return this._weekdaysParseExact ? (d(this, "_weekdaysRegex") || Qt.call(this), t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (d(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Xt), this._weekdaysMinStrictRegex && t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex)
		}, di.isPM = function(t) {
			return "p" === (t + "").toLowerCase().charAt(0)
		}, di.meridiem = function(t, e, i) {
			return 11 < t ? i ? "pm" : "PM" : i ? "am" : "AM"
		}, re("en", {
			dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
			ordinal: function(t) {
				var e = t % 10;
				return t + (1 === S(t % 100 / 10) ? "th" : 1 === e ? "st" : 2 === e ? "nd" : 3 === e ? "rd" : "th")
			}
		}), i.lang = C("moment.lang is deprecated. Use moment.locale instead.", re), i.langData = C("moment.langData is deprecated. Use moment.localeData instead.", de);
		var pi = Math.abs;

		function fi(t, e, i, s) {
			var n = Be(e, i);
			return t._milliseconds += s * n._milliseconds, t._days += s * n._days, t._months += s * n._months, t._bubble()
		}

		function mi(t) {
			return t < 0 ? Math.floor(t) : Math.ceil(t)
		}

		function gi(t) {
			return 4800 * t / 146097
		}

		function vi(t) {
			return 146097 * t / 4800
		}

		function yi(t) {
			return function() {
				return this.as(t)
			}
		}
		var bi = yi("ms"),
			wi = yi("s"),
			Si = yi("m"),
			xi = yi("h"),
			Ti = yi("d"),
			Ci = yi("w"),
			_i = yi("M"),
			Ei = yi("y");

		function Pi(t) {
			return function() {
				return this.isValid() ? this._data[t] : NaN
			}
		}
		var ki = Pi("milliseconds"),
			$i = Pi("seconds"),
			Mi = Pi("minutes"),
			Di = Pi("hours"),
			Oi = Pi("days"),
			zi = Pi("months"),
			Ai = Pi("years"),
			Ii = Math.round,
			Li = {
				ss: 44,
				s: 45,
				m: 45,
				h: 22,
				d: 26,
				M: 11
			},
			Ni = Math.abs;

		function Yi(t) {
			return (0 < t) - (t < 0) || +t
		}

		function Ri() {
			if (!this.isValid()) return this.localeData().invalidDate();
			var t, e, i = Ni(this._milliseconds) / 1e3,
				s = Ni(this._days),
				n = Ni(this._months);
			e = w((t = w(i / 60)) / 60), i %= 60, t %= 60;
			var a = w(n / 12),
				o = n %= 12,
				r = s,
				l = e,
				d = t,
				c = i ? i.toFixed(3).replace(/\.?0+$/, "") : "",
				h = this.asSeconds();
			if (!h) return "P0D";
			var u = h < 0 ? "-" : "",
				p = Yi(this._months) !== Yi(h) ? "-" : "",
				f = Yi(this._days) !== Yi(h) ? "-" : "",
				m = Yi(this._milliseconds) !== Yi(h) ? "-" : "";
			return u + "P" + (a ? p + a + "Y" : "") + (o ? p + o + "M" : "") + (r ? f + r + "D" : "") + (l || d || c ? "T" : "") + (l ? m + l + "H" : "") + (d ? m + d + "M" : "") + (c ? m + c + "S" : "")
		}
		var ji = De.prototype;
		return ji.isValid = function() {
			return this._isValid
		}, ji.abs = function() {
			var t = this._data;
			return this._milliseconds = pi(this._milliseconds), this._days = pi(this._days), this._months = pi(this._months), t.milliseconds = pi(t.milliseconds), t.seconds = pi(t.seconds), t.minutes = pi(t.minutes), t.hours = pi(t.hours), t.months = pi(t.months), t.years = pi(t.years), this
		}, ji.add = function(t, e) {
			return fi(this, t, e, 1)
		}, ji.subtract = function(t, e) {
			return fi(this, t, e, -1)
		}, ji.as = function(t) {
			if (!this.isValid()) return NaN;
			var e, i, s = this._milliseconds;
			if ("month" === (t = z(t)) || "year" === t) return e = this._days + s / 864e5, i = this._months + gi(e), "month" === t ? i : i / 12;
			switch (e = this._days + Math.round(vi(this._months)), t) {
				case "week":
					return e / 7 + s / 6048e5;
				case "day":
					return e + s / 864e5;
				case "hour":
					return 24 * e + s / 36e5;
				case "minute":
					return 1440 * e + s / 6e4;
				case "second":
					return 86400 * e + s / 1e3;
				case "millisecond":
					return Math.floor(864e5 * e) + s;
				default:
					throw new Error("Unknown unit " + t)
			}
		}, ji.asMilliseconds = bi, ji.asSeconds = wi, ji.asMinutes = Si, ji.asHours = xi, ji.asDays = Ti, ji.asWeeks = Ci, ji.asMonths = _i, ji.asYears = Ei, ji.valueOf = function() {
			return this.isValid() ? this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * S(this._months / 12) : NaN
		}, ji._bubble = function() {
			var t, e, i, s, n, a = this._milliseconds,
				o = this._days,
				r = this._months,
				l = this._data;
			return 0 <= a && 0 <= o && 0 <= r || a <= 0 && o <= 0 && r <= 0 || (a += 864e5 * mi(vi(r) + o), r = o = 0), l.milliseconds = a % 1e3, t = w(a / 1e3), l.seconds = t % 60, e = w(t / 60), l.minutes = e % 60, i = w(e / 60), l.hours = i % 24, r += n = w(gi(o += w(i / 24))), o -= mi(vi(n)), s = w(r / 12), r %= 12, l.days = o, l.months = r, l.years = s, this
		}, ji.clone = function() {
			return Be(this)
		}, ji.get = function(t) {
			return t = z(t), this.isValid() ? this[t + "s"]() : NaN
		}, ji.milliseconds = ki, ji.seconds = $i, ji.minutes = Mi, ji.hours = Di, ji.days = Oi, ji.weeks = function() {
			return w(this.days() / 7)
		}, ji.months = zi, ji.years = Ai, ji.humanize = function(t) {
			if (!this.isValid()) return this.localeData().invalidDate();
			var e, i, s, n, a, o, r, l, d, c, h = this.localeData(),
				u = (e = !t, i = h, s = Be(this).abs(), n = Ii(s.as("s")), a = Ii(s.as("m")), o = Ii(s.as("h")), r = Ii(s.as("d")), l = Ii(s.as("M")), d = Ii(s.as("y")), (c = n <= Li.ss && ["s", n] || n < Li.s && ["ss", n] || a <= 1 && ["m"] || a < Li.m && ["mm", a] || o <= 1 && ["h"] || o < Li.h && ["hh", o] || r <= 1 && ["d"] || r < Li.d && ["dd", r] || l <= 1 && ["M"] || l < Li.M && ["MM", l] || d <= 1 && ["y"] || ["yy", d])[2] = e, c[3] = 0 < +this, c[4] = i, function(t, e, i, s, n) {
					return n.relativeTime(e || 1, !!i, t, s)
				}.apply(null, c));
			return t && (u = h.pastFuture(+this, u)), h.postformat(u)
		}, ji.toISOString = Ri, ji.toString = Ri, ji.toJSON = Ri, ji.locale = Qe, ji.localeData = Ke, ji.toIsoString = C("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", Ri), ji.lang = Ze, B("X", 0, 0, "unix"), B("x", 0, 0, "valueOf"), lt("x", st), lt("X", /[+-]?\d+(\.\d{1,3})?/), ut("X", function(t, e, i) {
			i._d = new Date(1e3 * parseFloat(t, 10))
		}), ut("x", function(t, e, i) {
			i._d = new Date(S(t))
		}), i.version = "2.22.2", t = Ee, i.fn = ri, i.min = function() {
			return $e("isBefore", [].slice.call(arguments, 0))
		}, i.max = function() {
			return $e("isAfter", [].slice.call(arguments, 0))
		}, i.now = function() {
			return Date.now ? Date.now() : +new Date
		}, i.utc = h, i.unix = function(t) {
			return Ee(1e3 * t)
		}, i.months = function(t, e) {
			return hi(t, e, "months")
		}, i.isDate = r, i.locale = re, i.invalid = f, i.duration = Be, i.isMoment = b, i.weekdays = function(t, e, i) {
			return ui(t, e, i, "weekdays")
		}, i.parseZone = function() {
			return Ee.apply(null, arguments).parseZone()
		}, i.localeData = de, i.isDuration = Oe, i.monthsShort = function(t, e) {
			return hi(t, e, "monthsShort")
		}, i.weekdaysMin = function(t, e, i) {
			return ui(t, e, i, "weekdaysMin")
		}, i.defineLocale = le, i.updateLocale = function(t, e) {
			if (null != e) {
				var i, s, n = ie;
				null != (s = oe(t)) && (n = s._config), (i = new M(e = $(n, e))).parentLocale = se[t], se[t] = i, re(t)
			} else null != se[t] && (null != se[t].parentLocale ? se[t] = se[t].parentLocale : null != se[t] && delete se[t]);
			return se[t]
		}, i.locales = function() {
			return _(se)
		}, i.weekdaysShort = function(t, e, i) {
			return ui(t, e, i, "weekdaysShort")
		}, i.normalizeUnits = z, i.relativeTimeRounding = function(t) {
			return void 0 === t ? Ii : "function" == typeof t && (Ii = t, !0)
		}, i.relativeTimeThreshold = function(t, e) {
			return void 0 !== Li[t] && (void 0 === e ? Li[t] : (Li[t] = e, "s" === t && (Li.ss = e - 1), !0))
		}, i.calendarFormat = function(t, e) {
			var i = t.diff(e, "days", !0);
			return i < -6 ? "sameElse" : i < -1 ? "lastWeek" : i < 0 ? "lastDay" : i < 1 ? "sameDay" : i < 2 ? "nextDay" : i < 7 ? "nextWeek" : "sameElse"
		}, i.prototype = ri, i.HTML5_FMT = {
			DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
			DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
			DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
			DATE: "YYYY-MM-DD",
			TIME: "HH:mm",
			TIME_SECONDS: "HH:mm:ss",
			TIME_MS: "HH:mm:ss.SSS",
			WEEK: "YYYY-[W]WW",
			MONTH: "YYYY-MM"
		}, i
	}), "undefined" == typeof jQuery) throw new Error("Bootstrap's JavaScript requires jQuery");

function floatToString(t, e) {
	var i = t.toFixed(e).toString();
	return i.match(/^\.\d+/) ? "0" + i : i
}

function attributeToString(t) {
	return "string" != typeof t && "undefined" === (t += "") && (t = ""), jQuery.trim(t)
}! function(t) {
	"use strict";
	var e = jQuery.fn.jquery.split(" ")[0].split(".");
	if (e[0] < 2 && e[1] < 9 || 1 == e[0] && 9 == e[1] && e[2] < 1 || e[0] > 3) throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")
}(),
function(t) {
	"use strict";
	t.fn.emulateTransitionEnd = function(e) {
		var i = !1,
			s = this;
		t(this).one("bsTransitionEnd", function() {
			i = !0
		});
		return setTimeout(function() {
			i || t(s).trigger(t.support.transition.end)
		}, e), this
	}, t(function() {
		t.support.transition = function() {
			var t = document.createElement("bootstrap"),
				e = {
					WebkitTransition: "webkitTransitionEnd",
					MozTransition: "transitionend",
					OTransition: "oTransitionEnd otransitionend",
					transition: "transitionend"
				};
			for (var i in e)
				if (void 0 !== t.style[i]) return {
					end: e[i]
				};
			return !1
		}(), t.support.transition && (t.event.special.bsTransitionEnd = {
			bindType: t.support.transition.end,
			delegateType: t.support.transition.end,
			handle: function(e) {
				if (t(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
			}
		})
	})
}(jQuery),
function(t) {
	"use strict";
	var e = '[data-dismiss="alert"]',
		i = function(i) {
			t(i).on("click", e, this.close)
		};
	i.VERSION = "3.3.7", i.TRANSITION_DURATION = 150, i.prototype.close = function(e) {
		function s() {
			o.detach().trigger("closed.bs.alert").remove()
		}
		var n = t(this),
			a = n.attr("data-target");
		a || (a = (a = n.attr("href")) && a.replace(/.*(?=#[^\s]*$)/, ""));
		var o = t("#" === a ? [] : a);
		e && e.preventDefault(), o.length || (o = n.closest(".alert")), o.trigger(e = t.Event("close.bs.alert")), e.isDefaultPrevented() || (o.removeClass("in"), t.support.transition && o.hasClass("fade") ? o.one("bsTransitionEnd", s).emulateTransitionEnd(i.TRANSITION_DURATION) : s())
	};
	var s = t.fn.alert;
	t.fn.alert = function(e) {
		return this.each(function() {
			var s = t(this),
				n = s.data("bs.alert");
			n || s.data("bs.alert", n = new i(this)), "string" == typeof e && n[e].call(s)
		})
	}, t.fn.alert.Constructor = i, t.fn.alert.noConflict = function() {
		return t.fn.alert = s, this
	}, t(document).on("click.bs.alert.data-api", e, i.prototype.close)
}(jQuery),
function(t) {
	"use strict";

	function e(e) {
		return this.each(function() {
			var s = t(this),
				n = s.data("bs.button"),
				a = "object" == typeof e && e;
			n || s.data("bs.button", n = new i(this, a)), "toggle" == e ? n.toggle() : e && n.setState(e)
		})
	}
	var i = function(e, s) {
		this.$element = t(e), this.options = t.extend({}, i.DEFAULTS, s), this.isLoading = !1
	};
	i.VERSION = "3.3.7", i.DEFAULTS = {
		loadingText: "loading..."
	}, i.prototype.setState = function(e) {
		var i = "disabled",
			s = this.$element,
			n = s.is("input") ? "val" : "html",
			a = s.data();
		e += "Text", null == a.resetText && s.data("resetText", s[n]()), setTimeout(t.proxy(function() {
			s[n](null == a[e] ? this.options[e] : a[e]), "loadingText" == e ? (this.isLoading = !0, s.addClass(i).attr(i, i).prop(i, !0)) : this.isLoading && (this.isLoading = !1, s.removeClass(i).removeAttr(i).prop(i, !1))
		}, this), 0)
	}, i.prototype.toggle = function() {
		var t = !0,
			e = this.$element.closest('[data-toggle="buttons"]');
		if (e.length) {
			var i = this.$element.find("input");
			"radio" == i.prop("type") ? (i.prop("checked") && (t = !1), e.find(".active").removeClass("active"), this.$element.addClass("active")) : "checkbox" == i.prop("type") && (i.prop("checked") !== this.$element.hasClass("active") && (t = !1), this.$element.toggleClass("active")), i.prop("checked", this.$element.hasClass("active")), t && i.trigger("change")
		} else this.$element.attr("aria-pressed", !this.$element.hasClass("active")), this.$element.toggleClass("active")
	};
	var s = t.fn.button;
	t.fn.button = e, t.fn.button.Constructor = i, t.fn.button.noConflict = function() {
		return t.fn.button = s, this
	}, t(document).on("click.bs.button.data-api", '[data-toggle^="button"]', function(i) {
		var s = t(i.target).closest(".btn");
		e.call(s, "toggle"), t(i.target).is('input[type="radio"], input[type="checkbox"]') || (i.preventDefault(), s.is("input,button") ? s.trigger("focus") : s.find("input:visible,button:visible").first().trigger("focus"))
	}).on("focus.bs.button.data-api blur.bs.button.data-api", '[data-toggle^="button"]', function(e) {
		t(e.target).closest(".btn").toggleClass("focus", /^focus(in)?$/.test(e.type))
	})
}(jQuery),
function(t) {
	"use strict";

	function e(e) {
		return this.each(function() {
			var s = t(this),
				n = s.data("bs.carousel"),
				a = t.extend({}, i.DEFAULTS, s.data(), "object" == typeof e && e),
				o = "string" == typeof e ? e : a.slide;
			n || s.data("bs.carousel", n = new i(this, a)), "number" == typeof e ? n.to(e) : o ? n[o]() : a.interval && n.pause().cycle()
		})
	}
	var i = function(e, i) {
		this.$element = t(e), this.$indicators = this.$element.find(".carousel-indicators"), this.options = i, this.paused = null, this.sliding = null, this.interval = null, this.$active = null, this.$items = null, this.options.keyboard && this.$element.on("keydown.bs.carousel", t.proxy(this.keydown, this)), "hover" == this.options.pause && !("ontouchstart" in document.documentElement) && this.$element.on("mouseenter.bs.carousel", t.proxy(this.pause, this)).on("mouseleave.bs.carousel", t.proxy(this.cycle, this))
	};
	i.VERSION = "3.3.7", i.TRANSITION_DURATION = 600, i.DEFAULTS = {
		interval: 5e3,
		pause: "hover",
		wrap: !0,
		keyboard: !0
	}, i.prototype.keydown = function(t) {
		if (!/input|textarea/i.test(t.target.tagName)) {
			switch (t.which) {
				case 37:
					this.prev();
					break;
				case 39:
					this.next();
					break;
				default:
					return
			}
			t.preventDefault()
		}
	}, i.prototype.cycle = function(e) {
		return e || (this.paused = !1), this.interval && clearInterval(this.interval), this.options.interval && !this.paused && (this.interval = setInterval(t.proxy(this.next, this), this.options.interval)), this
	}, i.prototype.getItemIndex = function(t) {
		return this.$items = t.parent().children(".item"), this.$items.index(t || this.$active)
	}, i.prototype.getItemForDirection = function(t, e) {
		var i = this.getItemIndex(e);
		if (("prev" == t && 0 === i || "next" == t && i == this.$items.length - 1) && !this.options.wrap) return e;
		var s = (i + ("prev" == t ? -1 : 1)) % this.$items.length;
		return this.$items.eq(s)
	}, i.prototype.to = function(t) {
		var e = this,
			i = this.getItemIndex(this.$active = this.$element.find(".item.active"));
		if (!(t > this.$items.length - 1 || t < 0)) return this.sliding ? this.$element.one("slid.bs.carousel", function() {
			e.to(t)
		}) : i == t ? this.pause().cycle() : this.slide(t > i ? "next" : "prev", this.$items.eq(t))
	}, i.prototype.pause = function(e) {
		return e || (this.paused = !0), this.$element.find(".next, .prev").length && t.support.transition && (this.$element.trigger(t.support.transition.end), this.cycle(!0)), this.interval = clearInterval(this.interval), this
	}, i.prototype.next = function() {
		if (!this.sliding) return this.slide("next")
	}, i.prototype.prev = function() {
		if (!this.sliding) return this.slide("prev")
	}, i.prototype.slide = function(e, s) {
		var n = this.$element.find(".item.active"),
			a = s || this.getItemForDirection(e, n),
			o = this.interval,
			r = "next" == e ? "left" : "right",
			l = this;
		if (a.hasClass("active")) return this.sliding = !1;
		var d = a[0],
			c = t.Event("slide.bs.carousel", {
				relatedTarget: d,
				direction: r
			});
		if (this.$element.trigger(c), !c.isDefaultPrevented()) {
			if (this.sliding = !0, o && this.pause(), this.$indicators.length) {
				this.$indicators.find(".active").removeClass("active");
				var h = t(this.$indicators.children()[this.getItemIndex(a)]);
				h && h.addClass("active")
			}
			var u = t.Event("slid.bs.carousel", {
				relatedTarget: d,
				direction: r
			});
			return t.support.transition && this.$element.hasClass("slide") ? (a.addClass(e), a[0].offsetWidth, n.addClass(r), a.addClass(r), n.one("bsTransitionEnd", function() {
				a.removeClass([e, r].join(" ")).addClass("active"), n.removeClass(["active", r].join(" ")), l.sliding = !1, setTimeout(function() {
					l.$element.trigger(u)
				}, 0)
			}).emulateTransitionEnd(i.TRANSITION_DURATION)) : (n.removeClass("active"), a.addClass("active"), this.sliding = !1, this.$element.trigger(u)), o && this.cycle(), this
		}
	};
	var s = t.fn.carousel;
	t.fn.carousel = e, t.fn.carousel.Constructor = i, t.fn.carousel.noConflict = function() {
		return t.fn.carousel = s, this
	};
	var n = function(i) {
		var s, n = t(this),
			a = t(n.attr("data-target") || (s = n.attr("href")) && s.replace(/.*(?=#[^\s]+$)/, ""));
		if (a.hasClass("carousel")) {
			var o = t.extend({}, a.data(), n.data()),
				r = n.attr("data-slide-to");
			r && (o.interval = !1), e.call(a, o), r && a.data("bs.carousel").to(r), i.preventDefault()
		}
	};
	t(document).on("click.bs.carousel.data-api", "[data-slide]", n).on("click.bs.carousel.data-api", "[data-slide-to]", n), t(window).on("load", function() {
		t('[data-ride="carousel"]').each(function() {
			var i = t(this);
			e.call(i, i.data())
		})
	})
}(jQuery),
function(t) {
	"use strict";

	function e(e) {
		var i, s = e.attr("data-target") || (i = e.attr("href")) && i.replace(/.*(?=#[^\s]+$)/, "");
		return t(s)
	}

	function i(e) {
		return this.each(function() {
			var i = t(this),
				n = i.data("bs.collapse"),
				a = t.extend({}, s.DEFAULTS, i.data(), "object" == typeof e && e);
			!n && a.toggle && /show|hide/.test(e) && (a.toggle = !1), n || i.data("bs.collapse", n = new s(this, a)), "string" == typeof e && n[e]()
		})
	}
	var s = function(e, i) {
		this.$element = t(e), this.options = t.extend({}, s.DEFAULTS, i), this.$trigger = t('[data-toggle="collapse"][href="#' + e.id + '"],[data-toggle="collapse"][data-target="#' + e.id + '"]'), this.transitioning = null, this.options.parent ? this.$parent = this.getParent() : this.addAriaAndCollapsedClass(this.$element, this.$trigger), this.options.toggle && this.toggle()
	};
	s.VERSION = "3.3.7", s.TRANSITION_DURATION = 350, s.DEFAULTS = {
		toggle: !0
	}, s.prototype.dimension = function() {
		return this.$element.hasClass("width") ? "width" : "height"
	}, s.prototype.show = function() {
		if (!this.transitioning && !this.$element.hasClass("in")) {
			var e, n = this.$parent && this.$parent.children(".panel").children(".in, .collapsing");
			if (!(n && n.length && (e = n.data("bs.collapse"), e && e.transitioning))) {
				var a = t.Event("show.bs.collapse");
				if (this.$element.trigger(a), !a.isDefaultPrevented()) {
					n && n.length && (i.call(n, "hide"), e || n.data("bs.collapse", null));
					var o = this.dimension();
					this.$element.removeClass("collapse").addClass("collapsing")[o](0).attr("aria-expanded", !0), this.$trigger.removeClass("collapsed").attr("aria-expanded", !0), this.transitioning = 1;
					var r = function() {
						this.$element.removeClass("collapsing").addClass("collapse in")[o](""), this.transitioning = 0, this.$element.trigger("shown.bs.collapse")
					};
					if (!t.support.transition) return r.call(this);
					var l = t.camelCase(["scroll", o].join("-"));
					this.$element.one("bsTransitionEnd", t.proxy(r, this)).emulateTransitionEnd(s.TRANSITION_DURATION)[o](this.$element[0][l])
				}
			}
		}
	}, s.prototype.hide = function() {
		if (!this.transitioning && this.$element.hasClass("in")) {
			var e = t.Event("hide.bs.collapse");
			if (this.$element.trigger(e), !e.isDefaultPrevented()) {
				var i = this.dimension();
				this.$element[i](this.$element[i]())[0].offsetHeight, this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded", !1), this.$trigger.addClass("collapsed").attr("aria-expanded", !1), this.transitioning = 1;
				var n = function() {
					this.transitioning = 0, this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")
				};
				return t.support.transition ? void this.$element[i](0).one("bsTransitionEnd", t.proxy(n, this)).emulateTransitionEnd(s.TRANSITION_DURATION) : n.call(this)
			}
		}
	}, s.prototype.toggle = function() {
		this[this.$element.hasClass("in") ? "hide" : "show"]()
	}, s.prototype.getParent = function() {
		return t(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each(t.proxy(function(i, s) {
			var n = t(s);
			this.addAriaAndCollapsedClass(e(n), n)
		}, this)).end()
	}, s.prototype.addAriaAndCollapsedClass = function(t, e) {
		var i = t.hasClass("in");
		t.attr("aria-expanded", i), e.toggleClass("collapsed", !i).attr("aria-expanded", i)
	};
	var n = t.fn.collapse;
	t.fn.collapse = i, t.fn.collapse.Constructor = s, t.fn.collapse.noConflict = function() {
		return t.fn.collapse = n, this
	}, t(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function(s) {
		var n = t(this);
		n.attr("data-target") || s.preventDefault();
		var a = e(n),
			o = a.data("bs.collapse") ? "toggle" : n.data();
		i.call(a, o)
	})
}(jQuery),
function(t) {
	"use strict";

	function e(e) {
		var i = e.attr("data-target");
		i || (i = (i = e.attr("href")) && /#[A-Za-z]/.test(i) && i.replace(/.*(?=#[^\s]*$)/, ""));
		var s = i && t(i);
		return s && s.length ? s : e.parent()
	}

	function i(i) {
		i && 3 === i.which || (t(s).remove(), t(n).each(function() {
			var s = t(this),
				n = e(s),
				a = {
					relatedTarget: this
				};
			n.hasClass("open") && (i && "click" == i.type && /input|textarea/i.test(i.target.tagName) && t.contains(n[0], i.target) || (n.trigger(i = t.Event("hide.bs.dropdown", a)), i.isDefaultPrevented() || (s.attr("aria-expanded", "false"), n.removeClass("open").trigger(t.Event("hidden.bs.dropdown", a)))))
		}))
	}
	var s = ".dropdown-backdrop",
		n = '[data-toggle="dropdown"]',
		a = function(e) {
			t(e).on("click.bs.dropdown", this.toggle)
		};
	a.VERSION = "3.3.7", a.prototype.toggle = function(s) {
		var n = t(this);
		if (!n.is(".disabled, :disabled")) {
			var a = e(n),
				o = a.hasClass("open");
			if (i(), !o) {
				"ontouchstart" in document.documentElement && !a.closest(".navbar-nav").length && t(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(t(this)).on("click", i);
				var r = {
					relatedTarget: this
				};
				if (a.trigger(s = t.Event("show.bs.dropdown", r)), s.isDefaultPrevented()) return;
				n.trigger("focus").attr("aria-expanded", "true"), a.toggleClass("open").trigger(t.Event("shown.bs.dropdown", r))
			}
			return !1
		}
	}, a.prototype.keydown = function(i) {
		if (/(38|40|27|32)/.test(i.which) && !/input|textarea/i.test(i.target.tagName)) {
			var s = t(this);
			if (i.preventDefault(), i.stopPropagation(), !s.is(".disabled, :disabled")) {
				var a = e(s),
					o = a.hasClass("open");
				if (!o && 27 != i.which || o && 27 == i.which) return 27 == i.which && a.find(n).trigger("focus"), s.trigger("click");
				var r = a.find(".dropdown-menu li:not(.disabled):visible a");
				if (r.length) {
					var l = r.index(i.target);
					38 == i.which && l > 0 && l--, 40 == i.which && l < r.length - 1 && l++, ~l || (l = 0), r.eq(l).trigger("focus")
				}
			}
		}
	};
	var o = t.fn.dropdown;
	t.fn.dropdown = function(e) {
		return this.each(function() {
			var i = t(this),
				s = i.data("bs.dropdown");
			s || i.data("bs.dropdown", s = new a(this)), "string" == typeof e && s[e].call(i)
		})
	}, t.fn.dropdown.Constructor = a, t.fn.dropdown.noConflict = function() {
		return t.fn.dropdown = o, this
	}, t(document).on("click.bs.dropdown.data-api", i).on("click.bs.dropdown.data-api", ".dropdown form", function(t) {
		t.stopPropagation()
	}).on("click.bs.dropdown.data-api", n, a.prototype.toggle).on("keydown.bs.dropdown.data-api", n, a.prototype.keydown).on("keydown.bs.dropdown.data-api", ".dropdown-menu", a.prototype.keydown)
}(jQuery),
function(t) {
	"use strict";

	function e(e, s) {
		return this.each(function() {
			var n = t(this),
				a = n.data("bs.modal"),
				o = t.extend({}, i.DEFAULTS, n.data(), "object" == typeof e && e);
			a || n.data("bs.modal", a = new i(this, o)), "string" == typeof e ? a[e](s) : o.show && a.show(s)
		})
	}
	var i = function(e, i) {
		this.options = i, this.$body = t(document.body), this.$element = t(e), this.$dialog = this.$element.find(".modal-dialog"), this.$backdrop = null, this.isShown = null, this.originalBodyPad = null, this.scrollbarWidth = 0, this.ignoreBackdropClick = !1, this.options.remote && this.$element.find(".modal-content").load(this.options.remote, t.proxy(function() {
			this.$element.trigger("loaded.bs.modal")
		}, this))
	};
	i.VERSION = "3.3.7", i.TRANSITION_DURATION = 300, i.BACKDROP_TRANSITION_DURATION = 150, i.DEFAULTS = {
		backdrop: !0,
		keyboard: !0,
		show: !0
	}, i.prototype.toggle = function(t) {
		return this.isShown ? this.hide() : this.show(t)
	}, i.prototype.show = function(e) {
		var s = this,
			n = t.Event("show.bs.modal", {
				relatedTarget: e
			});
		this.$element.trigger(n), this.isShown || n.isDefaultPrevented() || (this.isShown = !0, this.checkScrollbar(), this.setScrollbar(), this.$body.addClass("modal-open"), this.escape(), this.resize(), this.$element.on("click.dismiss.bs.modal", '[data-dismiss="modal"]', t.proxy(this.hide, this)), this.$dialog.on("mousedown.dismiss.bs.modal", function() {
			s.$element.one("mouseup.dismiss.bs.modal", function(e) {
				t(e.target).is(s.$element) && (s.ignoreBackdropClick = !0)
			})
		}), this.backdrop(function() {
			var n = t.support.transition && s.$element.hasClass("fade");
			s.$element.parent().length || s.$element.appendTo(s.$body), s.$element.show().scrollTop(0), s.adjustDialog(), n && s.$element[0].offsetWidth, s.$element.addClass("in"), s.enforceFocus();
			var a = t.Event("shown.bs.modal", {
				relatedTarget: e
			});
			n ? s.$dialog.one("bsTransitionEnd", function() {
				s.$element.trigger("focus").trigger(a)
			}).emulateTransitionEnd(i.TRANSITION_DURATION) : s.$element.trigger("focus").trigger(a)
		}))
	}, i.prototype.hide = function(e) {
		e && e.preventDefault(), e = t.Event("hide.bs.modal"), this.$element.trigger(e), this.isShown && !e.isDefaultPrevented() && (this.isShown = !1, this.escape(), this.resize(), t(document).off("focusin.bs.modal"), this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"), this.$dialog.off("mousedown.dismiss.bs.modal"), t.support.transition && this.$element.hasClass("fade") ? this.$element.one("bsTransitionEnd", t.proxy(this.hideModal, this)).emulateTransitionEnd(i.TRANSITION_DURATION) : this.hideModal())
	}, i.prototype.enforceFocus = function() {
		t(document).off("focusin.bs.modal").on("focusin.bs.modal", t.proxy(function(t) {
			document === t.target || this.$element[0] === t.target || this.$element.has(t.target).length || this.$element.trigger("focus")
		}, this))
	}, i.prototype.escape = function() {
		this.isShown && this.options.keyboard ? this.$element.on("keydown.dismiss.bs.modal", t.proxy(function(t) {
			27 == t.which && this.hide()
		}, this)) : this.isShown || this.$element.off("keydown.dismiss.bs.modal")
	}, i.prototype.resize = function() {
		this.isShown ? t(window).on("resize.bs.modal", t.proxy(this.handleUpdate, this)) : t(window).off("resize.bs.modal")
	}, i.prototype.hideModal = function() {
		var t = this;
		this.$element.hide(), this.backdrop(function() {
			t.$body.removeClass("modal-open"), t.resetAdjustments(), t.resetScrollbar(), t.$element.trigger("hidden.bs.modal")
		})
	}, i.prototype.removeBackdrop = function() {
		this.$backdrop && this.$backdrop.remove(), this.$backdrop = null
	}, i.prototype.backdrop = function(e) {
		var s = this,
			n = this.$element.hasClass("fade") ? "fade" : "";
		if (this.isShown && this.options.backdrop) {
			var a = t.support.transition && n;
			if (this.$backdrop = t(document.createElement("div")).addClass("modal-backdrop " + n).appendTo(this.$body), this.$element.on("click.dismiss.bs.modal", t.proxy(function(t) {
					return this.ignoreBackdropClick ? void(this.ignoreBackdropClick = !1) : void(t.target === t.currentTarget && ("static" == this.options.backdrop ? this.$element[0].focus() : this.hide()))
				}, this)), a && this.$backdrop[0].offsetWidth, this.$backdrop.addClass("in"), !e) return;
			a ? this.$backdrop.one("bsTransitionEnd", e).emulateTransitionEnd(i.BACKDROP_TRANSITION_DURATION) : e()
		} else if (!this.isShown && this.$backdrop) {
			this.$backdrop.removeClass("in");
			var o = function() {
				s.removeBackdrop(), e && e()
			};
			t.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one("bsTransitionEnd", o).emulateTransitionEnd(i.BACKDROP_TRANSITION_DURATION) : o()
		} else e && e()
	}, i.prototype.handleUpdate = function() {
		this.adjustDialog()
	}, i.prototype.adjustDialog = function() {
		var t = this.$element[0].scrollHeight > document.documentElement.clientHeight;
		this.$element.css({
			paddingLeft: !this.bodyIsOverflowing && t ? this.scrollbarWidth : "",
			paddingRight: this.bodyIsOverflowing && !t ? this.scrollbarWidth : ""
		})
	}, i.prototype.resetAdjustments = function() {
		this.$element.css({
			paddingLeft: "",
			paddingRight: ""
		})
	}, i.prototype.checkScrollbar = function() {
		var t = window.innerWidth;
		if (!t) {
			var e = document.documentElement.getBoundingClientRect();
			t = e.right - Math.abs(e.left)
		}
		this.bodyIsOverflowing = document.body.clientWidth < t, this.scrollbarWidth = this.measureScrollbar()
	}, i.prototype.setScrollbar = function() {
		var t = parseInt(this.$body.css("padding-right") || 0, 10);
		this.originalBodyPad = document.body.style.paddingRight || "", this.bodyIsOverflowing && this.$body.css("padding-right", t + this.scrollbarWidth)
	}, i.prototype.resetScrollbar = function() {
		this.$body.css("padding-right", this.originalBodyPad)
	}, i.prototype.measureScrollbar = function() {
		var t = document.createElement("div");
		t.className = "modal-scrollbar-measure", this.$body.append(t);
		var e = t.offsetWidth - t.clientWidth;
		return this.$body[0].removeChild(t), e
	};
	var s = t.fn.modal;
	t.fn.modal = e, t.fn.modal.Constructor = i, t.fn.modal.noConflict = function() {
		return t.fn.modal = s, this
	}, t(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function(i) {
		var s = t(this),
			n = s.attr("href"),
			a = t(s.attr("data-target") || n && n.replace(/.*(?=#[^\s]+$)/, "")),
			o = a.data("bs.modal") ? "toggle" : t.extend({
				remote: !/#/.test(n) && n
			}, a.data(), s.data());
		s.is("a") && i.preventDefault(), a.one("show.bs.modal", function(t) {
			t.isDefaultPrevented() || a.one("hidden.bs.modal", function() {
				s.is(":visible") && s.trigger("focus")
			})
		}), e.call(a, o, this)
	})
}(jQuery),
function(t) {
	"use strict";
	var e = function(t, e) {
		this.type = null, this.options = null, this.enabled = null, this.timeout = null, this.hoverState = null, this.$element = null, this.inState = null, this.init("tooltip", t, e)
	};
	e.VERSION = "3.3.7", e.TRANSITION_DURATION = 150, e.DEFAULTS = {
		animation: !0,
		placement: "top",
		selector: !1,
		template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
		trigger: "hover focus",
		title: "",
		delay: 0,
		html: !1,
		container: !1,
		viewport: {
			selector: "body",
			padding: 0
		}
	}, e.prototype.init = function(e, i, s) {
		if (this.enabled = !0, this.type = e, this.$element = t(i), this.options = this.getOptions(s), this.$viewport = this.options.viewport && t(t.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : this.options.viewport.selector || this.options.viewport), this.inState = {
				click: !1,
				hover: !1,
				focus: !1
			}, this.$element[0] instanceof document.constructor && !this.options.selector) throw new Error("`selector` option must be specified when initializing " + this.type + " on the window.document object!");
		for (var n = this.options.trigger.split(" "), a = n.length; a--;) {
			var o = n[a];
			if ("click" == o) this.$element.on("click." + this.type, this.options.selector, t.proxy(this.toggle, this));
			else if ("manual" != o) {
				var r = "hover" == o ? "mouseenter" : "focusin",
					l = "hover" == o ? "mouseleave" : "focusout";
				this.$element.on(r + "." + this.type, this.options.selector, t.proxy(this.enter, this)), this.$element.on(l + "." + this.type, this.options.selector, t.proxy(this.leave, this))
			}
		}
		this.options.selector ? this._options = t.extend({}, this.options, {
			trigger: "manual",
			selector: ""
		}) : this.fixTitle()
	}, e.prototype.getDefaults = function() {
		return e.DEFAULTS
	}, e.prototype.getOptions = function(e) {
		return (e = t.extend({}, this.getDefaults(), this.$element.data(), e)).delay && "number" == typeof e.delay && (e.delay = {
			show: e.delay,
			hide: e.delay
		}), e
	}, e.prototype.getDelegateOptions = function() {
		var e = {},
			i = this.getDefaults();
		return this._options && t.each(this._options, function(t, s) {
			i[t] != s && (e[t] = s)
		}), e
	}, e.prototype.enter = function(e) {
		var i = e instanceof this.constructor ? e : t(e.currentTarget).data("bs." + this.type);
		return i || (i = new this.constructor(e.currentTarget, this.getDelegateOptions()), t(e.currentTarget).data("bs." + this.type, i)), e instanceof t.Event && (i.inState["focusin" == e.type ? "focus" : "hover"] = !0), i.tip().hasClass("in") || "in" == i.hoverState ? void(i.hoverState = "in") : (clearTimeout(i.timeout), i.hoverState = "in", i.options.delay && i.options.delay.show ? void(i.timeout = setTimeout(function() {
			"in" == i.hoverState && i.show()
		}, i.options.delay.show)) : i.show())
	}, e.prototype.isInStateTrue = function() {
		for (var t in this.inState)
			if (this.inState[t]) return !0;
		return !1
	}, e.prototype.leave = function(e) {
		var i = e instanceof this.constructor ? e : t(e.currentTarget).data("bs." + this.type);
		if (i || (i = new this.constructor(e.currentTarget, this.getDelegateOptions()), t(e.currentTarget).data("bs." + this.type, i)), e instanceof t.Event && (i.inState["focusout" == e.type ? "focus" : "hover"] = !1), !i.isInStateTrue()) return clearTimeout(i.timeout), i.hoverState = "out", i.options.delay && i.options.delay.hide ? void(i.timeout = setTimeout(function() {
			"out" == i.hoverState && i.hide()
		}, i.options.delay.hide)) : i.hide()
	}, e.prototype.show = function() {
		var i = t.Event("show.bs." + this.type);
		if (this.hasContent() && this.enabled) {
			this.$element.trigger(i);
			var s = t.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
			if (i.isDefaultPrevented() || !s) return;
			var n = this,
				a = this.tip(),
				o = this.getUID(this.type);
			this.setContent(), a.attr("id", o), this.$element.attr("aria-describedby", o), this.options.animation && a.addClass("fade");
			var r = "function" == typeof this.options.placement ? this.options.placement.call(this, a[0], this.$element[0]) : this.options.placement,
				l = /\s?auto?\s?/i,
				d = l.test(r);
			d && (r = r.replace(l, "") || "top"), a.detach().css({
				top: 0,
				left: 0,
				display: "block"
			}).addClass(r).data("bs." + this.type, this), this.options.container ? a.appendTo(this.options.container) : a.insertAfter(this.$element), this.$element.trigger("inserted.bs." + this.type);
			var c = this.getPosition(),
				h = a[0].offsetWidth,
				u = a[0].offsetHeight;
			if (d) {
				var p = r,
					f = this.getPosition(this.$viewport);
				r = "bottom" == r && c.bottom + u > f.bottom ? "top" : "top" == r && c.top - u < f.top ? "bottom" : "right" == r && c.right + h > f.width ? "left" : "left" == r && c.left - h < f.left ? "right" : r, a.removeClass(p).addClass(r)
			}
			var m = this.getCalculatedOffset(r, c, h, u);
			this.applyPlacement(m, r);
			var g = function() {
				var t = n.hoverState;
				n.$element.trigger("shown.bs." + n.type), n.hoverState = null, "out" == t && n.leave(n)
			};
			t.support.transition && this.$tip.hasClass("fade") ? a.one("bsTransitionEnd", g).emulateTransitionEnd(e.TRANSITION_DURATION) : g()
		}
	}, e.prototype.applyPlacement = function(e, i) {
		var s = this.tip(),
			n = s[0].offsetWidth,
			a = s[0].offsetHeight,
			o = parseInt(s.css("margin-top"), 10),
			r = parseInt(s.css("margin-left"), 10);
		isNaN(o) && (o = 0), isNaN(r) && (r = 0), e.top += o, e.left += r, t.offset.setOffset(s[0], t.extend({
			using: function(t) {
				s.css({
					top: Math.round(t.top),
					left: Math.round(t.left)
				})
			}
		}, e), 0), s.addClass("in");
		var l = s[0].offsetWidth,
			d = s[0].offsetHeight;
		"top" == i && d != a && (e.top = e.top + a - d);
		var c = this.getViewportAdjustedDelta(i, e, l, d);
		c.left ? e.left += c.left : e.top += c.top;
		var h = /top|bottom/.test(i),
			u = h ? 2 * c.left - n + l : 2 * c.top - a + d,
			p = h ? "offsetWidth" : "offsetHeight";
		s.offset(e), this.replaceArrow(u, s[0][p], h)
	}, e.prototype.replaceArrow = function(t, e, i) {
		this.arrow().css(i ? "left" : "top", 50 * (1 - t / e) + "%").css(i ? "top" : "left", "")
	}, e.prototype.setContent = function() {
		var t = this.tip(),
			e = this.getTitle();
		t.find(".tooltip-inner")[this.options.html ? "html" : "text"](e), t.removeClass("fade in top bottom left right")
	}, e.prototype.hide = function(i) {
		function s() {
			"in" != n.hoverState && a.detach(), n.$element && n.$element.removeAttr("aria-describedby").trigger("hidden.bs." + n.type), i && i()
		}
		var n = this,
			a = t(this.$tip),
			o = t.Event("hide.bs." + this.type);
		if (this.$element.trigger(o), !o.isDefaultPrevented()) return a.removeClass("in"), t.support.transition && a.hasClass("fade") ? a.one("bsTransitionEnd", s).emulateTransitionEnd(e.TRANSITION_DURATION) : s(), this.hoverState = null, this
	}, e.prototype.fixTitle = function() {
		var t = this.$element;
		(t.attr("title") || "string" != typeof t.attr("data-original-title")) && t.attr("data-original-title", t.attr("title") || "").attr("title", "")
	}, e.prototype.hasContent = function() {
		return this.getTitle()
	}, e.prototype.getPosition = function(e) {
		var i = (e = e || this.$element)[0],
			s = "BODY" == i.tagName,
			n = i.getBoundingClientRect();
		null == n.width && (n = t.extend({}, n, {
			width: n.right - n.left,
			height: n.bottom - n.top
		}));
		var a = window.SVGElement && i instanceof window.SVGElement,
			o = s ? {
				top: 0,
				left: 0
			} : a ? null : e.offset(),
			r = {
				scroll: s ? document.documentElement.scrollTop || document.body.scrollTop : e.scrollTop()
			},
			l = s ? {
				width: t(window).width(),
				height: t(window).height()
			} : null;
		return t.extend({}, n, r, l, o)
	}, e.prototype.getCalculatedOffset = function(t, e, i, s) {
		return "bottom" == t ? {
			top: e.top + e.height,
			left: e.left + e.width / 2 - i / 2
		} : "top" == t ? {
			top: e.top - s,
			left: e.left + e.width / 2 - i / 2
		} : "left" == t ? {
			top: e.top + e.height / 2 - s / 2,
			left: e.left - i
		} : {
			top: e.top + e.height / 2 - s / 2,
			left: e.left + e.width
		}
	}, e.prototype.getViewportAdjustedDelta = function(t, e, i, s) {
		var n = {
			top: 0,
			left: 0
		};
		if (!this.$viewport) return n;
		var a = this.options.viewport && this.options.viewport.padding || 0,
			o = this.getPosition(this.$viewport);
		if (/right|left/.test(t)) {
			var r = e.top - a - o.scroll,
				l = e.top + a - o.scroll + s;
			r < o.top ? n.top = o.top - r : l > o.top + o.height && (n.top = o.top + o.height - l)
		} else {
			var d = e.left - a,
				c = e.left + a + i;
			d < o.left ? n.left = o.left - d : c > o.right && (n.left = o.left + o.width - c)
		}
		return n
	}, e.prototype.getTitle = function() {
		var t = this.$element,
			e = this.options;
		return t.attr("data-original-title") || ("function" == typeof e.title ? e.title.call(t[0]) : e.title)
	}, e.prototype.getUID = function(t) {
		do {
			t += ~~(1e6 * Math.random())
		} while (document.getElementById(t));
		return t
	}, e.prototype.tip = function() {
		if (!this.$tip && (this.$tip = t(this.options.template), 1 != this.$tip.length)) throw new Error(this.type + " `template` option must consist of exactly 1 top-level element!");
		return this.$tip
	}, e.prototype.arrow = function() {
		return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow")
	}, e.prototype.enable = function() {
		this.enabled = !0
	}, e.prototype.disable = function() {
		this.enabled = !1
	}, e.prototype.toggleEnabled = function() {
		this.enabled = !this.enabled
	}, e.prototype.toggle = function(e) {
		var i = this;
		e && ((i = t(e.currentTarget).data("bs." + this.type)) || (i = new this.constructor(e.currentTarget, this.getDelegateOptions()), t(e.currentTarget).data("bs." + this.type, i))), e ? (i.inState.click = !i.inState.click, i.isInStateTrue() ? i.enter(i) : i.leave(i)) : i.tip().hasClass("in") ? i.leave(i) : i.enter(i)
	}, e.prototype.destroy = function() {
		var t = this;
		clearTimeout(this.timeout), this.hide(function() {
			t.$element.off("." + t.type).removeData("bs." + t.type), t.$tip && t.$tip.detach(), t.$tip = null, t.$arrow = null, t.$viewport = null, t.$element = null
		})
	};
	var i = t.fn.tooltip;
	t.fn.tooltip = function(i) {
		return this.each(function() {
			var s = t(this),
				n = s.data("bs.tooltip"),
				a = "object" == typeof i && i;
			!n && /destroy|hide/.test(i) || (n || s.data("bs.tooltip", n = new e(this, a)), "string" == typeof i && n[i]())
		})
	}, t.fn.tooltip.Constructor = e, t.fn.tooltip.noConflict = function() {
		return t.fn.tooltip = i, this
	}
}(jQuery),
function(t) {
	"use strict";
	var e = function(t, e) {
		this.init("popover", t, e)
	};
	if (!t.fn.tooltip) throw new Error("Popover requires tooltip.js");
	e.VERSION = "3.3.7", e.DEFAULTS = t.extend({}, t.fn.tooltip.Constructor.DEFAULTS, {
		placement: "right",
		trigger: "click",
		content: "",
		template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	}), e.prototype = t.extend({}, t.fn.tooltip.Constructor.prototype), e.prototype.constructor = e, e.prototype.getDefaults = function() {
		return e.DEFAULTS
	}, e.prototype.setContent = function() {
		var t = this.tip(),
			e = this.getTitle(),
			i = this.getContent();
		t.find(".popover-title")[this.options.html ? "html" : "text"](e), t.find(".popover-content").children().detach().end()[this.options.html ? "string" == typeof i ? "html" : "append" : "text"](i), t.removeClass("fade top bottom left right in"), t.find(".popover-title").html() || t.find(".popover-title").hide()
	}, e.prototype.hasContent = function() {
		return this.getTitle() || this.getContent()
	}, e.prototype.getContent = function() {
		var t = this.$element,
			e = this.options;
		return t.attr("data-content") || ("function" == typeof e.content ? e.content.call(t[0]) : e.content)
	}, e.prototype.arrow = function() {
		return this.$arrow = this.$arrow || this.tip().find(".arrow")
	};
	var i = t.fn.popover;
	t.fn.popover = function(i) {
		return this.each(function() {
			var s = t(this),
				n = s.data("bs.popover"),
				a = "object" == typeof i && i;
			!n && /destroy|hide/.test(i) || (n || s.data("bs.popover", n = new e(this, a)), "string" == typeof i && n[i]())
		})
	}, t.fn.popover.Constructor = e, t.fn.popover.noConflict = function() {
		return t.fn.popover = i, this
	}
}(jQuery),
function(t) {
	"use strict";

	function e(i, s) {
		this.$body = t(document.body), this.$scrollElement = t(t(i).is(document.body) ? window : i), this.options = t.extend({}, e.DEFAULTS, s), this.selector = (this.options.target || "") + " .nav li > a", this.offsets = [], this.targets = [], this.activeTarget = null, this.scrollHeight = 0, this.$scrollElement.on("scroll.bs.scrollspy", t.proxy(this.process, this)), this.refresh(), this.process()
	}

	function i(i) {
		return this.each(function() {
			var s = t(this),
				n = s.data("bs.scrollspy"),
				a = "object" == typeof i && i;
			n || s.data("bs.scrollspy", n = new e(this, a)), "string" == typeof i && n[i]()
		})
	}
	e.VERSION = "3.3.7", e.DEFAULTS = {
		offset: 10
	}, e.prototype.getScrollHeight = function() {
		return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	}, e.prototype.refresh = function() {
		var e = this,
			i = "offset",
			s = 0;
		this.offsets = [], this.targets = [], this.scrollHeight = this.getScrollHeight(), t.isWindow(this.$scrollElement[0]) || (i = "position", s = this.$scrollElement.scrollTop()), this.$body.find(this.selector).map(function() {
			var e = t(this),
				n = e.data("target") || e.attr("href"),
				a = /^#./.test(n) && t(n);
			return a && a.length && a.is(":visible") && [
				[a[i]().top + s, n]
			] || null
		}).sort(function(t, e) {
			return t[0] - e[0]
		}).each(function() {
			e.offsets.push(this[0]), e.targets.push(this[1])
		})
	}, e.prototype.process = function() {
		var t, e = this.$scrollElement.scrollTop() + this.options.offset,
			i = this.getScrollHeight(),
			s = this.options.offset + i - this.$scrollElement.height(),
			n = this.offsets,
			a = this.targets,
			o = this.activeTarget;
		if (this.scrollHeight != i && this.refresh(), e >= s) return o != (t = a[a.length - 1]) && this.activate(t);
		if (o && e < n[0]) return this.activeTarget = null, this.clear();
		for (t = n.length; t--;) o != a[t] && e >= n[t] && (void 0 === n[t + 1] || e < n[t + 1]) && this.activate(a[t])
	}, e.prototype.activate = function(e) {
		this.activeTarget = e, this.clear();
		var i = this.selector + '[data-target="' + e + '"],' + this.selector + '[href="' + e + '"]',
			s = t(i).parents("li").addClass("active");
		s.parent(".dropdown-menu").length && (s = s.closest("li.dropdown").addClass("active")), s.trigger("activate.bs.scrollspy")
	}, e.prototype.clear = function() {
		t(this.selector).parentsUntil(this.options.target, ".active").removeClass("active")
	};
	var s = t.fn.scrollspy;
	t.fn.scrollspy = i, t.fn.scrollspy.Constructor = e, t.fn.scrollspy.noConflict = function() {
		return t.fn.scrollspy = s, this
	}, t(window).on("load.bs.scrollspy.data-api", function() {
		t('[data-spy="scroll"]').each(function() {
			var e = t(this);
			i.call(e, e.data())
		})
	})
}(jQuery),
function(t) {
	"use strict";

	function e(e) {
		return this.each(function() {
			var s = t(this),
				n = s.data("bs.tab");
			n || s.data("bs.tab", n = new i(this)), "string" == typeof e && n[e]()
		})
	}
	var i = function(e) {
		this.element = t(e)
	};
	i.VERSION = "3.3.7", i.TRANSITION_DURATION = 150, i.prototype.show = function() {
		var e = this.element,
			i = e.closest("ul:not(.dropdown-menu)"),
			s = e.data("target");
		if (s || (s = (s = e.attr("href")) && s.replace(/.*(?=#[^\s]*$)/, "")), !e.parent("li").hasClass("active")) {
			var n = i.find(".active:last a"),
				a = t.Event("hide.bs.tab", {
					relatedTarget: e[0]
				}),
				o = t.Event("show.bs.tab", {
					relatedTarget: n[0]
				});
			if (n.trigger(a), e.trigger(o), !o.isDefaultPrevented() && !a.isDefaultPrevented()) {
				var r = t(s);
				this.activate(e.closest("li"), i), this.activate(r, r.parent(), function() {
					n.trigger({
						type: "hidden.bs.tab",
						relatedTarget: e[0]
					}), e.trigger({
						type: "shown.bs.tab",
						relatedTarget: n[0]
					})
				})
			}
		}
	}, i.prototype.activate = function(e, s, n) {
		function a() {
			o.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !1), e.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded", !0), r ? (e[0].offsetWidth, e.addClass("in")) : e.removeClass("fade"), e.parent(".dropdown-menu").length && e.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !0), n && n()
		}
		var o = s.find("> .active"),
			r = n && t.support.transition && (o.length && o.hasClass("fade") || !!s.find("> .fade").length);
		o.length && r ? o.one("bsTransitionEnd", a).emulateTransitionEnd(i.TRANSITION_DURATION) : a(), o.removeClass("in")
	};
	var s = t.fn.tab;
	t.fn.tab = e, t.fn.tab.Constructor = i, t.fn.tab.noConflict = function() {
		return t.fn.tab = s, this
	};
	var n = function(i) {
		i.preventDefault(), e.call(t(this), "show")
	};
	t(document).on("click.bs.tab.data-api", '[data-toggle="tab"]', n).on("click.bs.tab.data-api", '[data-toggle="pill"]', n)
}(jQuery),
function(t) {
	"use strict";

	function e(e) {
		return this.each(function() {
			var s = t(this),
				n = s.data("bs.affix"),
				a = "object" == typeof e && e;
			n || s.data("bs.affix", n = new i(this, a)), "string" == typeof e && n[e]()
		})
	}
	var i = function(e, s) {
		this.options = t.extend({}, i.DEFAULTS, s), this.$target = t(this.options.target).on("scroll.bs.affix.data-api", t.proxy(this.checkPosition, this)).on("click.bs.affix.data-api", t.proxy(this.checkPositionWithEventLoop, this)), this.$element = t(e), this.affixed = null, this.unpin = null, this.pinnedOffset = null, this.checkPosition()
	};
	i.VERSION = "3.3.7", i.RESET = "affix affix-top affix-bottom", i.DEFAULTS = {
		offset: 0,
		target: window
	}, i.prototype.getState = function(t, e, i, s) {
		var n = this.$target.scrollTop(),
			a = this.$element.offset(),
			o = this.$target.height();
		if (null != i && "top" == this.affixed) return n < i && "top";
		if ("bottom" == this.affixed) return null != i ? !(n + this.unpin <= a.top) && "bottom" : !(n + o <= t - s) && "bottom";
		var r = null == this.affixed,
			l = r ? n : a.top;
		return null != i && n <= i ? "top" : null != s && l + (r ? o : e) >= t - s && "bottom"
	}, i.prototype.getPinnedOffset = function() {
		if (this.pinnedOffset) return this.pinnedOffset;
		this.$element.removeClass(i.RESET).addClass("affix");
		var t = this.$target.scrollTop(),
			e = this.$element.offset();
		return this.pinnedOffset = e.top - t
	}, i.prototype.checkPositionWithEventLoop = function() {
		setTimeout(t.proxy(this.checkPosition, this), 1)
	}, i.prototype.checkPosition = function() {
		if (this.$element.is(":visible")) {
			var e = this.$element.height(),
				s = this.options.offset,
				n = s.top,
				a = s.bottom,
				o = Math.max(t(document).height(), t(document.body).height());
			"object" != typeof s && (a = n = s), "function" == typeof n && (n = s.top(this.$element)), "function" == typeof a && (a = s.bottom(this.$element));
			var r = this.getState(o, e, n, a);
			if (this.affixed != r) {
				null != this.unpin && this.$element.css("top", "");
				var l = "affix" + (r ? "-" + r : ""),
					d = t.Event(l + ".bs.affix");
				if (this.$element.trigger(d), d.isDefaultPrevented()) return;
				this.affixed = r, this.unpin = "bottom" == r ? this.getPinnedOffset() : null, this.$element.removeClass(i.RESET).addClass(l).trigger(l.replace("affix", "affixed") + ".bs.affix")
			}
			"bottom" == r && this.$element.offset({
				top: o - e - a
			})
		}
	};
	var s = t.fn.affix;
	t.fn.affix = e, t.fn.affix.Constructor = i, t.fn.affix.noConflict = function() {
		return t.fn.affix = s, this
	}, t(window).on("load", function() {
		t('[data-spy="affix"]').each(function() {
			var i = t(this),
				s = i.data();
			s.offset = s.offset || {}, null != s.offsetBottom && (s.offset.bottom = s.offsetBottom), null != s.offsetTop && (s.offset.top = s.offsetTop), e.call(i, s)
		})
	})
}(jQuery),
function(t, e) {
	var i = function(t, e) {
		"use strict";
		if (e.getElementsByClassName) {
			var i, s, n = e.documentElement,
				a = t.Date,
				o = t.HTMLPictureElement,
				r = "addEventListener",
				l = "getAttribute",
				d = t[r],
				c = t.setTimeout,
				h = t.requestAnimationFrame || c,
				u = t.requestIdleCallback,
				p = /^picture$/i,
				f = ["load", "error", "lazyincluded", "_lazyloaded"],
				m = {},
				g = Array.prototype.forEach,
				v = function(t, e) {
					return m[e] || (m[e] = new RegExp("(\\s|^)" + e + "(\\s|$)")), m[e].test(t[l]("class") || "") && m[e]
				},
				y = function(t, e) {
					v(t, e) || t.setAttribute("class", (t[l]("class") || "").trim() + " " + e)
				},
				b = function(t, e) {
					var i;
					(i = v(t, e)) && t.setAttribute("class", (t[l]("class") || "").replace(i, " "))
				},
				w = function(t, e, i) {
					var s = i ? r : "removeEventListener";
					i && w(t, e), f.forEach(function(i) {
						t[s](i, e)
					})
				},
				S = function(t, s, n, a, o) {
					var r = e.createEvent("Event");
					return n || (n = {}), n.instance = i, r.initEvent(s, !a, !o), r.detail = n, t.dispatchEvent(r), r
				},
				x = function(e, i) {
					var n;
					!o && (n = t.picturefill || s.pf) ? (i && i.src && !e[l]("srcset") && e.setAttribute("srcset", i.src), n({
						reevaluate: !0,
						elements: [e]
					})) : i && i.src && (e.src = i.src)
				},
				T = function(t, e) {
					return (getComputedStyle(t, null) || {})[e]
				},
				C = function(t, e, i) {
					for (i = i || t.offsetWidth; i < s.minSize && e && !t._lazysizesWidth;) i = e.offsetWidth, e = e.parentNode;
					return i
				},
				_ = function() {
					var t, i, s = [],
						n = [],
						a = s,
						o = function() {
							var e = a;
							for (a = s.length ? n : s, t = !0, i = !1; e.length;) e.shift()();
							t = !1
						},
						r = function(s, n) {
							t && !n ? s.apply(this, arguments) : (a.push(s), i || (i = !0, (e.hidden ? c : h)(o)))
						};
					return r._lsFlush = o, r
				}(),
				E = function(t, e) {
					return e ? function() {
						_(t)
					} : function() {
						var e = this,
							i = arguments;
						_(function() {
							t.apply(e, i)
						})
					}
				},
				P = function(t) {
					var e, i = 0,
						n = s.throttleDelay,
						o = s.ricTimeout,
						r = function() {
							e = !1, i = a.now(), t()
						},
						l = u && o > 49 ? function() {
							u(r, {
								timeout: o
							}), o !== s.ricTimeout && (o = s.ricTimeout)
						} : E(function() {
							c(r)
						}, !0);
					return function(t) {
						var s;
						(t = !0 === t) && (o = 33), e || (e = !0, 0 > (s = n - (a.now() - i)) && (s = 0), t || 9 > s ? l() : c(l, s))
					}
				},
				k = function(t) {
					var e, i, s = function() {
							e = null, t()
						},
						n = function() {
							var t = a.now() - i;
							99 > t ? c(n, 99 - t) : (u || s)(s)
						};
					return function() {
						i = a.now(), e || (e = c(n, 99))
					}
				};
			! function() {
				var e, i = {
					lazyClass: "lazyload",
					loadedClass: "lazyloaded",
					loadingClass: "lazyloading",
					preloadClass: "lazypreload",
					errorClass: "lazyerror",
					autosizesClass: "lazyautosizes",
					srcAttr: "data-src",
					srcsetAttr: "data-srcset",
					sizesAttr: "data-sizes",
					minSize: 40,
					customMedia: {},
					init: !0,
					expFactor: 1.5,
					hFac: .8,
					loadMode: 2,
					loadHidden: !0,
					ricTimeout: 0,
					throttleDelay: 125
				};
				for (e in s = t.lazySizesConfig || t.lazysizesConfig || {}, i) e in s || (s[e] = i[e]);
				t.lazySizesConfig = s, c(function() {
					s.init && D()
				})
			}();
			var $ = function() {
					var o, h, u, f, m, C, $, D, O, z, A, I, L, N, Y = /^img$/i,
						R = /^iframe$/i,
						j = "onscroll" in t && !/(gle|ing)bot/.test(navigator.userAgent),
						H = 0,
						B = 0,
						F = -1,
						W = function(t) {
							B--, t && t.target && w(t.target, W), (!t || 0 > B || !t.target) && (B = 0)
						},
						V = function(t, i) {
							var s, a = t,
								o = "hidden" == T(e.body, "visibility") || "hidden" != T(t.parentNode, "visibility") && "hidden" != T(t, "visibility");
							for (D -= i, A += i, O -= i, z += i; o && (a = a.offsetParent) && a != e.body && a != n;)(o = (T(a, "opacity") || 1) > 0) && "visible" != T(a, "overflow") && (s = a.getBoundingClientRect(), o = z > s.left && O < s.right && A > s.top - 1 && D < s.bottom + 1);
							return o
						},
						q = function() {
							var t, a, r, d, c, u, p, m, g, v = i.elements;
							if ((f = s.loadMode) && 8 > B && (t = v.length)) {
								a = 0, F++, null == L && ("expand" in s || (s.expand = n.clientHeight > 500 && n.clientWidth > 500 ? 500 : 370), I = s.expand, L = I * s.expFactor), L > H && 1 > B && F > 2 && f > 2 && !e.hidden ? (H = L, F = 0) : H = f > 1 && F > 1 && 6 > B ? I : 0;
								for (; t > a; a++)
									if (v[a] && !v[a]._lazyRace)
										if (j)
											if ((m = v[a][l]("data-expand")) && (u = 1 * m) || (u = H), g !== u && (C = innerWidth + u * N, $ = innerHeight + u, p = -1 * u, g = u), r = v[a].getBoundingClientRect(), (A = r.bottom) >= p && (D = r.top) <= $ && (z = r.right) >= p * N && (O = r.left) <= C && (A || z || O || D) && (s.loadHidden || "hidden" != T(v[a], "visibility")) && (h && 3 > B && !m && (3 > f || 4 > F) || V(v[a], u))) {
												if (J(v[a]), c = !0, B > 9) break
											} else !c && h && !d && 4 > B && 4 > F && f > 2 && (o[0] || s.preloadAfterLoad) && (o[0] || !m && (A || z || O || D || "auto" != v[a][l](s.sizesAttr))) && (d = o[0] || v[a]);
								else J(v[a]);
								d && !c && J(d)
							}
						},
						U = P(q),
						G = function(t) {
							y(t.target, s.loadedClass), b(t.target, s.loadingClass), w(t.target, Q), S(t.target, "lazyloaded")
						},
						X = E(G),
						Q = function(t) {
							X({
								target: t.target
							})
						},
						Z = function(t) {
							var e, i = t[l](s.srcsetAttr);
							(e = s.customMedia[t[l]("data-media") || t[l]("media")]) && t.setAttribute("media", e), i && t.setAttribute("srcset", i)
						},
						K = E(function(t, e, i, n, a) {
							var o, r, d, h, f, m;
							(f = S(t, "lazybeforeunveil", e)).defaultPrevented || (n && (i ? y(t, s.autosizesClass) : t.setAttribute("sizes", n)), r = t[l](s.srcsetAttr), o = t[l](s.srcAttr), a && (d = t.parentNode, h = d && p.test(d.nodeName || "")), m = e.firesLoad || "src" in t && (r || o || h), f = {
								target: t
							}, m && (w(t, W, !0), clearTimeout(u), u = c(W, 2500), y(t, s.loadingClass), w(t, Q, !0)), h && g.call(d.getElementsByTagName("source"), Z), r ? t.setAttribute("srcset", r) : o && !h && (R.test(t.nodeName) ? function(t, e) {
								try {
									t.contentWindow.location.replace(e)
								} catch (i) {
									t.src = e
								}
							}(t, o) : t.src = o), a && (r || h) && x(t, {
								src: o
							})), t._lazyRace && delete t._lazyRace, b(t, s.lazyClass), _(function() {
								(!m || t.complete && t.naturalWidth > 1) && (m ? W(f) : B--, G(f))
							}, !0)
						}),
						J = function(t) {
							var e, i = Y.test(t.nodeName),
								n = i && (t[l](s.sizesAttr) || t[l]("sizes")),
								a = "auto" == n;
							(!a && h || !i || !t[l]("src") && !t.srcset || t.complete || v(t, s.errorClass) || !v(t, s.lazyClass)) && (e = S(t, "lazyunveilread").detail, a && M.updateElem(t, !0, t.offsetWidth), t._lazyRace = !0, B++, K(t, e, a, n, i))
						},
						tt = function() {
							if (!h) {
								if (a.now() - m < 999) return void c(tt, 999);
								var t = k(function() {
									s.loadMode = 3, U()
								});
								h = !0, s.loadMode = 3, U(), d("scroll", function() {
									3 == s.loadMode && (s.loadMode = 2), t()
								}, !0)
							}
						};
					return {
						_: function() {
							m = a.now(), i.elements = e.getElementsByClassName(s.lazyClass), o = e.getElementsByClassName(s.lazyClass + " " + s.preloadClass), N = s.hFac, d("scroll", U, !0), d("resize", U, !0), t.MutationObserver ? new MutationObserver(U).observe(n, {
								childList: !0,
								subtree: !0,
								attributes: !0
							}) : (n[r]("DOMNodeInserted", U, !0), n[r]("DOMAttrModified", U, !0), setInterval(U, 999)), d("hashchange", U, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function(t) {
								e[r](t, U, !0)
							}), /d$|^c/.test(e.readyState) ? tt() : (d("load", tt), e[r]("DOMContentLoaded", U), c(tt, 2e4)), i.elements.length ? (q(), _._lsFlush()) : U()
						},
						checkElems: U,
						unveil: J
					}
				}(),
				M = function() {
					var t, i = E(function(t, e, i, s) {
							var n, a, o;
							if (t._lazysizesWidth = s, s += "px", t.setAttribute("sizes", s), p.test(e.nodeName || ""))
								for (n = e.getElementsByTagName("source"), a = 0, o = n.length; o > a; a++) n[a].setAttribute("sizes", s);
							i.detail.dataAttr || x(t, i.detail)
						}),
						n = function(t, e, s) {
							var n, a = t.parentNode;
							a && (s = C(t, a, s), (n = S(t, "lazybeforesizes", {
								width: s,
								dataAttr: !!e
							})).defaultPrevented || (s = n.detail.width) && s !== t._lazysizesWidth && i(t, a, n, s))
						},
						a = k(function() {
							var e, i = t.length;
							if (i)
								for (e = 0; i > e; e++) n(t[e])
						});
					return {
						_: function() {
							t = e.getElementsByClassName(s.autosizesClass), d("resize", a)
						},
						checkElems: a,
						updateElem: n
					}
				}(),
				D = function() {
					D.i || (D.i = !0, M._(), $._())
				};
			return i = {
				cfg: s,
				autoSizer: M,
				loader: $,
				init: D,
				uP: x,
				aC: y,
				rC: b,
				hC: v,
				fire: S,
				gW: C,
				rAF: _
			}
		}
	}(t, t.document);
	t.lazySizes = i, "object" == typeof module && module.exports && (module.exports = i)
}(window),
function(t, e) {
	var i = function() {
		e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0)
	};
	e = e.bind(null, t, t.document), "object" == typeof module && module.exports ? e(require("lazysizes")) : t.lazySizes ? i() : t.addEventListener("lazyunveilread", i, !0)
}(window, function(t, e, i) {
	"use strict";
	var s, n = e.createElement("img");
	!("srcset" in n) || "sizes" in n || t.HTMLPictureElement || (s = /^picture$/i, e.addEventListener("lazybeforeunveil", function(t) {
		var n, a, o, r, l, d, c;
		t.detail.instance == i && (!t.defaultPrevented && !lazySizesConfig.noIOSFix && (n = t.target) && (o = n.getAttribute(lazySizesConfig.srcsetAttr)) && (a = n.parentNode) && ((l = s.test(a.nodeName || "")) || (r = n.getAttribute("sizes") || n.getAttribute(lazySizesConfig.sizesAttr))) && (d = l ? a : e.createElement("picture"), n._lazyImgSrc || Object.defineProperty(n, "_lazyImgSrc", {
			value: e.createElement("source"),
			writable: !0
		}), c = n._lazyImgSrc, r && c.setAttribute("sizes", r), c.setAttribute(lazySizesConfig.srcsetAttr, o), n.setAttribute("data-pfsrcset", o), n.removeAttribute(lazySizesConfig.srcsetAttr), l || (a.insertBefore(d, n), d.appendChild(n)), d.insertBefore(c, n)))
	}))
}),
function(t, e) {
	var i = function() {
		e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0)
	};
	e = e.bind(null, t, t.document), "object" == typeof module && module.exports ? e(require("lazysizes")) : t.lazySizes ? i() : t.addEventListener("lazyunveilread", i, !0)
}(window, function(t, e, i) {
	"use strict";

	function s(e, i) {
		var s, n, a, o, r = t.getComputedStyle(e);
		for (s in n = e.parentNode, o = {
				isPicture: !(!n || !h.test(n.nodeName || ""))
			}, a = function(t, i) {
				var s = e.getAttribute("data-" + t);
				if (!s) {
					var n = r.getPropertyValue("--ls-" + t);
					n && (s = n.trim())
				}
				if (s) {
					if ("true" == s) s = !0;
					else if ("false" == s) s = !1;
					else if (c.test(s)) s = parseFloat(s);
					else if ("function" == typeof l[t]) s = l[t](e, s);
					else if (m.test(s)) try {
						s = JSON.parse(s)
					} catch (t) {}
					o[t] = s
				} else t in l && "function" != typeof l[t] ? o[t] = l[t] : i && "function" == typeof l[t] && (o[t] = l[t](e, s))
			}, l) a(s);
		return i.replace(f, function(t, e) {
			e in o || a(e, !0)
		}), o
	}

	function n(t, i, s) {
		var n = 0,
			a = 0,
			o = s;
		if (t) {
			if ("container" === i.ratio) {
				for (n = o.scrollWidth, a = o.scrollHeight; !(n && a || o === e);) n = (o = o.parentNode).scrollWidth, a = o.scrollHeight;
				n && a && (i.ratio = a / n)
			}(t = function(t, e) {
				var i = [];
				return i.srcset = [], e.absUrl && (v.setAttribute("href", t), t = v.href), t = ((e.prefix || "") + t + (e.postfix || "")).replace(f, function(t, i) {
					return d[typeof e[i]] ? e[i] : t
				}), e.widths.forEach(function(s) {
					var n = e.widthmap[s] || s,
						a = {
							u: t.replace(u, n).replace(p, e.ratio ? Math.round(s * e.ratio) : ""),
							w: s
						};
					i.push(a), i.srcset.push(a.c = a.u + " " + s + "w")
				}), i
			}(t, i)).isPicture = i.isPicture, b && "IMG" == s.nodeName.toUpperCase() ? s.removeAttribute(r.srcsetAttr) : s.setAttribute(r.srcsetAttr, t.srcset.join(", ")), Object.defineProperty(s, "_lazyrias", {
				value: t,
				writable: !0
			})
		}
	}

	function a(t, e) {
		var n = s(t, e);
		return l.modifyOptions.call(t, {
			target: t,
			details: n,
			detail: n
		}), i.fire(t, "lazyriasmodifyoptions", n), n
	}

	function o(t) {
		return t.getAttribute(t.getAttribute("data-srcattr") || l.srcAttr) || t.getAttribute(r.srcsetAttr) || t.getAttribute(r.srcAttr) || t.getAttribute("data-pfsrcset") || ""
	}
	var r, l, d = {
			string: 1,
			number: 1
		},
		c = /^\-*\+*\d+\.*\d*$/,
		h = /^picture$/i,
		u = /\s*\{\s*width\s*\}\s*/i,
		p = /\s*\{\s*height\s*\}\s*/i,
		f = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
		m = /^\[.*\]|\{.*\}$/,
		g = /^(?:auto|\d+(px)?)$/,
		v = e.createElement("a"),
		y = e.createElement("img"),
		b = "srcset" in y && !("sizes" in y),
		w = !!t.HTMLPictureElement && !b;
	! function() {
		var e, s = {
			prefix: "",
			postfix: "",
			srcAttr: "data-src",
			absUrl: !1,
			modifyOptions: function() {},
			widthmap: {},
			ratio: !1
		};
		for (e in (r = i && i.cfg || t.lazySizesConfig) || (r = {}, t.lazySizesConfig = r), r.supportsType || (r.supportsType = function(t) {
				return !t
			}), r.rias || (r.rias = {}), "widths" in (l = r.rias) || (l.widths = [], function(t) {
				for (var e, i = 0; !e || 3e3 > e;)(i += 5) > 30 && (i += 1), e = 36 * i, t.push(e)
			}(l.widths)), s) e in l || (l[e] = s[e])
	}(), addEventListener("lazybeforesizes", function(t) {
		var e, s, d, c, h, p, f, m, v, y, b, x, T;
		if (t.detail.instance == i && (e = t.target, t.detail.dataAttr && !t.defaultPrevented && !l.disabled && (v = e.getAttribute(r.sizesAttr) || e.getAttribute("sizes")) && g.test(v))) {
			if (d = a(e, s = o(e)), b = u.test(d.prefix) || u.test(d.postfix), d.isPicture && (c = e.parentNode))
				for (p = 0, f = (h = c.getElementsByTagName("source")).length; f > p; p++)(b || u.test(m = o(h[p]))) && (n(m, d, h[p]), x = !0);
			b || u.test(s) ? (n(s, d, e), x = !0) : x && ((T = []).srcset = [], T.isPicture = !0, Object.defineProperty(e, "_lazyrias", {
				value: T,
				writable: !0
			})), x && (w ? e.removeAttribute(r.srcAttr) : "auto" != v && (y = {
				width: parseInt(v, 10)
			}, S({
				target: e,
				detail: y
			})))
		}
	}, !0);
	var S = function() {
		var s = function(t, e) {
				return t.w - e.w
			},
			n = function(t, e) {
				var s;
				return !t._lazyrias && i.pWS && (s = i.pWS(t.getAttribute(r.srcsetAttr || ""))).length && (Object.defineProperty(t, "_lazyrias", {
					value: s,
					writable: !0
				}), e && t.parentNode && (s.isPicture = "PICTURE" == t.parentNode.nodeName.toUpperCase())), t._lazyrias
			},
			a = function(e) {
				var s = t.devicePixelRatio || 1,
					n = i.getX && i.getX(e);
				return Math.min(n || s, 2.4, s)
			},
			o = function(e, i) {
				var o, r, l, d, c, h;
				if ((c = e._lazyrias).isPicture && t.matchMedia)
					for (r = 0, l = (o = e.parentNode.getElementsByTagName("source")).length; l > r; r++)
						if (n(o[r]) && !o[r].getAttribute("type") && (!(d = o[r].getAttribute("media")) || (matchMedia(d) || {}).matches)) {
							c = o[r]._lazyrias;
							break
						} return (!c.w || c.w < i) && (c.w = i, c.d = a(e), h = function(t) {
					for (var e, i, s = t.length, n = t[s - 1], a = 0; s > a; a++)
						if ((n = t[a]).d = n.w / t.w, n.d >= t.d) {
							!n.cached && (e = t[a - 1]) && e.d > t.d - .13 * Math.pow(t.d, 2.2) && (i = Math.pow(e.d - .6, 1.6), e.cached && (e.d += .15 * i), e.d + (n.d - t.d) * i > t.d && (n = e));
							break
						} return n
				}(c.sort(s))), h
			},
			l = function(s) {
				if (s.detail.instance == i) {
					var a, d = s.target;
					return !b && (t.respimage || t.picturefill || lazySizesConfig.pf) ? void e.removeEventListener("lazybeforesizes", l) : void(("_lazyrias" in d || s.detail.dataAttr && n(d, !0)) && (a = o(d, s.detail.width), a && a.u && d._lazyrias.cur != a.u && (d._lazyrias.cur = a.u, a.cached = !0, i.rAF(function() {
						d.setAttribute(r.srcAttr, a.u), d.setAttribute("src", a.u)
					}))))
				}
			};
		return w ? l = function() {} : addEventListener("lazybeforesizes", l), l
	}()
}),
function(t, e) {
	var i = function() {
		e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0)
	};
	e = e.bind(null, t, t.document), "object" == typeof module && module.exports ? e(require("lazysizes")) : t.lazySizes ? i() : t.addEventListener("lazyunveilread", i, !0)
}(window, function(t, e, i) {
	"use strict";
	if (t.addEventListener) {
		var s = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
			n = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
			a = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
			o = /^picture$/i,
			r = {
				getParent: function(e, i) {
					var s = e,
						n = e.parentNode;
					return i && "prev" != i || !n || !o.test(n.nodeName || "") || (n = n.parentNode), "self" != i && (s = "prev" == i ? e.previousElementSibling : i && (n.closest || t.jQuery) && (n.closest ? n.closest(i) : jQuery(n).closest(i)[0]) || n), s
				},
				getFit: function(t) {
					var e, i, s = function(t) {
							return getComputedStyle(t, null) || {}
						}(t),
						o = s.content || s.fontFamily,
						l = {
							fit: t._lazysizesParentFit || t.getAttribute("data-parent-fit")
						};
					return !l.fit && o && (e = o.match(n)) && (l.fit = e[1]), l.fit ? (!(i = t._lazysizesParentContainer || t.getAttribute("data-parent-container")) && o && (e = o.match(a)) && (i = e[1]), l.parent = r.getParent(t, i)) : l.fit = s.objectFit, l
				},
				getImageRatio: function(e) {
					var i, n, a, r, l, d = e.parentNode,
						c = d && o.test(d.nodeName || "") ? d.querySelectorAll("source, img") : [e];
					for (i = 0; i < c.length; i++)
						if (n = (e = c[i]).getAttribute(lazySizesConfig.srcsetAttr) || e.getAttribute("srcset") || e.getAttribute("data-pfsrcset") || e.getAttribute("data-risrcset") || "", a = e._lsMedia || e.getAttribute("media"), a = lazySizesConfig.customMedia[e.getAttribute("data-media") || a] || a, n && (!a || (t.matchMedia && matchMedia(a) || {}).matches)) {
							!(r = parseFloat(e.getAttribute("data-aspectratio"))) && (l = n.match(s)) && (r = "w" == l[2] ? l[1] / l[3] : l[3] / l[1]);
							break
						} return r
				},
				calculateSize: function(t, e) {
					var i, s, n, a, o = this.getFit(t),
						r = o.fit,
						l = o.parent;
					return "width" == r || ("contain" == r || "cover" == r) && (n = this.getImageRatio(t)) ? (l ? e = l.clientWidth : l = t, a = e, "width" == r ? a = e : (s = l.clientHeight) > 40 && (i = e / s) && ("cover" == r && n > i || "contain" == r && i > n) && (a = e * (n / i)), a) : e
				}
			};
		i.parentFit = r, e.addEventListener("lazybeforesizes", function(t) {
			if (!t.defaultPrevented && t.detail.instance == i) {
				var e = t.target;
				t.detail.width = r.calculateSize(e, t.detail.width)
			}
		})
	}
}),
function(t, e) {
	var i = function() {
		e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0)
	};
	e = e.bind(null, t, t.document), "object" == typeof module && module.exports ? e(require("lazysizes"), require("../fix-ios-sizes/fix-ios-sizes")) : t.lazySizes ? i() : t.addEventListener("lazyunveilread", i, !0)
}(window, function(t, e, i) {
	"use strict";
	var s, n = i && i.cfg || t.lazySizesConfig,
		a = e.createElement("img"),
		o = "sizes" in a && "srcset" in a,
		r = /\s+\d+h/g,
		l = function() {
			var t = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
				i = Array.prototype.forEach;
			return function() {
				var s = e.createElement("img"),
					n = function(e) {
						var i, s, n = e.getAttribute(lazySizesConfig.srcsetAttr);
						n && ((s = n.match(t)) && ((i = "w" == s[2] ? s[1] / s[3] : s[3] / s[1]) && e.setAttribute("data-aspectratio", i)), e.setAttribute(lazySizesConfig.srcsetAttr, n.replace(r, "")))
					},
					a = function(t) {
						var e = t.target.parentNode;
						e && "PICTURE" == e.nodeName && i.call(e.getElementsByTagName("source"), n), n(t.target)
					},
					o = function() {
						s.currentSrc && e.removeEventListener("lazybeforeunveil", a)
					};
				e.addEventListener("lazybeforeunveil", a), s.onload = o, s.onerror = o, s.srcset = "data:,a 1w 1h", s.complete && o()
			}
		}();
	if (n || (n = {}, t.lazySizesConfig = n), n.supportsType || (n.supportsType = function(t) {
			return !t
		}), !t.picturefill && !n.pf) {
		if (t.HTMLPictureElement && o) return e.msElementsFromPoint && l(navigator.userAgent.match(/Edge\/(\d+)/)), void(n.pf = function() {});
		n.pf = function(e) {
			var i, n;
			if (!t.picturefill)
				for (i = 0, n = e.elements.length; n > i; i++) s(e.elements[i])
		}, s = function() {
			var a = function(t, e) {
					return t.w - e.w
				},
				l = /^\s*\d+\.*\d*px\s*$/,
				d = function() {
					var t, e = /(([^,\s].[^\s]+)\s+(\d+)w)/g,
						i = /\s/,
						s = function(e, i, s, n) {
							t.push({
								c: i,
								u: s,
								w: 1 * n
							})
						};
					return function(n) {
						return t = [], (n = n.trim()).replace(r, "").replace(e, s), t.length || !n || i.test(n) || t.push({
							c: n,
							u: n,
							w: 99
						}), t
					}
				}(),
				c = function() {
					var t, i, n;
					c.init || (c.init = !0, addEventListener("resize", (i = e.getElementsByClassName("lazymatchmedia"), n = function() {
						var t, e;
						for (t = 0, e = i.length; e > t; t++) s(i[t])
					}, function() {
						clearTimeout(t), t = setTimeout(n, 66)
					})))
				},
				h = function(e, s) {
					var a, o = e.getAttribute("srcset") || e.getAttribute(n.srcsetAttr);
					!o && s && (o = e._lazypolyfill ? e._lazypolyfill._set : e.getAttribute(n.srcAttr) || e.getAttribute("src")), e._lazypolyfill && e._lazypolyfill._set == o || (a = d(o || ""), s && e.parentNode && (a.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase(), a.isPicture && t.matchMedia && (i.aC(e, "lazymatchmedia"), c())), a._set = o, Object.defineProperty(e, "_lazypolyfill", {
						value: a,
						writable: !0
					}))
				},
				u = function(e) {
					var s = t.devicePixelRatio || 1,
						n = i.getX && i.getX(e);
					return Math.min(n || s, 2.5, s)
				},
				p = function(e) {
					return t.matchMedia ? (p = function(t) {
						return !t || (matchMedia(t) || {}).matches
					})(e) : !e
				},
				f = function(t) {
					var e, s, o, r, d, c, f;
					if (h(r = t, !0), (d = r._lazypolyfill).isPicture)
						for (s = 0, o = (e = t.parentNode.getElementsByTagName("source")).length; o > s; s++)
							if (n.supportsType(e[s].getAttribute("type"), t) && p(e[s].getAttribute("media"))) {
								r = e[s], h(r), d = r._lazypolyfill;
								break
							} return d.length > 1 ? (f = r.getAttribute("sizes") || "", f = l.test(f) && parseInt(f, 10) || i.gW(t, t.parentNode), d.d = u(t), !d.src || !d.w || d.w < f ? (d.w = f, c = function(t) {
						for (var e, i, s = t.length, n = t[s - 1], a = 0; s > a; a++)
							if ((n = t[a]).d = n.w / t.w, n.d >= t.d) {
								!n.cached && (e = t[a - 1]) && e.d > t.d - .13 * Math.pow(t.d, 2.2) && (i = Math.pow(e.d - .6, 1.6), e.cached && (e.d += .15 * i), e.d + (n.d - t.d) * i > t.d && (n = e));
								break
							} return n
					}(d.sort(a)), d.src = c) : c = d.src) : c = d[0], c
				},
				m = function(t) {
					if (!o || !t.parentNode || "PICTURE" == t.parentNode.nodeName.toUpperCase()) {
						var e = f(t);
						e && e.u && t._lazypolyfill.cur != e.u && (t._lazypolyfill.cur = e.u, e.cached = !0, t.setAttribute(n.srcAttr, e.u), t.setAttribute("src", e.u))
					}
				};
			return m.parse = d, m
		}(), n.loadedClass && n.loadingClass && function() {
			var t = [];
			['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function(e) {
				t.push(e + n.loadedClass), t.push(e + n.loadingClass)
			}), n.pf({
				elements: e.querySelectorAll(t.join(", "))
			})
		}()
	}
}),
function(t, e) {
	var i = function() {
		e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0)
	};
	e = e.bind(null, t, t.document), "object" == typeof module && module.exports ? e(require("lazysizes")) : t.lazySizes ? i() : t.addEventListener("lazyunveilread", i, !0)
}(window, function(t, e, i) {
	"use strict";
	if (t.addEventListener) {
		var s = /\s+/g,
			n = /\s*\|\s+|\s+\|\s*/g,
			a = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/,
			o = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/,
			r = /\(|\)|'/,
			l = {
				contain: 1,
				cover: 1
			},
			d = function(t, e) {
				if (e) {
					var i = e.match(o);
					i && i[1] ? t.setAttribute("type", i[1]) : t.setAttribute("media", lazySizesConfig.customMedia[e] || e)
				}
			},
			c = function(t, i, o) {
				var r = e.createElement("picture"),
					l = i.getAttribute(lazySizesConfig.sizesAttr),
					c = i.getAttribute("data-ratio"),
					h = i.getAttribute("data-optimumx");
				i._lazybgset && i._lazybgset.parentNode == i && i.removeChild(i._lazybgset), Object.defineProperty(o, "_lazybgset", {
					value: i,
					writable: !0
				}), Object.defineProperty(i, "_lazybgset", {
					value: r,
					writable: !0
				}), t = t.replace(s, " ").split(n), r.style.display = "none", o.className = lazySizesConfig.lazyClass, 1 != t.length || l || (l = "auto"), t.forEach(function(t) {
					var i, s = e.createElement("source");
					l && "auto" != l && s.setAttribute("sizes", l), (i = t.match(a)) ? (s.setAttribute(lazySizesConfig.srcsetAttr, i[1]), d(s, i[2]), d(s, i[3])) : s.setAttribute(lazySizesConfig.srcsetAttr, t), r.appendChild(s)
				}), l && (o.setAttribute(lazySizesConfig.sizesAttr, l), i.removeAttribute(lazySizesConfig.sizesAttr), i.removeAttribute("sizes")), h && o.setAttribute("data-optimumx", h), c && o.setAttribute("data-ratio", c), r.appendChild(o), i.appendChild(r)
			},
			h = function(t) {
				if (t.target._lazybgset) {
					var e = t.target,
						s = e._lazybgset,
						n = e.currentSrc || e.src;
					if (n) {
						var a = i.fire(s, "bgsetproxy", {
							src: n,
							useSrc: r.test(n) ? JSON.stringify(n) : n
						});
						a.defaultPrevented || (s.style.backgroundImage = "url(" + a.detail.useSrc + ")")
					}
					e._lazybgsetLoading && (i.fire(s, "_lazyloaded", {}, !1, !0), delete e._lazybgsetLoading)
				}
			};
		addEventListener("lazybeforeunveil", function(t) {
			var s, n, a;
			!t.defaultPrevented && (s = t.target.getAttribute("data-bgset")) && (a = t.target, (n = e.createElement("img")).alt = "", n._lazybgsetLoading = !0, t.detail.firesLoad = !0, c(s, a, n), setTimeout(function() {
				i.loader.unveil(n), i.rAF(function() {
					i.fire(n, "_lazyloaded", {}, !0, !0), n.complete && h({
						target: n
					})
				})
			}))
		}), e.addEventListener("load", h, !0), t.addEventListener("lazybeforesizes", function(t) {
			if (t.detail.instance == i && t.target._lazybgset && t.detail.dataAttr) {
				var e = function(t) {
					var e;
					return e = (getComputedStyle(t) || {
						getPropertyValue: function() {}
					}).getPropertyValue("background-size"), !l[e] && l[t.style.backgroundSize] && (e = t.style.backgroundSize), e
				}(t.target._lazybgset);
				l[e] && (t.target._lazysizesParentFit = e, i.rAF(function() {
					t.target.setAttribute("data-parent-fit", e), t.target._lazysizesParentFit && delete t.target._lazysizesParentFit
				}))
			}
		}, !0), e.documentElement.addEventListener("lazybeforesizes", function(t) {
			!t.defaultPrevented && t.target._lazybgset && t.detail.instance == i && (t.detail.width = function(t) {
				var e = i.gW(t, t.parentNode);
				return (!t._lazysizesWidth || e > t._lazysizesWidth) && (t._lazysizesWidth = e), t._lazysizesWidth
			}(t.target._lazybgset))
		})
	}
}),
function(t) {
	t.fn.extend({
		easyResponsiveTabs: function(e) {
			var i = e = t.extend({
					type: "default",
					width: "auto",
					fit: !0,
					closed: !1,
					tabidentify: "",
					activetab_bg: "white",
					inactive_bg: "#F5F5F5",
					active_border_color: "#c1c1c1",
					active_content_border_color: "#c1c1c1",
					activate: function() {}
				}, e),
				s = i.type,
				n = i.fit,
				a = i.width,
				o = "vertical",
				r = "accordion",
				l = window.location.hash,
				d = !(!window.history || !history.replaceState);
			t(".template-featured-product").length && (d = !1), t(this).bind("tabactivate", function(t, i) {
				"function" == typeof e.activate && e.activate.call(i, t)
			}), this.each(function() {
				var i, c = t(this),
					h = c.find("ul.resp-tabs-list." + e.tabidentify),
					u = c.attr("id");
				c.find("ul.resp-tabs-list." + e.tabidentify + " li").addClass("resp-tab-item").addClass(e.tabidentify), c.css({
						display: "block",
						width: a
					}), "vertical" == e.type && h.css("margin-top", "3px"), c.find(".resp-tabs-container." + e.tabidentify).css("border-color", e.active_content_border_color), c.find(".resp-tabs-container." + e.tabidentify + " > div").addClass("resp-tab-content").addClass(e.tabidentify),
					function() {
						s == o && c.addClass("resp-vtabs").addClass(e.tabidentify);
						1 == n && c.css({
							width: "100%",
							margin: "0px"
						});
						s == r && (c.addClass("resp-easy-accordion").addClass(e.tabidentify), c.find(".resp-tabs-list").css("display", "none"))
					}(), c.find(".resp-tab-content." + e.tabidentify).before("<h2 class='resp-accordion " + e.tabidentify + "' role='tab'><span class='resp-arrow'></span></h2>"), c.find(".resp-tab-content." + e.tabidentify).prev("h2").css({
						"background-color": e.inactive_bg,
						"border-color": e.active_border_color
					});
				var p = 0;
				c.find(".resp-accordion").each(function() {
					i = t(this);
					var s = c.find(".resp-tab-item:eq(" + p + ")"),
						n = c.find(".resp-accordion:eq(" + p + ")");
					n.append(s.html()), n.data(s.data()), i.attr("aria-controls", e.tabidentify + "_tab_item-" + p), p++
				});
				var f = 0;
				c.find(".resp-tab-item").each(function() {
					$tabItem = t(this), $tabItem.attr("aria-controls", e.tabidentify + "_tab_item-" + f), $tabItem.attr("role", "tab"), $tabItem.css({
						"background-color": e.inactive_bg,
						"border-color": "none"
					});
					var i = 0;
					c.find(".resp-tab-content." + e.tabidentify).each(function() {
						t(this).attr("aria-labelledby", e.tabidentify + "_tab_item-" + i).css({
							"border-color": e.active_border_color
						}), i++
					}), f++
				});
				var m = 0;
				if ("" != l) {
					var g = l.match(new RegExp(u + "([0-9]+)"));
					null !== g && 2 === g.length && (m = parseInt(g[1], 10) - 1) > f && (m = 0)
				}
				t(c.find(".resp-tab-item." + e.tabidentify)[m]).addClass("resp-tab-active").css({
					"background-color": e.activetab_bg,
					"border-color": e.active_border_color
				}), !0 === e.closed || "accordion" === e.closed && !h.is(":visible") || "tabs" === e.closed && h.is(":visible") || (t(c.find(".resp-accordion." + e.tabidentify)[m]).addClass("resp-tab-active").css({
					"background-color": e.activetab_bg + " !important",
					"border-color": e.active_border_color,
					background: "none"
				}), t(c.find(".resp-tab-content." + e.tabidentify)[m]).addClass("resp-tab-content-active").addClass(e.tabidentify).attr("style", "display:block")), c.find("[role=tab]").each(function() {
					t(this).click(function() {
						var i = t(this),
							s = i.attr("aria-controls");
						if (i.hasClass("resp-accordion") && i.hasClass("resp-tab-active")) return c.find(".resp-tab-content-active." + e.tabidentify).slideUp("", function() {
							t(this).addClass("resp-accordion-closed")
						}), i.removeClass("resp-tab-active").css({
							"background-color": e.inactive_bg,
							"border-color": "none"
						}), !1;
						if (!i.hasClass("resp-tab-active") && i.hasClass("resp-accordion") ? (c.find(".resp-tab-active." + e.tabidentify).removeClass("resp-tab-active").css({
								"background-color": e.inactive_bg,
								"border-color": "none"
							}), c.find(".resp-tab-content-active." + e.tabidentify).slideUp().removeClass("resp-tab-content-active resp-accordion-closed"), c.find("[aria-controls=" + s + "]").addClass("resp-tab-active").css({
								"background-color": e.activetab_bg,
								"border-color": e.active_border_color
							}), c.find(".resp-tab-content[aria-labelledby = " + s + "]." + e.tabidentify).slideDown().addClass("resp-tab-content-active")) : (console.log("here"), c.find(".resp-tab-active." + e.tabidentify).removeClass("resp-tab-active").css({
								"background-color": e.inactive_bg,
								"border-color": "none"
							}), c.find(".resp-tab-content-active." + e.tabidentify).removeAttr("style").removeClass("resp-tab-content-active").removeClass("resp-accordion-closed"), c.find("[aria-controls=" + s + "]").addClass("resp-tab-active").css({
								"background-color": e.activetab_bg,
								"border-color": e.active_border_color
							}), c.find(".resp-tab-content[aria-labelledby = " + s + "]." + e.tabidentify).addClass("resp-tab-content-active").attr("style", "display:block")), d) {
							var n = window.location.hash,
								a = (s.split("tab_item-"), c.find("ul.resp-tabs-list li.resp-tab-active").attr("id"));
							if ("" != n) {
								var o = c.find("ul.resp-tabs-list li.resp-tab-active").attr("id");
								a = null != n.match(o) ? n.replace(o, a) : "#tab=" + a
							} else a = "#tab=" + a;
							history.replaceState(null, null, a)
						}
						i.trigger("tabactivate", i)
					})
				}), t(window).resize(function() {
					c.find(".resp-accordion-closed").removeAttr("style")
				})
			})
		}
	})
}(jQuery),
function(t, e) {
	"use strict";
	e.AccordionSlider = {
		modules: {},
		addModule: function(t, i, a) {
			void 0 === this.modules[a] && (this.modules[a] = []), this.modules[a].push(t), "accordion" === a ? e.extend(s.prototype, i) : "panel" === a && e.extend(n.prototype, i)
		}
	};
	var i = e.AccordionSlider.namespace = "AccordionSlider",
		s = function(t, i) {
			this.$accordion = e(t), this.$panelsContainer = null, this.$maskContainer = null, this.options = i, this.settings = {}, this.originalSettings = {}, this.currentIndex = -1, this.currentPage = 0, this.totalSize = 0, this.totalPanelsSize = 0, this.computedOpenedPanelSize = 0, this.maxComputedOpenedPanelSize = 0, this.collapsedPanelSize = 0, this.closedPanelSize = 0, this.computedPanelDistance = 0, this.panels = [], this.mouseDelayTimer = 0, this.openPanelAnimation = {}, this.closePanelsAnimation = {}, this.uniqueId = (new Date).valueOf(), this.breakpoints = [], this.currentBreakpoint = -1, this.previousVisiblePanels = -1, this.isPageScrolling = !1, this.positionProperty = "left", this.sizeProperty = "width", this.autoResponsiveRatio = 1, this.isOverlapping = !1, this._init()
		};
	s.prototype = {
		_init: function() {
			var s = this;
			this.$accordion.removeClass("as-no-js"), this.$maskContainer = e('<div class="as-mask"></div>').appendTo(this.$accordion), this.$panelsContainer = this.$accordion.find(".as-panels").appendTo(this.$maskContainer), 0 === this.$panelsContainer.length && (this.$panelsContainer = e('<div class="as-panels"></div>').appendTo(this.$maskContainer));
			var n = e.AccordionSlider.modules.accordion;
			if (void 0 !== n)
				for (var a = 0; a < n.length; a++) {
					var o = n[a] + "Defaults";
					void 0 !== this[o] ? e.extend(this.defaults, this[o]) : void 0 !== this[o = n[a].substring(0, 1).toLowerCase() + n[a].substring(1) + "Defaults"] && e.extend(this.defaults, this[o])
				}
			if (this.settings = e.extend({}, this.defaults, this.options), void 0 !== n)
				for (var r = 0; r < n.length; r++) void 0 !== this["init" + n[r]] && this["init" + n[r]]();
			if (this.originalSettings = e.extend({}, this.settings), !0 === this.settings.shuffle) {
				var l = this.$panelsContainer.find(".as-panel").sort(function() {
					return .5 - Math.random()
				});
				this.$panelsContainer.empty().append(l)
			}
			if (this.currentIndex = this.settings.startPanel, -1 === this.currentIndex ? this.$accordion.addClass("as-closed") : this.$accordion.addClass("as-opened"), -1 !== this.settings.startPage && (this.currentPage = this.settings.startPage), null !== this.settings.breakpoints) {
				for (var d in this.settings.breakpoints) this.breakpoints.push({
					size: parseInt(d, 10),
					properties: this.settings.breakpoints[d]
				});
				this.breakpoints = this.breakpoints.sort(function(t, e) {
					return t.size >= e.size ? 1 : -1
				})
			}
			if (this._prepareRAF(), this.update(), -1 !== this.currentIndex) {
				this.$accordion.find(".as-panel").eq(this.currentIndex).addClass("as-opened");
				var c = {
					type: "panelOpen",
					index: this.currentIndex,
					previousIndex: -1
				};
				this.trigger(c), e.isFunction(this.settings.panelOpen) && this.settings.panelOpen.call(this, c)
			}
			this.on("mouseenter." + i, function() {
				var t = {
					type: "accordionMouseOver"
				};
				s.trigger(t), e.isFunction(s.settings.accordionMouseOver) && s.settings.accordionMouseOver.call(s, t)
			}), this.on("mouseleave." + i, function() {
				clearTimeout(s.mouseDelayTimer), !0 === s.settings.closePanelsOnMouseOut && s.closePanels();
				var t = {
					type: "accordionMouseOut"
				};
				s.trigger(t), e.isFunction(s.settings.accordionMouseOut) && s.settings.accordionMouseOut.call(s, t)
			}), e(t).on("resize." + this.uniqueId + "." + i, function() {
				s.resize()
			}), this.trigger({
				type: "init"
			}), e.isFunction(this.settings.init) && this.settings.init.call(this, {
				type: "init"
			})
		},
		update: function() {
			var t = this;
			if ("horizontal" === this.settings.orientation ? (this.$accordion.removeClass("as-vertical").addClass("as-horizontal"), this.positionProperty = "left", this.sizeProperty = "width") : "vertical" === this.settings.orientation && (this.$accordion.removeClass("as-horizontal").addClass("as-vertical"), this.positionProperty = "top", this.sizeProperty = "height"), -1 === this.settings.visiblePanels) this.currentPage = 0;
			else if (-1 !== this.currentIndex) this.currentPage = Math.floor(this.currentIndex / this.settings.visiblePanels);
			else if (this.settings.visiblePanels !== this.previousVisiblePanels && -1 !== this.previousVisiblePanels) {
				var i = Math.round(this.currentPage * this.previousVisiblePanels / this.settings.visiblePanels);
				this.currentPage !== i && (this.currentPage = i)
			}
			this.settings.panelDistance > 0 || !1 === this.settings.panelOverlap ? (this.isOverlapping = !1, this.$accordion.removeClass("as-overlap")) : !0 === this.settings.panelOverlap && (this.isOverlapping = !0, this.$accordion.addClass("as-overlap")), this.$accordion.find("img.as-background, img.as-background-opened").css({
				width: "",
				height: ""
			}), this._updatePanels(), this._updatePaginationButtons(), !0 === this.settings.shadow ? this.$accordion.find(".as-panel").addClass("as-shadow") : !1 === this.settings.shadow && this.$accordion.find(".as-shadow").removeClass("as-shadow"), this.$panelsContainer.attr("style", ""), this.resize();
			var s = {
				type: "update"
			};
			t.trigger(s), e.isFunction(t.settings.update) && t.settings.update.call(t, s)
		},
		_updatePanels: function() {
			for (var t = this, s = this.panels.length - 1; s >= 0; s--)
				if (0 === this.$accordion.find('.as-panel[data-index="' + s + '"]').length) {
					var n = this.panels[s];
					n.off("panelMouseOver." + i), n.off("panelMouseOut." + i), n.off("panelClick." + i), n.off("imagesComplete." + i), n.destroy(), this.panels.splice(s, 1)
				} this.$accordion.find(".as-panel").each(function(i, s) {
				var n = e(s);
				void 0 === n.attr("data-init") ? t._createPanel(i, n) : (t.panels[i].setIndex(i), t.panels[i].update())
			})
		},
		_createPanel: function(t, s) {
			var a = this,
				o = e(s),
				r = new n(o, this, t);
			this.panels.splice(t, 0, r), r.on("panelMouseOver." + i, function(i) {
				if (!0 !== a.isPageScrolling) {
					"hover" === a.settings.openPanelOn && (clearTimeout(a.mouseDelayTimer), a.mouseDelayTimer = setTimeout(function() {
						a.openPanel(i.index)
					}, a.settings.mouseDelay));
					var s = {
						type: "panelMouseOver",
						index: t
					};
					a.trigger(s), e.isFunction(a.settings.panelMouseOver) && a.settings.panelMouseOver.call(a, s)
				}
			}), r.on("panelMouseOut." + i, function() {
				if (!0 !== a.isPageScrolling) {
					var i = {
						type: "panelMouseOut",
						index: t
					};
					a.trigger(i), e.isFunction(a.settings.panelMouseOut) && a.settings.panelMouseOut.call(a, i)
				}
			}), r.on("panelClick." + i, function(i) {
				if (!a.$accordion.hasClass("as-swiping")) {
					"click" === a.settings.openPanelOn && (t !== a.currentIndex ? a.openPanel(i.index) : a.closePanels());
					var s = {
						type: "panelClick",
						index: t
					};
					a.trigger(s), e.isFunction(a.settings.panelClick) && a.settings.panelClick.call(a, s)
				}
			}), r.on("panelMouseDown." + i, function() {
				e(this).find("a").off("click.disablePanelLink"), t !== a.currentIndex && "click" === a.settings.openPanelOn && e(this).find("a").one("click.disablePanelLink", function(t) {
					t.preventDefault()
				})
			}), r.on("imagesComplete." + i, function(t) {
				t.index === a.currentIndex && t.contentSize !== a.computedOpenedPanelSize && a.openPanel(t.index, !0)
			})
		},
		removePanels: function() {
			e.each(this.panels, function(t, e) {
				e.off("panelMouseOver." + i), e.off("panelMouseOut." + i), e.off("panelClick." + i), e.off("imagesComplete." + i), e.destroy()
			}), this.panels.length = 0
		},
		resize: function() {
			var i = this;
			if (this.$maskContainer.attr("style", ""), !0 === this.settings.responsive ? (this.$accordion.css({
					width: "100%",
					height: this.settings.height,
					maxWidth: this.settings.width,
					maxHeight: this.settings.height
				}), -1 === this.settings.aspectRatio && (this.settings.aspectRatio = this.settings.width / this.settings.height), this.$accordion.css("height", this.$accordion.innerWidth() / this.settings.aspectRatio), "auto" === this.settings.responsiveMode ? (this.autoResponsiveRatio = this.$accordion.innerWidth() / this.settings.width, this.$maskContainer.css({
					width: this.settings.width,
					height: this.settings.height
				}), this.autoResponsiveRatio < 1 ? this.$maskContainer.css({
					"-webkit-transform": "scaleX(" + this.autoResponsiveRatio + ") scaleY(" + this.autoResponsiveRatio + ")",
					"-ms-transform": "scaleX(" + this.autoResponsiveRatio + ") scaleY(" + this.autoResponsiveRatio + ")",
					transform: "scaleX(" + this.autoResponsiveRatio + ") scaleY(" + this.autoResponsiveRatio + ")",
					"-webkit-transform-origin": "top left",
					"-ms-transform-origin": "top left",
					"transform-origin": "top left"
				}) : this.$maskContainer.css({
					"-webkit-transform": "",
					"-ms-transform": "",
					transform: "",
					"-webkit-transform-origin": "",
					"-ms-transform-origin": "",
					"transform-origin": ""
				}), this.totalSize = "horizontal" === this.settings.orientation ? this.$maskContainer.innerWidth() : this.$maskContainer.innerHeight()) : this.totalSize = "horizontal" === this.settings.orientation ? this.$accordion.innerWidth() : this.$accordion.innerHeight()) : (this.$accordion.css({
					width: this.settings.width,
					height: this.settings.height,
					maxWidth: "",
					maxHeight: ""
				}), this.totalSize = "horizontal" === this.settings.orientation ? this.$accordion.innerWidth() : this.$accordion.innerHeight()), "horizontal" === this.settings.orientation ? this.$accordion.find("img.as-background, img.as-background-opened").css("height", this.$panelsContainer.innerHeight()) : this.$accordion.find("img.as-background, img.as-background-opened").css("width", this.$panelsContainer.innerWidth()), this.computedPanelDistance = this.settings.panelDistance, "string" == typeof this.computedPanelDistance && (-1 !== this.computedPanelDistance.indexOf("%") ? this.computedPanelDistance = this.totalSize * (parseInt(this.computedPanelDistance, 10) / 100) : -1 !== this.computedPanelDistance.indexOf("px") && (this.computedPanelDistance = parseInt(this.computedPanelDistance, 10))), this.closedPanelSize = (this.totalSize - (this.getVisiblePanels() - 1) * this.computedPanelDistance) / this.getVisiblePanels(), this.closedPanelSize = Math.floor(this.closedPanelSize), this.computedOpenedPanelSize = this.settings.openedPanelSize, "max" === this.settings.openedPanelSize && (this.maxComputedOpenedPanelSize = this.settings.maxOpenedPanelSize, "string" == typeof this.maxComputedOpenedPanelSize && (-1 !== this.maxComputedOpenedPanelSize.indexOf("%") ? this.maxComputedOpenedPanelSize = this.totalSize * (parseInt(this.maxComputedOpenedPanelSize, 10) / 100) : -1 !== this.maxComputedOpenedPanelSize.indexOf("px") && (this.maxComputedOpenedPanelSize = parseInt(this.maxComputedOpenedPanelSize, 10)))), "string" == typeof this.computedOpenedPanelSize)
				if (-1 !== this.computedOpenedPanelSize.indexOf("%")) this.computedOpenedPanelSize = this.totalSize * (parseInt(this.computedOpenedPanelSize, 10) / 100);
				else if (-1 !== this.computedOpenedPanelSize.indexOf("px")) this.computedOpenedPanelSize = parseInt(this.computedOpenedPanelSize, 10);
			else if ("max" === this.computedOpenedPanelSize && -1 !== this.currentIndex) {
				var s = this.getPanelAt(this.currentIndex).getContentSize();
				this.computedOpenedPanelSize = "loading" === s ? this.closedPanelSize : Math.min(s, this.maxComputedOpenedPanelSize)
			}
			if (this.collapsedPanelSize = (this.totalSize - this.computedOpenedPanelSize - (this.getVisiblePanels() - 1) * this.computedPanelDistance) / (this.getVisiblePanels() - 1), this.computedOpenedPanelSize = Math.floor(this.computedOpenedPanelSize), this.collapsedPanelSize = Math.floor(this.collapsedPanelSize), this.totalPanelsSize = this.closedPanelSize * this.getTotalPanels() + this.computedPanelDistance * (this.getTotalPanels() - 1), this.$panelsContainer.css(this.sizeProperty, this.totalPanelsSize), this.totalSize = this.closedPanelSize * this.getVisiblePanels() + this.computedPanelDistance * (this.getVisiblePanels() - 1), "custom" === this.settings.responsiveMode || !1 === this.settings.responsive ? this.$accordion.css(this.sizeProperty, this.totalSize) : (this.$accordion.css(this.sizeProperty, this.totalSize * this.autoResponsiveRatio), this.$maskContainer.css(this.sizeProperty, this.totalSize)), -1 !== this.settings.visiblePanels) {
				var n = {},
					a = -(this.totalSize + this.computedPanelDistance) * this.currentPage;
				this.currentPage === this.getTotalPages() - 1 && (a = -(this.closedPanelSize * this.getTotalPanels() + this.computedPanelDistance * (this.getTotalPanels() - 1) - this.totalSize)), n[this.positionProperty] = a, this.$panelsContainer.css(n)
			}
			var o = this.currentPage === this.getTotalPages() - 1 && 0 != this.getTotalPanels() % this.settings.visiblePanels ? this.settings.visiblePanels - this.getTotalPanels() % this.settings.visiblePanels : 0;
			if (e.each(this.panels, function(t, e) {
					var s;
					if (-1 === i.currentIndex ? s = t * (i.closedPanelSize + i.computedPanelDistance) : -1 === i.settings.visiblePanels ? s = t * (i.collapsedPanelSize + i.computedPanelDistance) + (t > i.currentIndex ? i.computedOpenedPanelSize - i.collapsedPanelSize : 0) : i._getPageOfPanel(t) === i.currentPage ? (s = i.currentPage * (i.totalSize + i.computedPanelDistance) + (t + o - i.currentPage * i.settings.visiblePanels) * (i.collapsedPanelSize + i.computedPanelDistance) + (t > i.currentIndex ? i.computedOpenedPanelSize - i.collapsedPanelSize : 0), i.currentPage === i.getTotalPages() - 1 && 0 !== o && (s -= (i.getTotalPages() - i.getTotalPanels() / i.settings.visiblePanels) * (i.totalSize + i.computedPanelDistance))) : s = t * (i.closedPanelSize + i.computedPanelDistance), e.setPosition(s), !1 === i.isOverlapping) {
						var n = -1 === i.currentIndex || -1 !== i.settings.visiblePanels && i._getPageOfPanel(t) !== i.currentPage ? i.closedPanelSize : t === i.currentIndex ? i.computedOpenedPanelSize : i.collapsedPanelSize;
						e.setSize(n)
					}
				}), null !== this.settings.breakpoints && this.breakpoints.length > 0)
				if (e(t).width() > this.breakpoints[this.breakpoints.length - 1].size && -1 !== this.currentBreakpoint) this.currentBreakpoint = -1, this._setProperties(this.originalSettings, !1);
				else
					for (var r = 0, l = this.breakpoints.length; l > r; r++)
						if (e(t).width() <= this.breakpoints[r].size) {
							if (this.currentBreakpoint !== this.breakpoints[r].size) {
								var d = {
									type: "breakpointReach",
									size: this.breakpoints[r].size,
									settings: this.breakpoints[r].properties
								};
								i.trigger(d), e.isFunction(i.settings.breakpointReach) && i.settings.breakpointReach.call(i, d), this.currentBreakpoint = this.breakpoints[r].size;
								var c = e.extend({}, this.originalSettings, this.breakpoints[r].properties);
								this._setProperties(c, !1)
							}
							break
						}
		},
		_setProperties: function(t, e) {
			for (var i in t) "visiblePanels" === i && -1 !== this.settings.visiblePanels && (this.previousVisiblePanels = this.settings.visiblePanels), this.settings[i] = t[i], !1 !== e && (this.originalSettings[i] = t[i]);
			this.update()
		},
		destroy: function() {
			this.$accordion.removeData("accordionSlider"), this.$accordion.attr("style", ""), this.$panelsContainer.attr("style", ""), this.off("mouseenter." + i), this.off("mouseleave." + i), e(t).off("resize." + this.uniqueId + "." + i), this._stopPanelsAnimation(this.openPanelAnimation), this._stopPanelsAnimation(this.closePanelsAnimation);
			var s = e.AccordionSlider.modules.accordion;
			if (void 0 !== s)
				for (var n = 0; n < s.length; n++) void 0 !== this["destroy" + s[n]] && this["destroy" + s[n]]();
			this.removePanels(), this.$panelsContainer.appendTo(this.$accordion), this.$maskContainer.remove(), this.$accordion.find(".as-pagination-buttons").remove()
		},
		on: function(t, e) {
			return this.$accordion.on(t, e)
		},
		off: function(t) {
			return this.$accordion.off(t)
		},
		trigger: function(t) {
			return this.$accordion.triggerHandler(t)
		},
		getPanelAt: function(t) {
			return this.panels[t]
		},
		getCurrentIndex: function() {
			return this.currentIndex
		},
		getTotalPanels: function() {
			return this.panels.length
		},
		nextPanel: function() {
			var t = this.currentIndex >= this.getTotalPanels() - 1 ? 0 : this.currentIndex + 1;
			this.openPanel(t)
		},
		previousPanel: function() {
			var t = this.currentIndex <= 0 ? this.getTotalPanels() - 1 : this.currentIndex - 1;
			this.openPanel(t)
		},
		_animatePanels: function(e, i) {
			var s = (new Date).valueOf(),
				n = 0;
			e.isRunning = !0, e.timer = t.requestAnimationFrame(function a() {
				1 > n ? ((n = ((new Date).valueOf() - s) / i.duration) > 1 && (n = 1), n = .5 - Math.cos(n * Math.PI) / 2, i.step(n), e.timer = t.requestAnimationFrame(a)) : (i.complete(), e.isRunning = !1, t.cancelAnimationFrame(e.timer))
			})
		},
		_stopPanelsAnimation: function(e) {
			void 0 !== e.isRunning && !0 === e.isRunning && (e.isRunning = !1, t.cancelAnimationFrame(e.timer))
		},
		_prepareRAF: function() {
			if (void 0 === t.requestAnimationFrame)
				for (var e = ["webkit", "moz"], i = 0; i < e.length; i++) t.requestAnimationFrame = t[e[i] + "RequestAnimationFrame"], t.cancelAnimationFrame = t.cancelAnimationFrame || t[e[i] + "CancelAnimationFrame"] || t[e[i] + "CancelRequestAnimationFrame"];
			if (void 0 === t.requestAnimationFrame) {
				var s = 0;
				t.requestAnimationFrame = function(e) {
					var i = (new Date).valueOf(),
						n = Math.max(0, 16 - (i - s)),
						a = t.setTimeout(function() {
							e(i + n)
						}, n);
					return s = i + n, a
				}, t.cancelAnimationFrame = function(t) {
					clearTimeout(t)
				}
			}
		},
		openPanel: function(t, i) {
			if (t !== this.currentIndex || !0 === i) {
				!1 === this.$accordion.hasClass("as-opened") && (this.$accordion.removeClass("as-closed"), this.$accordion.addClass("as-opened"));
				var s = this.currentIndex;
				if (this.currentIndex = t, -1 !== this.settings.visiblePanels && !(this.currentPage === this.getTotalPages() - 1 && t >= this.getTotalPanels() - this.settings.visiblePanels)) {
					var n = Math.floor(this.currentIndex / this.settings.visiblePanels);
					n !== this.currentPage && this.gotoPage(n), this.currentIndex = t
				}
				var a = this,
					o = [],
					r = [],
					l = [],
					d = [],
					c = [],
					h = this._getFirstPanelFromPage(),
					u = this._getLastPanelFromPage(),
					p = 0;
				if (this.$accordion.find(".as-panel.as-opened").removeClass("as-opened"), this.$accordion.find(".as-panel").eq(this.currentIndex).addClass("as-opened"), "max" === this.settings.openedPanelSize) {
					var f = this.getPanelAt(this.currentIndex).getContentSize();
					this.computedOpenedPanelSize = "loading" === f ? this.closedPanelSize : Math.min(f, this.maxComputedOpenedPanelSize), this.collapsedPanelSize = (this.totalSize - this.computedOpenedPanelSize - (this.getVisiblePanels() - 1) * this.computedPanelDistance) / (this.getVisiblePanels() - 1)
				}
				for (var m = h; u >= m; m++) {
					var g = this.getPanelAt(m);
					d[m] = g.getPosition(), r[m] = this.currentPage * (this.totalSize + this.computedPanelDistance) + p * (this.collapsedPanelSize + this.computedPanelDistance) + (m > this.currentIndex ? this.computedOpenedPanelSize - this.collapsedPanelSize : 0), -1 !== this.settings.visiblePanels && this.currentPage === this.getTotalPages() - 1 && (r[m] -= (this.getTotalPages() - this.getTotalPanels() / this.settings.visiblePanels) * (this.totalSize + this.computedPanelDistance)), r[m] !== d[m] && c.push(m), !1 === this.isOverlapping && (l[m] = g.getSize(), o[m] = m === this.currentIndex ? this.computedOpenedPanelSize : this.collapsedPanelSize, o[m] !== l[m] && -1 === e.inArray(m, c) && c.push(m)), p++
				}
				var v = c.length;
				this.closePanelsAnimation.page === this.currentPage && this._stopPanelsAnimation(this.closePanelsAnimation), this._stopPanelsAnimation(this.openPanelAnimation), this.openPanelAnimation.page = this.currentPage, this._animatePanels(this.openPanelAnimation, {
					duration: this.settings.openPanelDuration,
					step: function(t) {
						for (var e = 0; v > e; e++) {
							var i = c[e],
								s = a.getPanelAt(i);
							s.setPosition(t * (r[i] - d[i]) + d[i]), !1 === a.isOverlapping && s.setSize(t * (o[i] - l[i]) + l[i])
						}
					},
					complete: function() {
						var t = {
							type: "panelOpenComplete",
							index: a.currentIndex
						};
						a.trigger(t), e.isFunction(a.settings.panelOpenComplete) && a.settings.panelOpenComplete.call(a, t)
					}
				});
				var y = {
					type: "panelOpen",
					index: t,
					previousIndex: s
				};
				this.trigger(y), e.isFunction(this.settings.panelOpen) && this.settings.panelOpen.call(this, y)
			}
		},
		closePanels: function() {
			var t = this.currentIndex;
			this.currentIndex = -1, !1 === this.$accordion.hasClass("as-closed") && (this.$accordion.removeClass("as-opened"), this.$accordion.addClass("as-closed")), this.$accordion.find(".as-panel.as-opened").removeClass("as-opened"), clearTimeout(this.mouseDelayTimer);
			for (var i = this, s = [], n = [], a = [], o = [], r = this._getFirstPanelFromPage(), l = this._getLastPanelFromPage(), d = 0, c = r; l >= c; c++) {
				var h = this.getPanelAt(c);
				o[c] = h.getPosition(), n[c] = this.currentPage * (this.totalSize + this.computedPanelDistance) + d * (this.closedPanelSize + this.computedPanelDistance), -1 !== this.settings.visiblePanels && this.currentPage === this.getTotalPages() - 1 && (n[c] -= (this.getTotalPages() - this.getTotalPanels() / this.settings.visiblePanels) * (this.totalSize + this.computedPanelDistance)), !1 === this.isOverlapping && (a[c] = h.getSize(), s[c] = this.closedPanelSize), d++
			}
			this.openPanelAnimation.page === this.currentPage && this._stopPanelsAnimation(this.openPanelAnimation), this._stopPanelsAnimation(this.closePanelsAnimation), this.closePanelsAnimation.page = this.currentPage, this._animatePanels(this.closePanelsAnimation, {
				duration: this.settings.closePanelDuration,
				step: function(t) {
					for (var e = r; l >= e; e++) {
						var d = i.getPanelAt(e);
						d.setPosition(t * (n[e] - o[e]) + o[e]), !1 === i.isOverlapping && d.setSize(t * (s[e] - a[e]) + a[e])
					}
				},
				complete: function() {
					var s = {
						type: "panelsCloseComplete",
						previousIndex: t
					};
					i.trigger(s), e.isFunction(i.settings.panelsCloseComplete) && i.settings.panelsCloseComplete.call(i, s)
				}
			});
			var u = {
				type: "panelsClose",
				previousIndex: t
			};
			this.trigger(u), e.isFunction(this.settings.panelsClose) && this.settings.panelsClose.call(this, u)
		},
		getVisiblePanels: function() {
			return -1 === this.settings.visiblePanels ? this.getTotalPanels() : this.settings.visiblePanels
		},
		getTotalPages: function() {
			return -1 === this.settings.visiblePanels ? 1 : Math.ceil(this.getTotalPanels() / this.settings.visiblePanels)
		},
		getCurrentPage: function() {
			return -1 === this.settings.visiblePanels ? 0 : this.currentPage
		},
		gotoPage: function(t) {
			-1 !== this.currentIndex && this.closePanels(), this.currentPage = t, this.isPageScrolling = !0;
			var i = this,
				s = {},
				n = -(t * this.totalSize + this.currentPage * this.computedPanelDistance);
			this.currentPage === this.getTotalPages() - 1 && (n = -(this.totalPanelsSize - this.totalSize)), s[this.positionProperty] = n;
			var a = {
				type: "pageScroll",
				index: this.currentPage
			};
			this.trigger(a), e.isFunction(this.settings.pageScroll) && this.settings.pageScroll.call(this, a), this.$panelsContainer.stop().animate(s, this.settings.pageScrollDuration, this.settings.pageScrollEasing, function() {
				i.isPageScrolling = !1;
				var t = {
					type: "pageScrollComplete",
					index: i.currentPage
				};
				i.trigger(t), e.isFunction(i.settings.pageScrollComplete) && i.settings.pageScrollComplete.call(i, t)
			})
		},
		nextPage: function() {
			var t = this.currentPage >= this.getTotalPages() - 1 ? 0 : this.currentPage + 1;
			this.gotoPage(t)
		},
		previousPage: function() {
			var t = this.currentPage <= 0 ? this.getTotalPages() - 1 : this.currentPage - 1;
			this.gotoPage(t)
		},
		_getFirstPanelFromPage: function() {
			return -1 === this.settings.visiblePanels ? 0 : this.currentPage === this.getTotalPages() - 1 && 0 !== this.currentPage ? this.getTotalPanels() - this.settings.visiblePanels : this.currentPage * this.settings.visiblePanels
		},
		_getLastPanelFromPage: function() {
			return -1 === this.settings.visiblePanels ? this.getTotalPanels() - 1 : this.currentPage === this.getTotalPages() - 1 ? this.getTotalPanels() - 1 : (this.currentPage + 1) * this.settings.visiblePanels - 1
		},
		_getPageOfPanel: function(t) {
			return this.currentPage === this.getTotalPages() - 1 && t >= this.getTotalPanels() - this.settings.visiblePanels ? this.getTotalPages() - 1 : Math.floor(t / this.settings.visiblePanels)
		},
		_updatePaginationButtons: function() {
			var t = this.$accordion.find(".as-pagination-buttons"),
				s = this,
				n = this.getTotalPages();
			if (1 >= n && 0 !== t.length) t.remove(), t.off("click." + i, ".as-pagination-button"), this.off("pageScroll." + i), this.$accordion.removeClass("as-has-buttons");
			else if (n > 1 && 0 === t.length) {
				t = e('<div class="as-pagination-buttons"></div>').appendTo(this.$accordion);
				for (var a = 0; a < this.getTotalPages(); a++) e('<div class="as-pagination-button"></div>').appendTo(t);
				t.on("click." + i, ".as-pagination-button", function() {
					s.gotoPage(e(this).index())
				}), t.find(".as-pagination-button").eq(this.currentPage).addClass("as-selected"), this.on("pageScroll." + i, function(e) {
					t.find(".as-selected").removeClass("as-selected"), t.find(".as-pagination-button").eq(e.index).addClass("as-selected")
				}), this.$accordion.addClass("as-has-buttons")
			} else if (n > 1 && 0 !== t.length) {
				t.empty();
				for (var o = 0; o < this.getTotalPages(); o++) e('<div class="as-pagination-button"></div>').appendTo(t);
				t.find(".as-selected").removeClass("as-selected"), t.find(".as-pagination-button").eq(this.currentPage).addClass("as-selected")
			}
		},
		defaults: {
			width: 800,
			height: 400,
			responsive: !0,
			responsiveMode: "auto",
			aspectRatio: -1,
			orientation: "horizontal",
			startPanel: -1,
			openedPanelSize: "max",
			maxOpenedPanelSize: "80%",
			openPanelOn: "hover",
			closePanelsOnMouseOut: !0,
			mouseDelay: 200,
			panelDistance: 0,
			openPanelDuration: 700,
			closePanelDuration: 700,
			pageScrollDuration: 500,
			pageScrollEasing: "swing",
			breakpoints: null,
			visiblePanels: -1,
			startPage: 0,
			shadow: !0,
			shuffle: !1,
			panelOverlap: !0,
			init: function() {},
			update: function() {},
			accordionMouseOver: function() {},
			accordionMouseOut: function() {},
			panelClick: function() {},
			panelMouseOver: function() {},
			panelMouseOut: function() {},
			panelOpen: function() {},
			panelsClose: function() {},
			pageScroll: function() {},
			panelOpenComplete: function() {},
			panelsCloseComplete: function() {},
			pageScrollComplete: function() {},
			breakpointReach: function() {}
		}
	};
	var n = function(t, e, s) {
		this.$panel = t, this.accordion = e, this.settings = this.accordion.settings, this.panelNS = "AccordionSliderPanel" + s + "." + i, this.isLoading = !1, this.isLoaded = !1, this.setIndex(s), this._init()
	};
	n.prototype = {
		_init: function() {
			var t = this;
			this.$panel.attr("data-init", !0), this.on("mouseenter." + this.panelNS, function() {
				t.trigger({
					type: "panelMouseOver." + i,
					index: t.index
				})
			}), this.on("mouseleave." + this.panelNS, function() {
				t.trigger({
					type: "panelMouseOut." + i,
					index: t.index
				})
			}), this.on("click." + this.panelNS, function() {
				t.trigger({
					type: "panelClick." + i,
					index: t.index
				})
			}), this.on("mousedown." + this.panelNS, function() {
				t.trigger({
					type: "panelMouseDown." + i,
					index: t.index
				})
			}), this.update();
			var s = e.AccordionSlider.modules.panel;
			if (void 0 !== s)
				for (var n = 0; n < s.length; n++) void 0 !== this["init" + s[n]] && this["init" + s[n]]()
		},
		update: function() {
			this.positionProperty = "horizontal" === this.settings.orientation ? "left" : "top", this.sizeProperty = "horizontal" === this.settings.orientation ? "width" : "height", this.$panel.css({
				top: "",
				left: "",
				width: "",
				height: ""
			})
		},
		destroy: function() {
			this.off("mouseenter." + this.panelNS), this.off("mouseleave." + this.panelNS), this.off("click." + this.panelNS), this.off("mousedown." + this.panelNS), this.$panel.attr("style", ""), this.$panel.removeAttr("data-init"), this.$panel.removeAttr("data-index");
			var t = e.AccordionSlider.modules.panel;
			if (void 0 !== t)
				for (var i = 0; i < t.length; i++) void 0 !== this["destroy" + t[i]] && this["destroy" + t[i]]()
		},
		getIndex: function() {
			return this.index
		},
		setIndex: function(t) {
			this.index = t, this.$panel.attr("data-index", this.index)
		},
		getPosition: function() {
			return parseInt(this.$panel.css(this.positionProperty), 10)
		},
		setPosition: function(t) {
			this.$panel.css(this.positionProperty, t)
		},
		getSize: function() {
			return parseInt(this.$panel.css(this.sizeProperty), 10)
		},
		setSize: function(t) {
			this.$panel.css(this.sizeProperty, t)
		},
		getContentSize: function() {
			if (!1 === this.isLoaded && "loading" === this.checkImagesComplete()) return "loading";
			this.$panel.find(".as-opened").css("display", "none");
			var t = "width" === this.sizeProperty ? this.$panel[0].scrollWidth : this.$panel[0].scrollHeight;
			return this.$panel.find(".as-opened").css("display", ""), t
		},
		checkImagesComplete: function() {
			if (!0 === this.isLoading) return "loading";
			var t = this,
				s = "complete";
			if (this.$panel.find("img").each(function() {
					(!1 === e(this)[0].complete || void 0 !== e(this).attr("data-src")) && (s = "loading")
				}), "loading" === s) {
				this.isLoading = !0;
				var n = setInterval(function() {
					var s = !0;
					t.$panel.find("img").each(function() {
						(!1 === e(this)[0].complete || void 0 !== e(this).attr("data-src")) && (s = !1)
					}), !0 === s && (t.isLoading = !1, t.isLoaded = !0, clearInterval(n), t.trigger({
						type: "imagesComplete." + i,
						index: t.index,
						contentSize: t.getContentSize()
					}))
				}, 100)
			} else this.isLoaded = !0;
			return s
		},
		on: function(t, e) {
			return this.$panel.on(t, e)
		},
		off: function(t) {
			return this.$panel.off(t)
		},
		trigger: function(t) {
			return this.$panel.triggerHandler(t)
		}
	}, t.AccordionSlider = s, t.AccordionSliderPanel = n, e.fn.accordionSlider = function(t) {
		var i = Array.prototype.slice.call(arguments, 1);
		return this.each(function() {
			if (void 0 === e(this).data("accordionSlider")) {
				var n = new s(this, t);
				e(this).data("accordionSlider", n)
			} else if (void 0 !== t) {
				var a = e(this).data("accordionSlider");
				if ("function" == typeof a[t]) a[t].apply(a, i);
				else if (void 0 !== a.settings[t]) {
					var o = {};
					o[t] = i[0], a._setProperties(o)
				} else "object" == typeof t ? a._setProperties(t) : e.error(t + " does not exist in accordionSlider.")
			}
		})
	}
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace,
		s = {
			autoplayIndex: -1,
			autoplayTimer: null,
			isTimerRunning: !1,
			isTimerPaused: !1,
			initAutoplay: function() {
				var t = this;
				!0 === this.settings.autoplay && this.startAutoplay(), this.on("panelOpen.Autoplay." + i, function(e) {
					t.autoplayIndex = e.index, !0 === t.settings.autoplay && (!0 === t.isTimerRunning && t.stopAutoplay(), !1 === t.isTimerPaused && t.startAutoplay())
				}), this.on("panelsClose.Autoplay." + i, function(e) {
					-1 !== e.previousIndex && (t.autoplayIndex = e.previousIndex)
				}), this.on("pageScroll.Autoplay." + i, function() {
					t.autoplayIndex = t._getFirstPanelFromPage() - 1
				}), this.on("mouseenter.Autoplay." + i, function() {
					!0 !== t.settings.autoplay || !t.isTimerRunning || "pause" !== t.settings.autoplayOnHover && "stop" !== t.settings.autoplayOnHover || (t.stopAutoplay(), t.isTimerPaused = !0)
				}), this.on("mouseleave.Autoplay." + i, function() {
					!0 === t.settings.autoplay && !1 === t.isTimerRunning && "stop" !== t.settings.autoplayOnHover && (t.startAutoplay(), t.isTimerPaused = !1)
				})
			},
			startAutoplay: function() {
				var t = this;
				this.isTimerRunning = !0, this.autoplayTimer = setTimeout(function() {
					-1 !== t.autoplayIndex && (t.currentIndex = t.autoplayIndex, t.autoplayIndex = -1), "normal" === t.settings.autoplayDirection ? t.nextPanel() : "backwards" === t.settings.autoplayDirection && t.previousPanel()
				}, this.settings.autoplayDelay)
			},
			stopAutoplay: function() {
				this.isTimerRunning = !1, clearTimeout(this.autoplayTimer)
			},
			destroyAutoplay: function() {
				clearTimeout(this.autoplayTimer), this.off("panelOpen.Autoplay." + i), this.off("pageScroll.Autoplay." + i), this.off("mouseenter.Autoplay." + i), this.off("mouseleave.Autoplay." + i)
			},
			autoplayDefaults: {
				autoplay: !0,
				autoplayDelay: 5e3,
				autoplayDirection: "normal",
				autoplayOnHover: "pause"
			}
		};
	e.AccordionSlider.addModule("Autoplay", s, "accordion")
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace,
		s = {
			initDeepLinking: function() {
				var s = this;
				!1 !== this._parseHash(t.location.hash) && (this.options.startPanel = -1), this.on("init.DeepLinking." + i, function() {
					s._gotoHash(t.location.hash)
				}), e(t).on("hashchange.DeepLinking." + this.uniqueId + "." + i, function() {
					s._gotoHash(t.location.hash)
				})
			},
			_parseHash: function(t) {
				if ("" !== t) {
					var e = (t = t.substring(1)).split("/").pop(),
						i = t.slice(0, -e.toString().length - 1);
					if (this.$accordion.attr("id") === i) return {
						accordionID: i,
						panelId: e
					}
				}
				return !1
			},
			_gotoHash: function(t) {
				var e = this._parseHash(t);
				if (!1 !== e) {
					var i = e.panelId,
						s = parseInt(i, 10);
					if (isNaN(s)) {
						var n = this.$accordion.find(".as-panel#" + i).index(); - 1 !== n && this.openPanel(n)
					} else this.openPanel(s)
				}
			},
			destroyDeepLinking: function() {
				e(t).off("hashchange.DeepLinking." + this.uniqueId + "." + i)
			}
		};
	e.AccordionSlider.addModule("DeepLinking", s, "accordion")
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace,
		s = {
			JSONDataAttributesMap: {
				width: "data-width",
				height: "data-height",
				depth: "data-depth",
				position: "data-position",
				horizontal: "data-horizontal",
				vertical: "data-vertical",
				showTransition: "data-show-transition",
				showOffset: "data-show-offset",
				showDelay: "data-show-delay",
				showDuration: "data-show-duration",
				showEasing: "data-show-easing",
				hideTransition: "data-hide-transition",
				hideOffset: "data-",
				hideDelay: "data-hide-delay",
				hideDuration: "data-hide-duration",
				hideEasing: "data-hide-easing"
			},
			initJSON: function() {
				null !== this.settings.JSONSource && this.updateJSON()
			},
			updateJSON: function() {
				var t = this;
				this.removePanels(), this.$panelsContainer.empty(), this.off("JSONReady." + i), this.on("JSONReady." + i, function(i) {
					var s = i.jsonData,
						n = s.accordion.panels,
						a = s.accordion.lazyLoading;
					e.each(n, function(i, s) {
						var n, o, r = s,
							l = e('<div class="as-panel"></div>').appendTo(t.$panelsContainer);
						if (void 0 !== r.backgroundLink && (n = e('<a href="' + r.backgroundLink.address + '"></a>'), e.each(r.backgroundLink, function(t, e) {
								"address" !== t && n.attr(t, e)
							}), n.appendTo(l)), void 0 !== r.background) {
							var d = e('<img class="as-background"/>');
							void 0 !== a ? d.attr({
								src: a,
								"data-src": r.background.source
							}) : d.attr({
								src: r.background.source
							}), void 0 !== r.backgroundRetina && d.attr({
								"data-retina": r.backgroundRetina.source
							}), e.each(r.background, function(t, e) {
								"source" !== t && d.attr(t, e)
							}), d.appendTo(void 0 !== n ? n : l)
						}
						if (void 0 !== r.backgroundOpenedLink && (o = e('<a href="' + r.backgroundOpenedLink.address + '"></a>'), e.each(r.backgroundOpenedLink, function(t, e) {
								"address" !== t && o.attr(t, e)
							}), o.appendTo(l)), void 0 !== r.backgroundOpened) {
							var c = e('<img class="as-background-opened"/>');
							void 0 !== a ? c.attr({
								src: a,
								"data-src": r.backgroundOpened.source
							}) : c.attr({
								src: r.backgroundOpened.source
							}), void 0 !== r.backgroundOpenedRetina && c.attr({
								"data-retina": r.backgroundOpenedRetina.source
							}), e.each(r.backgroundOpened, function(t, e) {
								"source" !== t && c.attr(t, e)
							}), c.appendTo(void 0 !== o ? o : l)
						}
						void 0 !== r.layers && t._parseLayers(r.layers, l)
					}), t.update()
				}), this._loadJSON()
			},
			_parseLayers: function(t, i) {
				var s = this;
				e.each(t, function(t, n) {
					var a = n,
						o = "",
						r = "";
					e.each(a, function(t, i) {
						if ("style" === t) {
							var n = i.split(" ");
							e.each(n, function(t, e) {
								o += " as-" + e
							})
						} else "content" !== t && "layers" !== t && (r += " " + s.JSONDataAttributesMap[t] + '="' + i + '"')
					});
					var l = e('<div class="as-layer' + o + '"' + r + "></div>").appendTo(i);
					void 0 !== n.layers ? s._parseLayers(n.layers, l) : l.html(a.content)
				})
			},
			_loadJSON: function() {
				var t = this;
				if (".json" === this.settings.JSONSource.slice(-5)) e.getJSON(this.settings.JSONSource, function(e) {
					t.trigger({
						type: "JSONReady." + i,
						jsonData: e
					})
				});
				else {
					var s = e.parseJSON(this.settings.JSONSource);
					t.trigger({
						type: "JSONReady." + i,
						jsonData: s
					})
				}
			},
			destroyJSON: function() {
				this.off("JSONReady." + i)
			},
			JSONDefaults: {
				JSONSource: null
			}
		};
	e.AccordionSlider.addModule("JSON", s, "accordion")
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace,
		s = {
			initKeyboard: function() {
				var t = this,
					s = !1;
				!1 !== this.settings.keyboard && (this.$accordion.on("focus.Keyboard." + i, function() {
					s = !0
				}), this.$accordion.on("blur.Keyboard." + i, function() {
					s = !1
				}), e(document).on("keydown.Keyboard." + this.uniqueId + "." + i, function(e) {
					(!0 !== t.settings.keyboardOnlyOnFocus || !1 !== s) && (37 === e.which ? "page" === t.settings.keyboardTarget ? t.previousPage() : t.previousPanel() : 39 === e.which ? "page" === t.settings.keyboardTarget ? t.nextPage() : t.nextPanel() : 13 === e.which && t.$accordion.find(".as-panel").eq(t.currentIndex).children("a")[0].click())
				}))
			},
			destroyKeyboard: function() {
				this.$accordion.off("focus.Keyboard." + i), this.$accordion.off("blur.Keyboard." + i), e(document).off("keydown.Keyboard." + this.uniqueId + "." + i)
			},
			keyboardDefaults: {
				keyboard: !0,
				keyboardOnlyOnFocus: !1,
				keyboardTarget: "panel"
			}
		};
	e.AccordionSlider.addModule("Keyboard", s, "accordion")
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = (e.AccordionSlider.namespace, t.navigator.userAgent.toLowerCase()),
		s = /(msie) ([\w.]+)/.exec(i) || [],
		n = s[1],
		a = s[2],
		o = {
			initLayers: function() {
				this.layers = [];
				var t = this;
				this.$panel.find(".as-layer").each(function() {
					var i = new r(e(this));
					t.layers.push(i)
				}), this.index === this.accordion.getCurrentIndex() ? this._handleLayersInOpenedState() : this._handleLayersInClosedState(), this.accordion.on("panelOpen.Layers." + this.panelNS, function(e) {
					e.index !== e.previousIndex && (t.index === e.previousIndex && t._handleLayersInClosedState(), t.index === e.index && t._handleLayersInOpenedState())
				}), this.accordion.on("panelsClose.Layers." + this.panelNS, function(e) {
					t.index === e.previousIndex && t._handleLayersInClosedState()
				})
			},
			_handleLayersInOpenedState: function() {
				e.each(this.layers, function(t, e) {
					"opened" === e.visibleOn && e.show(), "closed" === e.visibleOn && e.hide()
				})
			},
			_handleLayersInClosedState: function() {
				e.each(this.layers, function(t, e) {
					"opened" === e.visibleOn && e.hide(), "closed" === e.visibleOn && e.show()
				})
			},
			destroyLayers: function() {
				this.accordion.off("panelOpen.Layers." + this.panelNS), this.accordion.off("panelsClose.Layers." + this.panelNS), e.each(this.layers, function(t, e) {
					e.destroy()
				})
			}
		},
		r = function(t) {
			this.$layer = t, this.visibleOn = "n/a", this.isVisible = !1, this.styled = !1, this._init()
		};
	r.prototype = {
		_init: function() {
			this.$layer.css({
				visibility: "hidden",
				display: "none"
			}), this.$layer.hasClass("as-opened") ? this.visibleOn = "opened" : this.$layer.hasClass("as-closed") ? this.visibleOn = "closed" : (this.visibleOn = "always", this.show())
		},
		_setStyle: function() {
			this.styled = !0, this.$layer.css({
				display: "",
				margin: 0
			}), this.data = this.$layer.data(), void 0 !== this.data.width && this.$layer.css("width", this.data.width), void 0 !== this.data.height && this.$layer.css("height", this.data.height), void 0 !== this.data.depth && this.$layer.css("z-index", this.data.depth), this.position = this.data.position ? this.data.position.toLowerCase() : "topleft", this.horizontalPosition = -1 !== this.position.indexOf("right") ? "right" : "left", this.verticalPosition = -1 !== this.position.indexOf("bottom") ? "bottom" : "top", this._setPosition()
		},
		_setPosition: function() {
			void 0 !== this.data.horizontal ? "center" === this.data.horizontal ? (-1 === this.$layer.attr("style").indexOf("width") && !1 === this.$layer.is("img") && (this.$layer.css("white-space", "nowrap"), this.$layer.css("width", this.$layer.outerWidth(!0))), this.$layer.css({
				marginLeft: "auto",
				marginRight: "auto",
				left: 0,
				right: 0
			})) : this.$layer.css(this.horizontalPosition, this.data.horizontal) : this.$layer.css(this.horizontalPosition, 0), void 0 !== this.data.vertical ? "center" === this.data.vertical ? (-1 === this.$layer.attr("style").indexOf("height") && !1 === this.$layer.is("img") && (this.$layer.css("white-space", "nowrap"), this.$layer.css("height", this.$layer.outerHeight(!0))), this.$layer.css({
				marginTop: "auto",
				marginBottom: "auto",
				top: 0,
				bottom: 0
			})) : this.$layer.css(this.verticalPosition, this.data.vertical) : this.$layer.css(this.verticalPosition, 0)
		},
		show: function() {
			if (!0 !== this.isVisible) {
				this.isVisible = !0, !1 === this.styled && this._setStyle();
				var t = this,
					i = void 0 !== this.data.showOffset ? this.data.showOffset : 50,
					s = void 0 !== this.data.showDuration ? this.data.showDuration / 1e3 : .4,
					o = void 0 !== this.data.showDelay ? this.data.showDelay : 10;
				if ("always" === this.visibleOn || "msie" === n && parseInt(a, 10) <= 7) this.$layer.css("visibility", "visible");
				else if ("msie" === n && parseInt(a, 10) <= 9) this.$layer.stop().delay(o).css({
					opacity: 0,
					visibility: "visible"
				}).animate({
					opacity: 1
				}, 1e3 * s);
				else {
					var r = {
							opacity: 0,
							visibility: "visible"
						},
						d = "";
					"left" === this.data.showTransition ? d = i + "px, 0" : "right" === this.data.showTransition ? d = "-" + i + "px, 0" : "up" === this.data.showTransition ? d = "0, " + i + "px" : "down" === this.data.showTransition && (d = "0, -" + i + "px"), r.transform = "3d" === l.useTransforms() ? "translate3d(" + d + ", 0)" : "translate(" + d + ")", r["-webkit-transform"] = r["-ms-transform"] = r.transform;
					var c = {
						opacity: 1,
						transition: "all " + s + "s"
					};
					void 0 !== this.data.showTransition && (c.transform = "3d" === l.useTransforms() ? "translate3d(0, 0, 0)" : "translate(0, 0)", c["-webkit-transform"] = c["-ms-transform"] = c.transform), this.$layer.on("transitionend webkitTransitionEnd oTransitionEnd msTransitionEnd", function() {
						t.$layer.off("transitionend webkitTransitionEnd oTransitionEnd msTransitionEnd"), t.$layer.css("transition", "")
					}), this.$layer.css(r).delay(o).queue(function() {
						t.$layer.css(c), e(this).dequeue()
					})
				}
			}
		},
		hide: function() {
			if (!1 !== this.isVisible) {
				this.isVisible = !1;
				var t = this,
					i = void 0 !== this.data.hideOffset ? this.data.hideOffset : 50,
					s = void 0 !== this.data.hideDuration ? this.data.hideDuration / 1e3 : .4,
					o = void 0 !== this.data.hideDelay ? this.data.hideDelay : 10;
				if ("always" === this.visibleOn || "msie" === n && parseInt(a, 10) <= 7) this.$layer.css("visibility", "hidden");
				else if ("msie" === n && parseInt(a, 10) <= 9) this.$layer.stop().delay(o).animate({
					opacity: 0
				}, 1e3 * s, function() {
					e(this).css({
						visibility: "hidden"
					})
				});
				else {
					var r = {
							opacity: 0,
							transition: "all " + s + "s"
						},
						d = "";
					"left" === this.data.hideTransition ? d = "-" + i + "px, 0" : "right" === this.data.hideTransition ? d = i + "px, 0" : "up" === this.data.hideTransition ? d = "0, -" + i + "px" : "down" === this.data.hideTransition && (d = "0, " + i + "px"), r.transform = "3d" === l.useTransforms() ? "translate3d(" + d + ", 0)" : "translate(" + d + ")", r["-webkit-transform"] = r["-ms-transform"] = r.transform, this.$layer.on("transitionend webkitTransitionEnd oTransitionEnd msTransitionEnd", function() {
						t.$layer.off("transitionend webkitTransitionEnd oTransitionEnd msTransitionEnd"), t.$layer.css("transition", ""), !1 === t.isVisible && t.$layer.css("visibility", "hidden")
					}), this.$layer.delay(o).queue(function() {
						t.$layer.css(r), e(this).dequeue()
					})
				}
			}
		},
		destroy: function() {
			this.$layer.attr("style", "")
		}
	}, e.AccordionSlider.addModule("Layers", o, "panel");
	var l = {
		checked: !1,
		transforms: "",
		useTransforms: function() {
			if (!0 === this.checked) return this.transforms;
			this.checked = !0;
			var t = document.createElement("div");
			if ((void 0 !== t.style.WebkitPerspective || void 0 !== t.style.perspective) && (this.transforms = "3d"), "3d" === this.transforms && void 0 !== t.styleWebkitPerspective) {
				var e = document.createElement("style");
				e.textContent = "@media (transform-3d),(-webkit-transform-3d){#test-3d{left:9px;position:absolute;height:5px;margin:0;padding:0;border:0;}}", document.getElementsByTagName("head")[0].appendChild(e), t.id = "test-3d", document.body.appendChild(t), (9 !== t.offsetLeft || 5 !== t.offsetHeight) && (this.transforms = ""), e.parentNode.removeChild(e), t.parentNode.removeChild(t)
			}
			return "" !== this.transforms || void 0 === t.style["-webkit-transform"] && void 0 === t.style.transform || (this.transforms = "2d"), this.transforms
		}
	}
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace,
		s = {
			initLazyLoading: function() {
				this.on("update.LazyLoading." + i, e.proxy(this._checkImages, this)), this.on("pageScroll.LazyLoading." + i, e.proxy(this._checkImages, this))
			},
			_checkImages: function() {
				var t = this,
					i = this._getFirstPanelFromPage(),
					s = this._getLastPanelFromPage(),
					n = s !== this.getTotalPanels() - 1 ? this.panels.slice(i, s + 1) : this.panels.slice(i);
				e.each(n, function(i, s) {
					var n = s.$panel;
					void 0 === n.attr("data-loaded") && (n.attr("data-loaded", !0), n.find("img").each(function() {
						var i = e(this);
						t._loadImage(i, s)
					}))
				})
			},
			_loadImage: function(t) {
				if (void 0 !== t.attr("data-src")) {
					var i = e(new Image);
					i.attr("class", t.attr("class")), i.attr("style", t.attr("style")), e.each(t.data(), function(t, e) {
						i.attr("data-" + t, e)
					}), void 0 !== t.attr("width") && i.attr("width", t.attr("width")), void 0 !== t.attr("height") && i.attr("height", t.attr("height")), void 0 !== t.attr("alt") && i.attr("alt", t.attr("alt")), void 0 !== t.attr("title") && i.attr("title", t.attr("title")), i.attr("src", t.attr("data-src")), i.removeAttr("data-src"), i.insertAfter(t), t.remove()
				}
			},
			destroyLazyLoading: function() {
				this.off("update.LazyLoading." + i), this.off("pageScroll.LazyLoading." + i)
			}
		};
	e.AccordionSlider.addModule("LazyLoading", s, "accordion")
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace,
		s = {
			mouseWheelEventType: "",
			allowMouseWheelScroll: !0,
			initMouseWheel: function() {
				var t = this;
				!1 !== this.settings.mouseWheel && ("onwheel" in document ? this.mouseWheelEventType = "wheel" : "onmousewheel" in document ? this.mouseWheelEventType = "mousewheel" : "onDomMouseScroll" in document ? this.mouseWheelEventType = "DomMouseScroll" : "onMozMousePixelScroll" in document && (this.mouseWheelEventType = "MozMousePixelScroll"), this.on(this.mouseWheelEventType + "." + i, function(e) {
					e.preventDefault();
					var i, s = e.originalEvent;
					void 0 !== s.detail && (i = s.detail), void 0 !== s.wheelDelta && (i = s.wheelDelta), void 0 !== s.deltaY && (i = -1 * s.deltaY), !0 === t.allowMouseWheelScroll && Math.abs(i) >= t.settings.mouseWheelSensitivity && (t.allowMouseWheelScroll = !1, setTimeout(function() {
						t.allowMouseWheelScroll = !0
					}, 500), i <= -t.settings.mouseWheelSensitivity ? "page" === t.settings.mouseWheelTarget ? t.nextPage() : t.nextPanel() : i >= t.settings.mouseWheelSensitivity && ("page" === t.settings.mouseWheelTarget ? t.previousPage() : t.previousPanel()))
				}))
			},
			destroyMouseWheel: function() {
				this.off(this.mouseWheelEventType + "." + i)
			},
			mouseWheelDefaults: {
				mouseWheel: !0,
				mouseWheelSensitivity: 10,
				mouseWheelTarget: "panel"
			}
		};
	e.AccordionSlider.addModule("MouseWheel", s, "accordion")
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace,
		s = {
			initRetina: function() {
				!1 !== this._isRetina() && (void 0 !== this._loadImage ? this._loadImage = this._loadRetinaImage : this.on("update.Retina." + i, e.proxy(this._checkRetinaImages, this)))
			},
			_isRetina: function() {
				return t.devicePixelRatio >= 2 || !(!t.matchMedia || !t.matchMedia("(-webkit-min-device-pixel-ratio: 2),(min-resolution: 2dppx)").matches)
			},
			_checkRetinaImages: function() {
				var t = this;
				this.off("update.Retina." + i), e.each(this.panels, function(i, s) {
					var n = s.$panel;
					void 0 === n.attr("data-loaded") && (n.attr("data-loaded", !0), n.find("img").each(function() {
						var i = e(this);
						t._loadRetinaImage(i, s)
					}))
				})
			},
			_loadRetinaImage: function(t) {
				var i = !1,
					s = "";
				if (void 0 !== t.attr("data-retina") && (i = !0, s = t.attr("data-retina"), t.removeAttr("data-retina")), void 0 !== t.attr("data-src") && (!1 === i && (s = t.attr("data-src")), t.removeAttr("data-src")), "" !== s) {
					var n = e(new Image);
					n.attr("class", t.attr("class")), n.attr("style", t.attr("style")), e.each(t.data(), function(t, e) {
						n.attr("data-" + t, e)
					}), void 0 !== t.attr("width") && n.attr("width", t.attr("width")), void 0 !== t.attr("height") && n.attr("height", t.attr("height")), void 0 !== t.attr("alt") && n.attr("alt", t.attr("alt")), void 0 !== t.attr("title") && n.attr("title", t.attr("title")), n.attr("src", s), n.insertAfter(t), t.remove()
				}
			},
			destroyRetina: function() {}
		};
	e.AccordionSlider.addModule("Retina", s, "accordion")
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace;
	t.navigator.userAgent.toLowerCase();
	var s = {
		initSmartVideo: function() {
			this._setupVideos()
		},
		_setupVideos: function() {
			var t = this;
			this.$accordion.find(".as-video").each(function() {
				var i = e(this);
				i.videoController(), i.on("videoPlay.SmartVideo", function() {
					"stopAutoplay" === t.settings.playVideoAction && void 0 !== t.stopAutoplay && (t.stopAutoplay(), t.settings.autoplay = !1);
					var s = {
						type: "videoPlay",
						video: i
					};
					t.trigger(s), e.isFunction(t.settings.videoPlay) && t.settings.videoPlay.call(t, s)
				}), i.on("videoPause.SmartVideo", function() {
					"startAutoplay" === t.settings.pauseVideoAction && void 0 !== t.startAutoplay && (t.startAutoplay(), t.settings.autoplay = !0);
					var s = {
						type: "videoPause",
						video: i
					};
					t.trigger(s), e.isFunction(t.settings.videoPause) && t.settings.videoPause.call(t, s)
				}), i.on("videoEnded.SmartVideo", function() {
					"startAutoplay" === t.settings.endVideoAction && void 0 !== t.startAutoplay ? (t.startAutoplay(), t.settings.autoplay = !0) : "nextPanel" === t.settings.endVideoAction ? t.nextPanel() : "replayVideo" === t.settings.endVideoAction && i.videoController("replay");
					var s = {
						type: "videoEnd",
						video: i
					};
					t.trigger(s), e.isFunction(t.settings.videoEnd) && t.settings.videoEnd.call(t, s)
				})
			}), this.on("panelOpen.SmartVideo." + i, function(e) {
				if (-1 !== e.previousIndex && 0 !== t.$panelsContainer.find(".as-panel").eq(e.previousIndex).find(".as-video").length) {
					var i = t.$panelsContainer.find(".as-panel").eq(e.previousIndex).find(".as-video");
					"stopVideo" === t.settings.closePanelVideoAction ? i.videoController("stop") : "pauseVideo" === t.settings.closePanelVideoAction && i.videoController("pause")
				}
				if (0 !== t.$panelsContainer.find(".as-panel").eq(e.index).find(".as-video").length) {
					var s = t.$panelsContainer.find(".as-panel").eq(e.index).find(".as-video");
					"playVideo" === t.settings.openPanelVideoAction && s.videoController("play")
				}
			}), this.on("panelsClose.SmartVideo." + i, function(e) {
				if (-1 !== e.previousIndex && 0 !== t.$panelsContainer.find(".as-panel").eq(e.previousIndex).find(".as-video").length) {
					var i = t.$panelsContainer.find(".as-panel").eq(e.previousIndex).find(".as-video");
					"stopVideo" === t.settings.closePanelVideoAction ? i.videoController("stop") : "pauseVideo" === t.settings.closePanelVideoAction && i.videoController("pause")
				}
			})
		},
		destroySmartVideo: function() {
			this.$accordion.find(".as-video").each(function() {
				e(this).off("SmartVideo"), e(this).videoController("destroy")
			}), this.off("panelOpen.SmartVideo." + i), this.off("panelsClose.SmartVideo." + i)
		},
		smartVideoDefaults: {
			openPanelVideoAction: "playVideo",
			closePanelVideoAction: "pauseVideo",
			playVideoAction: "stopAutoplay",
			pauseVideoAction: "none",
			endVideoAction: "none",
			videoPlay: function() {},
			videoPause: function() {},
			videoEnd: function() {}
		}
	};
	e.AccordionSlider.addModule("SmartVideo", s, "accordion")
}(window, jQuery),
function(t) {
	"use strict";
	var e = !!window.navigator.userAgent.match(/(iPad|iPhone|iPod)/g),
		i = function(e, i) {
			this.$video = t(e), this.options = i, this.settings = {}, this.player = null, this._init()
		};
	i.prototype = {
		_init: function() {
			this.settings = t.extend({}, this.defaults, this.options);
			var e = this,
				i = t.VideoController.players,
				s = this.$video.attr("id");
			for (var n in i)
				if (void 0 !== i[n] && i[n].isType(this.$video)) {
					this.player = new i[n](this.$video);
					break
				} if (null !== this.player) {
				t.each(["ready", "start", "play", "pause", "ended"], function(i, n) {
					var a = "video" + n.charAt(0).toUpperCase() + n.slice(1);
					e.player.on(n, function() {
						e.trigger({
							type: a,
							video: s
						}), t.isFunction(e.settings[a]) && e.settings[a].call(e, {
							type: a,
							video: s
						})
					})
				})
			}
		},
		play: function() {
			!0 === e && !1 === this.player.isStarted() || "playing" === this.player.getState() || this.player.play()
		},
		stop: function() {
			!0 === e && !1 === this.player.isStarted() || "stopped" === this.player.getState() || this.player.stop()
		},
		pause: function() {
			!0 === e && !1 === this.player.isStarted() || "paused" === this.player.getState() || this.player.pause()
		},
		replay: function() {
			(!0 !== e || !1 !== this.player.isStarted()) && this.player.replay()
		},
		on: function(t, e) {
			return this.$video.on(t, e)
		},
		off: function(t) {
			return this.$video.off(t)
		},
		trigger: function(t) {
			return this.$video.triggerHandler(t)
		},
		destroy: function() {
			!0 === this.player.isStarted() && this.stop(), this.player.off("ready"), this.player.off("start"), this.player.off("play"), this.player.off("pause"), this.player.off("ended"), this.$video.removeData("videoController")
		},
		defaults: {
			videoReady: function() {},
			videoStart: function() {},
			videoPlay: function() {},
			videoPause: function() {},
			videoEnded: function() {}
		}
	}, t.VideoController = {
		players: {},
		addPlayer: function(t, e) {
			this.players[t] = e
		}
	}, t.fn.videoController = function(e) {
		var s = Array.prototype.slice.call(arguments, 1);
		return this.each(function() {
			if (void 0 === t(this).data("videoController")) {
				var n = new i(this, e);
				t(this).data("videoController", n)
			} else if (void 0 !== e) {
				var a = t(this).data("videoController");
				"function" == typeof a[e] ? a[e].apply(a, s) : t.error(e + " does not exist in videoController.")
			}
		})
	};
	var s = function(e) {
		this.$video = e, this.player = null, this.ready = !1, this.started = !1, this.state = "", this.events = t({}), this._init()
	};
	s.prototype = {
		_init: function() {},
		play: function() {},
		pause: function() {},
		stop: function() {},
		replay: function() {},
		isType: function() {},
		isReady: function() {
			return this.ready
		},
		isStarted: function() {
			return this.started
		},
		getState: function() {
			return this.state
		},
		on: function(t, e) {
			return this.events.on(t, e)
		},
		off: function(t) {
			return this.events.off(t)
		},
		trigger: function(t) {
			return this.events.triggerHandler(t)
		}
	};
	var n = {
			youtubeAPIAdded: !1,
			youtubeVideos: []
		},
		a = function(e) {
			if (this.init = !1, void 0 !== (window.YT && window.YT.Player)) s.call(this, e);
			else if (n.youtubeVideos.push({
					video: e,
					scope: this
				}), !1 === n.youtubeAPIAdded) {
				n.youtubeAPIAdded = !0;
				var i = document.createElement("script");
				i.src = "http://www.youtube.com/player_api";
				var a = document.getElementsByTagName("script")[0];
				a.parentNode.insertBefore(i, a), window.onYouTubePlayerAPIReady = function() {
					t.each(n.youtubeVideos, function(t, e) {
						s.call(e.scope, e.video)
					})
				}
			}
		};
	(a.prototype = new s).constructor = a, t.VideoController.addPlayer("YoutubeVideo", a), a.isType = function(t) {
		if (t.is("iframe")) {
			var e = t.attr("src");
			if (-1 !== e.indexOf("youtube.com") || -1 !== e.indexOf("youtu.be")) return !0
		}
		return !1
	}, a.prototype._init = function() {
		this.init = !0, this._setup()
	}, a.prototype._setup = function() {
		var t = this;
		this.player = new YT.Player(this.$video[0], {
			events: {
				onReady: function() {
					t.trigger({
						type: "ready"
					}), t.ready = !0
				},
				onStateChange: function(e) {
					switch (e.data) {
						case YT.PlayerState.PLAYING:
							!1 === t.started && (t.started = !0, t.trigger({
								type: "start"
							})), t.state = "playing", t.trigger({
								type: "play"
							});
							break;
						case YT.PlayerState.PAUSED:
							t.state = "paused", t.trigger({
								type: "pause"
							});
							break;
						case YT.PlayerState.ENDED:
							t.state = "ended", t.trigger({
								type: "ended"
							})
					}
				}
			}
		})
	}, a.prototype.play = function() {
		var t = this;
		if (!0 === this.ready) this.player.playVideo();
		else var e = setInterval(function() {
			!0 === t.ready && (clearInterval(e), t.player.playVideo())
		}, 100)
	}, a.prototype.pause = function() {
		!0 === e ? this.stop() : this.player.pauseVideo()
	}, a.prototype.stop = function() {
		this.player.seekTo(1), this.player.stopVideo(), this.state = "stopped"
	}, a.prototype.replay = function() {
		this.player.seekTo(1), this.player.playVideo()
	}, a.prototype.on = function(t, e) {
		var i = this;
		if (!0 === this.init) s.prototype.on.call(this, t, e);
		else var n = setInterval(function() {
			!0 === i.init && (clearInterval(n), s.prototype.on.call(i, t, e))
		}, 100)
	};
	var o = {
			vimeoAPIAdded: !1,
			vimeoVideos: []
		},
		r = function(e) {
			if (this.init = !1, void 0 !== window.Froogaloop) s.call(this, e);
			else if (o.vimeoVideos.push({
					video: e,
					scope: this
				}), !1 === o.vimeoAPIAdded) {
				o.vimeoAPIAdded = !0;
				var i = document.createElement("script");
				i.src = "http://a.vimeocdn.com/js/froogaloop2.min.js";
				var n = document.getElementsByTagName("script")[0];
				n.parentNode.insertBefore(i, n);
				var a = setInterval(function() {
					void 0 !== window.Froogaloop && (clearInterval(a), t.each(o.vimeoVideos, function(t, e) {
						s.call(e.scope, e.video)
					}))
				}, 100)
			}
		};
	(r.prototype = new s).constructor = r, t.VideoController.addPlayer("VimeoVideo", r), r.isType = function(t) {
		if (t.is("iframe") && -1 !== t.attr("src").indexOf("vimeo.com")) return !0;
		return !1
	}, r.prototype._init = function() {
		this.init = !0, this._setup()
	}, r.prototype._setup = function() {
		var t = this;
		this.player = $f(this.$video[0]), this.player.addEvent("ready", function() {
			t.ready = !0, t.trigger({
				type: "ready"
			}), t.player.addEvent("play", function() {
				!1 === t.started && (t.started = !0, t.trigger({
					type: "start"
				})), t.state = "playing", t.trigger({
					type: "play"
				})
			}), t.player.addEvent("pause", function() {
				t.state = "paused", t.trigger({
					type: "pause"
				})
			}), t.player.addEvent("finish", function() {
				t.state = "ended", t.trigger({
					type: "ended"
				})
			})
		})
	}, r.prototype.play = function() {
		var t = this;
		if (!0 === this.ready) this.player.api("play");
		else var e = setInterval(function() {
			!0 === t.ready && (clearInterval(e), t.player.api("play"))
		}, 100)
	}, r.prototype.pause = function() {
		this.player.api("pause")
	}, r.prototype.stop = function() {
		this.player.api("seekTo", 0), this.player.api("pause"), this.state = "stopped"
	}, r.prototype.replay = function() {
		this.player.api("seekTo", 0), this.player.api("play")
	}, r.prototype.on = function(t, e) {
		var i = this;
		if (!0 === this.init) s.prototype.on.call(this, t, e);
		else var n = setInterval(function() {
			!0 === i.init && (clearInterval(n), s.prototype.on.call(i, t, e))
		}, 100)
	};
	var l = function(t) {
		s.call(this, t)
	};
	(l.prototype = new s).constructor = l, t.VideoController.addPlayer("HTML5Video", l), l.isType = function(t) {
		return !(!t.is("video") || !1 !== t.hasClass("video-js") || !1 !== t.hasClass("sublime"))
	}, l.prototype._init = function() {
		var t = this;
		this.player = this.$video[0], this.ready = !0, this.player.addEventListener("play", function() {
			!1 === t.started && (t.started = !0, t.trigger({
				type: "start"
			})), t.state = "playing", t.trigger({
				type: "play"
			})
		}), this.player.addEventListener("pause", function() {
			t.state = "paused", t.trigger({
				type: "pause"
			})
		}), this.player.addEventListener("ended", function() {
			t.state = "ended", t.trigger({
				type: "ended"
			})
		})
	}, l.prototype.play = function() {
		this.player.play()
	}, l.prototype.pause = function() {
		this.player.pause()
	}, l.prototype.stop = function() {
		this.player.currentTime = 0, this.player.pause(), this.state = "stopped"
	}, l.prototype.replay = function() {
		this.player.currentTime = 0, this.player.play()
	};
	var d = function(t) {
		s.call(this, t)
	};
	(d.prototype = new s).constructor = d, t.VideoController.addPlayer("VideoJSVideo", d), d.isType = function(t) {
		return !(void 0 === t.attr("data-videojs-id") && !t.hasClass("video-js") || "undefined" == typeof videojs)
	}, d.prototype._init = function() {
		var t = this,
			e = this.$video.hasClass("video-js") ? this.$video.attr("id") : this.$video.attr("data-videojs-id");
		this.player = videojs(e), this.player.ready(function() {
			t.ready = !0, t.trigger({
				type: "ready"
			}), t.player.on("play", function() {
				!1 === t.started && (t.started = !0, t.trigger({
					type: "start"
				})), t.state = "playing", t.trigger({
					type: "play"
				})
			}), t.player.on("pause", function() {
				t.state = "paused", t.trigger({
					type: "pause"
				})
			}), t.player.on("ended", function() {
				t.state = "ended", t.trigger({
					type: "ended"
				})
			})
		})
	}, d.prototype.play = function() {
		this.player.play()
	}, d.prototype.pause = function() {
		this.player.pause()
	}, d.prototype.stop = function() {
		this.player.currentTime(0), this.player.pause(), this.state = "stopped"
	}, d.prototype.replay = function() {
		this.player.currentTime(0), this.player.play()
	};
	var c = function(t) {
		s.call(this, t)
	};
	(c.prototype = new s).constructor = c, t.VideoController.addPlayer("SublimeVideo", c), c.isType = function(t) {
		return !(!t.hasClass("sublime") || "undefined" == typeof sublime)
	}, c.prototype._init = function() {
		var t = this;
		sublime.ready(function() {
			t.player = sublime.player(t.$video.attr("id")), t.ready = !0, t.trigger({
				type: "ready"
			}), t.player.on("play", function() {
				!1 === t.started && (t.started = !0, t.trigger({
					type: "start"
				})), t.state = "playing", t.trigger({
					type: "play"
				})
			}), t.player.on("pause", function() {
				t.state = "paused", t.trigger({
					type: "pause"
				})
			}), t.player.on("stop", function() {
				t.state = "stopped", t.trigger({
					type: "stop"
				})
			}), t.player.on("end", function() {
				t.state = "ended", t.trigger({
					type: "ended"
				})
			})
		})
	}, c.prototype.play = function() {
		this.player.play()
	}, c.prototype.pause = function() {
		this.player.pause()
	}, c.prototype.stop = function() {
		this.player.stop()
	}, c.prototype.replay = function() {
		this.player.stop(), this.player.play()
	};
	var h = function(t) {
		s.call(this, t)
	};
	(h.prototype = new s).constructor = h, t.VideoController.addPlayer("JWPlayerVideo", h), h.isType = function(t) {
		return !(void 0 === t.attr("data-jwplayer-id") && !t.hasClass("jwplayer") && 0 === t.find("object[data*='jwplayer']").length || "undefined" == typeof jwplayer)
	}, h.prototype._init = function() {
		var t, e = this;
		this.$video.hasClass("jwplayer") ? t = this.$video.attr("id") : void 0 !== this.$video.attr("data-jwplayer-id") ? t = this.$video.attr("data-jwplayer-id") : 0 !== this.$video.find("object[data*='jwplayer']").length && (t = this.$video.find("object").attr("id")), this.player = jwplayer(t), this.player.onReady(function() {
			e.ready = !0, e.trigger({
				type: "ready"
			}), e.player.onPlay(function() {
				!1 === e.started && (e.started = !0, e.trigger({
					type: "start"
				})), e.state = "playing", e.trigger({
					type: "play"
				})
			}), e.player.onPause(function() {
				e.state = "paused", e.trigger({
					type: "pause"
				})
			}), e.player.onComplete(function() {
				e.state = "ended", e.trigger({
					type: "ended"
				})
			})
		})
	}, h.prototype.play = function() {
		this.player.play(!0)
	}, h.prototype.pause = function() {
		this.player.pause(!0)
	}, h.prototype.stop = function() {
		this.player.stop(), this.state = "stopped"
	}, h.prototype.replay = function() {
		this.player.seek(0), this.player.play(!0)
	}
}(jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace,
		s = {
			cssTransitions: null,
			cssTransitionEndEvents: "transitionend webkitTransitionEnd oTransitionEnd msTransitionEnd",
			checkCSSTransitions: function() {
				if (null !== this.cssTransitions) return this.cssTransitions;
				var t = (document.body || document.documentElement).style;
				return this.cssTransitions = void 0 !== t.transition || void 0 !== t.WebkitTransition || void 0 !== t.MozTransition || void 0 !== t.OTransition, this.cssTransitions
			}
		},
		n = {
			initSwapBackground: function() {
				var t = this;
				this.on("panelOpen.SwapBackground." + i, function(e) {
					var i = t.getPanelAt(e.index),
						s = i.$panel.find(".as-background"),
						n = i.$panel.find(".as-background-opened");
					if (0 !== n.length && (n.css({
							visibility: "visible",
							opacity: 0
						}), t._fadeInBackground(n), 0 !== s.length && !0 === t.settings.fadeOutBackground && t._fadeOutBackground(s)), -1 !== e.previousIndex && e.index !== e.previousIndex) {
						var a = t.getPanelAt(e.previousIndex),
							o = a.$panel.find(".as-background"),
							r = a.$panel.find(".as-background-opened");
						0 !== r.length && (t._fadeOutBackground(r), 0 !== o.length && !0 === t.settings.fadeOutBackground && t._fadeInBackground(o))
					}
				}), this.on("panelsClose.SwapBackground." + i, function(e) {
					if (-1 !== e.previousIndex) {
						var i = t.getPanelAt(e.previousIndex),
							s = i.$panel.find(".as-background"),
							n = i.$panel.find(".as-background-opened");
						0 !== n.length && (t._fadeOutBackground(n), 0 !== s.length && !0 === t.settings.fadeOutBackground && t._fadeInBackground(s))
					}
				})
			},
			_fadeInBackground: function(t) {
				var e = this.settings.swapBackgroundDuration;
				t.css({
					visibility: "visible"
				}), !0 === s.checkCSSTransitions() ? (t.off(s.cssTransitionEndEvents).on(s.cssTransitionEndEvents, function(e) {
					e.target === e.currentTarget && (t.off(s.cssTransitionEndEvents), t.css({
						transition: ""
					}))
				}), setTimeout(function() {
					t.css({
						opacity: 1,
						transition: "all " + e / 1e3 + "s"
					})
				}, 100)) : t.stop().animate({
					opacity: 1
				}, e)
			},
			_fadeOutBackground: function(t) {
				var e = this.settings.swapBackgroundDuration;
				!0 === s.checkCSSTransitions() ? (t.off(s.cssTransitionEndEvents).on(s.cssTransitionEndEvents, function(e) {
					e.target === e.currentTarget && (t.off(s.cssTransitionEndEvents), t.css({
						visibility: "hidden",
						transition: ""
					}))
				}), setTimeout(function() {
					t.css({
						opacity: 0,
						transition: "all " + e / 1e3 + "s"
					})
				}, 100)) : t.stop().animate({
					opacity: 0
				}, e, function() {
					t.css({
						visibility: "hidden"
					})
				})
			},
			destroySwapBackground: function() {
				this.off("panelOpen.SwapBackground." + i), this.off("panelsClose.SwapBackground." + i)
			},
			swapBackgroundDefaults: {
				swapBackgroundDuration: 700,
				fadeOutBackground: !1
			}
		};
	e.AccordionSlider.addModule("SwapBackground", n, "accordion")
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace,
		s = {
			touchStartPoint: {
				x: 0,
				y: 0
			},
			touchEndPoint: {
				x: 0,
				y: 0
			},
			touchDistance: {
				x: 0,
				y: 0
			},
			touchStartPosition: 0,
			isTouchMoving: !1,
			touchSwipeEvents: {
				startEvent: "",
				moveEvent: "",
				endEvent: ""
			},
			initTouchSwipe: function() {
				var t = this;
				!1 !== this.settings.touchSwipe && (this.touchSwipeEvents.startEvent = "touchstart." + i + " mousedown." + i, this.touchSwipeEvents.moveEvent = "touchmove." + i + " mousemove." + i, this.touchSwipeEvents.endEvent = "touchend." + this.uniqueId + "." + i + " mouseup." + this.uniqueId + "." + i, this.$panelsContainer.on(this.touchSwipeEvents.startEvent, e.proxy(this._onTouchStart, this)), this.on("update.TouchSwipe." + i, function() {
					t.getTotalPages() > 1 ? t.$panelsContainer.addClass("as-grab") : t.$panelsContainer.removeClass("as-grab")
				}))
			},
			_onTouchStart: function(t) {
				var i = void 0 !== t.originalEvent.touches ? t.originalEvent.touches[0] : t.originalEvent;
				e(t.target).closest(".as-selectable").length >= 1 || void 0 === t.originalEvent.touches && 1 === this.getTotalPages() || (void 0 === t.originalEvent.touches && t.preventDefault(), this.touchStartPoint.x = i.pageX || i.clientX, this.touchStartPoint.y = i.pageY || i.clientY, this.touchStartPosition = parseInt(this.$panelsContainer.css(this.positionProperty), 10), this.touchDistance.x = this.touchDistance.y = 0, this.$panelsContainer.on(this.touchSwipeEvents.moveEvent, e.proxy(this._onTouchMove, this)), e(document).on(this.touchSwipeEvents.endEvent, e.proxy(this._onTouchEnd, this)), this.$panelsContainer.removeClass("as-grab").addClass("as-grabbing"), e(t.target).parents(".as-panel").find("a").one("click.TouchSwipe", function(t) {
					t.preventDefault()
				}), this.$accordion.addClass("as-swiping"))
			},
			_onTouchMove: function(t) {
				var e = void 0 !== t.originalEvent.touches ? t.originalEvent.touches[0] : t.originalEvent;
				this.isTouchMoving = !0, this.touchEndPoint.x = e.pageX || e.clientX, this.touchEndPoint.y = e.pageY || e.clientY, this.touchDistance.x = this.touchEndPoint.x - this.touchStartPoint.x, this.touchDistance.y = this.touchEndPoint.y - this.touchStartPoint.y;
				var i = "horizontal" === this.settings.orientation ? this.touchDistance.x : this.touchDistance.y,
					s = "horizontal" === this.settings.orientation ? this.touchDistance.y : this.touchDistance.x;
				if (Math.abs(i) > Math.abs(s)) {
					t.preventDefault();
					var n = parseInt(this.$panelsContainer.css(this.positionProperty), 10);
					(n >= 0 && 0 === this.currentPage || n <= -this.totalPanelsSize + this.totalSize && this.currentPage === this.getTotalPages() - 1) && (i *= .2), this.$panelsContainer.css(this.positionProperty, this.touchStartPosition + i)
				}
			},
			_onTouchEnd: function(t) {
				var i = this;
				if (this.$panelsContainer.off(this.touchSwipeEvents.moveEvent), e(document).off(this.touchSwipeEvents.endEvent), this.$panelsContainer.removeClass("as-grabbing").addClass("as-grab"), void 0 !== t.originalEvent.touches && (!1 === this.isTouchMoving || !0 === this.isTouchMoving && Math.abs(this.touchDistance.x) < 10 && Math.abs(this.touchDistance.y) < 10)) {
					var s = e(t.target).parents(".as-panel").index();
					s !== this.currentIndex && -1 !== s ? (t.preventDefault(), this.openPanel(s)) : (e(t.target).parents(".as-panel").find("a").off("click.TouchSwipe"), this.$accordion.removeClass("as-swiping"))
				} else {
					if (!1 === this.isTouchMoving) return e(t.target).parents(".as-panel").find("a").off("click.TouchSwipe"), void this.$accordion.removeClass("as-swiping");
					e(t.target).parents(".as-panel").one("click", function(t) {
						t.preventDefault()
					}), this.isTouchMoving = !1, setTimeout(function() {
						i.$accordion.removeClass("as-swiping")
					}, 1);
					var n = {};
					n[this.positionProperty] = this.touchStartPosition, "horizontal" === this.settings.orientation ? this.touchDistance.x > this.settings.touchSwipeThreshold ? this.currentPage > 0 ? this.previousPage() : this.$panelsContainer.stop().animate(n, 300) : -this.touchDistance.x > this.settings.touchSwipeThreshold ? this.currentPage < this.getTotalPages() - 1 ? this.nextPage() : this.gotoPage(this.currentPage) : Math.abs(this.touchDistance.x) < this.settings.touchSwipeThreshold && this.$panelsContainer.stop().animate(n, 300) : "vertical" === this.settings.orientation && (this.touchDistance.y > this.settings.touchSwipeThreshold ? this.currentPage > 0 ? this.previousPage() : this.$panelsContainer.stop().animate(n, 300) : -this.touchDistance.y > this.settings.touchSwipeThreshold ? this.currentPage < this.getTotalPages() - 1 ? this.nextPage() : this.$panelsContainer.animate(n, 300) : Math.abs(this.touchDistance.y) < this.settings.touchSwipeThreshold && this.$panelsContainer.stop().animate(n, 300))
				}
			},
			destroyTouchSwipe: function() {
				this.$panelsContainer.off(this.touchSwipeEvents.startEvent), e(document).off(this.touchSwipeEvents.endEvent), this.$panelsContainer.off(this.touchSwipeEvents.moveEvent), this.off("update.TouchSwipe." + i)
			},
			touchSwipeDefaults: {
				touchSwipe: !0,
				touchSwipeThreshold: 50
			}
		};
	e.AccordionSlider.addModule("TouchSwipe", s, "accordion")
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace,
		s = t.navigator.userAgent.toLowerCase(),
		n = (/(msie) ([\w.]+)/.exec(s) || [])[1],
		a = {
			XMLDataAttributesMap: {
				width: "data-width",
				height: "data-height",
				depth: "data-depth",
				position: "data-position",
				horizontal: "data-horizontal",
				vertical: "data-vertical",
				showTransition: "data-show-transition",
				showOffset: "data-show-offset",
				showDelay: "data-show-delay",
				showDuration: "data-show-duration",
				showEasing: "data-show-easing",
				hideTransition: "data-hide-transition",
				hideOffset: "data-",
				hideDelay: "data-hide-delay",
				hideDuration: "data-hide-duration",
				hideEasing: "data-hide-easing"
			},
			initXML: function() {
				null !== this.settings.XMLSource && this.updateXML()
			},
			updateXML: function() {
				var t = this;
				this.removePanels(), this.$panelsContainer.empty(), this.off("XMLReady." + i), this.on("XMLReady." + i, function(i) {
					var s = e(i.xmlData),
						n = s.find("accordion")[0].attributes.lazyLoading;
					void 0 !== n && (n = n.nodeValue), s.find("panel").each(function() {
						var i, s, a = e(this),
							o = a.find("background"),
							r = a.find("backgroundRetina"),
							l = a.find("backgroundLink"),
							d = a.find("backgroundOpened"),
							c = a.find("backgroundOpenedRetina"),
							h = a.find("backgroundOpenedLink"),
							u = a.find("layer"),
							p = e('<div class="as-panel"></div>').appendTo(t.$panelsContainer);
						if (l.length >= 1 && (i = e('<a href="' + l.text() + '"></a>'), e.each(l[0].attributes, function(t, e) {
								i.attr(e.nodeName, e.nodeValue)
							}), i.appendTo(p)), o.length >= 1) {
							var f = e('<img class="as-background"/>');
							void 0 !== n ? f.attr({
								src: n,
								"data-src": o.text()
							}) : f.attr({
								src: o.text()
							}), r.length >= 1 && f.attr({
								"data-retina": r.text()
							}), e.each(o[0].attributes, function(t, e) {
								f.attr(e.nodeName, e.nodeValue)
							}), f.appendTo(l.length ? i : p)
						}
						if (h.length >= 1 && (s = e('<a href="' + h.text() + '"></a>'), e.each(h[0].attributes, function(t, e) {
								s.attr(e.nodeName, e.nodeValue)
							}), s.appendTo(p)), d.length >= 1) {
							var m = e('<img class="as-background-opened"/>');
							void 0 !== n ? m.attr({
								src: n,
								"data-src": d.text()
							}) : m.attr({
								src: d.text()
							}), c.length >= 1 && m.attr({
								"data-retina": c.text()
							}), e.each(d[0].attributes, function(t, e) {
								m.attr(e.nodeName, e.nodeValue)
							}), m.appendTo(h.length ? s : p)
						}
						u.length >= 1 && e.each(u, function() {
							var i = e(this),
								s = "",
								n = "",
								a = p;
							e.each(i[0].attributes, function(i, a) {
								if ("style" === a.nodeName) {
									var o = a.nodeValue.split(" ");
									e.each(o, function(t, e) {
										s += " as-" + e
									})
								} else n += " " + t.XMLDataAttributesMap[a.nodeName] + '="' + a.nodeValue + '"'
							});
							var o = e('<div class="as-layer' + s + '"' + n + '"></div>');
							if (i.find("layer").length >= 1) {
								var r = (new Date).valueOf();
								i.attr("parentID", r), o.attr("class", o.attr("class") + " " + r)
							} else o.html(i.text());
							i.parent().is("layer") && (a = p.find("." + i.parent().attr("parentID"))), o.appendTo(a)
						})
					}), t.update()
				}), this._loadXML()
			},
			_loadXML: function() {
				var t = this;
				if (".xml" === this.settings.XMLSource.slice(-4)) e.ajax({
					type: "GET",
					url: this.settings.XMLSource,
					dataType: "msie" === n ? "text" : "xml",
					success: function(e) {
						var s;
						"msie" === n ? ((s = new ActiveXObject("Microsoft.XMLDOM")).async = !1, s.loadXML(e)) : s = e, t.trigger({
							type: "XMLReady." + i,
							xmlData: s
						})
					}
				});
				else {
					var s = e.parseXML(this.settings.XMLSource);
					t.trigger({
						type: "XMLReady." + i,
						xmlData: s
					})
				}
			},
			destroyXML: function() {
				this.off("XMLReady." + i)
			},
			XMLDefaults: {
				XMLSource: null
			}
		};
	e.AccordionSlider.addModule("XML", a, "accordion")
}(window, jQuery),
function(t, e) {
	"function" == typeof define && define.amd ? define(e) : "object" == typeof exports ? module.exports = e() : t.transformicons = e()
}(this || window, function() {
	"use strict";
	var t = {},
		e = {
			transform: ["click"],
			revert: ["click"]
		},
		i = function(t) {
			return "string" == typeof t ? Array.prototype.slice.call(document.querySelectorAll(t)) : void 0 === t || t instanceof Array ? t : [t]
		},
		s = function(t) {
			return "string" == typeof t ? t.toLowerCase().split(" ") : t
		},
		n = function(t, n, o) {
			var r = (o ? "remove" : "add") + "EventListener",
				l = i(t),
				d = l.length,
				c = {};
			for (var h in e) c[h] = n && n[h] ? s(n[h]) : e[h];
			for (; d--;)
				for (var u in c)
					for (var p = c[u].length; p--;) l[d][r](c[u][p], a)
		},
		a = function(e) {
			t.toggle(e.currentTarget)
		};
	return t.add = function(e, i) {
		return n(e, i), t
	}, t.remove = function(e, i) {
		return n(e, i, !0), t
	}, t.transform = function(e) {
		return i(e).forEach(function(t) {
			t.classList.add("tcon-transform")
		}), t
	}, t.revert = function(e) {
		return i(e).forEach(function(t) {
			t.classList.remove("tcon-transform")
		}), t
	}, t.toggle = function(e) {
		return i(e).forEach(function(e) {
			t[e.classList.contains("tcon-transform") ? "revert" : "transform"](e)
		}), t
	}, t
}),
function(t) {
	"function" == typeof define && define.amd ? define(["jquery"], t) : "object" == typeof exports ? t(require("jquery")) : t(window.jQuery || window.Zepto)
}(function(t) {
	var e, i, s, n, a, o, r = function() {},
		l = !!window.jQuery,
		d = t(window),
		c = function(t, i) {
			e.ev.on("mfp" + t + ".mfp", i)
		},
		h = function(e, i, s, n) {
			var a = document.createElement("div");
			return a.className = "mfp-" + e, s && (a.innerHTML = s), n ? i && i.appendChild(a) : (a = t(a), i && a.appendTo(i)), a
		},
		u = function(i, s) {
			e.ev.triggerHandler("mfp" + i, s), e.st.callbacks && (i = i.charAt(0).toLowerCase() + i.slice(1), e.st.callbacks[i] && e.st.callbacks[i].apply(e, t.isArray(s) ? s : [s]))
		},
		p = function(i) {
			return i === o && e.currTemplate.closeBtn || (e.currTemplate.closeBtn = t(e.st.closeMarkup.replace("%title%", e.st.tClose)), o = i), e.currTemplate.closeBtn
		},
		f = function() {
			t.magnificPopup.instance || ((e = new r).init(), t.magnificPopup.instance = e)
		};
	r.prototype = {
		constructor: r,
		init: function() {
			var i = navigator.appVersion;
			e.isIE7 = -1 !== i.indexOf("MSIE 7."), e.isIE8 = -1 !== i.indexOf("MSIE 8."), e.isLowIE = e.isIE7 || e.isIE8, e.isAndroid = /android/gi.test(i), e.isIOS = /iphone|ipad|ipod/gi.test(i), e.supportsTransition = function() {
				var t = document.createElement("p").style,
					e = ["ms", "O", "Moz", "Webkit"];
				if (void 0 !== t.transition) return !0;
				for (; e.length;)
					if (e.pop() + "Transition" in t) return !0;
				return !1
			}(), e.probablyMobile = e.isAndroid || e.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), s = t(document), e.popupsCache = {}
		},
		open: function(i) {
			var n;
			if (!1 === i.isObj) {
				e.items = i.items.toArray(), e.index = 0;
				var o, r = i.items;
				for (n = 0; n < r.length; n++)
					if ((o = r[n]).parsed && (o = o.el[0]), o === i.el[0]) {
						e.index = n;
						break
					}
			} else e.items = t.isArray(i.items) ? i.items : [i.items], e.index = i.index || 0;
			if (!e.isOpen) {
				e.types = [], a = "", i.mainEl && i.mainEl.length ? e.ev = i.mainEl.eq(0) : e.ev = s, i.key ? (e.popupsCache[i.key] || (e.popupsCache[i.key] = {}), e.currTemplate = e.popupsCache[i.key]) : e.currTemplate = {}, e.st = t.extend(!0, {}, t.magnificPopup.defaults, i), e.fixedContentPos = "auto" === e.st.fixedContentPos ? !e.probablyMobile : e.st.fixedContentPos, e.st.modal && (e.st.closeOnContentClick = !1, e.st.closeOnBgClick = !1, e.st.showCloseBtn = !1, e.st.enableEscapeKey = !1), e.bgOverlay || (e.bgOverlay = h("bg").on("click.mfp", function() {
					e.close()
				}), e.wrap = h("wrap").attr("tabindex", -1).on("mousedown.mfp", function(t) {
					e._checkIfClose(t.target) && e.close()
				}), e.container = h("container", e.wrap)), e.contentContainer = h("content"), e.st.preloader && (e.preloader = h("preloader", e.container, e.st.tLoading));
				var l = t.magnificPopup.modules;
				for (n = 0; n < l.length; n++) {
					var f = l[n];
					f = f.charAt(0).toUpperCase() + f.slice(1), e["init" + f].call(e)
				}
				u("BeforeOpen"), e.st.showCloseBtn && (e.st.closeBtnInside ? (c("MarkupParse", function(t, e, i, s) {
					i.close_replaceWith = p(s.type)
				}), a += " mfp-close-btn-in") : e.wrap.append(p())), e.st.alignTop && (a += " mfp-align-top"), e.fixedContentPos ? e.wrap.css({
					overflow: e.st.overflowY,
					overflowX: "hidden",
					overflowY: e.st.overflowY
				}) : e.wrap.css({
					top: d.scrollTop(),
					position: "absolute"
				}), (!1 === e.st.fixedBgPos || "auto" === e.st.fixedBgPos && !e.fixedContentPos) && e.bgOverlay.css({
					height: s.height(),
					position: "absolute"
				}), e.st.enableEscapeKey && s.on("keyup.mfp", function(t) {
					27 === t.keyCode && e.close()
				}), d.on("resize.mfp", function() {
					e.updateSize()
				}), e.st.closeOnContentClick || (a += " mfp-auto-cursor"), a && e.wrap.addClass(a);
				var m = e.wH = d.height(),
					g = {};
				if (e.fixedContentPos && e._hasScrollBar(m)) {
					var v = e._getScrollbarSize();
					v && (g.marginRight = v)
				}
				e.fixedContentPos && (e.isIE7 ? t("body, html").css("overflow", "hidden") : g.overflow = "hidden");
				var y = e.st.mainClass;
				return e.isIE7 && (y += " mfp-ie7"), y && e._addClassToMFP(y), e.updateItemHTML(), u("BuildControls"), t("html").css(g), e.bgOverlay.add(e.wrap).prependTo(e.st.prependTo || t(document.body)), e._lastFocusedEl = document.activeElement, setTimeout(function() {
					e.content ? (e._addClassToMFP("mfp-ready"), e._setFocus()) : e.bgOverlay.addClass("mfp-ready"), s.on("focusin.mfp", e._onFocusIn)
				}, 16), e.isOpen = !0, e.updateSize(m), u("Open"), i
			}
			e.updateItemHTML()
		},
		close: function() {
			e.isOpen && (u("BeforeClose"), e.isOpen = !1, e.st.removalDelay && !e.isLowIE && e.supportsTransition ? (e._addClassToMFP("mfp-removing"), setTimeout(function() {
				e._close()
			}, e.st.removalDelay)) : e._close())
		},
		_close: function() {
			u("Close");
			var i = "mfp-removing mfp-ready ";
			if (e.bgOverlay.detach(), e.wrap.detach(), e.container.empty(), e.st.mainClass && (i += e.st.mainClass + " "), e._removeClassFromMFP(i), e.fixedContentPos) {
				var n = {
					marginRight: ""
				};
				e.isIE7 ? t("body, html").css("overflow", "") : n.overflow = "", t("html").css(n)
			}
			s.off("keyup.mfp focusin.mfp"), e.ev.off(".mfp"), e.wrap.attr("class", "mfp-wrap").removeAttr("style"), e.bgOverlay.attr("class", "mfp-bg"), e.container.attr("class", "mfp-container"), !e.st.showCloseBtn || e.st.closeBtnInside && !0 !== e.currTemplate[e.currItem.type] || e.currTemplate.closeBtn && e.currTemplate.closeBtn.detach(), e._lastFocusedEl && t(e._lastFocusedEl).focus(), e.currItem = null, e.content = null, e.currTemplate = null, e.prevHeight = 0, u("AfterClose")
		},
		updateSize: function(t) {
			if (e.isIOS) {
				var i = document.documentElement.clientWidth / window.innerWidth,
					s = window.innerHeight * i;
				e.wrap.css("height", s), e.wH = s
			} else e.wH = t || d.height();
			e.fixedContentPos || e.wrap.css("height", e.wH), u("Resize")
		},
		updateItemHTML: function() {
			var i = e.items[e.index];
			e.contentContainer.detach(), e.content && e.content.detach(), i.parsed || (i = e.parseEl(e.index));
			var s = i.type;
			if (u("BeforeChange", [e.currItem ? e.currItem.type : "", s]), e.currItem = i, !e.currTemplate[s]) {
				var a = !!e.st[s] && e.st[s].markup;
				u("FirstMarkupParse", a), e.currTemplate[s] = !a || t(a)
			}
			n && n !== i.type && e.container.removeClass("mfp-" + n + "-holder");
			var o = e["get" + s.charAt(0).toUpperCase() + s.slice(1)](i, e.currTemplate[s]);
			e.appendContent(o, s), i.preloaded = !0, u("Change", i), n = i.type, e.container.prepend(e.contentContainer), u("AfterChange")
		},
		appendContent: function(t, i) {
			e.content = t, t ? e.st.showCloseBtn && e.st.closeBtnInside && !0 === e.currTemplate[i] ? e.content.find(".mfp-close").length || e.content.append(p()) : e.content = t : e.content = "", u("BeforeAppend"), e.container.addClass("mfp-" + i + "-holder"), e.contentContainer.append(e.content)
		},
		parseEl: function(i) {
			var s, n = e.items[i];
			if (n.tagName ? n = {
					el: t(n)
				} : (s = n.type, n = {
					data: n,
					src: n.src
				}), n.el) {
				for (var a = e.types, o = 0; o < a.length; o++)
					if (n.el.hasClass("mfp-" + a[o])) {
						s = a[o];
						break
					} n.src = n.el.attr("data-mfp-src"), n.src || (n.src = n.el.attr("href"))
			}
			return n.type = s || e.st.type || "inline", n.index = i, n.parsed = !0, e.items[i] = n, u("ElementParse", n), e.items[i]
		},
		addGroup: function(t, i) {
			var s = function(s) {
				s.mfpEl = this, e._openClick(s, t, i)
			};
			i || (i = {});
			var n = "click.magnificPopup";
			i.mainEl = t, i.items ? (i.isObj = !0, t.off(n).on(n, s)) : (i.isObj = !1, i.delegate ? t.off(n).on(n, i.delegate, s) : (i.items = t, t.off(n).on(n, s)))
		},
		_openClick: function(i, s, n) {
			if ((void 0 !== n.midClick ? n.midClick : t.magnificPopup.defaults.midClick) || !(2 === i.which || i.ctrlKey || i.metaKey || i.altKey || i.shiftKey)) {
				var a = void 0 !== n.disableOn ? n.disableOn : t.magnificPopup.defaults.disableOn;
				if (a)
					if (t.isFunction(a)) {
						if (!a.call(e)) return !0
					} else if (d.width() < a) return !0;
				i.type && (i.preventDefault(), e.isOpen && i.stopPropagation()), n.el = t(i.mfpEl), n.delegate && (n.items = s.find(n.delegate)), e.open(n)
			}
		},
		updateStatus: function(t, s) {
			if (e.preloader) {
				i !== t && e.container.removeClass("mfp-s-" + i), s || "loading" !== t || (s = e.st.tLoading);
				var n = {
					status: t,
					text: s
				};
				u("UpdateStatus", n), t = n.status, s = n.text, e.preloader.html(s), e.preloader.find("a").on("click", function(t) {
					t.stopImmediatePropagation()
				}), e.container.addClass("mfp-s-" + t), i = t
			}
		},
		_checkIfClose: function(i) {
			if (!t(i).hasClass("mfp-prevent-close")) {
				var s = e.st.closeOnContentClick,
					n = e.st.closeOnBgClick;
				if (s && n) return !0;
				if (!e.content || t(i).hasClass("mfp-close") || e.preloader && i === e.preloader[0]) return !0;
				if (i === e.content[0] || t.contains(e.content[0], i)) {
					if (s) return !0
				} else if (n && t.contains(document, i)) return !0;
				return !1
			}
		},
		_addClassToMFP: function(t) {
			e.bgOverlay.addClass(t), e.wrap.addClass(t)
		},
		_removeClassFromMFP: function(t) {
			this.bgOverlay.removeClass(t), e.wrap.removeClass(t)
		},
		_hasScrollBar: function(t) {
			return (e.isIE7 ? s.height() : document.body.scrollHeight) > (t || d.height())
		},
		_setFocus: function() {
			(e.st.focus ? e.content.find(e.st.focus).eq(0) : e.wrap).focus()
		},
		_onFocusIn: function(i) {
			if (i.target !== e.wrap[0] && !t.contains(e.wrap[0], i.target)) return e._setFocus(), !1
		},
		_parseMarkup: function(e, i, s) {
			var n;
			s.data && (i = t.extend(s.data, i)), u("MarkupParse", [e, i, s]), t.each(i, function(t, i) {
				if (void 0 === i || !1 === i) return !0;
				if ((n = t.split("_")).length > 1) {
					var s = e.find(".mfp-" + n[0]);
					if (s.length > 0) {
						var a = n[1];
						"replaceWith" === a ? s[0] !== i[0] && s.replaceWith(i) : "img" === a ? s.is("img") ? s.attr("src", i) : s.replaceWith('<img src="' + i + '" class="' + s.attr("class") + '" />') : s.attr(n[1], i)
					}
				} else e.find(".mfp-" + t).html(i)
			})
		},
		_getScrollbarSize: function() {
			if (void 0 === e.scrollbarSize) {
				var t = document.createElement("div");
				t.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(t), e.scrollbarSize = t.offsetWidth - t.clientWidth, document.body.removeChild(t)
			}
			return e.scrollbarSize
		}
	}, t.magnificPopup = {
		instance: null,
		proto: r.prototype,
		modules: [],
		open: function(e, i) {
			return f(), (e = e ? t.extend(!0, {}, e) : {}).isObj = !0, e.index = i || 0, this.instance.open(e)
		},
		close: function() {
			return t.magnificPopup.instance && t.magnificPopup.instance.close()
		},
		registerModule: function(e, i) {
			i.options && (t.magnificPopup.defaults[e] = i.options), t.extend(this.proto, i.proto), this.modules.push(e)
		},
		defaults: {
			disableOn: 0,
			key: null,
			midClick: !1,
			mainClass: "",
			preloader: !0,
			focus: "",
			closeOnContentClick: !1,
			closeOnBgClick: !0,
			closeBtnInside: !0,
			showCloseBtn: !0,
			enableEscapeKey: !0,
			modal: !1,
			alignTop: !1,
			removalDelay: 0,
			prependTo: null,
			fixedContentPos: "auto",
			fixedBgPos: "auto",
			overflowY: "auto",
			closeMarkup: '<button title="%title%" type="button" class="mfp-close"></button>',
			tClose: "Close (Esc)",
			tLoading: "Loading..."
		}
	}, t.fn.magnificPopup = function(i) {
		f();
		var s = t(this);
		if ("string" == typeof i)
			if ("open" === i) {
				var n, a = l ? s.data("magnificPopup") : s[0].magnificPopup,
					o = parseInt(arguments[1], 10) || 0;
				a.items ? n = a.items[o] : (n = s, a.delegate && (n = n.find(a.delegate)), n = n.eq(o)), e._openClick({
					mfpEl: n
				}, s, a)
			} else e.isOpen && e[i].apply(e, Array.prototype.slice.call(arguments, 1));
		else i = t.extend(!0, {}, i), l ? s.data("magnificPopup", i) : s[0].magnificPopup = i, e.addGroup(s, i);
		return s
	};
	var m, g, v, y = function() {
		v && (g.after(v.addClass(m)).detach(), v = null)
	};
	t.magnificPopup.registerModule("inline", {
		options: {
			hiddenClass: "hide",
			markup: "",
			tNotFound: "Content not found"
		},
		proto: {
			initInline: function() {
				e.types.push("inline"), c("Close.inline", function() {
					y()
				})
			},
			getInline: function(i, s) {
				if (y(), i.src) {
					var n = e.st.inline,
						a = t(i.src);
					if (a.length) {
						var o = a[0].parentNode;
						o && o.tagName && (g || (m = n.hiddenClass, g = h(m), m = "mfp-" + m), v = a.after(g).detach().removeClass(m)), e.updateStatus("ready")
					} else e.updateStatus("error", n.tNotFound), a = t("<div>");
					return i.inlineElement = a, a
				}
				return e.updateStatus("ready"), e._parseMarkup(s, {}, i), s
			}
		}
	});
	var b, w = function() {
			b && t(document.body).removeClass(b)
		},
		S = function() {
			w(), e.req && e.req.abort()
		};
	t.magnificPopup.registerModule("ajax", {
		options: {
			settings: null,
			cursor: "mfp-ajax-cur",
			tError: '<a href="%url%">The content</a> could not be loaded.'
		},
		proto: {
			initAjax: function() {
				e.types.push("ajax"), b = e.st.ajax.cursor, c("Close.ajax", S), c("BeforeChange.ajax", S)
			},
			getAjax: function(i) {
				b && t(document.body).addClass(b), e.updateStatus("loading");
				var s = t.extend({
					url: i.src,
					success: function(s, n, a) {
						var o = {
							data: s,
							xhr: a
						};
						u("ParseAjax", o), e.appendContent(t(o.data), "ajax"), i.finished = !0, w(), e._setFocus(), setTimeout(function() {
							e.wrap.addClass("mfp-ready")
						}, 16), e.updateStatus("ready"), u("AjaxContentAdded"), window.BOLD && BOLD.options && BOLD.common && (BOLD.options.app.unload(), BOLD.options.app.boot())
					},
					error: function() {
						w(), i.finished = i.loadError = !0, e.updateStatus("error", e.st.ajax.tError.replace("%url%", i.src))
					}
				}, e.st.ajax.settings);
				return e.req = t.ajax(s), ""
			}
		}
	});
	var x, T = function(i) {
		if (i.data && void 0 !== i.data.title) return i.data.title;
		var s = e.st.image.titleSrc;
		if (s) {
			if (t.isFunction(s)) return s.call(e, i);
			if (i.el) return i.el.attr(s) || ""
		}
		return ""
	};
	t.magnificPopup.registerModule("image", {
		options: {
			markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
			cursor: "mfp-zoom-out-cur",
			titleSrc: "title",
			verticalFit: !0,
			tError: '<a href="%url%">The image</a> could not be loaded.'
		},
		proto: {
			initImage: function() {
				var i = e.st.image,
					s = ".image";
				e.types.push("image"), c("Open" + s, function() {
					"image" === e.currItem.type && i.cursor && t(document.body).addClass(i.cursor)
				}), c("Close" + s, function() {
					i.cursor && t(document.body).removeClass(i.cursor), d.off("resize.mfp")
				}), c("Resize" + s, e.resizeImage), e.isLowIE && c("AfterChange", e.resizeImage)
			},
			resizeImage: function() {
				var t = e.currItem;
				if (t && t.img && e.st.image.verticalFit) {
					var i = 0;
					e.isLowIE && (i = parseInt(t.img.css("padding-top"), 10) + parseInt(t.img.css("padding-bottom"), 10)), t.img.css("max-height", e.wH - i)
				}
			},
			_onImageHasSize: function(t) {
				t.img && (t.hasSize = !0, x && clearInterval(x), t.isCheckingImgSize = !1, u("ImageHasSize", t), t.imgHidden && (e.content && e.content.removeClass("mfp-loading"), t.imgHidden = !1))
			},
			findImageSize: function(t) {
				var i = 0,
					s = t.img[0],
					n = function(a) {
						x && clearInterval(x), x = setInterval(function() {
							s.naturalWidth > 0 ? e._onImageHasSize(t) : (i > 200 && clearInterval(x), 3 === ++i ? n(10) : 40 === i ? n(50) : 100 === i && n(500))
						}, a)
					};
				n(1)
			},
			getImage: function(i, s) {
				var n = 0,
					a = function() {
						i && (i.img[0].complete ? (i.img.off(".mfploader"), i === e.currItem && (e._onImageHasSize(i), e.updateStatus("ready")), i.hasSize = !0, i.loaded = !0, u("ImageLoadComplete")) : ++n < 200 ? setTimeout(a, 100) : o())
					},
					o = function() {
						i && (i.img.off(".mfploader"), i === e.currItem && (e._onImageHasSize(i), e.updateStatus("error", r.tError.replace("%url%", i.src))), i.hasSize = !0, i.loaded = !0, i.loadError = !0)
					},
					r = e.st.image,
					l = s.find(".mfp-img");
				if (l.length) {
					var d = document.createElement("img");
					d.className = "mfp-img", i.el && i.el.find("img").length && (d.alt = i.el.find("img").attr("alt")), i.img = t(d).on("load.mfploader", a).on("error.mfploader", o), d.src = i.src, l.is("img") && (i.img = i.img.clone()), (d = i.img[0]).naturalWidth > 0 ? i.hasSize = !0 : d.width || (i.hasSize = !1)
				}
				return e._parseMarkup(s, {
					title: T(i),
					img_replaceWith: i.img
				}, i), e.resizeImage(), i.hasSize ? (x && clearInterval(x), i.loadError ? (s.addClass("mfp-loading"), e.updateStatus("error", r.tError.replace("%url%", i.src))) : (s.removeClass("mfp-loading"), e.updateStatus("ready")), s) : (e.updateStatus("loading"), i.loading = !0, i.hasSize || (i.imgHidden = !0, s.addClass("mfp-loading"), e.findImageSize(i)), s)
			}
		}
	});
	var C;
	t.magnificPopup.registerModule("zoom", {
		options: {
			enabled: !1,
			easing: "ease-in-out",
			duration: 300,
			opener: function(t) {
				return t.is("img") ? t : t.find("img")
			}
		},
		proto: {
			initZoom: function() {
				var t, i = e.st.zoom,
					s = ".zoom";
				if (i.enabled && e.supportsTransition) {
					var n, a, o = i.duration,
						r = function(t) {
							var e = t.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
								s = "all " + i.duration / 1e3 + "s " + i.easing,
								n = {
									position: "fixed",
									zIndex: 9999,
									left: 0,
									top: 0,
									"-webkit-backface-visibility": "hidden"
								},
								a = "transition";
							return n["-webkit-" + a] = n["-moz-" + a] = n["-o-" + a] = n[a] = s, e.css(n), e
						},
						l = function() {
							e.content.css("visibility", "visible")
						};
					c("BuildControls" + s, function() {
						if (e._allowZoom()) {
							if (clearTimeout(n), e.content.css("visibility", "hidden"), !(t = e._getItemToZoom())) return void l();
							(a = r(t)).css(e._getOffset()), e.wrap.append(a), n = setTimeout(function() {
								a.css(e._getOffset(!0)), n = setTimeout(function() {
									l(), setTimeout(function() {
										a.remove(), t = a = null, u("ZoomAnimationEnded")
									}, 16)
								}, o)
							}, 16)
						}
					}), c("BeforeClose" + s, function() {
						if (e._allowZoom()) {
							if (clearTimeout(n), e.st.removalDelay = o, !t) {
								if (!(t = e._getItemToZoom())) return;
								a = r(t)
							}
							a.css(e._getOffset(!0)), e.wrap.append(a), e.content.css("visibility", "hidden"), setTimeout(function() {
								a.css(e._getOffset())
							}, 16)
						}
					}), c("Close" + s, function() {
						e._allowZoom() && (l(), a && a.remove(), t = null)
					})
				}
			},
			_allowZoom: function() {
				return "image" === e.currItem.type
			},
			_getItemToZoom: function() {
				return !!e.currItem.hasSize && e.currItem.img
			},
			_getOffset: function(i) {
				var s, n = (s = i ? e.currItem.img : e.st.zoom.opener(e.currItem.el || e.currItem)).offset(),
					a = parseInt(s.css("padding-top"), 10),
					o = parseInt(s.css("padding-bottom"), 10);
				n.top -= t(window).scrollTop() - a;
				var r = {
					width: s.width(),
					height: (l ? s.innerHeight() : s[0].offsetHeight) - o - a
				};
				return void 0 === C && (C = void 0 !== document.createElement("p").style.MozTransform), C ? r["-moz-transform"] = r.transform = "translate(" + n.left + "px," + n.top + "px)" : (r.left = n.left, r.top = n.top), r
			}
		}
	});
	var _ = function(t) {
		if (e.currTemplate.iframe) {
			var i = e.currTemplate.iframe.find("iframe");
			i.length && (t || (i[0].src = "//about:blank"), e.isIE8 && i.css("display", t ? "block" : "none"))
		}
	};
	t.magnificPopup.registerModule("iframe", {
		options: {
			markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
			srcAction: "iframe_src",
			patterns: {
				youtube: {
					index: "youtube.com",
					id: "v=",
					src: "//www.youtube.com/embed/%id%?autoplay=1"
				},
				vimeo: {
					index: "vimeo.com/",
					id: "/",
					src: "//player.vimeo.com/video/%id%?autoplay=1"
				},
				gmaps: {
					index: "//maps.google.",
					src: "%id%&output=embed"
				}
			}
		},
		proto: {
			initIframe: function() {
				e.types.push("iframe"), c("BeforeChange", function(t, e, i) {
					e !== i && ("iframe" === e ? _() : "iframe" === i && _(!0))
				}), c("Close.iframe", function() {
					_()
				})
			},
			getIframe: function(i, s) {
				var n = i.src,
					a = e.st.iframe;
				t.each(a.patterns, function() {
					if (n.indexOf(this.index) > -1) return this.id && (n = "string" == typeof this.id ? n.substr(n.lastIndexOf(this.id) + this.id.length, n.length) : this.id.call(this, n)), n = this.src.replace("%id%", n), !1
				});
				var o = {};
				return a.srcAction && (o[a.srcAction] = n), e._parseMarkup(s, o, i), e.updateStatus("ready"), s
			}
		}
	});
	var E = function(t) {
			var i = e.items.length;
			return t > i - 1 ? t - i : t < 0 ? i + t : t
		},
		P = function(t, e, i) {
			return t.replace(/%curr%/gi, e + 1).replace(/%total%/gi, i)
		};
	t.magnificPopup.registerModule("gallery", {
		options: {
			enabled: !1,
			arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
			preload: [0, 2],
			navigateByImgClick: !0,
			arrows: !0,
			tPrev: "Previous (Left arrow key)",
			tNext: "Next (Right arrow key)",
			tCounter: "%curr% of %total%"
		},
		proto: {
			initGallery: function() {
				var i = e.st.gallery,
					n = ".mfp-gallery",
					o = Boolean(t.fn.mfpFastClick);
				if (e.direction = !0, !i || !i.enabled) return !1;
				a += " mfp-gallery", c("Open" + n, function() {
					i.navigateByImgClick && e.wrap.on("click" + n, ".mfp-img", function() {
						if (e.items.length > 1) return e.next(), !1
					}), s.on("keydown" + n, function(t) {
						37 === t.keyCode ? e.prev() : 39 === t.keyCode && e.next()
					})
				}), c("UpdateStatus" + n, function(t, i) {
					i.text && (i.text = P(i.text, e.currItem.index, e.items.length))
				}), c("MarkupParse" + n, function(t, s, n, a) {
					var o = e.items.length;
					n.counter = o > 1 ? P(i.tCounter, a.index, o) : ""
				}), c("BuildControls" + n, function() {
					if (e.items.length > 1 && i.arrows && !e.arrowLeft) {
						var s = i.arrowMarkup,
							n = e.arrowLeft = t(s.replace(/%title%/gi, i.tPrev).replace(/%dir%/gi, "left")).addClass("mfp-prevent-close"),
							a = e.arrowRight = t(s.replace(/%title%/gi, i.tNext).replace(/%dir%/gi, "right")).addClass("mfp-prevent-close"),
							r = o ? "mfpFastClick" : "click";
						n[r](function() {
							e.prev()
						}), a[r](function() {
							e.next()
						}), e.isIE7 && (h("b", n[0], !1, !0), h("a", n[0], !1, !0), h("b", a[0], !1, !0), h("a", a[0], !1, !0)), e.container.append(n.add(a))
					}
				}), c("Change" + n, function() {
					e._preloadTimeout && clearTimeout(e._preloadTimeout), e._preloadTimeout = setTimeout(function() {
						e.preloadNearbyImages(), e._preloadTimeout = null
					}, 16)
				}), c("Close" + n, function() {
					s.off(n), e.wrap.off("click" + n), e.arrowLeft && o && e.arrowLeft.add(e.arrowRight).destroyMfpFastClick(), e.arrowRight = e.arrowLeft = null
				})
			},
			next: function() {
				e.direction = !0, e.index = E(e.index + 1), e.updateItemHTML()
			},
			prev: function() {
				e.direction = !1, e.index = E(e.index - 1), e.updateItemHTML()
			},
			goTo: function(t) {
				e.direction = t >= e.index, e.index = t, e.updateItemHTML()
			},
			preloadNearbyImages: function() {
				var t, i = e.st.gallery.preload,
					s = Math.min(i[0], e.items.length),
					n = Math.min(i[1], e.items.length);
				for (t = 1; t <= (e.direction ? n : s); t++) e._preloadItem(e.index + t);
				for (t = 1; t <= (e.direction ? s : n); t++) e._preloadItem(e.index - t)
			},
			_preloadItem: function(i) {
				if (i = E(i), !e.items[i].preloaded) {
					var s = e.items[i];
					s.parsed || (s = e.parseEl(i)), u("LazyLoad", s), "image" === s.type && (s.img = t('<img class="mfp-img" />').on("load.mfploader", function() {
						s.hasSize = !0
					}).on("error.mfploader", function() {
						s.hasSize = !0, s.loadError = !0, u("LazyLoadError", s)
					}).attr("src", s.src)), s.preloaded = !0
				}
			}
		}
	});
	var k, $, M;
	t.magnificPopup.registerModule("retina", {
		options: {
			replaceSrc: function(t) {
				return t.src.replace(/\.\w+$/, function(t) {
					return "@2x" + t
				})
			},
			ratio: 1
		},
		proto: {
			initRetina: function() {
				if (window.devicePixelRatio > 1) {
					var t = e.st.retina,
						i = t.ratio;
					(i = isNaN(i) ? i() : i) > 1 && (c("ImageHasSize.retina", function(t, e) {
						e.img.css({
							"max-width": e.img[0].naturalWidth / i,
							width: "100%"
						})
					}), c("ElementParse.retina", function(e, s) {
						s.src = t.replaceSrc(s, i)
					}))
				}
			}
		}
	}), k = "ontouchstart" in window, $ = function() {
		d.off("touchmove" + M + " touchend" + M)
	}, M = ".mfpFastClick", t.fn.mfpFastClick = function(e) {
		return t(this).each(function() {
			var i, s, n, a, o, r, l, c = t(this);
			k && c.on("touchstart" + M, function(t) {
				o = !1, l = 1, r = t.originalEvent ? t.originalEvent.touches[0] : t.touches[0], n = r.clientX, a = r.clientY, d.on("touchmove" + M, function(t) {
					r = t.originalEvent ? t.originalEvent.touches : t.touches, l = r.length, r = r[0], (Math.abs(r.clientX - n) > 10 || Math.abs(r.clientY - a) > 10) && (o = !0, $())
				}).on("touchend" + M, function(t) {
					$(), o || l > 1 || (i = !0, t.preventDefault(), clearTimeout(s), s = setTimeout(function() {
						i = !1
					}, 1e3), e())
				})
			}), c.on("click" + M, function() {
				i || e()
			})
		})
	}, t.fn.destroyMfpFastClick = function() {
		t(this).off("touchstart" + M + " click" + M), k && d.off("touchmove" + M + " touchend" + M)
	}, f()
}),
function(t, e) {
	"object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.Swiper = e()
}(this, function() {
	"use strict";
	var t = "undefined" == typeof document ? {
			body: {},
			addEventListener: function() {},
			removeEventListener: function() {},
			activeElement: {
				blur: function() {},
				nodeName: ""
			},
			querySelector: function() {
				return null
			},
			querySelectorAll: function() {
				return []
			},
			getElementById: function() {
				return null
			},
			createEvent: function() {
				return {
					initEvent: function() {}
				}
			},
			createElement: function() {
				return {
					children: [],
					childNodes: [],
					style: {},
					setAttribute: function() {},
					getElementsByTagName: function() {
						return []
					}
				}
			},
			location: {
				hash: ""
			}
		} : document,
		e = "undefined" == typeof window ? {
			document: t,
			navigator: {
				userAgent: ""
			},
			location: {},
			history: {},
			CustomEvent: function() {
				return this
			},
			addEventListener: function() {},
			removeEventListener: function() {},
			getComputedStyle: function() {
				return {
					getPropertyValue: function() {
						return ""
					}
				}
			},
			Image: function() {},
			Date: function() {},
			screen: {},
			setTimeout: function() {},
			clearTimeout: function() {}
		} : window,
		i = function(t) {
			for (var e = 0; e < t.length; e += 1) this[e] = t[e];
			return this.length = t.length, this
		};

	function s(s, n) {
		var a = [],
			o = 0;
		if (s && !n && s instanceof i) return s;
		if (s)
			if ("string" == typeof s) {
				var r, l, d = s.trim();
				if (d.indexOf("<") >= 0 && d.indexOf(">") >= 0) {
					var c = "div";
					for (0 === d.indexOf("<li") && (c = "ul"), 0 === d.indexOf("<tr") && (c = "tbody"), 0 !== d.indexOf("<td") && 0 !== d.indexOf("<th") || (c = "tr"), 0 === d.indexOf("<tbody") && (c = "table"), 0 === d.indexOf("<option") && (c = "select"), (l = t.createElement(c)).innerHTML = d, o = 0; o < l.childNodes.length; o += 1) a.push(l.childNodes[o])
				} else
					for (r = n || "#" !== s[0] || s.match(/[ .<>:~]/) ? (n || t).querySelectorAll(s.trim()) : [t.getElementById(s.trim().split("#")[1])], o = 0; o < r.length; o += 1) r[o] && a.push(r[o])
			} else if (s.nodeType || s === e || s === t) a.push(s);
		else if (s.length > 0 && s[0].nodeType)
			for (o = 0; o < s.length; o += 1) a.push(s[o]);
		return new i(a)
	}

	function n(t) {
		for (var e = [], i = 0; i < t.length; i += 1) - 1 === e.indexOf(t[i]) && e.push(t[i]);
		return e
	}
	s.fn = i.prototype, s.Class = i, s.Dom7 = i;
	var a = {
		addClass: function(t) {
			if (void 0 === t) return this;
			for (var e = t.split(" "), i = 0; i < e.length; i += 1)
				for (var s = 0; s < this.length; s += 1) void 0 !== this[s].classList && this[s].classList.add(e[i]);
			return this
		},
		removeClass: function(t) {
			for (var e = t.split(" "), i = 0; i < e.length; i += 1)
				for (var s = 0; s < this.length; s += 1) void 0 !== this[s].classList && this[s].classList.remove(e[i]);
			return this
		},
		hasClass: function(t) {
			return !!this[0] && this[0].classList.contains(t)
		},
		toggleClass: function(t) {
			for (var e = t.split(" "), i = 0; i < e.length; i += 1)
				for (var s = 0; s < this.length; s += 1) void 0 !== this[s].classList && this[s].classList.toggle(e[i]);
			return this
		},
		attr: function(t, e) {
			var i = arguments;
			if (1 === arguments.length && "string" == typeof t) return this[0] ? this[0].getAttribute(t) : void 0;
			for (var s = 0; s < this.length; s += 1)
				if (2 === i.length) this[s].setAttribute(t, e);
				else
					for (var n in t) this[s][n] = t[n], this[s].setAttribute(n, t[n]);
			return this
		},
		removeAttr: function(t) {
			for (var e = 0; e < this.length; e += 1) this[e].removeAttribute(t);
			return this
		},
		data: function(t, e) {
			var i;
			if (void 0 !== e) {
				for (var s = 0; s < this.length; s += 1)(i = this[s]).dom7ElementDataStorage || (i.dom7ElementDataStorage = {}), i.dom7ElementDataStorage[t] = e;
				return this
			}
			if (i = this[0]) return i.dom7ElementDataStorage && t in i.dom7ElementDataStorage ? i.dom7ElementDataStorage[t] : i.getAttribute("data-" + t) || void 0
		},
		transform: function(t) {
			for (var e = 0; e < this.length; e += 1) {
				var i = this[e].style;
				i.webkitTransform = t, i.transform = t
			}
			return this
		},
		transition: function(t) {
			"string" != typeof t && (t += "ms");
			for (var e = 0; e < this.length; e += 1) {
				var i = this[e].style;
				i.webkitTransitionDuration = t, i.transitionDuration = t
			}
			return this
		},
		on: function() {
			for (var t, e = [], i = arguments.length; i--;) e[i] = arguments[i];
			var n = e[0],
				a = e[1],
				o = e[2],
				r = e[3];

			function l(t) {
				var e = t.target;
				if (e) {
					var i = t.target.dom7EventData || [];
					if (i.unshift(t), s(e).is(a)) o.apply(e, i);
					else
						for (var n = s(e).parents(), r = 0; r < n.length; r += 1) s(n[r]).is(a) && o.apply(n[r], i)
				}
			}

			function d(t) {
				var e = t && t.target && t.target.dom7EventData || [];
				e.unshift(t), o.apply(this, e)
			}
			"function" == typeof e[1] && (n = (t = e)[0], o = t[1], r = t[2], a = void 0), r || (r = !1);
			for (var c, h = n.split(" "), u = 0; u < this.length; u += 1) {
				var p = this[u];
				if (a)
					for (c = 0; c < h.length; c += 1) p.dom7LiveListeners || (p.dom7LiveListeners = []), p.dom7LiveListeners.push({
						type: n,
						listener: o,
						proxyListener: l
					}), p.addEventListener(h[c], l, r);
				else
					for (c = 0; c < h.length; c += 1) p.dom7Listeners || (p.dom7Listeners = []), p.dom7Listeners.push({
						type: n,
						listener: o,
						proxyListener: d
					}), p.addEventListener(h[c], d, r)
			}
			return this
		},
		off: function() {
			for (var t, e = [], i = arguments.length; i--;) e[i] = arguments[i];
			var s = e[0],
				n = e[1],
				a = e[2],
				o = e[3];
			"function" == typeof e[1] && (s = (t = e)[0], a = t[1], o = t[2], n = void 0), o || (o = !1);
			for (var r = s.split(" "), l = 0; l < r.length; l += 1)
				for (var d = 0; d < this.length; d += 1) {
					var c = this[d];
					if (n) {
						if (c.dom7LiveListeners)
							for (var h = 0; h < c.dom7LiveListeners.length; h += 1) a ? c.dom7LiveListeners[h].listener === a && c.removeEventListener(r[l], c.dom7LiveListeners[h].proxyListener, o) : c.dom7LiveListeners[h].type === r[l] && c.removeEventListener(r[l], c.dom7LiveListeners[h].proxyListener, o)
					} else if (c.dom7Listeners)
						for (var u = 0; u < c.dom7Listeners.length; u += 1) a ? c.dom7Listeners[u].listener === a && c.removeEventListener(r[l], c.dom7Listeners[u].proxyListener, o) : c.dom7Listeners[u].type === r[l] && c.removeEventListener(r[l], c.dom7Listeners[u].proxyListener, o)
				}
			return this
		},
		trigger: function() {
			for (var i = [], s = arguments.length; s--;) i[s] = arguments[s];
			for (var n = i[0].split(" "), a = i[1], o = 0; o < n.length; o += 1)
				for (var r = 0; r < this.length; r += 1) {
					var l = void 0;
					try {
						l = new e.CustomEvent(n[o], {
							detail: a,
							bubbles: !0,
							cancelable: !0
						})
					} catch (e) {
						(l = t.createEvent("Event")).initEvent(n[o], !0, !0), l.detail = a
					}
					this[r].dom7EventData = i.filter(function(t, e) {
						return e > 0
					}), this[r].dispatchEvent(l), this[r].dom7EventData = [], delete this[r].dom7EventData
				}
			return this
		},
		transitionEnd: function(t) {
			var e, i = ["webkitTransitionEnd", "transitionend"],
				s = this;

			function n(a) {
				if (a.target === this)
					for (t.call(this, a), e = 0; e < i.length; e += 1) s.off(i[e], n)
			}
			if (t)
				for (e = 0; e < i.length; e += 1) s.on(i[e], n);
			return this
		},
		outerWidth: function(t) {
			if (this.length > 0) {
				if (t) {
					var e = this.styles();
					return this[0].offsetWidth + parseFloat(e.getPropertyValue("margin-right")) + parseFloat(e.getPropertyValue("margin-left"))
				}
				return this[0].offsetWidth
			}
			return null
		},
		outerHeight: function(t) {
			if (this.length > 0) {
				if (t) {
					var e = this.styles();
					return this[0].offsetHeight + parseFloat(e.getPropertyValue("margin-top")) + parseFloat(e.getPropertyValue("margin-bottom"))
				}
				return this[0].offsetHeight
			}
			return null
		},
		offset: function() {
			if (this.length > 0) {
				var i = this[0],
					s = i.getBoundingClientRect(),
					n = t.body,
					a = i.clientTop || n.clientTop || 0,
					o = i.clientLeft || n.clientLeft || 0,
					r = i === e ? e.scrollY : i.scrollTop,
					l = i === e ? e.scrollX : i.scrollLeft;
				return {
					top: s.top + r - a,
					left: s.left + l - o
				}
			}
			return null
		},
		css: function(t, i) {
			var s;
			if (1 === arguments.length) {
				if ("string" != typeof t) {
					for (s = 0; s < this.length; s += 1)
						for (var n in t) this[s].style[n] = t[n];
					return this
				}
				if (this[0]) return e.getComputedStyle(this[0], null).getPropertyValue(t)
			}
			if (2 === arguments.length && "string" == typeof t) {
				for (s = 0; s < this.length; s += 1) this[s].style[t] = i;
				return this
			}
			return this
		},
		each: function(t) {
			if (!t) return this;
			for (var e = 0; e < this.length; e += 1)
				if (!1 === t.call(this[e], e, this[e])) return this;
			return this
		},
		html: function(t) {
			if (void 0 === t) return this[0] ? this[0].innerHTML : void 0;
			for (var e = 0; e < this.length; e += 1) this[e].innerHTML = t;
			return this
		},
		text: function(t) {
			if (void 0 === t) return this[0] ? this[0].textContent.trim() : null;
			for (var e = 0; e < this.length; e += 1) this[e].textContent = t;
			return this
		},
		is: function(n) {
			var a, o, r = this[0];
			if (!r || void 0 === n) return !1;
			if ("string" == typeof n) {
				if (r.matches) return r.matches(n);
				if (r.webkitMatchesSelector) return r.webkitMatchesSelector(n);
				if (r.msMatchesSelector) return r.msMatchesSelector(n);
				for (a = s(n), o = 0; o < a.length; o += 1)
					if (a[o] === r) return !0;
				return !1
			}
			if (n === t) return r === t;
			if (n === e) return r === e;
			if (n.nodeType || n instanceof i) {
				for (a = n.nodeType ? [n] : n, o = 0; o < a.length; o += 1)
					if (a[o] === r) return !0;
				return !1
			}
			return !1
		},
		index: function() {
			var t, e = this[0];
			if (e) {
				for (t = 0; null !== (e = e.previousSibling);) 1 === e.nodeType && (t += 1);
				return t
			}
		},
		eq: function(t) {
			if (void 0 === t) return this;
			var e, s = this.length;
			return new i(t > s - 1 ? [] : t < 0 ? (e = s + t) < 0 ? [] : [this[e]] : [this[t]])
		},
		append: function() {
			for (var e, s = [], n = arguments.length; n--;) s[n] = arguments[n];
			for (var a = 0; a < s.length; a += 1) {
				e = s[a];
				for (var o = 0; o < this.length; o += 1)
					if ("string" == typeof e) {
						var r = t.createElement("div");
						for (r.innerHTML = e; r.firstChild;) this[o].appendChild(r.firstChild)
					} else if (e instanceof i)
					for (var l = 0; l < e.length; l += 1) this[o].appendChild(e[l]);
				else this[o].appendChild(e)
			}
			return this
		},
		prepend: function(e) {
			var s, n;
			for (s = 0; s < this.length; s += 1)
				if ("string" == typeof e) {
					var a = t.createElement("div");
					for (a.innerHTML = e, n = a.childNodes.length - 1; n >= 0; n -= 1) this[s].insertBefore(a.childNodes[n], this[s].childNodes[0])
				} else if (e instanceof i)
				for (n = 0; n < e.length; n += 1) this[s].insertBefore(e[n], this[s].childNodes[0]);
			else this[s].insertBefore(e, this[s].childNodes[0]);
			return this
		},
		next: function(t) {
			return this.length > 0 ? t ? this[0].nextElementSibling && s(this[0].nextElementSibling).is(t) ? new i([this[0].nextElementSibling]) : new i([]) : this[0].nextElementSibling ? new i([this[0].nextElementSibling]) : new i([]) : new i([])
		},
		nextAll: function(t) {
			var e = [],
				n = this[0];
			if (!n) return new i([]);
			for (; n.nextElementSibling;) {
				var a = n.nextElementSibling;
				t ? s(a).is(t) && e.push(a) : e.push(a), n = a
			}
			return new i(e)
		},
		prev: function(t) {
			if (this.length > 0) {
				var e = this[0];
				return t ? e.previousElementSibling && s(e.previousElementSibling).is(t) ? new i([e.previousElementSibling]) : new i([]) : e.previousElementSibling ? new i([e.previousElementSibling]) : new i([])
			}
			return new i([])
		},
		prevAll: function(t) {
			var e = [],
				n = this[0];
			if (!n) return new i([]);
			for (; n.previousElementSibling;) {
				var a = n.previousElementSibling;
				t ? s(a).is(t) && e.push(a) : e.push(a), n = a
			}
			return new i(e)
		},
		parent: function(t) {
			for (var e = [], i = 0; i < this.length; i += 1) null !== this[i].parentNode && (t ? s(this[i].parentNode).is(t) && e.push(this[i].parentNode) : e.push(this[i].parentNode));
			return s(n(e))
		},
		parents: function(t) {
			for (var e = [], i = 0; i < this.length; i += 1)
				for (var a = this[i].parentNode; a;) t ? s(a).is(t) && e.push(a) : e.push(a), a = a.parentNode;
			return s(n(e))
		},
		closest: function(t) {
			var e = this;
			return void 0 === t ? new i([]) : (e.is(t) || (e = e.parents(t).eq(0)), e)
		},
		find: function(t) {
			for (var e = [], s = 0; s < this.length; s += 1)
				for (var n = this[s].querySelectorAll(t), a = 0; a < n.length; a += 1) e.push(n[a]);
			return new i(e)
		},
		children: function(t) {
			for (var e = [], a = 0; a < this.length; a += 1)
				for (var o = this[a].childNodes, r = 0; r < o.length; r += 1) t ? 1 === o[r].nodeType && s(o[r]).is(t) && e.push(o[r]) : 1 === o[r].nodeType && e.push(o[r]);
			return new i(n(e))
		},
		remove: function() {
			for (var t = 0; t < this.length; t += 1) this[t].parentNode && this[t].parentNode.removeChild(this[t]);
			return this
		},
		add: function() {
			for (var t = [], e = arguments.length; e--;) t[e] = arguments[e];
			var i, n;
			for (i = 0; i < t.length; i += 1) {
				var a = s(t[i]);
				for (n = 0; n < a.length; n += 1) this[this.length] = a[n], this.length += 1
			}
			return this
		},
		styles: function() {
			return this[0] ? e.getComputedStyle(this[0], null) : {}
		}
	};
	Object.keys(a).forEach(function(t) {
		s.fn[t] = a[t]
	});
	var o, r, l, d = {
			deleteProps: function(t) {
				var e = t;
				Object.keys(e).forEach(function(t) {
					try {
						e[t] = null
					} catch (t) {}
					try {
						delete e[t]
					} catch (t) {}
				})
			},
			nextTick: function(t, e) {
				return void 0 === e && (e = 0), setTimeout(t, e)
			},
			now: function() {
				return Date.now()
			},
			getTranslate: function(t, i) {
				var s, n, a;
				void 0 === i && (i = "x");
				var o = e.getComputedStyle(t, null);
				return e.WebKitCSSMatrix ? ((n = o.transform || o.webkitTransform).split(",").length > 6 && (n = n.split(", ").map(function(t) {
					return t.replace(",", ".")
				}).join(", ")), a = new e.WebKitCSSMatrix("none" === n ? "" : n)) : s = (a = o.MozTransform || o.OTransform || o.MsTransform || o.msTransform || o.transform || o.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")).toString().split(","), "x" === i && (n = e.WebKitCSSMatrix ? a.m41 : 16 === s.length ? parseFloat(s[12]) : parseFloat(s[4])), "y" === i && (n = e.WebKitCSSMatrix ? a.m42 : 16 === s.length ? parseFloat(s[13]) : parseFloat(s[5])), n || 0
			},
			parseUrlQuery: function(t) {
				var i, s, n, a, o = {},
					r = t || e.location.href;
				if ("string" == typeof r && r.length)
					for (a = (s = (r = r.indexOf("?") > -1 ? r.replace(/\S*\?/, "") : "").split("&").filter(function(t) {
							return "" !== t
						})).length, i = 0; i < a; i += 1) n = s[i].replace(/#\S+/g, "").split("="), o[decodeURIComponent(n[0])] = void 0 === n[1] ? void 0 : decodeURIComponent(n[1]) || "";
				return o
			},
			isObject: function(t) {
				return "object" == typeof t && null !== t && t.constructor && t.constructor === Object
			},
			extend: function() {
				for (var t = [], e = arguments.length; e--;) t[e] = arguments[e];
				for (var i = Object(t[0]), s = 1; s < t.length; s += 1) {
					var n = t[s];
					if (null != n)
						for (var a = Object.keys(Object(n)), o = 0, r = a.length; o < r; o += 1) {
							var l = a[o],
								c = Object.getOwnPropertyDescriptor(n, l);
							void 0 !== c && c.enumerable && (d.isObject(i[l]) && d.isObject(n[l]) ? d.extend(i[l], n[l]) : !d.isObject(i[l]) && d.isObject(n[l]) ? (i[l] = {}, d.extend(i[l], n[l])) : i[l] = n[l])
						}
				}
				return i
			}
		},
		c = (l = t.createElement("div"), {
			touch: e.Modernizr && !0 === e.Modernizr.touch || !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch),
			pointerEvents: !(!e.navigator.pointerEnabled && !e.PointerEvent),
			prefixedPointerEvents: !!e.navigator.msPointerEnabled,
			transition: (r = l.style, "transition" in r || "webkitTransition" in r || "MozTransition" in r),
			transforms3d: e.Modernizr && !0 === e.Modernizr.csstransforms3d || (o = l.style, "webkitPerspective" in o || "MozPerspective" in o || "OPerspective" in o || "MsPerspective" in o || "perspective" in o),
			flexbox: function() {
				for (var t = l.style, e = "alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient".split(" "), i = 0; i < e.length; i += 1)
					if (e[i] in t) return !0;
				return !1
			}(),
			observer: "MutationObserver" in e || "WebkitMutationObserver" in e,
			passiveListener: function() {
				var t = !1;
				try {
					var i = Object.defineProperty({}, "passive", {
						get: function() {
							t = !0
						}
					});
					e.addEventListener("testPassiveListener", null, i)
				} catch (t) {}
				return t
			}(),
			gestures: "ongesturestart" in e
		}),
		h = function(t) {
			void 0 === t && (t = {});
			var e = this;
			e.params = t, e.eventsListeners = {}, e.params && e.params.on && Object.keys(e.params.on).forEach(function(t) {
				e.on(t, e.params.on[t])
			})
		},
		u = {
			components: {
				configurable: !0
			}
		};
	h.prototype.on = function(t, e, i) {
		var s = this;
		if ("function" != typeof e) return s;
		var n = i ? "unshift" : "push";
		return t.split(" ").forEach(function(t) {
			s.eventsListeners[t] || (s.eventsListeners[t] = []), s.eventsListeners[t][n](e)
		}), s
	}, h.prototype.once = function(t, e, i) {
		var s = this;
		return "function" != typeof e ? s : s.on(t, function i() {
			for (var n = [], a = arguments.length; a--;) n[a] = arguments[a];
			e.apply(s, n), s.off(t, i)
		}, i)
	}, h.prototype.off = function(t, e) {
		var i = this;
		return t.split(" ").forEach(function(t) {
			void 0 === e ? i.eventsListeners[t] = [] : i.eventsListeners[t].forEach(function(s, n) {
				s === e && i.eventsListeners[t].splice(n, 1)
			})
		}), i
	}, h.prototype.emit = function() {
		for (var t = [], e = arguments.length; e--;) t[e] = arguments[e];
		var i, s, n, a = this;
		return a.eventsListeners ? ("string" == typeof t[0] || Array.isArray(t[0]) ? (i = t[0], s = t.slice(1, t.length), n = a) : (i = t[0].events, s = t[0].data, n = t[0].context || a), (Array.isArray(i) ? i : i.split(" ")).forEach(function(t) {
			if (a.eventsListeners[t]) {
				var e = [];
				a.eventsListeners[t].forEach(function(t) {
					e.push(t)
				}), e.forEach(function(t) {
					t.apply(n, s)
				})
			}
		}), a) : a
	}, h.prototype.useModulesParams = function(t) {
		var e = this;
		e.modules && Object.keys(e.modules).forEach(function(i) {
			var s = e.modules[i];
			s.params && d.extend(t, s.params)
		})
	}, h.prototype.useModules = function(t) {
		void 0 === t && (t = {});
		var e = this;
		e.modules && Object.keys(e.modules).forEach(function(i) {
			var s = e.modules[i],
				n = t[i] || {};
			s.instance && Object.keys(s.instance).forEach(function(t) {
				var i = s.instance[t];
				e[t] = "function" == typeof i ? i.bind(e) : i
			}), s.on && e.on && Object.keys(s.on).forEach(function(t) {
				e.on(t, s.on[t])
			}), s.create && s.create.bind(e)(n)
		})
	}, u.components.set = function(t) {
		this.use && this.use(t)
	}, h.installModule = function(t) {
		for (var e = [], i = arguments.length - 1; i-- > 0;) e[i] = arguments[i + 1];
		var s = this;
		s.prototype.modules || (s.prototype.modules = {});
		var n = t.name || Object.keys(s.prototype.modules).length + "_" + d.now();
		return s.prototype.modules[n] = t, t.proto && Object.keys(t.proto).forEach(function(e) {
			s.prototype[e] = t.proto[e]
		}), t.static && Object.keys(t.static).forEach(function(e) {
			s[e] = t.static[e]
		}), t.install && t.install.apply(s, e), s
	}, h.use = function(t) {
		for (var e = [], i = arguments.length - 1; i-- > 0;) e[i] = arguments[i + 1];
		var s = this;
		return Array.isArray(t) ? (t.forEach(function(t) {
			return s.installModule(t)
		}), s) : s.installModule.apply(s, [t].concat(e))
	}, Object.defineProperties(h, u);
	var p = {
			updateSize: function() {
				var t, e, i = this.$el;
				t = void 0 !== this.params.width ? this.params.width : i[0].clientWidth, e = void 0 !== this.params.height ? this.params.height : i[0].clientHeight, 0 === t && this.isHorizontal() || 0 === e && this.isVertical() || (t = t - parseInt(i.css("padding-left"), 10) - parseInt(i.css("padding-right"), 10), e = e - parseInt(i.css("padding-top"), 10) - parseInt(i.css("padding-bottom"), 10), d.extend(this, {
					width: t,
					height: e,
					size: this.isHorizontal() ? t : e
				}))
			},
			updateSlides: function() {
				var t = this.params,
					i = this.$wrapperEl,
					s = this.size,
					n = this.rtlTranslate,
					a = this.wrongRTL,
					o = i.children("." + this.params.slideClass),
					r = this.virtual && t.virtual.enabled ? this.virtual.slides.length : o.length,
					l = [],
					h = [],
					u = [],
					p = t.slidesOffsetBefore;
				"function" == typeof p && (p = t.slidesOffsetBefore.call(this));
				var f = t.slidesOffsetAfter;
				"function" == typeof f && (f = t.slidesOffsetAfter.call(this));
				var m = r,
					g = this.snapGrid.length,
					v = this.snapGrid.length,
					y = t.spaceBetween,
					b = -p,
					w = 0,
					S = 0;
				if (void 0 !== s) {
					var x, T;
					"string" == typeof y && y.indexOf("%") >= 0 && (y = parseFloat(y.replace("%", "")) / 100 * s), this.virtualSize = -y, n ? o.css({
						marginLeft: "",
						marginTop: ""
					}) : o.css({
						marginRight: "",
						marginBottom: ""
					}), t.slidesPerColumn > 1 && (x = Math.floor(r / t.slidesPerColumn) === r / this.params.slidesPerColumn ? r : Math.ceil(r / t.slidesPerColumn) * t.slidesPerColumn, "auto" !== t.slidesPerView && "row" === t.slidesPerColumnFill && (x = Math.max(x, t.slidesPerView * t.slidesPerColumn)));
					for (var C, _ = t.slidesPerColumn, E = x / _, P = E - (t.slidesPerColumn * E - r), k = 0; k < r; k += 1) {
						T = 0;
						var $ = o.eq(k);
						if (t.slidesPerColumn > 1) {
							var M = void 0,
								D = void 0,
								O = void 0;
							"column" === t.slidesPerColumnFill ? (O = k - (D = Math.floor(k / _)) * _, (D > P || D === P && O === _ - 1) && (O += 1) >= _ && (O = 0, D += 1), M = D + O * x / _, $.css({
								"-webkit-box-ordinal-group": M,
								"-moz-box-ordinal-group": M,
								"-ms-flex-order": M,
								"-webkit-order": M,
								order: M
							})) : D = k - (O = Math.floor(k / E)) * E, $.css("margin-" + (this.isHorizontal() ? "top" : "left"), 0 !== O && t.spaceBetween && t.spaceBetween + "px").attr("data-swiper-column", D).attr("data-swiper-row", O)
						}
						if ("none" !== $.css("display")) {
							if ("auto" === t.slidesPerView) {
								var z = e.getComputedStyle($[0], null);
								T = this.isHorizontal() ? $[0].getBoundingClientRect().width + parseFloat(z.getPropertyValue("margin-left")) + parseFloat(z.getPropertyValue("margin-right")) : $[0].getBoundingClientRect().height + parseFloat(z.getPropertyValue("margin-top")) + parseFloat(z.getPropertyValue("margin-bottom")), t.roundLengths && (T = Math.floor(T))
							} else T = (s - (t.slidesPerView - 1) * y) / t.slidesPerView, t.roundLengths && (T = Math.floor(T)), o[k] && (this.isHorizontal() ? o[k].style.width = T + "px" : o[k].style.height = T + "px");
							o[k] && (o[k].swiperSlideSize = T), u.push(T), t.centeredSlides ? (b = b + T / 2 + w / 2 + y, 0 === w && 0 !== k && (b = b - s / 2 - y), 0 === k && (b = b - s / 2 - y), Math.abs(b) < .001 && (b = 0), S % t.slidesPerGroup == 0 && l.push(b), h.push(b)) : (S % t.slidesPerGroup == 0 && l.push(b), h.push(b), b = b + T + y), this.virtualSize += T + y, w = T, S += 1
						}
					}
					if (this.virtualSize = Math.max(this.virtualSize, s) + f, n && a && ("slide" === t.effect || "coverflow" === t.effect) && i.css({
							width: this.virtualSize + t.spaceBetween + "px"
						}), c.flexbox && !t.setWrapperSize || (this.isHorizontal() ? i.css({
							width: this.virtualSize + t.spaceBetween + "px"
						}) : i.css({
							height: this.virtualSize + t.spaceBetween + "px"
						})), t.slidesPerColumn > 1 && (this.virtualSize = (T + t.spaceBetween) * x, this.virtualSize = Math.ceil(this.virtualSize / t.slidesPerColumn) - t.spaceBetween, this.isHorizontal() ? i.css({
							width: this.virtualSize + t.spaceBetween + "px"
						}) : i.css({
							height: this.virtualSize + t.spaceBetween + "px"
						}), t.centeredSlides)) {
						C = [];
						for (var A = 0; A < l.length; A += 1) l[A] < this.virtualSize + l[0] && C.push(l[A]);
						l = C
					}
					if (!t.centeredSlides) {
						C = [];
						for (var I = 0; I < l.length; I += 1) l[I] <= this.virtualSize - s && C.push(l[I]);
						l = C, Math.floor(this.virtualSize - s) - Math.floor(l[l.length - 1]) > 1 && l.push(this.virtualSize - s)
					}
					0 === l.length && (l = [0]), 0 !== t.spaceBetween && (this.isHorizontal() ? n ? o.css({
						marginLeft: y + "px"
					}) : o.css({
						marginRight: y + "px"
					}) : o.css({
						marginBottom: y + "px"
					})), d.extend(this, {
						slides: o,
						snapGrid: l,
						slidesGrid: h,
						slidesSizesGrid: u
					}), r !== m && this.emit("slidesLengthChange"), l.length !== g && (this.params.watchOverflow && this.checkOverflow(), this.emit("snapGridLengthChange")), h.length !== v && this.emit("slidesGridLengthChange"), (t.watchSlidesProgress || t.watchSlidesVisibility) && this.updateSlidesOffset()
				}
			},
			updateAutoHeight: function(t) {
				var e, i = [],
					s = 0;
				if ("number" == typeof t ? this.setTransition(t) : !0 === t && this.setTransition(this.params.speed), "auto" !== this.params.slidesPerView && this.params.slidesPerView > 1)
					for (e = 0; e < Math.ceil(this.params.slidesPerView); e += 1) {
						var n = this.activeIndex + e;
						if (n > this.slides.length) break;
						i.push(this.slides.eq(n)[0])
					} else i.push(this.slides.eq(this.activeIndex)[0]);
				for (e = 0; e < i.length; e += 1)
					if (void 0 !== i[e]) {
						var a = i[e].offsetHeight;
						s = a > s ? a : s
					} s && this.$wrapperEl.css("height", s + "px")
			},
			updateSlidesOffset: function() {
				for (var t = this.slides, e = 0; e < t.length; e += 1) t[e].swiperSlideOffset = this.isHorizontal() ? t[e].offsetLeft : t[e].offsetTop
			},
			updateSlidesProgress: function(t) {
				void 0 === t && (t = this.translate || 0);
				var e = this.params,
					i = this.slides,
					s = this.rtlTranslate;
				if (0 !== i.length) {
					void 0 === i[0].swiperSlideOffset && this.updateSlidesOffset();
					var n = -t;
					s && (n = t), i.removeClass(e.slideVisibleClass);
					for (var a = 0; a < i.length; a += 1) {
						var o = i[a],
							r = (n + (e.centeredSlides ? this.minTranslate() : 0) - o.swiperSlideOffset) / (o.swiperSlideSize + e.spaceBetween);
						if (e.watchSlidesVisibility) {
							var l = -(n - o.swiperSlideOffset),
								d = l + this.slidesSizesGrid[a];
							(l >= 0 && l < this.size || d > 0 && d <= this.size || l <= 0 && d >= this.size) && i.eq(a).addClass(e.slideVisibleClass)
						}
						o.progress = s ? -r : r
					}
				}
			},
			updateProgress: function(t) {
				void 0 === t && (t = this.translate || 0);
				var e = this.params,
					i = this.maxTranslate() - this.minTranslate(),
					s = this.progress,
					n = this.isBeginning,
					a = this.isEnd,
					o = n,
					r = a;
				0 === i ? (s = 0, n = !0, a = !0) : (n = (s = (t - this.minTranslate()) / i) <= 0, a = s >= 1), d.extend(this, {
					progress: s,
					isBeginning: n,
					isEnd: a
				}), (e.watchSlidesProgress || e.watchSlidesVisibility) && this.updateSlidesProgress(t), n && !o && this.emit("reachBeginning toEdge"), a && !r && this.emit("reachEnd toEdge"), (o && !n || r && !a) && this.emit("fromEdge"), this.emit("progress", s)
			},
			updateSlidesClasses: function() {
				var t, e = this.slides,
					i = this.params,
					s = this.$wrapperEl,
					n = this.activeIndex,
					a = this.realIndex,
					o = this.virtual && i.virtual.enabled;
				e.removeClass(i.slideActiveClass + " " + i.slideNextClass + " " + i.slidePrevClass + " " + i.slideDuplicateActiveClass + " " + i.slideDuplicateNextClass + " " + i.slideDuplicatePrevClass), (t = o ? this.$wrapperEl.find("." + i.slideClass + '[data-swiper-slide-index="' + n + '"]') : e.eq(n)).addClass(i.slideActiveClass), i.loop && (t.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + a + '"]').addClass(i.slideDuplicateActiveClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + a + '"]').addClass(i.slideDuplicateActiveClass));
				var r = t.nextAll("." + i.slideClass).eq(0).addClass(i.slideNextClass);
				i.loop && 0 === r.length && (r = e.eq(0)).addClass(i.slideNextClass);
				var l = t.prevAll("." + i.slideClass).eq(0).addClass(i.slidePrevClass);
				i.loop && 0 === l.length && (l = e.eq(-1)).addClass(i.slidePrevClass), i.loop && (r.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + r.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicateNextClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + r.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicateNextClass), l.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + l.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicatePrevClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + l.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicatePrevClass))
			},
			updateActiveIndex: function(t) {
				var e, i = this.rtlTranslate ? this.translate : -this.translate,
					s = this.slidesGrid,
					n = this.snapGrid,
					a = this.params,
					o = this.activeIndex,
					r = this.realIndex,
					l = this.snapIndex,
					c = t;
				if (void 0 === c) {
					for (var h = 0; h < s.length; h += 1) void 0 !== s[h + 1] ? i >= s[h] && i < s[h + 1] - (s[h + 1] - s[h]) / 2 ? c = h : i >= s[h] && i < s[h + 1] && (c = h + 1) : i >= s[h] && (c = h);
					a.normalizeSlideIndex && (c < 0 || void 0 === c) && (c = 0)
				}
				if ((e = n.indexOf(i) >= 0 ? n.indexOf(i) : Math.floor(c / a.slidesPerGroup)) >= n.length && (e = n.length - 1), c !== o) {
					var u = parseInt(this.slides.eq(c).attr("data-swiper-slide-index") || c, 10);
					d.extend(this, {
						snapIndex: e,
						realIndex: u,
						previousIndex: o,
						activeIndex: c
					}), this.emit("activeIndexChange"), this.emit("snapIndexChange"), r !== u && this.emit("realIndexChange"), this.emit("slideChange")
				} else e !== l && (this.snapIndex = e, this.emit("snapIndexChange"))
			},
			updateClickedSlide: function(t) {
				var e = this.params,
					i = s(t.target).closest("." + e.slideClass)[0],
					n = !1;
				if (i)
					for (var a = 0; a < this.slides.length; a += 1) this.slides[a] === i && (n = !0);
				if (!i || !n) return this.clickedSlide = void 0, void(this.clickedIndex = void 0);
				this.clickedSlide = i, this.virtual && this.params.virtual.enabled ? this.clickedIndex = parseInt(s(i).attr("data-swiper-slide-index"), 10) : this.clickedIndex = s(i).index(), e.slideToClickedSlide && void 0 !== this.clickedIndex && this.clickedIndex !== this.activeIndex && this.slideToClickedSlide()
			}
		},
		f = {
			getTranslate: function(t) {
				void 0 === t && (t = this.isHorizontal() ? "x" : "y");
				var e = this.params,
					i = this.rtlTranslate,
					s = this.translate,
					n = this.$wrapperEl;
				if (e.virtualTranslate) return i ? -s : s;
				var a = d.getTranslate(n[0], t);
				return i && (a = -a), a || 0
			},
			setTranslate: function(t, e) {
				var i = this.rtlTranslate,
					s = this.params,
					n = this.$wrapperEl,
					a = this.progress,
					o = 0,
					r = 0;
				this.isHorizontal() ? o = i ? -t : t : r = t, s.roundLengths && (o = Math.floor(o), r = Math.floor(r)), s.virtualTranslate || (c.transforms3d ? n.transform("translate3d(" + o + "px, " + r + "px, 0px)") : n.transform("translate(" + o + "px, " + r + "px)")), this.translate = this.isHorizontal() ? o : r;
				var l = this.maxTranslate() - this.minTranslate();
				(0 === l ? 0 : (t - this.minTranslate()) / l) !== a && this.updateProgress(t), this.emit("setTranslate", this.translate, e)
			},
			minTranslate: function() {
				return -this.snapGrid[0]
			},
			maxTranslate: function() {
				return -this.snapGrid[this.snapGrid.length - 1]
			}
		},
		m = {
			slideTo: function(t, e, i, s) {
				void 0 === t && (t = 0), void 0 === e && (e = this.params.speed), void 0 === i && (i = !0);
				var n = this,
					a = t;
				a < 0 && (a = 0);
				var o = n.params,
					r = n.snapGrid,
					l = n.slidesGrid,
					d = n.previousIndex,
					h = n.activeIndex,
					u = n.rtlTranslate,
					p = n.$wrapperEl;
				if (n.animating && o.preventIntercationOnTransition) return !1;
				var f = Math.floor(a / o.slidesPerGroup);
				f >= r.length && (f = r.length - 1), (h || o.initialSlide || 0) === (d || 0) && i && n.emit("beforeSlideChangeStart");
				var m, g = -r[f];
				if (n.updateProgress(g), o.normalizeSlideIndex)
					for (var v = 0; v < l.length; v += 1) - Math.floor(100 * g) >= Math.floor(100 * l[v]) && (a = v);
				if (n.initialized && a !== h) {
					if (!n.allowSlideNext && g < n.translate && g < n.minTranslate()) return !1;
					if (!n.allowSlidePrev && g > n.translate && g > n.maxTranslate() && (h || 0) !== a) return !1
				}
				return m = a > h ? "next" : a < h ? "prev" : "reset", u && -g === n.translate || !u && g === n.translate ? (n.updateActiveIndex(a), o.autoHeight && n.updateAutoHeight(), n.updateSlidesClasses(), "slide" !== o.effect && n.setTranslate(g), "reset" !== m && (n.transitionStart(i, m), n.transitionEnd(i, m)), !1) : (0 !== e && c.transition ? (n.setTransition(e), n.setTranslate(g), n.updateActiveIndex(a), n.updateSlidesClasses(), n.emit("beforeTransitionStart", e, s), n.transitionStart(i, m), n.animating || (n.animating = !0, p.transitionEnd(function() {
					n && !n.destroyed && n.transitionEnd(i, m)
				}))) : (n.setTransition(0), n.setTranslate(g), n.updateActiveIndex(a), n.updateSlidesClasses(), n.emit("beforeTransitionStart", e, s), n.transitionStart(i, m), n.transitionEnd(i, m)), !0)
			},
			slideToLoop: function(t, e, i, s) {
				void 0 === t && (t = 0), void 0 === e && (e = this.params.speed), void 0 === i && (i = !0);
				var n = t;
				return this.params.loop && (n += this.loopedSlides), this.slideTo(n, e, i, s)
			},
			slideNext: function(t, e, i) {
				void 0 === t && (t = this.params.speed), void 0 === e && (e = !0);
				var s = this.params,
					n = this.animating;
				return s.loop ? !n && (this.loopFix(), this._clientLeft = this.$wrapperEl[0].clientLeft, this.slideTo(this.activeIndex + s.slidesPerGroup, t, e, i)) : this.slideTo(this.activeIndex + s.slidesPerGroup, t, e, i)
			},
			slidePrev: function(t, e, i) {
				void 0 === t && (t = this.params.speed), void 0 === e && (e = !0);
				var s = this.params,
					n = this.animating;
				return s.loop ? !n && (this.loopFix(), this._clientLeft = this.$wrapperEl[0].clientLeft, this.slideTo(this.activeIndex - 1, t, e, i)) : this.slideTo(this.activeIndex - 1, t, e, i)
			},
			slideReset: function(t, e, i) {
				return void 0 === t && (t = this.params.speed), void 0 === e && (e = !0), this.slideTo(this.activeIndex, t, e, i)
			},
			slideToClosest: function(t, e, i) {
				void 0 === t && (t = this.params.speed), void 0 === e && (e = !0);
				var s = this.activeIndex,
					n = Math.floor(s / this.params.slidesPerGroup);
				if (n < this.snapGrid.length - 1) {
					var a = this.rtlTranslate ? this.translate : -this.translate,
						o = this.snapGrid[n];
					a - o > (this.snapGrid[n + 1] - o) / 2 && (s = this.params.slidesPerGroup)
				}
				return this.slideTo(s, t, e, i)
			},
			slideToClickedSlide: function() {
				var t, e = this,
					i = e.params,
					n = e.$wrapperEl,
					a = "auto" === i.slidesPerView ? e.slidesPerViewDynamic() : i.slidesPerView,
					o = e.clickedIndex;
				if (i.loop) {
					if (e.animating) return;
					t = parseInt(s(e.clickedSlide).attr("data-swiper-slide-index"), 10), i.centeredSlides ? o < e.loopedSlides - a / 2 || o > e.slides.length - e.loopedSlides + a / 2 ? (e.loopFix(), o = n.children("." + i.slideClass + '[data-swiper-slide-index="' + t + '"]:not(.' + i.slideDuplicateClass + ")").eq(0).index(), d.nextTick(function() {
						e.slideTo(o)
					})) : e.slideTo(o) : o > e.slides.length - a ? (e.loopFix(), o = n.children("." + i.slideClass + '[data-swiper-slide-index="' + t + '"]:not(.' + i.slideDuplicateClass + ")").eq(0).index(), d.nextTick(function() {
						e.slideTo(o)
					})) : e.slideTo(o)
				} else e.slideTo(o)
			}
		},
		g = {
			loopCreate: function() {
				var e = this,
					i = e.params,
					n = e.$wrapperEl;
				n.children("." + i.slideClass + "." + i.slideDuplicateClass).remove();
				var a = n.children("." + i.slideClass);
				if (i.loopFillGroupWithBlank) {
					var o = i.slidesPerGroup - a.length % i.slidesPerGroup;
					if (o !== i.slidesPerGroup) {
						for (var r = 0; r < o; r += 1) {
							var l = s(t.createElement("div")).addClass(i.slideClass + " " + i.slideBlankClass);
							n.append(l)
						}
						a = n.children("." + i.slideClass)
					}
				}
				"auto" !== i.slidesPerView || i.loopedSlides || (i.loopedSlides = a.length), e.loopedSlides = parseInt(i.loopedSlides || i.slidesPerView, 10), e.loopedSlides += i.loopAdditionalSlides, e.loopedSlides > a.length && (e.loopedSlides = a.length);
				var d = [],
					c = [];
				a.each(function(t, i) {
					var n = s(i);
					t < e.loopedSlides && c.push(i), t < a.length && t >= a.length - e.loopedSlides && d.push(i), n.attr("data-swiper-slide-index", t)
				});
				for (var h = 0; h < c.length; h += 1) n.append(s(c[h].cloneNode(!0)).addClass(i.slideDuplicateClass));
				for (var u = d.length - 1; u >= 0; u -= 1) n.prepend(s(d[u].cloneNode(!0)).addClass(i.slideDuplicateClass))
			},
			loopFix: function() {
				var t, e = this.params,
					i = this.activeIndex,
					s = this.slides,
					n = this.loopedSlides,
					a = this.allowSlidePrev,
					o = this.allowSlideNext,
					r = this.snapGrid,
					l = this.rtlTranslate;
				this.allowSlidePrev = !0, this.allowSlideNext = !0;
				var d = -r[i] - this.getTranslate();
				i < n ? (t = s.length - 3 * n + i, t += n, this.slideTo(t, 0, !1, !0) && 0 !== d && this.setTranslate((l ? -this.translate : this.translate) - d)) : ("auto" === e.slidesPerView && i >= 2 * n || i > s.length - 2 * e.slidesPerView) && (t = -s.length + i + n, t += n, this.slideTo(t, 0, !1, !0) && 0 !== d && this.setTranslate((l ? -this.translate : this.translate) - d)), this.allowSlidePrev = a, this.allowSlideNext = o
			},
			loopDestroy: function() {
				var t = this.$wrapperEl,
					e = this.params,
					i = this.slides;
				t.children("." + e.slideClass + "." + e.slideDuplicateClass).remove(), i.removeAttr("data-swiper-slide-index")
			}
		},
		v = {
			setGrabCursor: function(t) {
				if (!c.touch && this.params.simulateTouch) {
					var e = this.el;
					e.style.cursor = "move", e.style.cursor = t ? "-webkit-grabbing" : "-webkit-grab", e.style.cursor = t ? "-moz-grabbin" : "-moz-grab", e.style.cursor = t ? "grabbing" : "grab"
				}
			},
			unsetGrabCursor: function() {
				c.touch || (this.el.style.cursor = "")
			}
		},
		y = {
			appendSlide: function(t) {
				var e = this.$wrapperEl,
					i = this.params;
				if (i.loop && this.loopDestroy(), "object" == typeof t && "length" in t)
					for (var s = 0; s < t.length; s += 1) t[s] && e.append(t[s]);
				else e.append(t);
				i.loop && this.loopCreate(), i.observer && c.observer || this.update()
			},
			prependSlide: function(t) {
				var e = this.params,
					i = this.$wrapperEl,
					s = this.activeIndex;
				e.loop && this.loopDestroy();
				var n = s + 1;
				if ("object" == typeof t && "length" in t) {
					for (var a = 0; a < t.length; a += 1) t[a] && i.prepend(t[a]);
					n = s + t.length
				} else i.prepend(t);
				e.loop && this.loopCreate(), e.observer && c.observer || this.update(), this.slideTo(n, 0, !1)
			},
			removeSlide: function(t) {
				var e = this.params,
					i = this.$wrapperEl,
					s = this.activeIndex;
				e.loop && (this.loopDestroy(), this.slides = i.children("." + e.slideClass));
				var n, a = s;
				if ("object" == typeof t && "length" in t) {
					for (var o = 0; o < t.length; o += 1) n = t[o], this.slides[n] && this.slides.eq(n).remove(), n < a && (a -= 1);
					a = Math.max(a, 0)
				} else n = t, this.slides[n] && this.slides.eq(n).remove(), n < a && (a -= 1), a = Math.max(a, 0);
				e.loop && this.loopCreate(), e.observer && c.observer || this.update(), e.loop ? this.slideTo(a + this.loopedSlides, 0, !1) : this.slideTo(a, 0, !1)
			},
			removeAllSlides: function() {
				for (var t = [], e = 0; e < this.slides.length; e += 1) t.push(e);
				this.removeSlide(t)
			}
		},
		b = function() {
			var i = e.navigator.userAgent,
				s = {
					ios: !1,
					android: !1,
					androidChrome: !1,
					desktop: !1,
					windows: !1,
					iphone: !1,
					ipod: !1,
					ipad: !1,
					cordova: e.cordova || e.phonegap,
					phonegap: e.cordova || e.phonegap
				},
				n = i.match(/(Windows Phone);?[\s\/]+([\d.]+)?/),
				a = i.match(/(Android);?[\s\/]+([\d.]+)?/),
				o = i.match(/(iPad).*OS\s([\d_]+)/),
				r = i.match(/(iPod)(.*OS\s([\d_]+))?/),
				l = !o && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
			if (n && (s.os = "windows", s.osVersion = n[2], s.windows = !0), a && !n && (s.os = "android", s.osVersion = a[2], s.android = !0, s.androidChrome = i.toLowerCase().indexOf("chrome") >= 0), (o || l || r) && (s.os = "ios", s.ios = !0), l && !r && (s.osVersion = l[2].replace(/_/g, "."), s.iphone = !0), o && (s.osVersion = o[2].replace(/_/g, "."), s.ipad = !0), r && (s.osVersion = r[3] ? r[3].replace(/_/g, ".") : null, s.iphone = !0), s.ios && s.osVersion && i.indexOf("Version/") >= 0 && "10" === s.osVersion.split(".")[0] && (s.osVersion = i.toLowerCase().split("version/")[1].split(" ")[0]), s.desktop = !(s.os || s.android || s.webView), s.webView = (l || o || r) && i.match(/.*AppleWebKit(?!.*Safari)/i), s.os && "ios" === s.os) {
				var d = s.osVersion.split("."),
					c = t.querySelector('meta[name="viewport"]');
				s.minimalUi = !s.webView && (r || l) && (1 * d[0] == 7 ? 1 * d[1] >= 1 : 1 * d[0] > 7) && c && c.getAttribute("content").indexOf("minimal-ui") >= 0
			}
			return s.pixelRatio = e.devicePixelRatio || 1, s
		}();

	function w() {
		var t = this.params,
			e = this.el;
		if (!e || 0 !== e.offsetWidth) {
			t.breakpoints && this.setBreakpoint();
			var i = this.allowSlideNext,
				s = this.allowSlidePrev;
			if (this.allowSlideNext = !0, this.allowSlidePrev = !0, this.updateSize(), this.updateSlides(), t.freeMode) {
				var n = Math.min(Math.max(this.translate, this.maxTranslate()), this.minTranslate());
				this.setTranslate(n), this.updateActiveIndex(), this.updateSlidesClasses(), t.autoHeight && this.updateAutoHeight()
			} else this.updateSlidesClasses(), ("auto" === t.slidesPerView || t.slidesPerView > 1) && this.isEnd && !this.params.centeredSlides ? this.slideTo(this.slides.length - 1, 0, !1, !0) : this.slideTo(this.activeIndex, 0, !1, !0);
			this.allowSlidePrev = s, this.allowSlideNext = i
		}
	}
	var S = {
			attachEvents: function() {
				var i = this.params,
					n = this.touchEvents,
					a = this.el,
					o = this.wrapperEl;
				this.onTouchStart = function(i) {
					var n = this.touchEventsData,
						a = this.params,
						o = this.touches;
					if (!this.animating || !a.preventIntercationOnTransition) {
						var r = i;
						if (r.originalEvent && (r = r.originalEvent), n.isTouchEvent = "touchstart" === r.type, (n.isTouchEvent || !("which" in r) || 3 !== r.which) && (!n.isTouched || !n.isMoved))
							if (a.noSwiping && s(r.target).closest(a.noSwipingSelector ? a.noSwipingSelector : "." + a.noSwipingClass)[0]) this.allowClick = !0;
							else if (!a.swipeHandler || s(r).closest(a.swipeHandler)[0]) {
							o.currentX = "touchstart" === r.type ? r.targetTouches[0].pageX : r.pageX, o.currentY = "touchstart" === r.type ? r.targetTouches[0].pageY : r.pageY;
							var l = o.currentX,
								c = o.currentY;
							if (!(b.ios && !b.cordova && a.iOSEdgeSwipeDetection && l <= a.iOSEdgeSwipeThreshold && l >= e.screen.width - a.iOSEdgeSwipeThreshold)) {
								if (d.extend(n, {
										isTouched: !0,
										isMoved: !1,
										allowTouchCallbacks: !0,
										isScrolling: void 0,
										startMoving: void 0
									}), o.startX = l, o.startY = c, n.touchStartTime = d.now(), this.allowClick = !0, this.updateSize(), this.swipeDirection = void 0, a.threshold > 0 && (n.allowThresholdMove = !1), "touchstart" !== r.type) {
									var h = !0;
									s(r.target).is(n.formElements) && (h = !1), t.activeElement && s(t.activeElement).is(n.formElements) && t.activeElement !== r.target && t.activeElement.blur(), h && this.allowTouchMove && r.preventDefault()
								}
								this.emit("touchStart", r)
							}
						}
					}
				}.bind(this), this.onTouchMove = function(e) {
					var i = this.touchEventsData,
						n = this.params,
						a = this.touches,
						o = this.rtlTranslate,
						r = e;
					if (r.originalEvent && (r = r.originalEvent), i.isTouched) {
						if (!i.isTouchEvent || "mousemove" !== r.type) {
							var l = "touchmove" === r.type ? r.targetTouches[0].pageX : r.pageX,
								c = "touchmove" === r.type ? r.targetTouches[0].pageY : r.pageY;
							if (r.preventedByNestedSwiper) return a.startX = l, void(a.startY = c);
							if (!this.allowTouchMove) return this.allowClick = !1, void(i.isTouched && (d.extend(a, {
								startX: l,
								startY: c,
								currentX: l,
								currentY: c
							}), i.touchStartTime = d.now()));
							if (i.isTouchEvent && n.touchReleaseOnEdges && !n.loop)
								if (this.isVertical()) {
									if (c < a.startY && this.translate <= this.maxTranslate() || c > a.startY && this.translate >= this.minTranslate()) return i.isTouched = !1, void(i.isMoved = !1)
								} else if (l < a.startX && this.translate <= this.maxTranslate() || l > a.startX && this.translate >= this.minTranslate()) return;
							if (i.isTouchEvent && t.activeElement && r.target === t.activeElement && s(r.target).is(i.formElements)) return i.isMoved = !0, void(this.allowClick = !1);
							if (i.allowTouchCallbacks && this.emit("touchMove", r), !(r.targetTouches && r.targetTouches.length > 1)) {
								a.currentX = l, a.currentY = c;
								var h, u = a.currentX - a.startX,
									p = a.currentY - a.startY;
								if (void 0 === i.isScrolling && (this.isHorizontal() && a.currentY === a.startY || this.isVertical() && a.currentX === a.startX ? i.isScrolling = !1 : u * u + p * p >= 25 && (h = 180 * Math.atan2(Math.abs(p), Math.abs(u)) / Math.PI, i.isScrolling = this.isHorizontal() ? h > n.touchAngle : 90 - h > n.touchAngle)), i.isScrolling && this.emit("touchMoveOpposite", r), "undefined" == typeof startMoving && (a.currentX === a.startX && a.currentY === a.startY || (i.startMoving = !0)), i.isScrolling) i.isTouched = !1;
								else if (i.startMoving) {
									this.allowClick = !1, r.preventDefault(), n.touchMoveStopPropagation && !n.nested && r.stopPropagation(), i.isMoved || (n.loop && this.loopFix(), i.startTranslate = this.getTranslate(), this.setTransition(0), this.animating && this.$wrapperEl.trigger("webkitTransitionEnd transitionend"), i.allowMomentumBounce = !1, !n.grabCursor || !0 !== this.allowSlideNext && !0 !== this.allowSlidePrev || this.setGrabCursor(!0), this.emit("sliderFirstMove", r)), this.emit("sliderMove", r), i.isMoved = !0;
									var f = this.isHorizontal() ? u : p;
									a.diff = f, f *= n.touchRatio, o && (f = -f), this.swipeDirection = f > 0 ? "prev" : "next", i.currentTranslate = f + i.startTranslate;
									var m = !0,
										g = n.resistanceRatio;
									if (n.touchReleaseOnEdges && (g = 0), f > 0 && i.currentTranslate > this.minTranslate() ? (m = !1, n.resistance && (i.currentTranslate = this.minTranslate() - 1 + Math.pow(-this.minTranslate() + i.startTranslate + f, g))) : f < 0 && i.currentTranslate < this.maxTranslate() && (m = !1, n.resistance && (i.currentTranslate = this.maxTranslate() + 1 - Math.pow(this.maxTranslate() - i.startTranslate - f, g))), m && (r.preventedByNestedSwiper = !0), !this.allowSlideNext && "next" === this.swipeDirection && i.currentTranslate < i.startTranslate && (i.currentTranslate = i.startTranslate), !this.allowSlidePrev && "prev" === this.swipeDirection && i.currentTranslate > i.startTranslate && (i.currentTranslate = i.startTranslate), n.threshold > 0) {
										if (!(Math.abs(f) > n.threshold || i.allowThresholdMove)) return void(i.currentTranslate = i.startTranslate);
										if (!i.allowThresholdMove) return i.allowThresholdMove = !0, a.startX = a.currentX, a.startY = a.currentY, i.currentTranslate = i.startTranslate, void(a.diff = this.isHorizontal() ? a.currentX - a.startX : a.currentY - a.startY)
									}
									n.followFinger && ((n.freeMode || n.watchSlidesProgress || n.watchSlidesVisibility) && (this.updateActiveIndex(), this.updateSlidesClasses()), n.freeMode && (0 === i.velocities.length && i.velocities.push({
										position: a[this.isHorizontal() ? "startX" : "startY"],
										time: i.touchStartTime
									}), i.velocities.push({
										position: a[this.isHorizontal() ? "currentX" : "currentY"],
										time: d.now()
									})), this.updateProgress(i.currentTranslate), this.setTranslate(i.currentTranslate))
								}
							}
						}
					} else i.startMoving && i.isScrolling && this.emit("touchMoveOpposite", r)
				}.bind(this), this.onTouchEnd = function(t) {
					var e = this,
						i = e.touchEventsData,
						s = e.params,
						n = e.touches,
						a = e.rtlTranslate,
						o = e.$wrapperEl,
						r = e.slidesGrid,
						l = e.snapGrid,
						c = t;
					if (c.originalEvent && (c = c.originalEvent), i.allowTouchCallbacks && e.emit("touchEnd", c), i.allowTouchCallbacks = !1, !i.isTouched) return i.isMoved && s.grabCursor && e.setGrabCursor(!1), i.isMoved = !1, void(i.startMoving = !1);
					s.grabCursor && i.isMoved && i.isTouched && (!0 === e.allowSlideNext || !0 === e.allowSlidePrev) && e.setGrabCursor(!1);
					var h, u = d.now(),
						p = u - i.touchStartTime;
					if (e.allowClick && (e.updateClickedSlide(c), e.emit("tap", c), p < 300 && u - i.lastClickTime > 300 && (i.clickTimeout && clearTimeout(i.clickTimeout), i.clickTimeout = d.nextTick(function() {
							e && !e.destroyed && e.emit("click", c)
						}, 300)), p < 300 && u - i.lastClickTime < 300 && (i.clickTimeout && clearTimeout(i.clickTimeout), e.emit("doubleTap", c))), i.lastClickTime = d.now(), d.nextTick(function() {
							e.destroyed || (e.allowClick = !0)
						}), !i.isTouched || !i.isMoved || !e.swipeDirection || 0 === n.diff || i.currentTranslate === i.startTranslate) return i.isTouched = !1, i.isMoved = !1, void(i.startMoving = !1);
					if (i.isTouched = !1, i.isMoved = !1, i.startMoving = !1, h = s.followFinger ? a ? e.translate : -e.translate : -i.currentTranslate, s.freeMode) {
						if (h < -e.minTranslate()) return void e.slideTo(e.activeIndex);
						if (h > -e.maxTranslate()) return void(e.slides.length < l.length ? e.slideTo(l.length - 1) : e.slideTo(e.slides.length - 1));
						if (s.freeModeMomentum) {
							if (i.velocities.length > 1) {
								var f = i.velocities.pop(),
									m = i.velocities.pop(),
									g = f.position - m.position,
									v = f.time - m.time;
								e.velocity = g / v, e.velocity /= 2, Math.abs(e.velocity) < s.freeModeMinimumVelocity && (e.velocity = 0), (v > 150 || d.now() - f.time > 300) && (e.velocity = 0)
							} else e.velocity = 0;
							e.velocity *= s.freeModeMomentumVelocityRatio, i.velocities.length = 0;
							var y = 1e3 * s.freeModeMomentumRatio,
								b = e.velocity * y,
								w = e.translate + b;
							a && (w = -w);
							var S, x = !1,
								T = 20 * Math.abs(e.velocity) * s.freeModeMomentumBounceRatio;
							if (w < e.maxTranslate()) s.freeModeMomentumBounce ? (w + e.maxTranslate() < -T && (w = e.maxTranslate() - T), S = e.maxTranslate(), x = !0, i.allowMomentumBounce = !0) : w = e.maxTranslate();
							else if (w > e.minTranslate()) s.freeModeMomentumBounce ? (w - e.minTranslate() > T && (w = e.minTranslate() + T), S = e.minTranslate(), x = !0, i.allowMomentumBounce = !0) : w = e.minTranslate();
							else if (s.freeModeSticky) {
								for (var C, _ = 0; _ < l.length; _ += 1)
									if (l[_] > -w) {
										C = _;
										break
									} w = -(w = Math.abs(l[C] - w) < Math.abs(l[C - 1] - w) || "next" === e.swipeDirection ? l[C] : l[C - 1])
							}
							if (0 !== e.velocity) y = a ? Math.abs((-w - e.translate) / e.velocity) : Math.abs((w - e.translate) / e.velocity);
							else if (s.freeModeSticky) return void e.slideToClosest();
							s.freeModeMomentumBounce && x ? (e.updateProgress(S), e.setTransition(y), e.setTranslate(w), e.transitionStart(!0, e.swipeDirection), e.animating = !0, o.transitionEnd(function() {
								e && !e.destroyed && i.allowMomentumBounce && (e.emit("momentumBounce"), e.setTransition(s.speed), e.setTranslate(S), o.transitionEnd(function() {
									e && !e.destroyed && e.transitionEnd()
								}))
							})) : e.velocity ? (e.updateProgress(w), e.setTransition(y), e.setTranslate(w), e.transitionStart(!0, e.swipeDirection), e.animating || (e.animating = !0, o.transitionEnd(function() {
								e && !e.destroyed && e.transitionEnd()
							}))) : e.updateProgress(w), e.updateActiveIndex(), e.updateSlidesClasses()
						} else if (s.freeModeSticky) return void e.slideToClosest();
						(!s.freeModeMomentum || p >= s.longSwipesMs) && (e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses())
					} else {
						for (var E = 0, P = e.slidesSizesGrid[0], k = 0; k < r.length; k += s.slidesPerGroup) void 0 !== r[k + s.slidesPerGroup] ? h >= r[k] && h < r[k + s.slidesPerGroup] && (E = k, P = r[k + s.slidesPerGroup] - r[k]) : h >= r[k] && (E = k, P = r[r.length - 1] - r[r.length - 2]);
						var $ = (h - r[E]) / P;
						if (p > s.longSwipesMs) {
							if (!s.longSwipes) return void e.slideTo(e.activeIndex);
							"next" === e.swipeDirection && ($ >= s.longSwipesRatio ? e.slideTo(E + s.slidesPerGroup) : e.slideTo(E)), "prev" === e.swipeDirection && ($ > 1 - s.longSwipesRatio ? e.slideTo(E + s.slidesPerGroup) : e.slideTo(E))
						} else {
							if (!s.shortSwipes) return void e.slideTo(e.activeIndex);
							"next" === e.swipeDirection && e.slideTo(E + s.slidesPerGroup), "prev" === e.swipeDirection && e.slideTo(E)
						}
					}
				}.bind(this), this.onClick = function(t) {
					this.allowClick || (this.params.preventClicks && t.preventDefault(), this.params.preventClicksPropagation && this.animating && (t.stopPropagation(), t.stopImmediatePropagation()))
				}.bind(this);
				var r = "container" === i.touchEventsTarget ? a : o,
					l = !!i.nested;
				if (c.touch || !c.pointerEvents && !c.prefixedPointerEvents) {
					if (c.touch) {
						var h = !("touchstart" !== n.start || !c.passiveListener || !i.passiveListeners) && {
							passive: !0,
							capture: !1
						};
						r.addEventListener(n.start, this.onTouchStart, h), r.addEventListener(n.move, this.onTouchMove, c.passiveListener ? {
							passive: !1,
							capture: l
						} : l), r.addEventListener(n.end, this.onTouchEnd, h)
					}(i.simulateTouch && !b.ios && !b.android || i.simulateTouch && !c.touch && b.ios) && (r.addEventListener("mousedown", this.onTouchStart, !1), t.addEventListener("mousemove", this.onTouchMove, l), t.addEventListener("mouseup", this.onTouchEnd, !1))
				} else r.addEventListener(n.start, this.onTouchStart, !1), t.addEventListener(n.move, this.onTouchMove, l), t.addEventListener(n.end, this.onTouchEnd, !1);
				(i.preventClicks || i.preventClicksPropagation) && r.addEventListener("click", this.onClick, !0), this.on("resize observerUpdate", w, !0)
			},
			detachEvents: function() {
				var e = this.params,
					i = this.touchEvents,
					s = this.el,
					n = this.wrapperEl,
					a = "container" === e.touchEventsTarget ? s : n,
					o = !!e.nested;
				if (c.touch || !c.pointerEvents && !c.prefixedPointerEvents) {
					if (c.touch) {
						var r = !("onTouchStart" !== i.start || !c.passiveListener || !e.passiveListeners) && {
							passive: !0,
							capture: !1
						};
						a.removeEventListener(i.start, this.onTouchStart, r), a.removeEventListener(i.move, this.onTouchMove, o), a.removeEventListener(i.end, this.onTouchEnd, r)
					}(e.simulateTouch && !b.ios && !b.android || e.simulateTouch && !c.touch && b.ios) && (a.removeEventListener("mousedown", this.onTouchStart, !1), t.removeEventListener("mousemove", this.onTouchMove, o), t.removeEventListener("mouseup", this.onTouchEnd, !1))
				} else a.removeEventListener(i.start, this.onTouchStart, !1), t.removeEventListener(i.move, this.onTouchMove, o), t.removeEventListener(i.end, this.onTouchEnd, !1);
				(e.preventClicks || e.preventClicksPropagation) && a.removeEventListener("click", this.onClick, !0), this.off("resize observerUpdate", w)
			}
		},
		x = {
			setBreakpoint: function() {
				var t = this.activeIndex,
					e = this.loopedSlides;
				void 0 === e && (e = 0);
				var i = this.params,
					s = i.breakpoints;
				if (s && (!s || 0 !== Object.keys(s).length)) {
					var n = this.getBreakpoint(s);
					if (n && this.currentBreakpoint !== n) {
						var a = n in s ? s[n] : this.originalParams,
							o = i.loop && a.slidesPerView !== i.slidesPerView;
						d.extend(this.params, a), d.extend(this, {
							allowTouchMove: this.params.allowTouchMove,
							allowSlideNext: this.params.allowSlideNext,
							allowSlidePrev: this.params.allowSlidePrev
						}), this.currentBreakpoint = n, o && (this.loopDestroy(), this.loopCreate(), this.updateSlides(), this.slideTo(t - e + this.loopedSlides, 0, !1)), this.emit("breakpoint", a)
					}
				}
			},
			getBreakpoint: function(t) {
				if (t) {
					var i = !1,
						s = [];
					Object.keys(t).forEach(function(t) {
						s.push(t)
					}), s.sort(function(t, e) {
						return parseInt(t, 10) - parseInt(e, 10)
					});
					for (var n = 0; n < s.length; n += 1) {
						var a = s[n];
						a >= e.innerWidth && !i && (i = a)
					}
					return i || "max"
				}
			}
		},
		T = function() {
			return {
				isIE: !!e.navigator.userAgent.match(/Trident/g) || !!e.navigator.userAgent.match(/MSIE/g),
				isSafari: (t = e.navigator.userAgent.toLowerCase(), t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0),
				isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)
			};
			var t
		}(),
		C = {
			init: !0,
			direction: "horizontal",
			touchEventsTarget: "container",
			initialSlide: 0,
			speed: 300,
			preventIntercationOnTransition: !1,
			iOSEdgeSwipeDetection: !1,
			iOSEdgeSwipeThreshold: 20,
			freeMode: !1,
			freeModeMomentum: !0,
			freeModeMomentumRatio: 1,
			freeModeMomentumBounce: !0,
			freeModeMomentumBounceRatio: 1,
			freeModeMomentumVelocityRatio: 1,
			freeModeSticky: !1,
			freeModeMinimumVelocity: .02,
			autoHeight: !1,
			setWrapperSize: !1,
			virtualTranslate: !1,
			effect: "slide",
			breakpoints: void 0,
			spaceBetween: 0,
			slidesPerView: 1,
			slidesPerColumn: 1,
			slidesPerColumnFill: "column",
			slidesPerGroup: 1,
			centeredSlides: !1,
			slidesOffsetBefore: 0,
			slidesOffsetAfter: 0,
			normalizeSlideIndex: !0,
			watchOverflow: !1,
			roundLengths: !1,
			touchRatio: 1,
			touchAngle: 45,
			simulateTouch: !0,
			shortSwipes: !0,
			longSwipes: !0,
			longSwipesRatio: .5,
			longSwipesMs: 300,
			followFinger: !0,
			allowTouchMove: !0,
			threshold: 0,
			touchMoveStopPropagation: !0,
			touchReleaseOnEdges: !1,
			uniqueNavElements: !0,
			resistance: !0,
			resistanceRatio: .85,
			watchSlidesProgress: !1,
			watchSlidesVisibility: !1,
			grabCursor: !1,
			preventClicks: !0,
			preventClicksPropagation: !0,
			slideToClickedSlide: !1,
			preloadImages: !0,
			updateOnImagesReady: !0,
			loop: !1,
			loopAdditionalSlides: 0,
			loopedSlides: null,
			loopFillGroupWithBlank: !1,
			allowSlidePrev: !0,
			allowSlideNext: !0,
			swipeHandler: null,
			noSwiping: !0,
			noSwipingClass: "swiper-no-swiping",
			noSwipingSelector: null,
			passiveListeners: !0,
			containerModifierClass: "swiper-container-",
			slideClass: "swiper-slide",
			slideBlankClass: "swiper-slide-invisible-blank",
			slideActiveClass: "swiper-slide-active",
			slideDuplicateActiveClass: "swiper-slide-duplicate-active",
			slideVisibleClass: "swiper-slide-visible",
			slideDuplicateClass: "swiper-slide-duplicate",
			slideNextClass: "swiper-slide-next",
			slideDuplicateNextClass: "swiper-slide-duplicate-next",
			slidePrevClass: "swiper-slide-prev",
			slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
			wrapperClass: "swiper-wrapper",
			runCallbacksOnInit: !0
		},
		_ = {
			update: p,
			translate: f,
			transition: {
				setTransition: function(t, e) {
					this.$wrapperEl.transition(t), this.emit("setTransition", t, e)
				},
				transitionStart: function(t, e) {
					void 0 === t && (t = !0);
					var i = this.activeIndex,
						s = this.params,
						n = this.previousIndex;
					s.autoHeight && this.updateAutoHeight();
					var a = e;
					if (a || (a = i > n ? "next" : i < n ? "prev" : "reset"), this.emit("transitionStart"), t && i !== n) {
						if ("reset" === a) return void this.emit("slideResetTransitionStart");
						this.emit("slideChangeTransitionStart"), "next" === a ? this.emit("slideNextTransitionStart") : this.emit("slidePrevTransitionStart")
					}
				},
				transitionEnd: function(t, e) {
					void 0 === t && (t = !0);
					var i = this.activeIndex,
						s = this.previousIndex;
					this.animating = !1, this.setTransition(0);
					var n = e;
					if (n || (n = i > s ? "next" : i < s ? "prev" : "reset"), this.emit("transitionEnd"), t && i !== s) {
						if ("reset" === n) return void this.emit("slideResetTransitionEnd");
						this.emit("slideChangeTransitionEnd"), "next" === n ? this.emit("slideNextTransitionEnd") : this.emit("slidePrevTransitionEnd")
					}
				}
			},
			slide: m,
			loop: g,
			grabCursor: v,
			manipulation: y,
			events: S,
			breakpoints: x,
			checkOverflow: {
				checkOverflow: function() {
					var t = this.isLocked;
					this.isLocked = 1 === this.snapGrid.length, this.allowTouchMove = !this.isLocked, t && t !== this.isLocked && (this.isEnd = !1, this.navigation.update())
				}
			},
			classes: {
				addClasses: function() {
					var t = this.classNames,
						e = this.params,
						i = this.rtl,
						s = this.$el,
						n = [];
					n.push(e.direction), e.freeMode && n.push("free-mode"), c.flexbox || n.push("no-flexbox"), e.autoHeight && n.push("autoheight"), i && n.push("rtl"), e.slidesPerColumn > 1 && n.push("multirow"), b.android && n.push("android"), b.ios && n.push("ios"), T.isIE && (c.pointerEvents || c.prefixedPointerEvents) && n.push("wp8-" + e.direction), n.forEach(function(i) {
						t.push(e.containerModifierClass + i)
					}), s.addClass(t.join(" "))
				},
				removeClasses: function() {
					var t = this.$el,
						e = this.classNames;
					t.removeClass(e.join(" "))
				}
			},
			images: {
				loadImage: function(t, i, s, n, a, o) {
					var r;

					function l() {
						o && o()
					}
					t.complete && a ? l() : i ? ((r = new e.Image).onload = l, r.onerror = l, n && (r.sizes = n), s && (r.srcset = s), i && (r.src = i)) : l()
				},
				preloadImages: function() {
					var t = this;

					function e() {
						null != t && t && !t.destroyed && (void 0 !== t.imagesLoaded && (t.imagesLoaded += 1), t.imagesLoaded === t.imagesToLoad.length && (t.params.updateOnImagesReady && t.update(), t.emit("imagesReady")))
					}
					t.imagesToLoad = t.$el.find("img");
					for (var i = 0; i < t.imagesToLoad.length; i += 1) {
						var s = t.imagesToLoad[i];
						t.loadImage(s, s.currentSrc || s.getAttribute("src"), s.srcset || s.getAttribute("srcset"), s.sizes || s.getAttribute("sizes"), !0, e)
					}
				}
			}
		},
		E = {},
		P = function(t) {
			function e() {
				for (var i, n, a, o = [], r = arguments.length; r--;) o[r] = arguments[r];
				1 === o.length && o[0].constructor && o[0].constructor === Object ? a = o[0] : (n = (i = o)[0], a = i[1]), a || (a = {}), a = d.extend({}, a), n && !a.el && (a.el = n), t.call(this, a), Object.keys(_).forEach(function(t) {
					Object.keys(_[t]).forEach(function(i) {
						e.prototype[i] || (e.prototype[i] = _[t][i])
					})
				});
				var l = this;
				void 0 === l.modules && (l.modules = {}), Object.keys(l.modules).forEach(function(t) {
					var e = l.modules[t];
					if (e.params) {
						var i = Object.keys(e.params)[0],
							s = e.params[i];
						if ("object" != typeof s) return;
						if (!(i in a && "enabled" in s)) return;
						!0 === a[i] && (a[i] = {
							enabled: !0
						}), "object" != typeof a[i] || "enabled" in a[i] || (a[i].enabled = !0), a[i] || (a[i] = {
							enabled: !1
						})
					}
				});
				var h = d.extend({}, C);
				l.useModulesParams(h), l.params = d.extend({}, h, E, a), l.originalParams = d.extend({}, l.params), l.passedParams = d.extend({}, a), l.$ = s;
				var u = s(l.params.el);
				if (n = u[0]) {
					if (u.length > 1) {
						var p = [];
						return u.each(function(t, i) {
							var s = d.extend({}, a, {
								el: i
							});
							p.push(new e(s))
						}), p
					}
					n.swiper = l, u.data("swiper", l);
					var f, m, g = u.children("." + l.params.wrapperClass);
					return d.extend(l, {
						$el: u,
						el: n,
						$wrapperEl: g,
						wrapperEl: g[0],
						classNames: [],
						slides: s(),
						slidesGrid: [],
						snapGrid: [],
						slidesSizesGrid: [],
						isHorizontal: function() {
							return "horizontal" === l.params.direction
						},
						isVertical: function() {
							return "vertical" === l.params.direction
						},
						rtl: "rtl" === n.dir.toLowerCase() || "rtl" === u.css("direction"),
						rtlTranslate: "horizontal" === l.params.direction && ("rtl" === n.dir.toLowerCase() || "rtl" === u.css("direction")),
						wrongRTL: "-webkit-box" === g.css("display"),
						activeIndex: 0,
						realIndex: 0,
						isBeginning: !0,
						isEnd: !1,
						translate: 0,
						progress: 0,
						velocity: 0,
						animating: !1,
						allowSlideNext: l.params.allowSlideNext,
						allowSlidePrev: l.params.allowSlidePrev,
						touchEvents: (f = ["touchstart", "touchmove", "touchend"], m = ["mousedown", "mousemove", "mouseup"], c.pointerEvents ? m = ["pointerdown", "pointermove", "pointerup"] : c.prefixedPointerEvents && (m = ["MSPointerDown", "MSPointerMove", "MSPointerUp"]), l.touchEventsTouch = {
							start: f[0],
							move: f[1],
							end: f[2]
						}, l.touchEventsDesktop = {
							start: m[0],
							move: m[1],
							end: m[2]
						}, c.touch || !l.params.simulateTouch ? l.touchEventsTouch : l.touchEventsDesktop),
						touchEventsData: {
							isTouched: void 0,
							isMoved: void 0,
							allowTouchCallbacks: void 0,
							touchStartTime: void 0,
							isScrolling: void 0,
							currentTranslate: void 0,
							startTranslate: void 0,
							allowThresholdMove: void 0,
							formElements: "input, select, option, textarea, button, video",
							lastClickTime: d.now(),
							clickTimeout: void 0,
							velocities: [],
							allowMomentumBounce: void 0,
							isTouchEvent: void 0,
							startMoving: void 0
						},
						allowClick: !0,
						allowTouchMove: l.params.allowTouchMove,
						touches: {
							startX: 0,
							startY: 0,
							currentX: 0,
							currentY: 0,
							diff: 0
						},
						imagesToLoad: [],
						imagesLoaded: 0
					}), l.useModules(), l.params.init && l.init(), l
				}
			}
			t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
			var i = {
				extendedDefaults: {
					configurable: !0
				},
				defaults: {
					configurable: !0
				},
				Class: {
					configurable: !0
				},
				$: {
					configurable: !0
				}
			};
			return e.prototype.slidesPerViewDynamic = function() {
				var t = this.params,
					e = this.slides,
					i = this.slidesGrid,
					s = this.size,
					n = this.activeIndex,
					a = 1;
				if (t.centeredSlides) {
					for (var o, r = e[n].swiperSlideSize, l = n + 1; l < e.length; l += 1) e[l] && !o && (a += 1, (r += e[l].swiperSlideSize) > s && (o = !0));
					for (var d = n - 1; d >= 0; d -= 1) e[d] && !o && (a += 1, (r += e[d].swiperSlideSize) > s && (o = !0))
				} else
					for (var c = n + 1; c < e.length; c += 1) i[c] - i[n] < s && (a += 1);
				return a
			}, e.prototype.update = function() {
				var t = this;

				function e() {
					var e = t.rtlTranslate ? -1 * t.translate : t.translate,
						i = Math.min(Math.max(e, t.maxTranslate()), t.minTranslate());
					t.setTranslate(i), t.updateActiveIndex(), t.updateSlidesClasses()
				}
				t && !t.destroyed && (t.updateSize(), t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), t.params.freeMode ? (e(), t.params.autoHeight && t.updateAutoHeight()) : (("auto" === t.params.slidesPerView || t.params.slidesPerView > 1) && t.isEnd && !t.params.centeredSlides ? t.slideTo(t.slides.length - 1, 0, !1, !0) : t.slideTo(t.activeIndex, 0, !1, !0)) || e(), t.emit("update"))
			}, e.prototype.init = function() {
				this.initialized || (this.emit("beforeInit"), this.params.breakpoints && this.setBreakpoint(), this.addClasses(), this.params.loop && this.loopCreate(), this.updateSize(), this.updateSlides(), this.params.watchOverflow && this.checkOverflow(), this.params.grabCursor && this.setGrabCursor(), this.params.preloadImages && this.preloadImages(), this.params.loop ? this.slideTo(this.params.initialSlide + this.loopedSlides, 0, this.params.runCallbacksOnInit) : this.slideTo(this.params.initialSlide, 0, this.params.runCallbacksOnInit), this.attachEvents(), this.initialized = !0, this.emit("init"))
			}, e.prototype.destroy = function(t, e) {
				void 0 === t && (t = !0), void 0 === e && (e = !0);
				var i = this,
					s = i.params,
					n = i.$el,
					a = i.$wrapperEl,
					o = i.slides;
				i.emit("beforeDestroy"), i.initialized = !1, i.detachEvents(), s.loop && i.loopDestroy(), e && (i.removeClasses(), n.removeAttr("style"), a.removeAttr("style"), o && o.length && o.removeClass([s.slideVisibleClass, s.slideActiveClass, s.slideNextClass, s.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index").removeAttr("data-swiper-column").removeAttr("data-swiper-row")), i.emit("destroy"), Object.keys(i.eventsListeners).forEach(function(t) {
					i.off(t)
				}), !1 !== t && (i.$el[0].swiper = null, i.$el.data("swiper", null), d.deleteProps(i)), i.destroyed = !0
			}, e.extendDefaults = function(t) {
				d.extend(E, t)
			}, i.extendedDefaults.get = function() {
				return E
			}, i.defaults.get = function() {
				return C
			}, i.Class.get = function() {
				return t
			}, i.$.get = function() {
				return s
			}, Object.defineProperties(e, i), e
		}(h),
		k = {
			name: "device",
			proto: {
				device: b
			},
			static: {
				device: b
			}
		},
		$ = {
			name: "support",
			proto: {
				support: c
			},
			static: {
				support: c
			}
		},
		M = {
			name: "browser",
			proto: {
				browser: T
			},
			static: {
				browser: T
			}
		},
		D = {
			name: "resize",
			create: function() {
				var t = this;
				d.extend(t, {
					resize: {
						resizeHandler: function() {
							t && !t.destroyed && t.initialized && (t.emit("beforeResize"), t.emit("resize"))
						},
						orientationChangeHandler: function() {
							t && !t.destroyed && t.initialized && t.emit("orientationchange")
						}
					}
				})
			},
			on: {
				init: function() {
					e.addEventListener("resize", this.resize.resizeHandler), e.addEventListener("orientationchange", this.resize.orientationChangeHandler)
				},
				destroy: function() {
					e.removeEventListener("resize", this.resize.resizeHandler), e.removeEventListener("orientationchange", this.resize.orientationChangeHandler)
				}
			}
		},
		O = {
			func: e.MutationObserver || e.WebkitMutationObserver,
			attach: function(t, e) {
				void 0 === e && (e = {});
				var i = this,
					s = new(0, O.func)(function(t) {
						t.forEach(function(t) {
							i.emit("observerUpdate", t)
						})
					});
				s.observe(t, {
					attributes: void 0 === e.attributes || e.attributes,
					childList: void 0 === e.childList || e.childList,
					characterData: void 0 === e.characterData || e.characterData
				}), i.observer.observers.push(s)
			},
			init: function() {
				if (c.observer && this.params.observer) {
					if (this.params.observeParents)
						for (var t = this.$el.parents(), e = 0; e < t.length; e += 1) this.observer.attach(t[e]);
					this.observer.attach(this.$el[0], {
						childList: !1
					}), this.observer.attach(this.$wrapperEl[0], {
						attributes: !1
					})
				}
			},
			destroy: function() {
				this.observer.observers.forEach(function(t) {
					t.disconnect()
				}), this.observer.observers = []
			}
		},
		z = {
			name: "observer",
			params: {
				observer: !1,
				observeParents: !1
			},
			create: function() {
				d.extend(this, {
					observer: {
						init: O.init.bind(this),
						attach: O.attach.bind(this),
						destroy: O.destroy.bind(this),
						observers: []
					}
				})
			},
			on: {
				init: function() {
					this.observer.init()
				},
				destroy: function() {
					this.observer.destroy()
				}
			}
		},
		A = {
			update: function(t) {
				var e = this,
					i = e.params,
					s = i.slidesPerView,
					n = i.slidesPerGroup,
					a = i.centeredSlides,
					o = e.virtual,
					r = o.from,
					l = o.to,
					c = o.slides,
					h = o.slidesGrid,
					u = o.renderSlide,
					p = o.offset;
				e.updateActiveIndex();
				var f, m, g, v = e.activeIndex || 0;
				f = e.rtlTranslate ? "right" : e.isHorizontal() ? "left" : "top", a ? (m = Math.floor(s / 2) + n, g = Math.floor(s / 2) + n) : (m = s + (n - 1), g = n);
				var y = Math.max((v || 0) - g, 0),
					b = Math.min((v || 0) + m, c.length - 1),
					w = (e.slidesGrid[y] || 0) - (e.slidesGrid[0] || 0);

				function S() {
					e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.lazy && e.params.lazy.enabled && e.lazy.load()
				}
				if (d.extend(e.virtual, {
						from: y,
						to: b,
						offset: w,
						slidesGrid: e.slidesGrid
					}), r === y && l === b && !t) return e.slidesGrid !== h && w !== p && e.slides.css(f, w + "px"), void e.updateProgress();
				if (e.params.virtual.renderExternal) return e.params.virtual.renderExternal.call(e, {
					offset: w,
					from: y,
					to: b,
					slides: function() {
						for (var t = [], e = y; e <= b; e += 1) t.push(c[e]);
						return t
					}()
				}), void S();
				var x = [],
					T = [];
				if (t) e.$wrapperEl.find("." + e.params.slideClass).remove();
				else
					for (var C = r; C <= l; C += 1)(C < y || C > b) && e.$wrapperEl.find("." + e.params.slideClass + '[data-swiper-slide-index="' + C + '"]').remove();
				for (var _ = 0; _ < c.length; _ += 1) _ >= y && _ <= b && (void 0 === l || t ? T.push(_) : (_ > l && T.push(_), _ < r && x.push(_)));
				T.forEach(function(t) {
					e.$wrapperEl.append(u(c[t], t))
				}), x.sort(function(t, e) {
					return t < e
				}).forEach(function(t) {
					e.$wrapperEl.prepend(u(c[t], t))
				}), e.$wrapperEl.children(".swiper-slide").css(f, w + "px"), S()
			},
			renderSlide: function(t, e) {
				var i = this.params.virtual;
				if (i.cache && this.virtual.cache[e]) return this.virtual.cache[e];
				var n = i.renderSlide ? s(i.renderSlide.call(this, t, e)) : s('<div class="' + this.params.slideClass + '" data-swiper-slide-index="' + e + '">' + t + "</div>");
				return n.attr("data-swiper-slide-index") || n.attr("data-swiper-slide-index", e), i.cache && (this.virtual.cache[e] = n), n
			},
			appendSlide: function(t) {
				this.virtual.slides.push(t), this.virtual.update(!0)
			},
			prependSlide: function(t) {
				if (this.virtual.slides.unshift(t), this.params.virtual.cache) {
					var e = this.virtual.cache,
						i = {};
					Object.keys(e).forEach(function(t) {
						i[t + 1] = e[t]
					}), this.virtual.cache = i
				}
				this.virtual.update(!0), this.slideNext(0)
			}
		},
		I = {
			name: "virtual",
			params: {
				virtual: {
					enabled: !1,
					slides: [],
					cache: !0,
					renderSlide: null,
					renderExternal: null
				}
			},
			create: function() {
				d.extend(this, {
					virtual: {
						update: A.update.bind(this),
						appendSlide: A.appendSlide.bind(this),
						prependSlide: A.prependSlide.bind(this),
						renderSlide: A.renderSlide.bind(this),
						slides: this.params.virtual.slides,
						cache: {}
					}
				})
			},
			on: {
				beforeInit: function() {
					if (this.params.virtual.enabled) {
						this.classNames.push(this.params.containerModifierClass + "virtual");
						var t = {
							watchSlidesProgress: !0
						};
						d.extend(this.params, t), d.extend(this.originalParams, t), this.virtual.update()
					}
				},
				setTranslate: function() {
					this.params.virtual.enabled && this.virtual.update()
				}
			}
		},
		L = {
			handle: function(i) {
				var s = this.rtlTranslate,
					n = i;
				n.originalEvent && (n = n.originalEvent);
				var a = n.keyCode || n.charCode;
				if (!this.allowSlideNext && (this.isHorizontal() && 39 === a || this.isVertical() && 40 === a)) return !1;
				if (!this.allowSlidePrev && (this.isHorizontal() && 37 === a || this.isVertical() && 38 === a)) return !1;
				if (!(n.shiftKey || n.altKey || n.ctrlKey || n.metaKey || t.activeElement && t.activeElement.nodeName && ("input" === t.activeElement.nodeName.toLowerCase() || "textarea" === t.activeElement.nodeName.toLowerCase()))) {
					if (this.params.keyboard.onlyInViewport && (37 === a || 39 === a || 38 === a || 40 === a)) {
						var o = !1;
						if (this.$el.parents("." + this.params.slideClass).length > 0 && 0 === this.$el.parents("." + this.params.slideActiveClass).length) return;
						var r = e.innerWidth,
							l = e.innerHeight,
							d = this.$el.offset();
						s && (d.left -= this.$el[0].scrollLeft);
						for (var c = [
								[d.left, d.top],
								[d.left + this.width, d.top],
								[d.left, d.top + this.height],
								[d.left + this.width, d.top + this.height]
							], h = 0; h < c.length; h += 1) {
							var u = c[h];
							u[0] >= 0 && u[0] <= r && u[1] >= 0 && u[1] <= l && (o = !0)
						}
						if (!o) return
					}
					this.isHorizontal() ? (37 !== a && 39 !== a || (n.preventDefault ? n.preventDefault() : n.returnValue = !1), (39 === a && !s || 37 === a && s) && this.slideNext(), (37 === a && !s || 39 === a && s) && this.slidePrev()) : (38 !== a && 40 !== a || (n.preventDefault ? n.preventDefault() : n.returnValue = !1), 40 === a && this.slideNext(), 38 === a && this.slidePrev()), this.emit("keyPress", a)
				}
			},
			enable: function() {
				this.keyboard.enabled || (s(t).on("keydown", this.keyboard.handle), this.keyboard.enabled = !0)
			},
			disable: function() {
				this.keyboard.enabled && (s(t).off("keydown", this.keyboard.handle), this.keyboard.enabled = !1)
			}
		},
		N = {
			name: "keyboard",
			params: {
				keyboard: {
					enabled: !1,
					onlyInViewport: !0
				}
			},
			create: function() {
				d.extend(this, {
					keyboard: {
						enabled: !1,
						enable: L.enable.bind(this),
						disable: L.disable.bind(this),
						handle: L.handle.bind(this)
					}
				})
			},
			on: {
				init: function() {
					this.params.keyboard.enabled && this.keyboard.enable()
				},
				destroy: function() {
					this.keyboard.enabled && this.keyboard.disable()
				}
			}
		},
		Y = {
			lastScrollTime: d.now(),
			event: e.navigator.userAgent.indexOf("firefox") > -1 ? "DOMMouseScroll" : function() {
				var e = "onwheel" in t;
				if (!e) {
					var i = t.createElement("div");
					i.setAttribute("onwheel", "return;"), e = "function" == typeof i.onwheel
				}
				return !e && t.implementation && t.implementation.hasFeature && !0 !== t.implementation.hasFeature("", "") && (e = t.implementation.hasFeature("Events.wheel", "3.0")), e
			}() ? "wheel" : "mousewheel",
			normalize: function(t) {
				var e = 0,
					i = 0,
					s = 0,
					n = 0;
				return "detail" in t && (i = t.detail), "wheelDelta" in t && (i = -t.wheelDelta / 120), "wheelDeltaY" in t && (i = -t.wheelDeltaY / 120), "wheelDeltaX" in t && (e = -t.wheelDeltaX / 120), "axis" in t && t.axis === t.HORIZONTAL_AXIS && (e = i, i = 0), s = 10 * e, n = 10 * i, "deltaY" in t && (n = t.deltaY), "deltaX" in t && (s = t.deltaX), (s || n) && t.deltaMode && (1 === t.deltaMode ? (s *= 40, n *= 40) : (s *= 800, n *= 800)), s && !e && (e = s < 1 ? -1 : 1), n && !i && (i = n < 1 ? -1 : 1), {
					spinX: e,
					spinY: i,
					pixelX: s,
					pixelY: n
				}
			},
			handleMouseEnter: function() {
				this.mouseEntered = !0
			},
			handleMouseLeave: function() {
				this.mouseEntered = !1
			},
			handle: function(t) {
				var i = t,
					s = this,
					n = s.params.mousewheel;
				if (!s.mouseEntered && !n.releaseOnEdges) return !0;
				i.originalEvent && (i = i.originalEvent);
				var a = 0,
					o = s.rtlTranslate ? -1 : 1,
					r = Y.normalize(i);
				if (n.forceToAxis)
					if (s.isHorizontal()) {
						if (!(Math.abs(r.pixelX) > Math.abs(r.pixelY))) return !0;
						a = r.pixelX * o
					} else {
						if (!(Math.abs(r.pixelY) > Math.abs(r.pixelX))) return !0;
						a = r.pixelY
					}
				else a = Math.abs(r.pixelX) > Math.abs(r.pixelY) ? -r.pixelX * o : -r.pixelY;
				if (0 === a) return !0;
				if (n.invert && (a = -a), s.params.freeMode) {
					var l = s.getTranslate() + a * n.sensitivity,
						c = s.isBeginning,
						h = s.isEnd;
					if (l >= s.minTranslate() && (l = s.minTranslate()), l <= s.maxTranslate() && (l = s.maxTranslate()), s.setTransition(0), s.setTranslate(l), s.updateProgress(), s.updateActiveIndex(), s.updateSlidesClasses(), (!c && s.isBeginning || !h && s.isEnd) && s.updateSlidesClasses(), s.params.freeModeSticky && (clearTimeout(s.mousewheel.timeout), s.mousewheel.timeout = d.nextTick(function() {
							s.slideToClosest()
						}, 300)), s.emit("scroll", i), s.params.autoplay && s.params.autoplayDisableOnInteraction && s.stopAutoplay(), l === s.minTranslate() || l === s.maxTranslate()) return !0
				} else {
					if (d.now() - s.mousewheel.lastScrollTime > 60)
						if (a < 0)
							if (s.isEnd && !s.params.loop || s.animating) {
								if (n.releaseOnEdges) return !0
							} else s.slideNext(), s.emit("scroll", i);
					else if (s.isBeginning && !s.params.loop || s.animating) {
						if (n.releaseOnEdges) return !0
					} else s.slidePrev(), s.emit("scroll", i);
					s.mousewheel.lastScrollTime = (new e.Date).getTime()
				}
				return i.preventDefault ? i.preventDefault() : i.returnValue = !1, !1
			},
			enable: function() {
				if (!Y.event) return !1;
				if (this.mousewheel.enabled) return !1;
				var t = this.$el;
				return "container" !== this.params.mousewheel.eventsTarged && (t = s(this.params.mousewheel.eventsTarged)), t.on("mouseenter", this.mousewheel.handleMouseEnter), t.on("mouseleave", this.mousewheel.handleMouseLeave), t.on(Y.event, this.mousewheel.handle), this.mousewheel.enabled = !0, !0
			},
			disable: function() {
				if (!Y.event) return !1;
				if (!this.mousewheel.enabled) return !1;
				var t = this.$el;
				return "container" !== this.params.mousewheel.eventsTarged && (t = s(this.params.mousewheel.eventsTarged)), t.off(Y.event, this.mousewheel.handle), this.mousewheel.enabled = !1, !0
			}
		},
		R = {
			update: function() {
				var t = this.params.navigation;
				if (!this.params.loop) {
					var e = this.navigation,
						i = e.$nextEl,
						s = e.$prevEl;
					s && s.length > 0 && (this.isBeginning ? s.addClass(t.disabledClass) : s.removeClass(t.disabledClass), s[this.params.watchOverflow && this.isLocked ? "addClass" : "removeClass"](t.lockClass)), i && i.length > 0 && (this.isEnd ? i.addClass(t.disabledClass) : i.removeClass(t.disabledClass), i[this.params.watchOverflow && this.isLocked ? "addClass" : "removeClass"](t.lockClass))
				}
			},
			init: function() {
				var t, e, i = this,
					n = i.params.navigation;
				(n.nextEl || n.prevEl) && (n.nextEl && (t = s(n.nextEl), i.params.uniqueNavElements && "string" == typeof n.nextEl && t.length > 1 && 1 === i.$el.find(n.nextEl).length && (t = i.$el.find(n.nextEl))), n.prevEl && (e = s(n.prevEl), i.params.uniqueNavElements && "string" == typeof n.prevEl && e.length > 1 && 1 === i.$el.find(n.prevEl).length && (e = i.$el.find(n.prevEl))), t && t.length > 0 && t.on("click", function(t) {
					t.preventDefault(), i.isEnd && !i.params.loop || i.slideNext()
				}), e && e.length > 0 && e.on("click", function(t) {
					t.preventDefault(), i.isBeginning && !i.params.loop || i.slidePrev()
				}), d.extend(i.navigation, {
					$nextEl: t,
					nextEl: t && t[0],
					$prevEl: e,
					prevEl: e && e[0]
				}))
			},
			destroy: function() {
				var t = this.navigation,
					e = t.$nextEl,
					i = t.$prevEl;
				e && e.length && (e.off("click"), e.removeClass(this.params.navigation.disabledClass)), i && i.length && (i.off("click"), i.removeClass(this.params.navigation.disabledClass))
			}
		},
		j = {
			update: function() {
				var t = this.rtl,
					e = this.params.pagination;
				if (e.el && this.pagination.el && this.pagination.$el && 0 !== this.pagination.$el.length) {
					var i, n = this.virtual && this.params.virtual.enabled ? this.virtual.slides.length : this.slides.length,
						a = this.pagination.$el,
						o = this.params.loop ? Math.ceil((n - 2 * this.loopedSlides) / this.params.slidesPerGroup) : this.snapGrid.length;
					if (this.params.loop ? ((i = Math.ceil((this.activeIndex - this.loopedSlides) / this.params.slidesPerGroup)) > n - 1 - 2 * this.loopedSlides && (i -= n - 2 * this.loopedSlides), i > o - 1 && (i -= o), i < 0 && "bullets" !== this.params.paginationType && (i = o + i)) : i = void 0 !== this.snapIndex ? this.snapIndex : this.activeIndex || 0, "bullets" === e.type && this.pagination.bullets && this.pagination.bullets.length > 0) {
						var r, l, d, c = this.pagination.bullets;
						if (e.dynamicBullets && (this.pagination.bulletSize = c.eq(0)[this.isHorizontal() ? "outerWidth" : "outerHeight"](!0), a.css(this.isHorizontal() ? "width" : "height", this.pagination.bulletSize * (e.dynamicMainBullets + 4) + "px"), e.dynamicMainBullets > 1 && void 0 !== this.previousIndex && (this.pagination.dynamicBulletIndex += i - this.previousIndex, this.pagination.dynamicBulletIndex > e.dynamicMainBullets - 1 ? this.pagination.dynamicBulletIndex = e.dynamicMainBullets - 1 : this.pagination.dynamicBulletIndex < 0 && (this.pagination.dynamicBulletIndex = 0)), r = i - this.pagination.dynamicBulletIndex, d = ((l = r + (Math.min(c.length, e.dynamicMainBullets) - 1)) + r) / 2), c.removeClass(e.bulletActiveClass + " " + e.bulletActiveClass + "-next " + e.bulletActiveClass + "-next-next " + e.bulletActiveClass + "-prev " + e.bulletActiveClass + "-prev-prev " + e.bulletActiveClass + "-main"), a.length > 1) c.each(function(t, n) {
							var a = s(n),
								o = a.index();
							o === i && a.addClass(e.bulletActiveClass), e.dynamicBullets && (o >= r && o <= l && a.addClass(e.bulletActiveClass + "-main"), o === r && a.prev().addClass(e.bulletActiveClass + "-prev").prev().addClass(e.bulletActiveClass + "-prev-prev"), o === l && a.next().addClass(e.bulletActiveClass + "-next").next().addClass(e.bulletActiveClass + "-next-next"))
						});
						else if (c.eq(i).addClass(e.bulletActiveClass), e.dynamicBullets) {
							for (var h = c.eq(r), u = c.eq(l), p = r; p <= l; p += 1) c.eq(p).addClass(e.bulletActiveClass + "-main");
							h.prev().addClass(e.bulletActiveClass + "-prev").prev().addClass(e.bulletActiveClass + "-prev-prev"), u.next().addClass(e.bulletActiveClass + "-next").next().addClass(e.bulletActiveClass + "-next-next")
						}
						if (e.dynamicBullets) {
							var f = Math.min(c.length, e.dynamicMainBullets + 4),
								m = (this.pagination.bulletSize * f - this.pagination.bulletSize) / 2 - d * this.pagination.bulletSize,
								g = t ? "right" : "left";
							c.css(this.isHorizontal() ? g : "top", m + "px")
						}
					}
					if ("fraction" === e.type && (a.find("." + e.currentClass).text(i + 1), a.find("." + e.totalClass).text(o)), "progressbar" === e.type) {
						var v = (i + 1) / o,
							y = v,
							b = 1;
						this.isHorizontal() || (b = v, y = 1), a.find("." + e.progressbarFillClass).transform("translate3d(0,0,0) scaleX(" + y + ") scaleY(" + b + ")").transition(this.params.speed)
					}
					"custom" === e.type && e.renderCustom ? (a.html(e.renderCustom(this, i + 1, o)), this.emit("paginationRender", this, a[0])) : this.emit("paginationUpdate", this, a[0]), a[this.params.watchOverflow && this.isLocked ? "addClass" : "removeClass"](e.lockClass)
				}
			},
			render: function() {
				var t = this.params.pagination;
				if (t.el && this.pagination.el && this.pagination.$el && 0 !== this.pagination.$el.length) {
					var e = this.virtual && this.params.virtual.enabled ? this.virtual.slides.length : this.slides.length,
						i = this.pagination.$el,
						s = "";
					if ("bullets" === t.type) {
						for (var n = this.params.loop ? Math.ceil((e - 2 * this.loopedSlides) / this.params.slidesPerGroup) : this.snapGrid.length, a = 0; a < n; a += 1) t.renderBullet ? s += t.renderBullet.call(this, a, t.bulletClass) : s += "<" + t.bulletElement + ' class="' + t.bulletClass + '"></' + t.bulletElement + ">";
						i.html(s), this.pagination.bullets = i.find("." + t.bulletClass)
					}
					"fraction" === t.type && (s = t.renderFraction ? t.renderFraction.call(this, t.currentClass, t.totalClass) : '<span class="' + t.currentClass + '"></span> / <span class="' + t.totalClass + '"></span>', i.html(s)), "progressbar" === t.type && (s = t.renderProgressbar ? t.renderProgressbar.call(this, t.progressbarFillClass) : '<span class="' + t.progressbarFillClass + '"></span>', i.html(s)), "custom" !== t.type && this.emit("paginationRender", this.pagination.$el[0])
				}
			},
			init: function() {
				var t = this,
					e = t.params.pagination;
				if (e.el) {
					var i = s(e.el);
					0 !== i.length && (t.params.uniqueNavElements && "string" == typeof e.el && i.length > 1 && 1 === t.$el.find(e.el).length && (i = t.$el.find(e.el)), "bullets" === e.type && e.clickable && i.addClass(e.clickableClass), i.addClass(e.modifierClass + e.type), "bullets" === e.type && e.dynamicBullets && (i.addClass("" + e.modifierClass + e.type + "-dynamic"), t.pagination.dynamicBulletIndex = 0, e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)), e.clickable && i.on("click", "." + e.bulletClass, function(e) {
						e.preventDefault();
						var i = s(this).index() * t.params.slidesPerGroup;
						t.params.loop && (i += t.loopedSlides), t.slideTo(i)
					}), d.extend(t.pagination, {
						$el: i,
						el: i[0]
					}))
				}
			},
			destroy: function() {
				var t = this.params.pagination;
				if (t.el && this.pagination.el && this.pagination.$el && 0 !== this.pagination.$el.length) {
					var e = this.pagination.$el;
					e.removeClass(t.hiddenClass), e.removeClass(t.modifierClass + t.type), this.pagination.bullets && this.pagination.bullets.removeClass(t.bulletActiveClass), t.clickable && e.off("click", "." + t.bulletClass)
				}
			}
		},
		H = {
			setTranslate: function() {
				if (this.params.scrollbar.el && this.scrollbar.el) {
					var t = this.scrollbar,
						e = this.rtlTranslate,
						i = this.progress,
						s = t.dragSize,
						n = t.trackSize,
						a = t.$dragEl,
						o = t.$el,
						r = this.params.scrollbar,
						l = s,
						d = (n - s) * i;
					e ? (d = -d) > 0 ? (l = s - d, d = 0) : -d + s > n && (l = n + d) : d < 0 ? (l = s + d, d = 0) : d + s > n && (l = n - d), this.isHorizontal() ? (c.transforms3d ? a.transform("translate3d(" + d + "px, 0, 0)") : a.transform("translateX(" + d + "px)"), a[0].style.width = l + "px") : (c.transforms3d ? a.transform("translate3d(0px, " + d + "px, 0)") : a.transform("translateY(" + d + "px)"), a[0].style.height = l + "px"), r.hide && (clearTimeout(this.scrollbar.timeout), o[0].style.opacity = 1, this.scrollbar.timeout = setTimeout(function() {
						o[0].style.opacity = 0, o.transition(400)
					}, 1e3))
				}
			},
			setTransition: function(t) {
				this.params.scrollbar.el && this.scrollbar.el && this.scrollbar.$dragEl.transition(t)
			},
			updateSize: function() {
				if (this.params.scrollbar.el && this.scrollbar.el) {
					var t = this.scrollbar,
						e = t.$dragEl,
						i = t.$el;
					e[0].style.width = "", e[0].style.height = "";
					var s, n = this.isHorizontal() ? i[0].offsetWidth : i[0].offsetHeight,
						a = this.size / this.virtualSize,
						o = a * (n / this.size);
					s = "auto" === this.params.scrollbar.dragSize ? n * a : parseInt(this.params.scrollbar.dragSize, 10), this.isHorizontal() ? e[0].style.width = s + "px" : e[0].style.height = s + "px", i[0].style.display = a >= 1 ? "none" : "", this.params.scrollbarHide && (i[0].style.opacity = 0), d.extend(t, {
						trackSize: n,
						divider: a,
						moveDivider: o,
						dragSize: s
					}), t.$el[this.params.watchOverflow && this.isLocked ? "addClass" : "removeClass"](this.params.scrollbar.lockClass)
				}
			},
			setDragPosition: function(t) {
				var e, i = this.scrollbar,
					s = this.rtlTranslate,
					n = i.$el,
					a = i.dragSize,
					o = i.trackSize;
				e = ((this.isHorizontal() ? "touchstart" === t.type || "touchmove" === t.type ? t.targetTouches[0].pageX : t.pageX || t.clientX : "touchstart" === t.type || "touchmove" === t.type ? t.targetTouches[0].pageY : t.pageY || t.clientY) - n.offset()[this.isHorizontal() ? "left" : "top"] - a / 2) / (o - a), e = Math.max(Math.min(e, 1), 0), s && (e = 1 - e);
				var r = this.minTranslate() + (this.maxTranslate() - this.minTranslate()) * e;
				this.updateProgress(r), this.setTranslate(r), this.updateActiveIndex(), this.updateSlidesClasses()
			},
			onDragStart: function(t) {
				var e = this.params.scrollbar,
					i = this.scrollbar,
					s = this.$wrapperEl,
					n = i.$el,
					a = i.$dragEl;
				this.scrollbar.isTouched = !0, t.preventDefault(), t.stopPropagation(), s.transition(100), a.transition(100), i.setDragPosition(t), clearTimeout(this.scrollbar.dragTimeout), n.transition(0), e.hide && n.css("opacity", 1), this.emit("scrollbarDragStart", t)
			},
			onDragMove: function(t) {
				var e = this.scrollbar,
					i = this.$wrapperEl,
					s = e.$el,
					n = e.$dragEl;
				this.scrollbar.isTouched && (t.preventDefault ? t.preventDefault() : t.returnValue = !1, e.setDragPosition(t), i.transition(0), s.transition(0), n.transition(0), this.emit("scrollbarDragMove", t))
			},
			onDragEnd: function(t) {
				var e = this.params.scrollbar,
					i = this.scrollbar.$el;
				this.scrollbar.isTouched && (this.scrollbar.isTouched = !1, e.hide && (clearTimeout(this.scrollbar.dragTimeout), this.scrollbar.dragTimeout = d.nextTick(function() {
					i.css("opacity", 0), i.transition(400)
				}, 1e3)), this.emit("scrollbarDragEnd", t), e.snapOnRelease && this.slideToClosest())
			},
			enableDraggable: function() {
				if (this.params.scrollbar.el) {
					var e = this.scrollbar,
						i = this.touchEvents,
						s = this.touchEventsDesktop,
						n = this.params,
						a = e.$el[0],
						o = !(!c.passiveListener || !n.passiveListener) && {
							passive: !1,
							capture: !1
						},
						r = !(!c.passiveListener || !n.passiveListener) && {
							passive: !0,
							capture: !1
						};
					c.touch || !c.pointerEvents && !c.prefixedPointerEvents ? (c.touch && (a.addEventListener(i.start, this.scrollbar.onDragStart, o), a.addEventListener(i.move, this.scrollbar.onDragMove, o), a.addEventListener(i.end, this.scrollbar.onDragEnd, r)), (n.simulateTouch && !b.ios && !b.android || n.simulateTouch && !c.touch && b.ios) && (a.addEventListener("mousedown", this.scrollbar.onDragStart, o), t.addEventListener("mousemove", this.scrollbar.onDragMove, o), t.addEventListener("mouseup", this.scrollbar.onDragEnd, r))) : (a.addEventListener(s.start, this.scrollbar.onDragStart, o), t.addEventListener(s.move, this.scrollbar.onDragMove, o), t.addEventListener(s.end, this.scrollbar.onDragEnd, r))
				}
			},
			disableDraggable: function() {
				if (this.params.scrollbar.el) {
					var e = this.scrollbar,
						i = this.touchEvents,
						s = this.touchEventsDesktop,
						n = this.params,
						a = e.$el[0],
						o = !(!c.passiveListener || !n.passiveListener) && {
							passive: !1,
							capture: !1
						},
						r = !(!c.passiveListener || !n.passiveListener) && {
							passive: !0,
							capture: !1
						};
					c.touch || !c.pointerEvents && !c.prefixedPointerEvents ? (c.touch && (a.removeEventListener(i.start, this.scrollbar.onDragStart, o), a.removeEventListener(i.move, this.scrollbar.onDragMove, o), a.removeEventListener(i.end, this.scrollbar.onDragEnd, r)), (n.simulateTouch && !b.ios && !b.android || n.simulateTouch && !c.touch && b.ios) && (a.removeEventListener("mousedown", this.scrollbar.onDragStart, o), t.removeEventListener("mousemove", this.scrollbar.onDragMove, o), t.removeEventListener("mouseup", this.scrollbar.onDragEnd, r))) : (a.removeEventListener(s.start, this.scrollbar.onDragStart, o), t.removeEventListener(s.move, this.scrollbar.onDragMove, o), t.removeEventListener(s.end, this.scrollbar.onDragEnd, r))
				}
			},
			init: function() {
				if (this.params.scrollbar.el) {
					var t = this.scrollbar,
						e = this.$el,
						i = this.params.scrollbar,
						n = s(i.el);
					this.params.uniqueNavElements && "string" == typeof i.el && n.length > 1 && 1 === e.find(i.el).length && (n = e.find(i.el));
					var a = n.find("." + this.params.scrollbar.dragClass);
					0 === a.length && (a = s('<div class="' + this.params.scrollbar.dragClass + '"></div>'), n.append(a)), d.extend(t, {
						$el: n,
						el: n[0],
						$dragEl: a,
						dragEl: a[0]
					}), i.draggable && t.enableDraggable()
				}
			},
			destroy: function() {
				this.scrollbar.disableDraggable()
			}
		},
		B = {
			setTransform: function(t, e) {
				var i = this.rtl,
					n = s(t),
					a = i ? -1 : 1,
					o = n.attr("data-swiper-parallax") || "0",
					r = n.attr("data-swiper-parallax-x"),
					l = n.attr("data-swiper-parallax-y"),
					d = n.attr("data-swiper-parallax-scale"),
					c = n.attr("data-swiper-parallax-opacity");
				if (r || l ? (r = r || "0", l = l || "0") : this.isHorizontal() ? (r = o, l = "0") : (l = o, r = "0"), r = r.indexOf("%") >= 0 ? parseInt(r, 10) * e * a + "%" : r * e * a + "px", l = l.indexOf("%") >= 0 ? parseInt(l, 10) * e + "%" : l * e + "px", null != c) {
					var h = c - (c - 1) * (1 - Math.abs(e));
					n[0].style.opacity = h
				}
				if (null == d) n.transform("translate3d(" + r + ", " + l + ", 0px)");
				else {
					var u = d - (d - 1) * (1 - Math.abs(e));
					n.transform("translate3d(" + r + ", " + l + ", 0px) scale(" + u + ")")
				}
			},
			setTranslate: function() {
				var t = this,
					e = t.$el,
					i = t.slides,
					n = t.progress,
					a = t.snapGrid;
				e.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function(e, i) {
					t.parallax.setTransform(i, n)
				}), i.each(function(e, i) {
					var o = i.progress;
					t.params.slidesPerGroup > 1 && "auto" !== t.params.slidesPerView && (o += Math.ceil(e / 2) - n * (a.length - 1)), o = Math.min(Math.max(o, -1), 1), s(i).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function(e, i) {
						t.parallax.setTransform(i, o)
					})
				})
			},
			setTransition: function(t) {
				void 0 === t && (t = this.params.speed), this.$el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function(e, i) {
					var n = s(i),
						a = parseInt(n.attr("data-swiper-parallax-duration"), 10) || t;
					0 === t && (a = 0), n.transition(a)
				})
			}
		},
		F = {
			getDistanceBetweenTouches: function(t) {
				if (t.targetTouches.length < 2) return 1;
				var e = t.targetTouches[0].pageX,
					i = t.targetTouches[0].pageY,
					s = t.targetTouches[1].pageX,
					n = t.targetTouches[1].pageY;
				return Math.sqrt(Math.pow(s - e, 2) + Math.pow(n - i, 2))
			},
			onGestureStart: function(t) {
				var e = this.params.zoom,
					i = this.zoom,
					n = i.gesture;
				if (i.fakeGestureTouched = !1, i.fakeGestureMoved = !1, !c.gestures) {
					if ("touchstart" !== t.type || "touchstart" === t.type && t.targetTouches.length < 2) return;
					i.fakeGestureTouched = !0, n.scaleStart = F.getDistanceBetweenTouches(t)
				}
				n.$slideEl && n.$slideEl.length || (n.$slideEl = s(t.target).closest(".swiper-slide"), 0 === n.$slideEl.length && (n.$slideEl = this.slides.eq(this.activeIndex)), n.$imageEl = n.$slideEl.find("img, svg, canvas"), n.$imageWrapEl = n.$imageEl.parent("." + e.containerClass), n.maxRatio = n.$imageWrapEl.attr("data-swiper-zoom") || e.maxRatio, 0 !== n.$imageWrapEl.length) ? (n.$imageEl.transition(0), this.zoom.isScaling = !0) : n.$imageEl = void 0
			},
			onGestureChange: function(t) {
				var e = this.params.zoom,
					i = this.zoom,
					s = i.gesture;
				if (!c.gestures) {
					if ("touchmove" !== t.type || "touchmove" === t.type && t.targetTouches.length < 2) return;
					i.fakeGestureMoved = !0, s.scaleMove = F.getDistanceBetweenTouches(t)
				}
				s.$imageEl && 0 !== s.$imageEl.length && (c.gestures ? this.zoom.scale = t.scale * i.currentScale : i.scale = s.scaleMove / s.scaleStart * i.currentScale, i.scale > s.maxRatio && (i.scale = s.maxRatio - 1 + Math.pow(i.scale - s.maxRatio + 1, .5)), i.scale < e.minRatio && (i.scale = e.minRatio + 1 - Math.pow(e.minRatio - i.scale + 1, .5)), s.$imageEl.transform("translate3d(0,0,0) scale(" + i.scale + ")"))
			},
			onGestureEnd: function(t) {
				var e = this.params.zoom,
					i = this.zoom,
					s = i.gesture;
				if (!c.gestures) {
					if (!i.fakeGestureTouched || !i.fakeGestureMoved) return;
					if ("touchend" !== t.type || "touchend" === t.type && t.changedTouches.length < 2 && !b.android) return;
					i.fakeGestureTouched = !1, i.fakeGestureMoved = !1
				}
				s.$imageEl && 0 !== s.$imageEl.length && (i.scale = Math.max(Math.min(i.scale, s.maxRatio), e.minRatio), s.$imageEl.transition(this.params.speed).transform("translate3d(0,0,0) scale(" + i.scale + ")"), i.currentScale = i.scale, i.isScaling = !1, 1 === i.scale && (s.$slideEl = void 0))
			},
			onTouchStart: function(t) {
				var e = this.zoom,
					i = e.gesture,
					s = e.image;
				i.$imageEl && 0 !== i.$imageEl.length && (s.isTouched || (b.android && t.preventDefault(), s.isTouched = !0, s.touchesStart.x = "touchstart" === t.type ? t.targetTouches[0].pageX : t.pageX, s.touchesStart.y = "touchstart" === t.type ? t.targetTouches[0].pageY : t.pageY))
			},
			onTouchMove: function(t) {
				var e = this.zoom,
					i = e.gesture,
					s = e.image,
					n = e.velocity;
				if (i.$imageEl && 0 !== i.$imageEl.length && (this.allowClick = !1, s.isTouched && i.$slideEl)) {
					s.isMoved || (s.width = i.$imageEl[0].offsetWidth, s.height = i.$imageEl[0].offsetHeight, s.startX = d.getTranslate(i.$imageWrapEl[0], "x") || 0, s.startY = d.getTranslate(i.$imageWrapEl[0], "y") || 0, i.slideWidth = i.$slideEl[0].offsetWidth, i.slideHeight = i.$slideEl[0].offsetHeight, i.$imageWrapEl.transition(0), this.rtl && (s.startX = -s.startX, s.startY = -s.startY));
					var a = s.width * e.scale,
						o = s.height * e.scale;
					if (!(a < i.slideWidth && o < i.slideHeight)) {
						if (s.minX = Math.min(i.slideWidth / 2 - a / 2, 0), s.maxX = -s.minX, s.minY = Math.min(i.slideHeight / 2 - o / 2, 0), s.maxY = -s.minY, s.touchesCurrent.x = "touchmove" === t.type ? t.targetTouches[0].pageX : t.pageX, s.touchesCurrent.y = "touchmove" === t.type ? t.targetTouches[0].pageY : t.pageY, !s.isMoved && !e.isScaling) {
							if (this.isHorizontal() && (Math.floor(s.minX) === Math.floor(s.startX) && s.touchesCurrent.x < s.touchesStart.x || Math.floor(s.maxX) === Math.floor(s.startX) && s.touchesCurrent.x > s.touchesStart.x)) return void(s.isTouched = !1);
							if (!this.isHorizontal() && (Math.floor(s.minY) === Math.floor(s.startY) && s.touchesCurrent.y < s.touchesStart.y || Math.floor(s.maxY) === Math.floor(s.startY) && s.touchesCurrent.y > s.touchesStart.y)) return void(s.isTouched = !1)
						}
						t.preventDefault(), t.stopPropagation(), s.isMoved = !0, s.currentX = s.touchesCurrent.x - s.touchesStart.x + s.startX, s.currentY = s.touchesCurrent.y - s.touchesStart.y + s.startY, s.currentX < s.minX && (s.currentX = s.minX + 1 - Math.pow(s.minX - s.currentX + 1, .8)), s.currentX > s.maxX && (s.currentX = s.maxX - 1 + Math.pow(s.currentX - s.maxX + 1, .8)), s.currentY < s.minY && (s.currentY = s.minY + 1 - Math.pow(s.minY - s.currentY + 1, .8)), s.currentY > s.maxY && (s.currentY = s.maxY - 1 + Math.pow(s.currentY - s.maxY + 1, .8)), n.prevPositionX || (n.prevPositionX = s.touchesCurrent.x), n.prevPositionY || (n.prevPositionY = s.touchesCurrent.y), n.prevTime || (n.prevTime = Date.now()), n.x = (s.touchesCurrent.x - n.prevPositionX) / (Date.now() - n.prevTime) / 2, n.y = (s.touchesCurrent.y - n.prevPositionY) / (Date.now() - n.prevTime) / 2, Math.abs(s.touchesCurrent.x - n.prevPositionX) < 2 && (n.x = 0), Math.abs(s.touchesCurrent.y - n.prevPositionY) < 2 && (n.y = 0), n.prevPositionX = s.touchesCurrent.x, n.prevPositionY = s.touchesCurrent.y, n.prevTime = Date.now(), i.$imageWrapEl.transform("translate3d(" + s.currentX + "px, " + s.currentY + "px,0)")
					}
				}
			},
			onTouchEnd: function() {
				var t = this.zoom,
					e = t.gesture,
					i = t.image,
					s = t.velocity;
				if (e.$imageEl && 0 !== e.$imageEl.length) {
					if (!i.isTouched || !i.isMoved) return i.isTouched = !1, void(i.isMoved = !1);
					i.isTouched = !1, i.isMoved = !1;
					var n = 300,
						a = 300,
						o = s.x * n,
						r = i.currentX + o,
						l = s.y * a,
						d = i.currentY + l;
					0 !== s.x && (n = Math.abs((r - i.currentX) / s.x)), 0 !== s.y && (a = Math.abs((d - i.currentY) / s.y));
					var c = Math.max(n, a);
					i.currentX = r, i.currentY = d;
					var h = i.width * t.scale,
						u = i.height * t.scale;
					i.minX = Math.min(e.slideWidth / 2 - h / 2, 0), i.maxX = -i.minX, i.minY = Math.min(e.slideHeight / 2 - u / 2, 0), i.maxY = -i.minY, i.currentX = Math.max(Math.min(i.currentX, i.maxX), i.minX), i.currentY = Math.max(Math.min(i.currentY, i.maxY), i.minY), e.$imageWrapEl.transition(c).transform("translate3d(" + i.currentX + "px, " + i.currentY + "px,0)")
				}
			},
			onTransitionEnd: function() {
				var t = this.zoom,
					e = t.gesture;
				e.$slideEl && this.previousIndex !== this.activeIndex && (e.$imageEl.transform("translate3d(0,0,0) scale(1)"), e.$imageWrapEl.transform("translate3d(0,0,0)"), e.$slideEl = void 0, e.$imageEl = void 0, e.$imageWrapEl = void 0, t.scale = 1, t.currentScale = 1)
			},
			toggle: function(t) {
				var e = this.zoom;
				e.scale && 1 !== e.scale ? e.out() : e.in(t)
			},
			in: function(t) {
				var e, i, n, a, o, r, l, d, c, h, u, p, f, m, g, v, y = this.zoom,
					b = this.params.zoom,
					w = y.gesture,
					S = y.image;
				w.$slideEl || (w.$slideEl = this.clickedSlide ? s(this.clickedSlide) : this.slides.eq(this.activeIndex), w.$imageEl = w.$slideEl.find("img, svg, canvas"), w.$imageWrapEl = w.$imageEl.parent("." + b.containerClass)), w.$imageEl && 0 !== w.$imageEl.length && (w.$slideEl.addClass("" + b.zoomedSlideClass), void 0 === S.touchesStart.x && t ? (e = "touchend" === t.type ? t.changedTouches[0].pageX : t.pageX, i = "touchend" === t.type ? t.changedTouches[0].pageY : t.pageY) : (e = S.touchesStart.x, i = S.touchesStart.y), y.scale = w.$imageWrapEl.attr("data-swiper-zoom") || b.maxRatio, y.currentScale = w.$imageWrapEl.attr("data-swiper-zoom") || b.maxRatio, t ? (g = w.$slideEl[0].offsetWidth, v = w.$slideEl[0].offsetHeight, n = w.$slideEl.offset().left + g / 2 - e, a = w.$slideEl.offset().top + v / 2 - i, l = w.$imageEl[0].offsetWidth, d = w.$imageEl[0].offsetHeight, c = l * y.scale, h = d * y.scale, f = -(u = Math.min(g / 2 - c / 2, 0)), m = -(p = Math.min(v / 2 - h / 2, 0)), (o = n * y.scale) < u && (o = u), o > f && (o = f), (r = a * y.scale) < p && (r = p), r > m && (r = m)) : (o = 0, r = 0), w.$imageWrapEl.transition(300).transform("translate3d(" + o + "px, " + r + "px,0)"), w.$imageEl.transition(300).transform("translate3d(0,0,0) scale(" + y.scale + ")"))
			},
			out: function() {
				var t = this.zoom,
					e = this.params.zoom,
					i = t.gesture;
				i.$slideEl || (i.$slideEl = this.clickedSlide ? s(this.clickedSlide) : this.slides.eq(this.activeIndex), i.$imageEl = i.$slideEl.find("img, svg, canvas"), i.$imageWrapEl = i.$imageEl.parent("." + e.containerClass)), i.$imageEl && 0 !== i.$imageEl.length && (t.scale = 1, t.currentScale = 1, i.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"), i.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"), i.$slideEl.removeClass("" + e.zoomedSlideClass), i.$slideEl = void 0)
			},
			enable: function() {
				var t = this.zoom;
				if (!t.enabled) {
					t.enabled = !0;
					var e = !("touchstart" !== this.touchEvents.start || !c.passiveListener || !this.params.passiveListeners) && {
						passive: !0,
						capture: !1
					};
					c.gestures ? (this.$wrapperEl.on("gesturestart", ".swiper-slide", t.onGestureStart, e), this.$wrapperEl.on("gesturechange", ".swiper-slide", t.onGestureChange, e), this.$wrapperEl.on("gestureend", ".swiper-slide", t.onGestureEnd, e)) : "touchstart" === this.touchEvents.start && (this.$wrapperEl.on(this.touchEvents.start, ".swiper-slide", t.onGestureStart, e), this.$wrapperEl.on(this.touchEvents.move, ".swiper-slide", t.onGestureChange, e), this.$wrapperEl.on(this.touchEvents.end, ".swiper-slide", t.onGestureEnd, e)), this.$wrapperEl.on(this.touchEvents.move, "." + this.params.zoom.containerClass, t.onTouchMove)
				}
			},
			disable: function() {
				var t = this.zoom;
				if (t.enabled) {
					this.zoom.enabled = !1;
					var e = !("touchstart" !== this.touchEvents.start || !c.passiveListener || !this.params.passiveListeners) && {
						passive: !0,
						capture: !1
					};
					c.gestures ? (this.$wrapperEl.off("gesturestart", ".swiper-slide", t.onGestureStart, e), this.$wrapperEl.off("gesturechange", ".swiper-slide", t.onGestureChange, e), this.$wrapperEl.off("gestureend", ".swiper-slide", t.onGestureEnd, e)) : "touchstart" === this.touchEvents.start && (this.$wrapperEl.off(this.touchEvents.start, ".swiper-slide", t.onGestureStart, e), this.$wrapperEl.off(this.touchEvents.move, ".swiper-slide", t.onGestureChange, e), this.$wrapperEl.off(this.touchEvents.end, ".swiper-slide", t.onGestureEnd, e)), this.$wrapperEl.off(this.touchEvents.move, "." + this.params.zoom.containerClass, t.onTouchMove)
				}
			}
		},
		W = {
			loadInSlide: function(t, e) {
				void 0 === e && (e = !0);
				var i = this,
					n = i.params.lazy;
				if (void 0 !== t && 0 !== i.slides.length) {
					var a = i.virtual && i.params.virtual.enabled ? i.$wrapperEl.children("." + i.params.slideClass + '[data-swiper-slide-index="' + t + '"]') : i.slides.eq(t),
						o = a.find("." + n.elementClass + ":not(." + n.loadedClass + "):not(." + n.loadingClass + ")");
					!a.hasClass(n.elementClass) || a.hasClass(n.loadedClass) || a.hasClass(n.loadingClass) || (o = o.add(a[0])), 0 !== o.length && o.each(function(t, o) {
						var r = s(o);
						r.addClass(n.loadingClass);
						var l = r.attr("data-background"),
							d = r.attr("data-src"),
							c = r.attr("data-srcset"),
							h = r.attr("data-sizes");
						i.loadImage(r[0], d || l, c, h, !1, function() {
							if (null != i && i && (!i || i.params) && !i.destroyed) {
								if (l ? (r.css("background-image", 'url("' + l + '")'), r.removeAttr("data-background")) : (c && (r.attr("srcset", c), r.removeAttr("data-srcset")), h && (r.attr("sizes", h), r.removeAttr("data-sizes")), d && (r.attr("src", d), r.removeAttr("data-src"))), r.addClass(n.loadedClass).removeClass(n.loadingClass), a.find("." + n.preloaderClass).remove(), i.params.loop && e) {
									var t = a.attr("data-swiper-slide-index");
									if (a.hasClass(i.params.slideDuplicateClass)) {
										var s = i.$wrapperEl.children('[data-swiper-slide-index="' + t + '"]:not(.' + i.params.slideDuplicateClass + ")");
										i.lazy.loadInSlide(s.index(), !1)
									} else {
										var o = i.$wrapperEl.children("." + i.params.slideDuplicateClass + '[data-swiper-slide-index="' + t + '"]');
										i.lazy.loadInSlide(o.index(), !1)
									}
								}
								i.emit("lazyImageReady", a[0], r[0])
							}
						}), i.emit("lazyImageLoad", a[0], r[0])
					})
				}
			},
			load: function() {
				var t = this,
					e = t.$wrapperEl,
					i = t.params,
					n = t.slides,
					a = t.activeIndex,
					o = t.virtual && i.virtual.enabled,
					r = i.lazy,
					l = i.slidesPerView;

				function d(t) {
					if (o) {
						if (e.children("." + i.slideClass + '[data-swiper-slide-index="' + t + '"]').length) return !0
					} else if (n[t]) return !0;
					return !1
				}

				function c(t) {
					return o ? s(t).attr("data-swiper-slide-index") : s(t).index()
				}
				if ("auto" === l && (l = 0), t.lazy.initialImageLoaded || (t.lazy.initialImageLoaded = !0), t.params.watchSlidesVisibility) e.children("." + i.slideVisibleClass).each(function(e, i) {
					var n = o ? s(i).attr("data-swiper-slide-index") : s(i).index();
					t.lazy.loadInSlide(n)
				});
				else if (l > 1)
					for (var h = a; h < a + l; h += 1) d(h) && t.lazy.loadInSlide(h);
				else t.lazy.loadInSlide(a);
				if (r.loadPrevNext)
					if (l > 1 || r.loadPrevNextAmount && r.loadPrevNextAmount > 1) {
						for (var u = r.loadPrevNextAmount, p = l, f = Math.min(a + p + Math.max(u, p), n.length), m = Math.max(a - Math.max(p, u), 0), g = a + l; g < f; g += 1) d(g) && t.lazy.loadInSlide(g);
						for (var v = m; v < a; v += 1) d(v) && t.lazy.loadInSlide(v)
					} else {
						var y = e.children("." + i.slideNextClass);
						y.length > 0 && t.lazy.loadInSlide(c(y));
						var b = e.children("." + i.slidePrevClass);
						b.length > 0 && t.lazy.loadInSlide(c(b))
					}
			}
		},
		V = {
			LinearSpline: function(t, e) {
				var i, s, n, a, o;
				return this.x = t, this.y = e, this.lastIndex = t.length - 1, this.interpolate = function(t) {
					return t ? (o = function(t, e) {
						for (s = -1, i = t.length; i - s > 1;) t[n = i + s >> 1] <= e ? s = n : i = n;
						return i
					}(this.x, t), a = o - 1, (t - this.x[a]) * (this.y[o] - this.y[a]) / (this.x[o] - this.x[a]) + this.y[a]) : 0
				}, this
			},
			getInterpolateFunction: function(t) {
				this.controller.spline || (this.controller.spline = this.params.loop ? new V.LinearSpline(this.slidesGrid, t.slidesGrid) : new V.LinearSpline(this.snapGrid, t.snapGrid))
			},
			setTranslate: function(t, e) {
				var i, s, n = this,
					a = n.controller.control;

				function o(t) {
					var e = n.rtlTranslate ? -n.translate : n.translate;
					"slide" === n.params.controller.by && (n.controller.getInterpolateFunction(t), s = -n.controller.spline.interpolate(-e)), s && "container" !== n.params.controller.by || (i = (t.maxTranslate() - t.minTranslate()) / (n.maxTranslate() - n.minTranslate()), s = (e - n.minTranslate()) * i + t.minTranslate()), n.params.controller.inverse && (s = t.maxTranslate() - s), t.updateProgress(s), t.setTranslate(s, n), t.updateActiveIndex(), t.updateSlidesClasses()
				}
				if (Array.isArray(a))
					for (var r = 0; r < a.length; r += 1) a[r] !== e && a[r] instanceof P && o(a[r]);
				else a instanceof P && e !== a && o(a)
			},
			setTransition: function(t, e) {
				var i, s = this,
					n = s.controller.control;

				function a(e) {
					e.setTransition(t, s), 0 !== t && (e.transitionStart(), e.$wrapperEl.transitionEnd(function() {
						n && (e.params.loop && "slide" === s.params.controller.by && e.loopFix(), e.transitionEnd())
					}))
				}
				if (Array.isArray(n))
					for (i = 0; i < n.length; i += 1) n[i] !== e && n[i] instanceof P && a(n[i]);
				else n instanceof P && e !== n && a(n)
			}
		},
		q = {
			makeElFocusable: function(t) {
				return t.attr("tabIndex", "0"), t
			},
			addElRole: function(t, e) {
				return t.attr("role", e), t
			},
			addElLabel: function(t, e) {
				return t.attr("aria-label", e), t
			},
			disableEl: function(t) {
				return t.attr("aria-disabled", !0), t
			},
			enableEl: function(t) {
				return t.attr("aria-disabled", !1), t
			},
			onEnterKey: function(t) {
				var e = this.params.a11y;
				if (13 === t.keyCode) {
					var i = s(t.target);
					this.navigation && this.navigation.$nextEl && i.is(this.navigation.$nextEl) && (this.isEnd && !this.params.loop || this.slideNext(), this.isEnd ? this.a11y.notify(e.lastSlideMessage) : this.a11y.notify(e.nextSlideMessage)), this.navigation && this.navigation.$prevEl && i.is(this.navigation.$prevEl) && (this.isBeginning && !this.params.loop || this.slidePrev(), this.isBeginning ? this.a11y.notify(e.firstSlideMessage) : this.a11y.notify(e.prevSlideMessage)), this.pagination && i.is("." + this.params.pagination.bulletClass) && i[0].click()
				}
			},
			notify: function(t) {
				var e = this.a11y.liveRegion;
				0 !== e.length && (e.html(""), e.html(t))
			},
			updateNavigation: function() {
				if (!this.params.loop) {
					var t = this.navigation,
						e = t.$nextEl,
						i = t.$prevEl;
					i && i.length > 0 && (this.isBeginning ? this.a11y.disableEl(i) : this.a11y.enableEl(i)), e && e.length > 0 && (this.isEnd ? this.a11y.disableEl(e) : this.a11y.enableEl(e))
				}
			},
			updatePagination: function() {
				var t = this,
					e = t.params.a11y;
				t.pagination && t.params.pagination.clickable && t.pagination.bullets && t.pagination.bullets.length && t.pagination.bullets.each(function(i, n) {
					var a = s(n);
					t.a11y.makeElFocusable(a), t.a11y.addElRole(a, "button"), t.a11y.addElLabel(a, e.paginationBulletMessage.replace(/{{index}}/, a.index() + 1))
				})
			},
			init: function() {
				this.$el.append(this.a11y.liveRegion);
				var t, e, i = this.params.a11y;
				this.navigation && this.navigation.$nextEl && (t = this.navigation.$nextEl), this.navigation && this.navigation.$prevEl && (e = this.navigation.$prevEl), t && (this.a11y.makeElFocusable(t), this.a11y.addElRole(t, "button"), this.a11y.addElLabel(t, i.nextSlideMessage), t.on("keydown", this.a11y.onEnterKey)), e && (this.a11y.makeElFocusable(e), this.a11y.addElRole(e, "button"), this.a11y.addElLabel(e, i.prevSlideMessage), e.on("keydown", this.a11y.onEnterKey)), this.pagination && this.params.pagination.clickable && this.pagination.bullets && this.pagination.bullets.length && this.pagination.$el.on("keydown", "." + this.params.pagination.bulletClass, this.a11y.onEnterKey)
			},
			destroy: function() {
				var t, e;
				this.a11y.liveRegion && this.a11y.liveRegion.length > 0 && this.a11y.liveRegion.remove(), this.navigation && this.navigation.$nextEl && (t = this.navigation.$nextEl), this.navigation && this.navigation.$prevEl && (e = this.navigation.$prevEl), t && t.off("keydown", this.a11y.onEnterKey), e && e.off("keydown", this.a11y.onEnterKey), this.pagination && this.params.pagination.clickable && this.pagination.bullets && this.pagination.bullets.length && this.pagination.$el.off("keydown", "." + this.params.pagination.bulletClass, this.a11y.onEnterKey)
			}
		},
		U = {
			init: function() {
				if (this.params.history) {
					if (!e.history || !e.history.pushState) return this.params.history.enabled = !1, void(this.params.hashNavigation.enabled = !0);
					var t = this.history;
					t.initialized = !0, t.paths = U.getPathValues(), (t.paths.key || t.paths.value) && (t.scrollToSlide(0, t.paths.value, this.params.runCallbacksOnInit), this.params.history.replaceState || e.addEventListener("popstate", this.history.setHistoryPopState))
				}
			},
			destroy: function() {
				this.params.history.replaceState || e.removeEventListener("popstate", this.history.setHistoryPopState)
			},
			setHistoryPopState: function() {
				this.history.paths = U.getPathValues(), this.history.scrollToSlide(this.params.speed, this.history.paths.value, !1)
			},
			getPathValues: function() {
				var t = e.location.pathname.slice(1).split("/").filter(function(t) {
						return "" !== t
					}),
					i = t.length;
				return {
					key: t[i - 2],
					value: t[i - 1]
				}
			},
			setHistory: function(t, i) {
				if (this.history.initialized && this.params.history.enabled) {
					var s = this.slides.eq(i),
						n = U.slugify(s.attr("data-history"));
					e.location.pathname.includes(t) || (n = t + "/" + n);
					var a = e.history.state;
					a && a.value === n || (this.params.history.replaceState ? e.history.replaceState({
						value: n
					}, null, n) : e.history.pushState({
						value: n
					}, null, n))
				}
			},
			slugify: function(t) {
				return t.toString().toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "")
			},
			scrollToSlide: function(t, e, i) {
				if (e)
					for (var s = 0, n = this.slides.length; s < n; s += 1) {
						var a = this.slides.eq(s);
						if (U.slugify(a.attr("data-history")) === e && !a.hasClass(this.params.slideDuplicateClass)) {
							var o = a.index();
							this.slideTo(o, t, i)
						}
					} else this.slideTo(0, t, i)
			}
		},
		G = {
			onHashCange: function() {
				var e = t.location.hash.replace("#", "");
				e !== this.slides.eq(this.activeIndex).attr("data-hash") && this.slideTo(this.$wrapperEl.children("." + this.params.slideClass + '[data-hash="' + e + '"]').index())
			},
			setHash: function() {
				if (this.hashNavigation.initialized && this.params.hashNavigation.enabled)
					if (this.params.hashNavigation.replaceState && e.history && e.history.replaceState) e.history.replaceState(null, null, "#" + this.slides.eq(this.activeIndex).attr("data-hash") || "");
					else {
						var i = this.slides.eq(this.activeIndex),
							s = i.attr("data-hash") || i.attr("data-history");
						t.location.hash = s || ""
					}
			},
			init: function() {
				if (!(!this.params.hashNavigation.enabled || this.params.history && this.params.history.enabled)) {
					this.hashNavigation.initialized = !0;
					var i = t.location.hash.replace("#", "");
					if (i)
						for (var n = 0, a = this.slides.length; n < a; n += 1) {
							var o = this.slides.eq(n);
							if ((o.attr("data-hash") || o.attr("data-history")) === i && !o.hasClass(this.params.slideDuplicateClass)) {
								var r = o.index();
								this.slideTo(r, 0, this.params.runCallbacksOnInit, !0)
							}
						}
					this.params.hashNavigation.watchState && s(e).on("hashchange", this.hashNavigation.onHashCange)
				}
			},
			destroy: function() {
				this.params.hashNavigation.watchState && s(e).off("hashchange", this.hashNavigation.onHashCange)
			}
		},
		X = {
			run: function() {
				var t = this,
					e = t.slides.eq(t.activeIndex),
					i = t.params.autoplay.delay;
				e.attr("data-swiper-autoplay") && (i = e.attr("data-swiper-autoplay") || t.params.autoplay.delay), t.autoplay.timeout = d.nextTick(function() {
					t.params.autoplay.reverseDirection ? t.params.loop ? (t.loopFix(), t.slidePrev(t.params.speed, !0, !0), t.emit("autoplay")) : t.isBeginning ? t.params.autoplay.stopOnLastSlide ? t.autoplay.stop() : (t.slideTo(t.slides.length - 1, t.params.speed, !0, !0), t.emit("autoplay")) : (t.slidePrev(t.params.speed, !0, !0), t.emit("autoplay")) : t.params.loop ? (t.loopFix(), t.slideNext(t.params.speed, !0, !0), t.emit("autoplay")) : t.isEnd ? t.params.autoplay.stopOnLastSlide ? t.autoplay.stop() : (t.slideTo(0, t.params.speed, !0, !0), t.emit("autoplay")) : (t.slideNext(t.params.speed, !0, !0), t.emit("autoplay"))
				}, i)
			},
			start: function() {
				return void 0 === this.autoplay.timeout && !this.autoplay.running && (this.autoplay.running = !0, this.emit("autoplayStart"), this.autoplay.run(), !0)
			},
			stop: function() {
				return !!this.autoplay.running && void 0 !== this.autoplay.timeout && (this.autoplay.timeout && (clearTimeout(this.autoplay.timeout), this.autoplay.timeout = void 0), this.autoplay.running = !1, this.emit("autoplayStop"), !0)
			},
			pause: function(t) {
				var e = this;
				e.autoplay.running && (e.autoplay.paused || (e.autoplay.timeout && clearTimeout(e.autoplay.timeout), e.autoplay.paused = !0, 0 !== t && e.params.autoplay.waitForTransition ? e.$wrapperEl.transitionEnd(function() {
					e && !e.destroyed && (e.autoplay.paused = !1, e.autoplay.running ? e.autoplay.run() : e.autoplay.stop())
				}) : (e.autoplay.paused = !1, e.autoplay.run())))
			}
		},
		Q = {
			setTranslate: function() {
				for (var t = this.slides, e = 0; e < t.length; e += 1) {
					var i = this.slides.eq(e),
						s = -i[0].swiperSlideOffset;
					this.params.virtualTranslate || (s -= this.translate);
					var n = 0;
					this.isHorizontal() || (n = s, s = 0);
					var a = this.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(i[0].progress), 0) : 1 + Math.min(Math.max(i[0].progress, -1), 0);
					i.css({
						opacity: a
					}).transform("translate3d(" + s + "px, " + n + "px, 0px)")
				}
			},
			setTransition: function(t) {
				var e = this,
					i = e.slides,
					s = e.$wrapperEl;
				if (i.transition(t), e.params.virtualTranslate && 0 !== t) {
					var n = !1;
					i.transitionEnd(function() {
						if (!n && e && !e.destroyed) {
							n = !0, e.animating = !1;
							for (var t = ["webkitTransitionEnd", "transitionend"], i = 0; i < t.length; i += 1) s.trigger(t[i])
						}
					})
				}
			}
		},
		Z = {
			setTranslate: function() {
				var t, e = this.$el,
					i = this.$wrapperEl,
					n = this.slides,
					a = this.width,
					o = this.height,
					r = this.rtlTranslate,
					l = this.size,
					d = this.params.cubeEffect,
					c = this.isHorizontal(),
					h = this.virtual && this.params.virtual.enabled,
					u = 0;
				d.shadow && (c ? (0 === (t = i.find(".swiper-cube-shadow")).length && (t = s('<div class="swiper-cube-shadow"></div>'), i.append(t)), t.css({
					height: a + "px"
				})) : 0 === (t = e.find(".swiper-cube-shadow")).length && (t = s('<div class="swiper-cube-shadow"></div>'), e.append(t)));
				for (var p = 0; p < n.length; p += 1) {
					var f = n.eq(p),
						m = p;
					h && (m = parseInt(f.attr("data-swiper-slide-index"), 10));
					var g = 90 * m,
						v = Math.floor(g / 360);
					r && (g = -g, v = Math.floor(-g / 360));
					var y = Math.max(Math.min(f[0].progress, 1), -1),
						b = 0,
						w = 0,
						S = 0;
					m % 4 == 0 ? (b = 4 * -v * l, S = 0) : (m - 1) % 4 == 0 ? (b = 0, S = 4 * -v * l) : (m - 2) % 4 == 0 ? (b = l + 4 * v * l, S = l) : (m - 3) % 4 == 0 && (b = -l, S = 3 * l + 4 * l * v), r && (b = -b), c || (w = b, b = 0);
					var x = "rotateX(" + (c ? 0 : -g) + "deg) rotateY(" + (c ? g : 0) + "deg) translate3d(" + b + "px, " + w + "px, " + S + "px)";
					if (y <= 1 && y > -1 && (u = 90 * m + 90 * y, r && (u = 90 * -m - 90 * y)), f.transform(x), d.slideShadows) {
						var C = c ? f.find(".swiper-slide-shadow-left") : f.find(".swiper-slide-shadow-top"),
							_ = c ? f.find(".swiper-slide-shadow-right") : f.find(".swiper-slide-shadow-bottom");
						0 === C.length && (C = s('<div class="swiper-slide-shadow-' + (c ? "left" : "top") + '"></div>'), f.append(C)), 0 === _.length && (_ = s('<div class="swiper-slide-shadow-' + (c ? "right" : "bottom") + '"></div>'), f.append(_)), C.length && (C[0].style.opacity = Math.max(-y, 0)), _.length && (_[0].style.opacity = Math.max(y, 0))
					}
				}
				if (i.css({
						"-webkit-transform-origin": "50% 50% -" + l / 2 + "px",
						"-moz-transform-origin": "50% 50% -" + l / 2 + "px",
						"-ms-transform-origin": "50% 50% -" + l / 2 + "px",
						"transform-origin": "50% 50% -" + l / 2 + "px"
					}), d.shadow)
					if (c) t.transform("translate3d(0px, " + (a / 2 + d.shadowOffset) + "px, " + -a / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + d.shadowScale + ")");
					else {
						var E = Math.abs(u) - 90 * Math.floor(Math.abs(u) / 90),
							P = 1.5 - (Math.sin(2 * E * Math.PI / 360) / 2 + Math.cos(2 * E * Math.PI / 360) / 2),
							k = d.shadowScale,
							$ = d.shadowScale / P,
							M = d.shadowOffset;
						t.transform("scale3d(" + k + ", 1, " + $ + ") translate3d(0px, " + (o / 2 + M) + "px, " + -o / 2 / $ + "px) rotateX(-90deg)")
					} var D = T.isSafari || T.isUiWebView ? -l / 2 : 0;
				i.transform("translate3d(0px,0," + D + "px) rotateX(" + (this.isHorizontal() ? 0 : u) + "deg) rotateY(" + (this.isHorizontal() ? -u : 0) + "deg)")
			},
			setTransition: function(t) {
				var e = this.$el;
				this.slides.transition(t).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(t), this.params.cubeEffect.shadow && !this.isHorizontal() && e.find(".swiper-cube-shadow").transition(t)
			}
		},
		K = {
			setTranslate: function() {
				for (var t = this.slides, e = this.rtlTranslate, i = 0; i < t.length; i += 1) {
					var n = t.eq(i),
						a = n[0].progress;
					this.params.flipEffect.limitRotation && (a = Math.max(Math.min(n[0].progress, 1), -1));
					var o = -180 * a,
						r = 0,
						l = -n[0].swiperSlideOffset,
						d = 0;
					if (this.isHorizontal() ? e && (o = -o) : (d = l, l = 0, r = -o, o = 0), n[0].style.zIndex = -Math.abs(Math.round(a)) + t.length, this.params.flipEffect.slideShadows) {
						var c = this.isHorizontal() ? n.find(".swiper-slide-shadow-left") : n.find(".swiper-slide-shadow-top"),
							h = this.isHorizontal() ? n.find(".swiper-slide-shadow-right") : n.find(".swiper-slide-shadow-bottom");
						0 === c.length && (c = s('<div class="swiper-slide-shadow-' + (this.isHorizontal() ? "left" : "top") + '"></div>'), n.append(c)), 0 === h.length && (h = s('<div class="swiper-slide-shadow-' + (this.isHorizontal() ? "right" : "bottom") + '"></div>'), n.append(h)), c.length && (c[0].style.opacity = Math.max(-a, 0)), h.length && (h[0].style.opacity = Math.max(a, 0))
					}
					n.transform("translate3d(" + l + "px, " + d + "px, 0px) rotateX(" + r + "deg) rotateY(" + o + "deg)")
				}
			},
			setTransition: function(t) {
				var e = this,
					i = e.slides,
					s = e.activeIndex,
					n = e.$wrapperEl;
				if (i.transition(t).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(t), e.params.virtualTranslate && 0 !== t) {
					var a = !1;
					i.eq(s).transitionEnd(function() {
						if (!a && e && !e.destroyed) {
							a = !0, e.animating = !1;
							for (var t = ["webkitTransitionEnd", "transitionend"], i = 0; i < t.length; i += 1) n.trigger(t[i])
						}
					})
				}
			}
		},
		J = {
			setTranslate: function() {
				for (var t = this.width, e = this.height, i = this.slides, n = this.$wrapperEl, a = this.slidesSizesGrid, o = this.params.coverflowEffect, r = this.isHorizontal(), l = this.translate, d = r ? t / 2 - l : e / 2 - l, h = r ? o.rotate : -o.rotate, u = o.depth, p = 0, f = i.length; p < f; p += 1) {
					var m = i.eq(p),
						g = a[p],
						v = (d - m[0].swiperSlideOffset - g / 2) / g * o.modifier,
						y = r ? h * v : 0,
						b = r ? 0 : h * v,
						w = -u * Math.abs(v),
						S = r ? 0 : o.stretch * v,
						x = r ? o.stretch * v : 0;
					Math.abs(x) < .001 && (x = 0), Math.abs(S) < .001 && (S = 0), Math.abs(w) < .001 && (w = 0), Math.abs(y) < .001 && (y = 0), Math.abs(b) < .001 && (b = 0);
					var T = "translate3d(" + x + "px," + S + "px," + w + "px)  rotateX(" + b + "deg) rotateY(" + y + "deg)";
					if (m.transform(T), m[0].style.zIndex = 1 - Math.abs(Math.round(v)), o.slideShadows) {
						var C = r ? m.find(".swiper-slide-shadow-left") : m.find(".swiper-slide-shadow-top"),
							_ = r ? m.find(".swiper-slide-shadow-right") : m.find(".swiper-slide-shadow-bottom");
						0 === C.length && (C = s('<div class="swiper-slide-shadow-' + (r ? "left" : "top") + '"></div>'), m.append(C)), 0 === _.length && (_ = s('<div class="swiper-slide-shadow-' + (r ? "right" : "bottom") + '"></div>'), m.append(_)), C.length && (C[0].style.opacity = v > 0 ? v : 0), _.length && (_[0].style.opacity = -v > 0 ? -v : 0)
					}
				}(c.pointerEvents || c.prefixedPointerEvents) && (n[0].style.perspectiveOrigin = d + "px 50%")
			},
			setTransition: function(t) {
				this.slides.transition(t).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(t)
			}
		},
		tt = [k, $, M, D, z, I, N, {
			name: "mousewheel",
			params: {
				mousewheel: {
					enabled: !1,
					releaseOnEdges: !1,
					invert: !1,
					forceToAxis: !1,
					sensitivity: 1,
					eventsTarged: "container"
				}
			},
			create: function() {
				d.extend(this, {
					mousewheel: {
						enabled: !1,
						enable: Y.enable.bind(this),
						disable: Y.disable.bind(this),
						handle: Y.handle.bind(this),
						handleMouseEnter: Y.handleMouseEnter.bind(this),
						handleMouseLeave: Y.handleMouseLeave.bind(this),
						lastScrollTime: d.now()
					}
				})
			},
			on: {
				init: function() {
					this.params.mousewheel.enabled && this.mousewheel.enable()
				},
				destroy: function() {
					this.mousewheel.enabled && this.mousewheel.disable()
				}
			}
		}, {
			name: "navigation",
			params: {
				navigation: {
					nextEl: null,
					prevEl: null,
					hideOnClick: !1,
					disabledClass: "swiper-button-disabled",
					hiddenClass: "swiper-button-hidden",
					lockClass: "swiper-button-lock"
				}
			},
			create: function() {
				d.extend(this, {
					navigation: {
						init: R.init.bind(this),
						update: R.update.bind(this),
						destroy: R.destroy.bind(this)
					}
				})
			},
			on: {
				init: function() {
					this.navigation.init(), this.navigation.update()
				},
				toEdge: function() {
					this.navigation.update()
				},
				fromEdge: function() {
					this.navigation.update()
				},
				destroy: function() {
					this.navigation.destroy()
				},
				click: function(t) {
					var e = this.navigation,
						i = e.$nextEl,
						n = e.$prevEl;
					!this.params.navigation.hideOnClick || s(t.target).is(n) || s(t.target).is(i) || (i && i.toggleClass(this.params.navigation.hiddenClass), n && n.toggleClass(this.params.navigation.hiddenClass))
				}
			}
		}, {
			name: "pagination",
			params: {
				pagination: {
					el: null,
					bulletElement: "span",
					clickable: !1,
					hideOnClick: !1,
					renderBullet: null,
					renderProgressbar: null,
					renderFraction: null,
					renderCustom: null,
					type: "bullets",
					dynamicBullets: !1,
					dynamicMainBullets: 1,
					bulletClass: "swiper-pagination-bullet",
					bulletActiveClass: "swiper-pagination-bullet-active",
					modifierClass: "swiper-pagination-",
					currentClass: "swiper-pagination-current",
					totalClass: "swiper-pagination-total",
					hiddenClass: "swiper-pagination-hidden",
					progressbarFillClass: "swiper-pagination-progressbar-fill",
					clickableClass: "swiper-pagination-clickable",
					lockClass: "swiper-pagination-lock"
				}
			},
			create: function() {
				d.extend(this, {
					pagination: {
						init: j.init.bind(this),
						render: j.render.bind(this),
						update: j.update.bind(this),
						destroy: j.destroy.bind(this),
						dynamicBulletIndex: 0
					}
				})
			},
			on: {
				init: function() {
					this.pagination.init(), this.pagination.render(), this.pagination.update()
				},
				activeIndexChange: function() {
					this.params.loop ? this.pagination.update() : void 0 === this.snapIndex && this.pagination.update()
				},
				snapIndexChange: function() {
					this.params.loop || this.pagination.update()
				},
				slidesLengthChange: function() {
					this.params.loop && (this.pagination.render(), this.pagination.update())
				},
				snapGridLengthChange: function() {
					this.params.loop || (this.pagination.render(), this.pagination.update())
				},
				destroy: function() {
					this.pagination.destroy()
				},
				click: function(t) {
					this.params.pagination.el && this.params.pagination.hideOnClick && this.pagination.$el.length > 0 && !s(t.target).hasClass(this.params.pagination.bulletClass) && this.pagination.$el.toggleClass(this.params.pagination.hiddenClass)
				}
			}
		}, {
			name: "scrollbar",
			params: {
				scrollbar: {
					el: null,
					dragSize: "auto",
					hide: !1,
					draggable: !1,
					snapOnRelease: !0,
					lockClass: "swiper-scrollbar-lock",
					dragClass: "swiper-scrollbar-drag"
				}
			},
			create: function() {
				d.extend(this, {
					scrollbar: {
						init: H.init.bind(this),
						destroy: H.destroy.bind(this),
						updateSize: H.updateSize.bind(this),
						setTranslate: H.setTranslate.bind(this),
						setTransition: H.setTransition.bind(this),
						enableDraggable: H.enableDraggable.bind(this),
						disableDraggable: H.disableDraggable.bind(this),
						setDragPosition: H.setDragPosition.bind(this),
						onDragStart: H.onDragStart.bind(this),
						onDragMove: H.onDragMove.bind(this),
						onDragEnd: H.onDragEnd.bind(this),
						isTouched: !1,
						timeout: null,
						dragTimeout: null
					}
				})
			},
			on: {
				init: function() {
					this.scrollbar.init(), this.scrollbar.updateSize(), this.scrollbar.setTranslate()
				},
				update: function() {
					this.scrollbar.updateSize()
				},
				resize: function() {
					this.scrollbar.updateSize()
				},
				observerUpdate: function() {
					this.scrollbar.updateSize()
				},
				setTranslate: function() {
					this.scrollbar.setTranslate()
				},
				setTransition: function(t) {
					this.scrollbar.setTransition(t)
				},
				destroy: function() {
					this.scrollbar.destroy()
				}
			}
		}, {
			name: "parallax",
			params: {
				parallax: {
					enabled: !1
				}
			},
			create: function() {
				d.extend(this, {
					parallax: {
						setTransform: B.setTransform.bind(this),
						setTranslate: B.setTranslate.bind(this),
						setTransition: B.setTransition.bind(this)
					}
				})
			},
			on: {
				beforeInit: function() {
					this.params.parallax.enabled && (this.params.watchSlidesProgress = !0)
				},
				init: function() {
					this.params.parallax && this.parallax.setTranslate()
				},
				setTranslate: function() {
					this.params.parallax && this.parallax.setTranslate()
				},
				setTransition: function(t) {
					this.params.parallax && this.parallax.setTransition(t)
				}
			}
		}, {
			name: "zoom",
			params: {
				zoom: {
					enabled: !1,
					maxRatio: 3,
					minRatio: 1,
					toggle: !0,
					containerClass: "swiper-zoom-container",
					zoomedSlideClass: "swiper-slide-zoomed"
				}
			},
			create: function() {
				var t = this,
					e = {
						enabled: !1,
						scale: 1,
						currentScale: 1,
						isScaling: !1,
						gesture: {
							$slideEl: void 0,
							slideWidth: void 0,
							slideHeight: void 0,
							$imageEl: void 0,
							$imageWrapEl: void 0,
							maxRatio: 3
						},
						image: {
							isTouched: void 0,
							isMoved: void 0,
							currentX: void 0,
							currentY: void 0,
							minX: void 0,
							minY: void 0,
							maxX: void 0,
							maxY: void 0,
							width: void 0,
							height: void 0,
							startX: void 0,
							startY: void 0,
							touchesStart: {},
							touchesCurrent: {}
						},
						velocity: {
							x: void 0,
							y: void 0,
							prevPositionX: void 0,
							prevPositionY: void 0,
							prevTime: void 0
						}
					};
				"onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out".split(" ").forEach(function(i) {
					e[i] = F[i].bind(t)
				}), d.extend(t, {
					zoom: e
				})
			},
			on: {
				init: function() {
					this.params.zoom.enabled && this.zoom.enable()
				},
				destroy: function() {
					this.zoom.disable()
				},
				touchStart: function(t) {
					this.zoom.enabled && this.zoom.onTouchStart(t)
				},
				touchEnd: function(t) {
					this.zoom.enabled && this.zoom.onTouchEnd(t)
				},
				doubleTap: function(t) {
					this.params.zoom.enabled && this.zoom.enabled && this.params.zoom.toggle && this.zoom.toggle(t)
				},
				transitionEnd: function() {
					this.zoom.enabled && this.params.zoom.enabled && this.zoom.onTransitionEnd()
				}
			}
		}, {
			name: "lazy",
			params: {
				lazy: {
					enabled: !1,
					loadPrevNext: !1,
					loadPrevNextAmount: 1,
					loadOnTransitionStart: !1,
					elementClass: "swiper-lazy",
					loadingClass: "swiper-lazy-loading",
					loadedClass: "swiper-lazy-loaded",
					preloaderClass: "swiper-lazy-preloader"
				}
			},
			create: function() {
				d.extend(this, {
					lazy: {
						initialImageLoaded: !1,
						load: W.load.bind(this),
						loadInSlide: W.loadInSlide.bind(this)
					}
				})
			},
			on: {
				beforeInit: function() {
					this.params.lazy.enabled && this.params.preloadImages && (this.params.preloadImages = !1)
				},
				init: function() {
					this.params.lazy.enabled && !this.params.loop && 0 === this.params.initialSlide && this.lazy.load()
				},
				scroll: function() {
					this.params.freeMode && !this.params.freeModeSticky && this.lazy.load()
				},
				resize: function() {
					this.params.lazy.enabled && this.lazy.load()
				},
				scrollbarDragMove: function() {
					this.params.lazy.enabled && this.lazy.load()
				},
				transitionStart: function() {
					this.params.lazy.enabled && (this.params.lazy.loadOnTransitionStart || !this.params.lazy.loadOnTransitionStart && !this.lazy.initialImageLoaded) && this.lazy.load()
				},
				transitionEnd: function() {
					this.params.lazy.enabled && !this.params.lazy.loadOnTransitionStart && this.lazy.load()
				}
			}
		}, {
			name: "controller",
			params: {
				controller: {
					control: void 0,
					inverse: !1,
					by: "slide"
				}
			},
			create: function() {
				d.extend(this, {
					controller: {
						control: this.params.controller.control,
						getInterpolateFunction: V.getInterpolateFunction.bind(this),
						setTranslate: V.setTranslate.bind(this),
						setTransition: V.setTransition.bind(this)
					}
				})
			},
			on: {
				update: function() {
					this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline)
				},
				resize: function() {
					this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline)
				},
				observerUpdate: function() {
					this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline)
				},
				setTranslate: function(t, e) {
					this.controller.control && this.controller.setTranslate(t, e)
				},
				setTransition: function(t, e) {
					this.controller.control && this.controller.setTransition(t, e)
				}
			}
		}, {
			name: "a11y",
			params: {
				a11y: {
					enabled: !0,
					notificationClass: "swiper-notification",
					prevSlideMessage: "Previous slide",
					nextSlideMessage: "Next slide",
					firstSlideMessage: "This is the first slide",
					lastSlideMessage: "This is the last slide",
					paginationBulletMessage: "Go to slide {{index}}"
				}
			},
			create: function() {
				var t = this;
				d.extend(t, {
					a11y: {
						liveRegion: s('<span class="' + t.params.a11y.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>')
					}
				}), Object.keys(q).forEach(function(e) {
					t.a11y[e] = q[e].bind(t)
				})
			},
			on: {
				init: function() {
					this.params.a11y.enabled && (this.a11y.init(), this.a11y.updateNavigation())
				},
				toEdge: function() {
					this.params.a11y.enabled && this.a11y.updateNavigation()
				},
				fromEdge: function() {
					this.params.a11y.enabled && this.a11y.updateNavigation()
				},
				paginationUpdate: function() {
					this.params.a11y.enabled && this.a11y.updatePagination()
				},
				destroy: function() {
					this.params.a11y.enabled && this.a11y.destroy()
				}
			}
		}, {
			name: "history",
			params: {
				history: {
					enabled: !1,
					replaceState: !1,
					key: "slides"
				}
			},
			create: function() {
				d.extend(this, {
					history: {
						init: U.init.bind(this),
						setHistory: U.setHistory.bind(this),
						setHistoryPopState: U.setHistoryPopState.bind(this),
						scrollToSlide: U.scrollToSlide.bind(this),
						destroy: U.destroy.bind(this)
					}
				})
			},
			on: {
				init: function() {
					this.params.history.enabled && this.history.init()
				},
				destroy: function() {
					this.params.history.enabled && this.history.destroy()
				},
				transitionEnd: function() {
					this.history.initialized && this.history.setHistory(this.params.history.key, this.activeIndex)
				}
			}
		}, {
			name: "hash-navigation",
			params: {
				hashNavigation: {
					enabled: !1,
					replaceState: !1,
					watchState: !1
				}
			},
			create: function() {
				d.extend(this, {
					hashNavigation: {
						initialized: !1,
						init: G.init.bind(this),
						destroy: G.destroy.bind(this),
						setHash: G.setHash.bind(this),
						onHashCange: G.onHashCange.bind(this)
					}
				})
			},
			on: {
				init: function() {
					this.params.hashNavigation.enabled && this.hashNavigation.init()
				},
				destroy: function() {
					this.params.hashNavigation.enabled && this.hashNavigation.destroy()
				},
				transitionEnd: function() {
					this.hashNavigation.initialized && this.hashNavigation.setHash()
				}
			}
		}, {
			name: "autoplay",
			params: {
				autoplay: {
					enabled: !1,
					delay: 3e3,
					waitForTransition: !0,
					disableOnInteraction: !0,
					stopOnLastSlide: !1,
					reverseDirection: !1
				}
			},
			create: function() {
				d.extend(this, {
					autoplay: {
						running: !1,
						paused: !1,
						run: X.run.bind(this),
						start: X.start.bind(this),
						stop: X.stop.bind(this),
						pause: X.pause.bind(this)
					}
				})
			},
			on: {
				init: function() {
					this.params.autoplay.enabled && this.autoplay.start()
				},
				beforeTransitionStart: function(t, e) {
					this.autoplay.running && (e || !this.params.autoplay.disableOnInteraction ? this.autoplay.pause(t) : this.autoplay.stop())
				},
				sliderFirstMove: function() {
					this.autoplay.running && (this.params.autoplay.disableOnInteraction ? this.autoplay.stop() : this.autoplay.pause())
				},
				destroy: function() {
					this.autoplay.running && this.autoplay.stop()
				}
			}
		}, {
			name: "effect-fade",
			params: {
				fadeEffect: {
					crossFade: !1
				}
			},
			create: function() {
				d.extend(this, {
					fadeEffect: {
						setTranslate: Q.setTranslate.bind(this),
						setTransition: Q.setTransition.bind(this)
					}
				})
			},
			on: {
				beforeInit: function() {
					if ("fade" === this.params.effect) {
						this.classNames.push(this.params.containerModifierClass + "fade");
						var t = {
							slidesPerView: 1,
							slidesPerColumn: 1,
							slidesPerGroup: 1,
							watchSlidesProgress: !0,
							spaceBetween: 0,
							virtualTranslate: !0
						};
						d.extend(this.params, t), d.extend(this.originalParams, t)
					}
				},
				setTranslate: function() {
					"fade" === this.params.effect && this.fadeEffect.setTranslate()
				},
				setTransition: function(t) {
					"fade" === this.params.effect && this.fadeEffect.setTransition(t)
				}
			}
		}, {
			name: "effect-cube",
			params: {
				cubeEffect: {
					slideShadows: !0,
					shadow: !0,
					shadowOffset: 20,
					shadowScale: .94
				}
			},
			create: function() {
				d.extend(this, {
					cubeEffect: {
						setTranslate: Z.setTranslate.bind(this),
						setTransition: Z.setTransition.bind(this)
					}
				})
			},
			on: {
				beforeInit: function() {
					if ("cube" === this.params.effect) {
						this.classNames.push(this.params.containerModifierClass + "cube"), this.classNames.push(this.params.containerModifierClass + "3d");
						var t = {
							slidesPerView: 1,
							slidesPerColumn: 1,
							slidesPerGroup: 1,
							watchSlidesProgress: !0,
							resistanceRatio: 0,
							spaceBetween: 0,
							centeredSlides: !1,
							virtualTranslate: !0
						};
						d.extend(this.params, t), d.extend(this.originalParams, t)
					}
				},
				setTranslate: function() {
					"cube" === this.params.effect && this.cubeEffect.setTranslate()
				},
				setTransition: function(t) {
					"cube" === this.params.effect && this.cubeEffect.setTransition(t)
				}
			}
		}, {
			name: "effect-flip",
			params: {
				flipEffect: {
					slideShadows: !0,
					limitRotation: !0
				}
			},
			create: function() {
				d.extend(this, {
					flipEffect: {
						setTranslate: K.setTranslate.bind(this),
						setTransition: K.setTransition.bind(this)
					}
				})
			},
			on: {
				beforeInit: function() {
					if ("flip" === this.params.effect) {
						this.classNames.push(this.params.containerModifierClass + "flip"), this.classNames.push(this.params.containerModifierClass + "3d");
						var t = {
							slidesPerView: 1,
							slidesPerColumn: 1,
							slidesPerGroup: 1,
							watchSlidesProgress: !0,
							spaceBetween: 0,
							virtualTranslate: !0
						};
						d.extend(this.params, t), d.extend(this.originalParams, t)
					}
				},
				setTranslate: function() {
					"flip" === this.params.effect && this.flipEffect.setTranslate()
				},
				setTransition: function(t) {
					"flip" === this.params.effect && this.flipEffect.setTransition(t)
				}
			}
		}, {
			name: "effect-coverflow",
			params: {
				coverflowEffect: {
					rotate: 50,
					stretch: 0,
					depth: 100,
					modifier: 1,
					slideShadows: !0
				}
			},
			create: function() {
				d.extend(this, {
					coverflowEffect: {
						setTranslate: J.setTranslate.bind(this),
						setTransition: J.setTransition.bind(this)
					}
				})
			},
			on: {
				beforeInit: function() {
					"coverflow" === this.params.effect && (this.classNames.push(this.params.containerModifierClass + "coverflow"), this.classNames.push(this.params.containerModifierClass + "3d"), this.params.watchSlidesProgress = !0, this.originalParams.watchSlidesProgress = !0)
				},
				setTranslate: function() {
					"coverflow" === this.params.effect && this.coverflowEffect.setTranslate()
				},
				setTransition: function(t) {
					"coverflow" === this.params.effect && this.coverflowEffect.setTransition(t)
				}
			}
		}];
	return void 0 === P.use && (P.use = P.Class.use, P.installModule = P.Class.installModule), P.use(tt), P
}),
function() {
	var t, e;
	t = this.jQuery || window.jQuery, e = t(window), t.fn.stick_in_parent = function(i) {
		var s, n, a, o, r, l, d, c, h, u, p, f;
		for (null == i && (i = {}), f = i.sticky_class, l = i.inner_scrolling, p = i.recalc_every, u = i.parent, h = i.offset_top, c = i.spacer, a = i.bottoming, null == h && (h = 0), null == u && (u = void 0), null == l && (l = !0), null == f && (f = "is_stuck"), s = t(document), null == a && (a = !0), o = function(i, n, o, r, d, m, g, v) {
				var y, b, w, S, x, T, C, _, E, P, k, $;
				if (i.data("sticky_kit", !0), x = s.height(), C = i.parent(), null != u && (C = C.closest(u)), !C.length) throw "failed to find stick parent";
				if (w = !1, y = !1, (k = null != c ? c && i.closest(c) : t("<div />")) && k.css("position", i.css("position")), (_ = function() {
						var t, e, a;
						if (!v) return x = s.height(), t = parseInt(C.css("border-top-width"), 10), e = parseInt(C.css("padding-top"), 10), n = parseInt(C.css("padding-bottom"), 10), o = C.offset().top + t + e, r = C.height(), w && (w = !1, y = !1, null == c && (i.insertAfter(k), k.detach()), i.css({
							position: "",
							top: "",
							width: "",
							bottom: ""
						}).removeClass(f), a = !0), d = i.offset().top - (parseInt(i.css("margin-top"), 10) || 0) - h, m = i.outerHeight(!0), g = i.css("float"), k && k.css({
							width: i.outerWidth(!0),
							height: m,
							display: i.css("display"),
							"vertical-align": i.css("vertical-align"),
							float: g
						}), a ? $() : void 0
					})(), m !== r) return S = void 0, T = h, P = p, $ = function() {
					var t, u, b, E, $, M;
					if (!v) return b = !1, null != P && (P -= 1) <= 0 && (P = p, _(), b = !0), b || s.height() === x || (_(), b = !0), E = e.scrollTop(), null != S && (u = E - S), S = E, w ? (a && ($ = E + m + T > r + o, y && !$ && (y = !1, i.css({
						position: "fixed",
						bottom: "",
						top: T
					}).trigger("sticky_kit:unbottom"))), E < d && (w = !1, T = h, null == c && ("left" !== g && "right" !== g || i.insertAfter(k), k.detach()), t = {
						position: "",
						width: "",
						top: ""
					}, i.css(t).removeClass(f).trigger("sticky_kit:unstick")), l && (M = e.height(), m + h > M && (y || (T -= u, T = Math.max(M - m, T), T = Math.min(h, T), w && i.css({
						top: T + "px"
					}))))) : E > d && (w = !0, (t = {
						position: "fixed",
						top: T
					}).width = "border-box" === i.css("box-sizing") ? i.outerWidth() + "px" : i.width() + "px", i.css(t).addClass(f), null == c && (i.after(k), "left" !== g && "right" !== g || k.append(i)), i.trigger("sticky_kit:stick")), w && a && (null == $ && ($ = E + m + T > r + o), !y && $) ? (y = !0, "static" === C.css("position") && C.css({
						position: "relative"
					}), i.css({
						position: "absolute",
						bottom: n,
						top: "auto"
					}).trigger("sticky_kit:bottom")) : void 0
				}, E = function() {
					return _(), $()
				}, b = function() {
					if (e.off("touchmove", $), e.off("scroll", $), e.off("resize", E), t(document.body).off("sticky_kit:recalc", E), i.off("sticky_kit:detach", b), i.removeData("sticky_kit"), i.css({
							position: "",
							bottom: "",
							top: "",
							width: ""
						}), C.position("position", ""), w) return null == c && ("left" !== g && "right" !== g || i.insertAfter(k), k.remove()), i.removeClass(f)
				}, e.on("touchmove", $), e.on("scroll", $), e.on("resize", E), t(document.body).on("sticky_kit:recalc", E), i.on("sticky_kit:detach", b), setTimeout($, 0)
			}, r = 0, d = this.length; r < d; r++) n = this[r], o(t(n));
		return this
	}
}.call(this),
	function(t) {
		"function" == typeof define && define.amd ? define(["jquery"], t) : t("object" == typeof exports ? require("jquery") : jQuery)
	}(function(t) {
		var e = function() {
				if (t && t.fn && t.fn.select2 && t.fn.select2.amd) var e = t.fn.select2.amd;
				return function() {
					var t, i, s;
					e && e.requirejs || (e ? i = e : e = {}, function(e) {
						function n(t, e) {
							return b.call(t, e)
						}

						function a(t, e) {
							var i, s, n, a, o, r, l, d, c, h, u, p = e && e.split("/"),
								f = v.map,
								m = f && f["*"] || {};
							if (t && "." === t.charAt(0))
								if (e) {
									for (o = (t = t.split("/")).length - 1, v.nodeIdCompat && S.test(t[o]) && (t[o] = t[o].replace(S, "")), t = p.slice(0, p.length - 1).concat(t), c = 0; c < t.length; c += 1)
										if ("." === (u = t[c])) t.splice(c, 1), c -= 1;
										else if (".." === u) {
										if (1 === c && (".." === t[2] || ".." === t[0])) break;
										c > 0 && (t.splice(c - 1, 2), c -= 2)
									}
									t = t.join("/")
								} else 0 === t.indexOf("./") && (t = t.substring(2));
							if ((p || m) && f) {
								for (c = (i = t.split("/")).length; c > 0; c -= 1) {
									if (s = i.slice(0, c).join("/"), p)
										for (h = p.length; h > 0; h -= 1)
											if ((n = f[p.slice(0, h).join("/")]) && (n = n[s])) {
												a = n, r = c;
												break
											} if (a) break;
									!l && m && m[s] && (l = m[s], d = c)
								}!a && l && (a = l, r = d), a && (i.splice(0, r, a), t = i.join("/"))
							}
							return t
						}

						function o(t, i) {
							return function() {
								var s = w.call(arguments, 0);
								return "string" != typeof s[0] && 1 === s.length && s.push(null), u.apply(e, s.concat([t, i]))
							}
						}

						function r(t) {
							return function(e) {
								m[t] = e
							}
						}

						function l(t) {
							if (n(g, t)) {
								var i = g[t];
								delete g[t], y[t] = !0, h.apply(e, i)
							}
							if (!n(m, t) && !n(y, t)) throw new Error("No " + t);
							return m[t]
						}

						function d(t) {
							var e, i = t ? t.indexOf("!") : -1;
							return i > -1 && (e = t.substring(0, i), t = t.substring(i + 1, t.length)), [e, t]
						}

						function c(t) {
							return function() {
								return v && v.config && v.config[t] || {}
							}
						}
						var h, u, p, f, m = {},
							g = {},
							v = {},
							y = {},
							b = Object.prototype.hasOwnProperty,
							w = [].slice,
							S = /\.js$/;
						p = function(t, e) {
							var i, s = d(t),
								n = s[0];
							return t = s[1], n && (i = l(n = a(n, e))), n ? t = i && i.normalize ? i.normalize(t, function(t) {
								return function(e) {
									return a(e, t)
								}
							}(e)) : a(t, e) : (n = (s = d(t = a(t, e)))[0], t = s[1], n && (i = l(n))), {
								f: n ? n + "!" + t : t,
								n: t,
								pr: n,
								p: i
							}
						}, f = {
							require: function(t) {
								return o(t)
							},
							exports: function(t) {
								var e = m[t];
								return void 0 !== e ? e : m[t] = {}
							},
							module: function(t) {
								return {
									id: t,
									uri: "",
									exports: m[t],
									config: c(t)
								}
							}
						}, h = function(t, i, s, a) {
							var d, c, h, u, v, b, w = [],
								S = typeof s;
							if (a = a || t, "undefined" === S || "function" === S) {
								for (i = !i.length && s.length ? ["require", "exports", "module"] : i, v = 0; v < i.length; v += 1)
									if ("require" === (c = (u = p(i[v], a)).f)) w[v] = f.require(t);
									else if ("exports" === c) w[v] = f.exports(t), b = !0;
								else if ("module" === c) d = w[v] = f.module(t);
								else if (n(m, c) || n(g, c) || n(y, c)) w[v] = l(c);
								else {
									if (!u.p) throw new Error(t + " missing " + c);
									u.p.load(u.n, o(a, !0), r(c), {}), w[v] = m[c]
								}
								h = s ? s.apply(m[t], w) : void 0, t && (d && d.exports !== e && d.exports !== m[t] ? m[t] = d.exports : h === e && b || (m[t] = h))
							} else t && (m[t] = s)
						}, t = i = u = function(t, i, s, n, a) {
							if ("string" == typeof t) return f[t] ? f[t](i) : l(p(t, i).f);
							if (!t.splice) {
								if ((v = t).deps && u(v.deps, v.callback), !i) return;
								i.splice ? (t = i, i = s, s = null) : t = e
							}
							return i = i || function() {}, "function" == typeof s && (s = n, n = a), n ? h(e, t, i, s) : setTimeout(function() {
								h(e, t, i, s)
							}, 4), u
						}, u.config = function(t) {
							return u(t)
						}, t._defined = m, (s = function(t, e, i) {
							if ("string" != typeof t) throw new Error("See almond README: incorrect module build, no module name");
							e.splice || (i = e, e = []), n(m, t) || n(g, t) || (g[t] = [t, e, i])
						}).amd = {
							jQuery: !0
						}
					}(), e.requirejs = t, e.require = i, e.define = s)
				}(), e.define("almond", function() {}), e.define("jquery", [], function() {
					var e = t || $;
					return null == e && console && console.error && console.error("Select2: An instance of jQuery or a jQuery-compatible library was not found. Make sure that you are including jQuery before Select2 on your web page."), e
				}), e.define("select2/utils", ["jquery"], function(t) {
					function e(t) {
						var e = t.prototype,
							i = [];
						for (var s in e) {
							"function" == typeof e[s] && "constructor" !== s && i.push(s)
						}
						return i
					}
					var i = {
							Extend: function(t, e) {
								function i() {
									this.constructor = t
								}
								var s = {}.hasOwnProperty;
								for (var n in e) s.call(e, n) && (t[n] = e[n]);
								return i.prototype = e.prototype, t.prototype = new i, t.__super__ = e.prototype, t
							},
							Decorate: function(t, i) {
								function s() {
									var e = Array.prototype.unshift,
										s = i.prototype.constructor.length,
										n = t.prototype.constructor;
									s > 0 && (e.call(arguments, t.prototype.constructor), n = i.prototype.constructor), n.apply(this, arguments)
								}
								var n = e(i),
									a = e(t);
								i.displayName = t.displayName, s.prototype = new function() {
									this.constructor = s
								};
								for (var o = 0; o < a.length; o++) {
									var r = a[o];
									s.prototype[r] = t.prototype[r]
								}
								for (var l = function(t) {
										var e = function() {};
										t in s.prototype && (e = s.prototype[t]);
										var n = i.prototype[t];
										return function() {
											return Array.prototype.unshift.call(arguments, e), n.apply(this, arguments)
										}
									}, d = 0; d < n.length; d++) {
									var c = n[d];
									s.prototype[c] = l(c)
								}
								return s
							}
						},
						s = function() {
							this.listeners = {}
						};
					return s.prototype.on = function(t, e) {
						this.listeners = this.listeners || {}, t in this.listeners ? this.listeners[t].push(e) : this.listeners[t] = [e]
					}, s.prototype.trigger = function(t) {
						var e = Array.prototype.slice,
							i = e.call(arguments, 1);
						this.listeners = this.listeners || {}, null == i && (i = []), 0 === i.length && i.push({}), i[0]._type = t, t in this.listeners && this.invoke(this.listeners[t], e.call(arguments, 1)), "*" in this.listeners && this.invoke(this.listeners["*"], arguments)
					}, s.prototype.invoke = function(t, e) {
						for (var i = 0, s = t.length; s > i; i++) t[i].apply(this, e)
					}, i.Observable = s, i.generateChars = function(t) {
						for (var e = "", i = 0; t > i; i++) {
							e += Math.floor(36 * Math.random()).toString(36)
						}
						return e
					}, i.bind = function(t, e) {
						return function() {
							t.apply(e, arguments)
						}
					}, i._convertData = function(t) {
						for (var e in t) {
							var i = e.split("-"),
								s = t;
							if (1 !== i.length) {
								for (var n = 0; n < i.length; n++) {
									var a = i[n];
									(a = a.substring(0, 1).toLowerCase() + a.substring(1)) in s || (s[a] = {}), n == i.length - 1 && (s[a] = t[e]), s = s[a]
								}
								delete t[e]
							}
						}
						return t
					}, i.hasScroll = function(e, i) {
						var s = t(i),
							n = i.style.overflowX,
							a = i.style.overflowY;
						return (n !== a || "hidden" !== a && "visible" !== a) && ("scroll" === n || "scroll" === a || (s.innerHeight() < i.scrollHeight || s.innerWidth() < i.scrollWidth))
					}, i.escapeMarkup = function(t) {
						var e = {
							"\\": "&#92;",
							"&": "&amp;",
							"<": "&lt;",
							">": "&gt;",
							'"': "&quot;",
							"'": "&#39;",
							"/": "&#47;"
						};
						return "string" != typeof t ? t : String(t).replace(/[&<>"'\/\\]/g, function(t) {
							return e[t]
						})
					}, i.appendMany = function(e, i) {
						if ("1.7" === t.fn.jquery.substr(0, 3)) {
							var s = t();
							t.map(i, function(t) {
								s = s.add(t)
							}), i = s
						}
						e.append(i)
					}, i
				}), e.define("select2/results", ["jquery", "./utils"], function(t, e) {
					function i(t, e, s) {
						this.$element = t, this.data = s, this.options = e, i.__super__.constructor.call(this)
					}
					return e.Extend(i, e.Observable), i.prototype.render = function() {
						var e = t('<ul class="select2-results__options" role="tree"></ul>');
						return this.options.get("multiple") && e.attr("aria-multiselectable", "true"), this.$results = e, e
					}, i.prototype.clear = function() {
						this.$results.empty()
					}, i.prototype.displayMessage = function(e) {
						var i = this.options.get("escapeMarkup");
						this.clear(), this.hideLoading();
						var s = t('<li role="treeitem" aria-live="assertive" class="select2-results__option"></li>'),
							n = this.options.get("translations").get(e.message);
						s.append(i(n(e.args))), s[0].className += " select2-results__message", this.$results.append(s)
					}, i.prototype.hideMessages = function() {
						this.$results.find(".select2-results__message").remove()
					}, i.prototype.append = function(t) {
						this.hideLoading();
						var e = [];
						if (null != t.results && 0 !== t.results.length) {
							t.results = this.sort(t.results);
							for (var i = 0; i < t.results.length; i++) {
								var s = t.results[i],
									n = this.option(s);
								e.push(n)
							}
							this.$results.append(e)
						} else 0 === this.$results.children().length && this.trigger("results:message", {
							message: "noResults"
						})
					}, i.prototype.position = function(t, e) {
						e.find(".select2-results").append(t)
					}, i.prototype.sort = function(t) {
						return this.options.get("sorter")(t)
					}, i.prototype.highlightFirstItem = function() {
						var t = this.$results.find(".select2-results__option[aria-selected]"),
							e = t.filter("[aria-selected=true]");
						e.length > 0 ? e.first().trigger("mouseenter") : t.first().trigger("mouseenter"), this.ensureHighlightVisible()
					}, i.prototype.setClasses = function() {
						var e = this;
						this.data.current(function(i) {
							var s = t.map(i, function(t) {
								return t.id.toString()
							});
							e.$results.find(".select2-results__option[aria-selected]").each(function() {
								var e = t(this),
									i = t.data(this, "data"),
									n = "" + i.id;
								null != i.element && i.element.selected || null == i.element && t.inArray(n, s) > -1 ? e.attr("aria-selected", "true") : e.attr("aria-selected", "false")
							})
						})
					}, i.prototype.showLoading = function(t) {
						this.hideLoading();
						var e = {
								disabled: !0,
								loading: !0,
								text: this.options.get("translations").get("searching")(t)
							},
							i = this.option(e);
						i.className += " loading-results", this.$results.prepend(i)
					}, i.prototype.hideLoading = function() {
						this.$results.find(".loading-results").remove()
					}, i.prototype.option = function(e) {
						var i = document.createElement("li");
						i.className = "select2-results__option";
						var s = {
							role: "treeitem",
							"aria-selected": "false"
						};
						for (var n in e.disabled && (delete s["aria-selected"], s["aria-disabled"] = "true"), null == e.id && delete s["aria-selected"], null != e._resultId && (i.id = e._resultId), e.title && (i.title = e.title), e.children && (s.role = "group", s["aria-label"] = e.text, delete s["aria-selected"]), s) {
							var a = s[n];
							i.setAttribute(n, a)
						}
						if (e.children) {
							var o = t(i),
								r = document.createElement("strong");
							r.className = "select2-results__group", t(r), this.template(e, r);
							for (var l = [], d = 0; d < e.children.length; d++) {
								var c = e.children[d],
									h = this.option(c);
								l.push(h)
							}
							var u = t("<ul></ul>", {
								class: "select2-results__options select2-results__options--nested"
							});
							u.append(l), o.append(r), o.append(u)
						} else this.template(e, i);
						return t.data(i, "data", e), i
					}, i.prototype.bind = function(e, i) {
						var s = this,
							n = e.id + "-results";
						this.$results.attr("id", n), e.on("results:all", function(t) {
							s.clear(), s.append(t.data), e.isOpen() && (s.setClasses(), s.highlightFirstItem())
						}), e.on("results:append", function(t) {
							s.append(t.data), e.isOpen() && s.setClasses()
						}), e.on("query", function(t) {
							s.hideMessages(), s.showLoading(t)
						}), e.on("select", function() {
							e.isOpen() && (s.setClasses(), s.highlightFirstItem())
						}), e.on("unselect", function() {
							e.isOpen() && (s.setClasses(), s.highlightFirstItem())
						}), e.on("open", function() {
							s.$results.attr("aria-expanded", "true"), s.$results.attr("aria-hidden", "false"), s.setClasses(), s.ensureHighlightVisible()
						}), e.on("close", function() {
							s.$results.attr("aria-expanded", "false"), s.$results.attr("aria-hidden", "true"), s.$results.removeAttr("aria-activedescendant")
						}), e.on("results:toggle", function() {
							var t = s.getHighlightedResults();
							0 !== t.length && t.trigger("mouseup")
						}), e.on("results:select", function() {
							var t = s.getHighlightedResults();
							if (0 !== t.length) {
								var e = t.data("data");
								"true" == t.attr("aria-selected") ? s.trigger("close", {}) : s.trigger("select", {
									data: e
								})
							}
						}), e.on("results:previous", function() {
							var t = s.getHighlightedResults(),
								e = s.$results.find("[aria-selected]"),
								i = e.index(t);
							if (0 !== i) {
								var n = i - 1;
								0 === t.length && (n = 0);
								var a = e.eq(n);
								a.trigger("mouseenter");
								var o = s.$results.offset().top,
									r = a.offset().top,
									l = s.$results.scrollTop() + (r - o);
								0 === n ? s.$results.scrollTop(0) : 0 > r - o && s.$results.scrollTop(l)
							}
						}), e.on("results:next", function() {
							var t = s.getHighlightedResults(),
								e = s.$results.find("[aria-selected]"),
								i = e.index(t) + 1;
							if (!(i >= e.length)) {
								var n = e.eq(i);
								n.trigger("mouseenter");
								var a = s.$results.offset().top + s.$results.outerHeight(!1),
									o = n.offset().top + n.outerHeight(!1),
									r = s.$results.scrollTop() + o - a;
								0 === i ? s.$results.scrollTop(0) : o > a && s.$results.scrollTop(r)
							}
						}), e.on("results:focus", function(t) {
							t.element.addClass("select2-results__option--highlighted")
						}), e.on("results:message", function(t) {
							s.displayMessage(t)
						}), t.fn.mousewheel && this.$results.on("mousewheel", function(t) {
							var e = s.$results.scrollTop(),
								i = s.$results.get(0).scrollHeight - e + t.deltaY,
								n = t.deltaY > 0 && e - t.deltaY <= 0,
								a = t.deltaY < 0 && i <= s.$results.height();
							n ? (s.$results.scrollTop(0), t.preventDefault(), t.stopPropagation()) : a && (s.$results.scrollTop(s.$results.get(0).scrollHeight - s.$results.height()), t.preventDefault(), t.stopPropagation())
						}), this.$results.on("mouseup", ".select2-results__option[aria-selected]", function(e) {
							var i = t(this),
								n = i.data("data");
							return "true" === i.attr("aria-selected") ? void(s.options.get("multiple") ? s.trigger("unselect", {
								originalEvent: e,
								data: n
							}) : s.trigger("close", {})) : void s.trigger("select", {
								originalEvent: e,
								data: n
							})
						}), this.$results.on("mouseenter", ".select2-results__option[aria-selected]", function(e) {
							var i = t(this).data("data");
							s.getHighlightedResults().removeClass("select2-results__option--highlighted"), s.trigger("results:focus", {
								data: i,
								element: t(this)
							})
						})
					}, i.prototype.getHighlightedResults = function() {
						return this.$results.find(".select2-results__option--highlighted")
					}, i.prototype.destroy = function() {
						this.$results.remove()
					}, i.prototype.ensureHighlightVisible = function() {
						var t = this.getHighlightedResults();
						if (0 !== t.length) {
							var e = this.$results.find("[aria-selected]").index(t),
								i = this.$results.offset().top,
								s = t.offset().top,
								n = this.$results.scrollTop() + (s - i),
								a = s - i;
							n -= 2 * t.outerHeight(!1), 2 >= e ? this.$results.scrollTop(0) : (a > this.$results.outerHeight() || 0 > a) && this.$results.scrollTop(n)
						}
					}, i.prototype.template = function(e, i) {
						var s = this.options.get("templateResult"),
							n = this.options.get("escapeMarkup"),
							a = s(e, i);
						null == a ? i.style.display = "none" : "string" == typeof a ? i.innerHTML = n(a) : t(i).append(a)
					}, i
				}), e.define("select2/keys", [], function() {
					return {
						BACKSPACE: 8,
						TAB: 9,
						ENTER: 13,
						SHIFT: 16,
						CTRL: 17,
						ALT: 18,
						ESC: 27,
						SPACE: 32,
						PAGE_UP: 33,
						PAGE_DOWN: 34,
						END: 35,
						HOME: 36,
						LEFT: 37,
						UP: 38,
						RIGHT: 39,
						DOWN: 40,
						DELETE: 46
					}
				}), e.define("select2/selection/base", ["jquery", "../utils", "../keys"], function(t, e, i) {
					function s(t, e) {
						this.$element = t, this.options = e, s.__super__.constructor.call(this)
					}
					return e.Extend(s, e.Observable), s.prototype.render = function() {
						var e = t('<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>');
						return this._tabindex = 0, null != this.$element.data("old-tabindex") ? this._tabindex = this.$element.data("old-tabindex") : null != this.$element.attr("tabindex") && (this._tabindex = this.$element.attr("tabindex")), e.attr("title", this.$element.attr("title")), e.attr("tabindex", this._tabindex), this.$selection = e, e
					}, s.prototype.bind = function(t, e) {
						var s = this,
							n = (t.id, t.id + "-results");
						this.container = t, this.$selection.on("focus", function(t) {
							s.trigger("focus", t)
						}), this.$selection.on("blur", function(t) {
							s._handleBlur(t)
						}), this.$selection.on("keydown", function(t) {
							s.trigger("keypress", t), t.which === i.SPACE && t.preventDefault()
						}), t.on("results:focus", function(t) {
							s.$selection.attr("aria-activedescendant", t.data._resultId)
						}), t.on("selection:update", function(t) {
							s.update(t.data)
						}), t.on("open", function() {
							s.$selection.attr("aria-expanded", "true"), s.$selection.attr("aria-owns", n), s._attachCloseHandler(t)
						}), t.on("close", function() {
							s.$selection.attr("aria-expanded", "false"), s.$selection.removeAttr("aria-activedescendant"), s.$selection.removeAttr("aria-owns"), s.$selection.focus(), s._detachCloseHandler(t)
						}), t.on("enable", function() {
							s.$selection.attr("tabindex", s._tabindex)
						}), t.on("disable", function() {
							s.$selection.attr("tabindex", "-1")
						})
					}, s.prototype._handleBlur = function(e) {
						var i = this;
						window.setTimeout(function() {
							document.activeElement == i.$selection[0] || t.contains(i.$selection[0], document.activeElement) || i.trigger("blur", e)
						}, 1)
					}, s.prototype._attachCloseHandler = function(e) {
						t(document.body).on("mousedown.select2." + e.id, function(e) {
							var i = t(e.target).closest(".select2");
							t(".select2.select2-container--open").each(function() {
								var e = t(this);
								this != i[0] && e.data("element").select2("close")
							})
						})
					}, s.prototype._detachCloseHandler = function(e) {
						t(document.body).off("mousedown.select2." + e.id)
					}, s.prototype.position = function(t, e) {
						e.find(".selection").append(t)
					}, s.prototype.destroy = function() {
						this._detachCloseHandler(this.container)
					}, s.prototype.update = function(t) {
						throw new Error("The `update` method must be defined in child classes.")
					}, s
				}), e.define("select2/selection/single", ["jquery", "./base", "../utils", "../keys"], function(t, e, i, s) {
					function n() {
						n.__super__.constructor.apply(this, arguments)
					}
					return i.Extend(n, e), n.prototype.render = function() {
						var t = n.__super__.render.call(this);
						return t.addClass("select2-selection--single"), t.html('<span class="select2-selection__rendered"></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>'), t
					}, n.prototype.bind = function(t, e) {
						var i = this;
						n.__super__.bind.apply(this, arguments);
						var s = t.id + "-container";
						this.$selection.find(".select2-selection__rendered").attr("id", s), this.$selection.attr("aria-labelledby", s), this.$selection.on("mousedown", function(t) {
							1 === t.which && i.trigger("toggle", {
								originalEvent: t
							})
						}), this.$selection.on("focus", function(t) {}), this.$selection.on("blur", function(t) {}), t.on("focus", function(e) {
							t.isOpen() || i.$selection.focus()
						}), t.on("selection:update", function(t) {
							i.update(t.data)
						})
					}, n.prototype.clear = function() {
						this.$selection.find(".select2-selection__rendered").empty()
					}, n.prototype.display = function(t, e) {
						var i = this.options.get("templateSelection");
						return this.options.get("escapeMarkup")(i(t, e))
					}, n.prototype.selectionContainer = function() {
						return t("<span></span>")
					}, n.prototype.update = function(t) {
						if (0 !== t.length) {
							var e = t[0],
								i = this.$selection.find(".select2-selection__rendered"),
								s = this.display(e, i);
							i.empty().append(s), i.prop("title", e.title || e.text)
						} else this.clear()
					}, n
				}), e.define("select2/selection/multiple", ["jquery", "./base", "../utils"], function(t, e, i) {
					function s(t, e) {
						s.__super__.constructor.apply(this, arguments)
					}
					return i.Extend(s, e), s.prototype.render = function() {
						var t = s.__super__.render.call(this);
						return t.addClass("select2-selection--multiple"), t.html('<ul class="select2-selection__rendered"></ul>'), t
					}, s.prototype.bind = function(e, i) {
						var n = this;
						s.__super__.bind.apply(this, arguments), this.$selection.on("click", function(t) {
							n.trigger("toggle", {
								originalEvent: t
							})
						}), this.$selection.on("click", ".select2-selection__choice__remove", function(e) {
							if (!n.options.get("disabled")) {
								var i = t(this).parent().data("data");
								n.trigger("unselect", {
									originalEvent: e,
									data: i
								})
							}
						})
					}, s.prototype.clear = function() {
						this.$selection.find(".select2-selection__rendered").empty()
					}, s.prototype.display = function(t, e) {
						var i = this.options.get("templateSelection");
						return this.options.get("escapeMarkup")(i(t, e))
					}, s.prototype.selectionContainer = function() {
						return t('<li class="select2-selection__choice"><span class="select2-selection__choice__remove" role="presentation">&times;</span></li>')
					}, s.prototype.update = function(t) {
						if (this.clear(), 0 !== t.length) {
							for (var e = [], s = 0; s < t.length; s++) {
								var n = t[s],
									a = this.selectionContainer(),
									o = this.display(n, a);
								a.append(o), a.prop("title", n.title || n.text), a.data("data", n), e.push(a)
							}
							var r = this.$selection.find(".select2-selection__rendered");
							i.appendMany(r, e)
						}
					}, s
				}), e.define("select2/selection/placeholder", ["../utils"], function(t) {
					function e(t, e, i) {
						this.placeholder = this.normalizePlaceholder(i.get("placeholder")), t.call(this, e, i)
					}
					return e.prototype.normalizePlaceholder = function(t, e) {
						return "string" == typeof e && (e = {
							id: "",
							text: e
						}), e
					}, e.prototype.createPlaceholder = function(t, e) {
						var i = this.selectionContainer();
						return i.html(this.display(e)), i.addClass("select2-selection__placeholder").removeClass("select2-selection__choice"), i
					}, e.prototype.update = function(t, e) {
						var i = 1 == e.length && e[0].id != this.placeholder.id;
						if (e.length > 1 || i) return t.call(this, e);
						this.clear();
						var s = this.createPlaceholder(this.placeholder);
						this.$selection.find(".select2-selection__rendered").append(s)
					}, e
				}), e.define("select2/selection/allowClear", ["jquery", "../keys"], function(t, e) {
					function i() {}
					return i.prototype.bind = function(t, e, i) {
						var s = this;
						t.call(this, e, i), null == this.placeholder && this.options.get("debug") && window.console && console.error && console.error("Select2: The `allowClear` option should be used in combination with the `placeholder` option."), this.$selection.on("mousedown", ".select2-selection__clear", function(t) {
							s._handleClear(t)
						}), e.on("keypress", function(t) {
							s._handleKeyboardClear(t, e)
						})
					}, i.prototype._handleClear = function(t, e) {
						if (!this.options.get("disabled")) {
							var i = this.$selection.find(".select2-selection__clear");
							if (0 !== i.length) {
								e.stopPropagation();
								for (var s = i.data("data"), n = 0; n < s.length; n++) {
									var a = {
										data: s[n]
									};
									if (this.trigger("unselect", a), a.prevented) return
								}
								this.$element.val(this.placeholder.id).trigger("change"), this.trigger("toggle", {})
							}
						}
					}, i.prototype._handleKeyboardClear = function(t, i, s) {
						s.isOpen() || (i.which == e.DELETE || i.which == e.BACKSPACE) && this._handleClear(i)
					}, i.prototype.update = function(e, i) {
						if (e.call(this, i), !(this.$selection.find(".select2-selection__placeholder").length > 0 || 0 === i.length)) {
							var s = t('<span class="select2-selection__clear">&times;</span>');
							s.data("data", i), this.$selection.find(".select2-selection__rendered").prepend(s)
						}
					}, i
				}), e.define("select2/selection/search", ["jquery", "../utils", "../keys"], function(t, e, i) {
					function s(t, e, i) {
						t.call(this, e, i)
					}
					return s.prototype.render = function(e) {
						var i = t('<li class="select2-search select2-search--inline"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" role="textbox" aria-autocomplete="list" /></li>');
						this.$searchContainer = i, this.$search = i.find("input");
						var s = e.call(this);
						return this._transferTabIndex(), s
					}, s.prototype.bind = function(t, e, s) {
						var n = this;
						t.call(this, e, s), e.on("open", function() {
							n.$search.trigger("focus")
						}), e.on("close", function() {
							n.$search.val(""), n.$search.removeAttr("aria-activedescendant"), n.$search.trigger("focus")
						}), e.on("enable", function() {
							n.$search.prop("disabled", !1), n._transferTabIndex()
						}), e.on("disable", function() {
							n.$search.prop("disabled", !0)
						}), e.on("focus", function(t) {
							n.$search.trigger("focus")
						}), e.on("results:focus", function(t) {
							n.$search.attr("aria-activedescendant", t.id)
						}), this.$selection.on("focusin", ".select2-search--inline", function(t) {
							n.trigger("focus", t)
						}), this.$selection.on("focusout", ".select2-search--inline", function(t) {
							n._handleBlur(t)
						}), this.$selection.on("keydown", ".select2-search--inline", function(t) {
							if (t.stopPropagation(), n.trigger("keypress", t), n._keyUpPrevented = t.isDefaultPrevented(), t.which === i.BACKSPACE && "" === n.$search.val()) {
								var e = n.$searchContainer.prev(".select2-selection__choice");
								if (e.length > 0) {
									var s = e.data("data");
									n.searchRemoveChoice(s), t.preventDefault()
								}
							}
						});
						var a = document.documentMode,
							o = a && 11 >= a;
						this.$selection.on("input.searchcheck", ".select2-search--inline", function(t) {
							return o ? void n.$selection.off("input.search input.searchcheck") : void n.$selection.off("keyup.search")
						}), this.$selection.on("keyup.search input.search", ".select2-search--inline", function(t) {
							if (o && "input" === t.type) n.$selection.off("input.search input.searchcheck");
							else {
								var e = t.which;
								e != i.SHIFT && e != i.CTRL && e != i.ALT && e != i.TAB && n.handleSearch(t)
							}
						})
					}, s.prototype._transferTabIndex = function(t) {
						this.$search.attr("tabindex", this.$selection.attr("tabindex")), this.$selection.attr("tabindex", "-1")
					}, s.prototype.createPlaceholder = function(t, e) {
						this.$search.attr("placeholder", e.text)
					}, s.prototype.update = function(t, e) {
						var i = this.$search[0] == document.activeElement;
						this.$search.attr("placeholder", ""), t.call(this, e), this.$selection.find(".select2-selection__rendered").append(this.$searchContainer), this.resizeSearch(), i && this.$search.focus()
					}, s.prototype.handleSearch = function() {
						if (this.resizeSearch(), !this._keyUpPrevented) {
							var t = this.$search.val();
							this.trigger("query", {
								term: t
							})
						}
						this._keyUpPrevented = !1
					}, s.prototype.searchRemoveChoice = function(t, e) {
						this.trigger("unselect", {
							data: e
						}), this.$search.val(e.text), this.handleSearch()
					}, s.prototype.resizeSearch = function() {
						this.$search.css("width", "25px");
						var t = "";
						"" !== this.$search.attr("placeholder") ? t = this.$selection.find(".select2-selection__rendered").innerWidth() : t = .75 * (this.$search.val().length + 1) + "em";
						this.$search.css("width", t)
					}, s
				}), e.define("select2/selection/eventRelay", ["jquery"], function(t) {
					function e() {}
					return e.prototype.bind = function(e, i, s) {
						var n = this,
							a = ["open", "opening", "close", "closing", "select", "selecting", "unselect", "unselecting"],
							o = ["opening", "closing", "selecting", "unselecting"];
						e.call(this, i, s), i.on("*", function(e, i) {
							if (-1 !== t.inArray(e, a)) {
								i = i || {};
								var s = t.Event("select2:" + e, {
									params: i
								});
								n.$element.trigger(s), -1 !== t.inArray(e, o) && (i.prevented = s.isDefaultPrevented())
							}
						})
					}, e
				}), e.define("select2/translation", ["jquery", "require"], function(t, e) {
					function i(t) {
						this.dict = t || {}
					}
					return i.prototype.all = function() {
						return this.dict
					}, i.prototype.get = function(t) {
						return this.dict[t]
					}, i.prototype.extend = function(e) {
						this.dict = t.extend({}, e.all(), this.dict)
					}, i._cache = {}, i.loadPath = function(t) {
						if (!(t in i._cache)) {
							var s = e(t);
							i._cache[t] = s
						}
						return new i(i._cache[t])
					}, i
				}), e.define("select2/diacritics", [], function() {
					return {
						"Ⓐ": "A",
						"Ａ": "A",
						"À": "A",
						"Á": "A",
						"Â": "A",
						"Ầ": "A",
						"Ấ": "A",
						"Ẫ": "A",
						"Ẩ": "A",
						"Ã": "A",
						"Ā": "A",
						"Ă": "A",
						"Ằ": "A",
						"Ắ": "A",
						"Ẵ": "A",
						"Ẳ": "A",
						"Ȧ": "A",
						"Ǡ": "A",
						"Ä": "A",
						"Ǟ": "A",
						"Ả": "A",
						"Å": "A",
						"Ǻ": "A",
						"Ǎ": "A",
						"Ȁ": "A",
						"Ȃ": "A",
						"Ạ": "A",
						"Ậ": "A",
						"Ặ": "A",
						"Ḁ": "A",
						"Ą": "A",
						"Ⱥ": "A",
						"Ɐ": "A",
						"Ꜳ": "AA",
						"Æ": "AE",
						"Ǽ": "AE",
						"Ǣ": "AE",
						"Ꜵ": "AO",
						"Ꜷ": "AU",
						"Ꜹ": "AV",
						"Ꜻ": "AV",
						"Ꜽ": "AY",
						"Ⓑ": "B",
						"Ｂ": "B",
						"Ḃ": "B",
						"Ḅ": "B",
						"Ḇ": "B",
						"Ƀ": "B",
						"Ƃ": "B",
						"Ɓ": "B",
						"Ⓒ": "C",
						"Ｃ": "C",
						"Ć": "C",
						"Ĉ": "C",
						"Ċ": "C",
						"Č": "C",
						"Ç": "C",
						"Ḉ": "C",
						"Ƈ": "C",
						"Ȼ": "C",
						"Ꜿ": "C",
						"Ⓓ": "D",
						"Ｄ": "D",
						"Ḋ": "D",
						"Ď": "D",
						"Ḍ": "D",
						"Ḑ": "D",
						"Ḓ": "D",
						"Ḏ": "D",
						"Đ": "D",
						"Ƌ": "D",
						"Ɗ": "D",
						"Ɖ": "D",
						"Ꝺ": "D",
						"Ǳ": "DZ",
						"Ǆ": "DZ",
						"ǲ": "Dz",
						"ǅ": "Dz",
						"Ⓔ": "E",
						"Ｅ": "E",
						"È": "E",
						"É": "E",
						"Ê": "E",
						"Ề": "E",
						"Ế": "E",
						"Ễ": "E",
						"Ể": "E",
						"Ẽ": "E",
						"Ē": "E",
						"Ḕ": "E",
						"Ḗ": "E",
						"Ĕ": "E",
						"Ė": "E",
						"Ë": "E",
						"Ẻ": "E",
						"Ě": "E",
						"Ȅ": "E",
						"Ȇ": "E",
						"Ẹ": "E",
						"Ệ": "E",
						"Ȩ": "E",
						"Ḝ": "E",
						"Ę": "E",
						"Ḙ": "E",
						"Ḛ": "E",
						"Ɛ": "E",
						"Ǝ": "E",
						"Ⓕ": "F",
						"Ｆ": "F",
						"Ḟ": "F",
						"Ƒ": "F",
						"Ꝼ": "F",
						"Ⓖ": "G",
						"Ｇ": "G",
						"Ǵ": "G",
						"Ĝ": "G",
						"Ḡ": "G",
						"Ğ": "G",
						"Ġ": "G",
						"Ǧ": "G",
						"Ģ": "G",
						"Ǥ": "G",
						"Ɠ": "G",
						"Ꞡ": "G",
						"Ᵹ": "G",
						"Ꝿ": "G",
						"Ⓗ": "H",
						"Ｈ": "H",
						"Ĥ": "H",
						"Ḣ": "H",
						"Ḧ": "H",
						"Ȟ": "H",
						"Ḥ": "H",
						"Ḩ": "H",
						"Ḫ": "H",
						"Ħ": "H",
						"Ⱨ": "H",
						"Ⱶ": "H",
						"Ɥ": "H",
						"Ⓘ": "I",
						"Ｉ": "I",
						"Ì": "I",
						"Í": "I",
						"Î": "I",
						"Ĩ": "I",
						"Ī": "I",
						"Ĭ": "I",
						"İ": "I",
						"Ï": "I",
						"Ḯ": "I",
						"Ỉ": "I",
						"Ǐ": "I",
						"Ȉ": "I",
						"Ȋ": "I",
						"Ị": "I",
						"Į": "I",
						"Ḭ": "I",
						"Ɨ": "I",
						"Ⓙ": "J",
						"Ｊ": "J",
						"Ĵ": "J",
						"Ɉ": "J",
						"Ⓚ": "K",
						"Ｋ": "K",
						"Ḱ": "K",
						"Ǩ": "K",
						"Ḳ": "K",
						"Ķ": "K",
						"Ḵ": "K",
						"Ƙ": "K",
						"Ⱪ": "K",
						"Ꝁ": "K",
						"Ꝃ": "K",
						"Ꝅ": "K",
						"Ꞣ": "K",
						"Ⓛ": "L",
						"Ｌ": "L",
						"Ŀ": "L",
						"Ĺ": "L",
						"Ľ": "L",
						"Ḷ": "L",
						"Ḹ": "L",
						"Ļ": "L",
						"Ḽ": "L",
						"Ḻ": "L",
						"Ł": "L",
						"Ƚ": "L",
						"Ɫ": "L",
						"Ⱡ": "L",
						"Ꝉ": "L",
						"Ꝇ": "L",
						"Ꞁ": "L",
						"Ǉ": "LJ",
						"ǈ": "Lj",
						"Ⓜ": "M",
						"Ｍ": "M",
						"Ḿ": "M",
						"Ṁ": "M",
						"Ṃ": "M",
						"Ɱ": "M",
						"Ɯ": "M",
						"Ⓝ": "N",
						"Ｎ": "N",
						"Ǹ": "N",
						"Ń": "N",
						"Ñ": "N",
						"Ṅ": "N",
						"Ň": "N",
						"Ṇ": "N",
						"Ņ": "N",
						"Ṋ": "N",
						"Ṉ": "N",
						"Ƞ": "N",
						"Ɲ": "N",
						"Ꞑ": "N",
						"Ꞥ": "N",
						"Ǌ": "NJ",
						"ǋ": "Nj",
						"Ⓞ": "O",
						"Ｏ": "O",
						"Ò": "O",
						"Ó": "O",
						"Ô": "O",
						"Ồ": "O",
						"Ố": "O",
						"Ỗ": "O",
						"Ổ": "O",
						"Õ": "O",
						"Ṍ": "O",
						"Ȭ": "O",
						"Ṏ": "O",
						"Ō": "O",
						"Ṑ": "O",
						"Ṓ": "O",
						"Ŏ": "O",
						"Ȯ": "O",
						"Ȱ": "O",
						"Ö": "O",
						"Ȫ": "O",
						"Ỏ": "O",
						"Ő": "O",
						"Ǒ": "O",
						"Ȍ": "O",
						"Ȏ": "O",
						"Ơ": "O",
						"Ờ": "O",
						"Ớ": "O",
						"Ỡ": "O",
						"Ở": "O",
						"Ợ": "O",
						"Ọ": "O",
						"Ộ": "O",
						"Ǫ": "O",
						"Ǭ": "O",
						"Ø": "O",
						"Ǿ": "O",
						"Ɔ": "O",
						"Ɵ": "O",
						"Ꝋ": "O",
						"Ꝍ": "O",
						"Ƣ": "OI",
						"Ꝏ": "OO",
						"Ȣ": "OU",
						"Ⓟ": "P",
						"Ｐ": "P",
						"Ṕ": "P",
						"Ṗ": "P",
						"Ƥ": "P",
						"Ᵽ": "P",
						"Ꝑ": "P",
						"Ꝓ": "P",
						"Ꝕ": "P",
						"Ⓠ": "Q",
						"Ｑ": "Q",
						"Ꝗ": "Q",
						"Ꝙ": "Q",
						"Ɋ": "Q",
						"Ⓡ": "R",
						"Ｒ": "R",
						"Ŕ": "R",
						"Ṙ": "R",
						"Ř": "R",
						"Ȑ": "R",
						"Ȓ": "R",
						"Ṛ": "R",
						"Ṝ": "R",
						"Ŗ": "R",
						"Ṟ": "R",
						"Ɍ": "R",
						"Ɽ": "R",
						"Ꝛ": "R",
						"Ꞧ": "R",
						"Ꞃ": "R",
						"Ⓢ": "S",
						"Ｓ": "S",
						"ẞ": "S",
						"Ś": "S",
						"Ṥ": "S",
						"Ŝ": "S",
						"Ṡ": "S",
						"Š": "S",
						"Ṧ": "S",
						"Ṣ": "S",
						"Ṩ": "S",
						"Ș": "S",
						"Ş": "S",
						"Ȿ": "S",
						"Ꞩ": "S",
						"Ꞅ": "S",
						"Ⓣ": "T",
						"Ｔ": "T",
						"Ṫ": "T",
						"Ť": "T",
						"Ṭ": "T",
						"Ț": "T",
						"Ţ": "T",
						"Ṱ": "T",
						"Ṯ": "T",
						"Ŧ": "T",
						"Ƭ": "T",
						"Ʈ": "T",
						"Ⱦ": "T",
						"Ꞇ": "T",
						"Ꜩ": "TZ",
						"Ⓤ": "U",
						"Ｕ": "U",
						"Ù": "U",
						"Ú": "U",
						"Û": "U",
						"Ũ": "U",
						"Ṹ": "U",
						"Ū": "U",
						"Ṻ": "U",
						"Ŭ": "U",
						"Ü": "U",
						"Ǜ": "U",
						"Ǘ": "U",
						"Ǖ": "U",
						"Ǚ": "U",
						"Ủ": "U",
						"Ů": "U",
						"Ű": "U",
						"Ǔ": "U",
						"Ȕ": "U",
						"Ȗ": "U",
						"Ư": "U",
						"Ừ": "U",
						"Ứ": "U",
						"Ữ": "U",
						"Ử": "U",
						"Ự": "U",
						"Ụ": "U",
						"Ṳ": "U",
						"Ų": "U",
						"Ṷ": "U",
						"Ṵ": "U",
						"Ʉ": "U",
						"Ⓥ": "V",
						"Ｖ": "V",
						"Ṽ": "V",
						"Ṿ": "V",
						"Ʋ": "V",
						"Ꝟ": "V",
						"Ʌ": "V",
						"Ꝡ": "VY",
						"Ⓦ": "W",
						"Ｗ": "W",
						"Ẁ": "W",
						"Ẃ": "W",
						"Ŵ": "W",
						"Ẇ": "W",
						"Ẅ": "W",
						"Ẉ": "W",
						"Ⱳ": "W",
						"Ⓧ": "X",
						"Ｘ": "X",
						"Ẋ": "X",
						"Ẍ": "X",
						"Ⓨ": "Y",
						"Ｙ": "Y",
						"Ỳ": "Y",
						"Ý": "Y",
						"Ŷ": "Y",
						"Ỹ": "Y",
						"Ȳ": "Y",
						"Ẏ": "Y",
						"Ÿ": "Y",
						"Ỷ": "Y",
						"Ỵ": "Y",
						"Ƴ": "Y",
						"Ɏ": "Y",
						"Ỿ": "Y",
						"Ⓩ": "Z",
						"Ｚ": "Z",
						"Ź": "Z",
						"Ẑ": "Z",
						"Ż": "Z",
						"Ž": "Z",
						"Ẓ": "Z",
						"Ẕ": "Z",
						"Ƶ": "Z",
						"Ȥ": "Z",
						"Ɀ": "Z",
						"Ⱬ": "Z",
						"Ꝣ": "Z",
						"ⓐ": "a",
						"ａ": "a",
						"ẚ": "a",
						"à": "a",
						"á": "a",
						"â": "a",
						"ầ": "a",
						"ấ": "a",
						"ẫ": "a",
						"ẩ": "a",
						"ã": "a",
						"ā": "a",
						"ă": "a",
						"ằ": "a",
						"ắ": "a",
						"ẵ": "a",
						"ẳ": "a",
						"ȧ": "a",
						"ǡ": "a",
						"ä": "a",
						"ǟ": "a",
						"ả": "a",
						"å": "a",
						"ǻ": "a",
						"ǎ": "a",
						"ȁ": "a",
						"ȃ": "a",
						"ạ": "a",
						"ậ": "a",
						"ặ": "a",
						"ḁ": "a",
						"ą": "a",
						"ⱥ": "a",
						"ɐ": "a",
						"ꜳ": "aa",
						"æ": "ae",
						"ǽ": "ae",
						"ǣ": "ae",
						"ꜵ": "ao",
						"ꜷ": "au",
						"ꜹ": "av",
						"ꜻ": "av",
						"ꜽ": "ay",
						"ⓑ": "b",
						"ｂ": "b",
						"ḃ": "b",
						"ḅ": "b",
						"ḇ": "b",
						"ƀ": "b",
						"ƃ": "b",
						"ɓ": "b",
						"ⓒ": "c",
						"ｃ": "c",
						"ć": "c",
						"ĉ": "c",
						"ċ": "c",
						"č": "c",
						"ç": "c",
						"ḉ": "c",
						"ƈ": "c",
						"ȼ": "c",
						"ꜿ": "c",
						"ↄ": "c",
						"ⓓ": "d",
						"ｄ": "d",
						"ḋ": "d",
						"ď": "d",
						"ḍ": "d",
						"ḑ": "d",
						"ḓ": "d",
						"ḏ": "d",
						"đ": "d",
						"ƌ": "d",
						"ɖ": "d",
						"ɗ": "d",
						"ꝺ": "d",
						"ǳ": "dz",
						"ǆ": "dz",
						"ⓔ": "e",
						"ｅ": "e",
						"è": "e",
						"é": "e",
						"ê": "e",
						"ề": "e",
						"ế": "e",
						"ễ": "e",
						"ể": "e",
						"ẽ": "e",
						"ē": "e",
						"ḕ": "e",
						"ḗ": "e",
						"ĕ": "e",
						"ė": "e",
						"ë": "e",
						"ẻ": "e",
						"ě": "e",
						"ȅ": "e",
						"ȇ": "e",
						"ẹ": "e",
						"ệ": "e",
						"ȩ": "e",
						"ḝ": "e",
						"ę": "e",
						"ḙ": "e",
						"ḛ": "e",
						"ɇ": "e",
						"ɛ": "e",
						"ǝ": "e",
						"ⓕ": "f",
						"ｆ": "f",
						"ḟ": "f",
						"ƒ": "f",
						"ꝼ": "f",
						"ⓖ": "g",
						"ｇ": "g",
						"ǵ": "g",
						"ĝ": "g",
						"ḡ": "g",
						"ğ": "g",
						"ġ": "g",
						"ǧ": "g",
						"ģ": "g",
						"ǥ": "g",
						"ɠ": "g",
						"ꞡ": "g",
						"ᵹ": "g",
						"ꝿ": "g",
						"ⓗ": "h",
						"ｈ": "h",
						"ĥ": "h",
						"ḣ": "h",
						"ḧ": "h",
						"ȟ": "h",
						"ḥ": "h",
						"ḩ": "h",
						"ḫ": "h",
						"ẖ": "h",
						"ħ": "h",
						"ⱨ": "h",
						"ⱶ": "h",
						"ɥ": "h",
						"ƕ": "hv",
						"ⓘ": "i",
						"ｉ": "i",
						"ì": "i",
						"í": "i",
						"î": "i",
						"ĩ": "i",
						"ī": "i",
						"ĭ": "i",
						"ï": "i",
						"ḯ": "i",
						"ỉ": "i",
						"ǐ": "i",
						"ȉ": "i",
						"ȋ": "i",
						"ị": "i",
						"į": "i",
						"ḭ": "i",
						"ɨ": "i",
						"ı": "i",
						"ⓙ": "j",
						"ｊ": "j",
						"ĵ": "j",
						"ǰ": "j",
						"ɉ": "j",
						"ⓚ": "k",
						"ｋ": "k",
						"ḱ": "k",
						"ǩ": "k",
						"ḳ": "k",
						"ķ": "k",
						"ḵ": "k",
						"ƙ": "k",
						"ⱪ": "k",
						"ꝁ": "k",
						"ꝃ": "k",
						"ꝅ": "k",
						"ꞣ": "k",
						"ⓛ": "l",
						"ｌ": "l",
						"ŀ": "l",
						"ĺ": "l",
						"ľ": "l",
						"ḷ": "l",
						"ḹ": "l",
						"ļ": "l",
						"ḽ": "l",
						"ḻ": "l",
						"ſ": "l",
						"ł": "l",
						"ƚ": "l",
						"ɫ": "l",
						"ⱡ": "l",
						"ꝉ": "l",
						"ꞁ": "l",
						"ꝇ": "l",
						"ǉ": "lj",
						"ⓜ": "m",
						"ｍ": "m",
						"ḿ": "m",
						"ṁ": "m",
						"ṃ": "m",
						"ɱ": "m",
						"ɯ": "m",
						"ⓝ": "n",
						"ｎ": "n",
						"ǹ": "n",
						"ń": "n",
						"ñ": "n",
						"ṅ": "n",
						"ň": "n",
						"ṇ": "n",
						"ņ": "n",
						"ṋ": "n",
						"ṉ": "n",
						"ƞ": "n",
						"ɲ": "n",
						"ŉ": "n",
						"ꞑ": "n",
						"ꞥ": "n",
						"ǌ": "nj",
						"ⓞ": "o",
						"ｏ": "o",
						"ò": "o",
						"ó": "o",
						"ô": "o",
						"ồ": "o",
						"ố": "o",
						"ỗ": "o",
						"ổ": "o",
						"õ": "o",
						"ṍ": "o",
						"ȭ": "o",
						"ṏ": "o",
						"ō": "o",
						"ṑ": "o",
						"ṓ": "o",
						"ŏ": "o",
						"ȯ": "o",
						"ȱ": "o",
						"ö": "o",
						"ȫ": "o",
						"ỏ": "o",
						"ő": "o",
						"ǒ": "o",
						"ȍ": "o",
						"ȏ": "o",
						"ơ": "o",
						"ờ": "o",
						"ớ": "o",
						"ỡ": "o",
						"ở": "o",
						"ợ": "o",
						"ọ": "o",
						"ộ": "o",
						"ǫ": "o",
						"ǭ": "o",
						"ø": "o",
						"ǿ": "o",
						"ɔ": "o",
						"ꝋ": "o",
						"ꝍ": "o",
						"ɵ": "o",
						"ƣ": "oi",
						"ȣ": "ou",
						"ꝏ": "oo",
						"ⓟ": "p",
						"ｐ": "p",
						"ṕ": "p",
						"ṗ": "p",
						"ƥ": "p",
						"ᵽ": "p",
						"ꝑ": "p",
						"ꝓ": "p",
						"ꝕ": "p",
						"ⓠ": "q",
						"ｑ": "q",
						"ɋ": "q",
						"ꝗ": "q",
						"ꝙ": "q",
						"ⓡ": "r",
						"ｒ": "r",
						"ŕ": "r",
						"ṙ": "r",
						"ř": "r",
						"ȑ": "r",
						"ȓ": "r",
						"ṛ": "r",
						"ṝ": "r",
						"ŗ": "r",
						"ṟ": "r",
						"ɍ": "r",
						"ɽ": "r",
						"ꝛ": "r",
						"ꞧ": "r",
						"ꞃ": "r",
						"ⓢ": "s",
						"ｓ": "s",
						"ß": "s",
						"ś": "s",
						"ṥ": "s",
						"ŝ": "s",
						"ṡ": "s",
						"š": "s",
						"ṧ": "s",
						"ṣ": "s",
						"ṩ": "s",
						"ș": "s",
						"ş": "s",
						"ȿ": "s",
						"ꞩ": "s",
						"ꞅ": "s",
						"ẛ": "s",
						"ⓣ": "t",
						"ｔ": "t",
						"ṫ": "t",
						"ẗ": "t",
						"ť": "t",
						"ṭ": "t",
						"ț": "t",
						"ţ": "t",
						"ṱ": "t",
						"ṯ": "t",
						"ŧ": "t",
						"ƭ": "t",
						"ʈ": "t",
						"ⱦ": "t",
						"ꞇ": "t",
						"ꜩ": "tz",
						"ⓤ": "u",
						"ｕ": "u",
						"ù": "u",
						"ú": "u",
						"û": "u",
						"ũ": "u",
						"ṹ": "u",
						"ū": "u",
						"ṻ": "u",
						"ŭ": "u",
						"ü": "u",
						"ǜ": "u",
						"ǘ": "u",
						"ǖ": "u",
						"ǚ": "u",
						"ủ": "u",
						"ů": "u",
						"ű": "u",
						"ǔ": "u",
						"ȕ": "u",
						"ȗ": "u",
						"ư": "u",
						"ừ": "u",
						"ứ": "u",
						"ữ": "u",
						"ử": "u",
						"ự": "u",
						"ụ": "u",
						"ṳ": "u",
						"ų": "u",
						"ṷ": "u",
						"ṵ": "u",
						"ʉ": "u",
						"ⓥ": "v",
						"ｖ": "v",
						"ṽ": "v",
						"ṿ": "v",
						"ʋ": "v",
						"ꝟ": "v",
						"ʌ": "v",
						"ꝡ": "vy",
						"ⓦ": "w",
						"ｗ": "w",
						"ẁ": "w",
						"ẃ": "w",
						"ŵ": "w",
						"ẇ": "w",
						"ẅ": "w",
						"ẘ": "w",
						"ẉ": "w",
						"ⱳ": "w",
						"ⓧ": "x",
						"ｘ": "x",
						"ẋ": "x",
						"ẍ": "x",
						"ⓨ": "y",
						"ｙ": "y",
						"ỳ": "y",
						"ý": "y",
						"ŷ": "y",
						"ỹ": "y",
						"ȳ": "y",
						"ẏ": "y",
						"ÿ": "y",
						"ỷ": "y",
						"ẙ": "y",
						"ỵ": "y",
						"ƴ": "y",
						"ɏ": "y",
						"ỿ": "y",
						"ⓩ": "z",
						"ｚ": "z",
						"ź": "z",
						"ẑ": "z",
						"ż": "z",
						"ž": "z",
						"ẓ": "z",
						"ẕ": "z",
						"ƶ": "z",
						"ȥ": "z",
						"ɀ": "z",
						"ⱬ": "z",
						"ꝣ": "z",
						"Ά": "Α",
						"Έ": "Ε",
						"Ή": "Η",
						"Ί": "Ι",
						"Ϊ": "Ι",
						"Ό": "Ο",
						"Ύ": "Υ",
						"Ϋ": "Υ",
						"Ώ": "Ω",
						"ά": "α",
						"έ": "ε",
						"ή": "η",
						"ί": "ι",
						"ϊ": "ι",
						"ΐ": "ι",
						"ό": "ο",
						"ύ": "υ",
						"ϋ": "υ",
						"ΰ": "υ",
						"ω": "ω",
						"ς": "σ"
					}
				}), e.define("select2/data/base", ["../utils"], function(t) {
					function e(t, i) {
						e.__super__.constructor.call(this)
					}
					return t.Extend(e, t.Observable), e.prototype.current = function(t) {
						throw new Error("The `current` method must be defined in child classes.")
					}, e.prototype.query = function(t, e) {
						throw new Error("The `query` method must be defined in child classes.")
					}, e.prototype.bind = function(t, e) {}, e.prototype.destroy = function() {}, e.prototype.generateResultId = function(e, i) {
						var s = e.id + "-result-";
						return (s += t.generateChars(4)) + (null != i.id ? "-" + i.id.toString() : "-" + t.generateChars(4))
					}, e
				}), e.define("select2/data/select", ["./base", "../utils", "jquery"], function(t, e, i) {
					function s(t, e) {
						this.$element = t, this.options = e, s.__super__.constructor.call(this)
					}
					return e.Extend(s, t), s.prototype.current = function(t) {
						var e = [],
							s = this;
						this.$element.find(":selected").each(function() {
							var t = i(this),
								n = s.item(t);
							e.push(n)
						}), t(e)
					}, s.prototype.select = function(t) {
						var e = this;
						if (t.selected = !0, i(t.element).is("option")) return t.element.selected = !0, void this.$element.trigger("change");
						if (this.$element.prop("multiple")) this.current(function(s) {
							var n = [];
							(t = [t]).push.apply(t, s);
							for (var a = 0; a < t.length; a++) {
								var o = t[a].id; - 1 === i.inArray(o, n) && n.push(o)
							}
							e.$element.val(n), e.$element.trigger("change")
						});
						else {
							var s = t.id;
							this.$element.val(s), this.$element.trigger("change")
						}
					}, s.prototype.unselect = function(t) {
						var e = this;
						if (this.$element.prop("multiple")) return t.selected = !1, i(t.element).is("option") ? (t.element.selected = !1, void this.$element.trigger("change")) : void this.current(function(s) {
							for (var n = [], a = 0; a < s.length; a++) {
								var o = s[a].id;
								o !== t.id && -1 === i.inArray(o, n) && n.push(o)
							}
							e.$element.val(n), e.$element.trigger("change")
						})
					}, s.prototype.bind = function(t, e) {
						var i = this;
						this.container = t, t.on("select", function(t) {
							i.select(t.data)
						}), t.on("unselect", function(t) {
							i.unselect(t.data)
						})
					}, s.prototype.destroy = function() {
						this.$element.find("*").each(function() {
							i.removeData(this, "data")
						})
					}, s.prototype.query = function(t, e) {
						var s = [],
							n = this;
						this.$element.children().each(function() {
							var e = i(this);
							if (e.is("option") || e.is("optgroup")) {
								var a = n.item(e),
									o = n.matches(t, a);
								null !== o && s.push(o)
							}
						}), e({
							results: s
						})
					}, s.prototype.addOptions = function(t) {
						e.appendMany(this.$element, t)
					}, s.prototype.option = function(t) {
						var e;
						t.children ? (e = document.createElement("optgroup")).label = t.text : void 0 !== (e = document.createElement("option")).textContent ? e.textContent = t.text : e.innerText = t.text, t.id && (e.value = t.id), t.disabled && (e.disabled = !0), t.selected && (e.selected = !0), t.title && (e.title = t.title);
						var s = i(e),
							n = this._normalizeItem(t);
						return n.element = e, i.data(e, "data", n), s
					}, s.prototype.item = function(t) {
						var e = {};
						if (null != (e = i.data(t[0], "data"))) return e;
						if (t.is("option")) e = {
							id: t.val(),
							text: t.text(),
							disabled: t.prop("disabled"),
							selected: t.prop("selected"),
							title: t.prop("title")
						};
						else if (t.is("optgroup")) {
							e = {
								text: t.prop("label"),
								children: [],
								title: t.prop("title")
							};
							for (var s = t.children("option"), n = [], a = 0; a < s.length; a++) {
								var o = i(s[a]),
									r = this.item(o);
								n.push(r)
							}
							e.children = n
						}
						return (e = this._normalizeItem(e)).element = t[0], i.data(t[0], "data", e), e
					}, s.prototype._normalizeItem = function(t) {
						i.isPlainObject(t) || (t = {
							id: t,
							text: t
						});
						return null != (t = i.extend({}, {
							text: ""
						}, t)).id && (t.id = t.id.toString()), null != t.text && (t.text = t.text.toString()), null == t._resultId && t.id && null != this.container && (t._resultId = this.generateResultId(this.container, t)), i.extend({}, {
							selected: !1,
							disabled: !1
						}, t)
					}, s.prototype.matches = function(t, e) {
						return this.options.get("matcher")(t, e)
					}, s
				}), e.define("select2/data/array", ["./select", "../utils", "jquery"], function(t, e, i) {
					function s(t, e) {
						var i = e.get("data") || [];
						s.__super__.constructor.call(this, t, e), this.addOptions(this.convertToOptions(i))
					}
					return e.Extend(s, t), s.prototype.select = function(t) {
						var e = this.$element.find("option").filter(function(e, i) {
							return i.value == t.id.toString()
						});
						0 === e.length && (e = this.option(t), this.addOptions(e)), s.__super__.select.call(this, t)
					}, s.prototype.convertToOptions = function(t) {
						function s(t) {
							return function() {
								return i(this).val() == t.id
							}
						}
						for (var n = this, a = this.$element.find("option"), o = a.map(function() {
								return n.item(i(this)).id
							}).get(), r = [], l = 0; l < t.length; l++) {
							var d = this._normalizeItem(t[l]);
							if (i.inArray(d.id, o) >= 0) {
								var c = a.filter(s(d)),
									h = this.item(c),
									u = i.extend(!0, {}, d, h),
									p = this.option(u);
								c.replaceWith(p)
							} else {
								var f = this.option(d);
								if (d.children) {
									var m = this.convertToOptions(d.children);
									e.appendMany(f, m)
								}
								r.push(f)
							}
						}
						return r
					}, s
				}), e.define("select2/data/ajax", ["./array", "../utils", "jquery"], function(t, e, i) {
					function s(t, e) {
						this.ajaxOptions = this._applyDefaults(e.get("ajax")), null != this.ajaxOptions.processResults && (this.processResults = this.ajaxOptions.processResults), s.__super__.constructor.call(this, t, e)
					}
					return e.Extend(s, t), s.prototype._applyDefaults = function(t) {
						var e = {
							data: function(t) {
								return i.extend({}, t, {
									q: t.term
								})
							},
							transport: function(t, e, s) {
								var n = i.ajax(t);
								return n.then(e), n.fail(s), n
							}
						};
						return i.extend({}, e, t, !0)
					}, s.prototype.processResults = function(t) {
						return t
					}, s.prototype.query = function(t, e) {
						function s() {
							var s = a.transport(a, function(s) {
								var a = n.processResults(s, t);
								n.options.get("debug") && window.console && console.error && (a && a.results && i.isArray(a.results) || console.error("Select2: The AJAX results did not return an array in the `results` key of the response.")), e(a)
							}, function() {
								s.status && "0" === s.status || n.trigger("results:message", {
									message: "errorLoading"
								})
							});
							n._request = s
						}
						var n = this;
						null != this._request && (i.isFunction(this._request.abort) && this._request.abort(), this._request = null);
						var a = i.extend({
							type: "GET"
						}, this.ajaxOptions);
						"function" == typeof a.url && (a.url = a.url.call(this.$element, t)), "function" == typeof a.data && (a.data = a.data.call(this.$element, t)), this.ajaxOptions.delay && null != t.term ? (this._queryTimeout && window.clearTimeout(this._queryTimeout), this._queryTimeout = window.setTimeout(s, this.ajaxOptions.delay)) : s()
					}, s
				}), e.define("select2/data/tags", ["jquery"], function(t) {
					function e(e, i, s) {
						var n = s.get("tags"),
							a = s.get("createTag");
						void 0 !== a && (this.createTag = a);
						var o = s.get("insertTag");
						if (void 0 !== o && (this.insertTag = o), e.call(this, i, s), t.isArray(n))
							for (var r = 0; r < n.length; r++) {
								var l = n[r],
									d = this._normalizeItem(l),
									c = this.option(d);
								this.$element.append(c)
							}
					}
					return e.prototype.query = function(t, e, i) {
						var s = this;
						return this._removeOldTags(), null == e.term || null != e.page ? void t.call(this, e, i) : void t.call(this, e, function t(n, a) {
							for (var o = n.results, r = 0; r < o.length; r++) {
								var l = o[r],
									d = null != l.children && !t({
										results: l.children
									}, !0);
								if (l.text === e.term || d) return !a && (n.data = o, void i(n))
							}
							if (a) return !0;
							var c = s.createTag(e);
							if (null != c) {
								var h = s.option(c);
								h.attr("data-select2-tag", !0), s.addOptions([h]), s.insertTag(o, c)
							}
							n.results = o, i(n)
						})
					}, e.prototype.createTag = function(e, i) {
						var s = t.trim(i.term);
						return "" === s ? null : {
							id: s,
							text: s
						}
					}, e.prototype.insertTag = function(t, e, i) {
						e.unshift(i)
					}, e.prototype._removeOldTags = function(e) {
						(this._lastTag, this.$element.find("option[data-select2-tag]")).each(function() {
							this.selected || t(this).remove()
						})
					}, e
				}), e.define("select2/data/tokenizer", ["jquery"], function(t) {
					function e(t, e, i) {
						var s = i.get("tokenizer");
						void 0 !== s && (this.tokenizer = s), t.call(this, e, i)
					}
					return e.prototype.bind = function(t, e, i) {
						t.call(this, e, i), this.$search = e.dropdown.$search || e.selection.$search || i.find(".select2-search__field")
					}, e.prototype.query = function(e, i, s) {
						var n = this;
						i.term = i.term || "";
						var a = this.tokenizer(i, this.options, function(e) {
							var i = n._normalizeItem(e);
							if (!n.$element.find("option").filter(function() {
									return t(this).val() === i.id
								}).length) {
								var s = n.option(i);
								s.attr("data-select2-tag", !0), n._removeOldTags(), n.addOptions([s])
							}! function(t) {
								n.trigger("select", {
									data: t
								})
							}(i)
						});
						a.term !== i.term && (this.$search.length && (this.$search.val(a.term), this.$search.focus()), i.term = a.term), e.call(this, i, s)
					}, e.prototype.tokenizer = function(e, i, s, n) {
						for (var a = s.get("tokenSeparators") || [], o = i.term, r = 0, l = this.createTag || function(t) {
								return {
									id: t.term,
									text: t.term
								}
							}; r < o.length;) {
							var d = o[r];
							if (-1 !== t.inArray(d, a)) {
								var c = o.substr(0, r),
									h = l(t.extend({}, i, {
										term: c
									}));
								null != h ? (n(h), o = o.substr(r + 1) || "", r = 0) : r++
							} else r++
						}
						return {
							term: o
						}
					}, e
				}), e.define("select2/data/minimumInputLength", [], function() {
					function t(t, e, i) {
						this.minimumInputLength = i.get("minimumInputLength"), t.call(this, e, i)
					}
					return t.prototype.query = function(t, e, i) {
						return e.term = e.term || "", e.term.length < this.minimumInputLength ? void this.trigger("results:message", {
							message: "inputTooShort",
							args: {
								minimum: this.minimumInputLength,
								input: e.term,
								params: e
							}
						}) : void t.call(this, e, i)
					}, t
				}), e.define("select2/data/maximumInputLength", [], function() {
					function t(t, e, i) {
						this.maximumInputLength = i.get("maximumInputLength"), t.call(this, e, i)
					}
					return t.prototype.query = function(t, e, i) {
						return e.term = e.term || "", this.maximumInputLength > 0 && e.term.length > this.maximumInputLength ? void this.trigger("results:message", {
							message: "inputTooLong",
							args: {
								maximum: this.maximumInputLength,
								input: e.term,
								params: e
							}
						}) : void t.call(this, e, i)
					}, t
				}), e.define("select2/data/maximumSelectionLength", [], function() {
					function t(t, e, i) {
						this.maximumSelectionLength = i.get("maximumSelectionLength"), t.call(this, e, i)
					}
					return t.prototype.query = function(t, e, i) {
						var s = this;
						this.current(function(n) {
							var a = null != n ? n.length : 0;
							return s.maximumSelectionLength > 0 && a >= s.maximumSelectionLength ? void s.trigger("results:message", {
								message: "maximumSelected",
								args: {
									maximum: s.maximumSelectionLength
								}
							}) : void t.call(s, e, i)
						})
					}, t
				}), e.define("select2/dropdown", ["jquery", "./utils"], function(t, e) {
					function i(t, e) {
						this.$element = t, this.options = e, i.__super__.constructor.call(this)
					}
					return e.Extend(i, e.Observable), i.prototype.render = function() {
						var e = t('<span class="select2-dropdown"><span class="select2-results"></span></span>');
						return e.attr("dir", this.options.get("dir")), this.$dropdown = e, e
					}, i.prototype.bind = function() {}, i.prototype.position = function(t, e) {}, i.prototype.destroy = function() {
						this.$dropdown.remove()
					}, i
				}), e.define("select2/dropdown/search", ["jquery", "../utils"], function(t, e) {
					function i() {}
					return i.prototype.render = function(e) {
						var i = e.call(this),
							s = t('<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" role="textbox" /></span>');
						return this.$searchContainer = s, this.$search = s.find("input"), i.prepend(s), i
					}, i.prototype.bind = function(e, i, s) {
						var n = this;
						e.call(this, i, s), this.$search.on("keydown", function(t) {
							n.trigger("keypress", t), n._keyUpPrevented = t.isDefaultPrevented()
						}), this.$search.on("input", function(e) {
							t(this).off("keyup")
						}), this.$search.on("keyup input", function(t) {
							n.handleSearch(t)
						}), i.on("open", function() {
							n.$search.attr("tabindex", 0), n.$search.focus(), window.setTimeout(function() {
								n.$search.focus()
							}, 0)
						}), i.on("close", function() {
							n.$search.attr("tabindex", -1), n.$search.val("")
						}), i.on("focus", function() {
							i.isOpen() && n.$search.focus()
						}), i.on("results:all", function(t) {
							null != t.query.term && "" !== t.query.term || (n.showSearch(t) ? n.$searchContainer.removeClass("select2-search--hide") : n.$searchContainer.addClass("select2-search--hide"))
						})
					}, i.prototype.handleSearch = function(t) {
						if (!this._keyUpPrevented) {
							var e = this.$search.val();
							this.trigger("query", {
								term: e
							})
						}
						this._keyUpPrevented = !1
					}, i.prototype.showSearch = function(t, e) {
						return !0
					}, i
				}), e.define("select2/dropdown/hidePlaceholder", [], function() {
					function t(t, e, i, s) {
						this.placeholder = this.normalizePlaceholder(i.get("placeholder")), t.call(this, e, i, s)
					}
					return t.prototype.append = function(t, e) {
						e.results = this.removePlaceholder(e.results), t.call(this, e)
					}, t.prototype.normalizePlaceholder = function(t, e) {
						return "string" == typeof e && (e = {
							id: "",
							text: e
						}), e
					}, t.prototype.removePlaceholder = function(t, e) {
						for (var i = e.slice(0), s = e.length - 1; s >= 0; s--) {
							var n = e[s];
							this.placeholder.id === n.id && i.splice(s, 1)
						}
						return i
					}, t
				}), e.define("select2/dropdown/infiniteScroll", ["jquery"], function(t) {
					function e(t, e, i, s) {
						this.lastParams = {}, t.call(this, e, i, s), this.$loadingMore = this.createLoadingMore(), this.loading = !1
					}
					return e.prototype.append = function(t, e) {
						this.$loadingMore.remove(), this.loading = !1, t.call(this, e), this.showLoadingMore(e) && this.$results.append(this.$loadingMore)
					}, e.prototype.bind = function(e, i, s) {
						var n = this;
						e.call(this, i, s), i.on("query", function(t) {
							n.lastParams = t, n.loading = !0
						}), i.on("query:append", function(t) {
							n.lastParams = t, n.loading = !0
						}), this.$results.on("scroll", function() {
							var e = t.contains(document.documentElement, n.$loadingMore[0]);
							!n.loading && e && (n.$results.offset().top + n.$results.outerHeight(!1) + 50 >= n.$loadingMore.offset().top + n.$loadingMore.outerHeight(!1) && n.loadMore())
						})
					}, e.prototype.loadMore = function() {
						this.loading = !0;
						var e = t.extend({}, {
							page: 1
						}, this.lastParams);
						e.page++, this.trigger("query:append", e)
					}, e.prototype.showLoadingMore = function(t, e) {
						return e.pagination && e.pagination.more
					}, e.prototype.createLoadingMore = function() {
						var e = t('<li class="select2-results__option select2-results__option--load-more"role="treeitem" aria-disabled="true"></li>'),
							i = this.options.get("translations").get("loadingMore");
						return e.html(i(this.lastParams)), e
					}, e
				}), e.define("select2/dropdown/attachBody", ["jquery", "../utils"], function(t, e) {
					function i(e, i, s) {
						this.$dropdownParent = s.get("dropdownParent") || t(document.body), e.call(this, i, s)
					}
					return i.prototype.bind = function(t, e, i) {
						var s = this,
							n = !1;
						t.call(this, e, i), e.on("open", function() {
							s._showDropdown(), s._attachPositioningHandler(e), n || (n = !0, e.on("results:all", function() {
								s._positionDropdown(), s._resizeDropdown()
							}), e.on("results:append", function() {
								s._positionDropdown(), s._resizeDropdown()
							}))
						}), e.on("close", function() {
							s._hideDropdown(), s._detachPositioningHandler(e)
						}), this.$dropdownContainer.on("mousedown", function(t) {
							t.stopPropagation()
						})
					}, i.prototype.destroy = function(t) {
						t.call(this), this.$dropdownContainer.remove()
					}, i.prototype.position = function(t, e, i) {
						e.attr("class", i.attr("class")), e.removeClass("select2"), e.addClass("select2-container--open"), e.css({
							position: "absolute",
							top: -999999
						}), this.$container = i
					}, i.prototype.render = function(e) {
						var i = t("<span></span>"),
							s = e.call(this);
						return i.append(s), this.$dropdownContainer = i, i
					}, i.prototype._hideDropdown = function(t) {
						this.$dropdownContainer.detach()
					}, i.prototype._attachPositioningHandler = function(i, s) {
						var n = this,
							a = "scroll.select2." + s.id,
							o = "resize.select2." + s.id,
							r = "orientationchange.select2." + s.id,
							l = this.$container.parents().filter(e.hasScroll);
						l.each(function() {
							t(this).data("select2-scroll-position", {
								x: t(this).scrollLeft(),
								y: t(this).scrollTop()
							})
						}), l.on(a, function(e) {
							var i = t(this).data("select2-scroll-position");
							t(this).scrollTop(i.y)
						}), t(window).on(a + " " + o + " " + r, function(t) {
							n._positionDropdown(), n._resizeDropdown()
						})
					}, i.prototype._detachPositioningHandler = function(i, s) {
						var n = "scroll.select2." + s.id,
							a = "resize.select2." + s.id,
							o = "orientationchange.select2." + s.id;
						this.$container.parents().filter(e.hasScroll).off(n), t(window).off(n + " " + a + " " + o)
					}, i.prototype._positionDropdown = function() {
						var e = t(window),
							i = this.$dropdown.hasClass("select2-dropdown--above"),
							s = this.$dropdown.hasClass("select2-dropdown--below"),
							n = null,
							a = this.$container.offset();
						a.bottom = a.top + this.$container.outerHeight(!1);
						var o = {
							height: this.$container.outerHeight(!1)
						};
						o.top = a.top, o.bottom = a.top + o.height;
						var r = this.$dropdown.outerHeight(!1),
							l = (e.scrollTop(), e.scrollTop(), e.height(), {
								left: a.left,
								top: o.bottom
							}),
							d = this.$dropdownParent;
						"static" === d.css("position") && (d = d.offsetParent());
						var c = d.offset();
						l.top -= c.top, l.left -= c.left, i || s || (n = "below"), i && (n = "below"), ("above" == n || i && "below" !== n) && (l.top = o.top - c.top - r), null != n && (this.$dropdown.removeClass("select2-dropdown--below select2-dropdown--above").addClass("select2-dropdown--" + n), this.$container.removeClass("select2-container--below select2-container--above").addClass("select2-container--" + n)), this.$dropdownContainer.css(l)
					}, i.prototype._resizeDropdown = function() {
						var t = {
							width: this.$container.outerWidth(!1) + "px"
						};
						this.options.get("dropdownAutoWidth") && (t.minWidth = t.width, t.position = "relative", t.width = "auto"), this.$dropdown.css(t)
					}, i.prototype._showDropdown = function(t) {
						this.$dropdownContainer.appendTo(this.$dropdownParent), this._positionDropdown(), this._resizeDropdown()
					}, i
				}), e.define("select2/dropdown/minimumResultsForSearch", [], function() {
					function t(t, e, i, s) {
						this.minimumResultsForSearch = i.get("minimumResultsForSearch"), this.minimumResultsForSearch < 0 && (this.minimumResultsForSearch = 1 / 0), t.call(this, e, i, s)
					}
					return t.prototype.showSearch = function(t, e) {
						return !(function t(e) {
							for (var i = 0, s = 0; s < e.length; s++) {
								var n = e[s];
								n.children ? i += t(n.children) : i++
							}
							return i
						}(e.data.results) < this.minimumResultsForSearch) && t.call(this, e)
					}, t
				}), e.define("select2/dropdown/selectOnClose", [], function() {
					function t() {}
					return t.prototype.bind = function(t, e, i) {
						var s = this;
						t.call(this, e, i), e.on("close", function(t) {
							s._handleSelectOnClose(t)
						})
					}, t.prototype._handleSelectOnClose = function(t, e) {
						if (e && null != e.originalSelect2Event) {
							var i = e.originalSelect2Event;
							if ("select" === i._type || "unselect" === i._type) return
						}
						var s = this.getHighlightedResults();
						if (!(s.length < 1)) {
							var n = s.data("data");
							null != n.element && n.element.selected || null == n.element && n.selected || this.trigger("select", {
								data: n
							})
						}
					}, t
				}), e.define("select2/dropdown/closeOnSelect", [], function() {
					function t() {}
					return t.prototype.bind = function(t, e, i) {
						var s = this;
						t.call(this, e, i), e.on("select", function(t) {
							s._selectTriggered(t)
						}), e.on("unselect", function(t) {
							s._selectTriggered(t)
						})
					}, t.prototype._selectTriggered = function(t, e) {
						var i = e.originalEvent;
						i && i.ctrlKey || this.trigger("close", {
							originalEvent: i,
							originalSelect2Event: e
						})
					}, t
				}), e.define("select2/i18n/en", [], function() {
					return {
						errorLoading: function() {
							return "The results could not be loaded."
						},
						inputTooLong: function(t) {
							var e = t.input.length - t.maximum,
								i = "Please delete " + e + " character";
							return 1 != e && (i += "s"), i
						},
						inputTooShort: function(t) {
							return "Please enter " + (t.minimum - t.input.length) + " or more characters"
						},
						loadingMore: function() {
							return "Loading more results…"
						},
						maximumSelected: function(t) {
							var e = "You can only select " + t.maximum + " item";
							return 1 != t.maximum && (e += "s"), e
						},
						noResults: function() {
							return "No results found"
						},
						searching: function() {
							return "Searching…"
						}
					}
				}), e.define("select2/defaults", ["jquery", "require", "./results", "./selection/single", "./selection/multiple", "./selection/placeholder", "./selection/allowClear", "./selection/search", "./selection/eventRelay", "./utils", "./translation", "./diacritics", "./data/select", "./data/array", "./data/ajax", "./data/tags", "./data/tokenizer", "./data/minimumInputLength", "./data/maximumInputLength", "./data/maximumSelectionLength", "./dropdown", "./dropdown/search", "./dropdown/hidePlaceholder", "./dropdown/infiniteScroll", "./dropdown/attachBody", "./dropdown/minimumResultsForSearch", "./dropdown/selectOnClose", "./dropdown/closeOnSelect", "./i18n/en"], function(t, e, i, s, n, a, o, r, l, d, c, h, u, p, f, m, g, v, y, b, w, S, x, T, C, _, E, P, k) {
					function $() {
						this.reset()
					}
					return $.prototype.apply = function(h) {
						if (null == (h = t.extend(!0, {}, this.defaults, h)).dataAdapter) {
							if (null != h.ajax ? h.dataAdapter = f : null != h.data ? h.dataAdapter = p : h.dataAdapter = u, h.minimumInputLength > 0 && (h.dataAdapter = d.Decorate(h.dataAdapter, v)), h.maximumInputLength > 0 && (h.dataAdapter = d.Decorate(h.dataAdapter, y)), h.maximumSelectionLength > 0 && (h.dataAdapter = d.Decorate(h.dataAdapter, b)), h.tags && (h.dataAdapter = d.Decorate(h.dataAdapter, m)), (null != h.tokenSeparators || null != h.tokenizer) && (h.dataAdapter = d.Decorate(h.dataAdapter, g)), null != h.query) {
								var k = e(h.amdBase + "compat/query");
								h.dataAdapter = d.Decorate(h.dataAdapter, k)
							}
							if (null != h.initSelection) {
								var $ = e(h.amdBase + "compat/initSelection");
								h.dataAdapter = d.Decorate(h.dataAdapter, $)
							}
						}
						if (null == h.resultsAdapter && (h.resultsAdapter = i, null != h.ajax && (h.resultsAdapter = d.Decorate(h.resultsAdapter, T)), null != h.placeholder && (h.resultsAdapter = d.Decorate(h.resultsAdapter, x)), h.selectOnClose && (h.resultsAdapter = d.Decorate(h.resultsAdapter, E))), null == h.dropdownAdapter) {
							if (h.multiple) h.dropdownAdapter = w;
							else {
								var M = d.Decorate(w, S);
								h.dropdownAdapter = M
							}
							if (0 !== h.minimumResultsForSearch && (h.dropdownAdapter = d.Decorate(h.dropdownAdapter, _)), h.closeOnSelect && (h.dropdownAdapter = d.Decorate(h.dropdownAdapter, P)), null != h.dropdownCssClass || null != h.dropdownCss || null != h.adaptDropdownCssClass) {
								var D = e(h.amdBase + "compat/dropdownCss");
								h.dropdownAdapter = d.Decorate(h.dropdownAdapter, D)
							}
							h.dropdownAdapter = d.Decorate(h.dropdownAdapter, C)
						}
						if (null == h.selectionAdapter) {
							if (h.multiple ? h.selectionAdapter = n : h.selectionAdapter = s, null != h.placeholder && (h.selectionAdapter = d.Decorate(h.selectionAdapter, a)), h.allowClear && (h.selectionAdapter = d.Decorate(h.selectionAdapter, o)), h.multiple && (h.selectionAdapter = d.Decorate(h.selectionAdapter, r)), null != h.containerCssClass || null != h.containerCss || null != h.adaptContainerCssClass) {
								var O = e(h.amdBase + "compat/containerCss");
								h.selectionAdapter = d.Decorate(h.selectionAdapter, O)
							}
							h.selectionAdapter = d.Decorate(h.selectionAdapter, l)
						}
						if ("string" == typeof h.language)
							if (h.language.indexOf("-") > 0) {
								var z = h.language.split("-")[0];
								h.language = [h.language, z]
							} else h.language = [h.language];
						if (t.isArray(h.language)) {
							var A = new c;
							h.language.push("en");
							for (var I = h.language, L = 0; L < I.length; L++) {
								var N = I[L],
									Y = {};
								try {
									Y = c.loadPath(N)
								} catch (t) {
									try {
										N = this.defaults.amdLanguageBase + N, Y = c.loadPath(N)
									} catch (t) {
										h.debug && window.console && console.warn && console.warn('Select2: The language file for "' + N + '" could not be automatically loaded. A fallback will be used instead.');
										continue
									}
								}
								A.extend(Y)
							}
							h.translations = A
						} else {
							var R = c.loadPath(this.defaults.amdLanguageBase + "en"),
								j = new c(h.language);
							j.extend(R), h.translations = j
						}
						return h
					}, $.prototype.reset = function() {
						function e(t) {
							return t.replace(/[^\u0000-\u007E]/g, function(t) {
								return h[t] || t
							})
						}
						this.defaults = {
							amdBase: "./",
							amdLanguageBase: "./i18n/",
							closeOnSelect: !0,
							debug: !1,
							dropdownAutoWidth: !1,
							escapeMarkup: d.escapeMarkup,
							language: k,
							matcher: function i(s, n) {
								if ("" === t.trim(s.term)) return n;
								if (n.children && n.children.length > 0) {
									for (var a = t.extend(!0, {}, n), o = n.children.length - 1; o >= 0; o--) null == i(s, n.children[o]) && a.children.splice(o, 1);
									return a.children.length > 0 ? a : i(s, a)
								}
								var r = e(n.text).toUpperCase(),
									l = e(s.term).toUpperCase();
								return r.indexOf(l) > -1 ? n : null
							},
							minimumInputLength: 0,
							maximumInputLength: 0,
							maximumSelectionLength: 0,
							minimumResultsForSearch: 0,
							selectOnClose: !1,
							sorter: function(t) {
								return t
							},
							templateResult: function(t) {
								return t.text
							},
							templateSelection: function(t) {
								return t.text
							},
							theme: "default",
							width: "resolve"
						}
					}, $.prototype.set = function(e, i) {
						var s = {};
						s[t.camelCase(e)] = i;
						var n = d._convertData(s);
						t.extend(this.defaults, n)
					}, new $
				}), e.define("select2/options", ["require", "jquery", "./defaults", "./utils"], function(t, e, i, s) {
					function n(e, n) {
						if (this.options = e, null != n && this.fromElement(n), this.options = i.apply(this.options), n && n.is("input")) {
							var a = t(this.get("amdBase") + "compat/inputData");
							this.options.dataAdapter = s.Decorate(this.options.dataAdapter, a)
						}
					}
					return n.prototype.fromElement = function(t) {
						var i = ["select2"];
						null == this.options.multiple && (this.options.multiple = t.prop("multiple")), null == this.options.disabled && (this.options.disabled = t.prop("disabled")), null == this.options.language && (t.prop("lang") ? this.options.language = t.prop("lang").toLowerCase() : t.closest("[lang]").prop("lang") && (this.options.language = t.closest("[lang]").prop("lang"))), null == this.options.dir && (t.prop("dir") ? this.options.dir = t.prop("dir") : t.closest("[dir]").prop("dir") ? this.options.dir = t.closest("[dir]").prop("dir") : this.options.dir = "ltr"), t.prop("disabled", this.options.disabled), t.prop("multiple", this.options.multiple), t.data("select2Tags") && (this.options.debug && window.console && console.warn && console.warn('Select2: The `data-select2-tags` attribute has been changed to use the `data-data` and `data-tags="true"` attributes and will be removed in future versions of Select2.'), t.data("data", t.data("select2Tags")), t.data("tags", !0)), t.data("ajaxUrl") && (this.options.debug && window.console && console.warn && console.warn("Select2: The `data-ajax-url` attribute has been changed to `data-ajax--url` and support for the old attribute will be removed in future versions of Select2."), t.attr("ajax--url", t.data("ajaxUrl")), t.data("ajax--url", t.data("ajaxUrl")));
						var n;
						n = e.fn.jquery && "1." == e.fn.jquery.substr(0, 2) && t[0].dataset ? e.extend(!0, {}, t[0].dataset, t.data()) : t.data();
						var a = e.extend(!0, {}, n);
						for (var o in a = s._convertData(a)) e.inArray(o, i) > -1 || (e.isPlainObject(this.options[o]) ? e.extend(this.options[o], a[o]) : this.options[o] = a[o]);
						return this
					}, n.prototype.get = function(t) {
						return this.options[t]
					}, n.prototype.set = function(t, e) {
						this.options[t] = e
					}, n
				}), e.define("select2/core", ["jquery", "./options", "./utils", "./keys"], function(t, e, i, s) {
					var n = function(t, i) {
						null != t.data("select2") && t.data("select2").destroy(), this.$element = t, this.id = this._generateId(t), i = i || {}, this.options = new e(i, t), n.__super__.constructor.call(this);
						var s = t.attr("tabindex") || 0;
						t.data("old-tabindex", s), t.attr("tabindex", "-1");
						var a = this.options.get("dataAdapter");
						this.dataAdapter = new a(t, this.options);
						var o = this.render();
						this._placeContainer(o);
						var r = this.options.get("selectionAdapter");
						this.selection = new r(t, this.options), this.$selection = this.selection.render(), this.selection.position(this.$selection, o);
						var l = this.options.get("dropdownAdapter");
						this.dropdown = new l(t, this.options), this.$dropdown = this.dropdown.render(), this.dropdown.position(this.$dropdown, o);
						var d = this.options.get("resultsAdapter");
						this.results = new d(t, this.options, this.dataAdapter), this.$results = this.results.render(), this.results.position(this.$results, this.$dropdown);
						var c = this;
						this._bindAdapters(), this._registerDomEvents(), this._registerDataEvents(), this._registerSelectionEvents(), this._registerDropdownEvents(), this._registerResultsEvents(), this._registerEvents(), this.dataAdapter.current(function(t) {
							c.trigger("selection:update", {
								data: t
							})
						}), t.addClass("select2-hidden-accessible"), t.attr("aria-hidden", "true"), this._syncAttributes(), t.data("select2", this)
					};
					return i.Extend(n, i.Observable), n.prototype._generateId = function(t) {
						return "select2-" + (null != t.attr("id") ? t.attr("id") : null != t.attr("name") ? t.attr("name") + "-" + i.generateChars(2) : i.generateChars(4)).replace(/(:|\.|\[|\]|,)/g, "")
					}, n.prototype._placeContainer = function(t) {
						t.insertAfter(this.$element);
						var e = this._resolveWidth(this.$element, this.options.get("width"));
						null != e && t.css("width", e), "auto" != e && t.css("width", "+=30")
					}, n.prototype._resolveWidth = function(t, e) {
						var i = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
						if ("resolve" == e) {
							var s = this._resolveWidth(t, "style");
							return null != s ? s : this._resolveWidth(t, "element")
						}
						if ("element" == e) {
							var n = t.outerWidth(!1);
							return 0 >= n ? "auto" : n + "px"
						}
						if ("style" == e) {
							var a = t.attr("style");
							if ("string" != typeof a) return null;
							for (var o = a.split(";"), r = 0, l = o.length; l > r; r += 1) {
								var d = o[r].replace(/\s/g, "").match(i);
								if (null !== d && d.length >= 1) return d[1]
							}
							return null
						}
						return e
					}, n.prototype._bindAdapters = function() {
						this.dataAdapter.bind(this, this.$container), this.selection.bind(this, this.$container), this.dropdown.bind(this, this.$container), this.results.bind(this, this.$container)
					}, n.prototype._registerDomEvents = function() {
						var e = this;
						this.$element.on("change.select2", function() {
							e.dataAdapter.current(function(t) {
								e.trigger("selection:update", {
									data: t
								})
							})
						}), this.$element.on("focus.select2", function(t) {
							e.trigger("focus", t)
						}), this._syncA = i.bind(this._syncAttributes, this), this._syncS = i.bind(this._syncSubtree, this), this.$element[0].attachEvent && this.$element[0].attachEvent("onpropertychange", this._syncA);
						var s = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
						null != s ? (this._observer = new s(function(i) {
							t.each(i, e._syncA), t.each(i, e._syncS)
						}), this._observer.observe(this.$element[0], {
							attributes: !0,
							childList: !0,
							subtree: !1
						})) : this.$element[0].addEventListener && (this.$element[0].addEventListener("DOMAttrModified", e._syncA, !1), this.$element[0].addEventListener("DOMNodeInserted", e._syncS, !1), this.$element[0].addEventListener("DOMNodeRemoved", e._syncS, !1))
					}, n.prototype._registerDataEvents = function() {
						var t = this;
						this.dataAdapter.on("*", function(e, i) {
							t.trigger(e, i)
						})
					}, n.prototype._registerSelectionEvents = function() {
						var e = this,
							i = ["toggle", "focus"];
						this.selection.on("toggle", function() {
							e.toggleDropdown()
						}), this.selection.on("focus", function(t) {
							e.focus(t)
						}), this.selection.on("*", function(s, n) {
							-1 === t.inArray(s, i) && e.trigger(s, n)
						})
					}, n.prototype._registerDropdownEvents = function() {
						var t = this;
						this.dropdown.on("*", function(e, i) {
							t.trigger(e, i)
						})
					}, n.prototype._registerResultsEvents = function() {
						var t = this;
						this.results.on("*", function(e, i) {
							t.trigger(e, i)
						})
					}, n.prototype._registerEvents = function() {
						var t = this;
						this.on("open", function() {
							t.$container.addClass("select2-container--open")
						}), this.on("close", function() {
							t.$container.removeClass("select2-container--open")
						}), this.on("enable", function() {
							t.$container.removeClass("select2-container--disabled")
						}), this.on("disable", function() {
							t.$container.addClass("select2-container--disabled")
						}), this.on("blur", function() {
							t.$container.removeClass("select2-container--focus")
						}), this.on("query", function(e) {
							t.isOpen() || t.trigger("open", {}), this.dataAdapter.query(e, function(i) {
								t.trigger("results:all", {
									data: i,
									query: e
								})
							})
						}), this.on("query:append", function(e) {
							this.dataAdapter.query(e, function(i) {
								t.trigger("results:append", {
									data: i,
									query: e
								})
							})
						}), this.on("keypress", function(e) {
							var i = e.which;
							t.isOpen() ? i === s.ESC || i === s.TAB || i === s.UP && e.altKey ? (t.close(), e.preventDefault()) : i === s.ENTER ? (t.trigger("results:select", {}), e.preventDefault()) : i === s.SPACE && e.ctrlKey ? (t.trigger("results:toggle", {}), e.preventDefault()) : i === s.UP ? (t.trigger("results:previous", {}), e.preventDefault()) : i === s.DOWN && (t.trigger("results:next", {}), e.preventDefault()) : (i === s.ENTER || i === s.SPACE || i === s.DOWN && e.altKey) && (t.open(), e.preventDefault())
						})
					}, n.prototype._syncAttributes = function() {
						this.options.set("disabled", this.$element.prop("disabled")), this.options.get("disabled") ? (this.isOpen() && this.close(), this.trigger("disable", {})) : this.trigger("enable", {})
					}, n.prototype._syncSubtree = function(t, e) {
						var i = !1,
							s = this;
						if (!t || !t.target || "OPTION" === t.target.nodeName || "OPTGROUP" === t.target.nodeName) {
							if (e)
								if (e.addedNodes && e.addedNodes.length > 0)
									for (var n = 0; n < e.addedNodes.length; n++) {
										e.addedNodes[n].selected && (i = !0)
									} else e.removedNodes && e.removedNodes.length > 0 && (i = !0);
								else i = !0;
							i && this.dataAdapter.current(function(t) {
								s.trigger("selection:update", {
									data: t
								})
							})
						}
					}, n.prototype.trigger = function(t, e) {
						var i = n.__super__.trigger,
							s = {
								open: "opening",
								close: "closing",
								select: "selecting",
								unselect: "unselecting"
							};
						if (void 0 === e && (e = {}), t in s) {
							var a = s[t],
								o = {
									prevented: !1,
									name: t,
									args: e
								};
							if (i.call(this, a, o), o.prevented) return void(e.prevented = !0)
						}
						i.call(this, t, e)
					}, n.prototype.toggleDropdown = function() {
						this.options.get("disabled") || (this.isOpen() ? this.close() : this.open())
					}, n.prototype.open = function() {
						this.isOpen() || this.trigger("query", {})
					}, n.prototype.close = function() {
						this.isOpen() && this.trigger("close", {})
					}, n.prototype.isOpen = function() {
						return this.$container.hasClass("select2-container--open")
					}, n.prototype.hasFocus = function() {
						return this.$container.hasClass("select2-container--focus")
					}, n.prototype.focus = function(t) {
						this.hasFocus() || (this.$container.addClass("select2-container--focus"), this.trigger("focus", {}))
					}, n.prototype.enable = function(t) {
						this.options.get("debug") && window.console && console.warn && console.warn('Select2: The `select2("enable")` method has been deprecated and will be removed in later Select2 versions. Use $element.prop("disabled") instead.'), (null == t || 0 === t.length) && (t = [!0]);
						var e = !t[0];
						this.$element.prop("disabled", e)
					}, n.prototype.data = function() {
						this.options.get("debug") && arguments.length > 0 && window.console && console.warn && console.warn('Select2: Data can no longer be set using `select2("data")`. You should consider setting the value instead using `$element.val()`.');
						var t = [];
						return this.dataAdapter.current(function(e) {
							t = e
						}), t
					}, n.prototype.val = function(e) {
						if (this.options.get("debug") && window.console && console.warn && console.warn('Select2: The `select2("val")` method has been deprecated and will be removed in later Select2 versions. Use $element.val() instead.'), null == e || 0 === e.length) return this.$element.val();
						var i = e[0];
						t.isArray(i) && (i = t.map(i, function(t) {
							return t.toString()
						})), this.$element.val(i).trigger("change")
					}, n.prototype.destroy = function() {
						this.$container.remove(), this.$element[0].detachEvent && this.$element[0].detachEvent("onpropertychange", this._syncA), null != this._observer ? (this._observer.disconnect(), this._observer = null) : this.$element[0].removeEventListener && (this.$element[0].removeEventListener("DOMAttrModified", this._syncA, !1), this.$element[0].removeEventListener("DOMNodeInserted", this._syncS, !1), this.$element[0].removeEventListener("DOMNodeRemoved", this._syncS, !1)), this._syncA = null, this._syncS = null, this.$element.off(".select2"), this.$element.attr("tabindex", this.$element.data("old-tabindex")), this.$element.removeClass("select2-hidden-accessible"), this.$element.attr("aria-hidden", "false"), this.$element.removeData("select2"), this.dataAdapter.destroy(), this.selection.destroy(), this.dropdown.destroy(), this.results.destroy(), this.dataAdapter = null, this.selection = null, this.dropdown = null, this.results = null
					}, n.prototype.render = function() {
						var e = t('<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>');
						return e.attr("dir", this.options.get("dir")), this.$container = e, this.$container.addClass("select2-container--" + this.options.get("theme")), e.data("element", this.$element), e
					}, n
				}), e.define("jquery-mousewheel", ["jquery"], function(t) {
					return t
				}), e.define("jquery.select2", ["jquery", "jquery-mousewheel", "./select2/core", "./select2/defaults"], function(t, e, i, s) {
					if (null == t.fn.select2) {
						var n = ["open", "close", "destroy"];
						t.fn.select2 = function(e) {
							if ("object" == typeof(e = e || {})) return this.each(function() {
								var s = t.extend(!0, {}, e);
								new i(t(this), s)
							}), this;
							if ("string" == typeof e) {
								var s, a = Array.prototype.slice.call(arguments, 1);
								return this.each(function() {
									var i = t(this).data("select2");
									null == i && window.console && console.error && console.error("The select2('" + e + "') method was called on an element that is not using Select2."), s = i[e].apply(i, a)
								}), t.inArray(e, n) > -1 ? this : s
							}
							throw new Error("Invalid arguments for Select2: " + e)
						}
					}
					return null == t.fn.select2.defaults && (t.fn.select2.defaults = s), i
				}), {
					define: e.define,
					require: e.require
				}
			}(),
			i = e.require("jquery.select2");
		return t.fn.select2.amd = e, i
	}),
	function(t) {
		t.fn.instagramLite = function(e) {
			if (!this.length) return this;
			self.plugin = this, self.plugin.settings = {}, self.plugin.settings = t.extend({}, {
				username: null,
				clientID: null,
				limit: null,
				list: !0,
				videos: !1,
				urls: !1,
				captions: !1,
				date: !1,
				likes: !1,
				max_id: null,
				loadMore: null,
				error: function() {},
				success: function() {}
			}, e), self.el = t(this), self.loadContent(), plugin.settings.loadMore && t(plugin.settings.loadMore).on("click", function(t) {
				t.preventDefault(), self.loadContent()
			})
		}, getMaxId = function(t) {
			return t[t.length - 1].id
		}, formatCaption = function(t) {
			for (var e = t.split(" "), i = "", s = 0; s < e.length; s++) {
				var n;
				if ("@" == e[s][0]) n = '<a href="http://twitter.com/' + e[s].replace("@", "").toLowerCase() + '" target="_blank">' + e[s] + "</a>";
				else if ("#" == e[s][0]) {
					n = '<a href="http://twitter.com/hashtag/' + e[s].replace("#", "").toLowerCase() + '" target="_blank">' + e[s] + "</a>"
				} else n = e[s];
				i += n + " "
			}
			return i
		}, loadContent = function() {
			plugin.settings.clientID ? el.each(function() {
				var e = "https://api.instagram.com/v1/users/self/media/recent/?access_token=" + plugin.settings.clientID + "&count=" + plugin.settings.limit + "&callback=?";
				e += plugin.settings.max_id ? "&max_id=" + plugin.settings.max_id : "", t.ajax({
					type: "GET",
					url: e,
					dataType: "jsonp",
					success: function(t) {
						if (200 === t.meta.code && t.data.length) {
							for (var e = 0; e < t.data.length; e++) {
								var i, s = t.data[e];
								if ("image" === s.type) {
									if (l = '<img class="il-photo__img" src="' + s.images.standard_resolution.url + '" alt="Instagram Image" data-filter="' + s.filter + '" />', plugin.settings.urls && (l = '<a href="' + s.link + '" target="_blank">' + l + "</a>"), (plugin.settings.captions || plugin.settings.date || plugin.settings.likes) && (l += '<div class="il-photo__meta">'), plugin.settings.captions && s.caption && (l += '<div class="il-photo__caption" data-caption-id="' + s.caption.id + '">' + self.formatCaption(s.caption.text) + "</div>"), plugin.settings.date) {
										var n = new Date(1e3 * s.created_time),
											a = n.getDate(),
											o = n.getMonth() + 1,
											r = n.getFullYear();
										n.getHours(), n.getMinutes(), n.getSeconds();
										l += '<div class="il-photo__date">' + (n = o + "/" + a + "/" + r) + "</div>"
									}
									plugin.settings.likes && (l += '<div class="il-photo__likes">' + s.likes.count + "</div>"), (plugin.settings.captions || plugin.settings.date || plugin.settings.likes) && (l += "</div>")
								}
								if ("video" === s.type && plugin.settings.videos)
									if (s.videos) s.videos.standard_resolution ? i = s.videos.standard_resolution.url : s.videos.low_resolution ? i = s.videos.low_resolution.url : s.videos.low_bandwidth && (i = s.videos.low_bandwidth.url), l = '<video poster="' + s.images.standard_resolution.url + '" controls>', l += '<source src="' + i + '" type="video/mp4;"></source>', l += "</video>";
								if (plugin.settings.list) var l = '<div class="clear"><div class="col-xs-3">' + l + "</div></div>";
								el.append(l)
							}
							plugin.settings.max_id = self.getMaxId(t.data), plugin.settings.success.call(this)
						} else plugin.settings.error.call(this, t.meta.code, t.meta.error_message)
					},
					error: function() {
						plugin.settings.error.call(this)
					}
				})
			}) : alert("An Instagram Access Token is required to display Instagram profile images.")
		}
	}(jQuery), "undefined" == typeof Shopify && (Shopify = {}), Shopify.money_format = "$ {{amount}}", Shopify.onError = function(t, e) {
		var i = jQuery.parseJSON(t.responseText).description;
		"function" != typeof $().magnificPopup ? alert(i) : ($(".product-item-caption-white").append('<div class="error cart-bottom-wrap"><h3>Sorry, looks like something went wrong. Please correct the following and submit again:</h3>' + i + "</div>"), setTimeout(function() {
			$(".product-item-caption-white .error.cart-bottom-wrap").remove()
		}, 8e3))
	}, Shopify.fullMessagesFromErrors = function(t) {
		var e = [];
		return jQuery.each(t, function(t, i) {
			jQuery.each(i, function(i, s) {
				e.push(t + " " + s)
			})
		}), e
	}, Shopify.onCartUpdate = function(t) {
		void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (t = window.BOLD.common.cartDoctor.fix(t)), alert("There are now " + t.item_count + " items in the cart.")
	}, Shopify.onCartShippingRatesUpdate = function(t, e) {
		var i = "";
		e.zip && (i += e.zip + ", "), e.province && (i += e.province + ", "), i += e.country, alert("There are " + t.length + " shipping rates available for " + i + ", starting at " + Shopify.formatMoney(t[0].price) + ".")
	}, Shopify.onItemAdded = function(t) {
		alert(t.title + " was added to your shopping cart.")
	}, Shopify.onProduct = function(t) {
		alert("Received everything we ever wanted to know about " + t.title)
	}, Shopify.formatMoney = function(t, e) {
		"string" == typeof t && (t = t.replace(".", ""));
		var i = "",
			s = /\{\{\s*(\w+)\s*\}\}/,
			n = e || this.money_format;

		function a(t) {
			return t.replace(/(\d+)(\d{3}[\.,]?)/, "$1,$2")
		}
		switch (n.match(s)[1]) {
			case "amount":
				i = a(floatToString(t / 100, 2));
				break;
			case "amount_no_decimals":
				i = a(floatToString(t / 100, 0));
				break;
			case "amount_with_comma_separator":
				i = floatToString(t / 100, 2).replace(/\./, ",");
				break;
			case "amount_no_decimals_with_comma_separator":
				i = a(floatToString(t / 100, 0)).replace(/\./, ",")
		}
		return n.replace(s, i)
	}, Shopify.resizeImage = function(t, e) {
		try {
			if ("original" == e) return t;
			var i = t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
			return i[1] + "_" + e + "." + i[2]
		} catch (e) {
			return t
		}
	}, Shopify.addItem = function(t, e, i) {
		var s = {
			type: "POST",
			url: "/cart/add.js",
			data: "quantity=" + (e = e || 1) + "&id=" + t,
			dataType: "json",
			success: function(t) {
				void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (t = window.BOLD.common.cartDoctor.fixItem(t)), "function" == typeof i ? i(t) : Shopify.onItemAdded(t)
			},
			error: function(t, e) {
				Shopify.onError(t, e)
			}
		};
		jQuery.ajax(s)
	}, Shopify.addItemFromForm = function(t, e) {
		var i = {
			type: "POST",
			url: "/cart/add.js",
			data: window.FormData ? new FormData(jQuery(t)[0]) : jQuery(t).serialize(),
			contentType: !1,
			processData: !1,
			dataType: "json",
			success: function(i) {
				void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (i = window.BOLD.common.cartDoctor.fixItem(i)), "function" == typeof e ? e(i, t) : (Shopify.getCart(Shopify.loadQuickCart), $("#shopify-section-accessories-recommendation").text().trim().length > 0 && setTimeout(function() {
					$("#container-accessories-modal").show(), $(".accessory-product-wrapper").hasClass("slick-initialized") || (console.log("slick inititalized"), $(".accessory-product-wrapper").slick({
						infinite: !0,
						slidesToShow: 3,
						slidesToScroll: 1
					})), $(".accessories-modal-inner").on("click", ".accessory-product-card .addtocart", function(t) {
   alert("kkkjjjddd");
                      console.log("kkkkkkkkkkkkkkkkkkkkkkkkkkkkkk");
						var e = {
							quantity: 1,
							id: $(this).attr("product-id")
						};
						$.ajax({
							type: "POST",
							url: "/cart/add.js",
							data: e,
							dataType: "json",
							success: function(t) {
								$(this).before("<p class='add-msg'>Product Added</p>")
							},
							error: function(t) {
								console.log(t)
							}
						})
					})
				}, 2e3))
			},
			error: function(t, e) {
				Shopify.onError(t, e)
			}
		};
		jQuery.ajax(i)
	}, Shopify.getCart = function(t) {
		jQuery.getJSON("/cart.js", function(e, i) {
			void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (e = window.BOLD.common.cartDoctor.fix(e)), "function" == typeof t ? t(e) : Shopify.onCartUpdate(e), window.BOLD && BOLD.common && BOLD.common.eventEmitter && "function" == typeof BOLD.common.eventEmitter.emit && BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded", e)
		})
	}, Shopify.getCartCustom = function() {
		jQuery.getJSON("/cart.js", function(t, e) {
			Shopify.updateQuickCart(t), Shopify.afterCartUpdate(t)
		})
	}, Shopify.getCartShippingRatesForDestination = function(t, e) {
		var i = {
			type: "GET",
			url: "/cart/shipping_rates.json",
			data: Shopify.param({
				shipping_address: t
			}),
			dataType: "json",
			success: function(i) {
				rates = i.shipping_rates, "function" == typeof e ? e(rates, t) : Shopify.onCartShippingRatesUpdate(rates, t)
			},
			error: function(t, e) {
				Shopify.onError(t, e)
			}
		};
		jQuery.ajax(i)
	}, Shopify.getProduct = function(t, e) {
		jQuery.getJSON("/products/" + t + ".js", function(t, i) {
			"function" == typeof e ? e(t) : Shopify.onProduct(t)
		})
	}, Shopify.changeItem = function(t, e, i) {
		console.log("Bold_Disabled"), document.querySelectorAll(".cart-line-item").forEach(function(t) {
			t.style = "pointer-events:none"
		});
		var s = {
			type: "POST",
			url: "/cart/change.js",
			data: "quantity=" + e + "&id=" + t,
			dataType: "json",
			success: function(t) {
				void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (t = window.BOLD.common.cartDoctor.fix(t)), "function" == typeof i ? i(t) : Shopify.onCartUpdate(t), window.BOLD && BOLD.common && BOLD.common.eventEmitter && "function" == typeof BOLD.common.eventEmitter.emit && BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded", t)
			},
			error: function(t, e) {
				Shopify.onError(t, e)
			}
		};
		jQuery.ajax(s)
	}, Shopify.removeItem = function(t, e) {
		console.log("Bold_Disabled"), document.querySelectorAll(".cart-line-item").forEach(function(t) {
			t.style = "pointer-events:none"
		});
		var i = {
			type: "POST",
			url: "/cart/change.js",
			data: "quantity=0&id=" + t,
			dataType: "json",
			success: function(t) {
				void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (t = window.BOLD.common.cartDoctor.fix(t)), "function" == typeof e ? e(t) : Shopify.onCartUpdate(t), window.BOLD && BOLD.common && BOLD.common.eventEmitter && "function" == typeof BOLD.common.eventEmitter.emit && BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded", t)
			},
			error: function(t, e) {
				Shopify.onError(t, e)
			}
		};
		jQuery.ajax(i)
	}, Shopify.clear = function(t) {
		var e = {
			type: "POST",
			url: "/cart/clear.js",
			data: "",
			dataType: "json",
			success: function(e) {
				void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (e = window.BOLD.common.cartDoctor.fix(e)), "function" == typeof t ? t(e) : Shopify.onCartUpdate(e)
			},
			error: function(t, e) {
				Shopify.onError(t, e)
			}
		};
		jQuery.ajax(e)
	}, Shopify.updateCartFromForm = function(t, e) {
		var i = {
			type: "POST",
			url: "/cart/update.js",
			data: jQuery(t).serialize(),
			dataType: "json",
			success: function(i) {
				void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (i = window.BOLD.common.cartDoctor.fix(i)), "function" == typeof e ? e(i, t) : Shopify.onCartUpdate(i, t)
			},
			error: function(t, e) {
				Shopify.onError(t, e)
			}
		};
		jQuery.ajax(i)
	}, Shopify.updateCartAttributes = function(t, e) {
		var i = "";
		jQuery.isArray(t) ? jQuery.each(t, function(t, e) {
			var s = attributeToString(e.key);
			"" !== s && (i += "attributes[" + s + "]=" + attributeToString(e.value) + "&")
		}) : "object" == typeof t && null !== t && jQuery.each(t, function(t, e) {
			i += "attributes[" + attributeToString(t) + "]=" + attributeToString(e) + "&"
		});
		var s = {
			type: "POST",
			url: "/cart/update.js",
			data: i,
			dataType: "json",
			success: function(t) {
				void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (t = window.BOLD.common.cartDoctor.fix(t)), "function" == typeof e ? e(t) : Shopify.onCartUpdate(t), window.BOLD && BOLD.common && BOLD.common.eventEmitter && "function" == typeof BOLD.common.eventEmitter.emit && BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded", t)
			},
			error: function(t, e) {
				Shopify.onError(t, e)
			}
		};
		jQuery.ajax(s)
	}, Shopify.updateCartNote = function(t, e) {
		var i = {
			type: "POST",
			url: "/cart/update.js",
			data: "note=" + attributeToString(t),
			dataType: "json",
			success: function(t) {
				void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (t = window.BOLD.common.cartDoctor.fix(t)), "function" == typeof e && e(t)
			},
			error: function(t, e) {
				Shopify.onError(t, e)
			}
		};
		jQuery.ajax(i)
	}, jQuery.fn.jquery >= "1.4" ? Shopify.param = jQuery.param : (Shopify.param = function(t) {
		var e = [],
			i = function(t, i) {
				i = jQuery.isFunction(i) ? i() : i, e[e.length] = encodeURIComponent(t) + "=" + encodeURIComponent(i)
			};
		if (jQuery.isArray(t) || t.jquery) jQuery.each(t, function() {
			i(this.name, this.value)
		});
		else
			for (var s in t) Shopify.buildParams(s, t[s], i);
		return e.join("&").replace(/%20/g, "+")
	}, Shopify.buildParams = function(t, e, i) {
		jQuery.isArray(e) && e.length ? jQuery.each(e, function(e, s) {
			rbracket.test(t) ? i(t, s) : Shopify.buildParams(t + "[" + ("object" == typeof s || jQuery.isArray(s) ? e : "") + "]", s, i)
		}) : null != e && "object" == typeof e ? Shopify.isEmptyObject(e) ? i(t, "") : jQuery.each(e, function(e, s) {
			Shopify.buildParams(t + "[" + e + "]", s, i)
		}) : i(t, e)
	}, Shopify.isEmptyObject = function(t) {
		for (var e in t) return !1;
		return !0
	}),
	function(t) {
		var e = {
			url: !1,
			callback: !1,
			target: !1,
			duration: 120,
			on: "mouseover",
			touch: !0,
			onZoomIn: !1,
			onZoomOut: !1,
			magnify: 1
		};
		t.zoom = function(e, i, s, n) {
			var a, o, r, l, d, c, h, u = t(e).css("position"),
				p = t(i);
			return e.style.position = /(absolute|fixed)/.test(u) ? u : "relative", e.style.overflow = "hidden", s.style.width = s.style.height = "", t(s).addClass("zoomImg").css({
				position: "absolute",
				top: 0,
				left: 0,
				opacity: 0,
				width: s.width * n,
				height: s.height * n,
				border: "none",
				maxWidth: "none",
				maxHeight: "none"
			}).appendTo(e), {
				init: function() {
					o = t(e).outerWidth(), a = t(e).outerHeight(), i === e ? (l = o, r = a) : (l = p.outerWidth(), r = p.outerHeight()), d = (s.width - o) / l, c = (s.height - a) / r, h = p.offset()
				},
				move: function(t) {
					var e = t.pageX - h.left,
						i = t.pageY - h.top;
					i = Math.max(Math.min(i, r), 0), e = Math.max(Math.min(e, l), 0), s.style.left = e * -d + "px", s.style.top = i * -c + "px"
				}
			}
		}, t.fn.zoom = function(i) {
			return this.each(function() {
				var s, n = t.extend({}, e, i || {}),
					a = n.target || this,
					o = this,
					r = t(o),
					l = document.createElement("img"),
					d = t(l),
					c = "mousemove.zoom",
					h = !1,
					u = !1;
				(n.url || ((s = r.find("img"))[0] && (n.url = s.data("src") || s.attr("src")), n.url)) && (function() {
					var t = a.style.position,
						e = a.style.overflow;
					r.one("zoom.destroy", function() {
						r.off(".zoom"), a.style.position = t, a.style.overflow = e, d.remove()
					})
				}(), l.onload = function() {
					function e(e) {
						s.init(), s.move(e), d.stop().fadeTo(t.support.opacity ? n.duration : 0, 1, !!t.isFunction(n.onZoomIn) && n.onZoomIn.call(l))
					}

					function i() {
						d.stop().fadeTo(n.duration, 0, !!t.isFunction(n.onZoomOut) && n.onZoomOut.call(l))
					}
					var s = t.zoom(a, o, l, n.magnify);
					"grab" === n.on ? r.on("mousedown.zoom", function(n) {
						1 === n.which && (t(document).one("mouseup.zoom", function() {
							i(), t(document).off(c, s.move)
						}), e(n), t(document).on(c, s.move), n.preventDefault())
					}) : "click" === n.on ? r.on("click.zoom", function(n) {
						return h ? void 0 : (h = !0, e(n), t(document).on(c, s.move), t(document).one("click.zoom", function() {
							i(), h = !1, t(document).off(c, s.move)
						}), !1)
					}) : "toggle" === n.on ? r.on("click.zoom", function(t) {
						h ? i() : e(t), h = !h
					}) : "mouseover" === n.on && (s.init(), r.on("mouseenter.zoom", e).on("mouseleave.zoom", i).on(c, s.move)), n.touch && r.on("touchstart.zoom", function(t) {
						t.preventDefault(), u ? (u = !1, i()) : (u = !0, e(t.originalEvent.touches[0] || t.originalEvent.changedTouches[0]))
					}).on("touchmove.zoom", function(t) {
						t.preventDefault(), s.move(t.originalEvent.touches[0] || t.originalEvent.changedTouches[0])
					}), t.isFunction(n.callback) && n.callback.call(l)
				}, l.src = n.url)
			})
		}, t.fn.zoom.defaults = e
	}(window.jQuery);

if (function(t, e) {
		"object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.moment = e()
	}(this, function() {
		"use strict";
		var t, e;

		function i() {
			return t.apply(null, arguments)
		}

		function s(t) {
			return t instanceof Array || "[object Array]" === Object.prototype.toString.call(t)
		}

		function n(t) {
			return null != t && "[object Object]" === Object.prototype.toString.call(t)
		}

		function a(t) {
			return void 0 === t
		}

		function o(t) {
			return "number" == typeof t || "[object Number]" === Object.prototype.toString.call(t)
		}

		function r(t) {
			return t instanceof Date || "[object Date]" === Object.prototype.toString.call(t)
		}

		function l(t, e) {
			var i, s = [];
			for (i = 0; i < t.length; ++i) s.push(e(t[i], i));
			return s
		}

		function d(t, e) {
			return Object.prototype.hasOwnProperty.call(t, e)
		}

		function c(t, e) {
			for (var i in e) d(e, i) && (t[i] = e[i]);
			return d(e, "toString") && (t.toString = e.toString), d(e, "valueOf") && (t.valueOf = e.valueOf), t
		}

		function h(t, e, i, s) {
			return _e(t, e, i, s, !0).utc()
		}

		function u(t) {
			return null == t._pf && (t._pf = {
				empty: !1,
				unusedTokens: [],
				unusedInput: [],
				overflow: -2,
				charsLeftOver: 0,
				nullInput: !1,
				invalidMonth: null,
				invalidFormat: !1,
				userInvalidated: !1,
				iso: !1,
				parsedDateParts: [],
				meridiem: null,
				rfc2822: !1,
				weekdayMismatch: !1
			}), t._pf
		}

		function p(t) {
			if (null == t._isValid) {
				var i = u(t),
					s = e.call(i.parsedDateParts, function(t) {
						return null != t
					}),
					n = !isNaN(t._d.getTime()) && i.overflow < 0 && !i.empty && !i.invalidMonth && !i.invalidWeekday && !i.weekdayMismatch && !i.nullInput && !i.invalidFormat && !i.userInvalidated && (!i.meridiem || i.meridiem && s);
				if (t._strict && (n = n && 0 === i.charsLeftOver && 0 === i.unusedTokens.length && void 0 === i.bigHour), null != Object.isFrozen && Object.isFrozen(t)) return n;
				t._isValid = n
			}
			return t._isValid
		}

		function f(t) {
			var e = h(NaN);
			return null != t ? c(u(e), t) : u(e).userInvalidated = !0, e
		}
		e = Array.prototype.some ? Array.prototype.some : function(t) {
			for (var e = Object(this), i = e.length >>> 0, s = 0; s < i; s++)
				if (s in e && t.call(this, e[s], s, e)) return !0;
			return !1
		};
		var m = i.momentProperties = [];

		function g(t, e) {
			var i, s, n;
			if (a(e._isAMomentObject) || (t._isAMomentObject = e._isAMomentObject), a(e._i) || (t._i = e._i), a(e._f) || (t._f = e._f), a(e._l) || (t._l = e._l), a(e._strict) || (t._strict = e._strict), a(e._tzm) || (t._tzm = e._tzm), a(e._isUTC) || (t._isUTC = e._isUTC), a(e._offset) || (t._offset = e._offset), a(e._pf) || (t._pf = u(e)), a(e._locale) || (t._locale = e._locale), 0 < m.length)
				for (i = 0; i < m.length; i++) a(n = e[s = m[i]]) || (t[s] = n);
			return t
		}
		var v = !1;

		function y(t) {
			g(this, t), this._d = new Date(null != t._d ? t._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === v && (v = !0, i.updateOffset(this), v = !1)
		}

		function b(t) {
			return t instanceof y || null != t && null != t._isAMomentObject
		}

		function w(t) {
			return t < 0 ? Math.ceil(t) || 0 : Math.floor(t)
		}

		function S(t) {
			var e = +t,
				i = 0;
			return 0 !== e && isFinite(e) && (i = w(e)), i
		}

		function x(t, e, i) {
			var s, n = Math.min(t.length, e.length),
				a = Math.abs(t.length - e.length),
				o = 0;
			for (s = 0; s < n; s++)(i && t[s] !== e[s] || !i && S(t[s]) !== S(e[s])) && o++;
			return o + a
		}

		function T(t) {
			!1 === i.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + t)
		}

		function C(t, e) {
			var s = !0;
			return c(function() {
				if (null != i.deprecationHandler && i.deprecationHandler(null, t), s) {
					for (var n, a = [], o = 0; o < arguments.length; o++) {
						if (n = "", "object" == typeof arguments[o]) {
							for (var r in n += "\n[" + o + "] ", arguments[0]) n += r + ": " + arguments[0][r] + ", ";
							n = n.slice(0, -2)
						} else n = arguments[o];
						a.push(n)
					}
					T(t + "\nArguments: " + Array.prototype.slice.call(a).join("") + "\n" + (new Error).stack), s = !1
				}
				return e.apply(this, arguments)
			}, e)
		}
		var _, E = {};

		function P(t, e) {
			null != i.deprecationHandler && i.deprecationHandler(t, e), E[t] || (T(e), E[t] = !0)
		}

		function k(t) {
			return t instanceof Function || "[object Function]" === Object.prototype.toString.call(t)
		}

		function $(t, e) {
			var i, s = c({}, t);
			for (i in e) d(e, i) && (n(t[i]) && n(e[i]) ? (s[i] = {}, c(s[i], t[i]), c(s[i], e[i])) : null != e[i] ? s[i] = e[i] : delete s[i]);
			for (i in t) d(t, i) && !d(e, i) && n(t[i]) && (s[i] = c({}, s[i]));
			return s
		}

		function M(t) {
			null != t && this.set(t)
		}
		i.suppressDeprecationWarnings = !1, i.deprecationHandler = null, _ = Object.keys ? Object.keys : function(t) {
			var e, i = [];
			for (e in t) d(t, e) && i.push(e);
			return i
		};
		var D = {};

		function O(t, e) {
			var i = t.toLowerCase();
			D[i] = D[i + "s"] = D[e] = t
		}

		function z(t) {
			return "string" == typeof t ? D[t] || D[t.toLowerCase()] : void 0
		}

		function A(t) {
			var e, i, s = {};
			for (i in t) d(t, i) && (e = z(i)) && (s[e] = t[i]);
			return s
		}
		var I = {};

		function L(t, e) {
			I[t] = e
		}

		function N(t, e, i) {
			var s = "" + Math.abs(t),
				n = e - s.length;
			return (0 <= t ? i ? "+" : "" : "-") + Math.pow(10, Math.max(0, n)).toString().substr(1) + s
		}
		var Y = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
			R = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
			j = {},
			H = {};

		function B(t, e, i, s) {
			var n = s;
			"string" == typeof s && (n = function() {
				return this[s]()
			}), t && (H[t] = n), e && (H[e[0]] = function() {
				return N(n.apply(this, arguments), e[1], e[2])
			}), i && (H[i] = function() {
				return this.localeData().ordinal(n.apply(this, arguments), t)
			})
		}

		function F(t, e) {
			return t.isValid() ? (e = W(e, t.localeData()), j[e] = j[e] || function(t) {
				var e, i, s, n = t.match(Y);
				for (e = 0, i = n.length; e < i; e++) H[n[e]] ? n[e] = H[n[e]] : n[e] = (s = n[e]).match(/\[[\s\S]/) ? s.replace(/^\[|\]$/g, "") : s.replace(/\\/g, "");
				return function(e) {
					var s, a = "";
					for (s = 0; s < i; s++) a += k(n[s]) ? n[s].call(e, t) : n[s];
					return a
				}
			}(e), j[e](t)) : t.localeData().invalidDate()
		}

		function W(t, e) {
			var i = 5;

			function s(t) {
				return e.longDateFormat(t) || t
			}
			for (R.lastIndex = 0; 0 <= i && R.test(t);) t = t.replace(R, s), R.lastIndex = 0, i -= 1;
			return t
		}
		var V = /\d/,
			q = /\d\d/,
			U = /\d{3}/,
			G = /\d{4}/,
			X = /[+-]?\d{6}/,
			Q = /\d\d?/,
			Z = /\d\d\d\d?/,
			K = /\d\d\d\d\d\d?/,
			J = /\d{1,3}/,
			tt = /\d{1,4}/,
			et = /[+-]?\d{1,6}/,
			it = /\d+/,
			st = /[+-]?\d+/,
			nt = /Z|[+-]\d\d:?\d\d/gi,
			at = /Z|[+-]\d\d(?::?\d\d)?/gi,
			ot = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
			rt = {};

		function lt(t, e, i) {
			rt[t] = k(e) ? e : function(t, s) {
				return t && i ? i : e
			}
		}

		function dt(t, e) {
			return d(rt, t) ? rt[t](e._strict, e._locale) : new RegExp(ct(t.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(t, e, i, s, n) {
				return e || i || s || n
			})))
		}

		function ct(t) {
			return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")
		}
		var ht = {};

		function ut(t, e) {
			var i, s = e;
			for ("string" == typeof t && (t = [t]), o(e) && (s = function(t, i) {
					i[e] = S(t)
				}), i = 0; i < t.length; i++) ht[t[i]] = s
		}

		function pt(t, e) {
			ut(t, function(t, i, s, n) {
				s._w = s._w || {}, e(t, s._w, s, n)
			})
		}
		var ft = 0,
			mt = 1,
			gt = 2,
			vt = 3,
			yt = 4,
			bt = 5,
			wt = 6,
			St = 7,
			xt = 8;

		function Tt(t) {
			return Ct(t) ? 366 : 365
		}

		function Ct(t) {
			return t % 4 == 0 && t % 100 != 0 || t % 400 == 0
		}
		B("Y", 0, 0, function() {
			var t = this.year();
			return t <= 9999 ? "" + t : "+" + t
		}), B(0, ["YY", 2], 0, function() {
			return this.year() % 100
		}), B(0, ["YYYY", 4], 0, "year"), B(0, ["YYYYY", 5], 0, "year"), B(0, ["YYYYYY", 6, !0], 0, "year"), O("year", "y"), L("year", 1), lt("Y", st), lt("YY", Q, q), lt("YYYY", tt, G), lt("YYYYY", et, X), lt("YYYYYY", et, X), ut(["YYYYY", "YYYYYY"], ft), ut("YYYY", function(t, e) {
			e[ft] = 2 === t.length ? i.parseTwoDigitYear(t) : S(t)
		}), ut("YY", function(t, e) {
			e[ft] = i.parseTwoDigitYear(t)
		}), ut("Y", function(t, e) {
			e[ft] = parseInt(t, 10)
		}), i.parseTwoDigitYear = function(t) {
			return S(t) + (68 < S(t) ? 1900 : 2e3)
		};
		var _t, Et = Pt("FullYear", !0);

		function Pt(t, e) {
			return function(s) {
				return null != s ? ($t(this, t, s), i.updateOffset(this, e), this) : kt(this, t)
			}
		}

		function kt(t, e) {
			return t.isValid() ? t._d["get" + (t._isUTC ? "UTC" : "") + e]() : NaN
		}

		function $t(t, e, i) {
			t.isValid() && !isNaN(i) && ("FullYear" === e && Ct(t.year()) && 1 === t.month() && 29 === t.date() ? t._d["set" + (t._isUTC ? "UTC" : "") + e](i, t.month(), Mt(i, t.month())) : t._d["set" + (t._isUTC ? "UTC" : "") + e](i))
		}

		function Mt(t, e) {
			if (isNaN(t) || isNaN(e)) return NaN;
			var i = (e % 12 + 12) % 12;
			return t += (e - i) / 12, 1 === i ? Ct(t) ? 29 : 28 : 31 - i % 7 % 2
		}
		_t = Array.prototype.indexOf ? Array.prototype.indexOf : function(t) {
			var e;
			for (e = 0; e < this.length; ++e)
				if (this[e] === t) return e;
			return -1
		}, B("M", ["MM", 2], "Mo", function() {
			return this.month() + 1
		}), B("MMM", 0, 0, function(t) {
			return this.localeData().monthsShort(this, t)
		}), B("MMMM", 0, 0, function(t) {
			return this.localeData().months(this, t)
		}), O("month", "M"), L("month", 8), lt("M", Q), lt("MM", Q, q), lt("MMM", function(t, e) {
			return e.monthsShortRegex(t)
		}), lt("MMMM", function(t, e) {
			return e.monthsRegex(t)
		}), ut(["M", "MM"], function(t, e) {
			e[mt] = S(t) - 1
		}), ut(["MMM", "MMMM"], function(t, e, i, s) {
			var n = i._locale.monthsParse(t, s, i._strict);
			null != n ? e[mt] = n : u(i).invalidMonth = t
		});
		var Dt = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
			Ot = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
			zt = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_");

		function At(t, e) {
			var i;
			if (!t.isValid()) return t;
			if ("string" == typeof e)
				if (/^\d+$/.test(e)) e = S(e);
				else if (!o(e = t.localeData().monthsParse(e))) return t;
			return i = Math.min(t.date(), Mt(t.year(), e)), t._d["set" + (t._isUTC ? "UTC" : "") + "Month"](e, i), t
		}

		function It(t) {
			return null != t ? (At(this, t), i.updateOffset(this, !0), this) : kt(this, "Month")
		}
		var Lt = ot,
			Nt = ot;

		function Yt() {
			function t(t, e) {
				return e.length - t.length
			}
			var e, i, s = [],
				n = [],
				a = [];
			for (e = 0; e < 12; e++) i = h([2e3, e]), s.push(this.monthsShort(i, "")), n.push(this.months(i, "")), a.push(this.months(i, "")), a.push(this.monthsShort(i, ""));
			for (s.sort(t), n.sort(t), a.sort(t), e = 0; e < 12; e++) s[e] = ct(s[e]), n[e] = ct(n[e]);
			for (e = 0; e < 24; e++) a[e] = ct(a[e]);
			this._monthsRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + s.join("|") + ")", "i")
		}

		function Rt(t) {
			var e = new Date(Date.UTC.apply(null, arguments));
			return t < 100 && 0 <= t && isFinite(e.getUTCFullYear()) && e.setUTCFullYear(t), e
		}

		function jt(t, e, i) {
			var s = 7 + e - i;
			return -(7 + Rt(t, 0, s).getUTCDay() - e) % 7 + s - 1
		}

		function Ht(t, e, i, s, n) {
			var a, o, r = 1 + 7 * (e - 1) + (7 + i - s) % 7 + jt(t, s, n);
			return r <= 0 ? o = Tt(a = t - 1) + r : r > Tt(t) ? (a = t + 1, o = r - Tt(t)) : (a = t, o = r), {
				year: a,
				dayOfYear: o
			}
		}

		function Bt(t, e, i) {
			var s, n, a = jt(t.year(), e, i),
				o = Math.floor((t.dayOfYear() - a - 1) / 7) + 1;
			return o < 1 ? s = o + Ft(n = t.year() - 1, e, i) : o > Ft(t.year(), e, i) ? (s = o - Ft(t.year(), e, i), n = t.year() + 1) : (n = t.year(), s = o), {
				week: s,
				year: n
			}
		}

		function Ft(t, e, i) {
			var s = jt(t, e, i),
				n = jt(t + 1, e, i);
			return (Tt(t) - s + n) / 7
		}
		B("w", ["ww", 2], "wo", "week"), B("W", ["WW", 2], "Wo", "isoWeek"), O("week", "w"), O("isoWeek", "W"), L("week", 5), L("isoWeek", 5), lt("w", Q), lt("ww", Q, q), lt("W", Q), lt("WW", Q, q), pt(["w", "ww", "W", "WW"], function(t, e, i, s) {
			e[s.substr(0, 1)] = S(t)
		}), B("d", 0, "do", "day"), B("dd", 0, 0, function(t) {
			return this.localeData().weekdaysMin(this, t)
		}), B("ddd", 0, 0, function(t) {
			return this.localeData().weekdaysShort(this, t)
		}), B("dddd", 0, 0, function(t) {
			return this.localeData().weekdays(this, t)
		}), B("e", 0, 0, "weekday"), B("E", 0, 0, "isoWeekday"), O("day", "d"), O("weekday", "e"), O("isoWeekday", "E"), L("day", 11), L("weekday", 11), L("isoWeekday", 11), lt("d", Q), lt("e", Q), lt("E", Q), lt("dd", function(t, e) {
			return e.weekdaysMinRegex(t)
		}), lt("ddd", function(t, e) {
			return e.weekdaysShortRegex(t)
		}), lt("dddd", function(t, e) {
			return e.weekdaysRegex(t)
		}), pt(["dd", "ddd", "dddd"], function(t, e, i, s) {
			var n = i._locale.weekdaysParse(t, s, i._strict);
			null != n ? e.d = n : u(i).invalidWeekday = t
		}), pt(["d", "e", "E"], function(t, e, i, s) {
			e[s] = S(t)
		});
		var Wt = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			Vt = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
			qt = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
			Ut = ot,
			Gt = ot,
			Xt = ot;

		function Qt() {
			function t(t, e) {
				return e.length - t.length
			}
			var e, i, s, n, a, o = [],
				r = [],
				l = [],
				d = [];
			for (e = 0; e < 7; e++) i = h([2e3, 1]).day(e), s = this.weekdaysMin(i, ""), n = this.weekdaysShort(i, ""), a = this.weekdays(i, ""), o.push(s), r.push(n), l.push(a), d.push(s), d.push(n), d.push(a);
			for (o.sort(t), r.sort(t), l.sort(t), d.sort(t), e = 0; e < 7; e++) r[e] = ct(r[e]), l[e] = ct(l[e]), d[e] = ct(d[e]);
			this._weekdaysRegex = new RegExp("^(" + d.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + l.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + o.join("|") + ")", "i")
		}

		function Zt() {
			return this.hours() % 12 || 12
		}

		function Kt(t, e) {
			B(t, 0, 0, function() {
				return this.localeData().meridiem(this.hours(), this.minutes(), e)
			})
		}

		function Jt(t, e) {
			return e._meridiemParse
		}
		B("H", ["HH", 2], 0, "hour"), B("h", ["hh", 2], 0, Zt), B("k", ["kk", 2], 0, function() {
			return this.hours() || 24
		}), B("hmm", 0, 0, function() {
			return "" + Zt.apply(this) + N(this.minutes(), 2)
		}), B("hmmss", 0, 0, function() {
			return "" + Zt.apply(this) + N(this.minutes(), 2) + N(this.seconds(), 2)
		}), B("Hmm", 0, 0, function() {
			return "" + this.hours() + N(this.minutes(), 2)
		}), B("Hmmss", 0, 0, function() {
			return "" + this.hours() + N(this.minutes(), 2) + N(this.seconds(), 2)
		}), Kt("a", !0), Kt("A", !1), O("hour", "h"), L("hour", 13), lt("a", Jt), lt("A", Jt), lt("H", Q), lt("h", Q), lt("k", Q), lt("HH", Q, q), lt("hh", Q, q), lt("kk", Q, q), lt("hmm", Z), lt("hmmss", K), lt("Hmm", Z), lt("Hmmss", K), ut(["H", "HH"], vt), ut(["k", "kk"], function(t, e, i) {
			var s = S(t);
			e[vt] = 24 === s ? 0 : s
		}), ut(["a", "A"], function(t, e, i) {
			i._isPm = i._locale.isPM(t), i._meridiem = t
		}), ut(["h", "hh"], function(t, e, i) {
			e[vt] = S(t), u(i).bigHour = !0
		}), ut("hmm", function(t, e, i) {
			var s = t.length - 2;
			e[vt] = S(t.substr(0, s)), e[yt] = S(t.substr(s)), u(i).bigHour = !0
		}), ut("hmmss", function(t, e, i) {
			var s = t.length - 4,
				n = t.length - 2;
			e[vt] = S(t.substr(0, s)), e[yt] = S(t.substr(s, 2)), e[bt] = S(t.substr(n)), u(i).bigHour = !0
		}), ut("Hmm", function(t, e, i) {
			var s = t.length - 2;
			e[vt] = S(t.substr(0, s)), e[yt] = S(t.substr(s))
		}), ut("Hmmss", function(t, e, i) {
			var s = t.length - 4,
				n = t.length - 2;
			e[vt] = S(t.substr(0, s)), e[yt] = S(t.substr(s, 2)), e[bt] = S(t.substr(n))
		});
		var te, ee = Pt("Hours", !0),
			ie = {
				calendar: {
					sameDay: "[Today at] LT",
					nextDay: "[Tomorrow at] LT",
					nextWeek: "dddd [at] LT",
					lastDay: "[Yesterday at] LT",
					lastWeek: "[Last] dddd [at] LT",
					sameElse: "L"
				},
				longDateFormat: {
					LTS: "h:mm:ss A",
					LT: "h:mm A",
					L: "MM/DD/YYYY",
					LL: "MMMM D, YYYY",
					LLL: "MMMM D, YYYY h:mm A",
					LLLL: "dddd, MMMM D, YYYY h:mm A"
				},
				invalidDate: "Invalid date",
				ordinal: "%d",
				dayOfMonthOrdinalParse: /\d{1,2}/,
				relativeTime: {
					future: "in %s",
					past: "%s ago",
					s: "a few seconds",
					ss: "%d seconds",
					m: "a minute",
					mm: "%d minutes",
					h: "an hour",
					hh: "%d hours",
					d: "a day",
					dd: "%d days",
					M: "a month",
					MM: "%d months",
					y: "a year",
					yy: "%d years"
				},
				months: Ot,
				monthsShort: zt,
				week: {
					dow: 0,
					doy: 6
				},
				weekdays: Wt,
				weekdaysMin: qt,
				weekdaysShort: Vt,
				meridiemParse: /[ap]\.?m?\.?/i
			},
			se = {},
			ne = {};

		function ae(t) {
			return t ? t.toLowerCase().replace("_", "-") : t
		}

		function oe(t) {
			var e = null;
			if (!se[t] && "undefined" != typeof module && module && module.exports) try {
				e = te._abbr, require("./locale/" + t), re(e)
			} catch (t) {}
			return se[t]
		}

		function re(t, e) {
			var i;
			return t && ((i = a(e) ? de(t) : le(t, e)) ? te = i : "undefined" != typeof console && console.warn && console.warn("Locale " + t + " not found. Did you forget to load it?")), te._abbr
		}

		function le(t, e) {
			if (null !== e) {
				var i, s = ie;
				if (e.abbr = t, null != se[t]) P("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), s = se[t]._config;
				else if (null != e.parentLocale)
					if (null != se[e.parentLocale]) s = se[e.parentLocale]._config;
					else {
						if (null == (i = oe(e.parentLocale))) return ne[e.parentLocale] || (ne[e.parentLocale] = []), ne[e.parentLocale].push({
							name: t,
							config: e
						}), null;
						s = i._config
					} return se[t] = new M($(s, e)), ne[t] && ne[t].forEach(function(t) {
					le(t.name, t.config)
				}), re(t), se[t]
			}
			return delete se[t], null
		}

		function de(t) {
			var e;
			if (t && t._locale && t._locale._abbr && (t = t._locale._abbr), !t) return te;
			if (!s(t)) {
				if (e = oe(t)) return e;
				t = [t]
			}
			return function(t) {
				for (var e, i, s, n, a = 0; a < t.length;) {
					for (e = (n = ae(t[a]).split("-")).length, i = (i = ae(t[a + 1])) ? i.split("-") : null; 0 < e;) {
						if (s = oe(n.slice(0, e).join("-"))) return s;
						if (i && i.length >= e && x(n, i, !0) >= e - 1) break;
						e--
					}
					a++
				}
				return te
			}(t)
		}

		function ce(t) {
			var e, i = t._a;
			return i && -2 === u(t).overflow && (e = i[mt] < 0 || 11 < i[mt] ? mt : i[gt] < 1 || i[gt] > Mt(i[ft], i[mt]) ? gt : i[vt] < 0 || 24 < i[vt] || 24 === i[vt] && (0 !== i[yt] || 0 !== i[bt] || 0 !== i[wt]) ? vt : i[yt] < 0 || 59 < i[yt] ? yt : i[bt] < 0 || 59 < i[bt] ? bt : i[wt] < 0 || 999 < i[wt] ? wt : -1, u(t)._overflowDayOfYear && (e < ft || gt < e) && (e = gt), u(t)._overflowWeeks && -1 === e && (e = St), u(t)._overflowWeekday && -1 === e && (e = xt), u(t).overflow = e), t
		}

		function he(t, e, i) {
			return null != t ? t : null != e ? e : i
		}

		function ue(t) {
			var e, s, n, a, o, r = [];
			if (!t._d) {
				var l, d;
				for (l = t, d = new Date(i.now()), n = l._useUTC ? [d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()] : [d.getFullYear(), d.getMonth(), d.getDate()], t._w && null == t._a[gt] && null == t._a[mt] && function(t) {
						var e, i, s, n, a, o, r, l;
						if (null != (e = t._w).GG || null != e.W || null != e.E) a = 1, o = 4, i = he(e.GG, t._a[ft], Bt(Ee(), 1, 4).year), s = he(e.W, 1), ((n = he(e.E, 1)) < 1 || 7 < n) && (l = !0);
						else {
							a = t._locale._week.dow, o = t._locale._week.doy;
							var d = Bt(Ee(), a, o);
							i = he(e.gg, t._a[ft], d.year), s = he(e.w, d.week), null != e.d ? ((n = e.d) < 0 || 6 < n) && (l = !0) : null != e.e ? (n = e.e + a, (e.e < 0 || 6 < e.e) && (l = !0)) : n = a
						}
						s < 1 || s > Ft(i, a, o) ? u(t)._overflowWeeks = !0 : null != l ? u(t)._overflowWeekday = !0 : (r = Ht(i, s, n, a, o), t._a[ft] = r.year, t._dayOfYear = r.dayOfYear)
					}(t), null != t._dayOfYear && (o = he(t._a[ft], n[ft]), (t._dayOfYear > Tt(o) || 0 === t._dayOfYear) && (u(t)._overflowDayOfYear = !0), s = Rt(o, 0, t._dayOfYear), t._a[mt] = s.getUTCMonth(), t._a[gt] = s.getUTCDate()), e = 0; e < 3 && null == t._a[e]; ++e) t._a[e] = r[e] = n[e];
				for (; e < 7; e++) t._a[e] = r[e] = null == t._a[e] ? 2 === e ? 1 : 0 : t._a[e];
				24 === t._a[vt] && 0 === t._a[yt] && 0 === t._a[bt] && 0 === t._a[wt] && (t._nextDay = !0, t._a[vt] = 0), t._d = (t._useUTC ? Rt : function(t, e, i, s, n, a, o) {
					var r = new Date(t, e, i, s, n, a, o);
					return t < 100 && 0 <= t && isFinite(r.getFullYear()) && r.setFullYear(t), r
				}).apply(null, r), a = t._useUTC ? t._d.getUTCDay() : t._d.getDay(), null != t._tzm && t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), t._nextDay && (t._a[vt] = 24), t._w && void 0 !== t._w.d && t._w.d !== a && (u(t).weekdayMismatch = !0)
			}
		}
		var pe = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
			fe = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
			me = /Z|[+-]\d\d(?::?\d\d)?/,
			ge = [
				["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
				["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
				["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
				["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
				["YYYY-DDD", /\d{4}-\d{3}/],
				["YYYY-MM", /\d{4}-\d\d/, !1],
				["YYYYYYMMDD", /[+-]\d{10}/],
				["YYYYMMDD", /\d{8}/],
				["GGGG[W]WWE", /\d{4}W\d{3}/],
				["GGGG[W]WW", /\d{4}W\d{2}/, !1],
				["YYYYDDD", /\d{7}/]
			],
			ve = [
				["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
				["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
				["HH:mm:ss", /\d\d:\d\d:\d\d/],
				["HH:mm", /\d\d:\d\d/],
				["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
				["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
				["HHmmss", /\d\d\d\d\d\d/],
				["HHmm", /\d\d\d\d/],
				["HH", /\d\d/]
			],
			ye = /^\/?Date\((\-?\d+)/i;

		function be(t) {
			var e, i, s, n, a, o, r = t._i,
				l = pe.exec(r) || fe.exec(r);
			if (l) {
				for (u(t).iso = !0, e = 0, i = ge.length; e < i; e++)
					if (ge[e][1].exec(l[1])) {
						n = ge[e][0], s = !1 !== ge[e][2];
						break
					} if (null == n) return void(t._isValid = !1);
				if (l[3]) {
					for (e = 0, i = ve.length; e < i; e++)
						if (ve[e][1].exec(l[3])) {
							a = (l[2] || " ") + ve[e][0];
							break
						} if (null == a) return void(t._isValid = !1)
				}
				if (!s && null != a) return void(t._isValid = !1);
				if (l[4]) {
					if (!me.exec(l[4])) return void(t._isValid = !1);
					o = "Z"
				}
				t._f = n + (a || "") + (o || ""), Te(t)
			} else t._isValid = !1
		}
		var we = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
		var Se = {
			UT: 0,
			GMT: 0,
			EDT: -240,
			EST: -300,
			CDT: -300,
			CST: -360,
			MDT: -360,
			MST: -420,
			PDT: -420,
			PST: -480
		};

		function xe(t) {
			var e, i, s, n = we.exec(t._i.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, ""));
			if (n) {
				var a = function(t, e, i, s, n, a) {
					var o = [function(t) {
						var e = parseInt(t, 10);
						return e <= 49 ? 2e3 + e : e <= 999 ? 1900 + e : e
					}(t), zt.indexOf(e), parseInt(i, 10), parseInt(s, 10), parseInt(n, 10)];
					return a && o.push(parseInt(a, 10)), o
				}(n[4], n[3], n[2], n[5], n[6], n[7]);
				if (i = a, s = t, (e = n[1]) && Vt.indexOf(e) !== new Date(i[0], i[1], i[2]).getDay() && (u(s).weekdayMismatch = !0, !(s._isValid = !1))) return;
				t._a = a, t._tzm = function(t, e, i) {
					if (t) return Se[t];
					if (e) return 0;
					var s = parseInt(i, 10),
						n = s % 100;
					return (s - n) / 100 * 60 + n
				}(n[8], n[9], n[10]), t._d = Rt.apply(null, t._a), t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), u(t).rfc2822 = !0
			} else t._isValid = !1
		}

		function Te(t) {
			if (t._f !== i.ISO_8601)
				if (t._f !== i.RFC_2822) {
					t._a = [], u(t).empty = !0;
					var e, s, n, a, o, r, l, c, h = "" + t._i,
						p = h.length,
						f = 0;
					for (n = W(t._f, t._locale).match(Y) || [], e = 0; e < n.length; e++) a = n[e], (s = (h.match(dt(a, t)) || [])[0]) && (0 < (o = h.substr(0, h.indexOf(s))).length && u(t).unusedInput.push(o), h = h.slice(h.indexOf(s) + s.length), f += s.length), H[a] ? (s ? u(t).empty = !1 : u(t).unusedTokens.push(a), r = a, c = t, null != (l = s) && d(ht, r) && ht[r](l, c._a, c, r)) : t._strict && !s && u(t).unusedTokens.push(a);
					u(t).charsLeftOver = p - f, 0 < h.length && u(t).unusedInput.push(h), t._a[vt] <= 12 && !0 === u(t).bigHour && 0 < t._a[vt] && (u(t).bigHour = void 0), u(t).parsedDateParts = t._a.slice(0), u(t).meridiem = t._meridiem, t._a[vt] = function(t, e, i) {
						var s;
						return null == i ? e : null != t.meridiemHour ? t.meridiemHour(e, i) : (null != t.isPM && ((s = t.isPM(i)) && e < 12 && (e += 12), s || 12 !== e || (e = 0)), e)
					}(t._locale, t._a[vt], t._meridiem), ue(t), ce(t)
				} else xe(t);
			else be(t)
		}

		function Ce(t) {
			var e, d, h, m, v = t._i,
				w = t._f;
			return t._locale = t._locale || de(t._l), null === v || void 0 === w && "" === v ? f({
				nullInput: !0
			}) : ("string" == typeof v && (t._i = v = t._locale.preparse(v)), b(v) ? new y(ce(v)) : (r(v) ? t._d = v : s(w) ? function(t) {
				var e, i, s, n, a;
				if (0 === t._f.length) return u(t).invalidFormat = !0, t._d = new Date(NaN);
				for (n = 0; n < t._f.length; n++) a = 0, e = g({}, t), null != t._useUTC && (e._useUTC = t._useUTC), e._f = t._f[n], Te(e), p(e) && (a += u(e).charsLeftOver, a += 10 * u(e).unusedTokens.length, u(e).score = a, (null == s || a < s) && (s = a, i = e));
				c(t, i || e)
			}(t) : w ? Te(t) : a(d = (e = t)._i) ? e._d = new Date(i.now()) : r(d) ? e._d = new Date(d.valueOf()) : "string" == typeof d ? (h = e, null === (m = ye.exec(h._i)) ? (be(h), !1 === h._isValid && (delete h._isValid, xe(h), !1 === h._isValid && (delete h._isValid, i.createFromInputFallback(h)))) : h._d = new Date(+m[1])) : s(d) ? (e._a = l(d.slice(0), function(t) {
				return parseInt(t, 10)
			}), ue(e)) : n(d) ? function(t) {
				if (!t._d) {
					var e = A(t._i);
					t._a = l([e.year, e.month, e.day || e.date, e.hour, e.minute, e.second, e.millisecond], function(t) {
						return t && parseInt(t, 10)
					}), ue(t)
				}
			}(e) : o(d) ? e._d = new Date(d) : i.createFromInputFallback(e), p(t) || (t._d = null), t))
		}

		function _e(t, e, i, a, o) {
			var r, l = {};
			return !0 !== i && !1 !== i || (a = i, i = void 0), (n(t) && function(t) {
				if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(t).length;
				var e;
				for (e in t)
					if (t.hasOwnProperty(e)) return !1;
				return !0
			}(t) || s(t) && 0 === t.length) && (t = void 0), l._isAMomentObject = !0, l._useUTC = l._isUTC = o, l._l = i, l._i = t, l._f = e, l._strict = a, (r = new y(ce(Ce(l))))._nextDay && (r.add(1, "d"), r._nextDay = void 0), r
		}

		function Ee(t, e, i, s) {
			return _e(t, e, i, s, !1)
		}
		i.createFromInputFallback = C("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(t) {
			t._d = new Date(t._i + (t._useUTC ? " UTC" : ""))
		}), i.ISO_8601 = function() {}, i.RFC_2822 = function() {};
		var Pe = C("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
				var t = Ee.apply(null, arguments);
				return this.isValid() && t.isValid() ? t < this ? this : t : f()
			}),
			ke = C("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
				var t = Ee.apply(null, arguments);
				return this.isValid() && t.isValid() ? this < t ? this : t : f()
			});

		function $e(t, e) {
			var i, n;
			if (1 === e.length && s(e[0]) && (e = e[0]), !e.length) return Ee();
			for (i = e[0], n = 1; n < e.length; ++n) e[n].isValid() && !e[n][t](i) || (i = e[n]);
			return i
		}
		var Me = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];

		function De(t) {
			var e = A(t),
				i = e.year || 0,
				s = e.quarter || 0,
				n = e.month || 0,
				a = e.week || 0,
				o = e.day || 0,
				r = e.hour || 0,
				l = e.minute || 0,
				d = e.second || 0,
				c = e.millisecond || 0;
			this._isValid = function(t) {
				for (var e in t)
					if (-1 === _t.call(Me, e) || null != t[e] && isNaN(t[e])) return !1;
				for (var i = !1, s = 0; s < Me.length; ++s)
					if (t[Me[s]]) {
						if (i) return !1;
						parseFloat(t[Me[s]]) !== S(t[Me[s]]) && (i = !0)
					} return !0
			}(e), this._milliseconds = +c + 1e3 * d + 6e4 * l + 1e3 * r * 60 * 60, this._days = +o + 7 * a, this._months = +n + 3 * s + 12 * i, this._data = {}, this._locale = de(), this._bubble()
		}

		function Oe(t) {
			return t instanceof De
		}

		function ze(t) {
			return t < 0 ? -1 * Math.round(-1 * t) : Math.round(t)
		}

		function Ae(t, e) {
			B(t, 0, 0, function() {
				var t = this.utcOffset(),
					i = "+";
				return t < 0 && (t = -t, i = "-"), i + N(~~(t / 60), 2) + e + N(~~t % 60, 2)
			})
		}
		Ae("Z", ":"), Ae("ZZ", ""), lt("Z", at), lt("ZZ", at), ut(["Z", "ZZ"], function(t, e, i) {
			i._useUTC = !0, i._tzm = Le(at, t)
		});
		var Ie = /([\+\-]|\d\d)/gi;

		function Le(t, e) {
			var i = (e || "").match(t);
			if (null === i) return null;
			var s = ((i[i.length - 1] || []) + "").match(Ie) || ["-", 0, 0],
				n = 60 * s[1] + S(s[2]);
			return 0 === n ? 0 : "+" === s[0] ? n : -n
		}

		function Ne(t, e) {
			var s, n;
			return e._isUTC ? (s = e.clone(), n = (b(t) || r(t) ? t.valueOf() : Ee(t).valueOf()) - s.valueOf(), s._d.setTime(s._d.valueOf() + n), i.updateOffset(s, !1), s) : Ee(t).local()
		}

		function Ye(t) {
			return 15 * -Math.round(t._d.getTimezoneOffset() / 15)
		}

		function Re() {
			return !!this.isValid() && this._isUTC && 0 === this._offset
		}
		i.updateOffset = function() {};
		var je = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/,
			He = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

		function Be(t, e) {
			var i, s, n, a = t,
				r = null;
			return Oe(t) ? a = {
				ms: t._milliseconds,
				d: t._days,
				M: t._months
			} : o(t) ? (a = {}, e ? a[e] = t : a.milliseconds = t) : (r = je.exec(t)) ? (i = "-" === r[1] ? -1 : 1, a = {
				y: 0,
				d: S(r[gt]) * i,
				h: S(r[vt]) * i,
				m: S(r[yt]) * i,
				s: S(r[bt]) * i,
				ms: S(ze(1e3 * r[wt])) * i
			}) : (r = He.exec(t)) ? (i = "-" === r[1] ? -1 : (r[1], 1), a = {
				y: Fe(r[2], i),
				M: Fe(r[3], i),
				w: Fe(r[4], i),
				d: Fe(r[5], i),
				h: Fe(r[6], i),
				m: Fe(r[7], i),
				s: Fe(r[8], i)
			}) : null == a ? a = {} : "object" == typeof a && ("from" in a || "to" in a) && (n = function(t, e) {
				var i;
				return t.isValid() && e.isValid() ? (e = Ne(e, t), t.isBefore(e) ? i = We(t, e) : ((i = We(e, t)).milliseconds = -i.milliseconds, i.months = -i.months), i) : {
					milliseconds: 0,
					months: 0
				}
			}(Ee(a.from), Ee(a.to)), (a = {}).ms = n.milliseconds, a.M = n.months), s = new De(a), Oe(t) && d(t, "_locale") && (s._locale = t._locale), s
		}

		function Fe(t, e) {
			var i = t && parseFloat(t.replace(",", "."));
			return (isNaN(i) ? 0 : i) * e
		}

		function We(t, e) {
			var i = {
				milliseconds: 0,
				months: 0
			};
			return i.months = e.month() - t.month() + 12 * (e.year() - t.year()), t.clone().add(i.months, "M").isAfter(e) && --i.months, i.milliseconds = +e - +t.clone().add(i.months, "M"), i
		}

		function Ve(t, e) {
			return function(i, s) {
				var n;
				return null === s || isNaN(+s) || (P(e, "moment()." + e + "(period, number) is deprecated. Please use moment()." + e + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), n = i, i = s, s = n), qe(this, Be(i = "string" == typeof i ? +i : i, s), t), this
			}
		}

		function qe(t, e, s, n) {
			var a = e._milliseconds,
				o = ze(e._days),
				r = ze(e._months);
			t.isValid() && (n = null == n || n, r && At(t, kt(t, "Month") + r * s), o && $t(t, "Date", kt(t, "Date") + o * s), a && t._d.setTime(t._d.valueOf() + a * s), n && i.updateOffset(t, o || r))
		}
		Be.fn = De.prototype, Be.invalid = function() {
			return Be(NaN)
		};
		var Ue = Ve(1, "add"),
			Ge = Ve(-1, "subtract");

		function Xe(t, e) {
			var i = 12 * (e.year() - t.year()) + (e.month() - t.month()),
				s = t.clone().add(i, "months");
			return -(i + (e - s < 0 ? (e - s) / (s - t.clone().add(i - 1, "months")) : (e - s) / (t.clone().add(i + 1, "months") - s))) || 0
		}

		function Qe(t) {
			var e;
			return void 0 === t ? this._locale._abbr : (null != (e = de(t)) && (this._locale = e), this)
		}
		i.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", i.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
		var Ze = C("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(t) {
			return void 0 === t ? this.localeData() : this.locale(t)
		});

		function Ke() {
			return this._locale
		}

		function Je(t, e) {
			B(0, [t, t.length], 0, e)
		}

		function ti(t, e, i, s, n) {
			var a;
			return null == t ? Bt(this, s, n).year : ((a = Ft(t, s, n)) < e && (e = a), function(t, e, i, s, n) {
				var a = Ht(t, e, i, s, n),
					o = Rt(a.year, 0, a.dayOfYear);
				return this.year(o.getUTCFullYear()), this.month(o.getUTCMonth()), this.date(o.getUTCDate()), this
			}.call(this, t, e, i, s, n))
		}
		B(0, ["gg", 2], 0, function() {
			return this.weekYear() % 100
		}), B(0, ["GG", 2], 0, function() {
			return this.isoWeekYear() % 100
		}), Je("gggg", "weekYear"), Je("ggggg", "weekYear"), Je("GGGG", "isoWeekYear"), Je("GGGGG", "isoWeekYear"), O("weekYear", "gg"), O("isoWeekYear", "GG"), L("weekYear", 1), L("isoWeekYear", 1), lt("G", st), lt("g", st), lt("GG", Q, q), lt("gg", Q, q), lt("GGGG", tt, G), lt("gggg", tt, G), lt("GGGGG", et, X), lt("ggggg", et, X), pt(["gggg", "ggggg", "GGGG", "GGGGG"], function(t, e, i, s) {
			e[s.substr(0, 2)] = S(t)
		}), pt(["gg", "GG"], function(t, e, s, n) {
			e[n] = i.parseTwoDigitYear(t)
		}), B("Q", 0, "Qo", "quarter"), O("quarter", "Q"), L("quarter", 7), lt("Q", V), ut("Q", function(t, e) {
			e[mt] = 3 * (S(t) - 1)
		}), B("D", ["DD", 2], "Do", "date"), O("date", "D"), L("date", 9), lt("D", Q), lt("DD", Q, q), lt("Do", function(t, e) {
			return t ? e._dayOfMonthOrdinalParse || e._ordinalParse : e._dayOfMonthOrdinalParseLenient
		}), ut(["D", "DD"], gt), ut("Do", function(t, e) {
			e[gt] = S(t.match(Q)[0])
		});
		var ei = Pt("Date", !0);
		B("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), O("dayOfYear", "DDD"), L("dayOfYear", 4), lt("DDD", J), lt("DDDD", U), ut(["DDD", "DDDD"], function(t, e, i) {
			i._dayOfYear = S(t)
		}), B("m", ["mm", 2], 0, "minute"), O("minute", "m"), L("minute", 14), lt("m", Q), lt("mm", Q, q), ut(["m", "mm"], yt);
		var ii = Pt("Minutes", !1);
		B("s", ["ss", 2], 0, "second"), O("second", "s"), L("second", 15), lt("s", Q), lt("ss", Q, q), ut(["s", "ss"], bt);
		var si, ni = Pt("Seconds", !1);
		for (B("S", 0, 0, function() {
				return ~~(this.millisecond() / 100)
			}), B(0, ["SS", 2], 0, function() {
				return ~~(this.millisecond() / 10)
			}), B(0, ["SSS", 3], 0, "millisecond"), B(0, ["SSSS", 4], 0, function() {
				return 10 * this.millisecond()
			}), B(0, ["SSSSS", 5], 0, function() {
				return 100 * this.millisecond()
			}), B(0, ["SSSSSS", 6], 0, function() {
				return 1e3 * this.millisecond()
			}), B(0, ["SSSSSSS", 7], 0, function() {
				return 1e4 * this.millisecond()
			}), B(0, ["SSSSSSSS", 8], 0, function() {
				return 1e5 * this.millisecond()
			}), B(0, ["SSSSSSSSS", 9], 0, function() {
				return 1e6 * this.millisecond()
			}), O("millisecond", "ms"), L("millisecond", 16), lt("S", J, V), lt("SS", J, q), lt("SSS", J, U), si = "SSSS"; si.length <= 9; si += "S") lt(si, it);

		function ai(t, e) {
			e[wt] = S(1e3 * ("0." + t))
		}
		for (si = "S"; si.length <= 9; si += "S") ut(si, ai);
		var oi = Pt("Milliseconds", !1);
		B("z", 0, 0, "zoneAbbr"), B("zz", 0, 0, "zoneName");
		var ri = y.prototype;

		function li(t) {
			return t
		}
		ri.add = Ue, ri.calendar = function(t, e) {
			var s = t || Ee(),
				n = Ne(s, this).startOf("day"),
				a = i.calendarFormat(this, n) || "sameElse",
				o = e && (k(e[a]) ? e[a].call(this, s) : e[a]);
			return this.format(o || this.localeData().calendar(a, this, Ee(s)))
		}, ri.clone = function() {
			return new y(this)
		}, ri.diff = function(t, e, i) {
			var s, n, a;
			if (!this.isValid()) return NaN;
			if (!(s = Ne(t, this)).isValid()) return NaN;
			switch (n = 6e4 * (s.utcOffset() - this.utcOffset()), e = z(e)) {
				case "year":
					a = Xe(this, s) / 12;
					break;
				case "month":
					a = Xe(this, s);
					break;
				case "quarter":
					a = Xe(this, s) / 3;
					break;
				case "second":
					a = (this - s) / 1e3;
					break;
				case "minute":
					a = (this - s) / 6e4;
					break;
				case "hour":
					a = (this - s) / 36e5;
					break;
				case "day":
					a = (this - s - n) / 864e5;
					break;
				case "week":
					a = (this - s - n) / 6048e5;
					break;
				default:
					a = this - s
			}
			return i ? a : w(a)
		}, ri.endOf = function(t) {
			return void 0 === (t = z(t)) || "millisecond" === t ? this : ("date" === t && (t = "day"), this.startOf(t).add(1, "isoWeek" === t ? "week" : t).subtract(1, "ms"))
		}, ri.format = function(t) {
			t || (t = this.isUtc() ? i.defaultFormatUtc : i.defaultFormat);
			var e = F(this, t);
			return this.localeData().postformat(e)
		}, ri.from = function(t, e) {
			return this.isValid() && (b(t) && t.isValid() || Ee(t).isValid()) ? Be({
				to: this,
				from: t
			}).locale(this.locale()).humanize(!e) : this.localeData().invalidDate()
		}, ri.fromNow = function(t) {
			return this.from(Ee(), t)
		}, ri.to = function(t, e) {
			return this.isValid() && (b(t) && t.isValid() || Ee(t).isValid()) ? Be({
				from: this,
				to: t
			}).locale(this.locale()).humanize(!e) : this.localeData().invalidDate()
		}, ri.toNow = function(t) {
			return this.to(Ee(), t)
		}, ri.get = function(t) {
			return k(this[t = z(t)]) ? this[t]() : this
		}, ri.invalidAt = function() {
			return u(this).overflow
		}, ri.isAfter = function(t, e) {
			var i = b(t) ? t : Ee(t);
			return !(!this.isValid() || !i.isValid()) && ("millisecond" === (e = z(a(e) ? "millisecond" : e)) ? this.valueOf() > i.valueOf() : i.valueOf() < this.clone().startOf(e).valueOf())
		}, ri.isBefore = function(t, e) {
			var i = b(t) ? t : Ee(t);
			return !(!this.isValid() || !i.isValid()) && ("millisecond" === (e = z(a(e) ? "millisecond" : e)) ? this.valueOf() < i.valueOf() : this.clone().endOf(e).valueOf() < i.valueOf())
		}, ri.isBetween = function(t, e, i, s) {
			return ("(" === (s = s || "()")[0] ? this.isAfter(t, i) : !this.isBefore(t, i)) && (")" === s[1] ? this.isBefore(e, i) : !this.isAfter(e, i))
		}, ri.isSame = function(t, e) {
			var i, s = b(t) ? t : Ee(t);
			return !(!this.isValid() || !s.isValid()) && ("millisecond" === (e = z(e || "millisecond")) ? this.valueOf() === s.valueOf() : (i = s.valueOf(), this.clone().startOf(e).valueOf() <= i && i <= this.clone().endOf(e).valueOf()))
		}, ri.isSameOrAfter = function(t, e) {
			return this.isSame(t, e) || this.isAfter(t, e)
		}, ri.isSameOrBefore = function(t, e) {
			return this.isSame(t, e) || this.isBefore(t, e)
		}, ri.isValid = function() {
			return p(this)
		}, ri.lang = Ze, ri.locale = Qe, ri.localeData = Ke, ri.max = ke, ri.min = Pe, ri.parsingFlags = function() {
			return c({}, u(this))
		}, ri.set = function(t, e) {
			if ("object" == typeof t)
				for (var i = function(t) {
						var e = [];
						for (var i in t) e.push({
							unit: i,
							priority: I[i]
						});
						return e.sort(function(t, e) {
							return t.priority - e.priority
						}), e
					}(t = A(t)), s = 0; s < i.length; s++) this[i[s].unit](t[i[s].unit]);
			else if (k(this[t = z(t)])) return this[t](e);
			return this
		}, ri.startOf = function(t) {
			switch (t = z(t)) {
				case "year":
					this.month(0);
				case "quarter":
				case "month":
					this.date(1);
				case "week":
				case "isoWeek":
				case "day":
				case "date":
					this.hours(0);
				case "hour":
					this.minutes(0);
				case "minute":
					this.seconds(0);
				case "second":
					this.milliseconds(0)
			}
			return "week" === t && this.weekday(0), "isoWeek" === t && this.isoWeekday(1), "quarter" === t && this.month(3 * Math.floor(this.month() / 3)), this
		}, ri.subtract = Ge, ri.toArray = function() {
			var t = this;
			return [t.year(), t.month(), t.date(), t.hour(), t.minute(), t.second(), t.millisecond()]
		}, ri.toObject = function() {
			var t = this;
			return {
				years: t.year(),
				months: t.month(),
				date: t.date(),
				hours: t.hours(),
				minutes: t.minutes(),
				seconds: t.seconds(),
				milliseconds: t.milliseconds()
			}
		}, ri.toDate = function() {
			return new Date(this.valueOf())
		}, ri.toISOString = function(t) {
			if (!this.isValid()) return null;
			var e = !0 !== t,
				i = e ? this.clone().utc() : this;
			return i.year() < 0 || 9999 < i.year() ? F(i, e ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : k(Date.prototype.toISOString) ? e ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", F(i, "Z")) : F(i, e ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ")
		}, ri.inspect = function() {
			if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
			var t = "moment",
				e = "";
			this.isLocal() || (t = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", e = "Z");
			var i = "[" + t + '("]',
				s = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY",
				n = e + '[")]';
			return this.format(i + s + "-MM-DD[T]HH:mm:ss.SSS" + n)
		}, ri.toJSON = function() {
			return this.isValid() ? this.toISOString() : null
		}, ri.toString = function() {
			return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")
		}, ri.unix = function() {
			return Math.floor(this.valueOf() / 1e3)
		}, ri.valueOf = function() {
			return this._d.valueOf() - 6e4 * (this._offset || 0)
		}, ri.creationData = function() {
			return {
				input: this._i,
				format: this._f,
				locale: this._locale,
				isUTC: this._isUTC,
				strict: this._strict
			}
		}, ri.year = Et, ri.isLeapYear = function() {
			return Ct(this.year())
		}, ri.weekYear = function(t) {
			return ti.call(this, t, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy)
		}, ri.isoWeekYear = function(t) {
			return ti.call(this, t, this.isoWeek(), this.isoWeekday(), 1, 4)
		}, ri.quarter = ri.quarters = function(t) {
			return null == t ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (t - 1) + this.month() % 3)
		}, ri.month = It, ri.daysInMonth = function() {
			return Mt(this.year(), this.month())
		}, ri.week = ri.weeks = function(t) {
			var e = this.localeData().week(this);
			return null == t ? e : this.add(7 * (t - e), "d")
		}, ri.isoWeek = ri.isoWeeks = function(t) {
			var e = Bt(this, 1, 4).week;
			return null == t ? e : this.add(7 * (t - e), "d")
		}, ri.weeksInYear = function() {
			var t = this.localeData()._week;
			return Ft(this.year(), t.dow, t.doy)
		}, ri.isoWeeksInYear = function() {
			return Ft(this.year(), 1, 4)
		}, ri.date = ei, ri.day = ri.days = function(t) {
			if (!this.isValid()) return null != t ? this : NaN;
			var e, i, s = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
			return null != t ? (e = t, i = this.localeData(), t = "string" != typeof e ? e : isNaN(e) ? "number" == typeof(e = i.weekdaysParse(e)) ? e : null : parseInt(e, 10), this.add(t - s, "d")) : s
		}, ri.weekday = function(t) {
			if (!this.isValid()) return null != t ? this : NaN;
			var e = (this.day() + 7 - this.localeData()._week.dow) % 7;
			return null == t ? e : this.add(t - e, "d")
		}, ri.isoWeekday = function(t) {
			if (!this.isValid()) return null != t ? this : NaN;
			if (null != t) {
				var e = (i = t, s = this.localeData(), "string" == typeof i ? s.weekdaysParse(i) % 7 || 7 : isNaN(i) ? null : i);
				return this.day(this.day() % 7 ? e : e - 7)
			}
			return this.day() || 7;
			var i, s
		}, ri.dayOfYear = function(t) {
			var e = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
			return null == t ? e : this.add(t - e, "d")
		}, ri.hour = ri.hours = ee, ri.minute = ri.minutes = ii, ri.second = ri.seconds = ni, ri.millisecond = ri.milliseconds = oi, ri.utcOffset = function(t, e, s) {
			var n, a = this._offset || 0;
			if (!this.isValid()) return null != t ? this : NaN;
			if (null != t) {
				if ("string" == typeof t) {
					if (null === (t = Le(at, t))) return this
				} else Math.abs(t) < 16 && !s && (t *= 60);
				return !this._isUTC && e && (n = Ye(this)), this._offset = t, this._isUTC = !0, null != n && this.add(n, "m"), a !== t && (!e || this._changeInProgress ? qe(this, Be(t - a, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, i.updateOffset(this, !0), this._changeInProgress = null)), this
			}
			return this._isUTC ? a : Ye(this)
		}, ri.utc = function(t) {
			return this.utcOffset(0, t)
		}, ri.local = function(t) {
			return this._isUTC && (this.utcOffset(0, t), this._isUTC = !1, t && this.subtract(Ye(this), "m")), this
		}, ri.parseZone = function() {
			if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);
			else if ("string" == typeof this._i) {
				var t = Le(nt, this._i);
				null != t ? this.utcOffset(t) : this.utcOffset(0, !0)
			}
			return this
		}, ri.hasAlignedHourOffset = function(t) {
			return !!this.isValid() && (t = t ? Ee(t).utcOffset() : 0, (this.utcOffset() - t) % 60 == 0)
		}, ri.isDST = function() {
			return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset()
		}, ri.isLocal = function() {
			return !!this.isValid() && !this._isUTC
		}, ri.isUtcOffset = function() {
			return !!this.isValid() && this._isUTC
		}, ri.isUtc = Re, ri.isUTC = Re, ri.zoneAbbr = function() {
			return this._isUTC ? "UTC" : ""
		}, ri.zoneName = function() {
			return this._isUTC ? "Coordinated Universal Time" : ""
		}, ri.dates = C("dates accessor is deprecated. Use date instead.", ei), ri.months = C("months accessor is deprecated. Use month instead", It), ri.years = C("years accessor is deprecated. Use year instead", Et), ri.zone = C("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", function(t, e) {
			return null != t ? ("string" != typeof t && (t = -t), this.utcOffset(t, e), this) : -this.utcOffset()
		}), ri.isDSTShifted = C("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", function() {
			if (!a(this._isDSTShifted)) return this._isDSTShifted;
			var t = {};
			if (g(t, this), (t = Ce(t))._a) {
				var e = t._isUTC ? h(t._a) : Ee(t._a);
				this._isDSTShifted = this.isValid() && 0 < x(t._a, e.toArray())
			} else this._isDSTShifted = !1;
			return this._isDSTShifted
		});
		var di = M.prototype;

		function ci(t, e, i, s) {
			var n = de(),
				a = h().set(s, e);
			return n[i](a, t)
		}

		function hi(t, e, i) {
			if (o(t) && (e = t, t = void 0), t = t || "", null != e) return ci(t, e, i, "month");
			var s, n = [];
			for (s = 0; s < 12; s++) n[s] = ci(t, s, i, "month");
			return n
		}

		function ui(t, e, i, s) {
			"boolean" == typeof t ? o(e) && (i = e, e = void 0) : (e = t, t = !1, o(i = e) && (i = e, e = void 0)), e = e || "";
			var n, a = de(),
				r = t ? a._week.dow : 0;
			if (null != i) return ci(e, (i + r) % 7, s, "day");
			var l = [];
			for (n = 0; n < 7; n++) l[n] = ci(e, (n + r) % 7, s, "day");
			return l
		}
		di.calendar = function(t, e, i) {
			var s = this._calendar[t] || this._calendar.sameElse;
			return k(s) ? s.call(e, i) : s
		}, di.longDateFormat = function(t) {
			var e = this._longDateFormat[t],
				i = this._longDateFormat[t.toUpperCase()];
			return e || !i ? e : (this._longDateFormat[t] = i.replace(/MMMM|MM|DD|dddd/g, function(t) {
				return t.slice(1)
			}), this._longDateFormat[t])
		}, di.invalidDate = function() {
			return this._invalidDate
		}, di.ordinal = function(t) {
			return this._ordinal.replace("%d", t)
		}, di.preparse = li, di.postformat = li, di.relativeTime = function(t, e, i, s) {
			var n = this._relativeTime[i];
			return k(n) ? n(t, e, i, s) : n.replace(/%d/i, t)
		}, di.pastFuture = function(t, e) {
			var i = this._relativeTime[0 < t ? "future" : "past"];
			return k(i) ? i(e) : i.replace(/%s/i, e)
		}, di.set = function(t) {
			var e, i;
			for (i in t) k(e = t[i]) ? this[i] = e : this["_" + i] = e;
			this._config = t, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source)
		}, di.months = function(t, e) {
			return t ? s(this._months) ? this._months[t.month()] : this._months[(this._months.isFormat || Dt).test(e) ? "format" : "standalone"][t.month()] : s(this._months) ? this._months : this._months.standalone
		}, di.monthsShort = function(t, e) {
			return t ? s(this._monthsShort) ? this._monthsShort[t.month()] : this._monthsShort[Dt.test(e) ? "format" : "standalone"][t.month()] : s(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone
		}, di.monthsParse = function(t, e, i) {
			var s, n, a;
			if (this._monthsParseExact) return function(t, e, i) {
				var s, n, a, o = t.toLocaleLowerCase();
				if (!this._monthsParse)
					for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], s = 0; s < 12; ++s) a = h([2e3, s]), this._shortMonthsParse[s] = this.monthsShort(a, "").toLocaleLowerCase(), this._longMonthsParse[s] = this.months(a, "").toLocaleLowerCase();
				return i ? "MMM" === e ? -1 !== (n = _t.call(this._shortMonthsParse, o)) ? n : null : -1 !== (n = _t.call(this._longMonthsParse, o)) ? n : null : "MMM" === e ? -1 !== (n = _t.call(this._shortMonthsParse, o)) ? n : -1 !== (n = _t.call(this._longMonthsParse, o)) ? n : null : -1 !== (n = _t.call(this._longMonthsParse, o)) ? n : -1 !== (n = _t.call(this._shortMonthsParse, o)) ? n : null
			}.call(this, t, e, i);
			for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), s = 0; s < 12; s++) {
				if (n = h([2e3, s]), i && !this._longMonthsParse[s] && (this._longMonthsParse[s] = new RegExp("^" + this.months(n, "").replace(".", "") + "$", "i"), this._shortMonthsParse[s] = new RegExp("^" + this.monthsShort(n, "").replace(".", "") + "$", "i")), i || this._monthsParse[s] || (a = "^" + this.months(n, "") + "|^" + this.monthsShort(n, ""), this._monthsParse[s] = new RegExp(a.replace(".", ""), "i")), i && "MMMM" === e && this._longMonthsParse[s].test(t)) return s;
				if (i && "MMM" === e && this._shortMonthsParse[s].test(t)) return s;
				if (!i && this._monthsParse[s].test(t)) return s
			}
		}, di.monthsRegex = function(t) {
			return this._monthsParseExact ? (d(this, "_monthsRegex") || Yt.call(this), t ? this._monthsStrictRegex : this._monthsRegex) : (d(this, "_monthsRegex") || (this._monthsRegex = Nt), this._monthsStrictRegex && t ? this._monthsStrictRegex : this._monthsRegex)
		}, di.monthsShortRegex = function(t) {
			return this._monthsParseExact ? (d(this, "_monthsRegex") || Yt.call(this), t ? this._monthsShortStrictRegex : this._monthsShortRegex) : (d(this, "_monthsShortRegex") || (this._monthsShortRegex = Lt), this._monthsShortStrictRegex && t ? this._monthsShortStrictRegex : this._monthsShortRegex)
		}, di.week = function(t) {
			return Bt(t, this._week.dow, this._week.doy).week
		}, di.firstDayOfYear = function() {
			return this._week.doy
		}, di.firstDayOfWeek = function() {
			return this._week.dow
		}, di.weekdays = function(t, e) {
			return t ? s(this._weekdays) ? this._weekdays[t.day()] : this._weekdays[this._weekdays.isFormat.test(e) ? "format" : "standalone"][t.day()] : s(this._weekdays) ? this._weekdays : this._weekdays.standalone
		}, di.weekdaysMin = function(t) {
			return t ? this._weekdaysMin[t.day()] : this._weekdaysMin
		}, di.weekdaysShort = function(t) {
			return t ? this._weekdaysShort[t.day()] : this._weekdaysShort
		}, di.weekdaysParse = function(t, e, i) {
			var s, n, a;
			if (this._weekdaysParseExact) return function(t, e, i) {
				var s, n, a, o = t.toLocaleLowerCase();
				if (!this._weekdaysParse)
					for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], s = 0; s < 7; ++s) a = h([2e3, 1]).day(s), this._minWeekdaysParse[s] = this.weekdaysMin(a, "").toLocaleLowerCase(), this._shortWeekdaysParse[s] = this.weekdaysShort(a, "").toLocaleLowerCase(), this._weekdaysParse[s] = this.weekdays(a, "").toLocaleLowerCase();
				return i ? "dddd" === e ? -1 !== (n = _t.call(this._weekdaysParse, o)) ? n : null : "ddd" === e ? -1 !== (n = _t.call(this._shortWeekdaysParse, o)) ? n : null : -1 !== (n = _t.call(this._minWeekdaysParse, o)) ? n : null : "dddd" === e ? -1 !== (n = _t.call(this._weekdaysParse, o)) ? n : -1 !== (n = _t.call(this._shortWeekdaysParse, o)) ? n : -1 !== (n = _t.call(this._minWeekdaysParse, o)) ? n : null : "ddd" === e ? -1 !== (n = _t.call(this._shortWeekdaysParse, o)) ? n : -1 !== (n = _t.call(this._weekdaysParse, o)) ? n : -1 !== (n = _t.call(this._minWeekdaysParse, o)) ? n : null : -1 !== (n = _t.call(this._minWeekdaysParse, o)) ? n : -1 !== (n = _t.call(this._weekdaysParse, o)) ? n : -1 !== (n = _t.call(this._shortWeekdaysParse, o)) ? n : null
			}.call(this, t, e, i);
			for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), s = 0; s < 7; s++) {
				if (n = h([2e3, 1]).day(s), i && !this._fullWeekdaysParse[s] && (this._fullWeekdaysParse[s] = new RegExp("^" + this.weekdays(n, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[s] = new RegExp("^" + this.weekdaysShort(n, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[s] = new RegExp("^" + this.weekdaysMin(n, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[s] || (a = "^" + this.weekdays(n, "") + "|^" + this.weekdaysShort(n, "") + "|^" + this.weekdaysMin(n, ""), this._weekdaysParse[s] = new RegExp(a.replace(".", ""), "i")), i && "dddd" === e && this._fullWeekdaysParse[s].test(t)) return s;
				if (i && "ddd" === e && this._shortWeekdaysParse[s].test(t)) return s;
				if (i && "dd" === e && this._minWeekdaysParse[s].test(t)) return s;
				if (!i && this._weekdaysParse[s].test(t)) return s
			}
		}, di.weekdaysRegex = function(t) {
			return this._weekdaysParseExact ? (d(this, "_weekdaysRegex") || Qt.call(this), t ? this._weekdaysStrictRegex : this._weekdaysRegex) : (d(this, "_weekdaysRegex") || (this._weekdaysRegex = Ut), this._weekdaysStrictRegex && t ? this._weekdaysStrictRegex : this._weekdaysRegex)
		}, di.weekdaysShortRegex = function(t) {
			return this._weekdaysParseExact ? (d(this, "_weekdaysRegex") || Qt.call(this), t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (d(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Gt), this._weekdaysShortStrictRegex && t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex)
		}, di.weekdaysMinRegex = function(t) {
			return this._weekdaysParseExact ? (d(this, "_weekdaysRegex") || Qt.call(this), t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (d(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Xt), this._weekdaysMinStrictRegex && t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex)
		}, di.isPM = function(t) {
			return "p" === (t + "").toLowerCase().charAt(0)
		}, di.meridiem = function(t, e, i) {
			return 11 < t ? i ? "pm" : "PM" : i ? "am" : "AM"
		}, re("en", {
			dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
			ordinal: function(t) {
				var e = t % 10;
				return t + (1 === S(t % 100 / 10) ? "th" : 1 === e ? "st" : 2 === e ? "nd" : 3 === e ? "rd" : "th")
			}
		}), i.lang = C("moment.lang is deprecated. Use moment.locale instead.", re), i.langData = C("moment.langData is deprecated. Use moment.localeData instead.", de);
		var pi = Math.abs;

		function fi(t, e, i, s) {
			var n = Be(e, i);
			return t._milliseconds += s * n._milliseconds, t._days += s * n._days, t._months += s * n._months, t._bubble()
		}

		function mi(t) {
			return t < 0 ? Math.floor(t) : Math.ceil(t)
		}

		function gi(t) {
			return 4800 * t / 146097
		}

		function vi(t) {
			return 146097 * t / 4800
		}

		function yi(t) {
			return function() {
				return this.as(t)
			}
		}
		var bi = yi("ms"),
			wi = yi("s"),
			Si = yi("m"),
			xi = yi("h"),
			Ti = yi("d"),
			Ci = yi("w"),
			_i = yi("M"),
			Ei = yi("y");

		function Pi(t) {
			return function() {
				return this.isValid() ? this._data[t] : NaN
			}
		}
		var ki = Pi("milliseconds"),
			$i = Pi("seconds"),
			Mi = Pi("minutes"),
			Di = Pi("hours"),
			Oi = Pi("days"),
			zi = Pi("months"),
			Ai = Pi("years"),
			Ii = Math.round,
			Li = {
				ss: 44,
				s: 45,
				m: 45,
				h: 22,
				d: 26,
				M: 11
			},
			Ni = Math.abs;

		function Yi(t) {
			return (0 < t) - (t < 0) || +t
		}

		function Ri() {
			if (!this.isValid()) return this.localeData().invalidDate();
			var t, e, i = Ni(this._milliseconds) / 1e3,
				s = Ni(this._days),
				n = Ni(this._months);
			e = w((t = w(i / 60)) / 60), i %= 60, t %= 60;
			var a = w(n / 12),
				o = n %= 12,
				r = s,
				l = e,
				d = t,
				c = i ? i.toFixed(3).replace(/\.?0+$/, "") : "",
				h = this.asSeconds();
			if (!h) return "P0D";
			var u = h < 0 ? "-" : "",
				p = Yi(this._months) !== Yi(h) ? "-" : "",
				f = Yi(this._days) !== Yi(h) ? "-" : "",
				m = Yi(this._milliseconds) !== Yi(h) ? "-" : "";
			return u + "P" + (a ? p + a + "Y" : "") + (o ? p + o + "M" : "") + (r ? f + r + "D" : "") + (l || d || c ? "T" : "") + (l ? m + l + "H" : "") + (d ? m + d + "M" : "") + (c ? m + c + "S" : "")
		}
		var ji = De.prototype;
		return ji.isValid = function() {
			return this._isValid
		}, ji.abs = function() {
			var t = this._data;
			return this._milliseconds = pi(this._milliseconds), this._days = pi(this._days), this._months = pi(this._months), t.milliseconds = pi(t.milliseconds), t.seconds = pi(t.seconds), t.minutes = pi(t.minutes), t.hours = pi(t.hours), t.months = pi(t.months), t.years = pi(t.years), this
		}, ji.add = function(t, e) {
			return fi(this, t, e, 1)
		}, ji.subtract = function(t, e) {
			return fi(this, t, e, -1)
		}, ji.as = function(t) {
			if (!this.isValid()) return NaN;
			var e, i, s = this._milliseconds;
			if ("month" === (t = z(t)) || "year" === t) return e = this._days + s / 864e5, i = this._months + gi(e), "month" === t ? i : i / 12;
			switch (e = this._days + Math.round(vi(this._months)), t) {
				case "week":
					return e / 7 + s / 6048e5;
				case "day":
					return e + s / 864e5;
				case "hour":
					return 24 * e + s / 36e5;
				case "minute":
					return 1440 * e + s / 6e4;
				case "second":
					return 86400 * e + s / 1e3;
				case "millisecond":
					return Math.floor(864e5 * e) + s;
				default:
					throw new Error("Unknown unit " + t)
			}
		}, ji.asMilliseconds = bi, ji.asSeconds = wi, ji.asMinutes = Si, ji.asHours = xi, ji.asDays = Ti, ji.asWeeks = Ci, ji.asMonths = _i, ji.asYears = Ei, ji.valueOf = function() {
			return this.isValid() ? this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * S(this._months / 12) : NaN
		}, ji._bubble = function() {
			var t, e, i, s, n, a = this._milliseconds,
				o = this._days,
				r = this._months,
				l = this._data;
			return 0 <= a && 0 <= o && 0 <= r || a <= 0 && o <= 0 && r <= 0 || (a += 864e5 * mi(vi(r) + o), r = o = 0), l.milliseconds = a % 1e3, t = w(a / 1e3), l.seconds = t % 60, e = w(t / 60), l.minutes = e % 60, i = w(e / 60), l.hours = i % 24, r += n = w(gi(o += w(i / 24))), o -= mi(vi(n)), s = w(r / 12), r %= 12, l.days = o, l.months = r, l.years = s, this
		}, ji.clone = function() {
			return Be(this)
		}, ji.get = function(t) {
			return t = z(t), this.isValid() ? this[t + "s"]() : NaN
		}, ji.milliseconds = ki, ji.seconds = $i, ji.minutes = Mi, ji.hours = Di, ji.days = Oi, ji.weeks = function() {
			return w(this.days() / 7)
		}, ji.months = zi, ji.years = Ai, ji.humanize = function(t) {
			if (!this.isValid()) return this.localeData().invalidDate();
			var e, i, s, n, a, o, r, l, d, c, h = this.localeData(),
				u = (e = !t, i = h, s = Be(this).abs(), n = Ii(s.as("s")), a = Ii(s.as("m")), o = Ii(s.as("h")), r = Ii(s.as("d")), l = Ii(s.as("M")), d = Ii(s.as("y")), (c = n <= Li.ss && ["s", n] || n < Li.s && ["ss", n] || a <= 1 && ["m"] || a < Li.m && ["mm", a] || o <= 1 && ["h"] || o < Li.h && ["hh", o] || r <= 1 && ["d"] || r < Li.d && ["dd", r] || l <= 1 && ["M"] || l < Li.M && ["MM", l] || d <= 1 && ["y"] || ["yy", d])[2] = e, c[3] = 0 < +this, c[4] = i, function(t, e, i, s, n) {
					return n.relativeTime(e || 1, !!i, t, s)
				}.apply(null, c));
			return t && (u = h.pastFuture(+this, u)), h.postformat(u)
		}, ji.toISOString = Ri, ji.toString = Ri, ji.toJSON = Ri, ji.locale = Qe, ji.localeData = Ke, ji.toIsoString = C("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", Ri), ji.lang = Ze, B("X", 0, 0, "unix"), B("x", 0, 0, "valueOf"), lt("x", st), lt("X", /[+-]?\d+(\.\d{1,3})?/), ut("X", function(t, e, i) {
			i._d = new Date(1e3 * parseFloat(t, 10))
		}), ut("x", function(t, e, i) {
			i._d = new Date(S(t))
		}), i.version = "2.22.2", t = Ee, i.fn = ri, i.min = function() {
			return $e("isBefore", [].slice.call(arguments, 0))
		}, i.max = function() {
			return $e("isAfter", [].slice.call(arguments, 0))
		}, i.now = function() {
			return Date.now ? Date.now() : +new Date
		}, i.utc = h, i.unix = function(t) {
			return Ee(1e3 * t)
		}, i.months = function(t, e) {
			return hi(t, e, "months")
		}, i.isDate = r, i.locale = re, i.invalid = f, i.duration = Be, i.isMoment = b, i.weekdays = function(t, e, i) {
			return ui(t, e, i, "weekdays")
		}, i.parseZone = function() {
			return Ee.apply(null, arguments).parseZone()
		}, i.localeData = de, i.isDuration = Oe, i.monthsShort = function(t, e) {
			return hi(t, e, "monthsShort")
		}, i.weekdaysMin = function(t, e, i) {
			return ui(t, e, i, "weekdaysMin")
		}, i.defineLocale = le, i.updateLocale = function(t, e) {
			if (null != e) {
				var i, s, n = ie;
				null != (s = oe(t)) && (n = s._config), (i = new M(e = $(n, e))).parentLocale = se[t], se[t] = i, re(t)
			} else null != se[t] && (null != se[t].parentLocale ? se[t] = se[t].parentLocale : null != se[t] && delete se[t]);
			return se[t]
		}, i.locales = function() {
			return _(se)
		}, i.weekdaysShort = function(t, e, i) {
			return ui(t, e, i, "weekdaysShort")
		}, i.normalizeUnits = z, i.relativeTimeRounding = function(t) {
			return void 0 === t ? Ii : "function" == typeof t && (Ii = t, !0)
		}, i.relativeTimeThreshold = function(t, e) {
			return void 0 !== Li[t] && (void 0 === e ? Li[t] : (Li[t] = e, "s" === t && (Li.ss = e - 1), !0))
		}, i.calendarFormat = function(t, e) {
			var i = t.diff(e, "days", !0);
			return i < -6 ? "sameElse" : i < -1 ? "lastWeek" : i < 0 ? "lastDay" : i < 1 ? "sameDay" : i < 2 ? "nextDay" : i < 7 ? "nextWeek" : "sameElse"
		}, i.prototype = ri, i.HTML5_FMT = {
			DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
			DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
			DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
			DATE: "YYYY-MM-DD",
			TIME: "HH:mm",
			TIME_SECONDS: "HH:mm:ss",
			TIME_MS: "HH:mm:ss.SSS",
			WEEK: "YYYY-[W]WW",
			MONTH: "YYYY-MM"
		}, i
	}), "undefined" == typeof jQuery) throw new Error("Bootstrap's JavaScript requires jQuery");

function floatToString(t, e) {
	var i = t.toFixed(e).toString();
	return i.match(/^\.\d+/) ? "0" + i : i
}

function attributeToString(t) {
	return "string" != typeof t && "undefined" === (t += "") && (t = ""), jQuery.trim(t)
}! function(t) {
	"use strict";
	var e = jQuery.fn.jquery.split(" ")[0].split(".");
	if (e[0] < 2 && e[1] < 9 || 1 == e[0] && 9 == e[1] && e[2] < 1 || e[0] > 3) throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")
}(),
function(t) {
	"use strict";
	t.fn.emulateTransitionEnd = function(e) {
		var i = !1,
			s = this;
		t(this).one("bsTransitionEnd", function() {
			i = !0
		});
		return setTimeout(function() {
			i || t(s).trigger(t.support.transition.end)
		}, e), this
	}, t(function() {
		t.support.transition = function() {
			var t = document.createElement("bootstrap"),
				e = {
					WebkitTransition: "webkitTransitionEnd",
					MozTransition: "transitionend",
					OTransition: "oTransitionEnd otransitionend",
					transition: "transitionend"
				};
			for (var i in e)
				if (void 0 !== t.style[i]) return {
					end: e[i]
				};
			return !1
		}(), t.support.transition && (t.event.special.bsTransitionEnd = {
			bindType: t.support.transition.end,
			delegateType: t.support.transition.end,
			handle: function(e) {
				if (t(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
			}
		})
	})
}(jQuery),
function(t) {
	"use strict";
	var e = '[data-dismiss="alert"]',
		i = function(i) {
			t(i).on("click", e, this.close)
		};
	i.VERSION = "3.3.7", i.TRANSITION_DURATION = 150, i.prototype.close = function(e) {
		function s() {
			o.detach().trigger("closed.bs.alert").remove()
		}
		var n = t(this),
			a = n.attr("data-target");
		a || (a = (a = n.attr("href")) && a.replace(/.*(?=#[^\s]*$)/, ""));
		var o = t("#" === a ? [] : a);
		e && e.preventDefault(), o.length || (o = n.closest(".alert")), o.trigger(e = t.Event("close.bs.alert")), e.isDefaultPrevented() || (o.removeClass("in"), t.support.transition && o.hasClass("fade") ? o.one("bsTransitionEnd", s).emulateTransitionEnd(i.TRANSITION_DURATION) : s())
	};
	var s = t.fn.alert;
	t.fn.alert = function(e) {
		return this.each(function() {
			var s = t(this),
				n = s.data("bs.alert");
			n || s.data("bs.alert", n = new i(this)), "string" == typeof e && n[e].call(s)
		})
	}, t.fn.alert.Constructor = i, t.fn.alert.noConflict = function() {
		return t.fn.alert = s, this
	}, t(document).on("click.bs.alert.data-api", e, i.prototype.close)
}(jQuery),
function(t) {
	"use strict";

	function e(e) {
		return this.each(function() {
			var s = t(this),
				n = s.data("bs.button"),
				a = "object" == typeof e && e;
			n || s.data("bs.button", n = new i(this, a)), "toggle" == e ? n.toggle() : e && n.setState(e)
		})
	}
	var i = function(e, s) {
		this.$element = t(e), this.options = t.extend({}, i.DEFAULTS, s), this.isLoading = !1
	};
	i.VERSION = "3.3.7", i.DEFAULTS = {
		loadingText: "loading..."
	}, i.prototype.setState = function(e) {
		var i = "disabled",
			s = this.$element,
			n = s.is("input") ? "val" : "html",
			a = s.data();
		e += "Text", null == a.resetText && s.data("resetText", s[n]()), setTimeout(t.proxy(function() {
			s[n](null == a[e] ? this.options[e] : a[e]), "loadingText" == e ? (this.isLoading = !0, s.addClass(i).attr(i, i).prop(i, !0)) : this.isLoading && (this.isLoading = !1, s.removeClass(i).removeAttr(i).prop(i, !1))
		}, this), 0)
	}, i.prototype.toggle = function() {
		var t = !0,
			e = this.$element.closest('[data-toggle="buttons"]');
		if (e.length) {
			var i = this.$element.find("input");
			"radio" == i.prop("type") ? (i.prop("checked") && (t = !1), e.find(".active").removeClass("active"), this.$element.addClass("active")) : "checkbox" == i.prop("type") && (i.prop("checked") !== this.$element.hasClass("active") && (t = !1), this.$element.toggleClass("active")), i.prop("checked", this.$element.hasClass("active")), t && i.trigger("change")
		} else this.$element.attr("aria-pressed", !this.$element.hasClass("active")), this.$element.toggleClass("active")
	};
	var s = t.fn.button;
	t.fn.button = e, t.fn.button.Constructor = i, t.fn.button.noConflict = function() {
		return t.fn.button = s, this
	}, t(document).on("click.bs.button.data-api", '[data-toggle^="button"]', function(i) {
		var s = t(i.target).closest(".btn");
		e.call(s, "toggle"), t(i.target).is('input[type="radio"], input[type="checkbox"]') || (i.preventDefault(), s.is("input,button") ? s.trigger("focus") : s.find("input:visible,button:visible").first().trigger("focus"))
	}).on("focus.bs.button.data-api blur.bs.button.data-api", '[data-toggle^="button"]', function(e) {
		t(e.target).closest(".btn").toggleClass("focus", /^focus(in)?$/.test(e.type))
	})
}(jQuery),
function(t) {
	"use strict";

	function e(e) {
		return this.each(function() {
			var s = t(this),
				n = s.data("bs.carousel"),
				a = t.extend({}, i.DEFAULTS, s.data(), "object" == typeof e && e),
				o = "string" == typeof e ? e : a.slide;
			n || s.data("bs.carousel", n = new i(this, a)), "number" == typeof e ? n.to(e) : o ? n[o]() : a.interval && n.pause().cycle()
		})
	}
	var i = function(e, i) {
		this.$element = t(e), this.$indicators = this.$element.find(".carousel-indicators"), this.options = i, this.paused = null, this.sliding = null, this.interval = null, this.$active = null, this.$items = null, this.options.keyboard && this.$element.on("keydown.bs.carousel", t.proxy(this.keydown, this)), "hover" == this.options.pause && !("ontouchstart" in document.documentElement) && this.$element.on("mouseenter.bs.carousel", t.proxy(this.pause, this)).on("mouseleave.bs.carousel", t.proxy(this.cycle, this))
	};
	i.VERSION = "3.3.7", i.TRANSITION_DURATION = 600, i.DEFAULTS = {
		interval: 5e3,
		pause: "hover",
		wrap: !0,
		keyboard: !0
	}, i.prototype.keydown = function(t) {
		if (!/input|textarea/i.test(t.target.tagName)) {
			switch (t.which) {
				case 37:
					this.prev();
					break;
				case 39:
					this.next();
					break;
				default:
					return
			}
			t.preventDefault()
		}
	}, i.prototype.cycle = function(e) {
		return e || (this.paused = !1), this.interval && clearInterval(this.interval), this.options.interval && !this.paused && (this.interval = setInterval(t.proxy(this.next, this), this.options.interval)), this
	}, i.prototype.getItemIndex = function(t) {
		return this.$items = t.parent().children(".item"), this.$items.index(t || this.$active)
	}, i.prototype.getItemForDirection = function(t, e) {
		var i = this.getItemIndex(e);
		if (("prev" == t && 0 === i || "next" == t && i == this.$items.length - 1) && !this.options.wrap) return e;
		var s = (i + ("prev" == t ? -1 : 1)) % this.$items.length;
		return this.$items.eq(s)
	}, i.prototype.to = function(t) {
		var e = this,
			i = this.getItemIndex(this.$active = this.$element.find(".item.active"));
		if (!(t > this.$items.length - 1 || t < 0)) return this.sliding ? this.$element.one("slid.bs.carousel", function() {
			e.to(t)
		}) : i == t ? this.pause().cycle() : this.slide(t > i ? "next" : "prev", this.$items.eq(t))
	}, i.prototype.pause = function(e) {
		return e || (this.paused = !0), this.$element.find(".next, .prev").length && t.support.transition && (this.$element.trigger(t.support.transition.end), this.cycle(!0)), this.interval = clearInterval(this.interval), this
	}, i.prototype.next = function() {
		if (!this.sliding) return this.slide("next")
	}, i.prototype.prev = function() {
		if (!this.sliding) return this.slide("prev")
	}, i.prototype.slide = function(e, s) {
		var n = this.$element.find(".item.active"),
			a = s || this.getItemForDirection(e, n),
			o = this.interval,
			r = "next" == e ? "left" : "right",
			l = this;
		if (a.hasClass("active")) return this.sliding = !1;
		var d = a[0],
			c = t.Event("slide.bs.carousel", {
				relatedTarget: d,
				direction: r
			});
		if (this.$element.trigger(c), !c.isDefaultPrevented()) {
			if (this.sliding = !0, o && this.pause(), this.$indicators.length) {
				this.$indicators.find(".active").removeClass("active");
				var h = t(this.$indicators.children()[this.getItemIndex(a)]);
				h && h.addClass("active")
			}
			var u = t.Event("slid.bs.carousel", {
				relatedTarget: d,
				direction: r
			});
			return t.support.transition && this.$element.hasClass("slide") ? (a.addClass(e), a[0].offsetWidth, n.addClass(r), a.addClass(r), n.one("bsTransitionEnd", function() {
				a.removeClass([e, r].join(" ")).addClass("active"), n.removeClass(["active", r].join(" ")), l.sliding = !1, setTimeout(function() {
					l.$element.trigger(u)
				}, 0)
			}).emulateTransitionEnd(i.TRANSITION_DURATION)) : (n.removeClass("active"), a.addClass("active"), this.sliding = !1, this.$element.trigger(u)), o && this.cycle(), this
		}
	};
	var s = t.fn.carousel;
	t.fn.carousel = e, t.fn.carousel.Constructor = i, t.fn.carousel.noConflict = function() {
		return t.fn.carousel = s, this
	};
	var n = function(i) {
		var s, n = t(this),
			a = t(n.attr("data-target") || (s = n.attr("href")) && s.replace(/.*(?=#[^\s]+$)/, ""));
		if (a.hasClass("carousel")) {
			var o = t.extend({}, a.data(), n.data()),
				r = n.attr("data-slide-to");
			r && (o.interval = !1), e.call(a, o), r && a.data("bs.carousel").to(r), i.preventDefault()
		}
	};
	t(document).on("click.bs.carousel.data-api", "[data-slide]", n).on("click.bs.carousel.data-api", "[data-slide-to]", n), t(window).on("load", function() {
		t('[data-ride="carousel"]').each(function() {
			var i = t(this);
			e.call(i, i.data())
		})
	})
}(jQuery),
function(t) {
	"use strict";

	function e(e) {
		var i, s = e.attr("data-target") || (i = e.attr("href")) && i.replace(/.*(?=#[^\s]+$)/, "");
		return t(s)
	}

	function i(e) {
		return this.each(function() {
			var i = t(this),
				n = i.data("bs.collapse"),
				a = t.extend({}, s.DEFAULTS, i.data(), "object" == typeof e && e);
			!n && a.toggle && /show|hide/.test(e) && (a.toggle = !1), n || i.data("bs.collapse", n = new s(this, a)), "string" == typeof e && n[e]()
		})
	}
	var s = function(e, i) {
		this.$element = t(e), this.options = t.extend({}, s.DEFAULTS, i), this.$trigger = t('[data-toggle="collapse"][href="#' + e.id + '"],[data-toggle="collapse"][data-target="#' + e.id + '"]'), this.transitioning = null, this.options.parent ? this.$parent = this.getParent() : this.addAriaAndCollapsedClass(this.$element, this.$trigger), this.options.toggle && this.toggle()
	};
	s.VERSION = "3.3.7", s.TRANSITION_DURATION = 350, s.DEFAULTS = {
		toggle: !0
	}, s.prototype.dimension = function() {
		return this.$element.hasClass("width") ? "width" : "height"
	}, s.prototype.show = function() {
		if (!this.transitioning && !this.$element.hasClass("in")) {
			var e, n = this.$parent && this.$parent.children(".panel").children(".in, .collapsing");
			if (!(n && n.length && (e = n.data("bs.collapse"), e && e.transitioning))) {
				var a = t.Event("show.bs.collapse");
				if (this.$element.trigger(a), !a.isDefaultPrevented()) {
					n && n.length && (i.call(n, "hide"), e || n.data("bs.collapse", null));
					var o = this.dimension();
					this.$element.removeClass("collapse").addClass("collapsing")[o](0).attr("aria-expanded", !0), this.$trigger.removeClass("collapsed").attr("aria-expanded", !0), this.transitioning = 1;
					var r = function() {
						this.$element.removeClass("collapsing").addClass("collapse in")[o](""), this.transitioning = 0, this.$element.trigger("shown.bs.collapse")
					};
					if (!t.support.transition) return r.call(this);
					var l = t.camelCase(["scroll", o].join("-"));
					this.$element.one("bsTransitionEnd", t.proxy(r, this)).emulateTransitionEnd(s.TRANSITION_DURATION)[o](this.$element[0][l])
				}
			}
		}
	}, s.prototype.hide = function() {
		if (!this.transitioning && this.$element.hasClass("in")) {
			var e = t.Event("hide.bs.collapse");
			if (this.$element.trigger(e), !e.isDefaultPrevented()) {
				var i = this.dimension();
				this.$element[i](this.$element[i]())[0].offsetHeight, this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded", !1), this.$trigger.addClass("collapsed").attr("aria-expanded", !1), this.transitioning = 1;
				var n = function() {
					this.transitioning = 0, this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")
				};
				return t.support.transition ? void this.$element[i](0).one("bsTransitionEnd", t.proxy(n, this)).emulateTransitionEnd(s.TRANSITION_DURATION) : n.call(this)
			}
		}
	}, s.prototype.toggle = function() {
		this[this.$element.hasClass("in") ? "hide" : "show"]()
	}, s.prototype.getParent = function() {
		return t(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each(t.proxy(function(i, s) {
			var n = t(s);
			this.addAriaAndCollapsedClass(e(n), n)
		}, this)).end()
	}, s.prototype.addAriaAndCollapsedClass = function(t, e) {
		var i = t.hasClass("in");
		t.attr("aria-expanded", i), e.toggleClass("collapsed", !i).attr("aria-expanded", i)
	};
	var n = t.fn.collapse;
	t.fn.collapse = i, t.fn.collapse.Constructor = s, t.fn.collapse.noConflict = function() {
		return t.fn.collapse = n, this
	}, t(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function(s) {
		var n = t(this);
		n.attr("data-target") || s.preventDefault();
		var a = e(n),
			o = a.data("bs.collapse") ? "toggle" : n.data();
		i.call(a, o)
	})
}(jQuery),
function(t) {
	"use strict";

	function e(e) {
		var i = e.attr("data-target");
		i || (i = (i = e.attr("href")) && /#[A-Za-z]/.test(i) && i.replace(/.*(?=#[^\s]*$)/, ""));
		var s = i && t(i);
		return s && s.length ? s : e.parent()
	}

	function i(i) {
		i && 3 === i.which || (t(s).remove(), t(n).each(function() {
			var s = t(this),
				n = e(s),
				a = {
					relatedTarget: this
				};
			n.hasClass("open") && (i && "click" == i.type && /input|textarea/i.test(i.target.tagName) && t.contains(n[0], i.target) || (n.trigger(i = t.Event("hide.bs.dropdown", a)), i.isDefaultPrevented() || (s.attr("aria-expanded", "false"), n.removeClass("open").trigger(t.Event("hidden.bs.dropdown", a)))))
		}))
	}
	var s = ".dropdown-backdrop",
		n = '[data-toggle="dropdown"]',
		a = function(e) {
			t(e).on("click.bs.dropdown", this.toggle)
		};
	a.VERSION = "3.3.7", a.prototype.toggle = function(s) {
		var n = t(this);
		if (!n.is(".disabled, :disabled")) {
			var a = e(n),
				o = a.hasClass("open");
			if (i(), !o) {
				"ontouchstart" in document.documentElement && !a.closest(".navbar-nav").length && t(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(t(this)).on("click", i);
				var r = {
					relatedTarget: this
				};
				if (a.trigger(s = t.Event("show.bs.dropdown", r)), s.isDefaultPrevented()) return;
				n.trigger("focus").attr("aria-expanded", "true"), a.toggleClass("open").trigger(t.Event("shown.bs.dropdown", r))
			}
			return !1
		}
	}, a.prototype.keydown = function(i) {
		if (/(38|40|27|32)/.test(i.which) && !/input|textarea/i.test(i.target.tagName)) {
			var s = t(this);
			if (i.preventDefault(), i.stopPropagation(), !s.is(".disabled, :disabled")) {
				var a = e(s),
					o = a.hasClass("open");
				if (!o && 27 != i.which || o && 27 == i.which) return 27 == i.which && a.find(n).trigger("focus"), s.trigger("click");
				var r = a.find(".dropdown-menu li:not(.disabled):visible a");
				if (r.length) {
					var l = r.index(i.target);
					38 == i.which && l > 0 && l--, 40 == i.which && l < r.length - 1 && l++, ~l || (l = 0), r.eq(l).trigger("focus")
				}
			}
		}
	};
	var o = t.fn.dropdown;
	t.fn.dropdown = function(e) {
		return this.each(function() {
			var i = t(this),
				s = i.data("bs.dropdown");
			s || i.data("bs.dropdown", s = new a(this)), "string" == typeof e && s[e].call(i)
		})
	}, t.fn.dropdown.Constructor = a, t.fn.dropdown.noConflict = function() {
		return t.fn.dropdown = o, this
	}, t(document).on("click.bs.dropdown.data-api", i).on("click.bs.dropdown.data-api", ".dropdown form", function(t) {
		t.stopPropagation()
	}).on("click.bs.dropdown.data-api", n, a.prototype.toggle).on("keydown.bs.dropdown.data-api", n, a.prototype.keydown).on("keydown.bs.dropdown.data-api", ".dropdown-menu", a.prototype.keydown)
}(jQuery),
function(t) {
	"use strict";

	function e(e, s) {
		return this.each(function() {
			var n = t(this),
				a = n.data("bs.modal"),
				o = t.extend({}, i.DEFAULTS, n.data(), "object" == typeof e && e);
			a || n.data("bs.modal", a = new i(this, o)), "string" == typeof e ? a[e](s) : o.show && a.show(s)
		})
	}
	var i = function(e, i) {
		this.options = i, this.$body = t(document.body), this.$element = t(e), this.$dialog = this.$element.find(".modal-dialog"), this.$backdrop = null, this.isShown = null, this.originalBodyPad = null, this.scrollbarWidth = 0, this.ignoreBackdropClick = !1, this.options.remote && this.$element.find(".modal-content").load(this.options.remote, t.proxy(function() {
			this.$element.trigger("loaded.bs.modal")
		}, this))
	};
	i.VERSION = "3.3.7", i.TRANSITION_DURATION = 300, i.BACKDROP_TRANSITION_DURATION = 150, i.DEFAULTS = {
		backdrop: !0,
		keyboard: !0,
		show: !0
	}, i.prototype.toggle = function(t) {
		return this.isShown ? this.hide() : this.show(t)
	}, i.prototype.show = function(e) {
		var s = this,
			n = t.Event("show.bs.modal", {
				relatedTarget: e
			});
		this.$element.trigger(n), this.isShown || n.isDefaultPrevented() || (this.isShown = !0, this.checkScrollbar(), this.setScrollbar(), this.$body.addClass("modal-open"), this.escape(), this.resize(), this.$element.on("click.dismiss.bs.modal", '[data-dismiss="modal"]', t.proxy(this.hide, this)), this.$dialog.on("mousedown.dismiss.bs.modal", function() {
			s.$element.one("mouseup.dismiss.bs.modal", function(e) {
				t(e.target).is(s.$element) && (s.ignoreBackdropClick = !0)
			})
		}), this.backdrop(function() {
			var n = t.support.transition && s.$element.hasClass("fade");
			s.$element.parent().length || s.$element.appendTo(s.$body), s.$element.show().scrollTop(0), s.adjustDialog(), n && s.$element[0].offsetWidth, s.$element.addClass("in"), s.enforceFocus();
			var a = t.Event("shown.bs.modal", {
				relatedTarget: e
			});
			n ? s.$dialog.one("bsTransitionEnd", function() {
				s.$element.trigger("focus").trigger(a)
			}).emulateTransitionEnd(i.TRANSITION_DURATION) : s.$element.trigger("focus").trigger(a)
		}))
	}, i.prototype.hide = function(e) {
		e && e.preventDefault(), e = t.Event("hide.bs.modal"), this.$element.trigger(e), this.isShown && !e.isDefaultPrevented() && (this.isShown = !1, this.escape(), this.resize(), t(document).off("focusin.bs.modal"), this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"), this.$dialog.off("mousedown.dismiss.bs.modal"), t.support.transition && this.$element.hasClass("fade") ? this.$element.one("bsTransitionEnd", t.proxy(this.hideModal, this)).emulateTransitionEnd(i.TRANSITION_DURATION) : this.hideModal())
	}, i.prototype.enforceFocus = function() {
		t(document).off("focusin.bs.modal").on("focusin.bs.modal", t.proxy(function(t) {
			document === t.target || this.$element[0] === t.target || this.$element.has(t.target).length || this.$element.trigger("focus")
		}, this))
	}, i.prototype.escape = function() {
		this.isShown && this.options.keyboard ? this.$element.on("keydown.dismiss.bs.modal", t.proxy(function(t) {
			27 == t.which && this.hide()
		}, this)) : this.isShown || this.$element.off("keydown.dismiss.bs.modal")
	}, i.prototype.resize = function() {
		this.isShown ? t(window).on("resize.bs.modal", t.proxy(this.handleUpdate, this)) : t(window).off("resize.bs.modal")
	}, i.prototype.hideModal = function() {
		var t = this;
		this.$element.hide(), this.backdrop(function() {
			t.$body.removeClass("modal-open"), t.resetAdjustments(), t.resetScrollbar(), t.$element.trigger("hidden.bs.modal")
		})
	}, i.prototype.removeBackdrop = function() {
		this.$backdrop && this.$backdrop.remove(), this.$backdrop = null
	}, i.prototype.backdrop = function(e) {
		var s = this,
			n = this.$element.hasClass("fade") ? "fade" : "";
		if (this.isShown && this.options.backdrop) {
			var a = t.support.transition && n;
			if (this.$backdrop = t(document.createElement("div")).addClass("modal-backdrop " + n).appendTo(this.$body), this.$element.on("click.dismiss.bs.modal", t.proxy(function(t) {
					return this.ignoreBackdropClick ? void(this.ignoreBackdropClick = !1) : void(t.target === t.currentTarget && ("static" == this.options.backdrop ? this.$element[0].focus() : this.hide()))
				}, this)), a && this.$backdrop[0].offsetWidth, this.$backdrop.addClass("in"), !e) return;
			a ? this.$backdrop.one("bsTransitionEnd", e).emulateTransitionEnd(i.BACKDROP_TRANSITION_DURATION) : e()
		} else if (!this.isShown && this.$backdrop) {
			this.$backdrop.removeClass("in");
			var o = function() {
				s.removeBackdrop(), e && e()
			};
			t.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one("bsTransitionEnd", o).emulateTransitionEnd(i.BACKDROP_TRANSITION_DURATION) : o()
		} else e && e()
	}, i.prototype.handleUpdate = function() {
		this.adjustDialog()
	}, i.prototype.adjustDialog = function() {
		var t = this.$element[0].scrollHeight > document.documentElement.clientHeight;
		this.$element.css({
			paddingLeft: !this.bodyIsOverflowing && t ? this.scrollbarWidth : "",
			paddingRight: this.bodyIsOverflowing && !t ? this.scrollbarWidth : ""
		})
	}, i.prototype.resetAdjustments = function() {
		this.$element.css({
			paddingLeft: "",
			paddingRight: ""
		})
	}, i.prototype.checkScrollbar = function() {
		var t = window.innerWidth;
		if (!t) {
			var e = document.documentElement.getBoundingClientRect();
			t = e.right - Math.abs(e.left)
		}
		this.bodyIsOverflowing = document.body.clientWidth < t, this.scrollbarWidth = this.measureScrollbar()
	}, i.prototype.setScrollbar = function() {
		var t = parseInt(this.$body.css("padding-right") || 0, 10);
		this.originalBodyPad = document.body.style.paddingRight || "", this.bodyIsOverflowing && this.$body.css("padding-right", t + this.scrollbarWidth)
	}, i.prototype.resetScrollbar = function() {
		this.$body.css("padding-right", this.originalBodyPad)
	}, i.prototype.measureScrollbar = function() {
		var t = document.createElement("div");
		t.className = "modal-scrollbar-measure", this.$body.append(t);
		var e = t.offsetWidth - t.clientWidth;
		return this.$body[0].removeChild(t), e
	};
	var s = t.fn.modal;
	t.fn.modal = e, t.fn.modal.Constructor = i, t.fn.modal.noConflict = function() {
		return t.fn.modal = s, this
	}, t(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function(i) {
		var s = t(this),
			n = s.attr("href"),
			a = t(s.attr("data-target") || n && n.replace(/.*(?=#[^\s]+$)/, "")),
			o = a.data("bs.modal") ? "toggle" : t.extend({
				remote: !/#/.test(n) && n
			}, a.data(), s.data());
		s.is("a") && i.preventDefault(), a.one("show.bs.modal", function(t) {
			t.isDefaultPrevented() || a.one("hidden.bs.modal", function() {
				s.is(":visible") && s.trigger("focus")
			})
		}), e.call(a, o, this)
	})
}(jQuery),
function(t) {
	"use strict";
	var e = function(t, e) {
		this.type = null, this.options = null, this.enabled = null, this.timeout = null, this.hoverState = null, this.$element = null, this.inState = null, this.init("tooltip", t, e)
	};
	e.VERSION = "3.3.7", e.TRANSITION_DURATION = 150, e.DEFAULTS = {
		animation: !0,
		placement: "top",
		selector: !1,
		template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
		trigger: "hover focus",
		title: "",
		delay: 0,
		html: !1,
		container: !1,
		viewport: {
			selector: "body",
			padding: 0
		}
	}, e.prototype.init = function(e, i, s) {
		if (this.enabled = !0, this.type = e, this.$element = t(i), this.options = this.getOptions(s), this.$viewport = this.options.viewport && t(t.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : this.options.viewport.selector || this.options.viewport), this.inState = {
				click: !1,
				hover: !1,
				focus: !1
			}, this.$element[0] instanceof document.constructor && !this.options.selector) throw new Error("`selector` option must be specified when initializing " + this.type + " on the window.document object!");
		for (var n = this.options.trigger.split(" "), a = n.length; a--;) {
			var o = n[a];
			if ("click" == o) this.$element.on("click." + this.type, this.options.selector, t.proxy(this.toggle, this));
			else if ("manual" != o) {
				var r = "hover" == o ? "mouseenter" : "focusin",
					l = "hover" == o ? "mouseleave" : "focusout";
				this.$element.on(r + "." + this.type, this.options.selector, t.proxy(this.enter, this)), this.$element.on(l + "." + this.type, this.options.selector, t.proxy(this.leave, this))
			}
		}
		this.options.selector ? this._options = t.extend({}, this.options, {
			trigger: "manual",
			selector: ""
		}) : this.fixTitle()
	}, e.prototype.getDefaults = function() {
		return e.DEFAULTS
	}, e.prototype.getOptions = function(e) {
		return (e = t.extend({}, this.getDefaults(), this.$element.data(), e)).delay && "number" == typeof e.delay && (e.delay = {
			show: e.delay,
			hide: e.delay
		}), e
	}, e.prototype.getDelegateOptions = function() {
		var e = {},
			i = this.getDefaults();
		return this._options && t.each(this._options, function(t, s) {
			i[t] != s && (e[t] = s)
		}), e
	}, e.prototype.enter = function(e) {
		var i = e instanceof this.constructor ? e : t(e.currentTarget).data("bs." + this.type);
		return i || (i = new this.constructor(e.currentTarget, this.getDelegateOptions()), t(e.currentTarget).data("bs." + this.type, i)), e instanceof t.Event && (i.inState["focusin" == e.type ? "focus" : "hover"] = !0), i.tip().hasClass("in") || "in" == i.hoverState ? void(i.hoverState = "in") : (clearTimeout(i.timeout), i.hoverState = "in", i.options.delay && i.options.delay.show ? void(i.timeout = setTimeout(function() {
			"in" == i.hoverState && i.show()
		}, i.options.delay.show)) : i.show())
	}, e.prototype.isInStateTrue = function() {
		for (var t in this.inState)
			if (this.inState[t]) return !0;
		return !1
	}, e.prototype.leave = function(e) {
		var i = e instanceof this.constructor ? e : t(e.currentTarget).data("bs." + this.type);
		if (i || (i = new this.constructor(e.currentTarget, this.getDelegateOptions()), t(e.currentTarget).data("bs." + this.type, i)), e instanceof t.Event && (i.inState["focusout" == e.type ? "focus" : "hover"] = !1), !i.isInStateTrue()) return clearTimeout(i.timeout), i.hoverState = "out", i.options.delay && i.options.delay.hide ? void(i.timeout = setTimeout(function() {
			"out" == i.hoverState && i.hide()
		}, i.options.delay.hide)) : i.hide()
	}, e.prototype.show = function() {
		var i = t.Event("show.bs." + this.type);
		if (this.hasContent() && this.enabled) {
			this.$element.trigger(i);
			var s = t.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
			if (i.isDefaultPrevented() || !s) return;
			var n = this,
				a = this.tip(),
				o = this.getUID(this.type);
			this.setContent(), a.attr("id", o), this.$element.attr("aria-describedby", o), this.options.animation && a.addClass("fade");
			var r = "function" == typeof this.options.placement ? this.options.placement.call(this, a[0], this.$element[0]) : this.options.placement,
				l = /\s?auto?\s?/i,
				d = l.test(r);
			d && (r = r.replace(l, "") || "top"), a.detach().css({
				top: 0,
				left: 0,
				display: "block"
			}).addClass(r).data("bs." + this.type, this), this.options.container ? a.appendTo(this.options.container) : a.insertAfter(this.$element), this.$element.trigger("inserted.bs." + this.type);
			var c = this.getPosition(),
				h = a[0].offsetWidth,
				u = a[0].offsetHeight;
			if (d) {
				var p = r,
					f = this.getPosition(this.$viewport);
				r = "bottom" == r && c.bottom + u > f.bottom ? "top" : "top" == r && c.top - u < f.top ? "bottom" : "right" == r && c.right + h > f.width ? "left" : "left" == r && c.left - h < f.left ? "right" : r, a.removeClass(p).addClass(r)
			}
			var m = this.getCalculatedOffset(r, c, h, u);
			this.applyPlacement(m, r);
			var g = function() {
				var t = n.hoverState;
				n.$element.trigger("shown.bs." + n.type), n.hoverState = null, "out" == t && n.leave(n)
			};
			t.support.transition && this.$tip.hasClass("fade") ? a.one("bsTransitionEnd", g).emulateTransitionEnd(e.TRANSITION_DURATION) : g()
		}
	}, e.prototype.applyPlacement = function(e, i) {
		var s = this.tip(),
			n = s[0].offsetWidth,
			a = s[0].offsetHeight,
			o = parseInt(s.css("margin-top"), 10),
			r = parseInt(s.css("margin-left"), 10);
		isNaN(o) && (o = 0), isNaN(r) && (r = 0), e.top += o, e.left += r, t.offset.setOffset(s[0], t.extend({
			using: function(t) {
				s.css({
					top: Math.round(t.top),
					left: Math.round(t.left)
				})
			}
		}, e), 0), s.addClass("in");
		var l = s[0].offsetWidth,
			d = s[0].offsetHeight;
		"top" == i && d != a && (e.top = e.top + a - d);
		var c = this.getViewportAdjustedDelta(i, e, l, d);
		c.left ? e.left += c.left : e.top += c.top;
		var h = /top|bottom/.test(i),
			u = h ? 2 * c.left - n + l : 2 * c.top - a + d,
			p = h ? "offsetWidth" : "offsetHeight";
		s.offset(e), this.replaceArrow(u, s[0][p], h)
	}, e.prototype.replaceArrow = function(t, e, i) {
		this.arrow().css(i ? "left" : "top", 50 * (1 - t / e) + "%").css(i ? "top" : "left", "")
	}, e.prototype.setContent = function() {
		var t = this.tip(),
			e = this.getTitle();
		t.find(".tooltip-inner")[this.options.html ? "html" : "text"](e), t.removeClass("fade in top bottom left right")
	}, e.prototype.hide = function(i) {
		function s() {
			"in" != n.hoverState && a.detach(), n.$element && n.$element.removeAttr("aria-describedby").trigger("hidden.bs." + n.type), i && i()
		}
		var n = this,
			a = t(this.$tip),
			o = t.Event("hide.bs." + this.type);
		if (this.$element.trigger(o), !o.isDefaultPrevented()) return a.removeClass("in"), t.support.transition && a.hasClass("fade") ? a.one("bsTransitionEnd", s).emulateTransitionEnd(e.TRANSITION_DURATION) : s(), this.hoverState = null, this
	}, e.prototype.fixTitle = function() {
		var t = this.$element;
		(t.attr("title") || "string" != typeof t.attr("data-original-title")) && t.attr("data-original-title", t.attr("title") || "").attr("title", "")
	}, e.prototype.hasContent = function() {
		return this.getTitle()
	}, e.prototype.getPosition = function(e) {
		var i = (e = e || this.$element)[0],
			s = "BODY" == i.tagName,
			n = i.getBoundingClientRect();
		null == n.width && (n = t.extend({}, n, {
			width: n.right - n.left,
			height: n.bottom - n.top
		}));
		var a = window.SVGElement && i instanceof window.SVGElement,
			o = s ? {
				top: 0,
				left: 0
			} : a ? null : e.offset(),
			r = {
				scroll: s ? document.documentElement.scrollTop || document.body.scrollTop : e.scrollTop()
			},
			l = s ? {
				width: t(window).width(),
				height: t(window).height()
			} : null;
		return t.extend({}, n, r, l, o)
	}, e.prototype.getCalculatedOffset = function(t, e, i, s) {
		return "bottom" == t ? {
			top: e.top + e.height,
			left: e.left + e.width / 2 - i / 2
		} : "top" == t ? {
			top: e.top - s,
			left: e.left + e.width / 2 - i / 2
		} : "left" == t ? {
			top: e.top + e.height / 2 - s / 2,
			left: e.left - i
		} : {
			top: e.top + e.height / 2 - s / 2,
			left: e.left + e.width
		}
	}, e.prototype.getViewportAdjustedDelta = function(t, e, i, s) {
		var n = {
			top: 0,
			left: 0
		};
		if (!this.$viewport) return n;
		var a = this.options.viewport && this.options.viewport.padding || 0,
			o = this.getPosition(this.$viewport);
		if (/right|left/.test(t)) {
			var r = e.top - a - o.scroll,
				l = e.top + a - o.scroll + s;
			r < o.top ? n.top = o.top - r : l > o.top + o.height && (n.top = o.top + o.height - l)
		} else {
			var d = e.left - a,
				c = e.left + a + i;
			d < o.left ? n.left = o.left - d : c > o.right && (n.left = o.left + o.width - c)
		}
		return n
	}, e.prototype.getTitle = function() {
		var t = this.$element,
			e = this.options;
		return t.attr("data-original-title") || ("function" == typeof e.title ? e.title.call(t[0]) : e.title)
	}, e.prototype.getUID = function(t) {
		do {
			t += ~~(1e6 * Math.random())
		} while (document.getElementById(t));
		return t
	}, e.prototype.tip = function() {
		if (!this.$tip && (this.$tip = t(this.options.template), 1 != this.$tip.length)) throw new Error(this.type + " `template` option must consist of exactly 1 top-level element!");
		return this.$tip
	}, e.prototype.arrow = function() {
		return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow")
	}, e.prototype.enable = function() {
		this.enabled = !0
	}, e.prototype.disable = function() {
		this.enabled = !1
	}, e.prototype.toggleEnabled = function() {
		this.enabled = !this.enabled
	}, e.prototype.toggle = function(e) {
		var i = this;
		e && ((i = t(e.currentTarget).data("bs." + this.type)) || (i = new this.constructor(e.currentTarget, this.getDelegateOptions()), t(e.currentTarget).data("bs." + this.type, i))), e ? (i.inState.click = !i.inState.click, i.isInStateTrue() ? i.enter(i) : i.leave(i)) : i.tip().hasClass("in") ? i.leave(i) : i.enter(i)
	}, e.prototype.destroy = function() {
		var t = this;
		clearTimeout(this.timeout), this.hide(function() {
			t.$element.off("." + t.type).removeData("bs." + t.type), t.$tip && t.$tip.detach(), t.$tip = null, t.$arrow = null, t.$viewport = null, t.$element = null
		})
	};
	var i = t.fn.tooltip;
	t.fn.tooltip = function(i) {
		return this.each(function() {
			var s = t(this),
				n = s.data("bs.tooltip"),
				a = "object" == typeof i && i;
			!n && /destroy|hide/.test(i) || (n || s.data("bs.tooltip", n = new e(this, a)), "string" == typeof i && n[i]())
		})
	}, t.fn.tooltip.Constructor = e, t.fn.tooltip.noConflict = function() {
		return t.fn.tooltip = i, this
	}
}(jQuery),
function(t) {
	"use strict";
	var e = function(t, e) {
		this.init("popover", t, e)
	};
	if (!t.fn.tooltip) throw new Error("Popover requires tooltip.js");
	e.VERSION = "3.3.7", e.DEFAULTS = t.extend({}, t.fn.tooltip.Constructor.DEFAULTS, {
		placement: "right",
		trigger: "click",
		content: "",
		template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	}), e.prototype = t.extend({}, t.fn.tooltip.Constructor.prototype), e.prototype.constructor = e, e.prototype.getDefaults = function() {
		return e.DEFAULTS
	}, e.prototype.setContent = function() {
		var t = this.tip(),
			e = this.getTitle(),
			i = this.getContent();
		t.find(".popover-title")[this.options.html ? "html" : "text"](e), t.find(".popover-content").children().detach().end()[this.options.html ? "string" == typeof i ? "html" : "append" : "text"](i), t.removeClass("fade top bottom left right in"), t.find(".popover-title").html() || t.find(".popover-title").hide()
	}, e.prototype.hasContent = function() {
		return this.getTitle() || this.getContent()
	}, e.prototype.getContent = function() {
		var t = this.$element,
			e = this.options;
		return t.attr("data-content") || ("function" == typeof e.content ? e.content.call(t[0]) : e.content)
	}, e.prototype.arrow = function() {
		return this.$arrow = this.$arrow || this.tip().find(".arrow")
	};
	var i = t.fn.popover;
	t.fn.popover = function(i) {
		return this.each(function() {
			var s = t(this),
				n = s.data("bs.popover"),
				a = "object" == typeof i && i;
			!n && /destroy|hide/.test(i) || (n || s.data("bs.popover", n = new e(this, a)), "string" == typeof i && n[i]())
		})
	}, t.fn.popover.Constructor = e, t.fn.popover.noConflict = function() {
		return t.fn.popover = i, this
	}
}(jQuery),
function(t) {
	"use strict";

	function e(i, s) {
		this.$body = t(document.body), this.$scrollElement = t(t(i).is(document.body) ? window : i), this.options = t.extend({}, e.DEFAULTS, s), this.selector = (this.options.target || "") + " .nav li > a", this.offsets = [], this.targets = [], this.activeTarget = null, this.scrollHeight = 0, this.$scrollElement.on("scroll.bs.scrollspy", t.proxy(this.process, this)), this.refresh(), this.process()
	}

	function i(i) {
		return this.each(function() {
			var s = t(this),
				n = s.data("bs.scrollspy"),
				a = "object" == typeof i && i;
			n || s.data("bs.scrollspy", n = new e(this, a)), "string" == typeof i && n[i]()
		})
	}
	e.VERSION = "3.3.7", e.DEFAULTS = {
		offset: 10
	}, e.prototype.getScrollHeight = function() {
		return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	}, e.prototype.refresh = function() {
		var e = this,
			i = "offset",
			s = 0;
		this.offsets = [], this.targets = [], this.scrollHeight = this.getScrollHeight(), t.isWindow(this.$scrollElement[0]) || (i = "position", s = this.$scrollElement.scrollTop()), this.$body.find(this.selector).map(function() {
			var e = t(this),
				n = e.data("target") || e.attr("href"),
				a = /^#./.test(n) && t(n);
			return a && a.length && a.is(":visible") && [
				[a[i]().top + s, n]
			] || null
		}).sort(function(t, e) {
			return t[0] - e[0]
		}).each(function() {
			e.offsets.push(this[0]), e.targets.push(this[1])
		})
	}, e.prototype.process = function() {
		var t, e = this.$scrollElement.scrollTop() + this.options.offset,
			i = this.getScrollHeight(),
			s = this.options.offset + i - this.$scrollElement.height(),
			n = this.offsets,
			a = this.targets,
			o = this.activeTarget;
		if (this.scrollHeight != i && this.refresh(), e >= s) return o != (t = a[a.length - 1]) && this.activate(t);
		if (o && e < n[0]) return this.activeTarget = null, this.clear();
		for (t = n.length; t--;) o != a[t] && e >= n[t] && (void 0 === n[t + 1] || e < n[t + 1]) && this.activate(a[t])
	}, e.prototype.activate = function(e) {
		this.activeTarget = e, this.clear();
		var i = this.selector + '[data-target="' + e + '"],' + this.selector + '[href="' + e + '"]',
			s = t(i).parents("li").addClass("active");
		s.parent(".dropdown-menu").length && (s = s.closest("li.dropdown").addClass("active")), s.trigger("activate.bs.scrollspy")
	}, e.prototype.clear = function() {
		t(this.selector).parentsUntil(this.options.target, ".active").removeClass("active")
	};
	var s = t.fn.scrollspy;
	t.fn.scrollspy = i, t.fn.scrollspy.Constructor = e, t.fn.scrollspy.noConflict = function() {
		return t.fn.scrollspy = s, this
	}, t(window).on("load.bs.scrollspy.data-api", function() {
		t('[data-spy="scroll"]').each(function() {
			var e = t(this);
			i.call(e, e.data())
		})
	})
}(jQuery),
function(t) {
	"use strict";

	function e(e) {
		return this.each(function() {
			var s = t(this),
				n = s.data("bs.tab");
			n || s.data("bs.tab", n = new i(this)), "string" == typeof e && n[e]()
		})
	}
	var i = function(e) {
		this.element = t(e)
	};
	i.VERSION = "3.3.7", i.TRANSITION_DURATION = 150, i.prototype.show = function() {
		var e = this.element,
			i = e.closest("ul:not(.dropdown-menu)"),
			s = e.data("target");
		if (s || (s = (s = e.attr("href")) && s.replace(/.*(?=#[^\s]*$)/, "")), !e.parent("li").hasClass("active")) {
			var n = i.find(".active:last a"),
				a = t.Event("hide.bs.tab", {
					relatedTarget: e[0]
				}),
				o = t.Event("show.bs.tab", {
					relatedTarget: n[0]
				});
			if (n.trigger(a), e.trigger(o), !o.isDefaultPrevented() && !a.isDefaultPrevented()) {
				var r = t(s);
				this.activate(e.closest("li"), i), this.activate(r, r.parent(), function() {
					n.trigger({
						type: "hidden.bs.tab",
						relatedTarget: e[0]
					}), e.trigger({
						type: "shown.bs.tab",
						relatedTarget: n[0]
					})
				})
			}
		}
	}, i.prototype.activate = function(e, s, n) {
		function a() {
			o.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !1), e.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded", !0), r ? (e[0].offsetWidth, e.addClass("in")) : e.removeClass("fade"), e.parent(".dropdown-menu").length && e.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !0), n && n()
		}
		var o = s.find("> .active"),
			r = n && t.support.transition && (o.length && o.hasClass("fade") || !!s.find("> .fade").length);
		o.length && r ? o.one("bsTransitionEnd", a).emulateTransitionEnd(i.TRANSITION_DURATION) : a(), o.removeClass("in")
	};
	var s = t.fn.tab;
	t.fn.tab = e, t.fn.tab.Constructor = i, t.fn.tab.noConflict = function() {
		return t.fn.tab = s, this
	};
	var n = function(i) {
		i.preventDefault(), e.call(t(this), "show")
	};
	t(document).on("click.bs.tab.data-api", '[data-toggle="tab"]', n).on("click.bs.tab.data-api", '[data-toggle="pill"]', n)
}(jQuery),
function(t) {
	"use strict";

	function e(e) {
		return this.each(function() {
			var s = t(this),
				n = s.data("bs.affix"),
				a = "object" == typeof e && e;
			n || s.data("bs.affix", n = new i(this, a)), "string" == typeof e && n[e]()
		})
	}
	var i = function(e, s) {
		this.options = t.extend({}, i.DEFAULTS, s), this.$target = t(this.options.target).on("scroll.bs.affix.data-api", t.proxy(this.checkPosition, this)).on("click.bs.affix.data-api", t.proxy(this.checkPositionWithEventLoop, this)), this.$element = t(e), this.affixed = null, this.unpin = null, this.pinnedOffset = null, this.checkPosition()
	};
	i.VERSION = "3.3.7", i.RESET = "affix affix-top affix-bottom", i.DEFAULTS = {
		offset: 0,
		target: window
	}, i.prototype.getState = function(t, e, i, s) {
		var n = this.$target.scrollTop(),
			a = this.$element.offset(),
			o = this.$target.height();
		if (null != i && "top" == this.affixed) return n < i && "top";
		if ("bottom" == this.affixed) return null != i ? !(n + this.unpin <= a.top) && "bottom" : !(n + o <= t - s) && "bottom";
		var r = null == this.affixed,
			l = r ? n : a.top;
		return null != i && n <= i ? "top" : null != s && l + (r ? o : e) >= t - s && "bottom"
	}, i.prototype.getPinnedOffset = function() {
		if (this.pinnedOffset) return this.pinnedOffset;
		this.$element.removeClass(i.RESET).addClass("affix");
		var t = this.$target.scrollTop(),
			e = this.$element.offset();
		return this.pinnedOffset = e.top - t
	}, i.prototype.checkPositionWithEventLoop = function() {
		setTimeout(t.proxy(this.checkPosition, this), 1)
	}, i.prototype.checkPosition = function() {
		if (this.$element.is(":visible")) {
			var e = this.$element.height(),
				s = this.options.offset,
				n = s.top,
				a = s.bottom,
				o = Math.max(t(document).height(), t(document.body).height());
			"object" != typeof s && (a = n = s), "function" == typeof n && (n = s.top(this.$element)), "function" == typeof a && (a = s.bottom(this.$element));
			var r = this.getState(o, e, n, a);
			if (this.affixed != r) {
				null != this.unpin && this.$element.css("top", "");
				var l = "affix" + (r ? "-" + r : ""),
					d = t.Event(l + ".bs.affix");
				if (this.$element.trigger(d), d.isDefaultPrevented()) return;
				this.affixed = r, this.unpin = "bottom" == r ? this.getPinnedOffset() : null, this.$element.removeClass(i.RESET).addClass(l).trigger(l.replace("affix", "affixed") + ".bs.affix")
			}
			"bottom" == r && this.$element.offset({
				top: o - e - a
			})
		}
	};
	var s = t.fn.affix;
	t.fn.affix = e, t.fn.affix.Constructor = i, t.fn.affix.noConflict = function() {
		return t.fn.affix = s, this
	}, t(window).on("load", function() {
		t('[data-spy="affix"]').each(function() {
			var i = t(this),
				s = i.data();
			s.offset = s.offset || {}, null != s.offsetBottom && (s.offset.bottom = s.offsetBottom), null != s.offsetTop && (s.offset.top = s.offsetTop), e.call(i, s)
		})
	})
}(jQuery),
function(t, e) {
	var i = function(t, e) {
		"use strict";
		if (e.getElementsByClassName) {
			var i, s, n = e.documentElement,
				a = t.Date,
				o = t.HTMLPictureElement,
				r = "addEventListener",
				l = "getAttribute",
				d = t[r],
				c = t.setTimeout,
				h = t.requestAnimationFrame || c,
				u = t.requestIdleCallback,
				p = /^picture$/i,
				f = ["load", "error", "lazyincluded", "_lazyloaded"],
				m = {},
				g = Array.prototype.forEach,
				v = function(t, e) {
					return m[e] || (m[e] = new RegExp("(\\s|^)" + e + "(\\s|$)")), m[e].test(t[l]("class") || "") && m[e]
				},
				y = function(t, e) {
					v(t, e) || t.setAttribute("class", (t[l]("class") || "").trim() + " " + e)
				},
				b = function(t, e) {
					var i;
					(i = v(t, e)) && t.setAttribute("class", (t[l]("class") || "").replace(i, " "))
				},
				w = function(t, e, i) {
					var s = i ? r : "removeEventListener";
					i && w(t, e), f.forEach(function(i) {
						t[s](i, e)
					})
				},
				S = function(t, s, n, a, o) {
					var r = e.createEvent("Event");
					return n || (n = {}), n.instance = i, r.initEvent(s, !a, !o), r.detail = n, t.dispatchEvent(r), r
				},
				x = function(e, i) {
					var n;
					!o && (n = t.picturefill || s.pf) ? (i && i.src && !e[l]("srcset") && e.setAttribute("srcset", i.src), n({
						reevaluate: !0,
						elements: [e]
					})) : i && i.src && (e.src = i.src)
				},
				T = function(t, e) {
					return (getComputedStyle(t, null) || {})[e]
				},
				C = function(t, e, i) {
					for (i = i || t.offsetWidth; i < s.minSize && e && !t._lazysizesWidth;) i = e.offsetWidth, e = e.parentNode;
					return i
				},
				_ = function() {
					var t, i, s = [],
						n = [],
						a = s,
						o = function() {
							var e = a;
							for (a = s.length ? n : s, t = !0, i = !1; e.length;) e.shift()();
							t = !1
						},
						r = function(s, n) {
							t && !n ? s.apply(this, arguments) : (a.push(s), i || (i = !0, (e.hidden ? c : h)(o)))
						};
					return r._lsFlush = o, r
				}(),
				E = function(t, e) {
					return e ? function() {
						_(t)
					} : function() {
						var e = this,
							i = arguments;
						_(function() {
							t.apply(e, i)
						})
					}
				},
				P = function(t) {
					var e, i = 0,
						n = s.throttleDelay,
						o = s.ricTimeout,
						r = function() {
							e = !1, i = a.now(), t()
						},
						l = u && o > 49 ? function() {
							u(r, {
								timeout: o
							}), o !== s.ricTimeout && (o = s.ricTimeout)
						} : E(function() {
							c(r)
						}, !0);
					return function(t) {
						var s;
						(t = !0 === t) && (o = 33), e || (e = !0, 0 > (s = n - (a.now() - i)) && (s = 0), t || 9 > s ? l() : c(l, s))
					}
				},
				k = function(t) {
					var e, i, s = function() {
							e = null, t()
						},
						n = function() {
							var t = a.now() - i;
							99 > t ? c(n, 99 - t) : (u || s)(s)
						};
					return function() {
						i = a.now(), e || (e = c(n, 99))
					}
				};
			! function() {
				var e, i = {
					lazyClass: "lazyload",
					loadedClass: "lazyloaded",
					loadingClass: "lazyloading",
					preloadClass: "lazypreload",
					errorClass: "lazyerror",
					autosizesClass: "lazyautosizes",
					srcAttr: "data-src",
					srcsetAttr: "data-srcset",
					sizesAttr: "data-sizes",
					minSize: 40,
					customMedia: {},
					init: !0,
					expFactor: 1.5,
					hFac: .8,
					loadMode: 2,
					loadHidden: !0,
					ricTimeout: 0,
					throttleDelay: 125
				};
				for (e in s = t.lazySizesConfig || t.lazysizesConfig || {}, i) e in s || (s[e] = i[e]);
				t.lazySizesConfig = s, c(function() {
					s.init && D()
				})
			}();
			var $ = function() {
					var o, h, u, f, m, C, $, D, O, z, A, I, L, N, Y = /^img$/i,
						R = /^iframe$/i,
						j = "onscroll" in t && !/(gle|ing)bot/.test(navigator.userAgent),
						H = 0,
						B = 0,
						F = -1,
						W = function(t) {
							B--, t && t.target && w(t.target, W), (!t || 0 > B || !t.target) && (B = 0)
						},
						V = function(t, i) {
							var s, a = t,
								o = "hidden" == T(e.body, "visibility") || "hidden" != T(t.parentNode, "visibility") && "hidden" != T(t, "visibility");
							for (D -= i, A += i, O -= i, z += i; o && (a = a.offsetParent) && a != e.body && a != n;)(o = (T(a, "opacity") || 1) > 0) && "visible" != T(a, "overflow") && (s = a.getBoundingClientRect(), o = z > s.left && O < s.right && A > s.top - 1 && D < s.bottom + 1);
							return o
						},
						q = function() {
							var t, a, r, d, c, u, p, m, g, v = i.elements;
							if ((f = s.loadMode) && 8 > B && (t = v.length)) {
								a = 0, F++, null == L && ("expand" in s || (s.expand = n.clientHeight > 500 && n.clientWidth > 500 ? 500 : 370), I = s.expand, L = I * s.expFactor), L > H && 1 > B && F > 2 && f > 2 && !e.hidden ? (H = L, F = 0) : H = f > 1 && F > 1 && 6 > B ? I : 0;
								for (; t > a; a++)
									if (v[a] && !v[a]._lazyRace)
										if (j)
											if ((m = v[a][l]("data-expand")) && (u = 1 * m) || (u = H), g !== u && (C = innerWidth + u * N, $ = innerHeight + u, p = -1 * u, g = u), r = v[a].getBoundingClientRect(), (A = r.bottom) >= p && (D = r.top) <= $ && (z = r.right) >= p * N && (O = r.left) <= C && (A || z || O || D) && (s.loadHidden || "hidden" != T(v[a], "visibility")) && (h && 3 > B && !m && (3 > f || 4 > F) || V(v[a], u))) {
												if (J(v[a]), c = !0, B > 9) break
											} else !c && h && !d && 4 > B && 4 > F && f > 2 && (o[0] || s.preloadAfterLoad) && (o[0] || !m && (A || z || O || D || "auto" != v[a][l](s.sizesAttr))) && (d = o[0] || v[a]);
								else J(v[a]);
								d && !c && J(d)
							}
						},
						U = P(q),
						G = function(t) {
							y(t.target, s.loadedClass), b(t.target, s.loadingClass), w(t.target, Q), S(t.target, "lazyloaded")
						},
						X = E(G),
						Q = function(t) {
							X({
								target: t.target
							})
						},
						Z = function(t) {
							var e, i = t[l](s.srcsetAttr);
							(e = s.customMedia[t[l]("data-media") || t[l]("media")]) && t.setAttribute("media", e), i && t.setAttribute("srcset", i)
						},
						K = E(function(t, e, i, n, a) {
							var o, r, d, h, f, m;
							(f = S(t, "lazybeforeunveil", e)).defaultPrevented || (n && (i ? y(t, s.autosizesClass) : t.setAttribute("sizes", n)), r = t[l](s.srcsetAttr), o = t[l](s.srcAttr), a && (d = t.parentNode, h = d && p.test(d.nodeName || "")), m = e.firesLoad || "src" in t && (r || o || h), f = {
								target: t
							}, m && (w(t, W, !0), clearTimeout(u), u = c(W, 2500), y(t, s.loadingClass), w(t, Q, !0)), h && g.call(d.getElementsByTagName("source"), Z), r ? t.setAttribute("srcset", r) : o && !h && (R.test(t.nodeName) ? function(t, e) {
								try {
									t.contentWindow.location.replace(e)
								} catch (i) {
									t.src = e
								}
							}(t, o) : t.src = o), a && (r || h) && x(t, {
								src: o
							})), t._lazyRace && delete t._lazyRace, b(t, s.lazyClass), _(function() {
								(!m || t.complete && t.naturalWidth > 1) && (m ? W(f) : B--, G(f))
							}, !0)
						}),
						J = function(t) {
							var e, i = Y.test(t.nodeName),
								n = i && (t[l](s.sizesAttr) || t[l]("sizes")),
								a = "auto" == n;
							(!a && h || !i || !t[l]("src") && !t.srcset || t.complete || v(t, s.errorClass) || !v(t, s.lazyClass)) && (e = S(t, "lazyunveilread").detail, a && M.updateElem(t, !0, t.offsetWidth), t._lazyRace = !0, B++, K(t, e, a, n, i))
						},
						tt = function() {
							if (!h) {
								if (a.now() - m < 999) return void c(tt, 999);
								var t = k(function() {
									s.loadMode = 3, U()
								});
								h = !0, s.loadMode = 3, U(), d("scroll", function() {
									3 == s.loadMode && (s.loadMode = 2), t()
								}, !0)
							}
						};
					return {
						_: function() {
							m = a.now(), i.elements = e.getElementsByClassName(s.lazyClass), o = e.getElementsByClassName(s.lazyClass + " " + s.preloadClass), N = s.hFac, d("scroll", U, !0), d("resize", U, !0), t.MutationObserver ? new MutationObserver(U).observe(n, {
								childList: !0,
								subtree: !0,
								attributes: !0
							}) : (n[r]("DOMNodeInserted", U, !0), n[r]("DOMAttrModified", U, !0), setInterval(U, 999)), d("hashchange", U, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function(t) {
								e[r](t, U, !0)
							}), /d$|^c/.test(e.readyState) ? tt() : (d("load", tt), e[r]("DOMContentLoaded", U), c(tt, 2e4)), i.elements.length ? (q(), _._lsFlush()) : U()
						},
						checkElems: U,
						unveil: J
					}
				}(),
				M = function() {
					var t, i = E(function(t, e, i, s) {
							var n, a, o;
							if (t._lazysizesWidth = s, s += "px", t.setAttribute("sizes", s), p.test(e.nodeName || ""))
								for (n = e.getElementsByTagName("source"), a = 0, o = n.length; o > a; a++) n[a].setAttribute("sizes", s);
							i.detail.dataAttr || x(t, i.detail)
						}),
						n = function(t, e, s) {
							var n, a = t.parentNode;
							a && (s = C(t, a, s), (n = S(t, "lazybeforesizes", {
								width: s,
								dataAttr: !!e
							})).defaultPrevented || (s = n.detail.width) && s !== t._lazysizesWidth && i(t, a, n, s))
						},
						a = k(function() {
							var e, i = t.length;
							if (i)
								for (e = 0; i > e; e++) n(t[e])
						});
					return {
						_: function() {
							t = e.getElementsByClassName(s.autosizesClass), d("resize", a)
						},
						checkElems: a,
						updateElem: n
					}
				}(),
				D = function() {
					D.i || (D.i = !0, M._(), $._())
				};
			return i = {
				cfg: s,
				autoSizer: M,
				loader: $,
				init: D,
				uP: x,
				aC: y,
				rC: b,
				hC: v,
				fire: S,
				gW: C,
				rAF: _
			}
		}
	}(t, t.document);
	t.lazySizes = i, "object" == typeof module && module.exports && (module.exports = i)
}(window),
function(t, e) {
	var i = function() {
		e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0)
	};
	e = e.bind(null, t, t.document), "object" == typeof module && module.exports ? e(require("lazysizes")) : t.lazySizes ? i() : t.addEventListener("lazyunveilread", i, !0)
}(window, function(t, e, i) {
	"use strict";
	var s, n = e.createElement("img");
	!("srcset" in n) || "sizes" in n || t.HTMLPictureElement || (s = /^picture$/i, e.addEventListener("lazybeforeunveil", function(t) {
		var n, a, o, r, l, d, c;
		t.detail.instance == i && (!t.defaultPrevented && !lazySizesConfig.noIOSFix && (n = t.target) && (o = n.getAttribute(lazySizesConfig.srcsetAttr)) && (a = n.parentNode) && ((l = s.test(a.nodeName || "")) || (r = n.getAttribute("sizes") || n.getAttribute(lazySizesConfig.sizesAttr))) && (d = l ? a : e.createElement("picture"), n._lazyImgSrc || Object.defineProperty(n, "_lazyImgSrc", {
			value: e.createElement("source"),
			writable: !0
		}), c = n._lazyImgSrc, r && c.setAttribute("sizes", r), c.setAttribute(lazySizesConfig.srcsetAttr, o), n.setAttribute("data-pfsrcset", o), n.removeAttribute(lazySizesConfig.srcsetAttr), l || (a.insertBefore(d, n), d.appendChild(n)), d.insertBefore(c, n)))
	}))
}),
function(t, e) {
	var i = function() {
		e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0)
	};
	e = e.bind(null, t, t.document), "object" == typeof module && module.exports ? e(require("lazysizes")) : t.lazySizes ? i() : t.addEventListener("lazyunveilread", i, !0)
}(window, function(t, e, i) {
	"use strict";

	function s(e, i) {
		var s, n, a, o, r = t.getComputedStyle(e);
		for (s in n = e.parentNode, o = {
				isPicture: !(!n || !h.test(n.nodeName || ""))
			}, a = function(t, i) {
				var s = e.getAttribute("data-" + t);
				if (!s) {
					var n = r.getPropertyValue("--ls-" + t);
					n && (s = n.trim())
				}
				if (s) {
					if ("true" == s) s = !0;
					else if ("false" == s) s = !1;
					else if (c.test(s)) s = parseFloat(s);
					else if ("function" == typeof l[t]) s = l[t](e, s);
					else if (m.test(s)) try {
						s = JSON.parse(s)
					} catch (t) {}
					o[t] = s
				} else t in l && "function" != typeof l[t] ? o[t] = l[t] : i && "function" == typeof l[t] && (o[t] = l[t](e, s))
			}, l) a(s);
		return i.replace(f, function(t, e) {
			e in o || a(e, !0)
		}), o
	}

	function n(t, i, s) {
		var n = 0,
			a = 0,
			o = s;
		if (t) {
			if ("container" === i.ratio) {
				for (n = o.scrollWidth, a = o.scrollHeight; !(n && a || o === e);) n = (o = o.parentNode).scrollWidth, a = o.scrollHeight;
				n && a && (i.ratio = a / n)
			}(t = function(t, e) {
				var i = [];
				return i.srcset = [], e.absUrl && (v.setAttribute("href", t), t = v.href), t = ((e.prefix || "") + t + (e.postfix || "")).replace(f, function(t, i) {
					return d[typeof e[i]] ? e[i] : t
				}), e.widths.forEach(function(s) {
					var n = e.widthmap[s] || s,
						a = {
							u: t.replace(u, n).replace(p, e.ratio ? Math.round(s * e.ratio) : ""),
							w: s
						};
					i.push(a), i.srcset.push(a.c = a.u + " " + s + "w")
				}), i
			}(t, i)).isPicture = i.isPicture, b && "IMG" == s.nodeName.toUpperCase() ? s.removeAttribute(r.srcsetAttr) : s.setAttribute(r.srcsetAttr, t.srcset.join(", ")), Object.defineProperty(s, "_lazyrias", {
				value: t,
				writable: !0
			})
		}
	}

	function a(t, e) {
		var n = s(t, e);
		return l.modifyOptions.call(t, {
			target: t,
			details: n,
			detail: n
		}), i.fire(t, "lazyriasmodifyoptions", n), n
	}

	function o(t) {
		return t.getAttribute(t.getAttribute("data-srcattr") || l.srcAttr) || t.getAttribute(r.srcsetAttr) || t.getAttribute(r.srcAttr) || t.getAttribute("data-pfsrcset") || ""
	}
	var r, l, d = {
			string: 1,
			number: 1
		},
		c = /^\-*\+*\d+\.*\d*$/,
		h = /^picture$/i,
		u = /\s*\{\s*width\s*\}\s*/i,
		p = /\s*\{\s*height\s*\}\s*/i,
		f = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
		m = /^\[.*\]|\{.*\}$/,
		g = /^(?:auto|\d+(px)?)$/,
		v = e.createElement("a"),
		y = e.createElement("img"),
		b = "srcset" in y && !("sizes" in y),
		w = !!t.HTMLPictureElement && !b;
	! function() {
		var e, s = {
			prefix: "",
			postfix: "",
			srcAttr: "data-src",
			absUrl: !1,
			modifyOptions: function() {},
			widthmap: {},
			ratio: !1
		};
		for (e in (r = i && i.cfg || t.lazySizesConfig) || (r = {}, t.lazySizesConfig = r), r.supportsType || (r.supportsType = function(t) {
				return !t
			}), r.rias || (r.rias = {}), "widths" in (l = r.rias) || (l.widths = [], function(t) {
				for (var e, i = 0; !e || 3e3 > e;)(i += 5) > 30 && (i += 1), e = 36 * i, t.push(e)
			}(l.widths)), s) e in l || (l[e] = s[e])
	}(), addEventListener("lazybeforesizes", function(t) {
		var e, s, d, c, h, p, f, m, v, y, b, x, T;
		if (t.detail.instance == i && (e = t.target, t.detail.dataAttr && !t.defaultPrevented && !l.disabled && (v = e.getAttribute(r.sizesAttr) || e.getAttribute("sizes")) && g.test(v))) {
			if (d = a(e, s = o(e)), b = u.test(d.prefix) || u.test(d.postfix), d.isPicture && (c = e.parentNode))
				for (p = 0, f = (h = c.getElementsByTagName("source")).length; f > p; p++)(b || u.test(m = o(h[p]))) && (n(m, d, h[p]), x = !0);
			b || u.test(s) ? (n(s, d, e), x = !0) : x && ((T = []).srcset = [], T.isPicture = !0, Object.defineProperty(e, "_lazyrias", {
				value: T,
				writable: !0
			})), x && (w ? e.removeAttribute(r.srcAttr) : "auto" != v && (y = {
				width: parseInt(v, 10)
			}, S({
				target: e,
				detail: y
			})))
		}
	}, !0);
	var S = function() {
		var s = function(t, e) {
				return t.w - e.w
			},
			n = function(t, e) {
				var s;
				return !t._lazyrias && i.pWS && (s = i.pWS(t.getAttribute(r.srcsetAttr || ""))).length && (Object.defineProperty(t, "_lazyrias", {
					value: s,
					writable: !0
				}), e && t.parentNode && (s.isPicture = "PICTURE" == t.parentNode.nodeName.toUpperCase())), t._lazyrias
			},
			a = function(e) {
				var s = t.devicePixelRatio || 1,
					n = i.getX && i.getX(e);
				return Math.min(n || s, 2.4, s)
			},
			o = function(e, i) {
				var o, r, l, d, c, h;
				if ((c = e._lazyrias).isPicture && t.matchMedia)
					for (r = 0, l = (o = e.parentNode.getElementsByTagName("source")).length; l > r; r++)
						if (n(o[r]) && !o[r].getAttribute("type") && (!(d = o[r].getAttribute("media")) || (matchMedia(d) || {}).matches)) {
							c = o[r]._lazyrias;
							break
						} return (!c.w || c.w < i) && (c.w = i, c.d = a(e), h = function(t) {
					for (var e, i, s = t.length, n = t[s - 1], a = 0; s > a; a++)
						if ((n = t[a]).d = n.w / t.w, n.d >= t.d) {
							!n.cached && (e = t[a - 1]) && e.d > t.d - .13 * Math.pow(t.d, 2.2) && (i = Math.pow(e.d - .6, 1.6), e.cached && (e.d += .15 * i), e.d + (n.d - t.d) * i > t.d && (n = e));
							break
						} return n
				}(c.sort(s))), h
			},
			l = function(s) {
				if (s.detail.instance == i) {
					var a, d = s.target;
					return !b && (t.respimage || t.picturefill || lazySizesConfig.pf) ? void e.removeEventListener("lazybeforesizes", l) : void(("_lazyrias" in d || s.detail.dataAttr && n(d, !0)) && (a = o(d, s.detail.width), a && a.u && d._lazyrias.cur != a.u && (d._lazyrias.cur = a.u, a.cached = !0, i.rAF(function() {
						d.setAttribute(r.srcAttr, a.u), d.setAttribute("src", a.u)
					}))))
				}
			};
		return w ? l = function() {} : addEventListener("lazybeforesizes", l), l
	}()
}),
function(t, e) {
	var i = function() {
		e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0)
	};
	e = e.bind(null, t, t.document), "object" == typeof module && module.exports ? e(require("lazysizes")) : t.lazySizes ? i() : t.addEventListener("lazyunveilread", i, !0)
}(window, function(t, e, i) {
	"use strict";
	if (t.addEventListener) {
		var s = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
			n = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
			a = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
			o = /^picture$/i,
			r = {
				getParent: function(e, i) {
					var s = e,
						n = e.parentNode;
					return i && "prev" != i || !n || !o.test(n.nodeName || "") || (n = n.parentNode), "self" != i && (s = "prev" == i ? e.previousElementSibling : i && (n.closest || t.jQuery) && (n.closest ? n.closest(i) : jQuery(n).closest(i)[0]) || n), s
				},
				getFit: function(t) {
					var e, i, s = function(t) {
							return getComputedStyle(t, null) || {}
						}(t),
						o = s.content || s.fontFamily,
						l = {
							fit: t._lazysizesParentFit || t.getAttribute("data-parent-fit")
						};
					return !l.fit && o && (e = o.match(n)) && (l.fit = e[1]), l.fit ? (!(i = t._lazysizesParentContainer || t.getAttribute("data-parent-container")) && o && (e = o.match(a)) && (i = e[1]), l.parent = r.getParent(t, i)) : l.fit = s.objectFit, l
				},
				getImageRatio: function(e) {
					var i, n, a, r, l, d = e.parentNode,
						c = d && o.test(d.nodeName || "") ? d.querySelectorAll("source, img") : [e];
					for (i = 0; i < c.length; i++)
						if (n = (e = c[i]).getAttribute(lazySizesConfig.srcsetAttr) || e.getAttribute("srcset") || e.getAttribute("data-pfsrcset") || e.getAttribute("data-risrcset") || "", a = e._lsMedia || e.getAttribute("media"), a = lazySizesConfig.customMedia[e.getAttribute("data-media") || a] || a, n && (!a || (t.matchMedia && matchMedia(a) || {}).matches)) {
							!(r = parseFloat(e.getAttribute("data-aspectratio"))) && (l = n.match(s)) && (r = "w" == l[2] ? l[1] / l[3] : l[3] / l[1]);
							break
						} return r
				},
				calculateSize: function(t, e) {
					var i, s, n, a, o = this.getFit(t),
						r = o.fit,
						l = o.parent;
					return "width" == r || ("contain" == r || "cover" == r) && (n = this.getImageRatio(t)) ? (l ? e = l.clientWidth : l = t, a = e, "width" == r ? a = e : (s = l.clientHeight) > 40 && (i = e / s) && ("cover" == r && n > i || "contain" == r && i > n) && (a = e * (n / i)), a) : e
				}
			};
		i.parentFit = r, e.addEventListener("lazybeforesizes", function(t) {
			if (!t.defaultPrevented && t.detail.instance == i) {
				var e = t.target;
				t.detail.width = r.calculateSize(e, t.detail.width)
			}
		})
	}
}),
function(t, e) {
	var i = function() {
		e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0)
	};
	e = e.bind(null, t, t.document), "object" == typeof module && module.exports ? e(require("lazysizes"), require("../fix-ios-sizes/fix-ios-sizes")) : t.lazySizes ? i() : t.addEventListener("lazyunveilread", i, !0)
}(window, function(t, e, i) {
	"use strict";
	var s, n = i && i.cfg || t.lazySizesConfig,
		a = e.createElement("img"),
		o = "sizes" in a && "srcset" in a,
		r = /\s+\d+h/g,
		l = function() {
			var t = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
				i = Array.prototype.forEach;
			return function() {
				var s = e.createElement("img"),
					n = function(e) {
						var i, s, n = e.getAttribute(lazySizesConfig.srcsetAttr);
						n && ((s = n.match(t)) && ((i = "w" == s[2] ? s[1] / s[3] : s[3] / s[1]) && e.setAttribute("data-aspectratio", i)), e.setAttribute(lazySizesConfig.srcsetAttr, n.replace(r, "")))
					},
					a = function(t) {
						var e = t.target.parentNode;
						e && "PICTURE" == e.nodeName && i.call(e.getElementsByTagName("source"), n), n(t.target)
					},
					o = function() {
						s.currentSrc && e.removeEventListener("lazybeforeunveil", a)
					};
				e.addEventListener("lazybeforeunveil", a), s.onload = o, s.onerror = o, s.srcset = "data:,a 1w 1h", s.complete && o()
			}
		}();
	if (n || (n = {}, t.lazySizesConfig = n), n.supportsType || (n.supportsType = function(t) {
			return !t
		}), !t.picturefill && !n.pf) {
		if (t.HTMLPictureElement && o) return e.msElementsFromPoint && l(navigator.userAgent.match(/Edge\/(\d+)/)), void(n.pf = function() {});
		n.pf = function(e) {
			var i, n;
			if (!t.picturefill)
				for (i = 0, n = e.elements.length; n > i; i++) s(e.elements[i])
		}, s = function() {
			var a = function(t, e) {
					return t.w - e.w
				},
				l = /^\s*\d+\.*\d*px\s*$/,
				d = function() {
					var t, e = /(([^,\s].[^\s]+)\s+(\d+)w)/g,
						i = /\s/,
						s = function(e, i, s, n) {
							t.push({
								c: i,
								u: s,
								w: 1 * n
							})
						};
					return function(n) {
						return t = [], (n = n.trim()).replace(r, "").replace(e, s), t.length || !n || i.test(n) || t.push({
							c: n,
							u: n,
							w: 99
						}), t
					}
				}(),
				c = function() {
					var t, i, n;
					c.init || (c.init = !0, addEventListener("resize", (i = e.getElementsByClassName("lazymatchmedia"), n = function() {
						var t, e;
						for (t = 0, e = i.length; e > t; t++) s(i[t])
					}, function() {
						clearTimeout(t), t = setTimeout(n, 66)
					})))
				},
				h = function(e, s) {
					var a, o = e.getAttribute("srcset") || e.getAttribute(n.srcsetAttr);
					!o && s && (o = e._lazypolyfill ? e._lazypolyfill._set : e.getAttribute(n.srcAttr) || e.getAttribute("src")), e._lazypolyfill && e._lazypolyfill._set == o || (a = d(o || ""), s && e.parentNode && (a.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase(), a.isPicture && t.matchMedia && (i.aC(e, "lazymatchmedia"), c())), a._set = o, Object.defineProperty(e, "_lazypolyfill", {
						value: a,
						writable: !0
					}))
				},
				u = function(e) {
					var s = t.devicePixelRatio || 1,
						n = i.getX && i.getX(e);
					return Math.min(n || s, 2.5, s)
				},
				p = function(e) {
					return t.matchMedia ? (p = function(t) {
						return !t || (matchMedia(t) || {}).matches
					})(e) : !e
				},
				f = function(t) {
					var e, s, o, r, d, c, f;
					if (h(r = t, !0), (d = r._lazypolyfill).isPicture)
						for (s = 0, o = (e = t.parentNode.getElementsByTagName("source")).length; o > s; s++)
							if (n.supportsType(e[s].getAttribute("type"), t) && p(e[s].getAttribute("media"))) {
								r = e[s], h(r), d = r._lazypolyfill;
								break
							} return d.length > 1 ? (f = r.getAttribute("sizes") || "", f = l.test(f) && parseInt(f, 10) || i.gW(t, t.parentNode), d.d = u(t), !d.src || !d.w || d.w < f ? (d.w = f, c = function(t) {
						for (var e, i, s = t.length, n = t[s - 1], a = 0; s > a; a++)
							if ((n = t[a]).d = n.w / t.w, n.d >= t.d) {
								!n.cached && (e = t[a - 1]) && e.d > t.d - .13 * Math.pow(t.d, 2.2) && (i = Math.pow(e.d - .6, 1.6), e.cached && (e.d += .15 * i), e.d + (n.d - t.d) * i > t.d && (n = e));
								break
							} return n
					}(d.sort(a)), d.src = c) : c = d.src) : c = d[0], c
				},
				m = function(t) {
					if (!o || !t.parentNode || "PICTURE" == t.parentNode.nodeName.toUpperCase()) {
						var e = f(t);
						e && e.u && t._lazypolyfill.cur != e.u && (t._lazypolyfill.cur = e.u, e.cached = !0, t.setAttribute(n.srcAttr, e.u), t.setAttribute("src", e.u))
					}
				};
			return m.parse = d, m
		}(), n.loadedClass && n.loadingClass && function() {
			var t = [];
			['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function(e) {
				t.push(e + n.loadedClass), t.push(e + n.loadingClass)
			}), n.pf({
				elements: e.querySelectorAll(t.join(", "))
			})
		}()
	}
}),
function(t, e) {
	var i = function() {
		e(t.lazySizes), t.removeEventListener("lazyunveilread", i, !0)
	};
	e = e.bind(null, t, t.document), "object" == typeof module && module.exports ? e(require("lazysizes")) : t.lazySizes ? i() : t.addEventListener("lazyunveilread", i, !0)
}(window, function(t, e, i) {
	"use strict";
	if (t.addEventListener) {
		var s = /\s+/g,
			n = /\s*\|\s+|\s+\|\s*/g,
			a = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/,
			o = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/,
			r = /\(|\)|'/,
			l = {
				contain: 1,
				cover: 1
			},
			d = function(t, e) {
				if (e) {
					var i = e.match(o);
					i && i[1] ? t.setAttribute("type", i[1]) : t.setAttribute("media", lazySizesConfig.customMedia[e] || e)
				}
			},
			c = function(t, i, o) {
				var r = e.createElement("picture"),
					l = i.getAttribute(lazySizesConfig.sizesAttr),
					c = i.getAttribute("data-ratio"),
					h = i.getAttribute("data-optimumx");
				i._lazybgset && i._lazybgset.parentNode == i && i.removeChild(i._lazybgset), Object.defineProperty(o, "_lazybgset", {
					value: i,
					writable: !0
				}), Object.defineProperty(i, "_lazybgset", {
					value: r,
					writable: !0
				}), t = t.replace(s, " ").split(n), r.style.display = "none", o.className = lazySizesConfig.lazyClass, 1 != t.length || l || (l = "auto"), t.forEach(function(t) {
					var i, s = e.createElement("source");
					l && "auto" != l && s.setAttribute("sizes", l), (i = t.match(a)) ? (s.setAttribute(lazySizesConfig.srcsetAttr, i[1]), d(s, i[2]), d(s, i[3])) : s.setAttribute(lazySizesConfig.srcsetAttr, t), r.appendChild(s)
				}), l && (o.setAttribute(lazySizesConfig.sizesAttr, l), i.removeAttribute(lazySizesConfig.sizesAttr), i.removeAttribute("sizes")), h && o.setAttribute("data-optimumx", h), c && o.setAttribute("data-ratio", c), r.appendChild(o), i.appendChild(r)
			},
			h = function(t) {
				if (t.target._lazybgset) {
					var e = t.target,
						s = e._lazybgset,
						n = e.currentSrc || e.src;
					if (n) {
						var a = i.fire(s, "bgsetproxy", {
							src: n,
							useSrc: r.test(n) ? JSON.stringify(n) : n
						});
						a.defaultPrevented || (s.style.backgroundImage = "url(" + a.detail.useSrc + ")")
					}
					e._lazybgsetLoading && (i.fire(s, "_lazyloaded", {}, !1, !0), delete e._lazybgsetLoading)
				}
			};
		addEventListener("lazybeforeunveil", function(t) {
			var s, n, a;
			!t.defaultPrevented && (s = t.target.getAttribute("data-bgset")) && (a = t.target, (n = e.createElement("img")).alt = "", n._lazybgsetLoading = !0, t.detail.firesLoad = !0, c(s, a, n), setTimeout(function() {
				i.loader.unveil(n), i.rAF(function() {
					i.fire(n, "_lazyloaded", {}, !0, !0), n.complete && h({
						target: n
					})
				})
			}))
		}), e.addEventListener("load", h, !0), t.addEventListener("lazybeforesizes", function(t) {
			if (t.detail.instance == i && t.target._lazybgset && t.detail.dataAttr) {
				var e = function(t) {
					var e;
					return e = (getComputedStyle(t) || {
						getPropertyValue: function() {}
					}).getPropertyValue("background-size"), !l[e] && l[t.style.backgroundSize] && (e = t.style.backgroundSize), e
				}(t.target._lazybgset);
				l[e] && (t.target._lazysizesParentFit = e, i.rAF(function() {
					t.target.setAttribute("data-parent-fit", e), t.target._lazysizesParentFit && delete t.target._lazysizesParentFit
				}))
			}
		}, !0), e.documentElement.addEventListener("lazybeforesizes", function(t) {
			!t.defaultPrevented && t.target._lazybgset && t.detail.instance == i && (t.detail.width = function(t) {
				var e = i.gW(t, t.parentNode);
				return (!t._lazysizesWidth || e > t._lazysizesWidth) && (t._lazysizesWidth = e), t._lazysizesWidth
			}(t.target._lazybgset))
		})
	}
}),
function(t) {
	t.fn.extend({
		easyResponsiveTabs: function(e) {
			var i = e = t.extend({
					type: "default",
					width: "auto",
					fit: !0,
					closed: !1,
					tabidentify: "",
					activetab_bg: "white",
					inactive_bg: "#F5F5F5",
					active_border_color: "#c1c1c1",
					active_content_border_color: "#c1c1c1",
					activate: function() {}
				}, e),
				s = i.type,
				n = i.fit,
				a = i.width,
				o = "vertical",
				r = "accordion",
				l = window.location.hash,
				d = !(!window.history || !history.replaceState);
			t(".template-featured-product").length && (d = !1), t(this).bind("tabactivate", function(t, i) {
				"function" == typeof e.activate && e.activate.call(i, t)
			}), this.each(function() {
				var i, c = t(this),
					h = c.find("ul.resp-tabs-list." + e.tabidentify),
					u = c.attr("id");
				c.find("ul.resp-tabs-list." + e.tabidentify + " li").addClass("resp-tab-item").addClass(e.tabidentify), c.css({
						display: "block",
						width: a
					}), "vertical" == e.type && h.css("margin-top", "3px"), c.find(".resp-tabs-container." + e.tabidentify).css("border-color", e.active_content_border_color), c.find(".resp-tabs-container." + e.tabidentify + " > div").addClass("resp-tab-content").addClass(e.tabidentify),
					function() {
						s == o && c.addClass("resp-vtabs").addClass(e.tabidentify);
						1 == n && c.css({
							width: "100%",
							margin: "0px"
						});
						s == r && (c.addClass("resp-easy-accordion").addClass(e.tabidentify), c.find(".resp-tabs-list").css("display", "none"))
					}(), c.find(".resp-tab-content." + e.tabidentify).before("<h2 class='resp-accordion " + e.tabidentify + "' role='tab'><span class='resp-arrow'></span></h2>"), c.find(".resp-tab-content." + e.tabidentify).prev("h2").css({
						"background-color": e.inactive_bg,
						"border-color": e.active_border_color
					});
				var p = 0;
				c.find(".resp-accordion").each(function() {
					i = t(this);
					var s = c.find(".resp-tab-item:eq(" + p + ")"),
						n = c.find(".resp-accordion:eq(" + p + ")");
					n.append(s.html()), n.data(s.data()), i.attr("aria-controls", e.tabidentify + "_tab_item-" + p), p++
				});
				var f = 0;
				c.find(".resp-tab-item").each(function() {
					$tabItem = t(this), $tabItem.attr("aria-controls", e.tabidentify + "_tab_item-" + f), $tabItem.attr("role", "tab"), $tabItem.css({
						"background-color": e.inactive_bg,
						"border-color": "none"
					});
					var i = 0;
					c.find(".resp-tab-content." + e.tabidentify).each(function() {
						t(this).attr("aria-labelledby", e.tabidentify + "_tab_item-" + i).css({
							"border-color": e.active_border_color
						}), i++
					}), f++
				});
				var m = 0;
				if ("" != l) {
					var g = l.match(new RegExp(u + "([0-9]+)"));
					null !== g && 2 === g.length && (m = parseInt(g[1], 10) - 1) > f && (m = 0)
				}
				t(c.find(".resp-tab-item." + e.tabidentify)[m]).addClass("resp-tab-active").css({
					"background-color": e.activetab_bg,
					"border-color": e.active_border_color
				}), !0 === e.closed || "accordion" === e.closed && !h.is(":visible") || "tabs" === e.closed && h.is(":visible") || (t(c.find(".resp-accordion." + e.tabidentify)[m]).addClass("resp-tab-active").css({
					"background-color": e.activetab_bg + " !important",
					"border-color": e.active_border_color,
					background: "none"
				}), t(c.find(".resp-tab-content." + e.tabidentify)[m]).addClass("resp-tab-content-active").addClass(e.tabidentify).attr("style", "display:block")), c.find("[role=tab]").each(function() {
					t(this).click(function() {
						var i = t(this),
							s = i.attr("aria-controls");
						if (i.hasClass("resp-accordion") && i.hasClass("resp-tab-active")) return c.find(".resp-tab-content-active." + e.tabidentify).slideUp("", function() {
							t(this).addClass("resp-accordion-closed")
						}), i.removeClass("resp-tab-active").css({
							"background-color": e.inactive_bg,
							"border-color": "none"
						}), !1;
						if (!i.hasClass("resp-tab-active") && i.hasClass("resp-accordion") ? (c.find(".resp-tab-active." + e.tabidentify).removeClass("resp-tab-active").css({
								"background-color": e.inactive_bg,
								"border-color": "none"
							}), c.find(".resp-tab-content-active." + e.tabidentify).slideUp().removeClass("resp-tab-content-active resp-accordion-closed"), c.find("[aria-controls=" + s + "]").addClass("resp-tab-active").css({
								"background-color": e.activetab_bg,
								"border-color": e.active_border_color
							}), c.find(".resp-tab-content[aria-labelledby = " + s + "]." + e.tabidentify).slideDown().addClass("resp-tab-content-active")) : (console.log("here"), c.find(".resp-tab-active." + e.tabidentify).removeClass("resp-tab-active").css({
								"background-color": e.inactive_bg,
								"border-color": "none"
							}), c.find(".resp-tab-content-active." + e.tabidentify).removeAttr("style").removeClass("resp-tab-content-active").removeClass("resp-accordion-closed"), c.find("[aria-controls=" + s + "]").addClass("resp-tab-active").css({
								"background-color": e.activetab_bg,
								"border-color": e.active_border_color
							}), c.find(".resp-tab-content[aria-labelledby = " + s + "]." + e.tabidentify).addClass("resp-tab-content-active").attr("style", "display:block")), d) {
							var n = window.location.hash,
								a = (s.split("tab_item-"), c.find("ul.resp-tabs-list li.resp-tab-active").attr("id"));
							if ("" != n) {
								var o = c.find("ul.resp-tabs-list li.resp-tab-active").attr("id");
								a = null != n.match(o) ? n.replace(o, a) : "#tab=" + a
							} else a = "#tab=" + a;
							history.replaceState(null, null, a)
						}
						i.trigger("tabactivate", i)
					})
				}), t(window).resize(function() {
					c.find(".resp-accordion-closed").removeAttr("style")
				})
			})
		}
	})
}(jQuery),
function(t, e) {
	"use strict";
	e.AccordionSlider = {
		modules: {},
		addModule: function(t, i, a) {
			void 0 === this.modules[a] && (this.modules[a] = []), this.modules[a].push(t), "accordion" === a ? e.extend(s.prototype, i) : "panel" === a && e.extend(n.prototype, i)
		}
	};
	var i = e.AccordionSlider.namespace = "AccordionSlider",
		s = function(t, i) {
			this.$accordion = e(t), this.$panelsContainer = null, this.$maskContainer = null, this.options = i, this.settings = {}, this.originalSettings = {}, this.currentIndex = -1, this.currentPage = 0, this.totalSize = 0, this.totalPanelsSize = 0, this.computedOpenedPanelSize = 0, this.maxComputedOpenedPanelSize = 0, this.collapsedPanelSize = 0, this.closedPanelSize = 0, this.computedPanelDistance = 0, this.panels = [], this.mouseDelayTimer = 0, this.openPanelAnimation = {}, this.closePanelsAnimation = {}, this.uniqueId = (new Date).valueOf(), this.breakpoints = [], this.currentBreakpoint = -1, this.previousVisiblePanels = -1, this.isPageScrolling = !1, this.positionProperty = "left", this.sizeProperty = "width", this.autoResponsiveRatio = 1, this.isOverlapping = !1, this._init()
		};
	s.prototype = {
		_init: function() {
			var s = this;
			this.$accordion.removeClass("as-no-js"), this.$maskContainer = e('<div class="as-mask"></div>').appendTo(this.$accordion), this.$panelsContainer = this.$accordion.find(".as-panels").appendTo(this.$maskContainer), 0 === this.$panelsContainer.length && (this.$panelsContainer = e('<div class="as-panels"></div>').appendTo(this.$maskContainer));
			var n = e.AccordionSlider.modules.accordion;
			if (void 0 !== n)
				for (var a = 0; a < n.length; a++) {
					var o = n[a] + "Defaults";
					void 0 !== this[o] ? e.extend(this.defaults, this[o]) : void 0 !== this[o = n[a].substring(0, 1).toLowerCase() + n[a].substring(1) + "Defaults"] && e.extend(this.defaults, this[o])
				}
			if (this.settings = e.extend({}, this.defaults, this.options), void 0 !== n)
				for (var r = 0; r < n.length; r++) void 0 !== this["init" + n[r]] && this["init" + n[r]]();
			if (this.originalSettings = e.extend({}, this.settings), !0 === this.settings.shuffle) {
				var l = this.$panelsContainer.find(".as-panel").sort(function() {
					return .5 - Math.random()
				});
				this.$panelsContainer.empty().append(l)
			}
			if (this.currentIndex = this.settings.startPanel, -1 === this.currentIndex ? this.$accordion.addClass("as-closed") : this.$accordion.addClass("as-opened"), -1 !== this.settings.startPage && (this.currentPage = this.settings.startPage), null !== this.settings.breakpoints) {
				for (var d in this.settings.breakpoints) this.breakpoints.push({
					size: parseInt(d, 10),
					properties: this.settings.breakpoints[d]
				});
				this.breakpoints = this.breakpoints.sort(function(t, e) {
					return t.size >= e.size ? 1 : -1
				})
			}
			if (this._prepareRAF(), this.update(), -1 !== this.currentIndex) {
				this.$accordion.find(".as-panel").eq(this.currentIndex).addClass("as-opened");
				var c = {
					type: "panelOpen",
					index: this.currentIndex,
					previousIndex: -1
				};
				this.trigger(c), e.isFunction(this.settings.panelOpen) && this.settings.panelOpen.call(this, c)
			}
			this.on("mouseenter." + i, function() {
				var t = {
					type: "accordionMouseOver"
				};
				s.trigger(t), e.isFunction(s.settings.accordionMouseOver) && s.settings.accordionMouseOver.call(s, t)
			}), this.on("mouseleave." + i, function() {
				clearTimeout(s.mouseDelayTimer), !0 === s.settings.closePanelsOnMouseOut && s.closePanels();
				var t = {
					type: "accordionMouseOut"
				};
				s.trigger(t), e.isFunction(s.settings.accordionMouseOut) && s.settings.accordionMouseOut.call(s, t)
			}), e(t).on("resize." + this.uniqueId + "." + i, function() {
				s.resize()
			}), this.trigger({
				type: "init"
			}), e.isFunction(this.settings.init) && this.settings.init.call(this, {
				type: "init"
			})
		},
		update: function() {
			var t = this;
			if ("horizontal" === this.settings.orientation ? (this.$accordion.removeClass("as-vertical").addClass("as-horizontal"), this.positionProperty = "left", this.sizeProperty = "width") : "vertical" === this.settings.orientation && (this.$accordion.removeClass("as-horizontal").addClass("as-vertical"), this.positionProperty = "top", this.sizeProperty = "height"), -1 === this.settings.visiblePanels) this.currentPage = 0;
			else if (-1 !== this.currentIndex) this.currentPage = Math.floor(this.currentIndex / this.settings.visiblePanels);
			else if (this.settings.visiblePanels !== this.previousVisiblePanels && -1 !== this.previousVisiblePanels) {
				var i = Math.round(this.currentPage * this.previousVisiblePanels / this.settings.visiblePanels);
				this.currentPage !== i && (this.currentPage = i)
			}
			this.settings.panelDistance > 0 || !1 === this.settings.panelOverlap ? (this.isOverlapping = !1, this.$accordion.removeClass("as-overlap")) : !0 === this.settings.panelOverlap && (this.isOverlapping = !0, this.$accordion.addClass("as-overlap")), this.$accordion.find("img.as-background, img.as-background-opened").css({
				width: "",
				height: ""
			}), this._updatePanels(), this._updatePaginationButtons(), !0 === this.settings.shadow ? this.$accordion.find(".as-panel").addClass("as-shadow") : !1 === this.settings.shadow && this.$accordion.find(".as-shadow").removeClass("as-shadow"), this.$panelsContainer.attr("style", ""), this.resize();
			var s = {
				type: "update"
			};
			t.trigger(s), e.isFunction(t.settings.update) && t.settings.update.call(t, s)
		},
		_updatePanels: function() {
			for (var t = this, s = this.panels.length - 1; s >= 0; s--)
				if (0 === this.$accordion.find('.as-panel[data-index="' + s + '"]').length) {
					var n = this.panels[s];
					n.off("panelMouseOver." + i), n.off("panelMouseOut." + i), n.off("panelClick." + i), n.off("imagesComplete." + i), n.destroy(), this.panels.splice(s, 1)
				} this.$accordion.find(".as-panel").each(function(i, s) {
				var n = e(s);
				void 0 === n.attr("data-init") ? t._createPanel(i, n) : (t.panels[i].setIndex(i), t.panels[i].update())
			})
		},
		_createPanel: function(t, s) {
			var a = this,
				o = e(s),
				r = new n(o, this, t);
			this.panels.splice(t, 0, r), r.on("panelMouseOver." + i, function(i) {
				if (!0 !== a.isPageScrolling) {
					"hover" === a.settings.openPanelOn && (clearTimeout(a.mouseDelayTimer), a.mouseDelayTimer = setTimeout(function() {
						a.openPanel(i.index)
					}, a.settings.mouseDelay));
					var s = {
						type: "panelMouseOver",
						index: t
					};
					a.trigger(s), e.isFunction(a.settings.panelMouseOver) && a.settings.panelMouseOver.call(a, s)
				}
			}), r.on("panelMouseOut." + i, function() {
				if (!0 !== a.isPageScrolling) {
					var i = {
						type: "panelMouseOut",
						index: t
					};
					a.trigger(i), e.isFunction(a.settings.panelMouseOut) && a.settings.panelMouseOut.call(a, i)
				}
			}), r.on("panelClick." + i, function(i) {
				if (!a.$accordion.hasClass("as-swiping")) {
					"click" === a.settings.openPanelOn && (t !== a.currentIndex ? a.openPanel(i.index) : a.closePanels());
					var s = {
						type: "panelClick",
						index: t
					};
					a.trigger(s), e.isFunction(a.settings.panelClick) && a.settings.panelClick.call(a, s)
				}
			}), r.on("panelMouseDown." + i, function() {
				e(this).find("a").off("click.disablePanelLink"), t !== a.currentIndex && "click" === a.settings.openPanelOn && e(this).find("a").one("click.disablePanelLink", function(t) {
					t.preventDefault()
				})
			}), r.on("imagesComplete." + i, function(t) {
				t.index === a.currentIndex && t.contentSize !== a.computedOpenedPanelSize && a.openPanel(t.index, !0)
			})
		},
		removePanels: function() {
			e.each(this.panels, function(t, e) {
				e.off("panelMouseOver." + i), e.off("panelMouseOut." + i), e.off("panelClick." + i), e.off("imagesComplete." + i), e.destroy()
			}), this.panels.length = 0
		},
		resize: function() {
			var i = this;
			if (this.$maskContainer.attr("style", ""), !0 === this.settings.responsive ? (this.$accordion.css({
					width: "100%",
					height: this.settings.height,
					maxWidth: this.settings.width,
					maxHeight: this.settings.height
				}), -1 === this.settings.aspectRatio && (this.settings.aspectRatio = this.settings.width / this.settings.height), this.$accordion.css("height", this.$accordion.innerWidth() / this.settings.aspectRatio), "auto" === this.settings.responsiveMode ? (this.autoResponsiveRatio = this.$accordion.innerWidth() / this.settings.width, this.$maskContainer.css({
					width: this.settings.width,
					height: this.settings.height
				}), this.autoResponsiveRatio < 1 ? this.$maskContainer.css({
					"-webkit-transform": "scaleX(" + this.autoResponsiveRatio + ") scaleY(" + this.autoResponsiveRatio + ")",
					"-ms-transform": "scaleX(" + this.autoResponsiveRatio + ") scaleY(" + this.autoResponsiveRatio + ")",
					transform: "scaleX(" + this.autoResponsiveRatio + ") scaleY(" + this.autoResponsiveRatio + ")",
					"-webkit-transform-origin": "top left",
					"-ms-transform-origin": "top left",
					"transform-origin": "top left"
				}) : this.$maskContainer.css({
					"-webkit-transform": "",
					"-ms-transform": "",
					transform: "",
					"-webkit-transform-origin": "",
					"-ms-transform-origin": "",
					"transform-origin": ""
				}), this.totalSize = "horizontal" === this.settings.orientation ? this.$maskContainer.innerWidth() : this.$maskContainer.innerHeight()) : this.totalSize = "horizontal" === this.settings.orientation ? this.$accordion.innerWidth() : this.$accordion.innerHeight()) : (this.$accordion.css({
					width: this.settings.width,
					height: this.settings.height,
					maxWidth: "",
					maxHeight: ""
				}), this.totalSize = "horizontal" === this.settings.orientation ? this.$accordion.innerWidth() : this.$accordion.innerHeight()), "horizontal" === this.settings.orientation ? this.$accordion.find("img.as-background, img.as-background-opened").css("height", this.$panelsContainer.innerHeight()) : this.$accordion.find("img.as-background, img.as-background-opened").css("width", this.$panelsContainer.innerWidth()), this.computedPanelDistance = this.settings.panelDistance, "string" == typeof this.computedPanelDistance && (-1 !== this.computedPanelDistance.indexOf("%") ? this.computedPanelDistance = this.totalSize * (parseInt(this.computedPanelDistance, 10) / 100) : -1 !== this.computedPanelDistance.indexOf("px") && (this.computedPanelDistance = parseInt(this.computedPanelDistance, 10))), this.closedPanelSize = (this.totalSize - (this.getVisiblePanels() - 1) * this.computedPanelDistance) / this.getVisiblePanels(), this.closedPanelSize = Math.floor(this.closedPanelSize), this.computedOpenedPanelSize = this.settings.openedPanelSize, "max" === this.settings.openedPanelSize && (this.maxComputedOpenedPanelSize = this.settings.maxOpenedPanelSize, "string" == typeof this.maxComputedOpenedPanelSize && (-1 !== this.maxComputedOpenedPanelSize.indexOf("%") ? this.maxComputedOpenedPanelSize = this.totalSize * (parseInt(this.maxComputedOpenedPanelSize, 10) / 100) : -1 !== this.maxComputedOpenedPanelSize.indexOf("px") && (this.maxComputedOpenedPanelSize = parseInt(this.maxComputedOpenedPanelSize, 10)))), "string" == typeof this.computedOpenedPanelSize)
				if (-1 !== this.computedOpenedPanelSize.indexOf("%")) this.computedOpenedPanelSize = this.totalSize * (parseInt(this.computedOpenedPanelSize, 10) / 100);
				else if (-1 !== this.computedOpenedPanelSize.indexOf("px")) this.computedOpenedPanelSize = parseInt(this.computedOpenedPanelSize, 10);
			else if ("max" === this.computedOpenedPanelSize && -1 !== this.currentIndex) {
				var s = this.getPanelAt(this.currentIndex).getContentSize();
				this.computedOpenedPanelSize = "loading" === s ? this.closedPanelSize : Math.min(s, this.maxComputedOpenedPanelSize)
			}
			if (this.collapsedPanelSize = (this.totalSize - this.computedOpenedPanelSize - (this.getVisiblePanels() - 1) * this.computedPanelDistance) / (this.getVisiblePanels() - 1), this.computedOpenedPanelSize = Math.floor(this.computedOpenedPanelSize), this.collapsedPanelSize = Math.floor(this.collapsedPanelSize), this.totalPanelsSize = this.closedPanelSize * this.getTotalPanels() + this.computedPanelDistance * (this.getTotalPanels() - 1), this.$panelsContainer.css(this.sizeProperty, this.totalPanelsSize), this.totalSize = this.closedPanelSize * this.getVisiblePanels() + this.computedPanelDistance * (this.getVisiblePanels() - 1), "custom" === this.settings.responsiveMode || !1 === this.settings.responsive ? this.$accordion.css(this.sizeProperty, this.totalSize) : (this.$accordion.css(this.sizeProperty, this.totalSize * this.autoResponsiveRatio), this.$maskContainer.css(this.sizeProperty, this.totalSize)), -1 !== this.settings.visiblePanels) {
				var n = {},
					a = -(this.totalSize + this.computedPanelDistance) * this.currentPage;
				this.currentPage === this.getTotalPages() - 1 && (a = -(this.closedPanelSize * this.getTotalPanels() + this.computedPanelDistance * (this.getTotalPanels() - 1) - this.totalSize)), n[this.positionProperty] = a, this.$panelsContainer.css(n)
			}
			var o = this.currentPage === this.getTotalPages() - 1 && 0 != this.getTotalPanels() % this.settings.visiblePanels ? this.settings.visiblePanels - this.getTotalPanels() % this.settings.visiblePanels : 0;
			if (e.each(this.panels, function(t, e) {
					var s;
					if (-1 === i.currentIndex ? s = t * (i.closedPanelSize + i.computedPanelDistance) : -1 === i.settings.visiblePanels ? s = t * (i.collapsedPanelSize + i.computedPanelDistance) + (t > i.currentIndex ? i.computedOpenedPanelSize - i.collapsedPanelSize : 0) : i._getPageOfPanel(t) === i.currentPage ? (s = i.currentPage * (i.totalSize + i.computedPanelDistance) + (t + o - i.currentPage * i.settings.visiblePanels) * (i.collapsedPanelSize + i.computedPanelDistance) + (t > i.currentIndex ? i.computedOpenedPanelSize - i.collapsedPanelSize : 0), i.currentPage === i.getTotalPages() - 1 && 0 !== o && (s -= (i.getTotalPages() - i.getTotalPanels() / i.settings.visiblePanels) * (i.totalSize + i.computedPanelDistance))) : s = t * (i.closedPanelSize + i.computedPanelDistance), e.setPosition(s), !1 === i.isOverlapping) {
						var n = -1 === i.currentIndex || -1 !== i.settings.visiblePanels && i._getPageOfPanel(t) !== i.currentPage ? i.closedPanelSize : t === i.currentIndex ? i.computedOpenedPanelSize : i.collapsedPanelSize;
						e.setSize(n)
					}
				}), null !== this.settings.breakpoints && this.breakpoints.length > 0)
				if (e(t).width() > this.breakpoints[this.breakpoints.length - 1].size && -1 !== this.currentBreakpoint) this.currentBreakpoint = -1, this._setProperties(this.originalSettings, !1);
				else
					for (var r = 0, l = this.breakpoints.length; l > r; r++)
						if (e(t).width() <= this.breakpoints[r].size) {
							if (this.currentBreakpoint !== this.breakpoints[r].size) {
								var d = {
									type: "breakpointReach",
									size: this.breakpoints[r].size,
									settings: this.breakpoints[r].properties
								};
								i.trigger(d), e.isFunction(i.settings.breakpointReach) && i.settings.breakpointReach.call(i, d), this.currentBreakpoint = this.breakpoints[r].size;
								var c = e.extend({}, this.originalSettings, this.breakpoints[r].properties);
								this._setProperties(c, !1)
							}
							break
						}
		},
		_setProperties: function(t, e) {
			for (var i in t) "visiblePanels" === i && -1 !== this.settings.visiblePanels && (this.previousVisiblePanels = this.settings.visiblePanels), this.settings[i] = t[i], !1 !== e && (this.originalSettings[i] = t[i]);
			this.update()
		},
		destroy: function() {
			this.$accordion.removeData("accordionSlider"), this.$accordion.attr("style", ""), this.$panelsContainer.attr("style", ""), this.off("mouseenter." + i), this.off("mouseleave." + i), e(t).off("resize." + this.uniqueId + "." + i), this._stopPanelsAnimation(this.openPanelAnimation), this._stopPanelsAnimation(this.closePanelsAnimation);
			var s = e.AccordionSlider.modules.accordion;
			if (void 0 !== s)
				for (var n = 0; n < s.length; n++) void 0 !== this["destroy" + s[n]] && this["destroy" + s[n]]();
			this.removePanels(), this.$panelsContainer.appendTo(this.$accordion), this.$maskContainer.remove(), this.$accordion.find(".as-pagination-buttons").remove()
		},
		on: function(t, e) {
			return this.$accordion.on(t, e)
		},
		off: function(t) {
			return this.$accordion.off(t)
		},
		trigger: function(t) {
			return this.$accordion.triggerHandler(t)
		},
		getPanelAt: function(t) {
			return this.panels[t]
		},
		getCurrentIndex: function() {
			return this.currentIndex
		},
		getTotalPanels: function() {
			return this.panels.length
		},
		nextPanel: function() {
			var t = this.currentIndex >= this.getTotalPanels() - 1 ? 0 : this.currentIndex + 1;
			this.openPanel(t)
		},
		previousPanel: function() {
			var t = this.currentIndex <= 0 ? this.getTotalPanels() - 1 : this.currentIndex - 1;
			this.openPanel(t)
		},
		_animatePanels: function(e, i) {
			var s = (new Date).valueOf(),
				n = 0;
			e.isRunning = !0, e.timer = t.requestAnimationFrame(function a() {
				1 > n ? ((n = ((new Date).valueOf() - s) / i.duration) > 1 && (n = 1), n = .5 - Math.cos(n * Math.PI) / 2, i.step(n), e.timer = t.requestAnimationFrame(a)) : (i.complete(), e.isRunning = !1, t.cancelAnimationFrame(e.timer))
			})
		},
		_stopPanelsAnimation: function(e) {
			void 0 !== e.isRunning && !0 === e.isRunning && (e.isRunning = !1, t.cancelAnimationFrame(e.timer))
		},
		_prepareRAF: function() {
			if (void 0 === t.requestAnimationFrame)
				for (var e = ["webkit", "moz"], i = 0; i < e.length; i++) t.requestAnimationFrame = t[e[i] + "RequestAnimationFrame"], t.cancelAnimationFrame = t.cancelAnimationFrame || t[e[i] + "CancelAnimationFrame"] || t[e[i] + "CancelRequestAnimationFrame"];
			if (void 0 === t.requestAnimationFrame) {
				var s = 0;
				t.requestAnimationFrame = function(e) {
					var i = (new Date).valueOf(),
						n = Math.max(0, 16 - (i - s)),
						a = t.setTimeout(function() {
							e(i + n)
						}, n);
					return s = i + n, a
				}, t.cancelAnimationFrame = function(t) {
					clearTimeout(t)
				}
			}
		},
		openPanel: function(t, i) {
			if (t !== this.currentIndex || !0 === i) {
				!1 === this.$accordion.hasClass("as-opened") && (this.$accordion.removeClass("as-closed"), this.$accordion.addClass("as-opened"));
				var s = this.currentIndex;
				if (this.currentIndex = t, -1 !== this.settings.visiblePanels && !(this.currentPage === this.getTotalPages() - 1 && t >= this.getTotalPanels() - this.settings.visiblePanels)) {
					var n = Math.floor(this.currentIndex / this.settings.visiblePanels);
					n !== this.currentPage && this.gotoPage(n), this.currentIndex = t
				}
				var a = this,
					o = [],
					r = [],
					l = [],
					d = [],
					c = [],
					h = this._getFirstPanelFromPage(),
					u = this._getLastPanelFromPage(),
					p = 0;
				if (this.$accordion.find(".as-panel.as-opened").removeClass("as-opened"), this.$accordion.find(".as-panel").eq(this.currentIndex).addClass("as-opened"), "max" === this.settings.openedPanelSize) {
					var f = this.getPanelAt(this.currentIndex).getContentSize();
					this.computedOpenedPanelSize = "loading" === f ? this.closedPanelSize : Math.min(f, this.maxComputedOpenedPanelSize), this.collapsedPanelSize = (this.totalSize - this.computedOpenedPanelSize - (this.getVisiblePanels() - 1) * this.computedPanelDistance) / (this.getVisiblePanels() - 1)
				}
				for (var m = h; u >= m; m++) {
					var g = this.getPanelAt(m);
					d[m] = g.getPosition(), r[m] = this.currentPage * (this.totalSize + this.computedPanelDistance) + p * (this.collapsedPanelSize + this.computedPanelDistance) + (m > this.currentIndex ? this.computedOpenedPanelSize - this.collapsedPanelSize : 0), -1 !== this.settings.visiblePanels && this.currentPage === this.getTotalPages() - 1 && (r[m] -= (this.getTotalPages() - this.getTotalPanels() / this.settings.visiblePanels) * (this.totalSize + this.computedPanelDistance)), r[m] !== d[m] && c.push(m), !1 === this.isOverlapping && (l[m] = g.getSize(), o[m] = m === this.currentIndex ? this.computedOpenedPanelSize : this.collapsedPanelSize, o[m] !== l[m] && -1 === e.inArray(m, c) && c.push(m)), p++
				}
				var v = c.length;
				this.closePanelsAnimation.page === this.currentPage && this._stopPanelsAnimation(this.closePanelsAnimation), this._stopPanelsAnimation(this.openPanelAnimation), this.openPanelAnimation.page = this.currentPage, this._animatePanels(this.openPanelAnimation, {
					duration: this.settings.openPanelDuration,
					step: function(t) {
						for (var e = 0; v > e; e++) {
							var i = c[e],
								s = a.getPanelAt(i);
							s.setPosition(t * (r[i] - d[i]) + d[i]), !1 === a.isOverlapping && s.setSize(t * (o[i] - l[i]) + l[i])
						}
					},
					complete: function() {
						var t = {
							type: "panelOpenComplete",
							index: a.currentIndex
						};
						a.trigger(t), e.isFunction(a.settings.panelOpenComplete) && a.settings.panelOpenComplete.call(a, t)
					}
				});
				var y = {
					type: "panelOpen",
					index: t,
					previousIndex: s
				};
				this.trigger(y), e.isFunction(this.settings.panelOpen) && this.settings.panelOpen.call(this, y)
			}
		},
		closePanels: function() {
			var t = this.currentIndex;
			this.currentIndex = -1, !1 === this.$accordion.hasClass("as-closed") && (this.$accordion.removeClass("as-opened"), this.$accordion.addClass("as-closed")), this.$accordion.find(".as-panel.as-opened").removeClass("as-opened"), clearTimeout(this.mouseDelayTimer);
			for (var i = this, s = [], n = [], a = [], o = [], r = this._getFirstPanelFromPage(), l = this._getLastPanelFromPage(), d = 0, c = r; l >= c; c++) {
				var h = this.getPanelAt(c);
				o[c] = h.getPosition(), n[c] = this.currentPage * (this.totalSize + this.computedPanelDistance) + d * (this.closedPanelSize + this.computedPanelDistance), -1 !== this.settings.visiblePanels && this.currentPage === this.getTotalPages() - 1 && (n[c] -= (this.getTotalPages() - this.getTotalPanels() / this.settings.visiblePanels) * (this.totalSize + this.computedPanelDistance)), !1 === this.isOverlapping && (a[c] = h.getSize(), s[c] = this.closedPanelSize), d++
			}
			this.openPanelAnimation.page === this.currentPage && this._stopPanelsAnimation(this.openPanelAnimation), this._stopPanelsAnimation(this.closePanelsAnimation), this.closePanelsAnimation.page = this.currentPage, this._animatePanels(this.closePanelsAnimation, {
				duration: this.settings.closePanelDuration,
				step: function(t) {
					for (var e = r; l >= e; e++) {
						var d = i.getPanelAt(e);
						d.setPosition(t * (n[e] - o[e]) + o[e]), !1 === i.isOverlapping && d.setSize(t * (s[e] - a[e]) + a[e])
					}
				},
				complete: function() {
					var s = {
						type: "panelsCloseComplete",
						previousIndex: t
					};
					i.trigger(s), e.isFunction(i.settings.panelsCloseComplete) && i.settings.panelsCloseComplete.call(i, s)
				}
			});
			var u = {
				type: "panelsClose",
				previousIndex: t
			};
			this.trigger(u), e.isFunction(this.settings.panelsClose) && this.settings.panelsClose.call(this, u)
		},
		getVisiblePanels: function() {
			return -1 === this.settings.visiblePanels ? this.getTotalPanels() : this.settings.visiblePanels
		},
		getTotalPages: function() {
			return -1 === this.settings.visiblePanels ? 1 : Math.ceil(this.getTotalPanels() / this.settings.visiblePanels)
		},
		getCurrentPage: function() {
			return -1 === this.settings.visiblePanels ? 0 : this.currentPage
		},
		gotoPage: function(t) {
			-1 !== this.currentIndex && this.closePanels(), this.currentPage = t, this.isPageScrolling = !0;
			var i = this,
				s = {},
				n = -(t * this.totalSize + this.currentPage * this.computedPanelDistance);
			this.currentPage === this.getTotalPages() - 1 && (n = -(this.totalPanelsSize - this.totalSize)), s[this.positionProperty] = n;
			var a = {
				type: "pageScroll",
				index: this.currentPage
			};
			this.trigger(a), e.isFunction(this.settings.pageScroll) && this.settings.pageScroll.call(this, a), this.$panelsContainer.stop().animate(s, this.settings.pageScrollDuration, this.settings.pageScrollEasing, function() {
				i.isPageScrolling = !1;
				var t = {
					type: "pageScrollComplete",
					index: i.currentPage
				};
				i.trigger(t), e.isFunction(i.settings.pageScrollComplete) && i.settings.pageScrollComplete.call(i, t)
			})
		},
		nextPage: function() {
			var t = this.currentPage >= this.getTotalPages() - 1 ? 0 : this.currentPage + 1;
			this.gotoPage(t)
		},
		previousPage: function() {
			var t = this.currentPage <= 0 ? this.getTotalPages() - 1 : this.currentPage - 1;
			this.gotoPage(t)
		},
		_getFirstPanelFromPage: function() {
			return -1 === this.settings.visiblePanels ? 0 : this.currentPage === this.getTotalPages() - 1 && 0 !== this.currentPage ? this.getTotalPanels() - this.settings.visiblePanels : this.currentPage * this.settings.visiblePanels
		},
		_getLastPanelFromPage: function() {
			return -1 === this.settings.visiblePanels ? this.getTotalPanels() - 1 : this.currentPage === this.getTotalPages() - 1 ? this.getTotalPanels() - 1 : (this.currentPage + 1) * this.settings.visiblePanels - 1
		},
		_getPageOfPanel: function(t) {
			return this.currentPage === this.getTotalPages() - 1 && t >= this.getTotalPanels() - this.settings.visiblePanels ? this.getTotalPages() - 1 : Math.floor(t / this.settings.visiblePanels)
		},
		_updatePaginationButtons: function() {
			var t = this.$accordion.find(".as-pagination-buttons"),
				s = this,
				n = this.getTotalPages();
			if (1 >= n && 0 !== t.length) t.remove(), t.off("click." + i, ".as-pagination-button"), this.off("pageScroll." + i), this.$accordion.removeClass("as-has-buttons");
			else if (n > 1 && 0 === t.length) {
				t = e('<div class="as-pagination-buttons"></div>').appendTo(this.$accordion);
				for (var a = 0; a < this.getTotalPages(); a++) e('<div class="as-pagination-button"></div>').appendTo(t);
				t.on("click." + i, ".as-pagination-button", function() {
					s.gotoPage(e(this).index())
				}), t.find(".as-pagination-button").eq(this.currentPage).addClass("as-selected"), this.on("pageScroll." + i, function(e) {
					t.find(".as-selected").removeClass("as-selected"), t.find(".as-pagination-button").eq(e.index).addClass("as-selected")
				}), this.$accordion.addClass("as-has-buttons")
			} else if (n > 1 && 0 !== t.length) {
				t.empty();
				for (var o = 0; o < this.getTotalPages(); o++) e('<div class="as-pagination-button"></div>').appendTo(t);
				t.find(".as-selected").removeClass("as-selected"), t.find(".as-pagination-button").eq(this.currentPage).addClass("as-selected")
			}
		},
		defaults: {
			width: 800,
			height: 400,
			responsive: !0,
			responsiveMode: "auto",
			aspectRatio: -1,
			orientation: "horizontal",
			startPanel: -1,
			openedPanelSize: "max",
			maxOpenedPanelSize: "80%",
			openPanelOn: "hover",
			closePanelsOnMouseOut: !0,
			mouseDelay: 200,
			panelDistance: 0,
			openPanelDuration: 700,
			closePanelDuration: 700,
			pageScrollDuration: 500,
			pageScrollEasing: "swing",
			breakpoints: null,
			visiblePanels: -1,
			startPage: 0,
			shadow: !0,
			shuffle: !1,
			panelOverlap: !0,
			init: function() {},
			update: function() {},
			accordionMouseOver: function() {},
			accordionMouseOut: function() {},
			panelClick: function() {},
			panelMouseOver: function() {},
			panelMouseOut: function() {},
			panelOpen: function() {},
			panelsClose: function() {},
			pageScroll: function() {},
			panelOpenComplete: function() {},
			panelsCloseComplete: function() {},
			pageScrollComplete: function() {},
			breakpointReach: function() {}
		}
	};
	var n = function(t, e, s) {
		this.$panel = t, this.accordion = e, this.settings = this.accordion.settings, this.panelNS = "AccordionSliderPanel" + s + "." + i, this.isLoading = !1, this.isLoaded = !1, this.setIndex(s), this._init()
	};
	n.prototype = {
		_init: function() {
			var t = this;
			this.$panel.attr("data-init", !0), this.on("mouseenter." + this.panelNS, function() {
				t.trigger({
					type: "panelMouseOver." + i,
					index: t.index
				})
			}), this.on("mouseleave." + this.panelNS, function() {
				t.trigger({
					type: "panelMouseOut." + i,
					index: t.index
				})
			}), this.on("click." + this.panelNS, function() {
				t.trigger({
					type: "panelClick." + i,
					index: t.index
				})
			}), this.on("mousedown." + this.panelNS, function() {
				t.trigger({
					type: "panelMouseDown." + i,
					index: t.index
				})
			}), this.update();
			var s = e.AccordionSlider.modules.panel;
			if (void 0 !== s)
				for (var n = 0; n < s.length; n++) void 0 !== this["init" + s[n]] && this["init" + s[n]]()
		},
		update: function() {
			this.positionProperty = "horizontal" === this.settings.orientation ? "left" : "top", this.sizeProperty = "horizontal" === this.settings.orientation ? "width" : "height", this.$panel.css({
				top: "",
				left: "",
				width: "",
				height: ""
			})
		},
		destroy: function() {
			this.off("mouseenter." + this.panelNS), this.off("mouseleave." + this.panelNS), this.off("click." + this.panelNS), this.off("mousedown." + this.panelNS), this.$panel.attr("style", ""), this.$panel.removeAttr("data-init"), this.$panel.removeAttr("data-index");
			var t = e.AccordionSlider.modules.panel;
			if (void 0 !== t)
				for (var i = 0; i < t.length; i++) void 0 !== this["destroy" + t[i]] && this["destroy" + t[i]]()
		},
		getIndex: function() {
			return this.index
		},
		setIndex: function(t) {
			this.index = t, this.$panel.attr("data-index", this.index)
		},
		getPosition: function() {
			return parseInt(this.$panel.css(this.positionProperty), 10)
		},
		setPosition: function(t) {
			this.$panel.css(this.positionProperty, t)
		},
		getSize: function() {
			return parseInt(this.$panel.css(this.sizeProperty), 10)
		},
		setSize: function(t) {
			this.$panel.css(this.sizeProperty, t)
		},
		getContentSize: function() {
			if (!1 === this.isLoaded && "loading" === this.checkImagesComplete()) return "loading";
			this.$panel.find(".as-opened").css("display", "none");
			var t = "width" === this.sizeProperty ? this.$panel[0].scrollWidth : this.$panel[0].scrollHeight;
			return this.$panel.find(".as-opened").css("display", ""), t
		},
		checkImagesComplete: function() {
			if (!0 === this.isLoading) return "loading";
			var t = this,
				s = "complete";
			if (this.$panel.find("img").each(function() {
					(!1 === e(this)[0].complete || void 0 !== e(this).attr("data-src")) && (s = "loading")
				}), "loading" === s) {
				this.isLoading = !0;
				var n = setInterval(function() {
					var s = !0;
					t.$panel.find("img").each(function() {
						(!1 === e(this)[0].complete || void 0 !== e(this).attr("data-src")) && (s = !1)
					}), !0 === s && (t.isLoading = !1, t.isLoaded = !0, clearInterval(n), t.trigger({
						type: "imagesComplete." + i,
						index: t.index,
						contentSize: t.getContentSize()
					}))
				}, 100)
			} else this.isLoaded = !0;
			return s
		},
		on: function(t, e) {
			return this.$panel.on(t, e)
		},
		off: function(t) {
			return this.$panel.off(t)
		},
		trigger: function(t) {
			return this.$panel.triggerHandler(t)
		}
	}, t.AccordionSlider = s, t.AccordionSliderPanel = n, e.fn.accordionSlider = function(t) {
		var i = Array.prototype.slice.call(arguments, 1);
		return this.each(function() {
			if (void 0 === e(this).data("accordionSlider")) {
				var n = new s(this, t);
				e(this).data("accordionSlider", n)
			} else if (void 0 !== t) {
				var a = e(this).data("accordionSlider");
				if ("function" == typeof a[t]) a[t].apply(a, i);
				else if (void 0 !== a.settings[t]) {
					var o = {};
					o[t] = i[0], a._setProperties(o)
				} else "object" == typeof t ? a._setProperties(t) : e.error(t + " does not exist in accordionSlider.")
			}
		})
	}
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace,
		s = {
			autoplayIndex: -1,
			autoplayTimer: null,
			isTimerRunning: !1,
			isTimerPaused: !1,
			initAutoplay: function() {
				var t = this;
				!0 === this.settings.autoplay && this.startAutoplay(), this.on("panelOpen.Autoplay." + i, function(e) {
					t.autoplayIndex = e.index, !0 === t.settings.autoplay && (!0 === t.isTimerRunning && t.stopAutoplay(), !1 === t.isTimerPaused && t.startAutoplay())
				}), this.on("panelsClose.Autoplay." + i, function(e) {
					-1 !== e.previousIndex && (t.autoplayIndex = e.previousIndex)
				}), this.on("pageScroll.Autoplay." + i, function() {
					t.autoplayIndex = t._getFirstPanelFromPage() - 1
				}), this.on("mouseenter.Autoplay." + i, function() {
					!0 !== t.settings.autoplay || !t.isTimerRunning || "pause" !== t.settings.autoplayOnHover && "stop" !== t.settings.autoplayOnHover || (t.stopAutoplay(), t.isTimerPaused = !0)
				}), this.on("mouseleave.Autoplay." + i, function() {
					!0 === t.settings.autoplay && !1 === t.isTimerRunning && "stop" !== t.settings.autoplayOnHover && (t.startAutoplay(), t.isTimerPaused = !1)
				})
			},
			startAutoplay: function() {
				var t = this;
				this.isTimerRunning = !0, this.autoplayTimer = setTimeout(function() {
					-1 !== t.autoplayIndex && (t.currentIndex = t.autoplayIndex, t.autoplayIndex = -1), "normal" === t.settings.autoplayDirection ? t.nextPanel() : "backwards" === t.settings.autoplayDirection && t.previousPanel()
				}, this.settings.autoplayDelay)
			},
			stopAutoplay: function() {
				this.isTimerRunning = !1, clearTimeout(this.autoplayTimer)
			},
			destroyAutoplay: function() {
				clearTimeout(this.autoplayTimer), this.off("panelOpen.Autoplay." + i), this.off("pageScroll.Autoplay." + i), this.off("mouseenter.Autoplay." + i), this.off("mouseleave.Autoplay." + i)
			},
			autoplayDefaults: {
				autoplay: !0,
				autoplayDelay: 5e3,
				autoplayDirection: "normal",
				autoplayOnHover: "pause"
			}
		};
	e.AccordionSlider.addModule("Autoplay", s, "accordion")
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace,
		s = {
			initDeepLinking: function() {
				var s = this;
				!1 !== this._parseHash(t.location.hash) && (this.options.startPanel = -1), this.on("init.DeepLinking." + i, function() {
					s._gotoHash(t.location.hash)
				}), e(t).on("hashchange.DeepLinking." + this.uniqueId + "." + i, function() {
					s._gotoHash(t.location.hash)
				})
			},
			_parseHash: function(t) {
				if ("" !== t) {
					var e = (t = t.substring(1)).split("/").pop(),
						i = t.slice(0, -e.toString().length - 1);
					if (this.$accordion.attr("id") === i) return {
						accordionID: i,
						panelId: e
					}
				}
				return !1
			},
			_gotoHash: function(t) {
				var e = this._parseHash(t);
				if (!1 !== e) {
					var i = e.panelId,
						s = parseInt(i, 10);
					if (isNaN(s)) {
						var n = this.$accordion.find(".as-panel#" + i).index(); - 1 !== n && this.openPanel(n)
					} else this.openPanel(s)
				}
			},
			destroyDeepLinking: function() {
				e(t).off("hashchange.DeepLinking." + this.uniqueId + "." + i)
			}
		};
	e.AccordionSlider.addModule("DeepLinking", s, "accordion")
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace,
		s = {
			JSONDataAttributesMap: {
				width: "data-width",
				height: "data-height",
				depth: "data-depth",
				position: "data-position",
				horizontal: "data-horizontal",
				vertical: "data-vertical",
				showTransition: "data-show-transition",
				showOffset: "data-show-offset",
				showDelay: "data-show-delay",
				showDuration: "data-show-duration",
				showEasing: "data-show-easing",
				hideTransition: "data-hide-transition",
				hideOffset: "data-",
				hideDelay: "data-hide-delay",
				hideDuration: "data-hide-duration",
				hideEasing: "data-hide-easing"
			},
			initJSON: function() {
				null !== this.settings.JSONSource && this.updateJSON()
			},
			updateJSON: function() {
				var t = this;
				this.removePanels(), this.$panelsContainer.empty(), this.off("JSONReady." + i), this.on("JSONReady." + i, function(i) {
					var s = i.jsonData,
						n = s.accordion.panels,
						a = s.accordion.lazyLoading;
					e.each(n, function(i, s) {
						var n, o, r = s,
							l = e('<div class="as-panel"></div>').appendTo(t.$panelsContainer);
						if (void 0 !== r.backgroundLink && (n = e('<a href="' + r.backgroundLink.address + '"></a>'), e.each(r.backgroundLink, function(t, e) {
								"address" !== t && n.attr(t, e)
							}), n.appendTo(l)), void 0 !== r.background) {
							var d = e('<img class="as-background"/>');
							void 0 !== a ? d.attr({
								src: a,
								"data-src": r.background.source
							}) : d.attr({
								src: r.background.source
							}), void 0 !== r.backgroundRetina && d.attr({
								"data-retina": r.backgroundRetina.source
							}), e.each(r.background, function(t, e) {
								"source" !== t && d.attr(t, e)
							}), d.appendTo(void 0 !== n ? n : l)
						}
						if (void 0 !== r.backgroundOpenedLink && (o = e('<a href="' + r.backgroundOpenedLink.address + '"></a>'), e.each(r.backgroundOpenedLink, function(t, e) {
								"address" !== t && o.attr(t, e)
							}), o.appendTo(l)), void 0 !== r.backgroundOpened) {
							var c = e('<img class="as-background-opened"/>');
							void 0 !== a ? c.attr({
								src: a,
								"data-src": r.backgroundOpened.source
							}) : c.attr({
								src: r.backgroundOpened.source
							}), void 0 !== r.backgroundOpenedRetina && c.attr({
								"data-retina": r.backgroundOpenedRetina.source
							}), e.each(r.backgroundOpened, function(t, e) {
								"source" !== t && c.attr(t, e)
							}), c.appendTo(void 0 !== o ? o : l)
						}
						void 0 !== r.layers && t._parseLayers(r.layers, l)
					}), t.update()
				}), this._loadJSON()
			},
			_parseLayers: function(t, i) {
				var s = this;
				e.each(t, function(t, n) {
					var a = n,
						o = "",
						r = "";
					e.each(a, function(t, i) {
						if ("style" === t) {
							var n = i.split(" ");
							e.each(n, function(t, e) {
								o += " as-" + e
							})
						} else "content" !== t && "layers" !== t && (r += " " + s.JSONDataAttributesMap[t] + '="' + i + '"')
					});
					var l = e('<div class="as-layer' + o + '"' + r + "></div>").appendTo(i);
					void 0 !== n.layers ? s._parseLayers(n.layers, l) : l.html(a.content)
				})
			},
			_loadJSON: function() {
				var t = this;
				if (".json" === this.settings.JSONSource.slice(-5)) e.getJSON(this.settings.JSONSource, function(e) {
					t.trigger({
						type: "JSONReady." + i,
						jsonData: e
					})
				});
				else {
					var s = e.parseJSON(this.settings.JSONSource);
					t.trigger({
						type: "JSONReady." + i,
						jsonData: s
					})
				}
			},
			destroyJSON: function() {
				this.off("JSONReady." + i)
			},
			JSONDefaults: {
				JSONSource: null
			}
		};
	e.AccordionSlider.addModule("JSON", s, "accordion")
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace,
		s = {
			initKeyboard: function() {
				var t = this,
					s = !1;
				!1 !== this.settings.keyboard && (this.$accordion.on("focus.Keyboard." + i, function() {
					s = !0
				}), this.$accordion.on("blur.Keyboard." + i, function() {
					s = !1
				}), e(document).on("keydown.Keyboard." + this.uniqueId + "." + i, function(e) {
					(!0 !== t.settings.keyboardOnlyOnFocus || !1 !== s) && (37 === e.which ? "page" === t.settings.keyboardTarget ? t.previousPage() : t.previousPanel() : 39 === e.which ? "page" === t.settings.keyboardTarget ? t.nextPage() : t.nextPanel() : 13 === e.which && t.$accordion.find(".as-panel").eq(t.currentIndex).children("a")[0].click())
				}))
			},
			destroyKeyboard: function() {
				this.$accordion.off("focus.Keyboard." + i), this.$accordion.off("blur.Keyboard." + i), e(document).off("keydown.Keyboard." + this.uniqueId + "." + i)
			},
			keyboardDefaults: {
				keyboard: !0,
				keyboardOnlyOnFocus: !1,
				keyboardTarget: "panel"
			}
		};
	e.AccordionSlider.addModule("Keyboard", s, "accordion")
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = (e.AccordionSlider.namespace, t.navigator.userAgent.toLowerCase()),
		s = /(msie) ([\w.]+)/.exec(i) || [],
		n = s[1],
		a = s[2],
		o = {
			initLayers: function() {
				this.layers = [];
				var t = this;
				this.$panel.find(".as-layer").each(function() {
					var i = new r(e(this));
					t.layers.push(i)
				}), this.index === this.accordion.getCurrentIndex() ? this._handleLayersInOpenedState() : this._handleLayersInClosedState(), this.accordion.on("panelOpen.Layers." + this.panelNS, function(e) {
					e.index !== e.previousIndex && (t.index === e.previousIndex && t._handleLayersInClosedState(), t.index === e.index && t._handleLayersInOpenedState())
				}), this.accordion.on("panelsClose.Layers." + this.panelNS, function(e) {
					t.index === e.previousIndex && t._handleLayersInClosedState()
				})
			},
			_handleLayersInOpenedState: function() {
				e.each(this.layers, function(t, e) {
					"opened" === e.visibleOn && e.show(), "closed" === e.visibleOn && e.hide()
				})
			},
			_handleLayersInClosedState: function() {
				e.each(this.layers, function(t, e) {
					"opened" === e.visibleOn && e.hide(), "closed" === e.visibleOn && e.show()
				})
			},
			destroyLayers: function() {
				this.accordion.off("panelOpen.Layers." + this.panelNS), this.accordion.off("panelsClose.Layers." + this.panelNS), e.each(this.layers, function(t, e) {
					e.destroy()
				})
			}
		},
		r = function(t) {
			this.$layer = t, this.visibleOn = "n/a", this.isVisible = !1, this.styled = !1, this._init()
		};
	r.prototype = {
		_init: function() {
			this.$layer.css({
				visibility: "hidden",
				display: "none"
			}), this.$layer.hasClass("as-opened") ? this.visibleOn = "opened" : this.$layer.hasClass("as-closed") ? this.visibleOn = "closed" : (this.visibleOn = "always", this.show())
		},
		_setStyle: function() {
			this.styled = !0, this.$layer.css({
				display: "",
				margin: 0
			}), this.data = this.$layer.data(), void 0 !== this.data.width && this.$layer.css("width", this.data.width), void 0 !== this.data.height && this.$layer.css("height", this.data.height), void 0 !== this.data.depth && this.$layer.css("z-index", this.data.depth), this.position = this.data.position ? this.data.position.toLowerCase() : "topleft", this.horizontalPosition = -1 !== this.position.indexOf("right") ? "right" : "left", this.verticalPosition = -1 !== this.position.indexOf("bottom") ? "bottom" : "top", this._setPosition()
		},
		_setPosition: function() {
			void 0 !== this.data.horizontal ? "center" === this.data.horizontal ? (-1 === this.$layer.attr("style").indexOf("width") && !1 === this.$layer.is("img") && (this.$layer.css("white-space", "nowrap"), this.$layer.css("width", this.$layer.outerWidth(!0))), this.$layer.css({
				marginLeft: "auto",
				marginRight: "auto",
				left: 0,
				right: 0
			})) : this.$layer.css(this.horizontalPosition, this.data.horizontal) : this.$layer.css(this.horizontalPosition, 0), void 0 !== this.data.vertical ? "center" === this.data.vertical ? (-1 === this.$layer.attr("style").indexOf("height") && !1 === this.$layer.is("img") && (this.$layer.css("white-space", "nowrap"), this.$layer.css("height", this.$layer.outerHeight(!0))), this.$layer.css({
				marginTop: "auto",
				marginBottom: "auto",
				top: 0,
				bottom: 0
			})) : this.$layer.css(this.verticalPosition, this.data.vertical) : this.$layer.css(this.verticalPosition, 0)
		},
		show: function() {
			if (!0 !== this.isVisible) {
				this.isVisible = !0, !1 === this.styled && this._setStyle();
				var t = this,
					i = void 0 !== this.data.showOffset ? this.data.showOffset : 50,
					s = void 0 !== this.data.showDuration ? this.data.showDuration / 1e3 : .4,
					o = void 0 !== this.data.showDelay ? this.data.showDelay : 10;
				if ("always" === this.visibleOn || "msie" === n && parseInt(a, 10) <= 7) this.$layer.css("visibility", "visible");
				else if ("msie" === n && parseInt(a, 10) <= 9) this.$layer.stop().delay(o).css({
					opacity: 0,
					visibility: "visible"
				}).animate({
					opacity: 1
				}, 1e3 * s);
				else {
					var r = {
							opacity: 0,
							visibility: "visible"
						},
						d = "";
					"left" === this.data.showTransition ? d = i + "px, 0" : "right" === this.data.showTransition ? d = "-" + i + "px, 0" : "up" === this.data.showTransition ? d = "0, " + i + "px" : "down" === this.data.showTransition && (d = "0, -" + i + "px"), r.transform = "3d" === l.useTransforms() ? "translate3d(" + d + ", 0)" : "translate(" + d + ")", r["-webkit-transform"] = r["-ms-transform"] = r.transform;
					var c = {
						opacity: 1,
						transition: "all " + s + "s"
					};
					void 0 !== this.data.showTransition && (c.transform = "3d" === l.useTransforms() ? "translate3d(0, 0, 0)" : "translate(0, 0)", c["-webkit-transform"] = c["-ms-transform"] = c.transform), this.$layer.on("transitionend webkitTransitionEnd oTransitionEnd msTransitionEnd", function() {
						t.$layer.off("transitionend webkitTransitionEnd oTransitionEnd msTransitionEnd"), t.$layer.css("transition", "")
					}), this.$layer.css(r).delay(o).queue(function() {
						t.$layer.css(c), e(this).dequeue()
					})
				}
			}
		},
		hide: function() {
			if (!1 !== this.isVisible) {
				this.isVisible = !1;
				var t = this,
					i = void 0 !== this.data.hideOffset ? this.data.hideOffset : 50,
					s = void 0 !== this.data.hideDuration ? this.data.hideDuration / 1e3 : .4,
					o = void 0 !== this.data.hideDelay ? this.data.hideDelay : 10;
				if ("always" === this.visibleOn || "msie" === n && parseInt(a, 10) <= 7) this.$layer.css("visibility", "hidden");
				else if ("msie" === n && parseInt(a, 10) <= 9) this.$layer.stop().delay(o).animate({
					opacity: 0
				}, 1e3 * s, function() {
					e(this).css({
						visibility: "hidden"
					})
				});
				else {
					var r = {
							opacity: 0,
							transition: "all " + s + "s"
						},
						d = "";
					"left" === this.data.hideTransition ? d = "-" + i + "px, 0" : "right" === this.data.hideTransition ? d = i + "px, 0" : "up" === this.data.hideTransition ? d = "0, -" + i + "px" : "down" === this.data.hideTransition && (d = "0, " + i + "px"), r.transform = "3d" === l.useTransforms() ? "translate3d(" + d + ", 0)" : "translate(" + d + ")", r["-webkit-transform"] = r["-ms-transform"] = r.transform, this.$layer.on("transitionend webkitTransitionEnd oTransitionEnd msTransitionEnd", function() {
						t.$layer.off("transitionend webkitTransitionEnd oTransitionEnd msTransitionEnd"), t.$layer.css("transition", ""), !1 === t.isVisible && t.$layer.css("visibility", "hidden")
					}), this.$layer.delay(o).queue(function() {
						t.$layer.css(r), e(this).dequeue()
					})
				}
			}
		},
		destroy: function() {
			this.$layer.attr("style", "")
		}
	}, e.AccordionSlider.addModule("Layers", o, "panel");
	var l = {
		checked: !1,
		transforms: "",
		useTransforms: function() {
			if (!0 === this.checked) return this.transforms;
			this.checked = !0;
			var t = document.createElement("div");
			if ((void 0 !== t.style.WebkitPerspective || void 0 !== t.style.perspective) && (this.transforms = "3d"), "3d" === this.transforms && void 0 !== t.styleWebkitPerspective) {
				var e = document.createElement("style");
				e.textContent = "@media (transform-3d),(-webkit-transform-3d){#test-3d{left:9px;position:absolute;height:5px;margin:0;padding:0;border:0;}}", document.getElementsByTagName("head")[0].appendChild(e), t.id = "test-3d", document.body.appendChild(t), (9 !== t.offsetLeft || 5 !== t.offsetHeight) && (this.transforms = ""), e.parentNode.removeChild(e), t.parentNode.removeChild(t)
			}
			return "" !== this.transforms || void 0 === t.style["-webkit-transform"] && void 0 === t.style.transform || (this.transforms = "2d"), this.transforms
		}
	}
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace,
		s = {
			initLazyLoading: function() {
				this.on("update.LazyLoading." + i, e.proxy(this._checkImages, this)), this.on("pageScroll.LazyLoading." + i, e.proxy(this._checkImages, this))
			},
			_checkImages: function() {
				var t = this,
					i = this._getFirstPanelFromPage(),
					s = this._getLastPanelFromPage(),
					n = s !== this.getTotalPanels() - 1 ? this.panels.slice(i, s + 1) : this.panels.slice(i);
				e.each(n, function(i, s) {
					var n = s.$panel;
					void 0 === n.attr("data-loaded") && (n.attr("data-loaded", !0), n.find("img").each(function() {
						var i = e(this);
						t._loadImage(i, s)
					}))
				})
			},
			_loadImage: function(t) {
				if (void 0 !== t.attr("data-src")) {
					var i = e(new Image);
					i.attr("class", t.attr("class")), i.attr("style", t.attr("style")), e.each(t.data(), function(t, e) {
						i.attr("data-" + t, e)
					}), void 0 !== t.attr("width") && i.attr("width", t.attr("width")), void 0 !== t.attr("height") && i.attr("height", t.attr("height")), void 0 !== t.attr("alt") && i.attr("alt", t.attr("alt")), void 0 !== t.attr("title") && i.attr("title", t.attr("title")), i.attr("src", t.attr("data-src")), i.removeAttr("data-src"), i.insertAfter(t), t.remove()
				}
			},
			destroyLazyLoading: function() {
				this.off("update.LazyLoading." + i), this.off("pageScroll.LazyLoading." + i)
			}
		};
	e.AccordionSlider.addModule("LazyLoading", s, "accordion")
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace,
		s = {
			mouseWheelEventType: "",
			allowMouseWheelScroll: !0,
			initMouseWheel: function() {
				var t = this;
				!1 !== this.settings.mouseWheel && ("onwheel" in document ? this.mouseWheelEventType = "wheel" : "onmousewheel" in document ? this.mouseWheelEventType = "mousewheel" : "onDomMouseScroll" in document ? this.mouseWheelEventType = "DomMouseScroll" : "onMozMousePixelScroll" in document && (this.mouseWheelEventType = "MozMousePixelScroll"), this.on(this.mouseWheelEventType + "." + i, function(e) {
					e.preventDefault();
					var i, s = e.originalEvent;
					void 0 !== s.detail && (i = s.detail), void 0 !== s.wheelDelta && (i = s.wheelDelta), void 0 !== s.deltaY && (i = -1 * s.deltaY), !0 === t.allowMouseWheelScroll && Math.abs(i) >= t.settings.mouseWheelSensitivity && (t.allowMouseWheelScroll = !1, setTimeout(function() {
						t.allowMouseWheelScroll = !0
					}, 500), i <= -t.settings.mouseWheelSensitivity ? "page" === t.settings.mouseWheelTarget ? t.nextPage() : t.nextPanel() : i >= t.settings.mouseWheelSensitivity && ("page" === t.settings.mouseWheelTarget ? t.previousPage() : t.previousPanel()))
				}))
			},
			destroyMouseWheel: function() {
				this.off(this.mouseWheelEventType + "." + i)
			},
			mouseWheelDefaults: {
				mouseWheel: !0,
				mouseWheelSensitivity: 10,
				mouseWheelTarget: "panel"
			}
		};
	e.AccordionSlider.addModule("MouseWheel", s, "accordion")
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace,
		s = {
			initRetina: function() {
				!1 !== this._isRetina() && (void 0 !== this._loadImage ? this._loadImage = this._loadRetinaImage : this.on("update.Retina." + i, e.proxy(this._checkRetinaImages, this)))
			},
			_isRetina: function() {
				return t.devicePixelRatio >= 2 || !(!t.matchMedia || !t.matchMedia("(-webkit-min-device-pixel-ratio: 2),(min-resolution: 2dppx)").matches)
			},
			_checkRetinaImages: function() {
				var t = this;
				this.off("update.Retina." + i), e.each(this.panels, function(i, s) {
					var n = s.$panel;
					void 0 === n.attr("data-loaded") && (n.attr("data-loaded", !0), n.find("img").each(function() {
						var i = e(this);
						t._loadRetinaImage(i, s)
					}))
				})
			},
			_loadRetinaImage: function(t) {
				var i = !1,
					s = "";
				if (void 0 !== t.attr("data-retina") && (i = !0, s = t.attr("data-retina"), t.removeAttr("data-retina")), void 0 !== t.attr("data-src") && (!1 === i && (s = t.attr("data-src")), t.removeAttr("data-src")), "" !== s) {
					var n = e(new Image);
					n.attr("class", t.attr("class")), n.attr("style", t.attr("style")), e.each(t.data(), function(t, e) {
						n.attr("data-" + t, e)
					}), void 0 !== t.attr("width") && n.attr("width", t.attr("width")), void 0 !== t.attr("height") && n.attr("height", t.attr("height")), void 0 !== t.attr("alt") && n.attr("alt", t.attr("alt")), void 0 !== t.attr("title") && n.attr("title", t.attr("title")), n.attr("src", s), n.insertAfter(t), t.remove()
				}
			},
			destroyRetina: function() {}
		};
	e.AccordionSlider.addModule("Retina", s, "accordion")
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace;
	t.navigator.userAgent.toLowerCase();
	var s = {
		initSmartVideo: function() {
			this._setupVideos()
		},
		_setupVideos: function() {
			var t = this;
			this.$accordion.find(".as-video").each(function() {
				var i = e(this);
				i.videoController(), i.on("videoPlay.SmartVideo", function() {
					"stopAutoplay" === t.settings.playVideoAction && void 0 !== t.stopAutoplay && (t.stopAutoplay(), t.settings.autoplay = !1);
					var s = {
						type: "videoPlay",
						video: i
					};
					t.trigger(s), e.isFunction(t.settings.videoPlay) && t.settings.videoPlay.call(t, s)
				}), i.on("videoPause.SmartVideo", function() {
					"startAutoplay" === t.settings.pauseVideoAction && void 0 !== t.startAutoplay && (t.startAutoplay(), t.settings.autoplay = !0);
					var s = {
						type: "videoPause",
						video: i
					};
					t.trigger(s), e.isFunction(t.settings.videoPause) && t.settings.videoPause.call(t, s)
				}), i.on("videoEnded.SmartVideo", function() {
					"startAutoplay" === t.settings.endVideoAction && void 0 !== t.startAutoplay ? (t.startAutoplay(), t.settings.autoplay = !0) : "nextPanel" === t.settings.endVideoAction ? t.nextPanel() : "replayVideo" === t.settings.endVideoAction && i.videoController("replay");
					var s = {
						type: "videoEnd",
						video: i
					};
					t.trigger(s), e.isFunction(t.settings.videoEnd) && t.settings.videoEnd.call(t, s)
				})
			}), this.on("panelOpen.SmartVideo." + i, function(e) {
				if (-1 !== e.previousIndex && 0 !== t.$panelsContainer.find(".as-panel").eq(e.previousIndex).find(".as-video").length) {
					var i = t.$panelsContainer.find(".as-panel").eq(e.previousIndex).find(".as-video");
					"stopVideo" === t.settings.closePanelVideoAction ? i.videoController("stop") : "pauseVideo" === t.settings.closePanelVideoAction && i.videoController("pause")
				}
				if (0 !== t.$panelsContainer.find(".as-panel").eq(e.index).find(".as-video").length) {
					var s = t.$panelsContainer.find(".as-panel").eq(e.index).find(".as-video");
					"playVideo" === t.settings.openPanelVideoAction && s.videoController("play")
				}
			}), this.on("panelsClose.SmartVideo." + i, function(e) {
				if (-1 !== e.previousIndex && 0 !== t.$panelsContainer.find(".as-panel").eq(e.previousIndex).find(".as-video").length) {
					var i = t.$panelsContainer.find(".as-panel").eq(e.previousIndex).find(".as-video");
					"stopVideo" === t.settings.closePanelVideoAction ? i.videoController("stop") : "pauseVideo" === t.settings.closePanelVideoAction && i.videoController("pause")
				}
			})
		},
		destroySmartVideo: function() {
			this.$accordion.find(".as-video").each(function() {
				e(this).off("SmartVideo"), e(this).videoController("destroy")
			}), this.off("panelOpen.SmartVideo." + i), this.off("panelsClose.SmartVideo." + i)
		},
		smartVideoDefaults: {
			openPanelVideoAction: "playVideo",
			closePanelVideoAction: "pauseVideo",
			playVideoAction: "stopAutoplay",
			pauseVideoAction: "none",
			endVideoAction: "none",
			videoPlay: function() {},
			videoPause: function() {},
			videoEnd: function() {}
		}
	};
	e.AccordionSlider.addModule("SmartVideo", s, "accordion")
}(window, jQuery),
function(t) {
	"use strict";
	var e = !!window.navigator.userAgent.match(/(iPad|iPhone|iPod)/g),
		i = function(e, i) {
			this.$video = t(e), this.options = i, this.settings = {}, this.player = null, this._init()
		};
	i.prototype = {
		_init: function() {
			this.settings = t.extend({}, this.defaults, this.options);
			var e = this,
				i = t.VideoController.players,
				s = this.$video.attr("id");
			for (var n in i)
				if (void 0 !== i[n] && i[n].isType(this.$video)) {
					this.player = new i[n](this.$video);
					break
				} if (null !== this.player) {
				t.each(["ready", "start", "play", "pause", "ended"], function(i, n) {
					var a = "video" + n.charAt(0).toUpperCase() + n.slice(1);
					e.player.on(n, function() {
						e.trigger({
							type: a,
							video: s
						}), t.isFunction(e.settings[a]) && e.settings[a].call(e, {
							type: a,
							video: s
						})
					})
				})
			}
		},
		play: function() {
			!0 === e && !1 === this.player.isStarted() || "playing" === this.player.getState() || this.player.play()
		},
		stop: function() {
			!0 === e && !1 === this.player.isStarted() || "stopped" === this.player.getState() || this.player.stop()
		},
		pause: function() {
			!0 === e && !1 === this.player.isStarted() || "paused" === this.player.getState() || this.player.pause()
		},
		replay: function() {
			(!0 !== e || !1 !== this.player.isStarted()) && this.player.replay()
		},
		on: function(t, e) {
			return this.$video.on(t, e)
		},
		off: function(t) {
			return this.$video.off(t)
		},
		trigger: function(t) {
			return this.$video.triggerHandler(t)
		},
		destroy: function() {
			!0 === this.player.isStarted() && this.stop(), this.player.off("ready"), this.player.off("start"), this.player.off("play"), this.player.off("pause"), this.player.off("ended"), this.$video.removeData("videoController")
		},
		defaults: {
			videoReady: function() {},
			videoStart: function() {},
			videoPlay: function() {},
			videoPause: function() {},
			videoEnded: function() {}
		}
	}, t.VideoController = {
		players: {},
		addPlayer: function(t, e) {
			this.players[t] = e
		}
	}, t.fn.videoController = function(e) {
		var s = Array.prototype.slice.call(arguments, 1);
		return this.each(function() {
			if (void 0 === t(this).data("videoController")) {
				var n = new i(this, e);
				t(this).data("videoController", n)
			} else if (void 0 !== e) {
				var a = t(this).data("videoController");
				"function" == typeof a[e] ? a[e].apply(a, s) : t.error(e + " does not exist in videoController.")
			}
		})
	};
	var s = function(e) {
		this.$video = e, this.player = null, this.ready = !1, this.started = !1, this.state = "", this.events = t({}), this._init()
	};
	s.prototype = {
		_init: function() {},
		play: function() {},
		pause: function() {},
		stop: function() {},
		replay: function() {},
		isType: function() {},
		isReady: function() {
			return this.ready
		},
		isStarted: function() {
			return this.started
		},
		getState: function() {
			return this.state
		},
		on: function(t, e) {
			return this.events.on(t, e)
		},
		off: function(t) {
			return this.events.off(t)
		},
		trigger: function(t) {
			return this.events.triggerHandler(t)
		}
	};
	var n = {
			youtubeAPIAdded: !1,
			youtubeVideos: []
		},
		a = function(e) {
			if (this.init = !1, void 0 !== (window.YT && window.YT.Player)) s.call(this, e);
			else if (n.youtubeVideos.push({
					video: e,
					scope: this
				}), !1 === n.youtubeAPIAdded) {
				n.youtubeAPIAdded = !0;
				var i = document.createElement("script");
				i.src = "http://www.youtube.com/player_api";
				var a = document.getElementsByTagName("script")[0];
				a.parentNode.insertBefore(i, a), window.onYouTubePlayerAPIReady = function() {
					t.each(n.youtubeVideos, function(t, e) {
						s.call(e.scope, e.video)
					})
				}
			}
		};
	(a.prototype = new s).constructor = a, t.VideoController.addPlayer("YoutubeVideo", a), a.isType = function(t) {
		if (t.is("iframe")) {
			var e = t.attr("src");
			if (-1 !== e.indexOf("youtube.com") || -1 !== e.indexOf("youtu.be")) return !0
		}
		return !1
	}, a.prototype._init = function() {
		this.init = !0, this._setup()
	}, a.prototype._setup = function() {
		var t = this;
		this.player = new YT.Player(this.$video[0], {
			events: {
				onReady: function() {
					t.trigger({
						type: "ready"
					}), t.ready = !0
				},
				onStateChange: function(e) {
					switch (e.data) {
						case YT.PlayerState.PLAYING:
							!1 === t.started && (t.started = !0, t.trigger({
								type: "start"
							})), t.state = "playing", t.trigger({
								type: "play"
							});
							break;
						case YT.PlayerState.PAUSED:
							t.state = "paused", t.trigger({
								type: "pause"
							});
							break;
						case YT.PlayerState.ENDED:
							t.state = "ended", t.trigger({
								type: "ended"
							})
					}
				}
			}
		})
	}, a.prototype.play = function() {
		var t = this;
		if (!0 === this.ready) this.player.playVideo();
		else var e = setInterval(function() {
			!0 === t.ready && (clearInterval(e), t.player.playVideo())
		}, 100)
	}, a.prototype.pause = function() {
		!0 === e ? this.stop() : this.player.pauseVideo()
	}, a.prototype.stop = function() {
		this.player.seekTo(1), this.player.stopVideo(), this.state = "stopped"
	}, a.prototype.replay = function() {
		this.player.seekTo(1), this.player.playVideo()
	}, a.prototype.on = function(t, e) {
		var i = this;
		if (!0 === this.init) s.prototype.on.call(this, t, e);
		else var n = setInterval(function() {
			!0 === i.init && (clearInterval(n), s.prototype.on.call(i, t, e))
		}, 100)
	};
	var o = {
			vimeoAPIAdded: !1,
			vimeoVideos: []
		},
		r = function(e) {
			if (this.init = !1, void 0 !== window.Froogaloop) s.call(this, e);
			else if (o.vimeoVideos.push({
					video: e,
					scope: this
				}), !1 === o.vimeoAPIAdded) {
				o.vimeoAPIAdded = !0;
				var i = document.createElement("script");
				i.src = "http://a.vimeocdn.com/js/froogaloop2.min.js";
				var n = document.getElementsByTagName("script")[0];
				n.parentNode.insertBefore(i, n);
				var a = setInterval(function() {
					void 0 !== window.Froogaloop && (clearInterval(a), t.each(o.vimeoVideos, function(t, e) {
						s.call(e.scope, e.video)
					}))
				}, 100)
			}
		};
	(r.prototype = new s).constructor = r, t.VideoController.addPlayer("VimeoVideo", r), r.isType = function(t) {
		if (t.is("iframe") && -1 !== t.attr("src").indexOf("vimeo.com")) return !0;
		return !1
	}, r.prototype._init = function() {
		this.init = !0, this._setup()
	}, r.prototype._setup = function() {
		var t = this;
		this.player = $f(this.$video[0]), this.player.addEvent("ready", function() {
			t.ready = !0, t.trigger({
				type: "ready"
			}), t.player.addEvent("play", function() {
				!1 === t.started && (t.started = !0, t.trigger({
					type: "start"
				})), t.state = "playing", t.trigger({
					type: "play"
				})
			}), t.player.addEvent("pause", function() {
				t.state = "paused", t.trigger({
					type: "pause"
				})
			}), t.player.addEvent("finish", function() {
				t.state = "ended", t.trigger({
					type: "ended"
				})
			})
		})
	}, r.prototype.play = function() {
		var t = this;
		if (!0 === this.ready) this.player.api("play");
		else var e = setInterval(function() {
			!0 === t.ready && (clearInterval(e), t.player.api("play"))
		}, 100)
	}, r.prototype.pause = function() {
		this.player.api("pause")
	}, r.prototype.stop = function() {
		this.player.api("seekTo", 0), this.player.api("pause"), this.state = "stopped"
	}, r.prototype.replay = function() {
		this.player.api("seekTo", 0), this.player.api("play")
	}, r.prototype.on = function(t, e) {
		var i = this;
		if (!0 === this.init) s.prototype.on.call(this, t, e);
		else var n = setInterval(function() {
			!0 === i.init && (clearInterval(n), s.prototype.on.call(i, t, e))
		}, 100)
	};
	var l = function(t) {
		s.call(this, t)
	};
	(l.prototype = new s).constructor = l, t.VideoController.addPlayer("HTML5Video", l), l.isType = function(t) {
		return !(!t.is("video") || !1 !== t.hasClass("video-js") || !1 !== t.hasClass("sublime"))
	}, l.prototype._init = function() {
		var t = this;
		this.player = this.$video[0], this.ready = !0, this.player.addEventListener("play", function() {
			!1 === t.started && (t.started = !0, t.trigger({
				type: "start"
			})), t.state = "playing", t.trigger({
				type: "play"
			})
		}), this.player.addEventListener("pause", function() {
			t.state = "paused", t.trigger({
				type: "pause"
			})
		}), this.player.addEventListener("ended", function() {
			t.state = "ended", t.trigger({
				type: "ended"
			})
		})
	}, l.prototype.play = function() {
		this.player.play()
	}, l.prototype.pause = function() {
		this.player.pause()
	}, l.prototype.stop = function() {
		this.player.currentTime = 0, this.player.pause(), this.state = "stopped"
	}, l.prototype.replay = function() {
		this.player.currentTime = 0, this.player.play()
	};
	var d = function(t) {
		s.call(this, t)
	};
	(d.prototype = new s).constructor = d, t.VideoController.addPlayer("VideoJSVideo", d), d.isType = function(t) {
		return !(void 0 === t.attr("data-videojs-id") && !t.hasClass("video-js") || "undefined" == typeof videojs)
	}, d.prototype._init = function() {
		var t = this,
			e = this.$video.hasClass("video-js") ? this.$video.attr("id") : this.$video.attr("data-videojs-id");
		this.player = videojs(e), this.player.ready(function() {
			t.ready = !0, t.trigger({
				type: "ready"
			}), t.player.on("play", function() {
				!1 === t.started && (t.started = !0, t.trigger({
					type: "start"
				})), t.state = "playing", t.trigger({
					type: "play"
				})
			}), t.player.on("pause", function() {
				t.state = "paused", t.trigger({
					type: "pause"
				})
			}), t.player.on("ended", function() {
				t.state = "ended", t.trigger({
					type: "ended"
				})
			})
		})
	}, d.prototype.play = function() {
		this.player.play()
	}, d.prototype.pause = function() {
		this.player.pause()
	}, d.prototype.stop = function() {
		this.player.currentTime(0), this.player.pause(), this.state = "stopped"
	}, d.prototype.replay = function() {
		this.player.currentTime(0), this.player.play()
	};
	var c = function(t) {
		s.call(this, t)
	};
	(c.prototype = new s).constructor = c, t.VideoController.addPlayer("SublimeVideo", c), c.isType = function(t) {
		return !(!t.hasClass("sublime") || "undefined" == typeof sublime)
	}, c.prototype._init = function() {
		var t = this;
		sublime.ready(function() {
			t.player = sublime.player(t.$video.attr("id")), t.ready = !0, t.trigger({
				type: "ready"
			}), t.player.on("play", function() {
				!1 === t.started && (t.started = !0, t.trigger({
					type: "start"
				})), t.state = "playing", t.trigger({
					type: "play"
				})
			}), t.player.on("pause", function() {
				t.state = "paused", t.trigger({
					type: "pause"
				})
			}), t.player.on("stop", function() {
				t.state = "stopped", t.trigger({
					type: "stop"
				})
			}), t.player.on("end", function() {
				t.state = "ended", t.trigger({
					type: "ended"
				})
			})
		})
	}, c.prototype.play = function() {
		this.player.play()
	}, c.prototype.pause = function() {
		this.player.pause()
	}, c.prototype.stop = function() {
		this.player.stop()
	}, c.prototype.replay = function() {
		this.player.stop(), this.player.play()
	};
	var h = function(t) {
		s.call(this, t)
	};
	(h.prototype = new s).constructor = h, t.VideoController.addPlayer("JWPlayerVideo", h), h.isType = function(t) {
		return !(void 0 === t.attr("data-jwplayer-id") && !t.hasClass("jwplayer") && 0 === t.find("object[data*='jwplayer']").length || "undefined" == typeof jwplayer)
	}, h.prototype._init = function() {
		var t, e = this;
		this.$video.hasClass("jwplayer") ? t = this.$video.attr("id") : void 0 !== this.$video.attr("data-jwplayer-id") ? t = this.$video.attr("data-jwplayer-id") : 0 !== this.$video.find("object[data*='jwplayer']").length && (t = this.$video.find("object").attr("id")), this.player = jwplayer(t), this.player.onReady(function() {
			e.ready = !0, e.trigger({
				type: "ready"
			}), e.player.onPlay(function() {
				!1 === e.started && (e.started = !0, e.trigger({
					type: "start"
				})), e.state = "playing", e.trigger({
					type: "play"
				})
			}), e.player.onPause(function() {
				e.state = "paused", e.trigger({
					type: "pause"
				})
			}), e.player.onComplete(function() {
				e.state = "ended", e.trigger({
					type: "ended"
				})
			})
		})
	}, h.prototype.play = function() {
		this.player.play(!0)
	}, h.prototype.pause = function() {
		this.player.pause(!0)
	}, h.prototype.stop = function() {
		this.player.stop(), this.state = "stopped"
	}, h.prototype.replay = function() {
		this.player.seek(0), this.player.play(!0)
	}
}(jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace,
		s = {
			cssTransitions: null,
			cssTransitionEndEvents: "transitionend webkitTransitionEnd oTransitionEnd msTransitionEnd",
			checkCSSTransitions: function() {
				if (null !== this.cssTransitions) return this.cssTransitions;
				var t = (document.body || document.documentElement).style;
				return this.cssTransitions = void 0 !== t.transition || void 0 !== t.WebkitTransition || void 0 !== t.MozTransition || void 0 !== t.OTransition, this.cssTransitions
			}
		},
		n = {
			initSwapBackground: function() {
				var t = this;
				this.on("panelOpen.SwapBackground." + i, function(e) {
					var i = t.getPanelAt(e.index),
						s = i.$panel.find(".as-background"),
						n = i.$panel.find(".as-background-opened");
					if (0 !== n.length && (n.css({
							visibility: "visible",
							opacity: 0
						}), t._fadeInBackground(n), 0 !== s.length && !0 === t.settings.fadeOutBackground && t._fadeOutBackground(s)), -1 !== e.previousIndex && e.index !== e.previousIndex) {
						var a = t.getPanelAt(e.previousIndex),
							o = a.$panel.find(".as-background"),
							r = a.$panel.find(".as-background-opened");
						0 !== r.length && (t._fadeOutBackground(r), 0 !== o.length && !0 === t.settings.fadeOutBackground && t._fadeInBackground(o))
					}
				}), this.on("panelsClose.SwapBackground." + i, function(e) {
					if (-1 !== e.previousIndex) {
						var i = t.getPanelAt(e.previousIndex),
							s = i.$panel.find(".as-background"),
							n = i.$panel.find(".as-background-opened");
						0 !== n.length && (t._fadeOutBackground(n), 0 !== s.length && !0 === t.settings.fadeOutBackground && t._fadeInBackground(s))
					}
				})
			},
			_fadeInBackground: function(t) {
				var e = this.settings.swapBackgroundDuration;
				t.css({
					visibility: "visible"
				}), !0 === s.checkCSSTransitions() ? (t.off(s.cssTransitionEndEvents).on(s.cssTransitionEndEvents, function(e) {
					e.target === e.currentTarget && (t.off(s.cssTransitionEndEvents), t.css({
						transition: ""
					}))
				}), setTimeout(function() {
					t.css({
						opacity: 1,
						transition: "all " + e / 1e3 + "s"
					})
				}, 100)) : t.stop().animate({
					opacity: 1
				}, e)
			},
			_fadeOutBackground: function(t) {
				var e = this.settings.swapBackgroundDuration;
				!0 === s.checkCSSTransitions() ? (t.off(s.cssTransitionEndEvents).on(s.cssTransitionEndEvents, function(e) {
					e.target === e.currentTarget && (t.off(s.cssTransitionEndEvents), t.css({
						visibility: "hidden",
						transition: ""
					}))
				}), setTimeout(function() {
					t.css({
						opacity: 0,
						transition: "all " + e / 1e3 + "s"
					})
				}, 100)) : t.stop().animate({
					opacity: 0
				}, e, function() {
					t.css({
						visibility: "hidden"
					})
				})
			},
			destroySwapBackground: function() {
				this.off("panelOpen.SwapBackground." + i), this.off("panelsClose.SwapBackground." + i)
			},
			swapBackgroundDefaults: {
				swapBackgroundDuration: 700,
				fadeOutBackground: !1
			}
		};
	e.AccordionSlider.addModule("SwapBackground", n, "accordion")
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace,
		s = {
			touchStartPoint: {
				x: 0,
				y: 0
			},
			touchEndPoint: {
				x: 0,
				y: 0
			},
			touchDistance: {
				x: 0,
				y: 0
			},
			touchStartPosition: 0,
			isTouchMoving: !1,
			touchSwipeEvents: {
				startEvent: "",
				moveEvent: "",
				endEvent: ""
			},
			initTouchSwipe: function() {
				var t = this;
				!1 !== this.settings.touchSwipe && (this.touchSwipeEvents.startEvent = "touchstart." + i + " mousedown." + i, this.touchSwipeEvents.moveEvent = "touchmove." + i + " mousemove." + i, this.touchSwipeEvents.endEvent = "touchend." + this.uniqueId + "." + i + " mouseup." + this.uniqueId + "." + i, this.$panelsContainer.on(this.touchSwipeEvents.startEvent, e.proxy(this._onTouchStart, this)), this.on("update.TouchSwipe." + i, function() {
					t.getTotalPages() > 1 ? t.$panelsContainer.addClass("as-grab") : t.$panelsContainer.removeClass("as-grab")
				}))
			},
			_onTouchStart: function(t) {
				var i = void 0 !== t.originalEvent.touches ? t.originalEvent.touches[0] : t.originalEvent;
				e(t.target).closest(".as-selectable").length >= 1 || void 0 === t.originalEvent.touches && 1 === this.getTotalPages() || (void 0 === t.originalEvent.touches && t.preventDefault(), this.touchStartPoint.x = i.pageX || i.clientX, this.touchStartPoint.y = i.pageY || i.clientY, this.touchStartPosition = parseInt(this.$panelsContainer.css(this.positionProperty), 10), this.touchDistance.x = this.touchDistance.y = 0, this.$panelsContainer.on(this.touchSwipeEvents.moveEvent, e.proxy(this._onTouchMove, this)), e(document).on(this.touchSwipeEvents.endEvent, e.proxy(this._onTouchEnd, this)), this.$panelsContainer.removeClass("as-grab").addClass("as-grabbing"), e(t.target).parents(".as-panel").find("a").one("click.TouchSwipe", function(t) {
					t.preventDefault()
				}), this.$accordion.addClass("as-swiping"))
			},
			_onTouchMove: function(t) {
				var e = void 0 !== t.originalEvent.touches ? t.originalEvent.touches[0] : t.originalEvent;
				this.isTouchMoving = !0, this.touchEndPoint.x = e.pageX || e.clientX, this.touchEndPoint.y = e.pageY || e.clientY, this.touchDistance.x = this.touchEndPoint.x - this.touchStartPoint.x, this.touchDistance.y = this.touchEndPoint.y - this.touchStartPoint.y;
				var i = "horizontal" === this.settings.orientation ? this.touchDistance.x : this.touchDistance.y,
					s = "horizontal" === this.settings.orientation ? this.touchDistance.y : this.touchDistance.x;
				if (Math.abs(i) > Math.abs(s)) {
					t.preventDefault();
					var n = parseInt(this.$panelsContainer.css(this.positionProperty), 10);
					(n >= 0 && 0 === this.currentPage || n <= -this.totalPanelsSize + this.totalSize && this.currentPage === this.getTotalPages() - 1) && (i *= .2), this.$panelsContainer.css(this.positionProperty, this.touchStartPosition + i)
				}
			},
			_onTouchEnd: function(t) {
				var i = this;
				if (this.$panelsContainer.off(this.touchSwipeEvents.moveEvent), e(document).off(this.touchSwipeEvents.endEvent), this.$panelsContainer.removeClass("as-grabbing").addClass("as-grab"), void 0 !== t.originalEvent.touches && (!1 === this.isTouchMoving || !0 === this.isTouchMoving && Math.abs(this.touchDistance.x) < 10 && Math.abs(this.touchDistance.y) < 10)) {
					var s = e(t.target).parents(".as-panel").index();
					s !== this.currentIndex && -1 !== s ? (t.preventDefault(), this.openPanel(s)) : (e(t.target).parents(".as-panel").find("a").off("click.TouchSwipe"), this.$accordion.removeClass("as-swiping"))
				} else {
					if (!1 === this.isTouchMoving) return e(t.target).parents(".as-panel").find("a").off("click.TouchSwipe"), void this.$accordion.removeClass("as-swiping");
					e(t.target).parents(".as-panel").one("click", function(t) {
						t.preventDefault()
					}), this.isTouchMoving = !1, setTimeout(function() {
						i.$accordion.removeClass("as-swiping")
					}, 1);
					var n = {};
					n[this.positionProperty] = this.touchStartPosition, "horizontal" === this.settings.orientation ? this.touchDistance.x > this.settings.touchSwipeThreshold ? this.currentPage > 0 ? this.previousPage() : this.$panelsContainer.stop().animate(n, 300) : -this.touchDistance.x > this.settings.touchSwipeThreshold ? this.currentPage < this.getTotalPages() - 1 ? this.nextPage() : this.gotoPage(this.currentPage) : Math.abs(this.touchDistance.x) < this.settings.touchSwipeThreshold && this.$panelsContainer.stop().animate(n, 300) : "vertical" === this.settings.orientation && (this.touchDistance.y > this.settings.touchSwipeThreshold ? this.currentPage > 0 ? this.previousPage() : this.$panelsContainer.stop().animate(n, 300) : -this.touchDistance.y > this.settings.touchSwipeThreshold ? this.currentPage < this.getTotalPages() - 1 ? this.nextPage() : this.$panelsContainer.animate(n, 300) : Math.abs(this.touchDistance.y) < this.settings.touchSwipeThreshold && this.$panelsContainer.stop().animate(n, 300))
				}
			},
			destroyTouchSwipe: function() {
				this.$panelsContainer.off(this.touchSwipeEvents.startEvent), e(document).off(this.touchSwipeEvents.endEvent), this.$panelsContainer.off(this.touchSwipeEvents.moveEvent), this.off("update.TouchSwipe." + i)
			},
			touchSwipeDefaults: {
				touchSwipe: !0,
				touchSwipeThreshold: 50
			}
		};
	e.AccordionSlider.addModule("TouchSwipe", s, "accordion")
}(window, jQuery),
function(t, e) {
	"use strict";
	var i = e.AccordionSlider.namespace,
		s = t.navigator.userAgent.toLowerCase(),
		n = (/(msie) ([\w.]+)/.exec(s) || [])[1],
		a = {
			XMLDataAttributesMap: {
				width: "data-width",
				height: "data-height",
				depth: "data-depth",
				position: "data-position",
				horizontal: "data-horizontal",
				vertical: "data-vertical",
				showTransition: "data-show-transition",
				showOffset: "data-show-offset",
				showDelay: "data-show-delay",
				showDuration: "data-show-duration",
				showEasing: "data-show-easing",
				hideTransition: "data-hide-transition",
				hideOffset: "data-",
				hideDelay: "data-hide-delay",
				hideDuration: "data-hide-duration",
				hideEasing: "data-hide-easing"
			},
			initXML: function() {
				null !== this.settings.XMLSource && this.updateXML()
			},
			updateXML: function() {
				var t = this;
				this.removePanels(), this.$panelsContainer.empty(), this.off("XMLReady." + i), this.on("XMLReady." + i, function(i) {
					var s = e(i.xmlData),
						n = s.find("accordion")[0].attributes.lazyLoading;
					void 0 !== n && (n = n.nodeValue), s.find("panel").each(function() {
						var i, s, a = e(this),
							o = a.find("background"),
							r = a.find("backgroundRetina"),
							l = a.find("backgroundLink"),
							d = a.find("backgroundOpened"),
							c = a.find("backgroundOpenedRetina"),
							h = a.find("backgroundOpenedLink"),
							u = a.find("layer"),
							p = e('<div class="as-panel"></div>').appendTo(t.$panelsContainer);
						if (l.length >= 1 && (i = e('<a href="' + l.text() + '"></a>'), e.each(l[0].attributes, function(t, e) {
								i.attr(e.nodeName, e.nodeValue)
							}), i.appendTo(p)), o.length >= 1) {
							var f = e('<img class="as-background"/>');
							void 0 !== n ? f.attr({
								src: n,
								"data-src": o.text()
							}) : f.attr({
								src: o.text()
							}), r.length >= 1 && f.attr({
								"data-retina": r.text()
							}), e.each(o[0].attributes, function(t, e) {
								f.attr(e.nodeName, e.nodeValue)
							}), f.appendTo(l.length ? i : p)
						}
						if (h.length >= 1 && (s = e('<a href="' + h.text() + '"></a>'), e.each(h[0].attributes, function(t, e) {
								s.attr(e.nodeName, e.nodeValue)
							}), s.appendTo(p)), d.length >= 1) {
							var m = e('<img class="as-background-opened"/>');
							void 0 !== n ? m.attr({
								src: n,
								"data-src": d.text()
							}) : m.attr({
								src: d.text()
							}), c.length >= 1 && m.attr({
								"data-retina": c.text()
							}), e.each(d[0].attributes, function(t, e) {
								m.attr(e.nodeName, e.nodeValue)
							}), m.appendTo(h.length ? s : p)
						}
						u.length >= 1 && e.each(u, function() {
							var i = e(this),
								s = "",
								n = "",
								a = p;
							e.each(i[0].attributes, function(i, a) {
								if ("style" === a.nodeName) {
									var o = a.nodeValue.split(" ");
									e.each(o, function(t, e) {
										s += " as-" + e
									})
								} else n += " " + t.XMLDataAttributesMap[a.nodeName] + '="' + a.nodeValue + '"'
							});
							var o = e('<div class="as-layer' + s + '"' + n + '"></div>');
							if (i.find("layer").length >= 1) {
								var r = (new Date).valueOf();
								i.attr("parentID", r), o.attr("class", o.attr("class") + " " + r)
							} else o.html(i.text());
							i.parent().is("layer") && (a = p.find("." + i.parent().attr("parentID"))), o.appendTo(a)
						})
					}), t.update()
				}), this._loadXML()
			},
			_loadXML: function() {
				var t = this;
				if (".xml" === this.settings.XMLSource.slice(-4)) e.ajax({
					type: "GET",
					url: this.settings.XMLSource,
					dataType: "msie" === n ? "text" : "xml",
					success: function(e) {
						var s;
						"msie" === n ? ((s = new ActiveXObject("Microsoft.XMLDOM")).async = !1, s.loadXML(e)) : s = e, t.trigger({
							type: "XMLReady." + i,
							xmlData: s
						})
					}
				});
				else {
					var s = e.parseXML(this.settings.XMLSource);
					t.trigger({
						type: "XMLReady." + i,
						xmlData: s
					})
				}
			},
			destroyXML: function() {
				this.off("XMLReady." + i)
			},
			XMLDefaults: {
				XMLSource: null
			}
		};
	e.AccordionSlider.addModule("XML", a, "accordion")
}(window, jQuery),
function(t, e) {
	"function" == typeof define && define.amd ? define(e) : "object" == typeof exports ? module.exports = e() : t.transformicons = e()
}(this || window, function() {
	"use strict";
	var t = {},
		e = {
			transform: ["click"],
			revert: ["click"]
		},
		i = function(t) {
			return "string" == typeof t ? Array.prototype.slice.call(document.querySelectorAll(t)) : void 0 === t || t instanceof Array ? t : [t]
		},
		s = function(t) {
			return "string" == typeof t ? t.toLowerCase().split(" ") : t
		},
		n = function(t, n, o) {
			var r = (o ? "remove" : "add") + "EventListener",
				l = i(t),
				d = l.length,
				c = {};
			for (var h in e) c[h] = n && n[h] ? s(n[h]) : e[h];
			for (; d--;)
				for (var u in c)
					for (var p = c[u].length; p--;) l[d][r](c[u][p], a)
		},
		a = function(e) {
			t.toggle(e.currentTarget)
		};
	return t.add = function(e, i) {
		return n(e, i), t
	}, t.remove = function(e, i) {
		return n(e, i, !0), t
	}, t.transform = function(e) {
		return i(e).forEach(function(t) {
			t.classList.add("tcon-transform")
		}), t
	}, t.revert = function(e) {
		return i(e).forEach(function(t) {
			t.classList.remove("tcon-transform")
		}), t
	}, t.toggle = function(e) {
		return i(e).forEach(function(e) {
			t[e.classList.contains("tcon-transform") ? "revert" : "transform"](e)
		}), t
	}, t
}),
function(t) {
	"function" == typeof define && define.amd ? define(["jquery"], t) : "object" == typeof exports ? t(require("jquery")) : t(window.jQuery || window.Zepto)
}(function(t) {
	var e, i, s, n, a, o, r = function() {},
		l = !!window.jQuery,
		d = t(window),
		c = function(t, i) {
			e.ev.on("mfp" + t + ".mfp", i)
		},
		h = function(e, i, s, n) {
			var a = document.createElement("div");
			return a.className = "mfp-" + e, s && (a.innerHTML = s), n ? i && i.appendChild(a) : (a = t(a), i && a.appendTo(i)), a
		},
		u = function(i, s) {
			e.ev.triggerHandler("mfp" + i, s), e.st.callbacks && (i = i.charAt(0).toLowerCase() + i.slice(1), e.st.callbacks[i] && e.st.callbacks[i].apply(e, t.isArray(s) ? s : [s]))
		},
		p = function(i) {
			return i === o && e.currTemplate.closeBtn || (e.currTemplate.closeBtn = t(e.st.closeMarkup.replace("%title%", e.st.tClose)), o = i), e.currTemplate.closeBtn
		},
		f = function() {
			t.magnificPopup.instance || ((e = new r).init(), t.magnificPopup.instance = e)
		};
	r.prototype = {
		constructor: r,
		init: function() {
			var i = navigator.appVersion;
			e.isIE7 = -1 !== i.indexOf("MSIE 7."), e.isIE8 = -1 !== i.indexOf("MSIE 8."), e.isLowIE = e.isIE7 || e.isIE8, e.isAndroid = /android/gi.test(i), e.isIOS = /iphone|ipad|ipod/gi.test(i), e.supportsTransition = function() {
				var t = document.createElement("p").style,
					e = ["ms", "O", "Moz", "Webkit"];
				if (void 0 !== t.transition) return !0;
				for (; e.length;)
					if (e.pop() + "Transition" in t) return !0;
				return !1
			}(), e.probablyMobile = e.isAndroid || e.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), s = t(document), e.popupsCache = {}
		},
		open: function(i) {
			var n;
			if (!1 === i.isObj) {
				e.items = i.items.toArray(), e.index = 0;
				var o, r = i.items;
				for (n = 0; n < r.length; n++)
					if ((o = r[n]).parsed && (o = o.el[0]), o === i.el[0]) {
						e.index = n;
						break
					}
			} else e.items = t.isArray(i.items) ? i.items : [i.items], e.index = i.index || 0;
			if (!e.isOpen) {
				e.types = [], a = "", i.mainEl && i.mainEl.length ? e.ev = i.mainEl.eq(0) : e.ev = s, i.key ? (e.popupsCache[i.key] || (e.popupsCache[i.key] = {}), e.currTemplate = e.popupsCache[i.key]) : e.currTemplate = {}, e.st = t.extend(!0, {}, t.magnificPopup.defaults, i), e.fixedContentPos = "auto" === e.st.fixedContentPos ? !e.probablyMobile : e.st.fixedContentPos, e.st.modal && (e.st.closeOnContentClick = !1, e.st.closeOnBgClick = !1, e.st.showCloseBtn = !1, e.st.enableEscapeKey = !1), e.bgOverlay || (e.bgOverlay = h("bg").on("click.mfp", function() {
					e.close()
				}), e.wrap = h("wrap").attr("tabindex", -1).on("mousedown.mfp", function(t) {
					e._checkIfClose(t.target) && e.close()
				}), e.container = h("container", e.wrap)), e.contentContainer = h("content"), e.st.preloader && (e.preloader = h("preloader", e.container, e.st.tLoading));
				var l = t.magnificPopup.modules;
				for (n = 0; n < l.length; n++) {
					var f = l[n];
					f = f.charAt(0).toUpperCase() + f.slice(1), e["init" + f].call(e)
				}
				u("BeforeOpen"), e.st.showCloseBtn && (e.st.closeBtnInside ? (c("MarkupParse", function(t, e, i, s) {
					i.close_replaceWith = p(s.type)
				}), a += " mfp-close-btn-in") : e.wrap.append(p())), e.st.alignTop && (a += " mfp-align-top"), e.fixedContentPos ? e.wrap.css({
					overflow: e.st.overflowY,
					overflowX: "hidden",
					overflowY: e.st.overflowY
				}) : e.wrap.css({
					top: d.scrollTop(),
					position: "absolute"
				}), (!1 === e.st.fixedBgPos || "auto" === e.st.fixedBgPos && !e.fixedContentPos) && e.bgOverlay.css({
					height: s.height(),
					position: "absolute"
				}), e.st.enableEscapeKey && s.on("keyup.mfp", function(t) {
					27 === t.keyCode && e.close()
				}), d.on("resize.mfp", function() {
					e.updateSize()
				}), e.st.closeOnContentClick || (a += " mfp-auto-cursor"), a && e.wrap.addClass(a);
				var m = e.wH = d.height(),
					g = {};
				if (e.fixedContentPos && e._hasScrollBar(m)) {
					var v = e._getScrollbarSize();
					v && (g.marginRight = v)
				}
				e.fixedContentPos && (e.isIE7 ? t("body, html").css("overflow", "hidden") : g.overflow = "hidden");
				var y = e.st.mainClass;
				return e.isIE7 && (y += " mfp-ie7"), y && e._addClassToMFP(y), e.updateItemHTML(), u("BuildControls"), t("html").css(g), e.bgOverlay.add(e.wrap).prependTo(e.st.prependTo || t(document.body)), e._lastFocusedEl = document.activeElement, setTimeout(function() {
					e.content ? (e._addClassToMFP("mfp-ready"), e._setFocus()) : e.bgOverlay.addClass("mfp-ready"), s.on("focusin.mfp", e._onFocusIn)
				}, 16), e.isOpen = !0, e.updateSize(m), u("Open"), i
			}
			e.updateItemHTML()
		},
		close: function() {
			e.isOpen && (u("BeforeClose"), e.isOpen = !1, e.st.removalDelay && !e.isLowIE && e.supportsTransition ? (e._addClassToMFP("mfp-removing"), setTimeout(function() {
				e._close()
			}, e.st.removalDelay)) : e._close())
		},
		_close: function() {
			u("Close");
			var i = "mfp-removing mfp-ready ";
			if (e.bgOverlay.detach(), e.wrap.detach(), e.container.empty(), e.st.mainClass && (i += e.st.mainClass + " "), e._removeClassFromMFP(i), e.fixedContentPos) {
				var n = {
					marginRight: ""
				};
				e.isIE7 ? t("body, html").css("overflow", "") : n.overflow = "", t("html").css(n)
			}
			s.off("keyup.mfp focusin.mfp"), e.ev.off(".mfp"), e.wrap.attr("class", "mfp-wrap").removeAttr("style"), e.bgOverlay.attr("class", "mfp-bg"), e.container.attr("class", "mfp-container"), !e.st.showCloseBtn || e.st.closeBtnInside && !0 !== e.currTemplate[e.currItem.type] || e.currTemplate.closeBtn && e.currTemplate.closeBtn.detach(), e._lastFocusedEl && t(e._lastFocusedEl).focus(), e.currItem = null, e.content = null, e.currTemplate = null, e.prevHeight = 0, u("AfterClose")
		},
		updateSize: function(t) {
			if (e.isIOS) {
				var i = document.documentElement.clientWidth / window.innerWidth,
					s = window.innerHeight * i;
				e.wrap.css("height", s), e.wH = s
			} else e.wH = t || d.height();
			e.fixedContentPos || e.wrap.css("height", e.wH), u("Resize")
		},
		updateItemHTML: function() {
			var i = e.items[e.index];
			e.contentContainer.detach(), e.content && e.content.detach(), i.parsed || (i = e.parseEl(e.index));
			var s = i.type;
			if (u("BeforeChange", [e.currItem ? e.currItem.type : "", s]), e.currItem = i, !e.currTemplate[s]) {
				var a = !!e.st[s] && e.st[s].markup;
				u("FirstMarkupParse", a), e.currTemplate[s] = !a || t(a)
			}
			n && n !== i.type && e.container.removeClass("mfp-" + n + "-holder");
			var o = e["get" + s.charAt(0).toUpperCase() + s.slice(1)](i, e.currTemplate[s]);
			e.appendContent(o, s), i.preloaded = !0, u("Change", i), n = i.type, e.container.prepend(e.contentContainer), u("AfterChange")
		},
		appendContent: function(t, i) {
			e.content = t, t ? e.st.showCloseBtn && e.st.closeBtnInside && !0 === e.currTemplate[i] ? e.content.find(".mfp-close").length || e.content.append(p()) : e.content = t : e.content = "", u("BeforeAppend"), e.container.addClass("mfp-" + i + "-holder"), e.contentContainer.append(e.content)
		},
		parseEl: function(i) {
			var s, n = e.items[i];
			if (n.tagName ? n = {
					el: t(n)
				} : (s = n.type, n = {
					data: n,
					src: n.src
				}), n.el) {
				for (var a = e.types, o = 0; o < a.length; o++)
					if (n.el.hasClass("mfp-" + a[o])) {
						s = a[o];
						break
					} n.src = n.el.attr("data-mfp-src"), n.src || (n.src = n.el.attr("href"))
			}
			return n.type = s || e.st.type || "inline", n.index = i, n.parsed = !0, e.items[i] = n, u("ElementParse", n), e.items[i]
		},
		addGroup: function(t, i) {
			var s = function(s) {
				s.mfpEl = this, e._openClick(s, t, i)
			};
			i || (i = {});
			var n = "click.magnificPopup";
			i.mainEl = t, i.items ? (i.isObj = !0, t.off(n).on(n, s)) : (i.isObj = !1, i.delegate ? t.off(n).on(n, i.delegate, s) : (i.items = t, t.off(n).on(n, s)))
		},
		_openClick: function(i, s, n) {
			if ((void 0 !== n.midClick ? n.midClick : t.magnificPopup.defaults.midClick) || !(2 === i.which || i.ctrlKey || i.metaKey || i.altKey || i.shiftKey)) {
				var a = void 0 !== n.disableOn ? n.disableOn : t.magnificPopup.defaults.disableOn;
				if (a)
					if (t.isFunction(a)) {
						if (!a.call(e)) return !0
					} else if (d.width() < a) return !0;
				i.type && (i.preventDefault(), e.isOpen && i.stopPropagation()), n.el = t(i.mfpEl), n.delegate && (n.items = s.find(n.delegate)), e.open(n)
			}
		},
		updateStatus: function(t, s) {
			if (e.preloader) {
				i !== t && e.container.removeClass("mfp-s-" + i), s || "loading" !== t || (s = e.st.tLoading);
				var n = {
					status: t,
					text: s
				};
				u("UpdateStatus", n), t = n.status, s = n.text, e.preloader.html(s), e.preloader.find("a").on("click", function(t) {
					t.stopImmediatePropagation()
				}), e.container.addClass("mfp-s-" + t), i = t
			}
		},
		_checkIfClose: function(i) {
			if (!t(i).hasClass("mfp-prevent-close")) {
				var s = e.st.closeOnContentClick,
					n = e.st.closeOnBgClick;
				if (s && n) return !0;
				if (!e.content || t(i).hasClass("mfp-close") || e.preloader && i === e.preloader[0]) return !0;
				if (i === e.content[0] || t.contains(e.content[0], i)) {
					if (s) return !0
				} else if (n && t.contains(document, i)) return !0;
				return !1
			}
		},
		_addClassToMFP: function(t) {
			e.bgOverlay.addClass(t), e.wrap.addClass(t)
		},
		_removeClassFromMFP: function(t) {
			this.bgOverlay.removeClass(t), e.wrap.removeClass(t)
		},
		_hasScrollBar: function(t) {
			return (e.isIE7 ? s.height() : document.body.scrollHeight) > (t || d.height())
		},
		_setFocus: function() {
			(e.st.focus ? e.content.find(e.st.focus).eq(0) : e.wrap).focus()
		},
		_onFocusIn: function(i) {
			if (i.target !== e.wrap[0] && !t.contains(e.wrap[0], i.target)) return e._setFocus(), !1
		},
		_parseMarkup: function(e, i, s) {
			var n;
			s.data && (i = t.extend(s.data, i)), u("MarkupParse", [e, i, s]), t.each(i, function(t, i) {
				if (void 0 === i || !1 === i) return !0;
				if ((n = t.split("_")).length > 1) {
					var s = e.find(".mfp-" + n[0]);
					if (s.length > 0) {
						var a = n[1];
						"replaceWith" === a ? s[0] !== i[0] && s.replaceWith(i) : "img" === a ? s.is("img") ? s.attr("src", i) : s.replaceWith('<img src="' + i + '" class="' + s.attr("class") + '" />') : s.attr(n[1], i)
					}
				} else e.find(".mfp-" + t).html(i)
			})
		},
		_getScrollbarSize: function() {
			if (void 0 === e.scrollbarSize) {
				var t = document.createElement("div");
				t.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(t), e.scrollbarSize = t.offsetWidth - t.clientWidth, document.body.removeChild(t)
			}
			return e.scrollbarSize
		}
	}, t.magnificPopup = {
		instance: null,
		proto: r.prototype,
		modules: [],
		open: function(e, i) {
			return f(), (e = e ? t.extend(!0, {}, e) : {}).isObj = !0, e.index = i || 0, this.instance.open(e)
		},
		close: function() {
			return t.magnificPopup.instance && t.magnificPopup.instance.close()
		},
		registerModule: function(e, i) {
			i.options && (t.magnificPopup.defaults[e] = i.options), t.extend(this.proto, i.proto), this.modules.push(e)
		},
		defaults: {
			disableOn: 0,
			key: null,
			midClick: !1,
			mainClass: "",
			preloader: !0,
			focus: "",
			closeOnContentClick: !1,
			closeOnBgClick: !0,
			closeBtnInside: !0,
			showCloseBtn: !0,
			enableEscapeKey: !0,
			modal: !1,
			alignTop: !1,
			removalDelay: 0,
			prependTo: null,
			fixedContentPos: "auto",
			fixedBgPos: "auto",
			overflowY: "auto",
			closeMarkup: '<button title="%title%" type="button" class="mfp-close"></button>',
			tClose: "Close (Esc)",
			tLoading: "Loading..."
		}
	}, t.fn.magnificPopup = function(i) {
		f();
		var s = t(this);
		if ("string" == typeof i)
			if ("open" === i) {
				var n, a = l ? s.data("magnificPopup") : s[0].magnificPopup,
					o = parseInt(arguments[1], 10) || 0;
				a.items ? n = a.items[o] : (n = s, a.delegate && (n = n.find(a.delegate)), n = n.eq(o)), e._openClick({
					mfpEl: n
				}, s, a)
			} else e.isOpen && e[i].apply(e, Array.prototype.slice.call(arguments, 1));
		else i = t.extend(!0, {}, i), l ? s.data("magnificPopup", i) : s[0].magnificPopup = i, e.addGroup(s, i);
		return s
	};
	var m, g, v, y = function() {
		v && (g.after(v.addClass(m)).detach(), v = null)
	};
	t.magnificPopup.registerModule("inline", {
		options: {
			hiddenClass: "hide",
			markup: "",
			tNotFound: "Content not found"
		},
		proto: {
			initInline: function() {
				e.types.push("inline"), c("Close.inline", function() {
					y()
				})
			},
			getInline: function(i, s) {
				if (y(), i.src) {
					var n = e.st.inline,
						a = t(i.src);
					if (a.length) {
						var o = a[0].parentNode;
						o && o.tagName && (g || (m = n.hiddenClass, g = h(m), m = "mfp-" + m), v = a.after(g).detach().removeClass(m)), e.updateStatus("ready")
					} else e.updateStatus("error", n.tNotFound), a = t("<div>");
					return i.inlineElement = a, a
				}
				return e.updateStatus("ready"), e._parseMarkup(s, {}, i), s
			}
		}
	});
	var b, w = function() {
			b && t(document.body).removeClass(b)
		},
		S = function() {
			w(), e.req && e.req.abort()
		};
	t.magnificPopup.registerModule("ajax", {
		options: {
			settings: null,
			cursor: "mfp-ajax-cur",
			tError: '<a href="%url%">The content</a> could not be loaded.'
		},
		proto: {
			initAjax: function() {
				e.types.push("ajax"), b = e.st.ajax.cursor, c("Close.ajax", S), c("BeforeChange.ajax", S)
			},
			getAjax: function(i) {
				b && t(document.body).addClass(b), e.updateStatus("loading");
				var s = t.extend({
					url: i.src,
					success: function(s, n, a) {
						var o = {
							data: s,
							xhr: a
						};
						u("ParseAjax", o), e.appendContent(t(o.data), "ajax"), i.finished = !0, w(), e._setFocus(), setTimeout(function() {
							e.wrap.addClass("mfp-ready")
						}, 16), e.updateStatus("ready"), u("AjaxContentAdded"), window.BOLD && BOLD.options && BOLD.common && (BOLD.options.app.unload(), BOLD.options.app.boot())
					},
					error: function() {
						w(), i.finished = i.loadError = !0, e.updateStatus("error", e.st.ajax.tError.replace("%url%", i.src))
					}
				}, e.st.ajax.settings);
				return e.req = t.ajax(s), ""
			}
		}
	});
	var x, T = function(i) {
		if (i.data && void 0 !== i.data.title) return i.data.title;
		var s = e.st.image.titleSrc;
		if (s) {
			if (t.isFunction(s)) return s.call(e, i);
			if (i.el) return i.el.attr(s) || ""
		}
		return ""
	};
	t.magnificPopup.registerModule("image", {
		options: {
			markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
			cursor: "mfp-zoom-out-cur",
			titleSrc: "title",
			verticalFit: !0,
			tError: '<a href="%url%">The image</a> could not be loaded.'
		},
		proto: {
			initImage: function() {
				var i = e.st.image,
					s = ".image";
				e.types.push("image"), c("Open" + s, function() {
					"image" === e.currItem.type && i.cursor && t(document.body).addClass(i.cursor)
				}), c("Close" + s, function() {
					i.cursor && t(document.body).removeClass(i.cursor), d.off("resize.mfp")
				}), c("Resize" + s, e.resizeImage), e.isLowIE && c("AfterChange", e.resizeImage)
			},
			resizeImage: function() {
				var t = e.currItem;
				if (t && t.img && e.st.image.verticalFit) {
					var i = 0;
					e.isLowIE && (i = parseInt(t.img.css("padding-top"), 10) + parseInt(t.img.css("padding-bottom"), 10)), t.img.css("max-height", e.wH - i)
				}
			},
			_onImageHasSize: function(t) {
				t.img && (t.hasSize = !0, x && clearInterval(x), t.isCheckingImgSize = !1, u("ImageHasSize", t), t.imgHidden && (e.content && e.content.removeClass("mfp-loading"), t.imgHidden = !1))
			},
			findImageSize: function(t) {
				var i = 0,
					s = t.img[0],
					n = function(a) {
						x && clearInterval(x), x = setInterval(function() {
							s.naturalWidth > 0 ? e._onImageHasSize(t) : (i > 200 && clearInterval(x), 3 === ++i ? n(10) : 40 === i ? n(50) : 100 === i && n(500))
						}, a)
					};
				n(1)
			},
			getImage: function(i, s) {
				var n = 0,
					a = function() {
						i && (i.img[0].complete ? (i.img.off(".mfploader"), i === e.currItem && (e._onImageHasSize(i), e.updateStatus("ready")), i.hasSize = !0, i.loaded = !0, u("ImageLoadComplete")) : ++n < 200 ? setTimeout(a, 100) : o())
					},
					o = function() {
						i && (i.img.off(".mfploader"), i === e.currItem && (e._onImageHasSize(i), e.updateStatus("error", r.tError.replace("%url%", i.src))), i.hasSize = !0, i.loaded = !0, i.loadError = !0)
					},
					r = e.st.image,
					l = s.find(".mfp-img");
				if (l.length) {
					var d = document.createElement("img");
					d.className = "mfp-img", i.el && i.el.find("img").length && (d.alt = i.el.find("img").attr("alt")), i.img = t(d).on("load.mfploader", a).on("error.mfploader", o), d.src = i.src, l.is("img") && (i.img = i.img.clone()), (d = i.img[0]).naturalWidth > 0 ? i.hasSize = !0 : d.width || (i.hasSize = !1)
				}
				return e._parseMarkup(s, {
					title: T(i),
					img_replaceWith: i.img
				}, i), e.resizeImage(), i.hasSize ? (x && clearInterval(x), i.loadError ? (s.addClass("mfp-loading"), e.updateStatus("error", r.tError.replace("%url%", i.src))) : (s.removeClass("mfp-loading"), e.updateStatus("ready")), s) : (e.updateStatus("loading"), i.loading = !0, i.hasSize || (i.imgHidden = !0, s.addClass("mfp-loading"), e.findImageSize(i)), s)
			}
		}
	});
	var C;
	t.magnificPopup.registerModule("zoom", {
		options: {
			enabled: !1,
			easing: "ease-in-out",
			duration: 300,
			opener: function(t) {
				return t.is("img") ? t : t.find("img")
			}
		},
		proto: {
			initZoom: function() {
				var t, i = e.st.zoom,
					s = ".zoom";
				if (i.enabled && e.supportsTransition) {
					var n, a, o = i.duration,
						r = function(t) {
							var e = t.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
								s = "all " + i.duration / 1e3 + "s " + i.easing,
								n = {
									position: "fixed",
									zIndex: 9999,
									left: 0,
									top: 0,
									"-webkit-backface-visibility": "hidden"
								},
								a = "transition";
							return n["-webkit-" + a] = n["-moz-" + a] = n["-o-" + a] = n[a] = s, e.css(n), e
						},
						l = function() {
							e.content.css("visibility", "visible")
						};
					c("BuildControls" + s, function() {
						if (e._allowZoom()) {
							if (clearTimeout(n), e.content.css("visibility", "hidden"), !(t = e._getItemToZoom())) return void l();
							(a = r(t)).css(e._getOffset()), e.wrap.append(a), n = setTimeout(function() {
								a.css(e._getOffset(!0)), n = setTimeout(function() {
									l(), setTimeout(function() {
										a.remove(), t = a = null, u("ZoomAnimationEnded")
									}, 16)
								}, o)
							}, 16)
						}
					}), c("BeforeClose" + s, function() {
						if (e._allowZoom()) {
							if (clearTimeout(n), e.st.removalDelay = o, !t) {
								if (!(t = e._getItemToZoom())) return;
								a = r(t)
							}
							a.css(e._getOffset(!0)), e.wrap.append(a), e.content.css("visibility", "hidden"), setTimeout(function() {
								a.css(e._getOffset())
							}, 16)
						}
					}), c("Close" + s, function() {
						e._allowZoom() && (l(), a && a.remove(), t = null)
					})
				}
			},
			_allowZoom: function() {
				return "image" === e.currItem.type
			},
			_getItemToZoom: function() {
				return !!e.currItem.hasSize && e.currItem.img
			},
			_getOffset: function(i) {
				var s, n = (s = i ? e.currItem.img : e.st.zoom.opener(e.currItem.el || e.currItem)).offset(),
					a = parseInt(s.css("padding-top"), 10),
					o = parseInt(s.css("padding-bottom"), 10);
				n.top -= t(window).scrollTop() - a;
				var r = {
					width: s.width(),
					height: (l ? s.innerHeight() : s[0].offsetHeight) - o - a
				};
				return void 0 === C && (C = void 0 !== document.createElement("p").style.MozTransform), C ? r["-moz-transform"] = r.transform = "translate(" + n.left + "px," + n.top + "px)" : (r.left = n.left, r.top = n.top), r
			}
		}
	});
	var _ = function(t) {
		if (e.currTemplate.iframe) {
			var i = e.currTemplate.iframe.find("iframe");
			i.length && (t || (i[0].src = "//about:blank"), e.isIE8 && i.css("display", t ? "block" : "none"))
		}
	};
	t.magnificPopup.registerModule("iframe", {
		options: {
			markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
			srcAction: "iframe_src",
			patterns: {
				youtube: {
					index: "youtube.com",
					id: "v=",
					src: "//www.youtube.com/embed/%id%?autoplay=1"
				},
				vimeo: {
					index: "vimeo.com/",
					id: "/",
					src: "//player.vimeo.com/video/%id%?autoplay=1"
				},
				gmaps: {
					index: "//maps.google.",
					src: "%id%&output=embed"
				}
			}
		},
		proto: {
			initIframe: function() {
				e.types.push("iframe"), c("BeforeChange", function(t, e, i) {
					e !== i && ("iframe" === e ? _() : "iframe" === i && _(!0))
				}), c("Close.iframe", function() {
					_()
				})
			},
			getIframe: function(i, s) {
				var n = i.src,
					a = e.st.iframe;
				t.each(a.patterns, function() {
					if (n.indexOf(this.index) > -1) return this.id && (n = "string" == typeof this.id ? n.substr(n.lastIndexOf(this.id) + this.id.length, n.length) : this.id.call(this, n)), n = this.src.replace("%id%", n), !1
				});
				var o = {};
				return a.srcAction && (o[a.srcAction] = n), e._parseMarkup(s, o, i), e.updateStatus("ready"), s
			}
		}
	});
	var E = function(t) {
			var i = e.items.length;
			return t > i - 1 ? t - i : t < 0 ? i + t : t
		},
		P = function(t, e, i) {
			return t.replace(/%curr%/gi, e + 1).replace(/%total%/gi, i)
		};
	t.magnificPopup.registerModule("gallery", {
		options: {
			enabled: !1,
			arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
			preload: [0, 2],
			navigateByImgClick: !0,
			arrows: !0,
			tPrev: "Previous (Left arrow key)",
			tNext: "Next (Right arrow key)",
			tCounter: "%curr% of %total%"
		},
		proto: {
			initGallery: function() {
				var i = e.st.gallery,
					n = ".mfp-gallery",
					o = Boolean(t.fn.mfpFastClick);
				if (e.direction = !0, !i || !i.enabled) return !1;
				a += " mfp-gallery", c("Open" + n, function() {
					i.navigateByImgClick && e.wrap.on("click" + n, ".mfp-img", function() {
						if (e.items.length > 1) return e.next(), !1
					}), s.on("keydown" + n, function(t) {
						37 === t.keyCode ? e.prev() : 39 === t.keyCode && e.next()
					})
				}), c("UpdateStatus" + n, function(t, i) {
					i.text && (i.text = P(i.text, e.currItem.index, e.items.length))
				}), c("MarkupParse" + n, function(t, s, n, a) {
					var o = e.items.length;
					n.counter = o > 1 ? P(i.tCounter, a.index, o) : ""
				}), c("BuildControls" + n, function() {
					if (e.items.length > 1 && i.arrows && !e.arrowLeft) {
						var s = i.arrowMarkup,
							n = e.arrowLeft = t(s.replace(/%title%/gi, i.tPrev).replace(/%dir%/gi, "left")).addClass("mfp-prevent-close"),
							a = e.arrowRight = t(s.replace(/%title%/gi, i.tNext).replace(/%dir%/gi, "right")).addClass("mfp-prevent-close"),
							r = o ? "mfpFastClick" : "click";
						n[r](function() {
							e.prev()
						}), a[r](function() {
							e.next()
						}), e.isIE7 && (h("b", n[0], !1, !0), h("a", n[0], !1, !0), h("b", a[0], !1, !0), h("a", a[0], !1, !0)), e.container.append(n.add(a))
					}
				}), c("Change" + n, function() {
					e._preloadTimeout && clearTimeout(e._preloadTimeout), e._preloadTimeout = setTimeout(function() {
						e.preloadNearbyImages(), e._preloadTimeout = null
					}, 16)
				}), c("Close" + n, function() {
					s.off(n), e.wrap.off("click" + n), e.arrowLeft && o && e.arrowLeft.add(e.arrowRight).destroyMfpFastClick(), e.arrowRight = e.arrowLeft = null
				})
			},
			next: function() {
				e.direction = !0, e.index = E(e.index + 1), e.updateItemHTML()
			},
			prev: function() {
				e.direction = !1, e.index = E(e.index - 1), e.updateItemHTML()
			},
			goTo: function(t) {
				e.direction = t >= e.index, e.index = t, e.updateItemHTML()
			},
			preloadNearbyImages: function() {
				var t, i = e.st.gallery.preload,
					s = Math.min(i[0], e.items.length),
					n = Math.min(i[1], e.items.length);
				for (t = 1; t <= (e.direction ? n : s); t++) e._preloadItem(e.index + t);
				for (t = 1; t <= (e.direction ? s : n); t++) e._preloadItem(e.index - t)
			},
			_preloadItem: function(i) {
				if (i = E(i), !e.items[i].preloaded) {
					var s = e.items[i];
					s.parsed || (s = e.parseEl(i)), u("LazyLoad", s), "image" === s.type && (s.img = t('<img class="mfp-img" />').on("load.mfploader", function() {
						s.hasSize = !0
					}).on("error.mfploader", function() {
						s.hasSize = !0, s.loadError = !0, u("LazyLoadError", s)
					}).attr("src", s.src)), s.preloaded = !0
				}
			}
		}
	});
	var k, $, M;
	t.magnificPopup.registerModule("retina", {
		options: {
			replaceSrc: function(t) {
				return t.src.replace(/\.\w+$/, function(t) {
					return "@2x" + t
				})
			},
			ratio: 1
		},
		proto: {
			initRetina: function() {
				if (window.devicePixelRatio > 1) {
					var t = e.st.retina,
						i = t.ratio;
					(i = isNaN(i) ? i() : i) > 1 && (c("ImageHasSize.retina", function(t, e) {
						e.img.css({
							"max-width": e.img[0].naturalWidth / i,
							width: "100%"
						})
					}), c("ElementParse.retina", function(e, s) {
						s.src = t.replaceSrc(s, i)
					}))
				}
			}
		}
	}), k = "ontouchstart" in window, $ = function() {
		d.off("touchmove" + M + " touchend" + M)
	}, M = ".mfpFastClick", t.fn.mfpFastClick = function(e) {
		return t(this).each(function() {
			var i, s, n, a, o, r, l, c = t(this);
			k && c.on("touchstart" + M, function(t) {
				o = !1, l = 1, r = t.originalEvent ? t.originalEvent.touches[0] : t.touches[0], n = r.clientX, a = r.clientY, d.on("touchmove" + M, function(t) {
					r = t.originalEvent ? t.originalEvent.touches : t.touches, l = r.length, r = r[0], (Math.abs(r.clientX - n) > 10 || Math.abs(r.clientY - a) > 10) && (o = !0, $())
				}).on("touchend" + M, function(t) {
					$(), o || l > 1 || (i = !0, t.preventDefault(), clearTimeout(s), s = setTimeout(function() {
						i = !1
					}, 1e3), e())
				})
			}), c.on("click" + M, function() {
				i || e()
			})
		})
	}, t.fn.destroyMfpFastClick = function() {
		t(this).off("touchstart" + M + " click" + M), k && d.off("touchmove" + M + " touchend" + M)
	}, f()
}),
function(t, e) {
	"object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.Swiper = e()
}(this, function() {
	"use strict";
	var t = "undefined" == typeof document ? {
			body: {},
			addEventListener: function() {},
			removeEventListener: function() {},
			activeElement: {
				blur: function() {},
				nodeName: ""
			},
			querySelector: function() {
				return null
			},
			querySelectorAll: function() {
				return []
			},
			getElementById: function() {
				return null
			},
			createEvent: function() {
				return {
					initEvent: function() {}
				}
			},
			createElement: function() {
				return {
					children: [],
					childNodes: [],
					style: {},
					setAttribute: function() {},
					getElementsByTagName: function() {
						return []
					}
				}
			},
			location: {
				hash: ""
			}
		} : document,
		e = "undefined" == typeof window ? {
			document: t,
			navigator: {
				userAgent: ""
			},
			location: {},
			history: {},
			CustomEvent: function() {
				return this
			},
			addEventListener: function() {},
			removeEventListener: function() {},
			getComputedStyle: function() {
				return {
					getPropertyValue: function() {
						return ""
					}
				}
			},
			Image: function() {},
			Date: function() {},
			screen: {},
			setTimeout: function() {},
			clearTimeout: function() {}
		} : window,
		i = function(t) {
			for (var e = 0; e < t.length; e += 1) this[e] = t[e];
			return this.length = t.length, this
		};

	function s(s, n) {
		var a = [],
			o = 0;
		if (s && !n && s instanceof i) return s;
		if (s)
			if ("string" == typeof s) {
				var r, l, d = s.trim();
				if (d.indexOf("<") >= 0 && d.indexOf(">") >= 0) {
					var c = "div";
					for (0 === d.indexOf("<li") && (c = "ul"), 0 === d.indexOf("<tr") && (c = "tbody"), 0 !== d.indexOf("<td") && 0 !== d.indexOf("<th") || (c = "tr"), 0 === d.indexOf("<tbody") && (c = "table"), 0 === d.indexOf("<option") && (c = "select"), (l = t.createElement(c)).innerHTML = d, o = 0; o < l.childNodes.length; o += 1) a.push(l.childNodes[o])
				} else
					for (r = n || "#" !== s[0] || s.match(/[ .<>:~]/) ? (n || t).querySelectorAll(s.trim()) : [t.getElementById(s.trim().split("#")[1])], o = 0; o < r.length; o += 1) r[o] && a.push(r[o])
			} else if (s.nodeType || s === e || s === t) a.push(s);
		else if (s.length > 0 && s[0].nodeType)
			for (o = 0; o < s.length; o += 1) a.push(s[o]);
		return new i(a)
	}

	function n(t) {
		for (var e = [], i = 0; i < t.length; i += 1) - 1 === e.indexOf(t[i]) && e.push(t[i]);
		return e
	}
	s.fn = i.prototype, s.Class = i, s.Dom7 = i;
	var a = {
		addClass: function(t) {
			if (void 0 === t) return this;
			for (var e = t.split(" "), i = 0; i < e.length; i += 1)
				for (var s = 0; s < this.length; s += 1) void 0 !== this[s].classList && this[s].classList.add(e[i]);
			return this
		},
		removeClass: function(t) {
			for (var e = t.split(" "), i = 0; i < e.length; i += 1)
				for (var s = 0; s < this.length; s += 1) void 0 !== this[s].classList && this[s].classList.remove(e[i]);
			return this
		},
		hasClass: function(t) {
			return !!this[0] && this[0].classList.contains(t)
		},
		toggleClass: function(t) {
			for (var e = t.split(" "), i = 0; i < e.length; i += 1)
				for (var s = 0; s < this.length; s += 1) void 0 !== this[s].classList && this[s].classList.toggle(e[i]);
			return this
		},
		attr: function(t, e) {
			var i = arguments;
			if (1 === arguments.length && "string" == typeof t) return this[0] ? this[0].getAttribute(t) : void 0;
			for (var s = 0; s < this.length; s += 1)
				if (2 === i.length) this[s].setAttribute(t, e);
				else
					for (var n in t) this[s][n] = t[n], this[s].setAttribute(n, t[n]);
			return this
		},
		removeAttr: function(t) {
			for (var e = 0; e < this.length; e += 1) this[e].removeAttribute(t);
			return this
		},
		data: function(t, e) {
			var i;
			if (void 0 !== e) {
				for (var s = 0; s < this.length; s += 1)(i = this[s]).dom7ElementDataStorage || (i.dom7ElementDataStorage = {}), i.dom7ElementDataStorage[t] = e;
				return this
			}
			if (i = this[0]) return i.dom7ElementDataStorage && t in i.dom7ElementDataStorage ? i.dom7ElementDataStorage[t] : i.getAttribute("data-" + t) || void 0
		},
		transform: function(t) {
			for (var e = 0; e < this.length; e += 1) {
				var i = this[e].style;
				i.webkitTransform = t, i.transform = t
			}
			return this
		},
		transition: function(t) {
			"string" != typeof t && (t += "ms");
			for (var e = 0; e < this.length; e += 1) {
				var i = this[e].style;
				i.webkitTransitionDuration = t, i.transitionDuration = t
			}
			return this
		},
		on: function() {
			for (var t, e = [], i = arguments.length; i--;) e[i] = arguments[i];
			var n = e[0],
				a = e[1],
				o = e[2],
				r = e[3];

			function l(t) {
				var e = t.target;
				if (e) {
					var i = t.target.dom7EventData || [];
					if (i.unshift(t), s(e).is(a)) o.apply(e, i);
					else
						for (var n = s(e).parents(), r = 0; r < n.length; r += 1) s(n[r]).is(a) && o.apply(n[r], i)
				}
			}

			function d(t) {
				var e = t && t.target && t.target.dom7EventData || [];
				e.unshift(t), o.apply(this, e)
			}
			"function" == typeof e[1] && (n = (t = e)[0], o = t[1], r = t[2], a = void 0), r || (r = !1);
			for (var c, h = n.split(" "), u = 0; u < this.length; u += 1) {
				var p = this[u];
				if (a)
					for (c = 0; c < h.length; c += 1) p.dom7LiveListeners || (p.dom7LiveListeners = []), p.dom7LiveListeners.push({
						type: n,
						listener: o,
						proxyListener: l
					}), p.addEventListener(h[c], l, r);
				else
					for (c = 0; c < h.length; c += 1) p.dom7Listeners || (p.dom7Listeners = []), p.dom7Listeners.push({
						type: n,
						listener: o,
						proxyListener: d
					}), p.addEventListener(h[c], d, r)
			}
			return this
		},
		off: function() {
			for (var t, e = [], i = arguments.length; i--;) e[i] = arguments[i];
			var s = e[0],
				n = e[1],
				a = e[2],
				o = e[3];
			"function" == typeof e[1] && (s = (t = e)[0], a = t[1], o = t[2], n = void 0), o || (o = !1);
			for (var r = s.split(" "), l = 0; l < r.length; l += 1)
				for (var d = 0; d < this.length; d += 1) {
					var c = this[d];
					if (n) {
						if (c.dom7LiveListeners)
							for (var h = 0; h < c.dom7LiveListeners.length; h += 1) a ? c.dom7LiveListeners[h].listener === a && c.removeEventListener(r[l], c.dom7LiveListeners[h].proxyListener, o) : c.dom7LiveListeners[h].type === r[l] && c.removeEventListener(r[l], c.dom7LiveListeners[h].proxyListener, o)
					} else if (c.dom7Listeners)
						for (var u = 0; u < c.dom7Listeners.length; u += 1) a ? c.dom7Listeners[u].listener === a && c.removeEventListener(r[l], c.dom7Listeners[u].proxyListener, o) : c.dom7Listeners[u].type === r[l] && c.removeEventListener(r[l], c.dom7Listeners[u].proxyListener, o)
				}
			return this
		},
		trigger: function() {
			for (var i = [], s = arguments.length; s--;) i[s] = arguments[s];
			for (var n = i[0].split(" "), a = i[1], o = 0; o < n.length; o += 1)
				for (var r = 0; r < this.length; r += 1) {
					var l = void 0;
					try {
						l = new e.CustomEvent(n[o], {
							detail: a,
							bubbles: !0,
							cancelable: !0
						})
					} catch (e) {
						(l = t.createEvent("Event")).initEvent(n[o], !0, !0), l.detail = a
					}
					this[r].dom7EventData = i.filter(function(t, e) {
						return e > 0
					}), this[r].dispatchEvent(l), this[r].dom7EventData = [], delete this[r].dom7EventData
				}
			return this
		},
		transitionEnd: function(t) {
			var e, i = ["webkitTransitionEnd", "transitionend"],
				s = this;

			function n(a) {
				if (a.target === this)
					for (t.call(this, a), e = 0; e < i.length; e += 1) s.off(i[e], n)
			}
			if (t)
				for (e = 0; e < i.length; e += 1) s.on(i[e], n);
			return this
		},
		outerWidth: function(t) {
			if (this.length > 0) {
				if (t) {
					var e = this.styles();
					return this[0].offsetWidth + parseFloat(e.getPropertyValue("margin-right")) + parseFloat(e.getPropertyValue("margin-left"))
				}
				return this[0].offsetWidth
			}
			return null
		},
		outerHeight: function(t) {
			if (this.length > 0) {
				if (t) {
					var e = this.styles();
					return this[0].offsetHeight + parseFloat(e.getPropertyValue("margin-top")) + parseFloat(e.getPropertyValue("margin-bottom"))
				}
				return this[0].offsetHeight
			}
			return null
		},
		offset: function() {
			if (this.length > 0) {
				var i = this[0],
					s = i.getBoundingClientRect(),
					n = t.body,
					a = i.clientTop || n.clientTop || 0,
					o = i.clientLeft || n.clientLeft || 0,
					r = i === e ? e.scrollY : i.scrollTop,
					l = i === e ? e.scrollX : i.scrollLeft;
				return {
					top: s.top + r - a,
					left: s.left + l - o
				}
			}
			return null
		},
		css: function(t, i) {
			var s;
			if (1 === arguments.length) {
				if ("string" != typeof t) {
					for (s = 0; s < this.length; s += 1)
						for (var n in t) this[s].style[n] = t[n];
					return this
				}
				if (this[0]) return e.getComputedStyle(this[0], null).getPropertyValue(t)
			}
			if (2 === arguments.length && "string" == typeof t) {
				for (s = 0; s < this.length; s += 1) this[s].style[t] = i;
				return this
			}
			return this
		},
		each: function(t) {
			if (!t) return this;
			for (var e = 0; e < this.length; e += 1)
				if (!1 === t.call(this[e], e, this[e])) return this;
			return this
		},
		html: function(t) {
			if (void 0 === t) return this[0] ? this[0].innerHTML : void 0;
			for (var e = 0; e < this.length; e += 1) this[e].innerHTML = t;
			return this
		},
		text: function(t) {
			if (void 0 === t) return this[0] ? this[0].textContent.trim() : null;
			for (var e = 0; e < this.length; e += 1) this[e].textContent = t;
			return this
		},
		is: function(n) {
			var a, o, r = this[0];
			if (!r || void 0 === n) return !1;
			if ("string" == typeof n) {
				if (r.matches) return r.matches(n);
				if (r.webkitMatchesSelector) return r.webkitMatchesSelector(n);
				if (r.msMatchesSelector) return r.msMatchesSelector(n);
				for (a = s(n), o = 0; o < a.length; o += 1)
					if (a[o] === r) return !0;
				return !1
			}
			if (n === t) return r === t;
			if (n === e) return r === e;
			if (n.nodeType || n instanceof i) {
				for (a = n.nodeType ? [n] : n, o = 0; o < a.length; o += 1)
					if (a[o] === r) return !0;
				return !1
			}
			return !1
		},
		index: function() {
			var t, e = this[0];
			if (e) {
				for (t = 0; null !== (e = e.previousSibling);) 1 === e.nodeType && (t += 1);
				return t
			}
		},
		eq: function(t) {
			if (void 0 === t) return this;
			var e, s = this.length;
			return new i(t > s - 1 ? [] : t < 0 ? (e = s + t) < 0 ? [] : [this[e]] : [this[t]])
		},
		append: function() {
			for (var e, s = [], n = arguments.length; n--;) s[n] = arguments[n];
			for (var a = 0; a < s.length; a += 1) {
				e = s[a];
				for (var o = 0; o < this.length; o += 1)
					if ("string" == typeof e) {
						var r = t.createElement("div");
						for (r.innerHTML = e; r.firstChild;) this[o].appendChild(r.firstChild)
					} else if (e instanceof i)
					for (var l = 0; l < e.length; l += 1) this[o].appendChild(e[l]);
				else this[o].appendChild(e)
			}
			return this
		},
		prepend: function(e) {
			var s, n;
			for (s = 0; s < this.length; s += 1)
				if ("string" == typeof e) {
					var a = t.createElement("div");
					for (a.innerHTML = e, n = a.childNodes.length - 1; n >= 0; n -= 1) this[s].insertBefore(a.childNodes[n], this[s].childNodes[0])
				} else if (e instanceof i)
				for (n = 0; n < e.length; n += 1) this[s].insertBefore(e[n], this[s].childNodes[0]);
			else this[s].insertBefore(e, this[s].childNodes[0]);
			return this
		},
		next: function(t) {
			return this.length > 0 ? t ? this[0].nextElementSibling && s(this[0].nextElementSibling).is(t) ? new i([this[0].nextElementSibling]) : new i([]) : this[0].nextElementSibling ? new i([this[0].nextElementSibling]) : new i([]) : new i([])
		},
		nextAll: function(t) {
			var e = [],
				n = this[0];
			if (!n) return new i([]);
			for (; n.nextElementSibling;) {
				var a = n.nextElementSibling;
				t ? s(a).is(t) && e.push(a) : e.push(a), n = a
			}
			return new i(e)
		},
		prev: function(t) {
			if (this.length > 0) {
				var e = this[0];
				return t ? e.previousElementSibling && s(e.previousElementSibling).is(t) ? new i([e.previousElementSibling]) : new i([]) : e.previousElementSibling ? new i([e.previousElementSibling]) : new i([])
			}
			return new i([])
		},
		prevAll: function(t) {
			var e = [],
				n = this[0];
			if (!n) return new i([]);
			for (; n.previousElementSibling;) {
				var a = n.previousElementSibling;
				t ? s(a).is(t) && e.push(a) : e.push(a), n = a
			}
			return new i(e)
		},
		parent: function(t) {
			for (var e = [], i = 0; i < this.length; i += 1) null !== this[i].parentNode && (t ? s(this[i].parentNode).is(t) && e.push(this[i].parentNode) : e.push(this[i].parentNode));
			return s(n(e))
		},
		parents: function(t) {
			for (var e = [], i = 0; i < this.length; i += 1)
				for (var a = this[i].parentNode; a;) t ? s(a).is(t) && e.push(a) : e.push(a), a = a.parentNode;
			return s(n(e))
		},
		closest: function(t) {
			var e = this;
			return void 0 === t ? new i([]) : (e.is(t) || (e = e.parents(t).eq(0)), e)
		},
		find: function(t) {
			for (var e = [], s = 0; s < this.length; s += 1)
				for (var n = this[s].querySelectorAll(t), a = 0; a < n.length; a += 1) e.push(n[a]);
			return new i(e)
		},
		children: function(t) {
			for (var e = [], a = 0; a < this.length; a += 1)
				for (var o = this[a].childNodes, r = 0; r < o.length; r += 1) t ? 1 === o[r].nodeType && s(o[r]).is(t) && e.push(o[r]) : 1 === o[r].nodeType && e.push(o[r]);
			return new i(n(e))
		},
		remove: function() {
			for (var t = 0; t < this.length; t += 1) this[t].parentNode && this[t].parentNode.removeChild(this[t]);
			return this
		},
		add: function() {
			for (var t = [], e = arguments.length; e--;) t[e] = arguments[e];
			var i, n;
			for (i = 0; i < t.length; i += 1) {
				var a = s(t[i]);
				for (n = 0; n < a.length; n += 1) this[this.length] = a[n], this.length += 1
			}
			return this
		},
		styles: function() {
			return this[0] ? e.getComputedStyle(this[0], null) : {}
		}
	};
	Object.keys(a).forEach(function(t) {
		s.fn[t] = a[t]
	});
	var o, r, l, d = {
			deleteProps: function(t) {
				var e = t;
				Object.keys(e).forEach(function(t) {
					try {
						e[t] = null
					} catch (t) {}
					try {
						delete e[t]
					} catch (t) {}
				})
			},
			nextTick: function(t, e) {
				return void 0 === e && (e = 0), setTimeout(t, e)
			},
			now: function() {
				return Date.now()
			},
			getTranslate: function(t, i) {
				var s, n, a;
				void 0 === i && (i = "x");
				var o = e.getComputedStyle(t, null);
				return e.WebKitCSSMatrix ? ((n = o.transform || o.webkitTransform).split(",").length > 6 && (n = n.split(", ").map(function(t) {
					return t.replace(",", ".")
				}).join(", ")), a = new e.WebKitCSSMatrix("none" === n ? "" : n)) : s = (a = o.MozTransform || o.OTransform || o.MsTransform || o.msTransform || o.transform || o.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")).toString().split(","), "x" === i && (n = e.WebKitCSSMatrix ? a.m41 : 16 === s.length ? parseFloat(s[12]) : parseFloat(s[4])), "y" === i && (n = e.WebKitCSSMatrix ? a.m42 : 16 === s.length ? parseFloat(s[13]) : parseFloat(s[5])), n || 0
			},
			parseUrlQuery: function(t) {
				var i, s, n, a, o = {},
					r = t || e.location.href;
				if ("string" == typeof r && r.length)
					for (a = (s = (r = r.indexOf("?") > -1 ? r.replace(/\S*\?/, "") : "").split("&").filter(function(t) {
							return "" !== t
						})).length, i = 0; i < a; i += 1) n = s[i].replace(/#\S+/g, "").split("="), o[decodeURIComponent(n[0])] = void 0 === n[1] ? void 0 : decodeURIComponent(n[1]) || "";
				return o
			},
			isObject: function(t) {
				return "object" == typeof t && null !== t && t.constructor && t.constructor === Object
			},
			extend: function() {
				for (var t = [], e = arguments.length; e--;) t[e] = arguments[e];
				for (var i = Object(t[0]), s = 1; s < t.length; s += 1) {
					var n = t[s];
					if (null != n)
						for (var a = Object.keys(Object(n)), o = 0, r = a.length; o < r; o += 1) {
							var l = a[o],
								c = Object.getOwnPropertyDescriptor(n, l);
							void 0 !== c && c.enumerable && (d.isObject(i[l]) && d.isObject(n[l]) ? d.extend(i[l], n[l]) : !d.isObject(i[l]) && d.isObject(n[l]) ? (i[l] = {}, d.extend(i[l], n[l])) : i[l] = n[l])
						}
				}
				return i
			}
		},
		c = (l = t.createElement("div"), {
			touch: e.Modernizr && !0 === e.Modernizr.touch || !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch),
			pointerEvents: !(!e.navigator.pointerEnabled && !e.PointerEvent),
			prefixedPointerEvents: !!e.navigator.msPointerEnabled,
			transition: (r = l.style, "transition" in r || "webkitTransition" in r || "MozTransition" in r),
			transforms3d: e.Modernizr && !0 === e.Modernizr.csstransforms3d || (o = l.style, "webkitPerspective" in o || "MozPerspective" in o || "OPerspective" in o || "MsPerspective" in o || "perspective" in o),
			flexbox: function() {
				for (var t = l.style, e = "alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient".split(" "), i = 0; i < e.length; i += 1)
					if (e[i] in t) return !0;
				return !1
			}(),
			observer: "MutationObserver" in e || "WebkitMutationObserver" in e,
			passiveListener: function() {
				var t = !1;
				try {
					var i = Object.defineProperty({}, "passive", {
						get: function() {
							t = !0
						}
					});
					e.addEventListener("testPassiveListener", null, i)
				} catch (t) {}
				return t
			}(),
			gestures: "ongesturestart" in e
		}),
		h = function(t) {
			void 0 === t && (t = {});
			var e = this;
			e.params = t, e.eventsListeners = {}, e.params && e.params.on && Object.keys(e.params.on).forEach(function(t) {
				e.on(t, e.params.on[t])
			})
		},
		u = {
			components: {
				configurable: !0
			}
		};
	h.prototype.on = function(t, e, i) {
		var s = this;
		if ("function" != typeof e) return s;
		var n = i ? "unshift" : "push";
		return t.split(" ").forEach(function(t) {
			s.eventsListeners[t] || (s.eventsListeners[t] = []), s.eventsListeners[t][n](e)
		}), s
	}, h.prototype.once = function(t, e, i) {
		var s = this;
		return "function" != typeof e ? s : s.on(t, function i() {
			for (var n = [], a = arguments.length; a--;) n[a] = arguments[a];
			e.apply(s, n), s.off(t, i)
		}, i)
	}, h.prototype.off = function(t, e) {
		var i = this;
		return t.split(" ").forEach(function(t) {
			void 0 === e ? i.eventsListeners[t] = [] : i.eventsListeners[t].forEach(function(s, n) {
				s === e && i.eventsListeners[t].splice(n, 1)
			})
		}), i
	}, h.prototype.emit = function() {
		for (var t = [], e = arguments.length; e--;) t[e] = arguments[e];
		var i, s, n, a = this;
		return a.eventsListeners ? ("string" == typeof t[0] || Array.isArray(t[0]) ? (i = t[0], s = t.slice(1, t.length), n = a) : (i = t[0].events, s = t[0].data, n = t[0].context || a), (Array.isArray(i) ? i : i.split(" ")).forEach(function(t) {
			if (a.eventsListeners[t]) {
				var e = [];
				a.eventsListeners[t].forEach(function(t) {
					e.push(t)
				}), e.forEach(function(t) {
					t.apply(n, s)
				})
			}
		}), a) : a
	}, h.prototype.useModulesParams = function(t) {
		var e = this;
		e.modules && Object.keys(e.modules).forEach(function(i) {
			var s = e.modules[i];
			s.params && d.extend(t, s.params)
		})
	}, h.prototype.useModules = function(t) {
		void 0 === t && (t = {});
		var e = this;
		e.modules && Object.keys(e.modules).forEach(function(i) {
			var s = e.modules[i],
				n = t[i] || {};
			s.instance && Object.keys(s.instance).forEach(function(t) {
				var i = s.instance[t];
				e[t] = "function" == typeof i ? i.bind(e) : i
			}), s.on && e.on && Object.keys(s.on).forEach(function(t) {
				e.on(t, s.on[t])
			}), s.create && s.create.bind(e)(n)
		})
	}, u.components.set = function(t) {
		this.use && this.use(t)
	}, h.installModule = function(t) {
		for (var e = [], i = arguments.length - 1; i-- > 0;) e[i] = arguments[i + 1];
		var s = this;
		s.prototype.modules || (s.prototype.modules = {});
		var n = t.name || Object.keys(s.prototype.modules).length + "_" + d.now();
		return s.prototype.modules[n] = t, t.proto && Object.keys(t.proto).forEach(function(e) {
			s.prototype[e] = t.proto[e]
		}), t.static && Object.keys(t.static).forEach(function(e) {
			s[e] = t.static[e]
		}), t.install && t.install.apply(s, e), s
	}, h.use = function(t) {
		for (var e = [], i = arguments.length - 1; i-- > 0;) e[i] = arguments[i + 1];
		var s = this;
		return Array.isArray(t) ? (t.forEach(function(t) {
			return s.installModule(t)
		}), s) : s.installModule.apply(s, [t].concat(e))
	}, Object.defineProperties(h, u);
	var p = {
			updateSize: function() {
				var t, e, i = this.$el;
				t = void 0 !== this.params.width ? this.params.width : i[0].clientWidth, e = void 0 !== this.params.height ? this.params.height : i[0].clientHeight, 0 === t && this.isHorizontal() || 0 === e && this.isVertical() || (t = t - parseInt(i.css("padding-left"), 10) - parseInt(i.css("padding-right"), 10), e = e - parseInt(i.css("padding-top"), 10) - parseInt(i.css("padding-bottom"), 10), d.extend(this, {
					width: t,
					height: e,
					size: this.isHorizontal() ? t : e
				}))
			},
			updateSlides: function() {
				var t = this.params,
					i = this.$wrapperEl,
					s = this.size,
					n = this.rtlTranslate,
					a = this.wrongRTL,
					o = i.children("." + this.params.slideClass),
					r = this.virtual && t.virtual.enabled ? this.virtual.slides.length : o.length,
					l = [],
					h = [],
					u = [],
					p = t.slidesOffsetBefore;
				"function" == typeof p && (p = t.slidesOffsetBefore.call(this));
				var f = t.slidesOffsetAfter;
				"function" == typeof f && (f = t.slidesOffsetAfter.call(this));
				var m = r,
					g = this.snapGrid.length,
					v = this.snapGrid.length,
					y = t.spaceBetween,
					b = -p,
					w = 0,
					S = 0;
				if (void 0 !== s) {
					var x, T;
					"string" == typeof y && y.indexOf("%") >= 0 && (y = parseFloat(y.replace("%", "")) / 100 * s), this.virtualSize = -y, n ? o.css({
						marginLeft: "",
						marginTop: ""
					}) : o.css({
						marginRight: "",
						marginBottom: ""
					}), t.slidesPerColumn > 1 && (x = Math.floor(r / t.slidesPerColumn) === r / this.params.slidesPerColumn ? r : Math.ceil(r / t.slidesPerColumn) * t.slidesPerColumn, "auto" !== t.slidesPerView && "row" === t.slidesPerColumnFill && (x = Math.max(x, t.slidesPerView * t.slidesPerColumn)));
					for (var C, _ = t.slidesPerColumn, E = x / _, P = E - (t.slidesPerColumn * E - r), k = 0; k < r; k += 1) {
						T = 0;
						var $ = o.eq(k);
						if (t.slidesPerColumn > 1) {
							var M = void 0,
								D = void 0,
								O = void 0;
							"column" === t.slidesPerColumnFill ? (O = k - (D = Math.floor(k / _)) * _, (D > P || D === P && O === _ - 1) && (O += 1) >= _ && (O = 0, D += 1), M = D + O * x / _, $.css({
								"-webkit-box-ordinal-group": M,
								"-moz-box-ordinal-group": M,
								"-ms-flex-order": M,
								"-webkit-order": M,
								order: M
							})) : D = k - (O = Math.floor(k / E)) * E, $.css("margin-" + (this.isHorizontal() ? "top" : "left"), 0 !== O && t.spaceBetween && t.spaceBetween + "px").attr("data-swiper-column", D).attr("data-swiper-row", O)
						}
						if ("none" !== $.css("display")) {
							if ("auto" === t.slidesPerView) {
								var z = e.getComputedStyle($[0], null);
								T = this.isHorizontal() ? $[0].getBoundingClientRect().width + parseFloat(z.getPropertyValue("margin-left")) + parseFloat(z.getPropertyValue("margin-right")) : $[0].getBoundingClientRect().height + parseFloat(z.getPropertyValue("margin-top")) + parseFloat(z.getPropertyValue("margin-bottom")), t.roundLengths && (T = Math.floor(T))
							} else T = (s - (t.slidesPerView - 1) * y) / t.slidesPerView, t.roundLengths && (T = Math.floor(T)), o[k] && (this.isHorizontal() ? o[k].style.width = T + "px" : o[k].style.height = T + "px");
							o[k] && (o[k].swiperSlideSize = T), u.push(T), t.centeredSlides ? (b = b + T / 2 + w / 2 + y, 0 === w && 0 !== k && (b = b - s / 2 - y), 0 === k && (b = b - s / 2 - y), Math.abs(b) < .001 && (b = 0), S % t.slidesPerGroup == 0 && l.push(b), h.push(b)) : (S % t.slidesPerGroup == 0 && l.push(b), h.push(b), b = b + T + y), this.virtualSize += T + y, w = T, S += 1
						}
					}
					if (this.virtualSize = Math.max(this.virtualSize, s) + f, n && a && ("slide" === t.effect || "coverflow" === t.effect) && i.css({
							width: this.virtualSize + t.spaceBetween + "px"
						}), c.flexbox && !t.setWrapperSize || (this.isHorizontal() ? i.css({
							width: this.virtualSize + t.spaceBetween + "px"
						}) : i.css({
							height: this.virtualSize + t.spaceBetween + "px"
						})), t.slidesPerColumn > 1 && (this.virtualSize = (T + t.spaceBetween) * x, this.virtualSize = Math.ceil(this.virtualSize / t.slidesPerColumn) - t.spaceBetween, this.isHorizontal() ? i.css({
							width: this.virtualSize + t.spaceBetween + "px"
						}) : i.css({
							height: this.virtualSize + t.spaceBetween + "px"
						}), t.centeredSlides)) {
						C = [];
						for (var A = 0; A < l.length; A += 1) l[A] < this.virtualSize + l[0] && C.push(l[A]);
						l = C
					}
					if (!t.centeredSlides) {
						C = [];
						for (var I = 0; I < l.length; I += 1) l[I] <= this.virtualSize - s && C.push(l[I]);
						l = C, Math.floor(this.virtualSize - s) - Math.floor(l[l.length - 1]) > 1 && l.push(this.virtualSize - s)
					}
					0 === l.length && (l = [0]), 0 !== t.spaceBetween && (this.isHorizontal() ? n ? o.css({
						marginLeft: y + "px"
					}) : o.css({
						marginRight: y + "px"
					}) : o.css({
						marginBottom: y + "px"
					})), d.extend(this, {
						slides: o,
						snapGrid: l,
						slidesGrid: h,
						slidesSizesGrid: u
					}), r !== m && this.emit("slidesLengthChange"), l.length !== g && (this.params.watchOverflow && this.checkOverflow(), this.emit("snapGridLengthChange")), h.length !== v && this.emit("slidesGridLengthChange"), (t.watchSlidesProgress || t.watchSlidesVisibility) && this.updateSlidesOffset()
				}
			},
			updateAutoHeight: function(t) {
				var e, i = [],
					s = 0;
				if ("number" == typeof t ? this.setTransition(t) : !0 === t && this.setTransition(this.params.speed), "auto" !== this.params.slidesPerView && this.params.slidesPerView > 1)
					for (e = 0; e < Math.ceil(this.params.slidesPerView); e += 1) {
						var n = this.activeIndex + e;
						if (n > this.slides.length) break;
						i.push(this.slides.eq(n)[0])
					} else i.push(this.slides.eq(this.activeIndex)[0]);
				for (e = 0; e < i.length; e += 1)
					if (void 0 !== i[e]) {
						var a = i[e].offsetHeight;
						s = a > s ? a : s
					} s && this.$wrapperEl.css("height", s + "px")
			},
			updateSlidesOffset: function() {
				for (var t = this.slides, e = 0; e < t.length; e += 1) t[e].swiperSlideOffset = this.isHorizontal() ? t[e].offsetLeft : t[e].offsetTop
			},
			updateSlidesProgress: function(t) {
				void 0 === t && (t = this.translate || 0);
				var e = this.params,
					i = this.slides,
					s = this.rtlTranslate;
				if (0 !== i.length) {
					void 0 === i[0].swiperSlideOffset && this.updateSlidesOffset();
					var n = -t;
					s && (n = t), i.removeClass(e.slideVisibleClass);
					for (var a = 0; a < i.length; a += 1) {
						var o = i[a],
							r = (n + (e.centeredSlides ? this.minTranslate() : 0) - o.swiperSlideOffset) / (o.swiperSlideSize + e.spaceBetween);
						if (e.watchSlidesVisibility) {
							var l = -(n - o.swiperSlideOffset),
								d = l + this.slidesSizesGrid[a];
							(l >= 0 && l < this.size || d > 0 && d <= this.size || l <= 0 && d >= this.size) && i.eq(a).addClass(e.slideVisibleClass)
						}
						o.progress = s ? -r : r
					}
				}
			},
			updateProgress: function(t) {
				void 0 === t && (t = this.translate || 0);
				var e = this.params,
					i = this.maxTranslate() - this.minTranslate(),
					s = this.progress,
					n = this.isBeginning,
					a = this.isEnd,
					o = n,
					r = a;
				0 === i ? (s = 0, n = !0, a = !0) : (n = (s = (t - this.minTranslate()) / i) <= 0, a = s >= 1), d.extend(this, {
					progress: s,
					isBeginning: n,
					isEnd: a
				}), (e.watchSlidesProgress || e.watchSlidesVisibility) && this.updateSlidesProgress(t), n && !o && this.emit("reachBeginning toEdge"), a && !r && this.emit("reachEnd toEdge"), (o && !n || r && !a) && this.emit("fromEdge"), this.emit("progress", s)
			},
			updateSlidesClasses: function() {
				var t, e = this.slides,
					i = this.params,
					s = this.$wrapperEl,
					n = this.activeIndex,
					a = this.realIndex,
					o = this.virtual && i.virtual.enabled;
				e.removeClass(i.slideActiveClass + " " + i.slideNextClass + " " + i.slidePrevClass + " " + i.slideDuplicateActiveClass + " " + i.slideDuplicateNextClass + " " + i.slideDuplicatePrevClass), (t = o ? this.$wrapperEl.find("." + i.slideClass + '[data-swiper-slide-index="' + n + '"]') : e.eq(n)).addClass(i.slideActiveClass), i.loop && (t.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + a + '"]').addClass(i.slideDuplicateActiveClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + a + '"]').addClass(i.slideDuplicateActiveClass));
				var r = t.nextAll("." + i.slideClass).eq(0).addClass(i.slideNextClass);
				i.loop && 0 === r.length && (r = e.eq(0)).addClass(i.slideNextClass);
				var l = t.prevAll("." + i.slideClass).eq(0).addClass(i.slidePrevClass);
				i.loop && 0 === l.length && (l = e.eq(-1)).addClass(i.slidePrevClass), i.loop && (r.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + r.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicateNextClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + r.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicateNextClass), l.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + l.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicatePrevClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + l.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicatePrevClass))
			},
			updateActiveIndex: function(t) {
				var e, i = this.rtlTranslate ? this.translate : -this.translate,
					s = this.slidesGrid,
					n = this.snapGrid,
					a = this.params,
					o = this.activeIndex,
					r = this.realIndex,
					l = this.snapIndex,
					c = t;
				if (void 0 === c) {
					for (var h = 0; h < s.length; h += 1) void 0 !== s[h + 1] ? i >= s[h] && i < s[h + 1] - (s[h + 1] - s[h]) / 2 ? c = h : i >= s[h] && i < s[h + 1] && (c = h + 1) : i >= s[h] && (c = h);
					a.normalizeSlideIndex && (c < 0 || void 0 === c) && (c = 0)
				}
				if ((e = n.indexOf(i) >= 0 ? n.indexOf(i) : Math.floor(c / a.slidesPerGroup)) >= n.length && (e = n.length - 1), c !== o) {
					var u = parseInt(this.slides.eq(c).attr("data-swiper-slide-index") || c, 10);
					d.extend(this, {
						snapIndex: e,
						realIndex: u,
						previousIndex: o,
						activeIndex: c
					}), this.emit("activeIndexChange"), this.emit("snapIndexChange"), r !== u && this.emit("realIndexChange"), this.emit("slideChange")
				} else e !== l && (this.snapIndex = e, this.emit("snapIndexChange"))
			},
			updateClickedSlide: function(t) {
				var e = this.params,
					i = s(t.target).closest("." + e.slideClass)[0],
					n = !1;
				if (i)
					for (var a = 0; a < this.slides.length; a += 1) this.slides[a] === i && (n = !0);
				if (!i || !n) return this.clickedSlide = void 0, void(this.clickedIndex = void 0);
				this.clickedSlide = i, this.virtual && this.params.virtual.enabled ? this.clickedIndex = parseInt(s(i).attr("data-swiper-slide-index"), 10) : this.clickedIndex = s(i).index(), e.slideToClickedSlide && void 0 !== this.clickedIndex && this.clickedIndex !== this.activeIndex && this.slideToClickedSlide()
			}
		},
		f = {
			getTranslate: function(t) {
				void 0 === t && (t = this.isHorizontal() ? "x" : "y");
				var e = this.params,
					i = this.rtlTranslate,
					s = this.translate,
					n = this.$wrapperEl;
				if (e.virtualTranslate) return i ? -s : s;
				var a = d.getTranslate(n[0], t);
				return i && (a = -a), a || 0
			},
			setTranslate: function(t, e) {
				var i = this.rtlTranslate,
					s = this.params,
					n = this.$wrapperEl,
					a = this.progress,
					o = 0,
					r = 0;
				this.isHorizontal() ? o = i ? -t : t : r = t, s.roundLengths && (o = Math.floor(o), r = Math.floor(r)), s.virtualTranslate || (c.transforms3d ? n.transform("translate3d(" + o + "px, " + r + "px, 0px)") : n.transform("translate(" + o + "px, " + r + "px)")), this.translate = this.isHorizontal() ? o : r;
				var l = this.maxTranslate() - this.minTranslate();
				(0 === l ? 0 : (t - this.minTranslate()) / l) !== a && this.updateProgress(t), this.emit("setTranslate", this.translate, e)
			},
			minTranslate: function() {
				return -this.snapGrid[0]
			},
			maxTranslate: function() {
				return -this.snapGrid[this.snapGrid.length - 1]
			}
		},
		m = {
			slideTo: function(t, e, i, s) {
				void 0 === t && (t = 0), void 0 === e && (e = this.params.speed), void 0 === i && (i = !0);
				var n = this,
					a = t;
				a < 0 && (a = 0);
				var o = n.params,
					r = n.snapGrid,
					l = n.slidesGrid,
					d = n.previousIndex,
					h = n.activeIndex,
					u = n.rtlTranslate,
					p = n.$wrapperEl;
				if (n.animating && o.preventIntercationOnTransition) return !1;
				var f = Math.floor(a / o.slidesPerGroup);
				f >= r.length && (f = r.length - 1), (h || o.initialSlide || 0) === (d || 0) && i && n.emit("beforeSlideChangeStart");
				var m, g = -r[f];
				if (n.updateProgress(g), o.normalizeSlideIndex)
					for (var v = 0; v < l.length; v += 1) - Math.floor(100 * g) >= Math.floor(100 * l[v]) && (a = v);
				if (n.initialized && a !== h) {
					if (!n.allowSlideNext && g < n.translate && g < n.minTranslate()) return !1;
					if (!n.allowSlidePrev && g > n.translate && g > n.maxTranslate() && (h || 0) !== a) return !1
				}
				return m = a > h ? "next" : a < h ? "prev" : "reset", u && -g === n.translate || !u && g === n.translate ? (n.updateActiveIndex(a), o.autoHeight && n.updateAutoHeight(), n.updateSlidesClasses(), "slide" !== o.effect && n.setTranslate(g), "reset" !== m && (n.transitionStart(i, m), n.transitionEnd(i, m)), !1) : (0 !== e && c.transition ? (n.setTransition(e), n.setTranslate(g), n.updateActiveIndex(a), n.updateSlidesClasses(), n.emit("beforeTransitionStart", e, s), n.transitionStart(i, m), n.animating || (n.animating = !0, p.transitionEnd(function() {
					n && !n.destroyed && n.transitionEnd(i, m)
				}))) : (n.setTransition(0), n.setTranslate(g), n.updateActiveIndex(a), n.updateSlidesClasses(), n.emit("beforeTransitionStart", e, s), n.transitionStart(i, m), n.transitionEnd(i, m)), !0)
			},
			slideToLoop: function(t, e, i, s) {
				void 0 === t && (t = 0), void 0 === e && (e = this.params.speed), void 0 === i && (i = !0);
				var n = t;
				return this.params.loop && (n += this.loopedSlides), this.slideTo(n, e, i, s)
			},
			slideNext: function(t, e, i) {
				void 0 === t && (t = this.params.speed), void 0 === e && (e = !0);
				var s = this.params,
					n = this.animating;
				return s.loop ? !n && (this.loopFix(), this._clientLeft = this.$wrapperEl[0].clientLeft, this.slideTo(this.activeIndex + s.slidesPerGroup, t, e, i)) : this.slideTo(this.activeIndex + s.slidesPerGroup, t, e, i)
			},
			slidePrev: function(t, e, i) {
				void 0 === t && (t = this.params.speed), void 0 === e && (e = !0);
				var s = this.params,
					n = this.animating;
				return s.loop ? !n && (this.loopFix(), this._clientLeft = this.$wrapperEl[0].clientLeft, this.slideTo(this.activeIndex - 1, t, e, i)) : this.slideTo(this.activeIndex - 1, t, e, i)
			},
			slideReset: function(t, e, i) {
				return void 0 === t && (t = this.params.speed), void 0 === e && (e = !0), this.slideTo(this.activeIndex, t, e, i)
			},
			slideToClosest: function(t, e, i) {
				void 0 === t && (t = this.params.speed), void 0 === e && (e = !0);
				var s = this.activeIndex,
					n = Math.floor(s / this.params.slidesPerGroup);
				if (n < this.snapGrid.length - 1) {
					var a = this.rtlTranslate ? this.translate : -this.translate,
						o = this.snapGrid[n];
					a - o > (this.snapGrid[n + 1] - o) / 2 && (s = this.params.slidesPerGroup)
				}
				return this.slideTo(s, t, e, i)
			},
			slideToClickedSlide: function() {
				var t, e = this,
					i = e.params,
					n = e.$wrapperEl,
					a = "auto" === i.slidesPerView ? e.slidesPerViewDynamic() : i.slidesPerView,
					o = e.clickedIndex;
				if (i.loop) {
					if (e.animating) return;
					t = parseInt(s(e.clickedSlide).attr("data-swiper-slide-index"), 10), i.centeredSlides ? o < e.loopedSlides - a / 2 || o > e.slides.length - e.loopedSlides + a / 2 ? (e.loopFix(), o = n.children("." + i.slideClass + '[data-swiper-slide-index="' + t + '"]:not(.' + i.slideDuplicateClass + ")").eq(0).index(), d.nextTick(function() {
						e.slideTo(o)
					})) : e.slideTo(o) : o > e.slides.length - a ? (e.loopFix(), o = n.children("." + i.slideClass + '[data-swiper-slide-index="' + t + '"]:not(.' + i.slideDuplicateClass + ")").eq(0).index(), d.nextTick(function() {
						e.slideTo(o)
					})) : e.slideTo(o)
				} else e.slideTo(o)
			}
		},
		g = {
			loopCreate: function() {
				var e = this,
					i = e.params,
					n = e.$wrapperEl;
				n.children("." + i.slideClass + "." + i.slideDuplicateClass).remove();
				var a = n.children("." + i.slideClass);
				if (i.loopFillGroupWithBlank) {
					var o = i.slidesPerGroup - a.length % i.slidesPerGroup;
					if (o !== i.slidesPerGroup) {
						for (var r = 0; r < o; r += 1) {
							var l = s(t.createElement("div")).addClass(i.slideClass + " " + i.slideBlankClass);
							n.append(l)
						}
						a = n.children("." + i.slideClass)
					}
				}
				"auto" !== i.slidesPerView || i.loopedSlides || (i.loopedSlides = a.length), e.loopedSlides = parseInt(i.loopedSlides || i.slidesPerView, 10), e.loopedSlides += i.loopAdditionalSlides, e.loopedSlides > a.length && (e.loopedSlides = a.length);
				var d = [],
					c = [];
				a.each(function(t, i) {
					var n = s(i);
					t < e.loopedSlides && c.push(i), t < a.length && t >= a.length - e.loopedSlides && d.push(i), n.attr("data-swiper-slide-index", t)
				});
				for (var h = 0; h < c.length; h += 1) n.append(s(c[h].cloneNode(!0)).addClass(i.slideDuplicateClass));
				for (var u = d.length - 1; u >= 0; u -= 1) n.prepend(s(d[u].cloneNode(!0)).addClass(i.slideDuplicateClass))
			},
			loopFix: function() {
				var t, e = this.params,
					i = this.activeIndex,
					s = this.slides,
					n = this.loopedSlides,
					a = this.allowSlidePrev,
					o = this.allowSlideNext,
					r = this.snapGrid,
					l = this.rtlTranslate;
				this.allowSlidePrev = !0, this.allowSlideNext = !0;
				var d = -r[i] - this.getTranslate();
				i < n ? (t = s.length - 3 * n + i, t += n, this.slideTo(t, 0, !1, !0) && 0 !== d && this.setTranslate((l ? -this.translate : this.translate) - d)) : ("auto" === e.slidesPerView && i >= 2 * n || i > s.length - 2 * e.slidesPerView) && (t = -s.length + i + n, t += n, this.slideTo(t, 0, !1, !0) && 0 !== d && this.setTranslate((l ? -this.translate : this.translate) - d)), this.allowSlidePrev = a, this.allowSlideNext = o
			},
			loopDestroy: function() {
				var t = this.$wrapperEl,
					e = this.params,
					i = this.slides;
				t.children("." + e.slideClass + "." + e.slideDuplicateClass).remove(), i.removeAttr("data-swiper-slide-index")
			}
		},
		v = {
			setGrabCursor: function(t) {
				if (!c.touch && this.params.simulateTouch) {
					var e = this.el;
					e.style.cursor = "move", e.style.cursor = t ? "-webkit-grabbing" : "-webkit-grab", e.style.cursor = t ? "-moz-grabbin" : "-moz-grab", e.style.cursor = t ? "grabbing" : "grab"
				}
			},
			unsetGrabCursor: function() {
				c.touch || (this.el.style.cursor = "")
			}
		},
		y = {
			appendSlide: function(t) {
				var e = this.$wrapperEl,
					i = this.params;
				if (i.loop && this.loopDestroy(), "object" == typeof t && "length" in t)
					for (var s = 0; s < t.length; s += 1) t[s] && e.append(t[s]);
				else e.append(t);
				i.loop && this.loopCreate(), i.observer && c.observer || this.update()
			},
			prependSlide: function(t) {
				var e = this.params,
					i = this.$wrapperEl,
					s = this.activeIndex;
				e.loop && this.loopDestroy();
				var n = s + 1;
				if ("object" == typeof t && "length" in t) {
					for (var a = 0; a < t.length; a += 1) t[a] && i.prepend(t[a]);
					n = s + t.length
				} else i.prepend(t);
				e.loop && this.loopCreate(), e.observer && c.observer || this.update(), this.slideTo(n, 0, !1)
			},
			removeSlide: function(t) {
				var e = this.params,
					i = this.$wrapperEl,
					s = this.activeIndex;
				e.loop && (this.loopDestroy(), this.slides = i.children("." + e.slideClass));
				var n, a = s;
				if ("object" == typeof t && "length" in t) {
					for (var o = 0; o < t.length; o += 1) n = t[o], this.slides[n] && this.slides.eq(n).remove(), n < a && (a -= 1);
					a = Math.max(a, 0)
				} else n = t, this.slides[n] && this.slides.eq(n).remove(), n < a && (a -= 1), a = Math.max(a, 0);
				e.loop && this.loopCreate(), e.observer && c.observer || this.update(), e.loop ? this.slideTo(a + this.loopedSlides, 0, !1) : this.slideTo(a, 0, !1)
			},
			removeAllSlides: function() {
				for (var t = [], e = 0; e < this.slides.length; e += 1) t.push(e);
				this.removeSlide(t)
			}
		},
		b = function() {
			var i = e.navigator.userAgent,
				s = {
					ios: !1,
					android: !1,
					androidChrome: !1,
					desktop: !1,
					windows: !1,
					iphone: !1,
					ipod: !1,
					ipad: !1,
					cordova: e.cordova || e.phonegap,
					phonegap: e.cordova || e.phonegap
				},
				n = i.match(/(Windows Phone);?[\s\/]+([\d.]+)?/),
				a = i.match(/(Android);?[\s\/]+([\d.]+)?/),
				o = i.match(/(iPad).*OS\s([\d_]+)/),
				r = i.match(/(iPod)(.*OS\s([\d_]+))?/),
				l = !o && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
			if (n && (s.os = "windows", s.osVersion = n[2], s.windows = !0), a && !n && (s.os = "android", s.osVersion = a[2], s.android = !0, s.androidChrome = i.toLowerCase().indexOf("chrome") >= 0), (o || l || r) && (s.os = "ios", s.ios = !0), l && !r && (s.osVersion = l[2].replace(/_/g, "."), s.iphone = !0), o && (s.osVersion = o[2].replace(/_/g, "."), s.ipad = !0), r && (s.osVersion = r[3] ? r[3].replace(/_/g, ".") : null, s.iphone = !0), s.ios && s.osVersion && i.indexOf("Version/") >= 0 && "10" === s.osVersion.split(".")[0] && (s.osVersion = i.toLowerCase().split("version/")[1].split(" ")[0]), s.desktop = !(s.os || s.android || s.webView), s.webView = (l || o || r) && i.match(/.*AppleWebKit(?!.*Safari)/i), s.os && "ios" === s.os) {
				var d = s.osVersion.split("."),
					c = t.querySelector('meta[name="viewport"]');
				s.minimalUi = !s.webView && (r || l) && (1 * d[0] == 7 ? 1 * d[1] >= 1 : 1 * d[0] > 7) && c && c.getAttribute("content").indexOf("minimal-ui") >= 0
			}
			return s.pixelRatio = e.devicePixelRatio || 1, s
		}();

	function w() {
		var t = this.params,
			e = this.el;
		if (!e || 0 !== e.offsetWidth) {
			t.breakpoints && this.setBreakpoint();
			var i = this.allowSlideNext,
				s = this.allowSlidePrev;
			if (this.allowSlideNext = !0, this.allowSlidePrev = !0, this.updateSize(), this.updateSlides(), t.freeMode) {
				var n = Math.min(Math.max(this.translate, this.maxTranslate()), this.minTranslate());
				this.setTranslate(n), this.updateActiveIndex(), this.updateSlidesClasses(), t.autoHeight && this.updateAutoHeight()
			} else this.updateSlidesClasses(), ("auto" === t.slidesPerView || t.slidesPerView > 1) && this.isEnd && !this.params.centeredSlides ? this.slideTo(this.slides.length - 1, 0, !1, !0) : this.slideTo(this.activeIndex, 0, !1, !0);
			this.allowSlidePrev = s, this.allowSlideNext = i
		}
	}
	var S = {
			attachEvents: function() {
				var i = this.params,
					n = this.touchEvents,
					a = this.el,
					o = this.wrapperEl;
				this.onTouchStart = function(i) {
					var n = this.touchEventsData,
						a = this.params,
						o = this.touches;
					if (!this.animating || !a.preventIntercationOnTransition) {
						var r = i;
						if (r.originalEvent && (r = r.originalEvent), n.isTouchEvent = "touchstart" === r.type, (n.isTouchEvent || !("which" in r) || 3 !== r.which) && (!n.isTouched || !n.isMoved))
							if (a.noSwiping && s(r.target).closest(a.noSwipingSelector ? a.noSwipingSelector : "." + a.noSwipingClass)[0]) this.allowClick = !0;
							else if (!a.swipeHandler || s(r).closest(a.swipeHandler)[0]) {
							o.currentX = "touchstart" === r.type ? r.targetTouches[0].pageX : r.pageX, o.currentY = "touchstart" === r.type ? r.targetTouches[0].pageY : r.pageY;
							var l = o.currentX,
								c = o.currentY;
							if (!(b.ios && !b.cordova && a.iOSEdgeSwipeDetection && l <= a.iOSEdgeSwipeThreshold && l >= e.screen.width - a.iOSEdgeSwipeThreshold)) {
								if (d.extend(n, {
										isTouched: !0,
										isMoved: !1,
										allowTouchCallbacks: !0,
										isScrolling: void 0,
										startMoving: void 0
									}), o.startX = l, o.startY = c, n.touchStartTime = d.now(), this.allowClick = !0, this.updateSize(), this.swipeDirection = void 0, a.threshold > 0 && (n.allowThresholdMove = !1), "touchstart" !== r.type) {
									var h = !0;
									s(r.target).is(n.formElements) && (h = !1), t.activeElement && s(t.activeElement).is(n.formElements) && t.activeElement !== r.target && t.activeElement.blur(), h && this.allowTouchMove && r.preventDefault()
								}
								this.emit("touchStart", r)
							}
						}
					}
				}.bind(this), this.onTouchMove = function(e) {
					var i = this.touchEventsData,
						n = this.params,
						a = this.touches,
						o = this.rtlTranslate,
						r = e;
					if (r.originalEvent && (r = r.originalEvent), i.isTouched) {
						if (!i.isTouchEvent || "mousemove" !== r.type) {
							var l = "touchmove" === r.type ? r.targetTouches[0].pageX : r.pageX,
								c = "touchmove" === r.type ? r.targetTouches[0].pageY : r.pageY;
							if (r.preventedByNestedSwiper) return a.startX = l, void(a.startY = c);
							if (!this.allowTouchMove) return this.allowClick = !1, void(i.isTouched && (d.extend(a, {
								startX: l,
								startY: c,
								currentX: l,
								currentY: c
							}), i.touchStartTime = d.now()));
							if (i.isTouchEvent && n.touchReleaseOnEdges && !n.loop)
								if (this.isVertical()) {
									if (c < a.startY && this.translate <= this.maxTranslate() || c > a.startY && this.translate >= this.minTranslate()) return i.isTouched = !1, void(i.isMoved = !1)
								} else if (l < a.startX && this.translate <= this.maxTranslate() || l > a.startX && this.translate >= this.minTranslate()) return;
							if (i.isTouchEvent && t.activeElement && r.target === t.activeElement && s(r.target).is(i.formElements)) return i.isMoved = !0, void(this.allowClick = !1);
							if (i.allowTouchCallbacks && this.emit("touchMove", r), !(r.targetTouches && r.targetTouches.length > 1)) {
								a.currentX = l, a.currentY = c;
								var h, u = a.currentX - a.startX,
									p = a.currentY - a.startY;
								if (void 0 === i.isScrolling && (this.isHorizontal() && a.currentY === a.startY || this.isVertical() && a.currentX === a.startX ? i.isScrolling = !1 : u * u + p * p >= 25 && (h = 180 * Math.atan2(Math.abs(p), Math.abs(u)) / Math.PI, i.isScrolling = this.isHorizontal() ? h > n.touchAngle : 90 - h > n.touchAngle)), i.isScrolling && this.emit("touchMoveOpposite", r), "undefined" == typeof startMoving && (a.currentX === a.startX && a.currentY === a.startY || (i.startMoving = !0)), i.isScrolling) i.isTouched = !1;
								else if (i.startMoving) {
									this.allowClick = !1, r.preventDefault(), n.touchMoveStopPropagation && !n.nested && r.stopPropagation(), i.isMoved || (n.loop && this.loopFix(), i.startTranslate = this.getTranslate(), this.setTransition(0), this.animating && this.$wrapperEl.trigger("webkitTransitionEnd transitionend"), i.allowMomentumBounce = !1, !n.grabCursor || !0 !== this.allowSlideNext && !0 !== this.allowSlidePrev || this.setGrabCursor(!0), this.emit("sliderFirstMove", r)), this.emit("sliderMove", r), i.isMoved = !0;
									var f = this.isHorizontal() ? u : p;
									a.diff = f, f *= n.touchRatio, o && (f = -f), this.swipeDirection = f > 0 ? "prev" : "next", i.currentTranslate = f + i.startTranslate;
									var m = !0,
										g = n.resistanceRatio;
									if (n.touchReleaseOnEdges && (g = 0), f > 0 && i.currentTranslate > this.minTranslate() ? (m = !1, n.resistance && (i.currentTranslate = this.minTranslate() - 1 + Math.pow(-this.minTranslate() + i.startTranslate + f, g))) : f < 0 && i.currentTranslate < this.maxTranslate() && (m = !1, n.resistance && (i.currentTranslate = this.maxTranslate() + 1 - Math.pow(this.maxTranslate() - i.startTranslate - f, g))), m && (r.preventedByNestedSwiper = !0), !this.allowSlideNext && "next" === this.swipeDirection && i.currentTranslate < i.startTranslate && (i.currentTranslate = i.startTranslate), !this.allowSlidePrev && "prev" === this.swipeDirection && i.currentTranslate > i.startTranslate && (i.currentTranslate = i.startTranslate), n.threshold > 0) {
										if (!(Math.abs(f) > n.threshold || i.allowThresholdMove)) return void(i.currentTranslate = i.startTranslate);
										if (!i.allowThresholdMove) return i.allowThresholdMove = !0, a.startX = a.currentX, a.startY = a.currentY, i.currentTranslate = i.startTranslate, void(a.diff = this.isHorizontal() ? a.currentX - a.startX : a.currentY - a.startY)
									}
									n.followFinger && ((n.freeMode || n.watchSlidesProgress || n.watchSlidesVisibility) && (this.updateActiveIndex(), this.updateSlidesClasses()), n.freeMode && (0 === i.velocities.length && i.velocities.push({
										position: a[this.isHorizontal() ? "startX" : "startY"],
										time: i.touchStartTime
									}), i.velocities.push({
										position: a[this.isHorizontal() ? "currentX" : "currentY"],
										time: d.now()
									})), this.updateProgress(i.currentTranslate), this.setTranslate(i.currentTranslate))
								}
							}
						}
					} else i.startMoving && i.isScrolling && this.emit("touchMoveOpposite", r)
				}.bind(this), this.onTouchEnd = function(t) {
					var e = this,
						i = e.touchEventsData,
						s = e.params,
						n = e.touches,
						a = e.rtlTranslate,
						o = e.$wrapperEl,
						r = e.slidesGrid,
						l = e.snapGrid,
						c = t;
					if (c.originalEvent && (c = c.originalEvent), i.allowTouchCallbacks && e.emit("touchEnd", c), i.allowTouchCallbacks = !1, !i.isTouched) return i.isMoved && s.grabCursor && e.setGrabCursor(!1), i.isMoved = !1, void(i.startMoving = !1);
					s.grabCursor && i.isMoved && i.isTouched && (!0 === e.allowSlideNext || !0 === e.allowSlidePrev) && e.setGrabCursor(!1);
					var h, u = d.now(),
						p = u - i.touchStartTime;
					if (e.allowClick && (e.updateClickedSlide(c), e.emit("tap", c), p < 300 && u - i.lastClickTime > 300 && (i.clickTimeout && clearTimeout(i.clickTimeout), i.clickTimeout = d.nextTick(function() {
							e && !e.destroyed && e.emit("click", c)
						}, 300)), p < 300 && u - i.lastClickTime < 300 && (i.clickTimeout && clearTimeout(i.clickTimeout), e.emit("doubleTap", c))), i.lastClickTime = d.now(), d.nextTick(function() {
							e.destroyed || (e.allowClick = !0)
						}), !i.isTouched || !i.isMoved || !e.swipeDirection || 0 === n.diff || i.currentTranslate === i.startTranslate) return i.isTouched = !1, i.isMoved = !1, void(i.startMoving = !1);
					if (i.isTouched = !1, i.isMoved = !1, i.startMoving = !1, h = s.followFinger ? a ? e.translate : -e.translate : -i.currentTranslate, s.freeMode) {
						if (h < -e.minTranslate()) return void e.slideTo(e.activeIndex);
						if (h > -e.maxTranslate()) return void(e.slides.length < l.length ? e.slideTo(l.length - 1) : e.slideTo(e.slides.length - 1));
						if (s.freeModeMomentum) {
							if (i.velocities.length > 1) {
								var f = i.velocities.pop(),
									m = i.velocities.pop(),
									g = f.position - m.position,
									v = f.time - m.time;
								e.velocity = g / v, e.velocity /= 2, Math.abs(e.velocity) < s.freeModeMinimumVelocity && (e.velocity = 0), (v > 150 || d.now() - f.time > 300) && (e.velocity = 0)
							} else e.velocity = 0;
							e.velocity *= s.freeModeMomentumVelocityRatio, i.velocities.length = 0;
							var y = 1e3 * s.freeModeMomentumRatio,
								b = e.velocity * y,
								w = e.translate + b;
							a && (w = -w);
							var S, x = !1,
								T = 20 * Math.abs(e.velocity) * s.freeModeMomentumBounceRatio;
							if (w < e.maxTranslate()) s.freeModeMomentumBounce ? (w + e.maxTranslate() < -T && (w = e.maxTranslate() - T), S = e.maxTranslate(), x = !0, i.allowMomentumBounce = !0) : w = e.maxTranslate();
							else if (w > e.minTranslate()) s.freeModeMomentumBounce ? (w - e.minTranslate() > T && (w = e.minTranslate() + T), S = e.minTranslate(), x = !0, i.allowMomentumBounce = !0) : w = e.minTranslate();
							else if (s.freeModeSticky) {
								for (var C, _ = 0; _ < l.length; _ += 1)
									if (l[_] > -w) {
										C = _;
										break
									} w = -(w = Math.abs(l[C] - w) < Math.abs(l[C - 1] - w) || "next" === e.swipeDirection ? l[C] : l[C - 1])
							}
							if (0 !== e.velocity) y = a ? Math.abs((-w - e.translate) / e.velocity) : Math.abs((w - e.translate) / e.velocity);
							else if (s.freeModeSticky) return void e.slideToClosest();
							s.freeModeMomentumBounce && x ? (e.updateProgress(S), e.setTransition(y), e.setTranslate(w), e.transitionStart(!0, e.swipeDirection), e.animating = !0, o.transitionEnd(function() {
								e && !e.destroyed && i.allowMomentumBounce && (e.emit("momentumBounce"), e.setTransition(s.speed), e.setTranslate(S), o.transitionEnd(function() {
									e && !e.destroyed && e.transitionEnd()
								}))
							})) : e.velocity ? (e.updateProgress(w), e.setTransition(y), e.setTranslate(w), e.transitionStart(!0, e.swipeDirection), e.animating || (e.animating = !0, o.transitionEnd(function() {
								e && !e.destroyed && e.transitionEnd()
							}))) : e.updateProgress(w), e.updateActiveIndex(), e.updateSlidesClasses()
						} else if (s.freeModeSticky) return void e.slideToClosest();
						(!s.freeModeMomentum || p >= s.longSwipesMs) && (e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses())
					} else {
						for (var E = 0, P = e.slidesSizesGrid[0], k = 0; k < r.length; k += s.slidesPerGroup) void 0 !== r[k + s.slidesPerGroup] ? h >= r[k] && h < r[k + s.slidesPerGroup] && (E = k, P = r[k + s.slidesPerGroup] - r[k]) : h >= r[k] && (E = k, P = r[r.length - 1] - r[r.length - 2]);
						var $ = (h - r[E]) / P;
						if (p > s.longSwipesMs) {
							if (!s.longSwipes) return void e.slideTo(e.activeIndex);
							"next" === e.swipeDirection && ($ >= s.longSwipesRatio ? e.slideTo(E + s.slidesPerGroup) : e.slideTo(E)), "prev" === e.swipeDirection && ($ > 1 - s.longSwipesRatio ? e.slideTo(E + s.slidesPerGroup) : e.slideTo(E))
						} else {
							if (!s.shortSwipes) return void e.slideTo(e.activeIndex);
							"next" === e.swipeDirection && e.slideTo(E + s.slidesPerGroup), "prev" === e.swipeDirection && e.slideTo(E)
						}
					}
				}.bind(this), this.onClick = function(t) {
					this.allowClick || (this.params.preventClicks && t.preventDefault(), this.params.preventClicksPropagation && this.animating && (t.stopPropagation(), t.stopImmediatePropagation()))
				}.bind(this);
				var r = "container" === i.touchEventsTarget ? a : o,
					l = !!i.nested;
				if (c.touch || !c.pointerEvents && !c.prefixedPointerEvents) {
					if (c.touch) {
						var h = !("touchstart" !== n.start || !c.passiveListener || !i.passiveListeners) && {
							passive: !0,
							capture: !1
						};
						r.addEventListener(n.start, this.onTouchStart, h), r.addEventListener(n.move, this.onTouchMove, c.passiveListener ? {
							passive: !1,
							capture: l
						} : l), r.addEventListener(n.end, this.onTouchEnd, h)
					}(i.simulateTouch && !b.ios && !b.android || i.simulateTouch && !c.touch && b.ios) && (r.addEventListener("mousedown", this.onTouchStart, !1), t.addEventListener("mousemove", this.onTouchMove, l), t.addEventListener("mouseup", this.onTouchEnd, !1))
				} else r.addEventListener(n.start, this.onTouchStart, !1), t.addEventListener(n.move, this.onTouchMove, l), t.addEventListener(n.end, this.onTouchEnd, !1);
				(i.preventClicks || i.preventClicksPropagation) && r.addEventListener("click", this.onClick, !0), this.on("resize observerUpdate", w, !0)
			},
			detachEvents: function() {
				var e = this.params,
					i = this.touchEvents,
					s = this.el,
					n = this.wrapperEl,
					a = "container" === e.touchEventsTarget ? s : n,
					o = !!e.nested;
				if (c.touch || !c.pointerEvents && !c.prefixedPointerEvents) {
					if (c.touch) {
						var r = !("onTouchStart" !== i.start || !c.passiveListener || !e.passiveListeners) && {
							passive: !0,
							capture: !1
						};
						a.removeEventListener(i.start, this.onTouchStart, r), a.removeEventListener(i.move, this.onTouchMove, o), a.removeEventListener(i.end, this.onTouchEnd, r)
					}(e.simulateTouch && !b.ios && !b.android || e.simulateTouch && !c.touch && b.ios) && (a.removeEventListener("mousedown", this.onTouchStart, !1), t.removeEventListener("mousemove", this.onTouchMove, o), t.removeEventListener("mouseup", this.onTouchEnd, !1))
				} else a.removeEventListener(i.start, this.onTouchStart, !1), t.removeEventListener(i.move, this.onTouchMove, o), t.removeEventListener(i.end, this.onTouchEnd, !1);
				(e.preventClicks || e.preventClicksPropagation) && a.removeEventListener("click", this.onClick, !0), this.off("resize observerUpdate", w)
			}
		},
		x = {
			setBreakpoint: function() {
				var t = this.activeIndex,
					e = this.loopedSlides;
				void 0 === e && (e = 0);
				var i = this.params,
					s = i.breakpoints;
				if (s && (!s || 0 !== Object.keys(s).length)) {
					var n = this.getBreakpoint(s);
					if (n && this.currentBreakpoint !== n) {
						var a = n in s ? s[n] : this.originalParams,
							o = i.loop && a.slidesPerView !== i.slidesPerView;
						d.extend(this.params, a), d.extend(this, {
							allowTouchMove: this.params.allowTouchMove,
							allowSlideNext: this.params.allowSlideNext,
							allowSlidePrev: this.params.allowSlidePrev
						}), this.currentBreakpoint = n, o && (this.loopDestroy(), this.loopCreate(), this.updateSlides(), this.slideTo(t - e + this.loopedSlides, 0, !1)), this.emit("breakpoint", a)
					}
				}
			},
			getBreakpoint: function(t) {
				if (t) {
					var i = !1,
						s = [];
					Object.keys(t).forEach(function(t) {
						s.push(t)
					}), s.sort(function(t, e) {
						return parseInt(t, 10) - parseInt(e, 10)
					});
					for (var n = 0; n < s.length; n += 1) {
						var a = s[n];
						a >= e.innerWidth && !i && (i = a)
					}
					return i || "max"
				}
			}
		},
		T = function() {
			return {
				isIE: !!e.navigator.userAgent.match(/Trident/g) || !!e.navigator.userAgent.match(/MSIE/g),
				isSafari: (t = e.navigator.userAgent.toLowerCase(), t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0),
				isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)
			};
			var t
		}(),
		C = {
			init: !0,
			direction: "horizontal",
			touchEventsTarget: "container",
			initialSlide: 0,
			speed: 300,
			preventIntercationOnTransition: !1,
			iOSEdgeSwipeDetection: !1,
			iOSEdgeSwipeThreshold: 20,
			freeMode: !1,
			freeModeMomentum: !0,
			freeModeMomentumRatio: 1,
			freeModeMomentumBounce: !0,
			freeModeMomentumBounceRatio: 1,
			freeModeMomentumVelocityRatio: 1,
			freeModeSticky: !1,
			freeModeMinimumVelocity: .02,
			autoHeight: !1,
			setWrapperSize: !1,
			virtualTranslate: !1,
			effect: "slide",
			breakpoints: void 0,
			spaceBetween: 0,
			slidesPerView: 1,
			slidesPerColumn: 1,
			slidesPerColumnFill: "column",
			slidesPerGroup: 1,
			centeredSlides: !1,
			slidesOffsetBefore: 0,
			slidesOffsetAfter: 0,
			normalizeSlideIndex: !0,
			watchOverflow: !1,
			roundLengths: !1,
			touchRatio: 1,
			touchAngle: 45,
			simulateTouch: !0,
			shortSwipes: !0,
			longSwipes: !0,
			longSwipesRatio: .5,
			longSwipesMs: 300,
			followFinger: !0,
			allowTouchMove: !0,
			threshold: 0,
			touchMoveStopPropagation: !0,
			touchReleaseOnEdges: !1,
			uniqueNavElements: !0,
			resistance: !0,
			resistanceRatio: .85,
			watchSlidesProgress: !1,
			watchSlidesVisibility: !1,
			grabCursor: !1,
			preventClicks: !0,
			preventClicksPropagation: !0,
			slideToClickedSlide: !1,
			preloadImages: !0,
			updateOnImagesReady: !0,
			loop: !1,
			loopAdditionalSlides: 0,
			loopedSlides: null,
			loopFillGroupWithBlank: !1,
			allowSlidePrev: !0,
			allowSlideNext: !0,
			swipeHandler: null,
			noSwiping: !0,
			noSwipingClass: "swiper-no-swiping",
			noSwipingSelector: null,
			passiveListeners: !0,
			containerModifierClass: "swiper-container-",
			slideClass: "swiper-slide",
			slideBlankClass: "swiper-slide-invisible-blank",
			slideActiveClass: "swiper-slide-active",
			slideDuplicateActiveClass: "swiper-slide-duplicate-active",
			slideVisibleClass: "swiper-slide-visible",
			slideDuplicateClass: "swiper-slide-duplicate",
			slideNextClass: "swiper-slide-next",
			slideDuplicateNextClass: "swiper-slide-duplicate-next",
			slidePrevClass: "swiper-slide-prev",
			slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
			wrapperClass: "swiper-wrapper",
			runCallbacksOnInit: !0
		},
		_ = {
			update: p,
			translate: f,
			transition: {
				setTransition: function(t, e) {
					this.$wrapperEl.transition(t), this.emit("setTransition", t, e)
				},
				transitionStart: function(t, e) {
					void 0 === t && (t = !0);
					var i = this.activeIndex,
						s = this.params,
						n = this.previousIndex;
					s.autoHeight && this.updateAutoHeight();
					var a = e;
					if (a || (a = i > n ? "next" : i < n ? "prev" : "reset"), this.emit("transitionStart"), t && i !== n) {
						if ("reset" === a) return void this.emit("slideResetTransitionStart");
						this.emit("slideChangeTransitionStart"), "next" === a ? this.emit("slideNextTransitionStart") : this.emit("slidePrevTransitionStart")
					}
				},
				transitionEnd: function(t, e) {
					void 0 === t && (t = !0);
					var i = this.activeIndex,
						s = this.previousIndex;
					this.animating = !1, this.setTransition(0);
					var n = e;
					if (n || (n = i > s ? "next" : i < s ? "prev" : "reset"), this.emit("transitionEnd"), t && i !== s) {
						if ("reset" === n) return void this.emit("slideResetTransitionEnd");
						this.emit("slideChangeTransitionEnd"), "next" === n ? this.emit("slideNextTransitionEnd") : this.emit("slidePrevTransitionEnd")
					}
				}
			},
			slide: m,
			loop: g,
			grabCursor: v,
			manipulation: y,
			events: S,
			breakpoints: x,
			checkOverflow: {
				checkOverflow: function() {
					var t = this.isLocked;
					this.isLocked = 1 === this.snapGrid.length, this.allowTouchMove = !this.isLocked, t && t !== this.isLocked && (this.isEnd = !1, this.navigation.update())
				}
			},
			classes: {
				addClasses: function() {
					var t = this.classNames,
						e = this.params,
						i = this.rtl,
						s = this.$el,
						n = [];
					n.push(e.direction), e.freeMode && n.push("free-mode"), c.flexbox || n.push("no-flexbox"), e.autoHeight && n.push("autoheight"), i && n.push("rtl"), e.slidesPerColumn > 1 && n.push("multirow"), b.android && n.push("android"), b.ios && n.push("ios"), T.isIE && (c.pointerEvents || c.prefixedPointerEvents) && n.push("wp8-" + e.direction), n.forEach(function(i) {
						t.push(e.containerModifierClass + i)
					}), s.addClass(t.join(" "))
				},
				removeClasses: function() {
					var t = this.$el,
						e = this.classNames;
					t.removeClass(e.join(" "))
				}
			},
			images: {
				loadImage: function(t, i, s, n, a, o) {
					var r;

					function l() {
						o && o()
					}
					t.complete && a ? l() : i ? ((r = new e.Image).onload = l, r.onerror = l, n && (r.sizes = n), s && (r.srcset = s), i && (r.src = i)) : l()
				},
				preloadImages: function() {
					var t = this;

					function e() {
						null != t && t && !t.destroyed && (void 0 !== t.imagesLoaded && (t.imagesLoaded += 1), t.imagesLoaded === t.imagesToLoad.length && (t.params.updateOnImagesReady && t.update(), t.emit("imagesReady")))
					}
					t.imagesToLoad = t.$el.find("img");
					for (var i = 0; i < t.imagesToLoad.length; i += 1) {
						var s = t.imagesToLoad[i];
						t.loadImage(s, s.currentSrc || s.getAttribute("src"), s.srcset || s.getAttribute("srcset"), s.sizes || s.getAttribute("sizes"), !0, e)
					}
				}
			}
		},
		E = {},
		P = function(t) {
			function e() {
				for (var i, n, a, o = [], r = arguments.length; r--;) o[r] = arguments[r];
				1 === o.length && o[0].constructor && o[0].constructor === Object ? a = o[0] : (n = (i = o)[0], a = i[1]), a || (a = {}), a = d.extend({}, a), n && !a.el && (a.el = n), t.call(this, a), Object.keys(_).forEach(function(t) {
					Object.keys(_[t]).forEach(function(i) {
						e.prototype[i] || (e.prototype[i] = _[t][i])
					})
				});
				var l = this;
				void 0 === l.modules && (l.modules = {}), Object.keys(l.modules).forEach(function(t) {
					var e = l.modules[t];
					if (e.params) {
						var i = Object.keys(e.params)[0],
							s = e.params[i];
						if ("object" != typeof s) return;
						if (!(i in a && "enabled" in s)) return;
						!0 === a[i] && (a[i] = {
							enabled: !0
						}), "object" != typeof a[i] || "enabled" in a[i] || (a[i].enabled = !0), a[i] || (a[i] = {
							enabled: !1
						})
					}
				});
				var h = d.extend({}, C);
				l.useModulesParams(h), l.params = d.extend({}, h, E, a), l.originalParams = d.extend({}, l.params), l.passedParams = d.extend({}, a), l.$ = s;
				var u = s(l.params.el);
				if (n = u[0]) {
					if (u.length > 1) {
						var p = [];
						return u.each(function(t, i) {
							var s = d.extend({}, a, {
								el: i
							});
							p.push(new e(s))
						}), p
					}
					n.swiper = l, u.data("swiper", l);
					var f, m, g = u.children("." + l.params.wrapperClass);
					return d.extend(l, {
						$el: u,
						el: n,
						$wrapperEl: g,
						wrapperEl: g[0],
						classNames: [],
						slides: s(),
						slidesGrid: [],
						snapGrid: [],
						slidesSizesGrid: [],
						isHorizontal: function() {
							return "horizontal" === l.params.direction
						},
						isVertical: function() {
							return "vertical" === l.params.direction
						},
						rtl: "rtl" === n.dir.toLowerCase() || "rtl" === u.css("direction"),
						rtlTranslate: "horizontal" === l.params.direction && ("rtl" === n.dir.toLowerCase() || "rtl" === u.css("direction")),
						wrongRTL: "-webkit-box" === g.css("display"),
						activeIndex: 0,
						realIndex: 0,
						isBeginning: !0,
						isEnd: !1,
						translate: 0,
						progress: 0,
						velocity: 0,
						animating: !1,
						allowSlideNext: l.params.allowSlideNext,
						allowSlidePrev: l.params.allowSlidePrev,
						touchEvents: (f = ["touchstart", "touchmove", "touchend"], m = ["mousedown", "mousemove", "mouseup"], c.pointerEvents ? m = ["pointerdown", "pointermove", "pointerup"] : c.prefixedPointerEvents && (m = ["MSPointerDown", "MSPointerMove", "MSPointerUp"]), l.touchEventsTouch = {
							start: f[0],
							move: f[1],
							end: f[2]
						}, l.touchEventsDesktop = {
							start: m[0],
							move: m[1],
							end: m[2]
						}, c.touch || !l.params.simulateTouch ? l.touchEventsTouch : l.touchEventsDesktop),
						touchEventsData: {
							isTouched: void 0,
							isMoved: void 0,
							allowTouchCallbacks: void 0,
							touchStartTime: void 0,
							isScrolling: void 0,
							currentTranslate: void 0,
							startTranslate: void 0,
							allowThresholdMove: void 0,
							formElements: "input, select, option, textarea, button, video",
							lastClickTime: d.now(),
							clickTimeout: void 0,
							velocities: [],
							allowMomentumBounce: void 0,
							isTouchEvent: void 0,
							startMoving: void 0
						},
						allowClick: !0,
						allowTouchMove: l.params.allowTouchMove,
						touches: {
							startX: 0,
							startY: 0,
							currentX: 0,
							currentY: 0,
							diff: 0
						},
						imagesToLoad: [],
						imagesLoaded: 0
					}), l.useModules(), l.params.init && l.init(), l
				}
			}
			t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
			var i = {
				extendedDefaults: {
					configurable: !0
				},
				defaults: {
					configurable: !0
				},
				Class: {
					configurable: !0
				},
				$: {
					configurable: !0
				}
			};
			return e.prototype.slidesPerViewDynamic = function() {
				var t = this.params,
					e = this.slides,
					i = this.slidesGrid,
					s = this.size,
					n = this.activeIndex,
					a = 1;
				if (t.centeredSlides) {
					for (var o, r = e[n].swiperSlideSize, l = n + 1; l < e.length; l += 1) e[l] && !o && (a += 1, (r += e[l].swiperSlideSize) > s && (o = !0));
					for (var d = n - 1; d >= 0; d -= 1) e[d] && !o && (a += 1, (r += e[d].swiperSlideSize) > s && (o = !0))
				} else
					for (var c = n + 1; c < e.length; c += 1) i[c] - i[n] < s && (a += 1);
				return a
			}, e.prototype.update = function() {
				var t = this;

				function e() {
					var e = t.rtlTranslate ? -1 * t.translate : t.translate,
						i = Math.min(Math.max(e, t.maxTranslate()), t.minTranslate());
					t.setTranslate(i), t.updateActiveIndex(), t.updateSlidesClasses()
				}
				t && !t.destroyed && (t.updateSize(), t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), t.params.freeMode ? (e(), t.params.autoHeight && t.updateAutoHeight()) : (("auto" === t.params.slidesPerView || t.params.slidesPerView > 1) && t.isEnd && !t.params.centeredSlides ? t.slideTo(t.slides.length - 1, 0, !1, !0) : t.slideTo(t.activeIndex, 0, !1, !0)) || e(), t.emit("update"))
			}, e.prototype.init = function() {
				this.initialized || (this.emit("beforeInit"), this.params.breakpoints && this.setBreakpoint(), this.addClasses(), this.params.loop && this.loopCreate(), this.updateSize(), this.updateSlides(), this.params.watchOverflow && this.checkOverflow(), this.params.grabCursor && this.setGrabCursor(), this.params.preloadImages && this.preloadImages(), this.params.loop ? this.slideTo(this.params.initialSlide + this.loopedSlides, 0, this.params.runCallbacksOnInit) : this.slideTo(this.params.initialSlide, 0, this.params.runCallbacksOnInit), this.attachEvents(), this.initialized = !0, this.emit("init"))
			}, e.prototype.destroy = function(t, e) {
				void 0 === t && (t = !0), void 0 === e && (e = !0);
				var i = this,
					s = i.params,
					n = i.$el,
					a = i.$wrapperEl,
					o = i.slides;
				i.emit("beforeDestroy"), i.initialized = !1, i.detachEvents(), s.loop && i.loopDestroy(), e && (i.removeClasses(), n.removeAttr("style"), a.removeAttr("style"), o && o.length && o.removeClass([s.slideVisibleClass, s.slideActiveClass, s.slideNextClass, s.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index").removeAttr("data-swiper-column").removeAttr("data-swiper-row")), i.emit("destroy"), Object.keys(i.eventsListeners).forEach(function(t) {
					i.off(t)
				}), !1 !== t && (i.$el[0].swiper = null, i.$el.data("swiper", null), d.deleteProps(i)), i.destroyed = !0
			}, e.extendDefaults = function(t) {
				d.extend(E, t)
			}, i.extendedDefaults.get = function() {
				return E
			}, i.defaults.get = function() {
				return C
			}, i.Class.get = function() {
				return t
			}, i.$.get = function() {
				return s
			}, Object.defineProperties(e, i), e
		}(h),
		k = {
			name: "device",
			proto: {
				device: b
			},
			static: {
				device: b
			}
		},
		$ = {
			name: "support",
			proto: {
				support: c
			},
			static: {
				support: c
			}
		},
		M = {
			name: "browser",
			proto: {
				browser: T
			},
			static: {
				browser: T
			}
		},
		D = {
			name: "resize",
			create: function() {
				var t = this;
				d.extend(t, {
					resize: {
						resizeHandler: function() {
							t && !t.destroyed && t.initialized && (t.emit("beforeResize"), t.emit("resize"))
						},
						orientationChangeHandler: function() {
							t && !t.destroyed && t.initialized && t.emit("orientationchange")
						}
					}
				})
			},
			on: {
				init: function() {
					e.addEventListener("resize", this.resize.resizeHandler), e.addEventListener("orientationchange", this.resize.orientationChangeHandler)
				},
				destroy: function() {
					e.removeEventListener("resize", this.resize.resizeHandler), e.removeEventListener("orientationchange", this.resize.orientationChangeHandler)
				}
			}
		},
		O = {
			func: e.MutationObserver || e.WebkitMutationObserver,
			attach: function(t, e) {
				void 0 === e && (e = {});
				var i = this,
					s = new(0, O.func)(function(t) {
						t.forEach(function(t) {
							i.emit("observerUpdate", t)
						})
					});
				s.observe(t, {
					attributes: void 0 === e.attributes || e.attributes,
					childList: void 0 === e.childList || e.childList,
					characterData: void 0 === e.characterData || e.characterData
				}), i.observer.observers.push(s)
			},
			init: function() {
				if (c.observer && this.params.observer) {
					if (this.params.observeParents)
						for (var t = this.$el.parents(), e = 0; e < t.length; e += 1) this.observer.attach(t[e]);
					this.observer.attach(this.$el[0], {
						childList: !1
					}), this.observer.attach(this.$wrapperEl[0], {
						attributes: !1
					})
				}
			},
			destroy: function() {
				this.observer.observers.forEach(function(t) {
					t.disconnect()
				}), this.observer.observers = []
			}
		},
		z = {
			name: "observer",
			params: {
				observer: !1,
				observeParents: !1
			},
			create: function() {
				d.extend(this, {
					observer: {
						init: O.init.bind(this),
						attach: O.attach.bind(this),
						destroy: O.destroy.bind(this),
						observers: []
					}
				})
			},
			on: {
				init: function() {
					this.observer.init()
				},
				destroy: function() {
					this.observer.destroy()
				}
			}
		},
		A = {
			update: function(t) {
				var e = this,
					i = e.params,
					s = i.slidesPerView,
					n = i.slidesPerGroup,
					a = i.centeredSlides,
					o = e.virtual,
					r = o.from,
					l = o.to,
					c = o.slides,
					h = o.slidesGrid,
					u = o.renderSlide,
					p = o.offset;
				e.updateActiveIndex();
				var f, m, g, v = e.activeIndex || 0;
				f = e.rtlTranslate ? "right" : e.isHorizontal() ? "left" : "top", a ? (m = Math.floor(s / 2) + n, g = Math.floor(s / 2) + n) : (m = s + (n - 1), g = n);
				var y = Math.max((v || 0) - g, 0),
					b = Math.min((v || 0) + m, c.length - 1),
					w = (e.slidesGrid[y] || 0) - (e.slidesGrid[0] || 0);

				function S() {
					e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.lazy && e.params.lazy.enabled && e.lazy.load()
				}
				if (d.extend(e.virtual, {
						from: y,
						to: b,
						offset: w,
						slidesGrid: e.slidesGrid
					}), r === y && l === b && !t) return e.slidesGrid !== h && w !== p && e.slides.css(f, w + "px"), void e.updateProgress();
				if (e.params.virtual.renderExternal) return e.params.virtual.renderExternal.call(e, {
					offset: w,
					from: y,
					to: b,
					slides: function() {
						for (var t = [], e = y; e <= b; e += 1) t.push(c[e]);
						return t
					}()
				}), void S();
				var x = [],
					T = [];
				if (t) e.$wrapperEl.find("." + e.params.slideClass).remove();
				else
					for (var C = r; C <= l; C += 1)(C < y || C > b) && e.$wrapperEl.find("." + e.params.slideClass + '[data-swiper-slide-index="' + C + '"]').remove();
				for (var _ = 0; _ < c.length; _ += 1) _ >= y && _ <= b && (void 0 === l || t ? T.push(_) : (_ > l && T.push(_), _ < r && x.push(_)));
				T.forEach(function(t) {
					e.$wrapperEl.append(u(c[t], t))
				}), x.sort(function(t, e) {
					return t < e
				}).forEach(function(t) {
					e.$wrapperEl.prepend(u(c[t], t))
				}), e.$wrapperEl.children(".swiper-slide").css(f, w + "px"), S()
			},
			renderSlide: function(t, e) {
				var i = this.params.virtual;
				if (i.cache && this.virtual.cache[e]) return this.virtual.cache[e];
				var n = i.renderSlide ? s(i.renderSlide.call(this, t, e)) : s('<div class="' + this.params.slideClass + '" data-swiper-slide-index="' + e + '">' + t + "</div>");
				return n.attr("data-swiper-slide-index") || n.attr("data-swiper-slide-index", e), i.cache && (this.virtual.cache[e] = n), n
			},
			appendSlide: function(t) {
				this.virtual.slides.push(t), this.virtual.update(!0)
			},
			prependSlide: function(t) {
				if (this.virtual.slides.unshift(t), this.params.virtual.cache) {
					var e = this.virtual.cache,
						i = {};
					Object.keys(e).forEach(function(t) {
						i[t + 1] = e[t]
					}), this.virtual.cache = i
				}
				this.virtual.update(!0), this.slideNext(0)
			}
		},
		I = {
			name: "virtual",
			params: {
				virtual: {
					enabled: !1,
					slides: [],
					cache: !0,
					renderSlide: null,
					renderExternal: null
				}
			},
			create: function() {
				d.extend(this, {
					virtual: {
						update: A.update.bind(this),
						appendSlide: A.appendSlide.bind(this),
						prependSlide: A.prependSlide.bind(this),
						renderSlide: A.renderSlide.bind(this),
						slides: this.params.virtual.slides,
						cache: {}
					}
				})
			},
			on: {
				beforeInit: function() {
					if (this.params.virtual.enabled) {
						this.classNames.push(this.params.containerModifierClass + "virtual");
						var t = {
							watchSlidesProgress: !0
						};
						d.extend(this.params, t), d.extend(this.originalParams, t), this.virtual.update()
					}
				},
				setTranslate: function() {
					this.params.virtual.enabled && this.virtual.update()
				}
			}
		},
		L = {
			handle: function(i) {
				var s = this.rtlTranslate,
					n = i;
				n.originalEvent && (n = n.originalEvent);
				var a = n.keyCode || n.charCode;
				if (!this.allowSlideNext && (this.isHorizontal() && 39 === a || this.isVertical() && 40 === a)) return !1;
				if (!this.allowSlidePrev && (this.isHorizontal() && 37 === a || this.isVertical() && 38 === a)) return !1;
				if (!(n.shiftKey || n.altKey || n.ctrlKey || n.metaKey || t.activeElement && t.activeElement.nodeName && ("input" === t.activeElement.nodeName.toLowerCase() || "textarea" === t.activeElement.nodeName.toLowerCase()))) {
					if (this.params.keyboard.onlyInViewport && (37 === a || 39 === a || 38 === a || 40 === a)) {
						var o = !1;
						if (this.$el.parents("." + this.params.slideClass).length > 0 && 0 === this.$el.parents("." + this.params.slideActiveClass).length) return;
						var r = e.innerWidth,
							l = e.innerHeight,
							d = this.$el.offset();
						s && (d.left -= this.$el[0].scrollLeft);
						for (var c = [
								[d.left, d.top],
								[d.left + this.width, d.top],
								[d.left, d.top + this.height],
								[d.left + this.width, d.top + this.height]
							], h = 0; h < c.length; h += 1) {
							var u = c[h];
							u[0] >= 0 && u[0] <= r && u[1] >= 0 && u[1] <= l && (o = !0)
						}
						if (!o) return
					}
					this.isHorizontal() ? (37 !== a && 39 !== a || (n.preventDefault ? n.preventDefault() : n.returnValue = !1), (39 === a && !s || 37 === a && s) && this.slideNext(), (37 === a && !s || 39 === a && s) && this.slidePrev()) : (38 !== a && 40 !== a || (n.preventDefault ? n.preventDefault() : n.returnValue = !1), 40 === a && this.slideNext(), 38 === a && this.slidePrev()), this.emit("keyPress", a)
				}
			},
			enable: function() {
				this.keyboard.enabled || (s(t).on("keydown", this.keyboard.handle), this.keyboard.enabled = !0)
			},
			disable: function() {
				this.keyboard.enabled && (s(t).off("keydown", this.keyboard.handle), this.keyboard.enabled = !1)
			}
		},
		N = {
			name: "keyboard",
			params: {
				keyboard: {
					enabled: !1,
					onlyInViewport: !0
				}
			},
			create: function() {
				d.extend(this, {
					keyboard: {
						enabled: !1,
						enable: L.enable.bind(this),
						disable: L.disable.bind(this),
						handle: L.handle.bind(this)
					}
				})
			},
			on: {
				init: function() {
					this.params.keyboard.enabled && this.keyboard.enable()
				},
				destroy: function() {
					this.keyboard.enabled && this.keyboard.disable()
				}
			}
		},
		Y = {
			lastScrollTime: d.now(),
			event: e.navigator.userAgent.indexOf("firefox") > -1 ? "DOMMouseScroll" : function() {
				var e = "onwheel" in t;
				if (!e) {
					var i = t.createElement("div");
					i.setAttribute("onwheel", "return;"), e = "function" == typeof i.onwheel
				}
				return !e && t.implementation && t.implementation.hasFeature && !0 !== t.implementation.hasFeature("", "") && (e = t.implementation.hasFeature("Events.wheel", "3.0")), e
			}() ? "wheel" : "mousewheel",
			normalize: function(t) {
				var e = 0,
					i = 0,
					s = 0,
					n = 0;
				return "detail" in t && (i = t.detail), "wheelDelta" in t && (i = -t.wheelDelta / 120), "wheelDeltaY" in t && (i = -t.wheelDeltaY / 120), "wheelDeltaX" in t && (e = -t.wheelDeltaX / 120), "axis" in t && t.axis === t.HORIZONTAL_AXIS && (e = i, i = 0), s = 10 * e, n = 10 * i, "deltaY" in t && (n = t.deltaY), "deltaX" in t && (s = t.deltaX), (s || n) && t.deltaMode && (1 === t.deltaMode ? (s *= 40, n *= 40) : (s *= 800, n *= 800)), s && !e && (e = s < 1 ? -1 : 1), n && !i && (i = n < 1 ? -1 : 1), {
					spinX: e,
					spinY: i,
					pixelX: s,
					pixelY: n
				}
			},
			handleMouseEnter: function() {
				this.mouseEntered = !0
			},
			handleMouseLeave: function() {
				this.mouseEntered = !1
			},
			handle: function(t) {
				var i = t,
					s = this,
					n = s.params.mousewheel;
				if (!s.mouseEntered && !n.releaseOnEdges) return !0;
				i.originalEvent && (i = i.originalEvent);
				var a = 0,
					o = s.rtlTranslate ? -1 : 1,
					r = Y.normalize(i);
				if (n.forceToAxis)
					if (s.isHorizontal()) {
						if (!(Math.abs(r.pixelX) > Math.abs(r.pixelY))) return !0;
						a = r.pixelX * o
					} else {
						if (!(Math.abs(r.pixelY) > Math.abs(r.pixelX))) return !0;
						a = r.pixelY
					}
				else a = Math.abs(r.pixelX) > Math.abs(r.pixelY) ? -r.pixelX * o : -r.pixelY;
				if (0 === a) return !0;
				if (n.invert && (a = -a), s.params.freeMode) {
					var l = s.getTranslate() + a * n.sensitivity,
						c = s.isBeginning,
						h = s.isEnd;
					if (l >= s.minTranslate() && (l = s.minTranslate()), l <= s.maxTranslate() && (l = s.maxTranslate()), s.setTransition(0), s.setTranslate(l), s.updateProgress(), s.updateActiveIndex(), s.updateSlidesClasses(), (!c && s.isBeginning || !h && s.isEnd) && s.updateSlidesClasses(), s.params.freeModeSticky && (clearTimeout(s.mousewheel.timeout), s.mousewheel.timeout = d.nextTick(function() {
							s.slideToClosest()
						}, 300)), s.emit("scroll", i), s.params.autoplay && s.params.autoplayDisableOnInteraction && s.stopAutoplay(), l === s.minTranslate() || l === s.maxTranslate()) return !0
				} else {
					if (d.now() - s.mousewheel.lastScrollTime > 60)
						if (a < 0)
							if (s.isEnd && !s.params.loop || s.animating) {
								if (n.releaseOnEdges) return !0
							} else s.slideNext(), s.emit("scroll", i);
					else if (s.isBeginning && !s.params.loop || s.animating) {
						if (n.releaseOnEdges) return !0
					} else s.slidePrev(), s.emit("scroll", i);
					s.mousewheel.lastScrollTime = (new e.Date).getTime()
				}
				return i.preventDefault ? i.preventDefault() : i.returnValue = !1, !1
			},
			enable: function() {
				if (!Y.event) return !1;
				if (this.mousewheel.enabled) return !1;
				var t = this.$el;
				return "container" !== this.params.mousewheel.eventsTarged && (t = s(this.params.mousewheel.eventsTarged)), t.on("mouseenter", this.mousewheel.handleMouseEnter), t.on("mouseleave", this.mousewheel.handleMouseLeave), t.on(Y.event, this.mousewheel.handle), this.mousewheel.enabled = !0, !0
			},
			disable: function() {
				if (!Y.event) return !1;
				if (!this.mousewheel.enabled) return !1;
				var t = this.$el;
				return "container" !== this.params.mousewheel.eventsTarged && (t = s(this.params.mousewheel.eventsTarged)), t.off(Y.event, this.mousewheel.handle), this.mousewheel.enabled = !1, !0
			}
		},
		R = {
			update: function() {
				var t = this.params.navigation;
				if (!this.params.loop) {
					var e = this.navigation,
						i = e.$nextEl,
						s = e.$prevEl;
					s && s.length > 0 && (this.isBeginning ? s.addClass(t.disabledClass) : s.removeClass(t.disabledClass), s[this.params.watchOverflow && this.isLocked ? "addClass" : "removeClass"](t.lockClass)), i && i.length > 0 && (this.isEnd ? i.addClass(t.disabledClass) : i.removeClass(t.disabledClass), i[this.params.watchOverflow && this.isLocked ? "addClass" : "removeClass"](t.lockClass))
				}
			},
			init: function() {
				var t, e, i = this,
					n = i.params.navigation;
				(n.nextEl || n.prevEl) && (n.nextEl && (t = s(n.nextEl), i.params.uniqueNavElements && "string" == typeof n.nextEl && t.length > 1 && 1 === i.$el.find(n.nextEl).length && (t = i.$el.find(n.nextEl))), n.prevEl && (e = s(n.prevEl), i.params.uniqueNavElements && "string" == typeof n.prevEl && e.length > 1 && 1 === i.$el.find(n.prevEl).length && (e = i.$el.find(n.prevEl))), t && t.length > 0 && t.on("click", function(t) {
					t.preventDefault(), i.isEnd && !i.params.loop || i.slideNext()
				}), e && e.length > 0 && e.on("click", function(t) {
					t.preventDefault(), i.isBeginning && !i.params.loop || i.slidePrev()
				}), d.extend(i.navigation, {
					$nextEl: t,
					nextEl: t && t[0],
					$prevEl: e,
					prevEl: e && e[0]
				}))
			},
			destroy: function() {
				var t = this.navigation,
					e = t.$nextEl,
					i = t.$prevEl;
				e && e.length && (e.off("click"), e.removeClass(this.params.navigation.disabledClass)), i && i.length && (i.off("click"), i.removeClass(this.params.navigation.disabledClass))
			}
		},
		j = {
			update: function() {
				var t = this.rtl,
					e = this.params.pagination;
				if (e.el && this.pagination.el && this.pagination.$el && 0 !== this.pagination.$el.length) {
					var i, n = this.virtual && this.params.virtual.enabled ? this.virtual.slides.length : this.slides.length,
						a = this.pagination.$el,
						o = this.params.loop ? Math.ceil((n - 2 * this.loopedSlides) / this.params.slidesPerGroup) : this.snapGrid.length;
					if (this.params.loop ? ((i = Math.ceil((this.activeIndex - this.loopedSlides) / this.params.slidesPerGroup)) > n - 1 - 2 * this.loopedSlides && (i -= n - 2 * this.loopedSlides), i > o - 1 && (i -= o), i < 0 && "bullets" !== this.params.paginationType && (i = o + i)) : i = void 0 !== this.snapIndex ? this.snapIndex : this.activeIndex || 0, "bullets" === e.type && this.pagination.bullets && this.pagination.bullets.length > 0) {
						var r, l, d, c = this.pagination.bullets;
						if (e.dynamicBullets && (this.pagination.bulletSize = c.eq(0)[this.isHorizontal() ? "outerWidth" : "outerHeight"](!0), a.css(this.isHorizontal() ? "width" : "height", this.pagination.bulletSize * (e.dynamicMainBullets + 4) + "px"), e.dynamicMainBullets > 1 && void 0 !== this.previousIndex && (this.pagination.dynamicBulletIndex += i - this.previousIndex, this.pagination.dynamicBulletIndex > e.dynamicMainBullets - 1 ? this.pagination.dynamicBulletIndex = e.dynamicMainBullets - 1 : this.pagination.dynamicBulletIndex < 0 && (this.pagination.dynamicBulletIndex = 0)), r = i - this.pagination.dynamicBulletIndex, d = ((l = r + (Math.min(c.length, e.dynamicMainBullets) - 1)) + r) / 2), c.removeClass(e.bulletActiveClass + " " + e.bulletActiveClass + "-next " + e.bulletActiveClass + "-next-next " + e.bulletActiveClass + "-prev " + e.bulletActiveClass + "-prev-prev " + e.bulletActiveClass + "-main"), a.length > 1) c.each(function(t, n) {
							var a = s(n),
								o = a.index();
							o === i && a.addClass(e.bulletActiveClass), e.dynamicBullets && (o >= r && o <= l && a.addClass(e.bulletActiveClass + "-main"), o === r && a.prev().addClass(e.bulletActiveClass + "-prev").prev().addClass(e.bulletActiveClass + "-prev-prev"), o === l && a.next().addClass(e.bulletActiveClass + "-next").next().addClass(e.bulletActiveClass + "-next-next"))
						});
						else if (c.eq(i).addClass(e.bulletActiveClass), e.dynamicBullets) {
							for (var h = c.eq(r), u = c.eq(l), p = r; p <= l; p += 1) c.eq(p).addClass(e.bulletActiveClass + "-main");
							h.prev().addClass(e.bulletActiveClass + "-prev").prev().addClass(e.bulletActiveClass + "-prev-prev"), u.next().addClass(e.bulletActiveClass + "-next").next().addClass(e.bulletActiveClass + "-next-next")
						}
						if (e.dynamicBullets) {
							var f = Math.min(c.length, e.dynamicMainBullets + 4),
								m = (this.pagination.bulletSize * f - this.pagination.bulletSize) / 2 - d * this.pagination.bulletSize,
								g = t ? "right" : "left";
							c.css(this.isHorizontal() ? g : "top", m + "px")
						}
					}
					if ("fraction" === e.type && (a.find("." + e.currentClass).text(i + 1), a.find("." + e.totalClass).text(o)), "progressbar" === e.type) {
						var v = (i + 1) / o,
							y = v,
							b = 1;
						this.isHorizontal() || (b = v, y = 1), a.find("." + e.progressbarFillClass).transform("translate3d(0,0,0) scaleX(" + y + ") scaleY(" + b + ")").transition(this.params.speed)
					}
					"custom" === e.type && e.renderCustom ? (a.html(e.renderCustom(this, i + 1, o)), this.emit("paginationRender", this, a[0])) : this.emit("paginationUpdate", this, a[0]), a[this.params.watchOverflow && this.isLocked ? "addClass" : "removeClass"](e.lockClass)
				}
			},
			render: function() {
				var t = this.params.pagination;
				if (t.el && this.pagination.el && this.pagination.$el && 0 !== this.pagination.$el.length) {
					var e = this.virtual && this.params.virtual.enabled ? this.virtual.slides.length : this.slides.length,
						i = this.pagination.$el,
						s = "";
					if ("bullets" === t.type) {
						for (var n = this.params.loop ? Math.ceil((e - 2 * this.loopedSlides) / this.params.slidesPerGroup) : this.snapGrid.length, a = 0; a < n; a += 1) t.renderBullet ? s += t.renderBullet.call(this, a, t.bulletClass) : s += "<" + t.bulletElement + ' class="' + t.bulletClass + '"></' + t.bulletElement + ">";
						i.html(s), this.pagination.bullets = i.find("." + t.bulletClass)
					}
					"fraction" === t.type && (s = t.renderFraction ? t.renderFraction.call(this, t.currentClass, t.totalClass) : '<span class="' + t.currentClass + '"></span> / <span class="' + t.totalClass + '"></span>', i.html(s)), "progressbar" === t.type && (s = t.renderProgressbar ? t.renderProgressbar.call(this, t.progressbarFillClass) : '<span class="' + t.progressbarFillClass + '"></span>', i.html(s)), "custom" !== t.type && this.emit("paginationRender", this.pagination.$el[0])
				}
			},
			init: function() {
				var t = this,
					e = t.params.pagination;
				if (e.el) {
					var i = s(e.el);
					0 !== i.length && (t.params.uniqueNavElements && "string" == typeof e.el && i.length > 1 && 1 === t.$el.find(e.el).length && (i = t.$el.find(e.el)), "bullets" === e.type && e.clickable && i.addClass(e.clickableClass), i.addClass(e.modifierClass + e.type), "bullets" === e.type && e.dynamicBullets && (i.addClass("" + e.modifierClass + e.type + "-dynamic"), t.pagination.dynamicBulletIndex = 0, e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)), e.clickable && i.on("click", "." + e.bulletClass, function(e) {
						e.preventDefault();
						var i = s(this).index() * t.params.slidesPerGroup;
						t.params.loop && (i += t.loopedSlides), t.slideTo(i)
					}), d.extend(t.pagination, {
						$el: i,
						el: i[0]
					}))
				}
			},
			destroy: function() {
				var t = this.params.pagination;
				if (t.el && this.pagination.el && this.pagination.$el && 0 !== this.pagination.$el.length) {
					var e = this.pagination.$el;
					e.removeClass(t.hiddenClass), e.removeClass(t.modifierClass + t.type), this.pagination.bullets && this.pagination.bullets.removeClass(t.bulletActiveClass), t.clickable && e.off("click", "." + t.bulletClass)
				}
			}
		},
		H = {
			setTranslate: function() {
				if (this.params.scrollbar.el && this.scrollbar.el) {
					var t = this.scrollbar,
						e = this.rtlTranslate,
						i = this.progress,
						s = t.dragSize,
						n = t.trackSize,
						a = t.$dragEl,
						o = t.$el,
						r = this.params.scrollbar,
						l = s,
						d = (n - s) * i;
					e ? (d = -d) > 0 ? (l = s - d, d = 0) : -d + s > n && (l = n + d) : d < 0 ? (l = s + d, d = 0) : d + s > n && (l = n - d), this.isHorizontal() ? (c.transforms3d ? a.transform("translate3d(" + d + "px, 0, 0)") : a.transform("translateX(" + d + "px)"), a[0].style.width = l + "px") : (c.transforms3d ? a.transform("translate3d(0px, " + d + "px, 0)") : a.transform("translateY(" + d + "px)"), a[0].style.height = l + "px"), r.hide && (clearTimeout(this.scrollbar.timeout), o[0].style.opacity = 1, this.scrollbar.timeout = setTimeout(function() {
						o[0].style.opacity = 0, o.transition(400)
					}, 1e3))
				}
			},
			setTransition: function(t) {
				this.params.scrollbar.el && this.scrollbar.el && this.scrollbar.$dragEl.transition(t)
			},
			updateSize: function() {
				if (this.params.scrollbar.el && this.scrollbar.el) {
					var t = this.scrollbar,
						e = t.$dragEl,
						i = t.$el;
					e[0].style.width = "", e[0].style.height = "";
					var s, n = this.isHorizontal() ? i[0].offsetWidth : i[0].offsetHeight,
						a = this.size / this.virtualSize,
						o = a * (n / this.size);
					s = "auto" === this.params.scrollbar.dragSize ? n * a : parseInt(this.params.scrollbar.dragSize, 10), this.isHorizontal() ? e[0].style.width = s + "px" : e[0].style.height = s + "px", i[0].style.display = a >= 1 ? "none" : "", this.params.scrollbarHide && (i[0].style.opacity = 0), d.extend(t, {
						trackSize: n,
						divider: a,
						moveDivider: o,
						dragSize: s
					}), t.$el[this.params.watchOverflow && this.isLocked ? "addClass" : "removeClass"](this.params.scrollbar.lockClass)
				}
			},
			setDragPosition: function(t) {
				var e, i = this.scrollbar,
					s = this.rtlTranslate,
					n = i.$el,
					a = i.dragSize,
					o = i.trackSize;
				e = ((this.isHorizontal() ? "touchstart" === t.type || "touchmove" === t.type ? t.targetTouches[0].pageX : t.pageX || t.clientX : "touchstart" === t.type || "touchmove" === t.type ? t.targetTouches[0].pageY : t.pageY || t.clientY) - n.offset()[this.isHorizontal() ? "left" : "top"] - a / 2) / (o - a), e = Math.max(Math.min(e, 1), 0), s && (e = 1 - e);
				var r = this.minTranslate() + (this.maxTranslate() - this.minTranslate()) * e;
				this.updateProgress(r), this.setTranslate(r), this.updateActiveIndex(), this.updateSlidesClasses()
			},
			onDragStart: function(t) {
				var e = this.params.scrollbar,
					i = this.scrollbar,
					s = this.$wrapperEl,
					n = i.$el,
					a = i.$dragEl;
				this.scrollbar.isTouched = !0, t.preventDefault(), t.stopPropagation(), s.transition(100), a.transition(100), i.setDragPosition(t), clearTimeout(this.scrollbar.dragTimeout), n.transition(0), e.hide && n.css("opacity", 1), this.emit("scrollbarDragStart", t)
			},
			onDragMove: function(t) {
				var e = this.scrollbar,
					i = this.$wrapperEl,
					s = e.$el,
					n = e.$dragEl;
				this.scrollbar.isTouched && (t.preventDefault ? t.preventDefault() : t.returnValue = !1, e.setDragPosition(t), i.transition(0), s.transition(0), n.transition(0), this.emit("scrollbarDragMove", t))
			},
			onDragEnd: function(t) {
				var e = this.params.scrollbar,
					i = this.scrollbar.$el;
				this.scrollbar.isTouched && (this.scrollbar.isTouched = !1, e.hide && (clearTimeout(this.scrollbar.dragTimeout), this.scrollbar.dragTimeout = d.nextTick(function() {
					i.css("opacity", 0), i.transition(400)
				}, 1e3)), this.emit("scrollbarDragEnd", t), e.snapOnRelease && this.slideToClosest())
			},
			enableDraggable: function() {
				if (this.params.scrollbar.el) {
					var e = this.scrollbar,
						i = this.touchEvents,
						s = this.touchEventsDesktop,
						n = this.params,
						a = e.$el[0],
						o = !(!c.passiveListener || !n.passiveListener) && {
							passive: !1,
							capture: !1
						},
						r = !(!c.passiveListener || !n.passiveListener) && {
							passive: !0,
							capture: !1
						};
					c.touch || !c.pointerEvents && !c.prefixedPointerEvents ? (c.touch && (a.addEventListener(i.start, this.scrollbar.onDragStart, o), a.addEventListener(i.move, this.scrollbar.onDragMove, o), a.addEventListener(i.end, this.scrollbar.onDragEnd, r)), (n.simulateTouch && !b.ios && !b.android || n.simulateTouch && !c.touch && b.ios) && (a.addEventListener("mousedown", this.scrollbar.onDragStart, o), t.addEventListener("mousemove", this.scrollbar.onDragMove, o), t.addEventListener("mouseup", this.scrollbar.onDragEnd, r))) : (a.addEventListener(s.start, this.scrollbar.onDragStart, o), t.addEventListener(s.move, this.scrollbar.onDragMove, o), t.addEventListener(s.end, this.scrollbar.onDragEnd, r))
				}
			},
			disableDraggable: function() {
				if (this.params.scrollbar.el) {
					var e = this.scrollbar,
						i = this.touchEvents,
						s = this.touchEventsDesktop,
						n = this.params,
						a = e.$el[0],
						o = !(!c.passiveListener || !n.passiveListener) && {
							passive: !1,
							capture: !1
						},
						r = !(!c.passiveListener || !n.passiveListener) && {
							passive: !0,
							capture: !1
						};
					c.touch || !c.pointerEvents && !c.prefixedPointerEvents ? (c.touch && (a.removeEventListener(i.start, this.scrollbar.onDragStart, o), a.removeEventListener(i.move, this.scrollbar.onDragMove, o), a.removeEventListener(i.end, this.scrollbar.onDragEnd, r)), (n.simulateTouch && !b.ios && !b.android || n.simulateTouch && !c.touch && b.ios) && (a.removeEventListener("mousedown", this.scrollbar.onDragStart, o), t.removeEventListener("mousemove", this.scrollbar.onDragMove, o), t.removeEventListener("mouseup", this.scrollbar.onDragEnd, r))) : (a.removeEventListener(s.start, this.scrollbar.onDragStart, o), t.removeEventListener(s.move, this.scrollbar.onDragMove, o), t.removeEventListener(s.end, this.scrollbar.onDragEnd, r))
				}
			},
			init: function() {
				if (this.params.scrollbar.el) {
					var t = this.scrollbar,
						e = this.$el,
						i = this.params.scrollbar,
						n = s(i.el);
					this.params.uniqueNavElements && "string" == typeof i.el && n.length > 1 && 1 === e.find(i.el).length && (n = e.find(i.el));
					var a = n.find("." + this.params.scrollbar.dragClass);
					0 === a.length && (a = s('<div class="' + this.params.scrollbar.dragClass + '"></div>'), n.append(a)), d.extend(t, {
						$el: n,
						el: n[0],
						$dragEl: a,
						dragEl: a[0]
					}), i.draggable && t.enableDraggable()
				}
			},
			destroy: function() {
				this.scrollbar.disableDraggable()
			}
		},
		B = {
			setTransform: function(t, e) {
				var i = this.rtl,
					n = s(t),
					a = i ? -1 : 1,
					o = n.attr("data-swiper-parallax") || "0",
					r = n.attr("data-swiper-parallax-x"),
					l = n.attr("data-swiper-parallax-y"),
					d = n.attr("data-swiper-parallax-scale"),
					c = n.attr("data-swiper-parallax-opacity");
				if (r || l ? (r = r || "0", l = l || "0") : this.isHorizontal() ? (r = o, l = "0") : (l = o, r = "0"), r = r.indexOf("%") >= 0 ? parseInt(r, 10) * e * a + "%" : r * e * a + "px", l = l.indexOf("%") >= 0 ? parseInt(l, 10) * e + "%" : l * e + "px", null != c) {
					var h = c - (c - 1) * (1 - Math.abs(e));
					n[0].style.opacity = h
				}
				if (null == d) n.transform("translate3d(" + r + ", " + l + ", 0px)");
				else {
					var u = d - (d - 1) * (1 - Math.abs(e));
					n.transform("translate3d(" + r + ", " + l + ", 0px) scale(" + u + ")")
				}
			},
			setTranslate: function() {
				var t = this,
					e = t.$el,
					i = t.slides,
					n = t.progress,
					a = t.snapGrid;
				e.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function(e, i) {
					t.parallax.setTransform(i, n)
				}), i.each(function(e, i) {
					var o = i.progress;
					t.params.slidesPerGroup > 1 && "auto" !== t.params.slidesPerView && (o += Math.ceil(e / 2) - n * (a.length - 1)), o = Math.min(Math.max(o, -1), 1), s(i).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function(e, i) {
						t.parallax.setTransform(i, o)
					})
				})
			},
			setTransition: function(t) {
				void 0 === t && (t = this.params.speed), this.$el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function(e, i) {
					var n = s(i),
						a = parseInt(n.attr("data-swiper-parallax-duration"), 10) || t;
					0 === t && (a = 0), n.transition(a)
				})
			}
		},
		F = {
			getDistanceBetweenTouches: function(t) {
				if (t.targetTouches.length < 2) return 1;
				var e = t.targetTouches[0].pageX,
					i = t.targetTouches[0].pageY,
					s = t.targetTouches[1].pageX,
					n = t.targetTouches[1].pageY;
				return Math.sqrt(Math.pow(s - e, 2) + Math.pow(n - i, 2))
			},
			onGestureStart: function(t) {
				var e = this.params.zoom,
					i = this.zoom,
					n = i.gesture;
				if (i.fakeGestureTouched = !1, i.fakeGestureMoved = !1, !c.gestures) {
					if ("touchstart" !== t.type || "touchstart" === t.type && t.targetTouches.length < 2) return;
					i.fakeGestureTouched = !0, n.scaleStart = F.getDistanceBetweenTouches(t)
				}
				n.$slideEl && n.$slideEl.length || (n.$slideEl = s(t.target).closest(".swiper-slide"), 0 === n.$slideEl.length && (n.$slideEl = this.slides.eq(this.activeIndex)), n.$imageEl = n.$slideEl.find("img, svg, canvas"), n.$imageWrapEl = n.$imageEl.parent("." + e.containerClass), n.maxRatio = n.$imageWrapEl.attr("data-swiper-zoom") || e.maxRatio, 0 !== n.$imageWrapEl.length) ? (n.$imageEl.transition(0), this.zoom.isScaling = !0) : n.$imageEl = void 0
			},
			onGestureChange: function(t) {
				var e = this.params.zoom,
					i = this.zoom,
					s = i.gesture;
				if (!c.gestures) {
					if ("touchmove" !== t.type || "touchmove" === t.type && t.targetTouches.length < 2) return;
					i.fakeGestureMoved = !0, s.scaleMove = F.getDistanceBetweenTouches(t)
				}
				s.$imageEl && 0 !== s.$imageEl.length && (c.gestures ? this.zoom.scale = t.scale * i.currentScale : i.scale = s.scaleMove / s.scaleStart * i.currentScale, i.scale > s.maxRatio && (i.scale = s.maxRatio - 1 + Math.pow(i.scale - s.maxRatio + 1, .5)), i.scale < e.minRatio && (i.scale = e.minRatio + 1 - Math.pow(e.minRatio - i.scale + 1, .5)), s.$imageEl.transform("translate3d(0,0,0) scale(" + i.scale + ")"))
			},
			onGestureEnd: function(t) {
				var e = this.params.zoom,
					i = this.zoom,
					s = i.gesture;
				if (!c.gestures) {
					if (!i.fakeGestureTouched || !i.fakeGestureMoved) return;
					if ("touchend" !== t.type || "touchend" === t.type && t.changedTouches.length < 2 && !b.android) return;
					i.fakeGestureTouched = !1, i.fakeGestureMoved = !1
				}
				s.$imageEl && 0 !== s.$imageEl.length && (i.scale = Math.max(Math.min(i.scale, s.maxRatio), e.minRatio), s.$imageEl.transition(this.params.speed).transform("translate3d(0,0,0) scale(" + i.scale + ")"), i.currentScale = i.scale, i.isScaling = !1, 1 === i.scale && (s.$slideEl = void 0))
			},
			onTouchStart: function(t) {
				var e = this.zoom,
					i = e.gesture,
					s = e.image;
				i.$imageEl && 0 !== i.$imageEl.length && (s.isTouched || (b.android && t.preventDefault(), s.isTouched = !0, s.touchesStart.x = "touchstart" === t.type ? t.targetTouches[0].pageX : t.pageX, s.touchesStart.y = "touchstart" === t.type ? t.targetTouches[0].pageY : t.pageY))
			},
			onTouchMove: function(t) {
				var e = this.zoom,
					i = e.gesture,
					s = e.image,
					n = e.velocity;
				if (i.$imageEl && 0 !== i.$imageEl.length && (this.allowClick = !1, s.isTouched && i.$slideEl)) {
					s.isMoved || (s.width = i.$imageEl[0].offsetWidth, s.height = i.$imageEl[0].offsetHeight, s.startX = d.getTranslate(i.$imageWrapEl[0], "x") || 0, s.startY = d.getTranslate(i.$imageWrapEl[0], "y") || 0, i.slideWidth = i.$slideEl[0].offsetWidth, i.slideHeight = i.$slideEl[0].offsetHeight, i.$imageWrapEl.transition(0), this.rtl && (s.startX = -s.startX, s.startY = -s.startY));
					var a = s.width * e.scale,
						o = s.height * e.scale;
					if (!(a < i.slideWidth && o < i.slideHeight)) {
						if (s.minX = Math.min(i.slideWidth / 2 - a / 2, 0), s.maxX = -s.minX, s.minY = Math.min(i.slideHeight / 2 - o / 2, 0), s.maxY = -s.minY, s.touchesCurrent.x = "touchmove" === t.type ? t.targetTouches[0].pageX : t.pageX, s.touchesCurrent.y = "touchmove" === t.type ? t.targetTouches[0].pageY : t.pageY, !s.isMoved && !e.isScaling) {
							if (this.isHorizontal() && (Math.floor(s.minX) === Math.floor(s.startX) && s.touchesCurrent.x < s.touchesStart.x || Math.floor(s.maxX) === Math.floor(s.startX) && s.touchesCurrent.x > s.touchesStart.x)) return void(s.isTouched = !1);
							if (!this.isHorizontal() && (Math.floor(s.minY) === Math.floor(s.startY) && s.touchesCurrent.y < s.touchesStart.y || Math.floor(s.maxY) === Math.floor(s.startY) && s.touchesCurrent.y > s.touchesStart.y)) return void(s.isTouched = !1)
						}
						t.preventDefault(), t.stopPropagation(), s.isMoved = !0, s.currentX = s.touchesCurrent.x - s.touchesStart.x + s.startX, s.currentY = s.touchesCurrent.y - s.touchesStart.y + s.startY, s.currentX < s.minX && (s.currentX = s.minX + 1 - Math.pow(s.minX - s.currentX + 1, .8)), s.currentX > s.maxX && (s.currentX = s.maxX - 1 + Math.pow(s.currentX - s.maxX + 1, .8)), s.currentY < s.minY && (s.currentY = s.minY + 1 - Math.pow(s.minY - s.currentY + 1, .8)), s.currentY > s.maxY && (s.currentY = s.maxY - 1 + Math.pow(s.currentY - s.maxY + 1, .8)), n.prevPositionX || (n.prevPositionX = s.touchesCurrent.x), n.prevPositionY || (n.prevPositionY = s.touchesCurrent.y), n.prevTime || (n.prevTime = Date.now()), n.x = (s.touchesCurrent.x - n.prevPositionX) / (Date.now() - n.prevTime) / 2, n.y = (s.touchesCurrent.y - n.prevPositionY) / (Date.now() - n.prevTime) / 2, Math.abs(s.touchesCurrent.x - n.prevPositionX) < 2 && (n.x = 0), Math.abs(s.touchesCurrent.y - n.prevPositionY) < 2 && (n.y = 0), n.prevPositionX = s.touchesCurrent.x, n.prevPositionY = s.touchesCurrent.y, n.prevTime = Date.now(), i.$imageWrapEl.transform("translate3d(" + s.currentX + "px, " + s.currentY + "px,0)")
					}
				}
			},
			onTouchEnd: function() {
				var t = this.zoom,
					e = t.gesture,
					i = t.image,
					s = t.velocity;
				if (e.$imageEl && 0 !== e.$imageEl.length) {
					if (!i.isTouched || !i.isMoved) return i.isTouched = !1, void(i.isMoved = !1);
					i.isTouched = !1, i.isMoved = !1;
					var n = 300,
						a = 300,
						o = s.x * n,
						r = i.currentX + o,
						l = s.y * a,
						d = i.currentY + l;
					0 !== s.x && (n = Math.abs((r - i.currentX) / s.x)), 0 !== s.y && (a = Math.abs((d - i.currentY) / s.y));
					var c = Math.max(n, a);
					i.currentX = r, i.currentY = d;
					var h = i.width * t.scale,
						u = i.height * t.scale;
					i.minX = Math.min(e.slideWidth / 2 - h / 2, 0), i.maxX = -i.minX, i.minY = Math.min(e.slideHeight / 2 - u / 2, 0), i.maxY = -i.minY, i.currentX = Math.max(Math.min(i.currentX, i.maxX), i.minX), i.currentY = Math.max(Math.min(i.currentY, i.maxY), i.minY), e.$imageWrapEl.transition(c).transform("translate3d(" + i.currentX + "px, " + i.currentY + "px,0)")
				}
			},
			onTransitionEnd: function() {
				var t = this.zoom,
					e = t.gesture;
				e.$slideEl && this.previousIndex !== this.activeIndex && (e.$imageEl.transform("translate3d(0,0,0) scale(1)"), e.$imageWrapEl.transform("translate3d(0,0,0)"), e.$slideEl = void 0, e.$imageEl = void 0, e.$imageWrapEl = void 0, t.scale = 1, t.currentScale = 1)
			},
			toggle: function(t) {
				var e = this.zoom;
				e.scale && 1 !== e.scale ? e.out() : e.in(t)
			},
			in: function(t) {
				var e, i, n, a, o, r, l, d, c, h, u, p, f, m, g, v, y = this.zoom,
					b = this.params.zoom,
					w = y.gesture,
					S = y.image;
				w.$slideEl || (w.$slideEl = this.clickedSlide ? s(this.clickedSlide) : this.slides.eq(this.activeIndex), w.$imageEl = w.$slideEl.find("img, svg, canvas"), w.$imageWrapEl = w.$imageEl.parent("." + b.containerClass)), w.$imageEl && 0 !== w.$imageEl.length && (w.$slideEl.addClass("" + b.zoomedSlideClass), void 0 === S.touchesStart.x && t ? (e = "touchend" === t.type ? t.changedTouches[0].pageX : t.pageX, i = "touchend" === t.type ? t.changedTouches[0].pageY : t.pageY) : (e = S.touchesStart.x, i = S.touchesStart.y), y.scale = w.$imageWrapEl.attr("data-swiper-zoom") || b.maxRatio, y.currentScale = w.$imageWrapEl.attr("data-swiper-zoom") || b.maxRatio, t ? (g = w.$slideEl[0].offsetWidth, v = w.$slideEl[0].offsetHeight, n = w.$slideEl.offset().left + g / 2 - e, a = w.$slideEl.offset().top + v / 2 - i, l = w.$imageEl[0].offsetWidth, d = w.$imageEl[0].offsetHeight, c = l * y.scale, h = d * y.scale, f = -(u = Math.min(g / 2 - c / 2, 0)), m = -(p = Math.min(v / 2 - h / 2, 0)), (o = n * y.scale) < u && (o = u), o > f && (o = f), (r = a * y.scale) < p && (r = p), r > m && (r = m)) : (o = 0, r = 0), w.$imageWrapEl.transition(300).transform("translate3d(" + o + "px, " + r + "px,0)"), w.$imageEl.transition(300).transform("translate3d(0,0,0) scale(" + y.scale + ")"))
			},
			out: function() {
				var t = this.zoom,
					e = this.params.zoom,
					i = t.gesture;
				i.$slideEl || (i.$slideEl = this.clickedSlide ? s(this.clickedSlide) : this.slides.eq(this.activeIndex), i.$imageEl = i.$slideEl.find("img, svg, canvas"), i.$imageWrapEl = i.$imageEl.parent("." + e.containerClass)), i.$imageEl && 0 !== i.$imageEl.length && (t.scale = 1, t.currentScale = 1, i.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"), i.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"), i.$slideEl.removeClass("" + e.zoomedSlideClass), i.$slideEl = void 0)
			},
			enable: function() {
				var t = this.zoom;
				if (!t.enabled) {
					t.enabled = !0;
					var e = !("touchstart" !== this.touchEvents.start || !c.passiveListener || !this.params.passiveListeners) && {
						passive: !0,
						capture: !1
					};
					c.gestures ? (this.$wrapperEl.on("gesturestart", ".swiper-slide", t.onGestureStart, e), this.$wrapperEl.on("gesturechange", ".swiper-slide", t.onGestureChange, e), this.$wrapperEl.on("gestureend", ".swiper-slide", t.onGestureEnd, e)) : "touchstart" === this.touchEvents.start && (this.$wrapperEl.on(this.touchEvents.start, ".swiper-slide", t.onGestureStart, e), this.$wrapperEl.on(this.touchEvents.move, ".swiper-slide", t.onGestureChange, e), this.$wrapperEl.on(this.touchEvents.end, ".swiper-slide", t.onGestureEnd, e)), this.$wrapperEl.on(this.touchEvents.move, "." + this.params.zoom.containerClass, t.onTouchMove)
				}
			},
			disable: function() {
				var t = this.zoom;
				if (t.enabled) {
					this.zoom.enabled = !1;
					var e = !("touchstart" !== this.touchEvents.start || !c.passiveListener || !this.params.passiveListeners) && {
						passive: !0,
						capture: !1
					};
					c.gestures ? (this.$wrapperEl.off("gesturestart", ".swiper-slide", t.onGestureStart, e), this.$wrapperEl.off("gesturechange", ".swiper-slide", t.onGestureChange, e), this.$wrapperEl.off("gestureend", ".swiper-slide", t.onGestureEnd, e)) : "touchstart" === this.touchEvents.start && (this.$wrapperEl.off(this.touchEvents.start, ".swiper-slide", t.onGestureStart, e), this.$wrapperEl.off(this.touchEvents.move, ".swiper-slide", t.onGestureChange, e), this.$wrapperEl.off(this.touchEvents.end, ".swiper-slide", t.onGestureEnd, e)), this.$wrapperEl.off(this.touchEvents.move, "." + this.params.zoom.containerClass, t.onTouchMove)
				}
			}
		},
		W = {
			loadInSlide: function(t, e) {
				void 0 === e && (e = !0);
				var i = this,
					n = i.params.lazy;
				if (void 0 !== t && 0 !== i.slides.length) {
					var a = i.virtual && i.params.virtual.enabled ? i.$wrapperEl.children("." + i.params.slideClass + '[data-swiper-slide-index="' + t + '"]') : i.slides.eq(t),
						o = a.find("." + n.elementClass + ":not(." + n.loadedClass + "):not(." + n.loadingClass + ")");
					!a.hasClass(n.elementClass) || a.hasClass(n.loadedClass) || a.hasClass(n.loadingClass) || (o = o.add(a[0])), 0 !== o.length && o.each(function(t, o) {
						var r = s(o);
						r.addClass(n.loadingClass);
						var l = r.attr("data-background"),
							d = r.attr("data-src"),
							c = r.attr("data-srcset"),
							h = r.attr("data-sizes");
						i.loadImage(r[0], d || l, c, h, !1, function() {
							if (null != i && i && (!i || i.params) && !i.destroyed) {
								if (l ? (r.css("background-image", 'url("' + l + '")'), r.removeAttr("data-background")) : (c && (r.attr("srcset", c), r.removeAttr("data-srcset")), h && (r.attr("sizes", h), r.removeAttr("data-sizes")), d && (r.attr("src", d), r.removeAttr("data-src"))), r.addClass(n.loadedClass).removeClass(n.loadingClass), a.find("." + n.preloaderClass).remove(), i.params.loop && e) {
									var t = a.attr("data-swiper-slide-index");
									if (a.hasClass(i.params.slideDuplicateClass)) {
										var s = i.$wrapperEl.children('[data-swiper-slide-index="' + t + '"]:not(.' + i.params.slideDuplicateClass + ")");
										i.lazy.loadInSlide(s.index(), !1)
									} else {
										var o = i.$wrapperEl.children("." + i.params.slideDuplicateClass + '[data-swiper-slide-index="' + t + '"]');
										i.lazy.loadInSlide(o.index(), !1)
									}
								}
								i.emit("lazyImageReady", a[0], r[0])
							}
						}), i.emit("lazyImageLoad", a[0], r[0])
					})
				}
			},
			load: function() {
				var t = this,
					e = t.$wrapperEl,
					i = t.params,
					n = t.slides,
					a = t.activeIndex,
					o = t.virtual && i.virtual.enabled,
					r = i.lazy,
					l = i.slidesPerView;

				function d(t) {
					if (o) {
						if (e.children("." + i.slideClass + '[data-swiper-slide-index="' + t + '"]').length) return !0
					} else if (n[t]) return !0;
					return !1
				}

				function c(t) {
					return o ? s(t).attr("data-swiper-slide-index") : s(t).index()
				}
				if ("auto" === l && (l = 0), t.lazy.initialImageLoaded || (t.lazy.initialImageLoaded = !0), t.params.watchSlidesVisibility) e.children("." + i.slideVisibleClass).each(function(e, i) {
					var n = o ? s(i).attr("data-swiper-slide-index") : s(i).index();
					t.lazy.loadInSlide(n)
				});
				else if (l > 1)
					for (var h = a; h < a + l; h += 1) d(h) && t.lazy.loadInSlide(h);
				else t.lazy.loadInSlide(a);
				if (r.loadPrevNext)
					if (l > 1 || r.loadPrevNextAmount && r.loadPrevNextAmount > 1) {
						for (var u = r.loadPrevNextAmount, p = l, f = Math.min(a + p + Math.max(u, p), n.length), m = Math.max(a - Math.max(p, u), 0), g = a + l; g < f; g += 1) d(g) && t.lazy.loadInSlide(g);
						for (var v = m; v < a; v += 1) d(v) && t.lazy.loadInSlide(v)
					} else {
						var y = e.children("." + i.slideNextClass);
						y.length > 0 && t.lazy.loadInSlide(c(y));
						var b = e.children("." + i.slidePrevClass);
						b.length > 0 && t.lazy.loadInSlide(c(b))
					}
			}
		},
		V = {
			LinearSpline: function(t, e) {
				var i, s, n, a, o;
				return this.x = t, this.y = e, this.lastIndex = t.length - 1, this.interpolate = function(t) {
					return t ? (o = function(t, e) {
						for (s = -1, i = t.length; i - s > 1;) t[n = i + s >> 1] <= e ? s = n : i = n;
						return i
					}(this.x, t), a = o - 1, (t - this.x[a]) * (this.y[o] - this.y[a]) / (this.x[o] - this.x[a]) + this.y[a]) : 0
				}, this
			},
			getInterpolateFunction: function(t) {
				this.controller.spline || (this.controller.spline = this.params.loop ? new V.LinearSpline(this.slidesGrid, t.slidesGrid) : new V.LinearSpline(this.snapGrid, t.snapGrid))
			},
			setTranslate: function(t, e) {
				var i, s, n = this,
					a = n.controller.control;

				function o(t) {
					var e = n.rtlTranslate ? -n.translate : n.translate;
					"slide" === n.params.controller.by && (n.controller.getInterpolateFunction(t), s = -n.controller.spline.interpolate(-e)), s && "container" !== n.params.controller.by || (i = (t.maxTranslate() - t.minTranslate()) / (n.maxTranslate() - n.minTranslate()), s = (e - n.minTranslate()) * i + t.minTranslate()), n.params.controller.inverse && (s = t.maxTranslate() - s), t.updateProgress(s), t.setTranslate(s, n), t.updateActiveIndex(), t.updateSlidesClasses()
				}
				if (Array.isArray(a))
					for (var r = 0; r < a.length; r += 1) a[r] !== e && a[r] instanceof P && o(a[r]);
				else a instanceof P && e !== a && o(a)
			},
			setTransition: function(t, e) {
				var i, s = this,
					n = s.controller.control;

				function a(e) {
					e.setTransition(t, s), 0 !== t && (e.transitionStart(), e.$wrapperEl.transitionEnd(function() {
						n && (e.params.loop && "slide" === s.params.controller.by && e.loopFix(), e.transitionEnd())
					}))
				}
				if (Array.isArray(n))
					for (i = 0; i < n.length; i += 1) n[i] !== e && n[i] instanceof P && a(n[i]);
				else n instanceof P && e !== n && a(n)
			}
		},
		q = {
			makeElFocusable: function(t) {
				return t.attr("tabIndex", "0"), t
			},
			addElRole: function(t, e) {
				return t.attr("role", e), t
			},
			addElLabel: function(t, e) {
				return t.attr("aria-label", e), t
			},
			disableEl: function(t) {
				return t.attr("aria-disabled", !0), t
			},
			enableEl: function(t) {
				return t.attr("aria-disabled", !1), t
			},
			onEnterKey: function(t) {
				var e = this.params.a11y;
				if (13 === t.keyCode) {
					var i = s(t.target);
					this.navigation && this.navigation.$nextEl && i.is(this.navigation.$nextEl) && (this.isEnd && !this.params.loop || this.slideNext(), this.isEnd ? this.a11y.notify(e.lastSlideMessage) : this.a11y.notify(e.nextSlideMessage)), this.navigation && this.navigation.$prevEl && i.is(this.navigation.$prevEl) && (this.isBeginning && !this.params.loop || this.slidePrev(), this.isBeginning ? this.a11y.notify(e.firstSlideMessage) : this.a11y.notify(e.prevSlideMessage)), this.pagination && i.is("." + this.params.pagination.bulletClass) && i[0].click()
				}
			},
			notify: function(t) {
				var e = this.a11y.liveRegion;
				0 !== e.length && (e.html(""), e.html(t))
			},
			updateNavigation: function() {
				if (!this.params.loop) {
					var t = this.navigation,
						e = t.$nextEl,
						i = t.$prevEl;
					i && i.length > 0 && (this.isBeginning ? this.a11y.disableEl(i) : this.a11y.enableEl(i)), e && e.length > 0 && (this.isEnd ? this.a11y.disableEl(e) : this.a11y.enableEl(e))
				}
			},
			updatePagination: function() {
				var t = this,
					e = t.params.a11y;
				t.pagination && t.params.pagination.clickable && t.pagination.bullets && t.pagination.bullets.length && t.pagination.bullets.each(function(i, n) {
					var a = s(n);
					t.a11y.makeElFocusable(a), t.a11y.addElRole(a, "button"), t.a11y.addElLabel(a, e.paginationBulletMessage.replace(/{{index}}/, a.index() + 1))
				})
			},
			init: function() {
				this.$el.append(this.a11y.liveRegion);
				var t, e, i = this.params.a11y;
				this.navigation && this.navigation.$nextEl && (t = this.navigation.$nextEl), this.navigation && this.navigation.$prevEl && (e = this.navigation.$prevEl), t && (this.a11y.makeElFocusable(t), this.a11y.addElRole(t, "button"), this.a11y.addElLabel(t, i.nextSlideMessage), t.on("keydown", this.a11y.onEnterKey)), e && (this.a11y.makeElFocusable(e), this.a11y.addElRole(e, "button"), this.a11y.addElLabel(e, i.prevSlideMessage), e.on("keydown", this.a11y.onEnterKey)), this.pagination && this.params.pagination.clickable && this.pagination.bullets && this.pagination.bullets.length && this.pagination.$el.on("keydown", "." + this.params.pagination.bulletClass, this.a11y.onEnterKey)
			},
			destroy: function() {
				var t, e;
				this.a11y.liveRegion && this.a11y.liveRegion.length > 0 && this.a11y.liveRegion.remove(), this.navigation && this.navigation.$nextEl && (t = this.navigation.$nextEl), this.navigation && this.navigation.$prevEl && (e = this.navigation.$prevEl), t && t.off("keydown", this.a11y.onEnterKey), e && e.off("keydown", this.a11y.onEnterKey), this.pagination && this.params.pagination.clickable && this.pagination.bullets && this.pagination.bullets.length && this.pagination.$el.off("keydown", "." + this.params.pagination.bulletClass, this.a11y.onEnterKey)
			}
		},
		U = {
			init: function() {
				if (this.params.history) {
					if (!e.history || !e.history.pushState) return this.params.history.enabled = !1, void(this.params.hashNavigation.enabled = !0);
					var t = this.history;
					t.initialized = !0, t.paths = U.getPathValues(), (t.paths.key || t.paths.value) && (t.scrollToSlide(0, t.paths.value, this.params.runCallbacksOnInit), this.params.history.replaceState || e.addEventListener("popstate", this.history.setHistoryPopState))
				}
			},
			destroy: function() {
				this.params.history.replaceState || e.removeEventListener("popstate", this.history.setHistoryPopState)
			},
			setHistoryPopState: function() {
				this.history.paths = U.getPathValues(), this.history.scrollToSlide(this.params.speed, this.history.paths.value, !1)
			},
			getPathValues: function() {
				var t = e.location.pathname.slice(1).split("/").filter(function(t) {
						return "" !== t
					}),
					i = t.length;
				return {
					key: t[i - 2],
					value: t[i - 1]
				}
			},
			setHistory: function(t, i) {
				if (this.history.initialized && this.params.history.enabled) {
					var s = this.slides.eq(i),
						n = U.slugify(s.attr("data-history"));
					e.location.pathname.includes(t) || (n = t + "/" + n);
					var a = e.history.state;
					a && a.value === n || (this.params.history.replaceState ? e.history.replaceState({
						value: n
					}, null, n) : e.history.pushState({
						value: n
					}, null, n))
				}
			},
			slugify: function(t) {
				return t.toString().toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "")
			},
			scrollToSlide: function(t, e, i) {
				if (e)
					for (var s = 0, n = this.slides.length; s < n; s += 1) {
						var a = this.slides.eq(s);
						if (U.slugify(a.attr("data-history")) === e && !a.hasClass(this.params.slideDuplicateClass)) {
							var o = a.index();
							this.slideTo(o, t, i)
						}
					} else this.slideTo(0, t, i)
			}
		},
		G = {
			onHashCange: function() {
				var e = t.location.hash.replace("#", "");
				e !== this.slides.eq(this.activeIndex).attr("data-hash") && this.slideTo(this.$wrapperEl.children("." + this.params.slideClass + '[data-hash="' + e + '"]').index())
			},
			setHash: function() {
				if (this.hashNavigation.initialized && this.params.hashNavigation.enabled)
					if (this.params.hashNavigation.replaceState && e.history && e.history.replaceState) e.history.replaceState(null, null, "#" + this.slides.eq(this.activeIndex).attr("data-hash") || "");
					else {
						var i = this.slides.eq(this.activeIndex),
							s = i.attr("data-hash") || i.attr("data-history");
						t.location.hash = s || ""
					}
			},
			init: function() {
				if (!(!this.params.hashNavigation.enabled || this.params.history && this.params.history.enabled)) {
					this.hashNavigation.initialized = !0;
					var i = t.location.hash.replace("#", "");
					if (i)
						for (var n = 0, a = this.slides.length; n < a; n += 1) {
							var o = this.slides.eq(n);
							if ((o.attr("data-hash") || o.attr("data-history")) === i && !o.hasClass(this.params.slideDuplicateClass)) {
								var r = o.index();
								this.slideTo(r, 0, this.params.runCallbacksOnInit, !0)
							}
						}
					this.params.hashNavigation.watchState && s(e).on("hashchange", this.hashNavigation.onHashCange)
				}
			},
			destroy: function() {
				this.params.hashNavigation.watchState && s(e).off("hashchange", this.hashNavigation.onHashCange)
			}
		},
		X = {
			run: function() {
				var t = this,
					e = t.slides.eq(t.activeIndex),
					i = t.params.autoplay.delay;
				e.attr("data-swiper-autoplay") && (i = e.attr("data-swiper-autoplay") || t.params.autoplay.delay), t.autoplay.timeout = d.nextTick(function() {
					t.params.autoplay.reverseDirection ? t.params.loop ? (t.loopFix(), t.slidePrev(t.params.speed, !0, !0), t.emit("autoplay")) : t.isBeginning ? t.params.autoplay.stopOnLastSlide ? t.autoplay.stop() : (t.slideTo(t.slides.length - 1, t.params.speed, !0, !0), t.emit("autoplay")) : (t.slidePrev(t.params.speed, !0, !0), t.emit("autoplay")) : t.params.loop ? (t.loopFix(), t.slideNext(t.params.speed, !0, !0), t.emit("autoplay")) : t.isEnd ? t.params.autoplay.stopOnLastSlide ? t.autoplay.stop() : (t.slideTo(0, t.params.speed, !0, !0), t.emit("autoplay")) : (t.slideNext(t.params.speed, !0, !0), t.emit("autoplay"))
				}, i)
			},
			start: function() {
				return void 0 === this.autoplay.timeout && !this.autoplay.running && (this.autoplay.running = !0, this.emit("autoplayStart"), this.autoplay.run(), !0)
			},
			stop: function() {
				return !!this.autoplay.running && void 0 !== this.autoplay.timeout && (this.autoplay.timeout && (clearTimeout(this.autoplay.timeout), this.autoplay.timeout = void 0), this.autoplay.running = !1, this.emit("autoplayStop"), !0)
			},
			pause: function(t) {
				var e = this;
				e.autoplay.running && (e.autoplay.paused || (e.autoplay.timeout && clearTimeout(e.autoplay.timeout), e.autoplay.paused = !0, 0 !== t && e.params.autoplay.waitForTransition ? e.$wrapperEl.transitionEnd(function() {
					e && !e.destroyed && (e.autoplay.paused = !1, e.autoplay.running ? e.autoplay.run() : e.autoplay.stop())
				}) : (e.autoplay.paused = !1, e.autoplay.run())))
			}
		},
		Q = {
			setTranslate: function() {
				for (var t = this.slides, e = 0; e < t.length; e += 1) {
					var i = this.slides.eq(e),
						s = -i[0].swiperSlideOffset;
					this.params.virtualTranslate || (s -= this.translate);
					var n = 0;
					this.isHorizontal() || (n = s, s = 0);
					var a = this.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(i[0].progress), 0) : 1 + Math.min(Math.max(i[0].progress, -1), 0);
					i.css({
						opacity: a
					}).transform("translate3d(" + s + "px, " + n + "px, 0px)")
				}
			},
			setTransition: function(t) {
				var e = this,
					i = e.slides,
					s = e.$wrapperEl;
				if (i.transition(t), e.params.virtualTranslate && 0 !== t) {
					var n = !1;
					i.transitionEnd(function() {
						if (!n && e && !e.destroyed) {
							n = !0, e.animating = !1;
							for (var t = ["webkitTransitionEnd", "transitionend"], i = 0; i < t.length; i += 1) s.trigger(t[i])
						}
					})
				}
			}
		},
		Z = {
			setTranslate: function() {
				var t, e = this.$el,
					i = this.$wrapperEl,
					n = this.slides,
					a = this.width,
					o = this.height,
					r = this.rtlTranslate,
					l = this.size,
					d = this.params.cubeEffect,
					c = this.isHorizontal(),
					h = this.virtual && this.params.virtual.enabled,
					u = 0;
				d.shadow && (c ? (0 === (t = i.find(".swiper-cube-shadow")).length && (t = s('<div class="swiper-cube-shadow"></div>'), i.append(t)), t.css({
					height: a + "px"
				})) : 0 === (t = e.find(".swiper-cube-shadow")).length && (t = s('<div class="swiper-cube-shadow"></div>'), e.append(t)));
				for (var p = 0; p < n.length; p += 1) {
					var f = n.eq(p),
						m = p;
					h && (m = parseInt(f.attr("data-swiper-slide-index"), 10));
					var g = 90 * m,
						v = Math.floor(g / 360);
					r && (g = -g, v = Math.floor(-g / 360));
					var y = Math.max(Math.min(f[0].progress, 1), -1),
						b = 0,
						w = 0,
						S = 0;
					m % 4 == 0 ? (b = 4 * -v * l, S = 0) : (m - 1) % 4 == 0 ? (b = 0, S = 4 * -v * l) : (m - 2) % 4 == 0 ? (b = l + 4 * v * l, S = l) : (m - 3) % 4 == 0 && (b = -l, S = 3 * l + 4 * l * v), r && (b = -b), c || (w = b, b = 0);
					var x = "rotateX(" + (c ? 0 : -g) + "deg) rotateY(" + (c ? g : 0) + "deg) translate3d(" + b + "px, " + w + "px, " + S + "px)";
					if (y <= 1 && y > -1 && (u = 90 * m + 90 * y, r && (u = 90 * -m - 90 * y)), f.transform(x), d.slideShadows) {
						var C = c ? f.find(".swiper-slide-shadow-left") : f.find(".swiper-slide-shadow-top"),
							_ = c ? f.find(".swiper-slide-shadow-right") : f.find(".swiper-slide-shadow-bottom");
						0 === C.length && (C = s('<div class="swiper-slide-shadow-' + (c ? "left" : "top") + '"></div>'), f.append(C)), 0 === _.length && (_ = s('<div class="swiper-slide-shadow-' + (c ? "right" : "bottom") + '"></div>'), f.append(_)), C.length && (C[0].style.opacity = Math.max(-y, 0)), _.length && (_[0].style.opacity = Math.max(y, 0))
					}
				}
				if (i.css({
						"-webkit-transform-origin": "50% 50% -" + l / 2 + "px",
						"-moz-transform-origin": "50% 50% -" + l / 2 + "px",
						"-ms-transform-origin": "50% 50% -" + l / 2 + "px",
						"transform-origin": "50% 50% -" + l / 2 + "px"
					}), d.shadow)
					if (c) t.transform("translate3d(0px, " + (a / 2 + d.shadowOffset) + "px, " + -a / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + d.shadowScale + ")");
					else {
						var E = Math.abs(u) - 90 * Math.floor(Math.abs(u) / 90),
							P = 1.5 - (Math.sin(2 * E * Math.PI / 360) / 2 + Math.cos(2 * E * Math.PI / 360) / 2),
							k = d.shadowScale,
							$ = d.shadowScale / P,
							M = d.shadowOffset;
						t.transform("scale3d(" + k + ", 1, " + $ + ") translate3d(0px, " + (o / 2 + M) + "px, " + -o / 2 / $ + "px) rotateX(-90deg)")
					} var D = T.isSafari || T.isUiWebView ? -l / 2 : 0;
				i.transform("translate3d(0px,0," + D + "px) rotateX(" + (this.isHorizontal() ? 0 : u) + "deg) rotateY(" + (this.isHorizontal() ? -u : 0) + "deg)")
			},
			setTransition: function(t) {
				var e = this.$el;
				this.slides.transition(t).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(t), this.params.cubeEffect.shadow && !this.isHorizontal() && e.find(".swiper-cube-shadow").transition(t)
			}
		},
		K = {
			setTranslate: function() {
				for (var t = this.slides, e = this.rtlTranslate, i = 0; i < t.length; i += 1) {
					var n = t.eq(i),
						a = n[0].progress;
					this.params.flipEffect.limitRotation && (a = Math.max(Math.min(n[0].progress, 1), -1));
					var o = -180 * a,
						r = 0,
						l = -n[0].swiperSlideOffset,
						d = 0;
					if (this.isHorizontal() ? e && (o = -o) : (d = l, l = 0, r = -o, o = 0), n[0].style.zIndex = -Math.abs(Math.round(a)) + t.length, this.params.flipEffect.slideShadows) {
						var c = this.isHorizontal() ? n.find(".swiper-slide-shadow-left") : n.find(".swiper-slide-shadow-top"),
							h = this.isHorizontal() ? n.find(".swiper-slide-shadow-right") : n.find(".swiper-slide-shadow-bottom");
						0 === c.length && (c = s('<div class="swiper-slide-shadow-' + (this.isHorizontal() ? "left" : "top") + '"></div>'), n.append(c)), 0 === h.length && (h = s('<div class="swiper-slide-shadow-' + (this.isHorizontal() ? "right" : "bottom") + '"></div>'), n.append(h)), c.length && (c[0].style.opacity = Math.max(-a, 0)), h.length && (h[0].style.opacity = Math.max(a, 0))
					}
					n.transform("translate3d(" + l + "px, " + d + "px, 0px) rotateX(" + r + "deg) rotateY(" + o + "deg)")
				}
			},
			setTransition: function(t) {
				var e = this,
					i = e.slides,
					s = e.activeIndex,
					n = e.$wrapperEl;
				if (i.transition(t).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(t), e.params.virtualTranslate && 0 !== t) {
					var a = !1;
					i.eq(s).transitionEnd(function() {
						if (!a && e && !e.destroyed) {
							a = !0, e.animating = !1;
							for (var t = ["webkitTransitionEnd", "transitionend"], i = 0; i < t.length; i += 1) n.trigger(t[i])
						}
					})
				}
			}
		},
		J = {
			setTranslate: function() {
				for (var t = this.width, e = this.height, i = this.slides, n = this.$wrapperEl, a = this.slidesSizesGrid, o = this.params.coverflowEffect, r = this.isHorizontal(), l = this.translate, d = r ? t / 2 - l : e / 2 - l, h = r ? o.rotate : -o.rotate, u = o.depth, p = 0, f = i.length; p < f; p += 1) {
					var m = i.eq(p),
						g = a[p],
						v = (d - m[0].swiperSlideOffset - g / 2) / g * o.modifier,
						y = r ? h * v : 0,
						b = r ? 0 : h * v,
						w = -u * Math.abs(v),
						S = r ? 0 : o.stretch * v,
						x = r ? o.stretch * v : 0;
					Math.abs(x) < .001 && (x = 0), Math.abs(S) < .001 && (S = 0), Math.abs(w) < .001 && (w = 0), Math.abs(y) < .001 && (y = 0), Math.abs(b) < .001 && (b = 0);
					var T = "translate3d(" + x + "px," + S + "px," + w + "px)  rotateX(" + b + "deg) rotateY(" + y + "deg)";
					if (m.transform(T), m[0].style.zIndex = 1 - Math.abs(Math.round(v)), o.slideShadows) {
						var C = r ? m.find(".swiper-slide-shadow-left") : m.find(".swiper-slide-shadow-top"),
							_ = r ? m.find(".swiper-slide-shadow-right") : m.find(".swiper-slide-shadow-bottom");
						0 === C.length && (C = s('<div class="swiper-slide-shadow-' + (r ? "left" : "top") + '"></div>'), m.append(C)), 0 === _.length && (_ = s('<div class="swiper-slide-shadow-' + (r ? "right" : "bottom") + '"></div>'), m.append(_)), C.length && (C[0].style.opacity = v > 0 ? v : 0), _.length && (_[0].style.opacity = -v > 0 ? -v : 0)
					}
				}(c.pointerEvents || c.prefixedPointerEvents) && (n[0].style.perspectiveOrigin = d + "px 50%")
			},
			setTransition: function(t) {
				this.slides.transition(t).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(t)
			}
		},
		tt = [k, $, M, D, z, I, N, {
			name: "mousewheel",
			params: {
				mousewheel: {
					enabled: !1,
					releaseOnEdges: !1,
					invert: !1,
					forceToAxis: !1,
					sensitivity: 1,
					eventsTarged: "container"
				}
			},
			create: function() {
				d.extend(this, {
					mousewheel: {
						enabled: !1,
						enable: Y.enable.bind(this),
						disable: Y.disable.bind(this),
						handle: Y.handle.bind(this),
						handleMouseEnter: Y.handleMouseEnter.bind(this),
						handleMouseLeave: Y.handleMouseLeave.bind(this),
						lastScrollTime: d.now()
					}
				})
			},
			on: {
				init: function() {
					this.params.mousewheel.enabled && this.mousewheel.enable()
				},
				destroy: function() {
					this.mousewheel.enabled && this.mousewheel.disable()
				}
			}
		}, {
			name: "navigation",
			params: {
				navigation: {
					nextEl: null,
					prevEl: null,
					hideOnClick: !1,
					disabledClass: "swiper-button-disabled",
					hiddenClass: "swiper-button-hidden",
					lockClass: "swiper-button-lock"
				}
			},
			create: function() {
				d.extend(this, {
					navigation: {
						init: R.init.bind(this),
						update: R.update.bind(this),
						destroy: R.destroy.bind(this)
					}
				})
			},
			on: {
				init: function() {
					this.navigation.init(), this.navigation.update()
				},
				toEdge: function() {
					this.navigation.update()
				},
				fromEdge: function() {
					this.navigation.update()
				},
				destroy: function() {
					this.navigation.destroy()
				},
				click: function(t) {
					var e = this.navigation,
						i = e.$nextEl,
						n = e.$prevEl;
					!this.params.navigation.hideOnClick || s(t.target).is(n) || s(t.target).is(i) || (i && i.toggleClass(this.params.navigation.hiddenClass), n && n.toggleClass(this.params.navigation.hiddenClass))
				}
			}
		}, {
			name: "pagination",
			params: {
				pagination: {
					el: null,
					bulletElement: "span",
					clickable: !1,
					hideOnClick: !1,
					renderBullet: null,
					renderProgressbar: null,
					renderFraction: null,
					renderCustom: null,
					type: "bullets",
					dynamicBullets: !1,
					dynamicMainBullets: 1,
					bulletClass: "swiper-pagination-bullet",
					bulletActiveClass: "swiper-pagination-bullet-active",
					modifierClass: "swiper-pagination-",
					currentClass: "swiper-pagination-current",
					totalClass: "swiper-pagination-total",
					hiddenClass: "swiper-pagination-hidden",
					progressbarFillClass: "swiper-pagination-progressbar-fill",
					clickableClass: "swiper-pagination-clickable",
					lockClass: "swiper-pagination-lock"
				}
			},
			create: function() {
				d.extend(this, {
					pagination: {
						init: j.init.bind(this),
						render: j.render.bind(this),
						update: j.update.bind(this),
						destroy: j.destroy.bind(this),
						dynamicBulletIndex: 0
					}
				})
			},
			on: {
				init: function() {
					this.pagination.init(), this.pagination.render(), this.pagination.update()
				},
				activeIndexChange: function() {
					this.params.loop ? this.pagination.update() : void 0 === this.snapIndex && this.pagination.update()
				},
				snapIndexChange: function() {
					this.params.loop || this.pagination.update()
				},
				slidesLengthChange: function() {
					this.params.loop && (this.pagination.render(), this.pagination.update())
				},
				snapGridLengthChange: function() {
					this.params.loop || (this.pagination.render(), this.pagination.update())
				},
				destroy: function() {
					this.pagination.destroy()
				},
				click: function(t) {
					this.params.pagination.el && this.params.pagination.hideOnClick && this.pagination.$el.length > 0 && !s(t.target).hasClass(this.params.pagination.bulletClass) && this.pagination.$el.toggleClass(this.params.pagination.hiddenClass)
				}
			}
		}, {
			name: "scrollbar",
			params: {
				scrollbar: {
					el: null,
					dragSize: "auto",
					hide: !1,
					draggable: !1,
					snapOnRelease: !0,
					lockClass: "swiper-scrollbar-lock",
					dragClass: "swiper-scrollbar-drag"
				}
			},
			create: function() {
				d.extend(this, {
					scrollbar: {
						init: H.init.bind(this),
						destroy: H.destroy.bind(this),
						updateSize: H.updateSize.bind(this),
						setTranslate: H.setTranslate.bind(this),
						setTransition: H.setTransition.bind(this),
						enableDraggable: H.enableDraggable.bind(this),
						disableDraggable: H.disableDraggable.bind(this),
						setDragPosition: H.setDragPosition.bind(this),
						onDragStart: H.onDragStart.bind(this),
						onDragMove: H.onDragMove.bind(this),
						onDragEnd: H.onDragEnd.bind(this),
						isTouched: !1,
						timeout: null,
						dragTimeout: null
					}
				})
			},
			on: {
				init: function() {
					this.scrollbar.init(), this.scrollbar.updateSize(), this.scrollbar.setTranslate()
				},
				update: function() {
					this.scrollbar.updateSize()
				},
				resize: function() {
					this.scrollbar.updateSize()
				},
				observerUpdate: function() {
					this.scrollbar.updateSize()
				},
				setTranslate: function() {
					this.scrollbar.setTranslate()
				},
				setTransition: function(t) {
					this.scrollbar.setTransition(t)
				},
				destroy: function() {
					this.scrollbar.destroy()
				}
			}
		}, {
			name: "parallax",
			params: {
				parallax: {
					enabled: !1
				}
			},
			create: function() {
				d.extend(this, {
					parallax: {
						setTransform: B.setTransform.bind(this),
						setTranslate: B.setTranslate.bind(this),
						setTransition: B.setTransition.bind(this)
					}
				})
			},
			on: {
				beforeInit: function() {
					this.params.parallax.enabled && (this.params.watchSlidesProgress = !0)
				},
				init: function() {
					this.params.parallax && this.parallax.setTranslate()
				},
				setTranslate: function() {
					this.params.parallax && this.parallax.setTranslate()
				},
				setTransition: function(t) {
					this.params.parallax && this.parallax.setTransition(t)
				}
			}
		}, {
			name: "zoom",
			params: {
				zoom: {
					enabled: !1,
					maxRatio: 3,
					minRatio: 1,
					toggle: !0,
					containerClass: "swiper-zoom-container",
					zoomedSlideClass: "swiper-slide-zoomed"
				}
			},
			create: function() {
				var t = this,
					e = {
						enabled: !1,
						scale: 1,
						currentScale: 1,
						isScaling: !1,
						gesture: {
							$slideEl: void 0,
							slideWidth: void 0,
							slideHeight: void 0,
							$imageEl: void 0,
							$imageWrapEl: void 0,
							maxRatio: 3
						},
						image: {
							isTouched: void 0,
							isMoved: void 0,
							currentX: void 0,
							currentY: void 0,
							minX: void 0,
							minY: void 0,
							maxX: void 0,
							maxY: void 0,
							width: void 0,
							height: void 0,
							startX: void 0,
							startY: void 0,
							touchesStart: {},
							touchesCurrent: {}
						},
						velocity: {
							x: void 0,
							y: void 0,
							prevPositionX: void 0,
							prevPositionY: void 0,
							prevTime: void 0
						}
					};
				"onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out".split(" ").forEach(function(i) {
					e[i] = F[i].bind(t)
				}), d.extend(t, {
					zoom: e
				})
			},
			on: {
				init: function() {
					this.params.zoom.enabled && this.zoom.enable()
				},
				destroy: function() {
					this.zoom.disable()
				},
				touchStart: function(t) {
					this.zoom.enabled && this.zoom.onTouchStart(t)
				},
				touchEnd: function(t) {
					this.zoom.enabled && this.zoom.onTouchEnd(t)
				},
				doubleTap: function(t) {
					this.params.zoom.enabled && this.zoom.enabled && this.params.zoom.toggle && this.zoom.toggle(t)
				},
				transitionEnd: function() {
					this.zoom.enabled && this.params.zoom.enabled && this.zoom.onTransitionEnd()
				}
			}
		}, {
			name: "lazy",
			params: {
				lazy: {
					enabled: !1,
					loadPrevNext: !1,
					loadPrevNextAmount: 1,
					loadOnTransitionStart: !1,
					elementClass: "swiper-lazy",
					loadingClass: "swiper-lazy-loading",
					loadedClass: "swiper-lazy-loaded",
					preloaderClass: "swiper-lazy-preloader"
				}
			},
			create: function() {
				d.extend(this, {
					lazy: {
						initialImageLoaded: !1,
						load: W.load.bind(this),
						loadInSlide: W.loadInSlide.bind(this)
					}
				})
			},
			on: {
				beforeInit: function() {
					this.params.lazy.enabled && this.params.preloadImages && (this.params.preloadImages = !1)
				},
				init: function() {
					this.params.lazy.enabled && !this.params.loop && 0 === this.params.initialSlide && this.lazy.load()
				},
				scroll: function() {
					this.params.freeMode && !this.params.freeModeSticky && this.lazy.load()
				},
				resize: function() {
					this.params.lazy.enabled && this.lazy.load()
				},
				scrollbarDragMove: function() {
					this.params.lazy.enabled && this.lazy.load()
				},
				transitionStart: function() {
					this.params.lazy.enabled && (this.params.lazy.loadOnTransitionStart || !this.params.lazy.loadOnTransitionStart && !this.lazy.initialImageLoaded) && this.lazy.load()
				},
				transitionEnd: function() {
					this.params.lazy.enabled && !this.params.lazy.loadOnTransitionStart && this.lazy.load()
				}
			}
		}, {
			name: "controller",
			params: {
				controller: {
					control: void 0,
					inverse: !1,
					by: "slide"
				}
			},
			create: function() {
				d.extend(this, {
					controller: {
						control: this.params.controller.control,
						getInterpolateFunction: V.getInterpolateFunction.bind(this),
						setTranslate: V.setTranslate.bind(this),
						setTransition: V.setTransition.bind(this)
					}
				})
			},
			on: {
				update: function() {
					this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline)
				},
				resize: function() {
					this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline)
				},
				observerUpdate: function() {
					this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline)
				},
				setTranslate: function(t, e) {
					this.controller.control && this.controller.setTranslate(t, e)
				},
				setTransition: function(t, e) {
					this.controller.control && this.controller.setTransition(t, e)
				}
			}
		}, {
			name: "a11y",
			params: {
				a11y: {
					enabled: !0,
					notificationClass: "swiper-notification",
					prevSlideMessage: "Previous slide",
					nextSlideMessage: "Next slide",
					firstSlideMessage: "This is the first slide",
					lastSlideMessage: "This is the last slide",
					paginationBulletMessage: "Go to slide {{index}}"
				}
			},
			create: function() {
				var t = this;
				d.extend(t, {
					a11y: {
						liveRegion: s('<span class="' + t.params.a11y.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>')
					}
				}), Object.keys(q).forEach(function(e) {
					t.a11y[e] = q[e].bind(t)
				})
			},
			on: {
				init: function() {
					this.params.a11y.enabled && (this.a11y.init(), this.a11y.updateNavigation())
				},
				toEdge: function() {
					this.params.a11y.enabled && this.a11y.updateNavigation()
				},
				fromEdge: function() {
					this.params.a11y.enabled && this.a11y.updateNavigation()
				},
				paginationUpdate: function() {
					this.params.a11y.enabled && this.a11y.updatePagination()
				},
				destroy: function() {
					this.params.a11y.enabled && this.a11y.destroy()
				}
			}
		}, {
			name: "history",
			params: {
				history: {
					enabled: !1,
					replaceState: !1,
					key: "slides"
				}
			},
			create: function() {
				d.extend(this, {
					history: {
						init: U.init.bind(this),
						setHistory: U.setHistory.bind(this),
						setHistoryPopState: U.setHistoryPopState.bind(this),
						scrollToSlide: U.scrollToSlide.bind(this),
						destroy: U.destroy.bind(this)
					}
				})
			},
			on: {
				init: function() {
					this.params.history.enabled && this.history.init()
				},
				destroy: function() {
					this.params.history.enabled && this.history.destroy()
				},
				transitionEnd: function() {
					this.history.initialized && this.history.setHistory(this.params.history.key, this.activeIndex)
				}
			}
		}, {
			name: "hash-navigation",
			params: {
				hashNavigation: {
					enabled: !1,
					replaceState: !1,
					watchState: !1
				}
			},
			create: function() {
				d.extend(this, {
					hashNavigation: {
						initialized: !1,
						init: G.init.bind(this),
						destroy: G.destroy.bind(this),
						setHash: G.setHash.bind(this),
						onHashCange: G.onHashCange.bind(this)
					}
				})
			},
			on: {
				init: function() {
					this.params.hashNavigation.enabled && this.hashNavigation.init()
				},
				destroy: function() {
					this.params.hashNavigation.enabled && this.hashNavigation.destroy()
				},
				transitionEnd: function() {
					this.hashNavigation.initialized && this.hashNavigation.setHash()
				}
			}
		}, {
			name: "autoplay",
			params: {
				autoplay: {
					enabled: !1,
					delay: 3e3,
					waitForTransition: !0,
					disableOnInteraction: !0,
					stopOnLastSlide: !1,
					reverseDirection: !1
				}
			},
			create: function() {
				d.extend(this, {
					autoplay: {
						running: !1,
						paused: !1,
						run: X.run.bind(this),
						start: X.start.bind(this),
						stop: X.stop.bind(this),
						pause: X.pause.bind(this)
					}
				})
			},
			on: {
				init: function() {
					this.params.autoplay.enabled && this.autoplay.start()
				},
				beforeTransitionStart: function(t, e) {
					this.autoplay.running && (e || !this.params.autoplay.disableOnInteraction ? this.autoplay.pause(t) : this.autoplay.stop())
				},
				sliderFirstMove: function() {
					this.autoplay.running && (this.params.autoplay.disableOnInteraction ? this.autoplay.stop() : this.autoplay.pause())
				},
				destroy: function() {
					this.autoplay.running && this.autoplay.stop()
				}
			}
		}, {
			name: "effect-fade",
			params: {
				fadeEffect: {
					crossFade: !1
				}
			},
			create: function() {
				d.extend(this, {
					fadeEffect: {
						setTranslate: Q.setTranslate.bind(this),
						setTransition: Q.setTransition.bind(this)
					}
				})
			},
			on: {
				beforeInit: function() {
					if ("fade" === this.params.effect) {
						this.classNames.push(this.params.containerModifierClass + "fade");
						var t = {
							slidesPerView: 1,
							slidesPerColumn: 1,
							slidesPerGroup: 1,
							watchSlidesProgress: !0,
							spaceBetween: 0,
							virtualTranslate: !0
						};
						d.extend(this.params, t), d.extend(this.originalParams, t)
					}
				},
				setTranslate: function() {
					"fade" === this.params.effect && this.fadeEffect.setTranslate()
				},
				setTransition: function(t) {
					"fade" === this.params.effect && this.fadeEffect.setTransition(t)
				}
			}
		}, {
			name: "effect-cube",
			params: {
				cubeEffect: {
					slideShadows: !0,
					shadow: !0,
					shadowOffset: 20,
					shadowScale: .94
				}
			},
			create: function() {
				d.extend(this, {
					cubeEffect: {
						setTranslate: Z.setTranslate.bind(this),
						setTransition: Z.setTransition.bind(this)
					}
				})
			},
			on: {
				beforeInit: function() {
					if ("cube" === this.params.effect) {
						this.classNames.push(this.params.containerModifierClass + "cube"), this.classNames.push(this.params.containerModifierClass + "3d");
						var t = {
							slidesPerView: 1,
							slidesPerColumn: 1,
							slidesPerGroup: 1,
							watchSlidesProgress: !0,
							resistanceRatio: 0,
							spaceBetween: 0,
							centeredSlides: !1,
							virtualTranslate: !0
						};
						d.extend(this.params, t), d.extend(this.originalParams, t)
					}
				},
				setTranslate: function() {
					"cube" === this.params.effect && this.cubeEffect.setTranslate()
				},
				setTransition: function(t) {
					"cube" === this.params.effect && this.cubeEffect.setTransition(t)
				}
			}
		}, {
			name: "effect-flip",
			params: {
				flipEffect: {
					slideShadows: !0,
					limitRotation: !0
				}
			},
			create: function() {
				d.extend(this, {
					flipEffect: {
						setTranslate: K.setTranslate.bind(this),
						setTransition: K.setTransition.bind(this)
					}
				})
			},
			on: {
				beforeInit: function() {
					if ("flip" === this.params.effect) {
						this.classNames.push(this.params.containerModifierClass + "flip"), this.classNames.push(this.params.containerModifierClass + "3d");
						var t = {
							slidesPerView: 1,
							slidesPerColumn: 1,
							slidesPerGroup: 1,
							watchSlidesProgress: !0,
							spaceBetween: 0,
							virtualTranslate: !0
						};
						d.extend(this.params, t), d.extend(this.originalParams, t)
					}
				},
				setTranslate: function() {
					"flip" === this.params.effect && this.flipEffect.setTranslate()
				},
				setTransition: function(t) {
					"flip" === this.params.effect && this.flipEffect.setTransition(t)
				}
			}
		}, {
			name: "effect-coverflow",
			params: {
				coverflowEffect: {
					rotate: 50,
					stretch: 0,
					depth: 100,
					modifier: 1,
					slideShadows: !0
				}
			},
			create: function() {
				d.extend(this, {
					coverflowEffect: {
						setTranslate: J.setTranslate.bind(this),
						setTransition: J.setTransition.bind(this)
					}
				})
			},
			on: {
				beforeInit: function() {
					"coverflow" === this.params.effect && (this.classNames.push(this.params.containerModifierClass + "coverflow"), this.classNames.push(this.params.containerModifierClass + "3d"), this.params.watchSlidesProgress = !0, this.originalParams.watchSlidesProgress = !0)
				},
				setTranslate: function() {
					"coverflow" === this.params.effect && this.coverflowEffect.setTranslate()
				},
				setTransition: function(t) {
					"coverflow" === this.params.effect && this.coverflowEffect.setTransition(t)
				}
			}
		}];
	return void 0 === P.use && (P.use = P.Class.use, P.installModule = P.Class.installModule), P.use(tt), P
}),
function() {
	var t, e;
	t = this.jQuery || window.jQuery, e = t(window), t.fn.stick_in_parent = function(i) {
		var s, n, a, o, r, l, d, c, h, u, p, f;
		for (null == i && (i = {}), f = i.sticky_class, l = i.inner_scrolling, p = i.recalc_every, u = i.parent, h = i.offset_top, c = i.spacer, a = i.bottoming, null == h && (h = 0), null == u && (u = void 0), null == l && (l = !0), null == f && (f = "is_stuck"), s = t(document), null == a && (a = !0), o = function(i, n, o, r, d, m, g, v) {
				var y, b, w, S, x, T, C, _, E, P, k, $;
				if (i.data("sticky_kit", !0), x = s.height(), C = i.parent(), null != u && (C = C.closest(u)), !C.length) throw "failed to find stick parent";
				if (w = !1, y = !1, (k = null != c ? c && i.closest(c) : t("<div />")) && k.css("position", i.css("position")), (_ = function() {
						var t, e, a;
						if (!v) return x = s.height(), t = parseInt(C.css("border-top-width"), 10), e = parseInt(C.css("padding-top"), 10), n = parseInt(C.css("padding-bottom"), 10), o = C.offset().top + t + e, r = C.height(), w && (w = !1, y = !1, null == c && (i.insertAfter(k), k.detach()), i.css({
							position: "",
							top: "",
							width: "",
							bottom: ""
						}).removeClass(f), a = !0), d = i.offset().top - (parseInt(i.css("margin-top"), 10) || 0) - h, m = i.outerHeight(!0), g = i.css("float"), k && k.css({
							width: i.outerWidth(!0),
							height: m,
							display: i.css("display"),
							"vertical-align": i.css("vertical-align"),
							float: g
						}), a ? $() : void 0
					})(), m !== r) return S = void 0, T = h, P = p, $ = function() {
					var t, u, b, E, $, M;
					if (!v) return b = !1, null != P && (P -= 1) <= 0 && (P = p, _(), b = !0), b || s.height() === x || (_(), b = !0), E = e.scrollTop(), null != S && (u = E - S), S = E, w ? (a && ($ = E + m + T > r + o, y && !$ && (y = !1, i.css({
						position: "fixed",
						bottom: "",
						top: T
					}).trigger("sticky_kit:unbottom"))), E < d && (w = !1, T = h, null == c && ("left" !== g && "right" !== g || i.insertAfter(k), k.detach()), t = {
						position: "",
						width: "",
						top: ""
					}, i.css(t).removeClass(f).trigger("sticky_kit:unstick")), l && (M = e.height(), m + h > M && (y || (T -= u, T = Math.max(M - m, T), T = Math.min(h, T), w && i.css({
						top: T + "px"
					}))))) : E > d && (w = !0, (t = {
						position: "fixed",
						top: T
					}).width = "border-box" === i.css("box-sizing") ? i.outerWidth() + "px" : i.width() + "px", i.css(t).addClass(f), null == c && (i.after(k), "left" !== g && "right" !== g || k.append(i)), i.trigger("sticky_kit:stick")), w && a && (null == $ && ($ = E + m + T > r + o), !y && $) ? (y = !0, "static" === C.css("position") && C.css({
						position: "relative"
					}), i.css({
						position: "absolute",
						bottom: n,
						top: "auto"
					}).trigger("sticky_kit:bottom")) : void 0
				}, E = function() {
					return _(), $()
				}, b = function() {
					if (e.off("touchmove", $), e.off("scroll", $), e.off("resize", E), t(document.body).off("sticky_kit:recalc", E), i.off("sticky_kit:detach", b), i.removeData("sticky_kit"), i.css({
							position: "",
							bottom: "",
							top: "",
							width: ""
						}), C.position("position", ""), w) return null == c && ("left" !== g && "right" !== g || i.insertAfter(k), k.remove()), i.removeClass(f)
				}, e.on("touchmove", $), e.on("scroll", $), e.on("resize", E), t(document.body).on("sticky_kit:recalc", E), i.on("sticky_kit:detach", b), setTimeout($, 0)
			}, r = 0, d = this.length; r < d; r++) n = this[r], o(t(n));
		return this
	}
}.call(this),
	function(t) {
		"function" == typeof define && define.amd ? define(["jquery"], t) : t("object" == typeof exports ? require("jquery") : jQuery)
	}(function(t) {
		var e = function() {
				if (t && t.fn && t.fn.select2 && t.fn.select2.amd) var e = t.fn.select2.amd;
				return function() {
					var t, i, s;
					e && e.requirejs || (e ? i = e : e = {}, function(e) {
						function n(t, e) {
							return b.call(t, e)
						}

						function a(t, e) {
							var i, s, n, a, o, r, l, d, c, h, u, p = e && e.split("/"),
								f = v.map,
								m = f && f["*"] || {};
							if (t && "." === t.charAt(0))
								if (e) {
									for (o = (t = t.split("/")).length - 1, v.nodeIdCompat && S.test(t[o]) && (t[o] = t[o].replace(S, "")), t = p.slice(0, p.length - 1).concat(t), c = 0; c < t.length; c += 1)
										if ("." === (u = t[c])) t.splice(c, 1), c -= 1;
										else if (".." === u) {
										if (1 === c && (".." === t[2] || ".." === t[0])) break;
										c > 0 && (t.splice(c - 1, 2), c -= 2)
									}
									t = t.join("/")
								} else 0 === t.indexOf("./") && (t = t.substring(2));
							if ((p || m) && f) {
								for (c = (i = t.split("/")).length; c > 0; c -= 1) {
									if (s = i.slice(0, c).join("/"), p)
										for (h = p.length; h > 0; h -= 1)
											if ((n = f[p.slice(0, h).join("/")]) && (n = n[s])) {
												a = n, r = c;
												break
											} if (a) break;
									!l && m && m[s] && (l = m[s], d = c)
								}!a && l && (a = l, r = d), a && (i.splice(0, r, a), t = i.join("/"))
							}
							return t
						}

						function o(t, i) {
							return function() {
								var s = w.call(arguments, 0);
								return "string" != typeof s[0] && 1 === s.length && s.push(null), u.apply(e, s.concat([t, i]))
							}
						}

						function r(t) {
							return function(e) {
								m[t] = e
							}
						}

						function l(t) {
							if (n(g, t)) {
								var i = g[t];
								delete g[t], y[t] = !0, h.apply(e, i)
							}
							if (!n(m, t) && !n(y, t)) throw new Error("No " + t);
							return m[t]
						}

						function d(t) {
							var e, i = t ? t.indexOf("!") : -1;
							return i > -1 && (e = t.substring(0, i), t = t.substring(i + 1, t.length)), [e, t]
						}

						function c(t) {
							return function() {
								return v && v.config && v.config[t] || {}
							}
						}
						var h, u, p, f, m = {},
							g = {},
							v = {},
							y = {},
							b = Object.prototype.hasOwnProperty,
							w = [].slice,
							S = /\.js$/;
						p = function(t, e) {
							var i, s = d(t),
								n = s[0];
							return t = s[1], n && (i = l(n = a(n, e))), n ? t = i && i.normalize ? i.normalize(t, function(t) {
								return function(e) {
									return a(e, t)
								}
							}(e)) : a(t, e) : (n = (s = d(t = a(t, e)))[0], t = s[1], n && (i = l(n))), {
								f: n ? n + "!" + t : t,
								n: t,
								pr: n,
								p: i
							}
						}, f = {
							require: function(t) {
								return o(t)
							},
							exports: function(t) {
								var e = m[t];
								return void 0 !== e ? e : m[t] = {}
							},
							module: function(t) {
								return {
									id: t,
									uri: "",
									exports: m[t],
									config: c(t)
								}
							}
						}, h = function(t, i, s, a) {
							var d, c, h, u, v, b, w = [],
								S = typeof s;
							if (a = a || t, "undefined" === S || "function" === S) {
								for (i = !i.length && s.length ? ["require", "exports", "module"] : i, v = 0; v < i.length; v += 1)
									if ("require" === (c = (u = p(i[v], a)).f)) w[v] = f.require(t);
									else if ("exports" === c) w[v] = f.exports(t), b = !0;
								else if ("module" === c) d = w[v] = f.module(t);
								else if (n(m, c) || n(g, c) || n(y, c)) w[v] = l(c);
								else {
									if (!u.p) throw new Error(t + " missing " + c);
									u.p.load(u.n, o(a, !0), r(c), {}), w[v] = m[c]
								}
								h = s ? s.apply(m[t], w) : void 0, t && (d && d.exports !== e && d.exports !== m[t] ? m[t] = d.exports : h === e && b || (m[t] = h))
							} else t && (m[t] = s)
						}, t = i = u = function(t, i, s, n, a) {
							if ("string" == typeof t) return f[t] ? f[t](i) : l(p(t, i).f);
							if (!t.splice) {
								if ((v = t).deps && u(v.deps, v.callback), !i) return;
								i.splice ? (t = i, i = s, s = null) : t = e
							}
							return i = i || function() {}, "function" == typeof s && (s = n, n = a), n ? h(e, t, i, s) : setTimeout(function() {
								h(e, t, i, s)
							}, 4), u
						}, u.config = function(t) {
							return u(t)
						}, t._defined = m, (s = function(t, e, i) {
							if ("string" != typeof t) throw new Error("See almond README: incorrect module build, no module name");
							e.splice || (i = e, e = []), n(m, t) || n(g, t) || (g[t] = [t, e, i])
						}).amd = {
							jQuery: !0
						}
					}(), e.requirejs = t, e.require = i, e.define = s)
				}(), e.define("almond", function() {}), e.define("jquery", [], function() {
					var e = t || $;
					return null == e && console && console.error && console.error("Select2: An instance of jQuery or a jQuery-compatible library was not found. Make sure that you are including jQuery before Select2 on your web page."), e
				}), e.define("select2/utils", ["jquery"], function(t) {
					function e(t) {
						var e = t.prototype,
							i = [];
						for (var s in e) {
							"function" == typeof e[s] && "constructor" !== s && i.push(s)
						}
						return i
					}
					var i = {
							Extend: function(t, e) {
								function i() {
									this.constructor = t
								}
								var s = {}.hasOwnProperty;
								for (var n in e) s.call(e, n) && (t[n] = e[n]);
								return i.prototype = e.prototype, t.prototype = new i, t.__super__ = e.prototype, t
							},
							Decorate: function(t, i) {
								function s() {
									var e = Array.prototype.unshift,
										s = i.prototype.constructor.length,
										n = t.prototype.constructor;
									s > 0 && (e.call(arguments, t.prototype.constructor), n = i.prototype.constructor), n.apply(this, arguments)
								}
								var n = e(i),
									a = e(t);
								i.displayName = t.displayName, s.prototype = new function() {
									this.constructor = s
								};
								for (var o = 0; o < a.length; o++) {
									var r = a[o];
									s.prototype[r] = t.prototype[r]
								}
								for (var l = function(t) {
										var e = function() {};
										t in s.prototype && (e = s.prototype[t]);
										var n = i.prototype[t];
										return function() {
											return Array.prototype.unshift.call(arguments, e), n.apply(this, arguments)
										}
									}, d = 0; d < n.length; d++) {
									var c = n[d];
									s.prototype[c] = l(c)
								}
								return s
							}
						},
						s = function() {
							this.listeners = {}
						};
					return s.prototype.on = function(t, e) {
						this.listeners = this.listeners || {}, t in this.listeners ? this.listeners[t].push(e) : this.listeners[t] = [e]
					}, s.prototype.trigger = function(t) {
						var e = Array.prototype.slice,
							i = e.call(arguments, 1);
						this.listeners = this.listeners || {}, null == i && (i = []), 0 === i.length && i.push({}), i[0]._type = t, t in this.listeners && this.invoke(this.listeners[t], e.call(arguments, 1)), "*" in this.listeners && this.invoke(this.listeners["*"], arguments)
					}, s.prototype.invoke = function(t, e) {
						for (var i = 0, s = t.length; s > i; i++) t[i].apply(this, e)
					}, i.Observable = s, i.generateChars = function(t) {
						for (var e = "", i = 0; t > i; i++) {
							e += Math.floor(36 * Math.random()).toString(36)
						}
						return e
					}, i.bind = function(t, e) {
						return function() {
							t.apply(e, arguments)
						}
					}, i._convertData = function(t) {
						for (var e in t) {
							var i = e.split("-"),
								s = t;
							if (1 !== i.length) {
								for (var n = 0; n < i.length; n++) {
									var a = i[n];
									(a = a.substring(0, 1).toLowerCase() + a.substring(1)) in s || (s[a] = {}), n == i.length - 1 && (s[a] = t[e]), s = s[a]
								}
								delete t[e]
							}
						}
						return t
					}, i.hasScroll = function(e, i) {
						var s = t(i),
							n = i.style.overflowX,
							a = i.style.overflowY;
						return (n !== a || "hidden" !== a && "visible" !== a) && ("scroll" === n || "scroll" === a || (s.innerHeight() < i.scrollHeight || s.innerWidth() < i.scrollWidth))
					}, i.escapeMarkup = function(t) {
						var e = {
							"\\": "&#92;",
							"&": "&amp;",
							"<": "&lt;",
							">": "&gt;",
							'"': "&quot;",
							"'": "&#39;",
							"/": "&#47;"
						};
						return "string" != typeof t ? t : String(t).replace(/[&<>"'\/\\]/g, function(t) {
							return e[t]
						})
					}, i.appendMany = function(e, i) {
						if ("1.7" === t.fn.jquery.substr(0, 3)) {
							var s = t();
							t.map(i, function(t) {
								s = s.add(t)
							}), i = s
						}
						e.append(i)
					}, i
				}), e.define("select2/results", ["jquery", "./utils"], function(t, e) {
					function i(t, e, s) {
						this.$element = t, this.data = s, this.options = e, i.__super__.constructor.call(this)
					}
					return e.Extend(i, e.Observable), i.prototype.render = function() {
						var e = t('<ul class="select2-results__options" role="tree"></ul>');
						return this.options.get("multiple") && e.attr("aria-multiselectable", "true"), this.$results = e, e
					}, i.prototype.clear = function() {
						this.$results.empty()
					}, i.prototype.displayMessage = function(e) {
						var i = this.options.get("escapeMarkup");
						this.clear(), this.hideLoading();
						var s = t('<li role="treeitem" aria-live="assertive" class="select2-results__option"></li>'),
							n = this.options.get("translations").get(e.message);
						s.append(i(n(e.args))), s[0].className += " select2-results__message", this.$results.append(s)
					}, i.prototype.hideMessages = function() {
						this.$results.find(".select2-results__message").remove()
					}, i.prototype.append = function(t) {
						this.hideLoading();
						var e = [];
						if (null != t.results && 0 !== t.results.length) {
							t.results = this.sort(t.results);
							for (var i = 0; i < t.results.length; i++) {
								var s = t.results[i],
									n = this.option(s);
								e.push(n)
							}
							this.$results.append(e)
						} else 0 === this.$results.children().length && this.trigger("results:message", {
							message: "noResults"
						})
					}, i.prototype.position = function(t, e) {
						e.find(".select2-results").append(t)
					}, i.prototype.sort = function(t) {
						return this.options.get("sorter")(t)
					}, i.prototype.highlightFirstItem = function() {
						var t = this.$results.find(".select2-results__option[aria-selected]"),
							e = t.filter("[aria-selected=true]");
						e.length > 0 ? e.first().trigger("mouseenter") : t.first().trigger("mouseenter"), this.ensureHighlightVisible()
					}, i.prototype.setClasses = function() {
						var e = this;
						this.data.current(function(i) {
							var s = t.map(i, function(t) {
								return t.id.toString()
							});
							e.$results.find(".select2-results__option[aria-selected]").each(function() {
								var e = t(this),
									i = t.data(this, "data"),
									n = "" + i.id;
								null != i.element && i.element.selected || null == i.element && t.inArray(n, s) > -1 ? e.attr("aria-selected", "true") : e.attr("aria-selected", "false")
							})
						})
					}, i.prototype.showLoading = function(t) {
						this.hideLoading();
						var e = {
								disabled: !0,
								loading: !0,
								text: this.options.get("translations").get("searching")(t)
							},
							i = this.option(e);
						i.className += " loading-results", this.$results.prepend(i)
					}, i.prototype.hideLoading = function() {
						this.$results.find(".loading-results").remove()
					}, i.prototype.option = function(e) {
						var i = document.createElement("li");
						i.className = "select2-results__option";
						var s = {
							role: "treeitem",
							"aria-selected": "false"
						};
						for (var n in e.disabled && (delete s["aria-selected"], s["aria-disabled"] = "true"), null == e.id && delete s["aria-selected"], null != e._resultId && (i.id = e._resultId), e.title && (i.title = e.title), e.children && (s.role = "group", s["aria-label"] = e.text, delete s["aria-selected"]), s) {
							var a = s[n];
							i.setAttribute(n, a)
						}
						if (e.children) {
							var o = t(i),
								r = document.createElement("strong");
							r.className = "select2-results__group", t(r), this.template(e, r);
							for (var l = [], d = 0; d < e.children.length; d++) {
								var c = e.children[d],
									h = this.option(c);
								l.push(h)
							}
							var u = t("<ul></ul>", {
								class: "select2-results__options select2-results__options--nested"
							});
							u.append(l), o.append(r), o.append(u)
						} else this.template(e, i);
						return t.data(i, "data", e), i
					}, i.prototype.bind = function(e, i) {
						var s = this,
							n = e.id + "-results";
						this.$results.attr("id", n), e.on("results:all", function(t) {
							s.clear(), s.append(t.data), e.isOpen() && (s.setClasses(), s.highlightFirstItem())
						}), e.on("results:append", function(t) {
							s.append(t.data), e.isOpen() && s.setClasses()
						}), e.on("query", function(t) {
							s.hideMessages(), s.showLoading(t)
						}), e.on("select", function() {
							e.isOpen() && (s.setClasses(), s.highlightFirstItem())
						}), e.on("unselect", function() {
							e.isOpen() && (s.setClasses(), s.highlightFirstItem())
						}), e.on("open", function() {
							s.$results.attr("aria-expanded", "true"), s.$results.attr("aria-hidden", "false"), s.setClasses(), s.ensureHighlightVisible()
						}), e.on("close", function() {
							s.$results.attr("aria-expanded", "false"), s.$results.attr("aria-hidden", "true"), s.$results.removeAttr("aria-activedescendant")
						}), e.on("results:toggle", function() {
							var t = s.getHighlightedResults();
							0 !== t.length && t.trigger("mouseup")
						}), e.on("results:select", function() {
							var t = s.getHighlightedResults();
							if (0 !== t.length) {
								var e = t.data("data");
								"true" == t.attr("aria-selected") ? s.trigger("close", {}) : s.trigger("select", {
									data: e
								})
							}
						}), e.on("results:previous", function() {
							var t = s.getHighlightedResults(),
								e = s.$results.find("[aria-selected]"),
								i = e.index(t);
							if (0 !== i) {
								var n = i - 1;
								0 === t.length && (n = 0);
								var a = e.eq(n);
								a.trigger("mouseenter");
								var o = s.$results.offset().top,
									r = a.offset().top,
									l = s.$results.scrollTop() + (r - o);
								0 === n ? s.$results.scrollTop(0) : 0 > r - o && s.$results.scrollTop(l)
							}
						}), e.on("results:next", function() {
							var t = s.getHighlightedResults(),
								e = s.$results.find("[aria-selected]"),
								i = e.index(t) + 1;
							if (!(i >= e.length)) {
								var n = e.eq(i);
								n.trigger("mouseenter");
								var a = s.$results.offset().top + s.$results.outerHeight(!1),
									o = n.offset().top + n.outerHeight(!1),
									r = s.$results.scrollTop() + o - a;
								0 === i ? s.$results.scrollTop(0) : o > a && s.$results.scrollTop(r)
							}
						}), e.on("results:focus", function(t) {
							t.element.addClass("select2-results__option--highlighted")
						}), e.on("results:message", function(t) {
							s.displayMessage(t)
						}), t.fn.mousewheel && this.$results.on("mousewheel", function(t) {
							var e = s.$results.scrollTop(),
								i = s.$results.get(0).scrollHeight - e + t.deltaY,
								n = t.deltaY > 0 && e - t.deltaY <= 0,
								a = t.deltaY < 0 && i <= s.$results.height();
							n ? (s.$results.scrollTop(0), t.preventDefault(), t.stopPropagation()) : a && (s.$results.scrollTop(s.$results.get(0).scrollHeight - s.$results.height()), t.preventDefault(), t.stopPropagation())
						}), this.$results.on("mouseup", ".select2-results__option[aria-selected]", function(e) {
							var i = t(this),
								n = i.data("data");
							return "true" === i.attr("aria-selected") ? void(s.options.get("multiple") ? s.trigger("unselect", {
								originalEvent: e,
								data: n
							}) : s.trigger("close", {})) : void s.trigger("select", {
								originalEvent: e,
								data: n
							})
						}), this.$results.on("mouseenter", ".select2-results__option[aria-selected]", function(e) {
							var i = t(this).data("data");
							s.getHighlightedResults().removeClass("select2-results__option--highlighted"), s.trigger("results:focus", {
								data: i,
								element: t(this)
							})
						})
					}, i.prototype.getHighlightedResults = function() {
						return this.$results.find(".select2-results__option--highlighted")
					}, i.prototype.destroy = function() {
						this.$results.remove()
					}, i.prototype.ensureHighlightVisible = function() {
						var t = this.getHighlightedResults();
						if (0 !== t.length) {
							var e = this.$results.find("[aria-selected]").index(t),
								i = this.$results.offset().top,
								s = t.offset().top,
								n = this.$results.scrollTop() + (s - i),
								a = s - i;
							n -= 2 * t.outerHeight(!1), 2 >= e ? this.$results.scrollTop(0) : (a > this.$results.outerHeight() || 0 > a) && this.$results.scrollTop(n)
						}
					}, i.prototype.template = function(e, i) {
						var s = this.options.get("templateResult"),
							n = this.options.get("escapeMarkup"),
							a = s(e, i);
						null == a ? i.style.display = "none" : "string" == typeof a ? i.innerHTML = n(a) : t(i).append(a)
					}, i
				}), e.define("select2/keys", [], function() {
					return {
						BACKSPACE: 8,
						TAB: 9,
						ENTER: 13,
						SHIFT: 16,
						CTRL: 17,
						ALT: 18,
						ESC: 27,
						SPACE: 32,
						PAGE_UP: 33,
						PAGE_DOWN: 34,
						END: 35,
						HOME: 36,
						LEFT: 37,
						UP: 38,
						RIGHT: 39,
						DOWN: 40,
						DELETE: 46
					}
				}), e.define("select2/selection/base", ["jquery", "../utils", "../keys"], function(t, e, i) {
					function s(t, e) {
						this.$element = t, this.options = e, s.__super__.constructor.call(this)
					}
					return e.Extend(s, e.Observable), s.prototype.render = function() {
						var e = t('<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>');
						return this._tabindex = 0, null != this.$element.data("old-tabindex") ? this._tabindex = this.$element.data("old-tabindex") : null != this.$element.attr("tabindex") && (this._tabindex = this.$element.attr("tabindex")), e.attr("title", this.$element.attr("title")), e.attr("tabindex", this._tabindex), this.$selection = e, e
					}, s.prototype.bind = function(t, e) {
						var s = this,
							n = (t.id, t.id + "-results");
						this.container = t, this.$selection.on("focus", function(t) {
							s.trigger("focus", t)
						}), this.$selection.on("blur", function(t) {
							s._handleBlur(t)
						}), this.$selection.on("keydown", function(t) {
							s.trigger("keypress", t), t.which === i.SPACE && t.preventDefault()
						}), t.on("results:focus", function(t) {
							s.$selection.attr("aria-activedescendant", t.data._resultId)
						}), t.on("selection:update", function(t) {
							s.update(t.data)
						}), t.on("open", function() {
							s.$selection.attr("aria-expanded", "true"), s.$selection.attr("aria-owns", n), s._attachCloseHandler(t)
						}), t.on("close", function() {
							s.$selection.attr("aria-expanded", "false"), s.$selection.removeAttr("aria-activedescendant"), s.$selection.removeAttr("aria-owns"), s.$selection.focus(), s._detachCloseHandler(t)
						}), t.on("enable", function() {
							s.$selection.attr("tabindex", s._tabindex)
						}), t.on("disable", function() {
							s.$selection.attr("tabindex", "-1")
						})
					}, s.prototype._handleBlur = function(e) {
						var i = this;
						window.setTimeout(function() {
							document.activeElement == i.$selection[0] || t.contains(i.$selection[0], document.activeElement) || i.trigger("blur", e)
						}, 1)
					}, s.prototype._attachCloseHandler = function(e) {
						t(document.body).on("mousedown.select2." + e.id, function(e) {
							var i = t(e.target).closest(".select2");
							t(".select2.select2-container--open").each(function() {
								var e = t(this);
								this != i[0] && e.data("element").select2("close")
							})
						})
					}, s.prototype._detachCloseHandler = function(e) {
						t(document.body).off("mousedown.select2." + e.id)
					}, s.prototype.position = function(t, e) {
						e.find(".selection").append(t)
					}, s.prototype.destroy = function() {
						this._detachCloseHandler(this.container)
					}, s.prototype.update = function(t) {
						throw new Error("The `update` method must be defined in child classes.")
					}, s
				}), e.define("select2/selection/single", ["jquery", "./base", "../utils", "../keys"], function(t, e, i, s) {
					function n() {
						n.__super__.constructor.apply(this, arguments)
					}
					return i.Extend(n, e), n.prototype.render = function() {
						var t = n.__super__.render.call(this);
						return t.addClass("select2-selection--single"), t.html('<span class="select2-selection__rendered"></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>'), t
					}, n.prototype.bind = function(t, e) {
						var i = this;
						n.__super__.bind.apply(this, arguments);
						var s = t.id + "-container";
						this.$selection.find(".select2-selection__rendered").attr("id", s), this.$selection.attr("aria-labelledby", s), this.$selection.on("mousedown", function(t) {
							1 === t.which && i.trigger("toggle", {
								originalEvent: t
							})
						}), this.$selection.on("focus", function(t) {}), this.$selection.on("blur", function(t) {}), t.on("focus", function(e) {
							t.isOpen() || i.$selection.focus()
						}), t.on("selection:update", function(t) {
							i.update(t.data)
						})
					}, n.prototype.clear = function() {
						this.$selection.find(".select2-selection__rendered").empty()
					}, n.prototype.display = function(t, e) {
						var i = this.options.get("templateSelection");
						return this.options.get("escapeMarkup")(i(t, e))
					}, n.prototype.selectionContainer = function() {
						return t("<span></span>")
					}, n.prototype.update = function(t) {
						if (0 !== t.length) {
							var e = t[0],
								i = this.$selection.find(".select2-selection__rendered"),
								s = this.display(e, i);
							i.empty().append(s), i.prop("title", e.title || e.text)
						} else this.clear()
					}, n
				}), e.define("select2/selection/multiple", ["jquery", "./base", "../utils"], function(t, e, i) {
					function s(t, e) {
						s.__super__.constructor.apply(this, arguments)
					}
					return i.Extend(s, e), s.prototype.render = function() {
						var t = s.__super__.render.call(this);
						return t.addClass("select2-selection--multiple"), t.html('<ul class="select2-selection__rendered"></ul>'), t
					}, s.prototype.bind = function(e, i) {
						var n = this;
						s.__super__.bind.apply(this, arguments), this.$selection.on("click", function(t) {
							n.trigger("toggle", {
								originalEvent: t
							})
						}), this.$selection.on("click", ".select2-selection__choice__remove", function(e) {
							if (!n.options.get("disabled")) {
								var i = t(this).parent().data("data");
								n.trigger("unselect", {
									originalEvent: e,
									data: i
								})
							}
						})
					}, s.prototype.clear = function() {
						this.$selection.find(".select2-selection__rendered").empty()
					}, s.prototype.display = function(t, e) {
						var i = this.options.get("templateSelection");
						return this.options.get("escapeMarkup")(i(t, e))
					}, s.prototype.selectionContainer = function() {
						return t('<li class="select2-selection__choice"><span class="select2-selection__choice__remove" role="presentation">&times;</span></li>')
					}, s.prototype.update = function(t) {
						if (this.clear(), 0 !== t.length) {
							for (var e = [], s = 0; s < t.length; s++) {
								var n = t[s],
									a = this.selectionContainer(),
									o = this.display(n, a);
								a.append(o), a.prop("title", n.title || n.text), a.data("data", n), e.push(a)
							}
							var r = this.$selection.find(".select2-selection__rendered");
							i.appendMany(r, e)
						}
					}, s
				}), e.define("select2/selection/placeholder", ["../utils"], function(t) {
					function e(t, e, i) {
						this.placeholder = this.normalizePlaceholder(i.get("placeholder")), t.call(this, e, i)
					}
					return e.prototype.normalizePlaceholder = function(t, e) {
						return "string" == typeof e && (e = {
							id: "",
							text: e
						}), e
					}, e.prototype.createPlaceholder = function(t, e) {
						var i = this.selectionContainer();
						return i.html(this.display(e)), i.addClass("select2-selection__placeholder").removeClass("select2-selection__choice"), i
					}, e.prototype.update = function(t, e) {
						var i = 1 == e.length && e[0].id != this.placeholder.id;
						if (e.length > 1 || i) return t.call(this, e);
						this.clear();
						var s = this.createPlaceholder(this.placeholder);
						this.$selection.find(".select2-selection__rendered").append(s)
					}, e
				}), e.define("select2/selection/allowClear", ["jquery", "../keys"], function(t, e) {
					function i() {}
					return i.prototype.bind = function(t, e, i) {
						var s = this;
						t.call(this, e, i), null == this.placeholder && this.options.get("debug") && window.console && console.error && console.error("Select2: The `allowClear` option should be used in combination with the `placeholder` option."), this.$selection.on("mousedown", ".select2-selection__clear", function(t) {
							s._handleClear(t)
						}), e.on("keypress", function(t) {
							s._handleKeyboardClear(t, e)
						})
					}, i.prototype._handleClear = function(t, e) {
						if (!this.options.get("disabled")) {
							var i = this.$selection.find(".select2-selection__clear");
							if (0 !== i.length) {
								e.stopPropagation();
								for (var s = i.data("data"), n = 0; n < s.length; n++) {
									var a = {
										data: s[n]
									};
									if (this.trigger("unselect", a), a.prevented) return
								}
								this.$element.val(this.placeholder.id).trigger("change"), this.trigger("toggle", {})
							}
						}
					}, i.prototype._handleKeyboardClear = function(t, i, s) {
						s.isOpen() || (i.which == e.DELETE || i.which == e.BACKSPACE) && this._handleClear(i)
					}, i.prototype.update = function(e, i) {
						if (e.call(this, i), !(this.$selection.find(".select2-selection__placeholder").length > 0 || 0 === i.length)) {
							var s = t('<span class="select2-selection__clear">&times;</span>');
							s.data("data", i), this.$selection.find(".select2-selection__rendered").prepend(s)
						}
					}, i
				}), e.define("select2/selection/search", ["jquery", "../utils", "../keys"], function(t, e, i) {
					function s(t, e, i) {
						t.call(this, e, i)
					}
					return s.prototype.render = function(e) {
						var i = t('<li class="select2-search select2-search--inline"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" role="textbox" aria-autocomplete="list" /></li>');
						this.$searchContainer = i, this.$search = i.find("input");
						var s = e.call(this);
						return this._transferTabIndex(), s
					}, s.prototype.bind = function(t, e, s) {
						var n = this;
						t.call(this, e, s), e.on("open", function() {
							n.$search.trigger("focus")
						}), e.on("close", function() {
							n.$search.val(""), n.$search.removeAttr("aria-activedescendant"), n.$search.trigger("focus")
						}), e.on("enable", function() {
							n.$search.prop("disabled", !1), n._transferTabIndex()
						}), e.on("disable", function() {
							n.$search.prop("disabled", !0)
						}), e.on("focus", function(t) {
							n.$search.trigger("focus")
						}), e.on("results:focus", function(t) {
							n.$search.attr("aria-activedescendant", t.id)
						}), this.$selection.on("focusin", ".select2-search--inline", function(t) {
							n.trigger("focus", t)
						}), this.$selection.on("focusout", ".select2-search--inline", function(t) {
							n._handleBlur(t)
						}), this.$selection.on("keydown", ".select2-search--inline", function(t) {
							if (t.stopPropagation(), n.trigger("keypress", t), n._keyUpPrevented = t.isDefaultPrevented(), t.which === i.BACKSPACE && "" === n.$search.val()) {
								var e = n.$searchContainer.prev(".select2-selection__choice");
								if (e.length > 0) {
									var s = e.data("data");
									n.searchRemoveChoice(s), t.preventDefault()
								}
							}
						});
						var a = document.documentMode,
							o = a && 11 >= a;
						this.$selection.on("input.searchcheck", ".select2-search--inline", function(t) {
							return o ? void n.$selection.off("input.search input.searchcheck") : void n.$selection.off("keyup.search")
						}), this.$selection.on("keyup.search input.search", ".select2-search--inline", function(t) {
							if (o && "input" === t.type) n.$selection.off("input.search input.searchcheck");
							else {
								var e = t.which;
								e != i.SHIFT && e != i.CTRL && e != i.ALT && e != i.TAB && n.handleSearch(t)
							}
						})
					}, s.prototype._transferTabIndex = function(t) {
						this.$search.attr("tabindex", this.$selection.attr("tabindex")), this.$selection.attr("tabindex", "-1")
					}, s.prototype.createPlaceholder = function(t, e) {
						this.$search.attr("placeholder", e.text)
					}, s.prototype.update = function(t, e) {
						var i = this.$search[0] == document.activeElement;
						this.$search.attr("placeholder", ""), t.call(this, e), this.$selection.find(".select2-selection__rendered").append(this.$searchContainer), this.resizeSearch(), i && this.$search.focus()
					}, s.prototype.handleSearch = function() {
						if (this.resizeSearch(), !this._keyUpPrevented) {
							var t = this.$search.val();
							this.trigger("query", {
								term: t
							})
						}
						this._keyUpPrevented = !1
					}, s.prototype.searchRemoveChoice = function(t, e) {
						this.trigger("unselect", {
							data: e
						}), this.$search.val(e.text), this.handleSearch()
					}, s.prototype.resizeSearch = function() {
						this.$search.css("width", "25px");
						var t = "";
						"" !== this.$search.attr("placeholder") ? t = this.$selection.find(".select2-selection__rendered").innerWidth() : t = .75 * (this.$search.val().length + 1) + "em";
						this.$search.css("width", t)
					}, s
				}), e.define("select2/selection/eventRelay", ["jquery"], function(t) {
					function e() {}
					return e.prototype.bind = function(e, i, s) {
						var n = this,
							a = ["open", "opening", "close", "closing", "select", "selecting", "unselect", "unselecting"],
							o = ["opening", "closing", "selecting", "unselecting"];
						e.call(this, i, s), i.on("*", function(e, i) {
							if (-1 !== t.inArray(e, a)) {
								i = i || {};
								var s = t.Event("select2:" + e, {
									params: i
								});
								n.$element.trigger(s), -1 !== t.inArray(e, o) && (i.prevented = s.isDefaultPrevented())
							}
						})
					}, e
				}), e.define("select2/translation", ["jquery", "require"], function(t, e) {
					function i(t) {
						this.dict = t || {}
					}
					return i.prototype.all = function() {
						return this.dict
					}, i.prototype.get = function(t) {
						return this.dict[t]
					}, i.prototype.extend = function(e) {
						this.dict = t.extend({}, e.all(), this.dict)
					}, i._cache = {}, i.loadPath = function(t) {
						if (!(t in i._cache)) {
							var s = e(t);
							i._cache[t] = s
						}
						return new i(i._cache[t])
					}, i
				}), e.define("select2/diacritics", [], function() {
					return {
						"Ⓐ": "A",
						"Ａ": "A",
						"À": "A",
						"Á": "A",
						"Â": "A",
						"Ầ": "A",
						"Ấ": "A",
						"Ẫ": "A",
						"Ẩ": "A",
						"Ã": "A",
						"Ā": "A",
						"Ă": "A",
						"Ằ": "A",
						"Ắ": "A",
						"Ẵ": "A",
						"Ẳ": "A",
						"Ȧ": "A",
						"Ǡ": "A",
						"Ä": "A",
						"Ǟ": "A",
						"Ả": "A",
						"Å": "A",
						"Ǻ": "A",
						"Ǎ": "A",
						"Ȁ": "A",
						"Ȃ": "A",
						"Ạ": "A",
						"Ậ": "A",
						"Ặ": "A",
						"Ḁ": "A",
						"Ą": "A",
						"Ⱥ": "A",
						"Ɐ": "A",
						"Ꜳ": "AA",
						"Æ": "AE",
						"Ǽ": "AE",
						"Ǣ": "AE",
						"Ꜵ": "AO",
						"Ꜷ": "AU",
						"Ꜹ": "AV",
						"Ꜻ": "AV",
						"Ꜽ": "AY",
						"Ⓑ": "B",
						"Ｂ": "B",
						"Ḃ": "B",
						"Ḅ": "B",
						"Ḇ": "B",
						"Ƀ": "B",
						"Ƃ": "B",
						"Ɓ": "B",
						"Ⓒ": "C",
						"Ｃ": "C",
						"Ć": "C",
						"Ĉ": "C",
						"Ċ": "C",
						"Č": "C",
						"Ç": "C",
						"Ḉ": "C",
						"Ƈ": "C",
						"Ȼ": "C",
						"Ꜿ": "C",
						"Ⓓ": "D",
						"Ｄ": "D",
						"Ḋ": "D",
						"Ď": "D",
						"Ḍ": "D",
						"Ḑ": "D",
						"Ḓ": "D",
						"Ḏ": "D",
						"Đ": "D",
						"Ƌ": "D",
						"Ɗ": "D",
						"Ɖ": "D",
						"Ꝺ": "D",
						"Ǳ": "DZ",
						"Ǆ": "DZ",
						"ǲ": "Dz",
						"ǅ": "Dz",
						"Ⓔ": "E",
						"Ｅ": "E",
						"È": "E",
						"É": "E",
						"Ê": "E",
						"Ề": "E",
						"Ế": "E",
						"Ễ": "E",
						"Ể": "E",
						"Ẽ": "E",
						"Ē": "E",
						"Ḕ": "E",
						"Ḗ": "E",
						"Ĕ": "E",
						"Ė": "E",
						"Ë": "E",
						"Ẻ": "E",
						"Ě": "E",
						"Ȅ": "E",
						"Ȇ": "E",
						"Ẹ": "E",
						"Ệ": "E",
						"Ȩ": "E",
						"Ḝ": "E",
						"Ę": "E",
						"Ḙ": "E",
						"Ḛ": "E",
						"Ɛ": "E",
						"Ǝ": "E",
						"Ⓕ": "F",
						"Ｆ": "F",
						"Ḟ": "F",
						"Ƒ": "F",
						"Ꝼ": "F",
						"Ⓖ": "G",
						"Ｇ": "G",
						"Ǵ": "G",
						"Ĝ": "G",
						"Ḡ": "G",
						"Ğ": "G",
						"Ġ": "G",
						"Ǧ": "G",
						"Ģ": "G",
						"Ǥ": "G",
						"Ɠ": "G",
						"Ꞡ": "G",
						"Ᵹ": "G",
						"Ꝿ": "G",
						"Ⓗ": "H",
						"Ｈ": "H",
						"Ĥ": "H",
						"Ḣ": "H",
						"Ḧ": "H",
						"Ȟ": "H",
						"Ḥ": "H",
						"Ḩ": "H",
						"Ḫ": "H",
						"Ħ": "H",
						"Ⱨ": "H",
						"Ⱶ": "H",
						"Ɥ": "H",
						"Ⓘ": "I",
						"Ｉ": "I",
						"Ì": "I",
						"Í": "I",
						"Î": "I",
						"Ĩ": "I",
						"Ī": "I",
						"Ĭ": "I",
						"İ": "I",
						"Ï": "I",
						"Ḯ": "I",
						"Ỉ": "I",
						"Ǐ": "I",
						"Ȉ": "I",
						"Ȋ": "I",
						"Ị": "I",
						"Į": "I",
						"Ḭ": "I",
						"Ɨ": "I",
						"Ⓙ": "J",
						"Ｊ": "J",
						"Ĵ": "J",
						"Ɉ": "J",
						"Ⓚ": "K",
						"Ｋ": "K",
						"Ḱ": "K",
						"Ǩ": "K",
						"Ḳ": "K",
						"Ķ": "K",
						"Ḵ": "K",
						"Ƙ": "K",
						"Ⱪ": "K",
						"Ꝁ": "K",
						"Ꝃ": "K",
						"Ꝅ": "K",
						"Ꞣ": "K",
						"Ⓛ": "L",
						"Ｌ": "L",
						"Ŀ": "L",
						"Ĺ": "L",
						"Ľ": "L",
						"Ḷ": "L",
						"Ḹ": "L",
						"Ļ": "L",
						"Ḽ": "L",
						"Ḻ": "L",
						"Ł": "L",
						"Ƚ": "L",
						"Ɫ": "L",
						"Ⱡ": "L",
						"Ꝉ": "L",
						"Ꝇ": "L",
						"Ꞁ": "L",
						"Ǉ": "LJ",
						"ǈ": "Lj",
						"Ⓜ": "M",
						"Ｍ": "M",
						"Ḿ": "M",
						"Ṁ": "M",
						"Ṃ": "M",
						"Ɱ": "M",
						"Ɯ": "M",
						"Ⓝ": "N",
						"Ｎ": "N",
						"Ǹ": "N",
						"Ń": "N",
						"Ñ": "N",
						"Ṅ": "N",
						"Ň": "N",
						"Ṇ": "N",
						"Ņ": "N",
						"Ṋ": "N",
						"Ṉ": "N",
						"Ƞ": "N",
						"Ɲ": "N",
						"Ꞑ": "N",
						"Ꞥ": "N",
						"Ǌ": "NJ",
						"ǋ": "Nj",
						"Ⓞ": "O",
						"Ｏ": "O",
						"Ò": "O",
						"Ó": "O",
						"Ô": "O",
						"Ồ": "O",
						"Ố": "O",
						"Ỗ": "O",
						"Ổ": "O",
						"Õ": "O",
						"Ṍ": "O",
						"Ȭ": "O",
						"Ṏ": "O",
						"Ō": "O",
						"Ṑ": "O",
						"Ṓ": "O",
						"Ŏ": "O",
						"Ȯ": "O",
						"Ȱ": "O",
						"Ö": "O",
						"Ȫ": "O",
						"Ỏ": "O",
						"Ő": "O",
						"Ǒ": "O",
						"Ȍ": "O",
						"Ȏ": "O",
						"Ơ": "O",
						"Ờ": "O",
						"Ớ": "O",
						"Ỡ": "O",
						"Ở": "O",
						"Ợ": "O",
						"Ọ": "O",
						"Ộ": "O",
						"Ǫ": "O",
						"Ǭ": "O",
						"Ø": "O",
						"Ǿ": "O",
						"Ɔ": "O",
						"Ɵ": "O",
						"Ꝋ": "O",
						"Ꝍ": "O",
						"Ƣ": "OI",
						"Ꝏ": "OO",
						"Ȣ": "OU",
						"Ⓟ": "P",
						"Ｐ": "P",
						"Ṕ": "P",
						"Ṗ": "P",
						"Ƥ": "P",
						"Ᵽ": "P",
						"Ꝑ": "P",
						"Ꝓ": "P",
						"Ꝕ": "P",
						"Ⓠ": "Q",
						"Ｑ": "Q",
						"Ꝗ": "Q",
						"Ꝙ": "Q",
						"Ɋ": "Q",
						"Ⓡ": "R",
						"Ｒ": "R",
						"Ŕ": "R",
						"Ṙ": "R",
						"Ř": "R",
						"Ȑ": "R",
						"Ȓ": "R",
						"Ṛ": "R",
						"Ṝ": "R",
						"Ŗ": "R",
						"Ṟ": "R",
						"Ɍ": "R",
						"Ɽ": "R",
						"Ꝛ": "R",
						"Ꞧ": "R",
						"Ꞃ": "R",
						"Ⓢ": "S",
						"Ｓ": "S",
						"ẞ": "S",
						"Ś": "S",
						"Ṥ": "S",
						"Ŝ": "S",
						"Ṡ": "S",
						"Š": "S",
						"Ṧ": "S",
						"Ṣ": "S",
						"Ṩ": "S",
						"Ș": "S",
						"Ş": "S",
						"Ȿ": "S",
						"Ꞩ": "S",
						"Ꞅ": "S",
						"Ⓣ": "T",
						"Ｔ": "T",
						"Ṫ": "T",
						"Ť": "T",
						"Ṭ": "T",
						"Ț": "T",
						"Ţ": "T",
						"Ṱ": "T",
						"Ṯ": "T",
						"Ŧ": "T",
						"Ƭ": "T",
						"Ʈ": "T",
						"Ⱦ": "T",
						"Ꞇ": "T",
						"Ꜩ": "TZ",
						"Ⓤ": "U",
						"Ｕ": "U",
						"Ù": "U",
						"Ú": "U",
						"Û": "U",
						"Ũ": "U",
						"Ṹ": "U",
						"Ū": "U",
						"Ṻ": "U",
						"Ŭ": "U",
						"Ü": "U",
						"Ǜ": "U",
						"Ǘ": "U",
						"Ǖ": "U",
						"Ǚ": "U",
						"Ủ": "U",
						"Ů": "U",
						"Ű": "U",
						"Ǔ": "U",
						"Ȕ": "U",
						"Ȗ": "U",
						"Ư": "U",
						"Ừ": "U",
						"Ứ": "U",
						"Ữ": "U",
						"Ử": "U",
						"Ự": "U",
						"Ụ": "U",
						"Ṳ": "U",
						"Ų": "U",
						"Ṷ": "U",
						"Ṵ": "U",
						"Ʉ": "U",
						"Ⓥ": "V",
						"Ｖ": "V",
						"Ṽ": "V",
						"Ṿ": "V",
						"Ʋ": "V",
						"Ꝟ": "V",
						"Ʌ": "V",
						"Ꝡ": "VY",
						"Ⓦ": "W",
						"Ｗ": "W",
						"Ẁ": "W",
						"Ẃ": "W",
						"Ŵ": "W",
						"Ẇ": "W",
						"Ẅ": "W",
						"Ẉ": "W",
						"Ⱳ": "W",
						"Ⓧ": "X",
						"Ｘ": "X",
						"Ẋ": "X",
						"Ẍ": "X",
						"Ⓨ": "Y",
						"Ｙ": "Y",
						"Ỳ": "Y",
						"Ý": "Y",
						"Ŷ": "Y",
						"Ỹ": "Y",
						"Ȳ": "Y",
						"Ẏ": "Y",
						"Ÿ": "Y",
						"Ỷ": "Y",
						"Ỵ": "Y",
						"Ƴ": "Y",
						"Ɏ": "Y",
						"Ỿ": "Y",
						"Ⓩ": "Z",
						"Ｚ": "Z",
						"Ź": "Z",
						"Ẑ": "Z",
						"Ż": "Z",
						"Ž": "Z",
						"Ẓ": "Z",
						"Ẕ": "Z",
						"Ƶ": "Z",
						"Ȥ": "Z",
						"Ɀ": "Z",
						"Ⱬ": "Z",
						"Ꝣ": "Z",
						"ⓐ": "a",
						"ａ": "a",
						"ẚ": "a",
						"à": "a",
						"á": "a",
						"â": "a",
						"ầ": "a",
						"ấ": "a",
						"ẫ": "a",
						"ẩ": "a",
						"ã": "a",
						"ā": "a",
						"ă": "a",
						"ằ": "a",
						"ắ": "a",
						"ẵ": "a",
						"ẳ": "a",
						"ȧ": "a",
						"ǡ": "a",
						"ä": "a",
						"ǟ": "a",
						"ả": "a",
						"å": "a",
						"ǻ": "a",
						"ǎ": "a",
						"ȁ": "a",
						"ȃ": "a",
						"ạ": "a",
						"ậ": "a",
						"ặ": "a",
						"ḁ": "a",
						"ą": "a",
						"ⱥ": "a",
						"ɐ": "a",
						"ꜳ": "aa",
						"æ": "ae",
						"ǽ": "ae",
						"ǣ": "ae",
						"ꜵ": "ao",
						"ꜷ": "au",
						"ꜹ": "av",
						"ꜻ": "av",
						"ꜽ": "ay",
						"ⓑ": "b",
						"ｂ": "b",
						"ḃ": "b",
						"ḅ": "b",
						"ḇ": "b",
						"ƀ": "b",
						"ƃ": "b",
						"ɓ": "b",
						"ⓒ": "c",
						"ｃ": "c",
						"ć": "c",
						"ĉ": "c",
						"ċ": "c",
						"č": "c",
						"ç": "c",
						"ḉ": "c",
						"ƈ": "c",
						"ȼ": "c",
						"ꜿ": "c",
						"ↄ": "c",
						"ⓓ": "d",
						"ｄ": "d",
						"ḋ": "d",
						"ď": "d",
						"ḍ": "d",
						"ḑ": "d",
						"ḓ": "d",
						"ḏ": "d",
						"đ": "d",
						"ƌ": "d",
						"ɖ": "d",
						"ɗ": "d",
						"ꝺ": "d",
						"ǳ": "dz",
						"ǆ": "dz",
						"ⓔ": "e",
						"ｅ": "e",
						"è": "e",
						"é": "e",
						"ê": "e",
						"ề": "e",
						"ế": "e",
						"ễ": "e",
						"ể": "e",
						"ẽ": "e",
						"ē": "e",
						"ḕ": "e",
						"ḗ": "e",
						"ĕ": "e",
						"ė": "e",
						"ë": "e",
						"ẻ": "e",
						"ě": "e",
						"ȅ": "e",
						"ȇ": "e",
						"ẹ": "e",
						"ệ": "e",
						"ȩ": "e",
						"ḝ": "e",
						"ę": "e",
						"ḙ": "e",
						"ḛ": "e",
						"ɇ": "e",
						"ɛ": "e",
						"ǝ": "e",
						"ⓕ": "f",
						"ｆ": "f",
						"ḟ": "f",
						"ƒ": "f",
						"ꝼ": "f",
						"ⓖ": "g",
						"ｇ": "g",
						"ǵ": "g",
						"ĝ": "g",
						"ḡ": "g",
						"ğ": "g",
						"ġ": "g",
						"ǧ": "g",
						"ģ": "g",
						"ǥ": "g",
						"ɠ": "g",
						"ꞡ": "g",
						"ᵹ": "g",
						"ꝿ": "g",
						"ⓗ": "h",
						"ｈ": "h",
						"ĥ": "h",
						"ḣ": "h",
						"ḧ": "h",
						"ȟ": "h",
						"ḥ": "h",
						"ḩ": "h",
						"ḫ": "h",
						"ẖ": "h",
						"ħ": "h",
						"ⱨ": "h",
						"ⱶ": "h",
						"ɥ": "h",
						"ƕ": "hv",
						"ⓘ": "i",
						"ｉ": "i",
						"ì": "i",
						"í": "i",
						"î": "i",
						"ĩ": "i",
						"ī": "i",
						"ĭ": "i",
						"ï": "i",
						"ḯ": "i",
						"ỉ": "i",
						"ǐ": "i",
						"ȉ": "i",
						"ȋ": "i",
						"ị": "i",
						"į": "i",
						"ḭ": "i",
						"ɨ": "i",
						"ı": "i",
						"ⓙ": "j",
						"ｊ": "j",
						"ĵ": "j",
						"ǰ": "j",
						"ɉ": "j",
						"ⓚ": "k",
						"ｋ": "k",
						"ḱ": "k",
						"ǩ": "k",
						"ḳ": "k",
						"ķ": "k",
						"ḵ": "k",
						"ƙ": "k",
						"ⱪ": "k",
						"ꝁ": "k",
						"ꝃ": "k",
						"ꝅ": "k",
						"ꞣ": "k",
						"ⓛ": "l",
						"ｌ": "l",
						"ŀ": "l",
						"ĺ": "l",
						"ľ": "l",
						"ḷ": "l",
						"ḹ": "l",
						"ļ": "l",
						"ḽ": "l",
						"ḻ": "l",
						"ſ": "l",
						"ł": "l",
						"ƚ": "l",
						"ɫ": "l",
						"ⱡ": "l",
						"ꝉ": "l",
						"ꞁ": "l",
						"ꝇ": "l",
						"ǉ": "lj",
						"ⓜ": "m",
						"ｍ": "m",
						"ḿ": "m",
						"ṁ": "m",
						"ṃ": "m",
						"ɱ": "m",
						"ɯ": "m",
						"ⓝ": "n",
						"ｎ": "n",
						"ǹ": "n",
						"ń": "n",
						"ñ": "n",
						"ṅ": "n",
						"ň": "n",
						"ṇ": "n",
						"ņ": "n",
						"ṋ": "n",
						"ṉ": "n",
						"ƞ": "n",
						"ɲ": "n",
						"ŉ": "n",
						"ꞑ": "n",
						"ꞥ": "n",
						"ǌ": "nj",
						"ⓞ": "o",
						"ｏ": "o",
						"ò": "o",
						"ó": "o",
						"ô": "o",
						"ồ": "o",
						"ố": "o",
						"ỗ": "o",
						"ổ": "o",
						"õ": "o",
						"ṍ": "o",
						"ȭ": "o",
						"ṏ": "o",
						"ō": "o",
						"ṑ": "o",
						"ṓ": "o",
						"ŏ": "o",
						"ȯ": "o",
						"ȱ": "o",
						"ö": "o",
						"ȫ": "o",
						"ỏ": "o",
						"ő": "o",
						"ǒ": "o",
						"ȍ": "o",
						"ȏ": "o",
						"ơ": "o",
						"ờ": "o",
						"ớ": "o",
						"ỡ": "o",
						"ở": "o",
						"ợ": "o",
						"ọ": "o",
						"ộ": "o",
						"ǫ": "o",
						"ǭ": "o",
						"ø": "o",
						"ǿ": "o",
						"ɔ": "o",
						"ꝋ": "o",
						"ꝍ": "o",
						"ɵ": "o",
						"ƣ": "oi",
						"ȣ": "ou",
						"ꝏ": "oo",
						"ⓟ": "p",
						"ｐ": "p",
						"ṕ": "p",
						"ṗ": "p",
						"ƥ": "p",
						"ᵽ": "p",
						"ꝑ": "p",
						"ꝓ": "p",
						"ꝕ": "p",
						"ⓠ": "q",
						"ｑ": "q",
						"ɋ": "q",
						"ꝗ": "q",
						"ꝙ": "q",
						"ⓡ": "r",
						"ｒ": "r",
						"ŕ": "r",
						"ṙ": "r",
						"ř": "r",
						"ȑ": "r",
						"ȓ": "r",
						"ṛ": "r",
						"ṝ": "r",
						"ŗ": "r",
						"ṟ": "r",
						"ɍ": "r",
						"ɽ": "r",
						"ꝛ": "r",
						"ꞧ": "r",
						"ꞃ": "r",
						"ⓢ": "s",
						"ｓ": "s",
						"ß": "s",
						"ś": "s",
						"ṥ": "s",
						"ŝ": "s",
						"ṡ": "s",
						"š": "s",
						"ṧ": "s",
						"ṣ": "s",
						"ṩ": "s",
						"ș": "s",
						"ş": "s",
						"ȿ": "s",
						"ꞩ": "s",
						"ꞅ": "s",
						"ẛ": "s",
						"ⓣ": "t",
						"ｔ": "t",
						"ṫ": "t",
						"ẗ": "t",
						"ť": "t",
						"ṭ": "t",
						"ț": "t",
						"ţ": "t",
						"ṱ": "t",
						"ṯ": "t",
						"ŧ": "t",
						"ƭ": "t",
						"ʈ": "t",
						"ⱦ": "t",
						"ꞇ": "t",
						"ꜩ": "tz",
						"ⓤ": "u",
						"ｕ": "u",
						"ù": "u",
						"ú": "u",
						"û": "u",
						"ũ": "u",
						"ṹ": "u",
						"ū": "u",
						"ṻ": "u",
						"ŭ": "u",
						"ü": "u",
						"ǜ": "u",
						"ǘ": "u",
						"ǖ": "u",
						"ǚ": "u",
						"ủ": "u",
						"ů": "u",
						"ű": "u",
						"ǔ": "u",
						"ȕ": "u",
						"ȗ": "u",
						"ư": "u",
						"ừ": "u",
						"ứ": "u",
						"ữ": "u",
						"ử": "u",
						"ự": "u",
						"ụ": "u",
						"ṳ": "u",
						"ų": "u",
						"ṷ": "u",
						"ṵ": "u",
						"ʉ": "u",
						"ⓥ": "v",
						"ｖ": "v",
						"ṽ": "v",
						"ṿ": "v",
						"ʋ": "v",
						"ꝟ": "v",
						"ʌ": "v",
						"ꝡ": "vy",
						"ⓦ": "w",
						"ｗ": "w",
						"ẁ": "w",
						"ẃ": "w",
						"ŵ": "w",
						"ẇ": "w",
						"ẅ": "w",
						"ẘ": "w",
						"ẉ": "w",
						"ⱳ": "w",
						"ⓧ": "x",
						"ｘ": "x",
						"ẋ": "x",
						"ẍ": "x",
						"ⓨ": "y",
						"ｙ": "y",
						"ỳ": "y",
						"ý": "y",
						"ŷ": "y",
						"ỹ": "y",
						"ȳ": "y",
						"ẏ": "y",
						"ÿ": "y",
						"ỷ": "y",
						"ẙ": "y",
						"ỵ": "y",
						"ƴ": "y",
						"ɏ": "y",
						"ỿ": "y",
						"ⓩ": "z",
						"ｚ": "z",
						"ź": "z",
						"ẑ": "z",
						"ż": "z",
						"ž": "z",
						"ẓ": "z",
						"ẕ": "z",
						"ƶ": "z",
						"ȥ": "z",
						"ɀ": "z",
						"ⱬ": "z",
						"ꝣ": "z",
						"Ά": "Α",
						"Έ": "Ε",
						"Ή": "Η",
						"Ί": "Ι",
						"Ϊ": "Ι",
						"Ό": "Ο",
						"Ύ": "Υ",
						"Ϋ": "Υ",
						"Ώ": "Ω",
						"ά": "α",
						"έ": "ε",
						"ή": "η",
						"ί": "ι",
						"ϊ": "ι",
						"ΐ": "ι",
						"ό": "ο",
						"ύ": "υ",
						"ϋ": "υ",
						"ΰ": "υ",
						"ω": "ω",
						"ς": "σ"
					}
				}), e.define("select2/data/base", ["../utils"], function(t) {
					function e(t, i) {
						e.__super__.constructor.call(this)
					}
					return t.Extend(e, t.Observable), e.prototype.current = function(t) {
						throw new Error("The `current` method must be defined in child classes.")
					}, e.prototype.query = function(t, e) {
						throw new Error("The `query` method must be defined in child classes.")
					}, e.prototype.bind = function(t, e) {}, e.prototype.destroy = function() {}, e.prototype.generateResultId = function(e, i) {
						var s = e.id + "-result-";
						return (s += t.generateChars(4)) + (null != i.id ? "-" + i.id.toString() : "-" + t.generateChars(4))
					}, e
				}), e.define("select2/data/select", ["./base", "../utils", "jquery"], function(t, e, i) {
					function s(t, e) {
						this.$element = t, this.options = e, s.__super__.constructor.call(this)
					}
					return e.Extend(s, t), s.prototype.current = function(t) {
						var e = [],
							s = this;
						this.$element.find(":selected").each(function() {
							var t = i(this),
								n = s.item(t);
							e.push(n)
						}), t(e)
					}, s.prototype.select = function(t) {
						var e = this;
						if (t.selected = !0, i(t.element).is("option")) return t.element.selected = !0, void this.$element.trigger("change");
						if (this.$element.prop("multiple")) this.current(function(s) {
							var n = [];
							(t = [t]).push.apply(t, s);
							for (var a = 0; a < t.length; a++) {
								var o = t[a].id; - 1 === i.inArray(o, n) && n.push(o)
							}
							e.$element.val(n), e.$element.trigger("change")
						});
						else {
							var s = t.id;
							this.$element.val(s), this.$element.trigger("change")
						}
					}, s.prototype.unselect = function(t) {
						var e = this;
						if (this.$element.prop("multiple")) return t.selected = !1, i(t.element).is("option") ? (t.element.selected = !1, void this.$element.trigger("change")) : void this.current(function(s) {
							for (var n = [], a = 0; a < s.length; a++) {
								var o = s[a].id;
								o !== t.id && -1 === i.inArray(o, n) && n.push(o)
							}
							e.$element.val(n), e.$element.trigger("change")
						})
					}, s.prototype.bind = function(t, e) {
						var i = this;
						this.container = t, t.on("select", function(t) {
							i.select(t.data)
						}), t.on("unselect", function(t) {
							i.unselect(t.data)
						})
					}, s.prototype.destroy = function() {
						this.$element.find("*").each(function() {
							i.removeData(this, "data")
						})
					}, s.prototype.query = function(t, e) {
						var s = [],
							n = this;
						this.$element.children().each(function() {
							var e = i(this);
							if (e.is("option") || e.is("optgroup")) {
								var a = n.item(e),
									o = n.matches(t, a);
								null !== o && s.push(o)
							}
						}), e({
							results: s
						})
					}, s.prototype.addOptions = function(t) {
						e.appendMany(this.$element, t)
					}, s.prototype.option = function(t) {
						var e;
						t.children ? (e = document.createElement("optgroup")).label = t.text : void 0 !== (e = document.createElement("option")).textContent ? e.textContent = t.text : e.innerText = t.text, t.id && (e.value = t.id), t.disabled && (e.disabled = !0), t.selected && (e.selected = !0), t.title && (e.title = t.title);
						var s = i(e),
							n = this._normalizeItem(t);
						return n.element = e, i.data(e, "data", n), s
					}, s.prototype.item = function(t) {
						var e = {};
						if (null != (e = i.data(t[0], "data"))) return e;
						if (t.is("option")) e = {
							id: t.val(),
							text: t.text(),
							disabled: t.prop("disabled"),
							selected: t.prop("selected"),
							title: t.prop("title")
						};
						else if (t.is("optgroup")) {
							e = {
								text: t.prop("label"),
								children: [],
								title: t.prop("title")
							};
							for (var s = t.children("option"), n = [], a = 0; a < s.length; a++) {
								var o = i(s[a]),
									r = this.item(o);
								n.push(r)
							}
							e.children = n
						}
						return (e = this._normalizeItem(e)).element = t[0], i.data(t[0], "data", e), e
					}, s.prototype._normalizeItem = function(t) {
						i.isPlainObject(t) || (t = {
							id: t,
							text: t
						});
						return null != (t = i.extend({}, {
							text: ""
						}, t)).id && (t.id = t.id.toString()), null != t.text && (t.text = t.text.toString()), null == t._resultId && t.id && null != this.container && (t._resultId = this.generateResultId(this.container, t)), i.extend({}, {
							selected: !1,
							disabled: !1
						}, t)
					}, s.prototype.matches = function(t, e) {
						return this.options.get("matcher")(t, e)
					}, s
				}), e.define("select2/data/array", ["./select", "../utils", "jquery"], function(t, e, i) {
					function s(t, e) {
						var i = e.get("data") || [];
						s.__super__.constructor.call(this, t, e), this.addOptions(this.convertToOptions(i))
					}
					return e.Extend(s, t), s.prototype.select = function(t) {
						var e = this.$element.find("option").filter(function(e, i) {
							return i.value == t.id.toString()
						});
						0 === e.length && (e = this.option(t), this.addOptions(e)), s.__super__.select.call(this, t)
					}, s.prototype.convertToOptions = function(t) {
						function s(t) {
							return function() {
								return i(this).val() == t.id
							}
						}
						for (var n = this, a = this.$element.find("option"), o = a.map(function() {
								return n.item(i(this)).id
							}).get(), r = [], l = 0; l < t.length; l++) {
							var d = this._normalizeItem(t[l]);
							if (i.inArray(d.id, o) >= 0) {
								var c = a.filter(s(d)),
									h = this.item(c),
									u = i.extend(!0, {}, d, h),
									p = this.option(u);
								c.replaceWith(p)
							} else {
								var f = this.option(d);
								if (d.children) {
									var m = this.convertToOptions(d.children);
									e.appendMany(f, m)
								}
								r.push(f)
							}
						}
						return r
					}, s
				}), e.define("select2/data/ajax", ["./array", "../utils", "jquery"], function(t, e, i) {
					function s(t, e) {
						this.ajaxOptions = this._applyDefaults(e.get("ajax")), null != this.ajaxOptions.processResults && (this.processResults = this.ajaxOptions.processResults), s.__super__.constructor.call(this, t, e)
					}
					return e.Extend(s, t), s.prototype._applyDefaults = function(t) {
						var e = {
							data: function(t) {
								return i.extend({}, t, {
									q: t.term
								})
							},
							transport: function(t, e, s) {
								var n = i.ajax(t);
								return n.then(e), n.fail(s), n
							}
						};
						return i.extend({}, e, t, !0)
					}, s.prototype.processResults = function(t) {
						return t
					}, s.prototype.query = function(t, e) {
						function s() {
							var s = a.transport(a, function(s) {
								var a = n.processResults(s, t);
								n.options.get("debug") && window.console && console.error && (a && a.results && i.isArray(a.results) || console.error("Select2: The AJAX results did not return an array in the `results` key of the response.")), e(a)
							}, function() {
								s.status && "0" === s.status || n.trigger("results:message", {
									message: "errorLoading"
								})
							});
							n._request = s
						}
						var n = this;
						null != this._request && (i.isFunction(this._request.abort) && this._request.abort(), this._request = null);
						var a = i.extend({
							type: "GET"
						}, this.ajaxOptions);
						"function" == typeof a.url && (a.url = a.url.call(this.$element, t)), "function" == typeof a.data && (a.data = a.data.call(this.$element, t)), this.ajaxOptions.delay && null != t.term ? (this._queryTimeout && window.clearTimeout(this._queryTimeout), this._queryTimeout = window.setTimeout(s, this.ajaxOptions.delay)) : s()
					}, s
				}), e.define("select2/data/tags", ["jquery"], function(t) {
					function e(e, i, s) {
						var n = s.get("tags"),
							a = s.get("createTag");
						void 0 !== a && (this.createTag = a);
						var o = s.get("insertTag");
						if (void 0 !== o && (this.insertTag = o), e.call(this, i, s), t.isArray(n))
							for (var r = 0; r < n.length; r++) {
								var l = n[r],
									d = this._normalizeItem(l),
									c = this.option(d);
								this.$element.append(c)
							}
					}
					return e.prototype.query = function(t, e, i) {
						var s = this;
						return this._removeOldTags(), null == e.term || null != e.page ? void t.call(this, e, i) : void t.call(this, e, function t(n, a) {
							for (var o = n.results, r = 0; r < o.length; r++) {
								var l = o[r],
									d = null != l.children && !t({
										results: l.children
									}, !0);
								if (l.text === e.term || d) return !a && (n.data = o, void i(n))
							}
							if (a) return !0;
							var c = s.createTag(e);
							if (null != c) {
								var h = s.option(c);
								h.attr("data-select2-tag", !0), s.addOptions([h]), s.insertTag(o, c)
							}
							n.results = o, i(n)
						})
					}, e.prototype.createTag = function(e, i) {
						var s = t.trim(i.term);
						return "" === s ? null : {
							id: s,
							text: s
						}
					}, e.prototype.insertTag = function(t, e, i) {
						e.unshift(i)
					}, e.prototype._removeOldTags = function(e) {
						(this._lastTag, this.$element.find("option[data-select2-tag]")).each(function() {
							this.selected || t(this).remove()
						})
					}, e
				}), e.define("select2/data/tokenizer", ["jquery"], function(t) {
					function e(t, e, i) {
						var s = i.get("tokenizer");
						void 0 !== s && (this.tokenizer = s), t.call(this, e, i)
					}
					return e.prototype.bind = function(t, e, i) {
						t.call(this, e, i), this.$search = e.dropdown.$search || e.selection.$search || i.find(".select2-search__field")
					}, e.prototype.query = function(e, i, s) {
						var n = this;
						i.term = i.term || "";
						var a = this.tokenizer(i, this.options, function(e) {
							var i = n._normalizeItem(e);
							if (!n.$element.find("option").filter(function() {
									return t(this).val() === i.id
								}).length) {
								var s = n.option(i);
								s.attr("data-select2-tag", !0), n._removeOldTags(), n.addOptions([s])
							}! function(t) {
								n.trigger("select", {
									data: t
								})
							}(i)
						});
						a.term !== i.term && (this.$search.length && (this.$search.val(a.term), this.$search.focus()), i.term = a.term), e.call(this, i, s)
					}, e.prototype.tokenizer = function(e, i, s, n) {
						for (var a = s.get("tokenSeparators") || [], o = i.term, r = 0, l = this.createTag || function(t) {
								return {
									id: t.term,
									text: t.term
								}
							}; r < o.length;) {
							var d = o[r];
							if (-1 !== t.inArray(d, a)) {
								var c = o.substr(0, r),
									h = l(t.extend({}, i, {
										term: c
									}));
								null != h ? (n(h), o = o.substr(r + 1) || "", r = 0) : r++
							} else r++
						}
						return {
							term: o
						}
					}, e
				}), e.define("select2/data/minimumInputLength", [], function() {
					function t(t, e, i) {
						this.minimumInputLength = i.get("minimumInputLength"), t.call(this, e, i)
					}
					return t.prototype.query = function(t, e, i) {
						return e.term = e.term || "", e.term.length < this.minimumInputLength ? void this.trigger("results:message", {
							message: "inputTooShort",
							args: {
								minimum: this.minimumInputLength,
								input: e.term,
								params: e
							}
						}) : void t.call(this, e, i)
					}, t
				}), e.define("select2/data/maximumInputLength", [], function() {
					function t(t, e, i) {
						this.maximumInputLength = i.get("maximumInputLength"), t.call(this, e, i)
					}
					return t.prototype.query = function(t, e, i) {
						return e.term = e.term || "", this.maximumInputLength > 0 && e.term.length > this.maximumInputLength ? void this.trigger("results:message", {
							message: "inputTooLong",
							args: {
								maximum: this.maximumInputLength,
								input: e.term,
								params: e
							}
						}) : void t.call(this, e, i)
					}, t
				}), e.define("select2/data/maximumSelectionLength", [], function() {
					function t(t, e, i) {
						this.maximumSelectionLength = i.get("maximumSelectionLength"), t.call(this, e, i)
					}
					return t.prototype.query = function(t, e, i) {
						var s = this;
						this.current(function(n) {
							var a = null != n ? n.length : 0;
							return s.maximumSelectionLength > 0 && a >= s.maximumSelectionLength ? void s.trigger("results:message", {
								message: "maximumSelected",
								args: {
									maximum: s.maximumSelectionLength
								}
							}) : void t.call(s, e, i)
						})
					}, t
				}), e.define("select2/dropdown", ["jquery", "./utils"], function(t, e) {
					function i(t, e) {
						this.$element = t, this.options = e, i.__super__.constructor.call(this)
					}
					return e.Extend(i, e.Observable), i.prototype.render = function() {
						var e = t('<span class="select2-dropdown"><span class="select2-results"></span></span>');
						return e.attr("dir", this.options.get("dir")), this.$dropdown = e, e
					}, i.prototype.bind = function() {}, i.prototype.position = function(t, e) {}, i.prototype.destroy = function() {
						this.$dropdown.remove()
					}, i
				}), e.define("select2/dropdown/search", ["jquery", "../utils"], function(t, e) {
					function i() {}
					return i.prototype.render = function(e) {
						var i = e.call(this),
							s = t('<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" role="textbox" /></span>');
						return this.$searchContainer = s, this.$search = s.find("input"), i.prepend(s), i
					}, i.prototype.bind = function(e, i, s) {
						var n = this;
						e.call(this, i, s), this.$search.on("keydown", function(t) {
							n.trigger("keypress", t), n._keyUpPrevented = t.isDefaultPrevented()
						}), this.$search.on("input", function(e) {
							t(this).off("keyup")
						}), this.$search.on("keyup input", function(t) {
							n.handleSearch(t)
						}), i.on("open", function() {
							n.$search.attr("tabindex", 0), n.$search.focus(), window.setTimeout(function() {
								n.$search.focus()
							}, 0)
						}), i.on("close", function() {
							n.$search.attr("tabindex", -1), n.$search.val("")
						}), i.on("focus", function() {
							i.isOpen() && n.$search.focus()
						}), i.on("results:all", function(t) {
							null != t.query.term && "" !== t.query.term || (n.showSearch(t) ? n.$searchContainer.removeClass("select2-search--hide") : n.$searchContainer.addClass("select2-search--hide"))
						})
					}, i.prototype.handleSearch = function(t) {
						if (!this._keyUpPrevented) {
							var e = this.$search.val();
							this.trigger("query", {
								term: e
							})
						}
						this._keyUpPrevented = !1
					}, i.prototype.showSearch = function(t, e) {
						return !0
					}, i
				}), e.define("select2/dropdown/hidePlaceholder", [], function() {
					function t(t, e, i, s) {
						this.placeholder = this.normalizePlaceholder(i.get("placeholder")), t.call(this, e, i, s)
					}
					return t.prototype.append = function(t, e) {
						e.results = this.removePlaceholder(e.results), t.call(this, e)
					}, t.prototype.normalizePlaceholder = function(t, e) {
						return "string" == typeof e && (e = {
							id: "",
							text: e
						}), e
					}, t.prototype.removePlaceholder = function(t, e) {
						for (var i = e.slice(0), s = e.length - 1; s >= 0; s--) {
							var n = e[s];
							this.placeholder.id === n.id && i.splice(s, 1)
						}
						return i
					}, t
				}), e.define("select2/dropdown/infiniteScroll", ["jquery"], function(t) {
					function e(t, e, i, s) {
						this.lastParams = {}, t.call(this, e, i, s), this.$loadingMore = this.createLoadingMore(), this.loading = !1
					}
					return e.prototype.append = function(t, e) {
						this.$loadingMore.remove(), this.loading = !1, t.call(this, e), this.showLoadingMore(e) && this.$results.append(this.$loadingMore)
					}, e.prototype.bind = function(e, i, s) {
						var n = this;
						e.call(this, i, s), i.on("query", function(t) {
							n.lastParams = t, n.loading = !0
						}), i.on("query:append", function(t) {
							n.lastParams = t, n.loading = !0
						}), this.$results.on("scroll", function() {
							var e = t.contains(document.documentElement, n.$loadingMore[0]);
							!n.loading && e && (n.$results.offset().top + n.$results.outerHeight(!1) + 50 >= n.$loadingMore.offset().top + n.$loadingMore.outerHeight(!1) && n.loadMore())
						})
					}, e.prototype.loadMore = function() {
						this.loading = !0;
						var e = t.extend({}, {
							page: 1
						}, this.lastParams);
						e.page++, this.trigger("query:append", e)
					}, e.prototype.showLoadingMore = function(t, e) {
						return e.pagination && e.pagination.more
					}, e.prototype.createLoadingMore = function() {
						var e = t('<li class="select2-results__option select2-results__option--load-more"role="treeitem" aria-disabled="true"></li>'),
							i = this.options.get("translations").get("loadingMore");
						return e.html(i(this.lastParams)), e
					}, e
				}), e.define("select2/dropdown/attachBody", ["jquery", "../utils"], function(t, e) {
					function i(e, i, s) {
						this.$dropdownParent = s.get("dropdownParent") || t(document.body), e.call(this, i, s)
					}
					return i.prototype.bind = function(t, e, i) {
						var s = this,
							n = !1;
						t.call(this, e, i), e.on("open", function() {
							s._showDropdown(), s._attachPositioningHandler(e), n || (n = !0, e.on("results:all", function() {
								s._positionDropdown(), s._resizeDropdown()
							}), e.on("results:append", function() {
								s._positionDropdown(), s._resizeDropdown()
							}))
						}), e.on("close", function() {
							s._hideDropdown(), s._detachPositioningHandler(e)
						}), this.$dropdownContainer.on("mousedown", function(t) {
							t.stopPropagation()
						})
					}, i.prototype.destroy = function(t) {
						t.call(this), this.$dropdownContainer.remove()
					}, i.prototype.position = function(t, e, i) {
						e.attr("class", i.attr("class")), e.removeClass("select2"), e.addClass("select2-container--open"), e.css({
							position: "absolute",
							top: -999999
						}), this.$container = i
					}, i.prototype.render = function(e) {
						var i = t("<span></span>"),
							s = e.call(this);
						return i.append(s), this.$dropdownContainer = i, i
					}, i.prototype._hideDropdown = function(t) {
						this.$dropdownContainer.detach()
					}, i.prototype._attachPositioningHandler = function(i, s) {
						var n = this,
							a = "scroll.select2." + s.id,
							o = "resize.select2." + s.id,
							r = "orientationchange.select2." + s.id,
							l = this.$container.parents().filter(e.hasScroll);
						l.each(function() {
							t(this).data("select2-scroll-position", {
								x: t(this).scrollLeft(),
								y: t(this).scrollTop()
							})
						}), l.on(a, function(e) {
							var i = t(this).data("select2-scroll-position");
							t(this).scrollTop(i.y)
						}), t(window).on(a + " " + o + " " + r, function(t) {
							n._positionDropdown(), n._resizeDropdown()
						})
					}, i.prototype._detachPositioningHandler = function(i, s) {
						var n = "scroll.select2." + s.id,
							a = "resize.select2." + s.id,
							o = "orientationchange.select2." + s.id;
						this.$container.parents().filter(e.hasScroll).off(n), t(window).off(n + " " + a + " " + o)
					}, i.prototype._positionDropdown = function() {
						var e = t(window),
							i = this.$dropdown.hasClass("select2-dropdown--above"),
							s = this.$dropdown.hasClass("select2-dropdown--below"),
							n = null,
							a = this.$container.offset();
						a.bottom = a.top + this.$container.outerHeight(!1);
						var o = {
							height: this.$container.outerHeight(!1)
						};
						o.top = a.top, o.bottom = a.top + o.height;
						var r = this.$dropdown.outerHeight(!1),
							l = (e.scrollTop(), e.scrollTop(), e.height(), {
								left: a.left,
								top: o.bottom
							}),
							d = this.$dropdownParent;
						"static" === d.css("position") && (d = d.offsetParent());
						var c = d.offset();
						l.top -= c.top, l.left -= c.left, i || s || (n = "below"), i && (n = "below"), ("above" == n || i && "below" !== n) && (l.top = o.top - c.top - r), null != n && (this.$dropdown.removeClass("select2-dropdown--below select2-dropdown--above").addClass("select2-dropdown--" + n), this.$container.removeClass("select2-container--below select2-container--above").addClass("select2-container--" + n)), this.$dropdownContainer.css(l)
					}, i.prototype._resizeDropdown = function() {
						var t = {
							width: this.$container.outerWidth(!1) + "px"
						};
						this.options.get("dropdownAutoWidth") && (t.minWidth = t.width, t.position = "relative", t.width = "auto"), this.$dropdown.css(t)
					}, i.prototype._showDropdown = function(t) {
						this.$dropdownContainer.appendTo(this.$dropdownParent), this._positionDropdown(), this._resizeDropdown()
					}, i
				}), e.define("select2/dropdown/minimumResultsForSearch", [], function() {
					function t(t, e, i, s) {
						this.minimumResultsForSearch = i.get("minimumResultsForSearch"), this.minimumResultsForSearch < 0 && (this.minimumResultsForSearch = 1 / 0), t.call(this, e, i, s)
					}
					return t.prototype.showSearch = function(t, e) {
						return !(function t(e) {
							for (var i = 0, s = 0; s < e.length; s++) {
								var n = e[s];
								n.children ? i += t(n.children) : i++
							}
							return i
						}(e.data.results) < this.minimumResultsForSearch) && t.call(this, e)
					}, t
				}), e.define("select2/dropdown/selectOnClose", [], function() {
					function t() {}
					return t.prototype.bind = function(t, e, i) {
						var s = this;
						t.call(this, e, i), e.on("close", function(t) {
							s._handleSelectOnClose(t)
						})
					}, t.prototype._handleSelectOnClose = function(t, e) {
						if (e && null != e.originalSelect2Event) {
							var i = e.originalSelect2Event;
							if ("select" === i._type || "unselect" === i._type) return
						}
						var s = this.getHighlightedResults();
						if (!(s.length < 1)) {
							var n = s.data("data");
							null != n.element && n.element.selected || null == n.element && n.selected || this.trigger("select", {
								data: n
							})
						}
					}, t
				}), e.define("select2/dropdown/closeOnSelect", [], function() {
					function t() {}
					return t.prototype.bind = function(t, e, i) {
						var s = this;
						t.call(this, e, i), e.on("select", function(t) {
							s._selectTriggered(t)
						}), e.on("unselect", function(t) {
							s._selectTriggered(t)
						})
					}, t.prototype._selectTriggered = function(t, e) {
						var i = e.originalEvent;
						i && i.ctrlKey || this.trigger("close", {
							originalEvent: i,
							originalSelect2Event: e
						})
					}, t
				}), e.define("select2/i18n/en", [], function() {
					return {
						errorLoading: function() {
							return "The results could not be loaded."
						},
						inputTooLong: function(t) {
							var e = t.input.length - t.maximum,
								i = "Please delete " + e + " character";
							return 1 != e && (i += "s"), i
						},
						inputTooShort: function(t) {
							return "Please enter " + (t.minimum - t.input.length) + " or more characters"
						},
						loadingMore: function() {
							return "Loading more results…"
						},
						maximumSelected: function(t) {
							var e = "You can only select " + t.maximum + " item";
							return 1 != t.maximum && (e += "s"), e
						},
						noResults: function() {
							return "No results found"
						},
						searching: function() {
							return "Searching…"
						}
					}
				}), e.define("select2/defaults", ["jquery", "require", "./results", "./selection/single", "./selection/multiple", "./selection/placeholder", "./selection/allowClear", "./selection/search", "./selection/eventRelay", "./utils", "./translation", "./diacritics", "./data/select", "./data/array", "./data/ajax", "./data/tags", "./data/tokenizer", "./data/minimumInputLength", "./data/maximumInputLength", "./data/maximumSelectionLength", "./dropdown", "./dropdown/search", "./dropdown/hidePlaceholder", "./dropdown/infiniteScroll", "./dropdown/attachBody", "./dropdown/minimumResultsForSearch", "./dropdown/selectOnClose", "./dropdown/closeOnSelect", "./i18n/en"], function(t, e, i, s, n, a, o, r, l, d, c, h, u, p, f, m, g, v, y, b, w, S, x, T, C, _, E, P, k) {
					function $() {
						this.reset()
					}
					return $.prototype.apply = function(h) {
						if (null == (h = t.extend(!0, {}, this.defaults, h)).dataAdapter) {
							if (null != h.ajax ? h.dataAdapter = f : null != h.data ? h.dataAdapter = p : h.dataAdapter = u, h.minimumInputLength > 0 && (h.dataAdapter = d.Decorate(h.dataAdapter, v)), h.maximumInputLength > 0 && (h.dataAdapter = d.Decorate(h.dataAdapter, y)), h.maximumSelectionLength > 0 && (h.dataAdapter = d.Decorate(h.dataAdapter, b)), h.tags && (h.dataAdapter = d.Decorate(h.dataAdapter, m)), (null != h.tokenSeparators || null != h.tokenizer) && (h.dataAdapter = d.Decorate(h.dataAdapter, g)), null != h.query) {
								var k = e(h.amdBase + "compat/query");
								h.dataAdapter = d.Decorate(h.dataAdapter, k)
							}
							if (null != h.initSelection) {
								var $ = e(h.amdBase + "compat/initSelection");
								h.dataAdapter = d.Decorate(h.dataAdapter, $)
							}
						}
						if (null == h.resultsAdapter && (h.resultsAdapter = i, null != h.ajax && (h.resultsAdapter = d.Decorate(h.resultsAdapter, T)), null != h.placeholder && (h.resultsAdapter = d.Decorate(h.resultsAdapter, x)), h.selectOnClose && (h.resultsAdapter = d.Decorate(h.resultsAdapter, E))), null == h.dropdownAdapter) {
							if (h.multiple) h.dropdownAdapter = w;
							else {
								var M = d.Decorate(w, S);
								h.dropdownAdapter = M
							}
							if (0 !== h.minimumResultsForSearch && (h.dropdownAdapter = d.Decorate(h.dropdownAdapter, _)), h.closeOnSelect && (h.dropdownAdapter = d.Decorate(h.dropdownAdapter, P)), null != h.dropdownCssClass || null != h.dropdownCss || null != h.adaptDropdownCssClass) {
								var D = e(h.amdBase + "compat/dropdownCss");
								h.dropdownAdapter = d.Decorate(h.dropdownAdapter, D)
							}
							h.dropdownAdapter = d.Decorate(h.dropdownAdapter, C)
						}
						if (null == h.selectionAdapter) {
							if (h.multiple ? h.selectionAdapter = n : h.selectionAdapter = s, null != h.placeholder && (h.selectionAdapter = d.Decorate(h.selectionAdapter, a)), h.allowClear && (h.selectionAdapter = d.Decorate(h.selectionAdapter, o)), h.multiple && (h.selectionAdapter = d.Decorate(h.selectionAdapter, r)), null != h.containerCssClass || null != h.containerCss || null != h.adaptContainerCssClass) {
								var O = e(h.amdBase + "compat/containerCss");
								h.selectionAdapter = d.Decorate(h.selectionAdapter, O)
							}
							h.selectionAdapter = d.Decorate(h.selectionAdapter, l)
						}
						if ("string" == typeof h.language)
							if (h.language.indexOf("-") > 0) {
								var z = h.language.split("-")[0];
								h.language = [h.language, z]
							} else h.language = [h.language];
						if (t.isArray(h.language)) {
							var A = new c;
							h.language.push("en");
							for (var I = h.language, L = 0; L < I.length; L++) {
								var N = I[L],
									Y = {};
								try {
									Y = c.loadPath(N)
								} catch (t) {
									try {
										N = this.defaults.amdLanguageBase + N, Y = c.loadPath(N)
									} catch (t) {
										h.debug && window.console && console.warn && console.warn('Select2: The language file for "' + N + '" could not be automatically loaded. A fallback will be used instead.');
										continue
									}
								}
								A.extend(Y)
							}
							h.translations = A
						} else {
							var R = c.loadPath(this.defaults.amdLanguageBase + "en"),
								j = new c(h.language);
							j.extend(R), h.translations = j
						}
						return h
					}, $.prototype.reset = function() {
						function e(t) {
							return t.replace(/[^\u0000-\u007E]/g, function(t) {
								return h[t] || t
							})
						}
						this.defaults = {
							amdBase: "./",
							amdLanguageBase: "./i18n/",
							closeOnSelect: !0,
							debug: !1,
							dropdownAutoWidth: !1,
							escapeMarkup: d.escapeMarkup,
							language: k,
							matcher: function i(s, n) {
								if ("" === t.trim(s.term)) return n;
								if (n.children && n.children.length > 0) {
									for (var a = t.extend(!0, {}, n), o = n.children.length - 1; o >= 0; o--) null == i(s, n.children[o]) && a.children.splice(o, 1);
									return a.children.length > 0 ? a : i(s, a)
								}
								var r = e(n.text).toUpperCase(),
									l = e(s.term).toUpperCase();
								return r.indexOf(l) > -1 ? n : null
							},
							minimumInputLength: 0,
							maximumInputLength: 0,
							maximumSelectionLength: 0,
							minimumResultsForSearch: 0,
							selectOnClose: !1,
							sorter: function(t) {
								return t
							},
							templateResult: function(t) {
								return t.text
							},
							templateSelection: function(t) {
								return t.text
							},
							theme: "default",
							width: "resolve"
						}
					}, $.prototype.set = function(e, i) {
						var s = {};
						s[t.camelCase(e)] = i;
						var n = d._convertData(s);
						t.extend(this.defaults, n)
					}, new $
				}), e.define("select2/options", ["require", "jquery", "./defaults", "./utils"], function(t, e, i, s) {
					function n(e, n) {
						if (this.options = e, null != n && this.fromElement(n), this.options = i.apply(this.options), n && n.is("input")) {
							var a = t(this.get("amdBase") + "compat/inputData");
							this.options.dataAdapter = s.Decorate(this.options.dataAdapter, a)
						}
					}
					return n.prototype.fromElement = function(t) {
						var i = ["select2"];
						null == this.options.multiple && (this.options.multiple = t.prop("multiple")), null == this.options.disabled && (this.options.disabled = t.prop("disabled")), null == this.options.language && (t.prop("lang") ? this.options.language = t.prop("lang").toLowerCase() : t.closest("[lang]").prop("lang") && (this.options.language = t.closest("[lang]").prop("lang"))), null == this.options.dir && (t.prop("dir") ? this.options.dir = t.prop("dir") : t.closest("[dir]").prop("dir") ? this.options.dir = t.closest("[dir]").prop("dir") : this.options.dir = "ltr"), t.prop("disabled", this.options.disabled), t.prop("multiple", this.options.multiple), t.data("select2Tags") && (this.options.debug && window.console && console.warn && console.warn('Select2: The `data-select2-tags` attribute has been changed to use the `data-data` and `data-tags="true"` attributes and will be removed in future versions of Select2.'), t.data("data", t.data("select2Tags")), t.data("tags", !0)), t.data("ajaxUrl") && (this.options.debug && window.console && console.warn && console.warn("Select2: The `data-ajax-url` attribute has been changed to `data-ajax--url` and support for the old attribute will be removed in future versions of Select2."), t.attr("ajax--url", t.data("ajaxUrl")), t.data("ajax--url", t.data("ajaxUrl")));
						var n;
						n = e.fn.jquery && "1." == e.fn.jquery.substr(0, 2) && t[0].dataset ? e.extend(!0, {}, t[0].dataset, t.data()) : t.data();
						var a = e.extend(!0, {}, n);
						for (var o in a = s._convertData(a)) e.inArray(o, i) > -1 || (e.isPlainObject(this.options[o]) ? e.extend(this.options[o], a[o]) : this.options[o] = a[o]);
						return this
					}, n.prototype.get = function(t) {
						return this.options[t]
					}, n.prototype.set = function(t, e) {
						this.options[t] = e
					}, n
				}), e.define("select2/core", ["jquery", "./options", "./utils", "./keys"], function(t, e, i, s) {
					var n = function(t, i) {
						null != t.data("select2") && t.data("select2").destroy(), this.$element = t, this.id = this._generateId(t), i = i || {}, this.options = new e(i, t), n.__super__.constructor.call(this);
						var s = t.attr("tabindex") || 0;
						t.data("old-tabindex", s), t.attr("tabindex", "-1");
						var a = this.options.get("dataAdapter");
						this.dataAdapter = new a(t, this.options);
						var o = this.render();
						this._placeContainer(o);
						var r = this.options.get("selectionAdapter");
						this.selection = new r(t, this.options), this.$selection = this.selection.render(), this.selection.position(this.$selection, o);
						var l = this.options.get("dropdownAdapter");
						this.dropdown = new l(t, this.options), this.$dropdown = this.dropdown.render(), this.dropdown.position(this.$dropdown, o);
						var d = this.options.get("resultsAdapter");
						this.results = new d(t, this.options, this.dataAdapter), this.$results = this.results.render(), this.results.position(this.$results, this.$dropdown);
						var c = this;
						this._bindAdapters(), this._registerDomEvents(), this._registerDataEvents(), this._registerSelectionEvents(), this._registerDropdownEvents(), this._registerResultsEvents(), this._registerEvents(), this.dataAdapter.current(function(t) {
							c.trigger("selection:update", {
								data: t
							})
						}), t.addClass("select2-hidden-accessible"), t.attr("aria-hidden", "true"), this._syncAttributes(), t.data("select2", this)
					};
					return i.Extend(n, i.Observable), n.prototype._generateId = function(t) {
						return "select2-" + (null != t.attr("id") ? t.attr("id") : null != t.attr("name") ? t.attr("name") + "-" + i.generateChars(2) : i.generateChars(4)).replace(/(:|\.|\[|\]|,)/g, "")
					}, n.prototype._placeContainer = function(t) {
						t.insertAfter(this.$element);
						var e = this._resolveWidth(this.$element, this.options.get("width"));
						null != e && t.css("width", e), "auto" != e && t.css("width", "+=30")
					}, n.prototype._resolveWidth = function(t, e) {
						var i = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
						if ("resolve" == e) {
							var s = this._resolveWidth(t, "style");
							return null != s ? s : this._resolveWidth(t, "element")
						}
						if ("element" == e) {
							var n = t.outerWidth(!1);
							return 0 >= n ? "auto" : n + "px"
						}
						if ("style" == e) {
							var a = t.attr("style");
							if ("string" != typeof a) return null;
							for (var o = a.split(";"), r = 0, l = o.length; l > r; r += 1) {
								var d = o[r].replace(/\s/g, "").match(i);
								if (null !== d && d.length >= 1) return d[1]
							}
							return null
						}
						return e
					}, n.prototype._bindAdapters = function() {
						this.dataAdapter.bind(this, this.$container), this.selection.bind(this, this.$container), this.dropdown.bind(this, this.$container), this.results.bind(this, this.$container)
					}, n.prototype._registerDomEvents = function() {
						var e = this;
						this.$element.on("change.select2", function() {
							e.dataAdapter.current(function(t) {
								e.trigger("selection:update", {
									data: t
								})
							})
						}), this.$element.on("focus.select2", function(t) {
							e.trigger("focus", t)
						}), this._syncA = i.bind(this._syncAttributes, this), this._syncS = i.bind(this._syncSubtree, this), this.$element[0].attachEvent && this.$element[0].attachEvent("onpropertychange", this._syncA);
						var s = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
						null != s ? (this._observer = new s(function(i) {
							t.each(i, e._syncA), t.each(i, e._syncS)
						}), this._observer.observe(this.$element[0], {
							attributes: !0,
							childList: !0,
							subtree: !1
						})) : this.$element[0].addEventListener && (this.$element[0].addEventListener("DOMAttrModified", e._syncA, !1), this.$element[0].addEventListener("DOMNodeInserted", e._syncS, !1), this.$element[0].addEventListener("DOMNodeRemoved", e._syncS, !1))
					}, n.prototype._registerDataEvents = function() {
						var t = this;
						this.dataAdapter.on("*", function(e, i) {
							t.trigger(e, i)
						})
					}, n.prototype._registerSelectionEvents = function() {
						var e = this,
							i = ["toggle", "focus"];
						this.selection.on("toggle", function() {
							e.toggleDropdown()
						}), this.selection.on("focus", function(t) {
							e.focus(t)
						}), this.selection.on("*", function(s, n) {
							-1 === t.inArray(s, i) && e.trigger(s, n)
						})
					}, n.prototype._registerDropdownEvents = function() {
						var t = this;
						this.dropdown.on("*", function(e, i) {
							t.trigger(e, i)
						})
					}, n.prototype._registerResultsEvents = function() {
						var t = this;
						this.results.on("*", function(e, i) {
							t.trigger(e, i)
						})
					}, n.prototype._registerEvents = function() {
						var t = this;
						this.on("open", function() {
							t.$container.addClass("select2-container--open")
						}), this.on("close", function() {
							t.$container.removeClass("select2-container--open")
						}), this.on("enable", function() {
							t.$container.removeClass("select2-container--disabled")
						}), this.on("disable", function() {
							t.$container.addClass("select2-container--disabled")
						}), this.on("blur", function() {
							t.$container.removeClass("select2-container--focus")
						}), this.on("query", function(e) {
							t.isOpen() || t.trigger("open", {}), this.dataAdapter.query(e, function(i) {
								t.trigger("results:all", {
									data: i,
									query: e
								})
							})
						}), this.on("query:append", function(e) {
							this.dataAdapter.query(e, function(i) {
								t.trigger("results:append", {
									data: i,
									query: e
								})
							})
						}), this.on("keypress", function(e) {
							var i = e.which;
							t.isOpen() ? i === s.ESC || i === s.TAB || i === s.UP && e.altKey ? (t.close(), e.preventDefault()) : i === s.ENTER ? (t.trigger("results:select", {}), e.preventDefault()) : i === s.SPACE && e.ctrlKey ? (t.trigger("results:toggle", {}), e.preventDefault()) : i === s.UP ? (t.trigger("results:previous", {}), e.preventDefault()) : i === s.DOWN && (t.trigger("results:next", {}), e.preventDefault()) : (i === s.ENTER || i === s.SPACE || i === s.DOWN && e.altKey) && (t.open(), e.preventDefault())
						})
					}, n.prototype._syncAttributes = function() {
						this.options.set("disabled", this.$element.prop("disabled")), this.options.get("disabled") ? (this.isOpen() && this.close(), this.trigger("disable", {})) : this.trigger("enable", {})
					}, n.prototype._syncSubtree = function(t, e) {
						var i = !1,
							s = this;
						if (!t || !t.target || "OPTION" === t.target.nodeName || "OPTGROUP" === t.target.nodeName) {
							if (e)
								if (e.addedNodes && e.addedNodes.length > 0)
									for (var n = 0; n < e.addedNodes.length; n++) {
										e.addedNodes[n].selected && (i = !0)
									} else e.removedNodes && e.removedNodes.length > 0 && (i = !0);
								else i = !0;
							i && this.dataAdapter.current(function(t) {
								s.trigger("selection:update", {
									data: t
								})
							})
						}
					}, n.prototype.trigger = function(t, e) {
						var i = n.__super__.trigger,
							s = {
								open: "opening",
								close: "closing",
								select: "selecting",
								unselect: "unselecting"
							};
						if (void 0 === e && (e = {}), t in s) {
							var a = s[t],
								o = {
									prevented: !1,
									name: t,
									args: e
								};
							if (i.call(this, a, o), o.prevented) return void(e.prevented = !0)
						}
						i.call(this, t, e)
					}, n.prototype.toggleDropdown = function() {
						this.options.get("disabled") || (this.isOpen() ? this.close() : this.open())
					}, n.prototype.open = function() {
						this.isOpen() || this.trigger("query", {})
					}, n.prototype.close = function() {
						this.isOpen() && this.trigger("close", {})
					}, n.prototype.isOpen = function() {
						return this.$container.hasClass("select2-container--open")
					}, n.prototype.hasFocus = function() {
						return this.$container.hasClass("select2-container--focus")
					}, n.prototype.focus = function(t) {
						this.hasFocus() || (this.$container.addClass("select2-container--focus"), this.trigger("focus", {}))
					}, n.prototype.enable = function(t) {
						this.options.get("debug") && window.console && console.warn && console.warn('Select2: The `select2("enable")` method has been deprecated and will be removed in later Select2 versions. Use $element.prop("disabled") instead.'), (null == t || 0 === t.length) && (t = [!0]);
						var e = !t[0];
						this.$element.prop("disabled", e)
					}, n.prototype.data = function() {
						this.options.get("debug") && arguments.length > 0 && window.console && console.warn && console.warn('Select2: Data can no longer be set using `select2("data")`. You should consider setting the value instead using `$element.val()`.');
						var t = [];
						return this.dataAdapter.current(function(e) {
							t = e
						}), t
					}, n.prototype.val = function(e) {
						if (this.options.get("debug") && window.console && console.warn && console.warn('Select2: The `select2("val")` method has been deprecated and will be removed in later Select2 versions. Use $element.val() instead.'), null == e || 0 === e.length) return this.$element.val();
						var i = e[0];
						t.isArray(i) && (i = t.map(i, function(t) {
							return t.toString()
						})), this.$element.val(i).trigger("change")
					}, n.prototype.destroy = function() {
						this.$container.remove(), this.$element[0].detachEvent && this.$element[0].detachEvent("onpropertychange", this._syncA), null != this._observer ? (this._observer.disconnect(), this._observer = null) : this.$element[0].removeEventListener && (this.$element[0].removeEventListener("DOMAttrModified", this._syncA, !1), this.$element[0].removeEventListener("DOMNodeInserted", this._syncS, !1), this.$element[0].removeEventListener("DOMNodeRemoved", this._syncS, !1)), this._syncA = null, this._syncS = null, this.$element.off(".select2"), this.$element.attr("tabindex", this.$element.data("old-tabindex")), this.$element.removeClass("select2-hidden-accessible"), this.$element.attr("aria-hidden", "false"), this.$element.removeData("select2"), this.dataAdapter.destroy(), this.selection.destroy(), this.dropdown.destroy(), this.results.destroy(), this.dataAdapter = null, this.selection = null, this.dropdown = null, this.results = null
					}, n.prototype.render = function() {
						var e = t('<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>');
						return e.attr("dir", this.options.get("dir")), this.$container = e, this.$container.addClass("select2-container--" + this.options.get("theme")), e.data("element", this.$element), e
					}, n
				}), e.define("jquery-mousewheel", ["jquery"], function(t) {
					return t
				}), e.define("jquery.select2", ["jquery", "jquery-mousewheel", "./select2/core", "./select2/defaults"], function(t, e, i, s) {
					if (null == t.fn.select2) {
						var n = ["open", "close", "destroy"];
						t.fn.select2 = function(e) {
							if ("object" == typeof(e = e || {})) return this.each(function() {
								var s = t.extend(!0, {}, e);
								new i(t(this), s)
							}), this;
							if ("string" == typeof e) {
								var s, a = Array.prototype.slice.call(arguments, 1);
								return this.each(function() {
									var i = t(this).data("select2");
									null == i && window.console && console.error && console.error("The select2('" + e + "') method was called on an element that is not using Select2."), s = i[e].apply(i, a)
								}), t.inArray(e, n) > -1 ? this : s
							}
							throw new Error("Invalid arguments for Select2: " + e)
						}
					}
					return null == t.fn.select2.defaults && (t.fn.select2.defaults = s), i
				}), {
					define: e.define,
					require: e.require
				}
			}(),
			i = e.require("jquery.select2");
		return t.fn.select2.amd = e, i
	}),
	function(t) {
		t.fn.instagramLite = function(e) {
			if (!this.length) return this;
			self.plugin = this, self.plugin.settings = {}, self.plugin.settings = t.extend({}, {
				username: null,
				clientID: null,
				limit: null,
				list: !0,
				videos: !1,
				urls: !1,
				captions: !1,
				date: !1,
				likes: !1,
				max_id: null,
				loadMore: null,
				error: function() {},
				success: function() {}
			}, e), self.el = t(this), self.loadContent(), plugin.settings.loadMore && t(plugin.settings.loadMore).on("click", function(t) {
				t.preventDefault(), self.loadContent()
			})
		}, getMaxId = function(t) {
			return t[t.length - 1].id
		}, formatCaption = function(t) {
			for (var e = t.split(" "), i = "", s = 0; s < e.length; s++) {
				var n;
				if ("@" == e[s][0]) n = '<a href="http://twitter.com/' + e[s].replace("@", "").toLowerCase() + '" target="_blank">' + e[s] + "</a>";
				else if ("#" == e[s][0]) {
					n = '<a href="http://twitter.com/hashtag/' + e[s].replace("#", "").toLowerCase() + '" target="_blank">' + e[s] + "</a>"
				} else n = e[s];
				i += n + " "
			}
			return i
		}, loadContent = function() {
			plugin.settings.clientID ? el.each(function() {
				var e = "https://api.instagram.com/v1/users/self/media/recent/?access_token=" + plugin.settings.clientID + "&count=" + plugin.settings.limit + "&callback=?";
				e += plugin.settings.max_id ? "&max_id=" + plugin.settings.max_id : "", t.ajax({
					type: "GET",
					url: e,
					dataType: "jsonp",
					success: function(t) {
						if (200 === t.meta.code && t.data.length) {
							for (var e = 0; e < t.data.length; e++) {
								var i, s = t.data[e];
								if ("image" === s.type) {
									if (l = '<img class="il-photo__img" src="' + s.images.standard_resolution.url + '" alt="Instagram Image" data-filter="' + s.filter + '" />', plugin.settings.urls && (l = '<a href="' + s.link + '" target="_blank">' + l + "</a>"), (plugin.settings.captions || plugin.settings.date || plugin.settings.likes) && (l += '<div class="il-photo__meta">'), plugin.settings.captions && s.caption && (l += '<div class="il-photo__caption" data-caption-id="' + s.caption.id + '">' + self.formatCaption(s.caption.text) + "</div>"), plugin.settings.date) {
										var n = new Date(1e3 * s.created_time),
											a = n.getDate(),
											o = n.getMonth() + 1,
											r = n.getFullYear();
										n.getHours(), n.getMinutes(), n.getSeconds();
										l += '<div class="il-photo__date">' + (n = o + "/" + a + "/" + r) + "</div>"
									}
									plugin.settings.likes && (l += '<div class="il-photo__likes">' + s.likes.count + "</div>"), (plugin.settings.captions || plugin.settings.date || plugin.settings.likes) && (l += "</div>")
								}
								if ("video" === s.type && plugin.settings.videos)
									if (s.videos) s.videos.standard_resolution ? i = s.videos.standard_resolution.url : s.videos.low_resolution ? i = s.videos.low_resolution.url : s.videos.low_bandwidth && (i = s.videos.low_bandwidth.url), l = '<video poster="' + s.images.standard_resolution.url + '" controls>', l += '<source src="' + i + '" type="video/mp4;"></source>', l += "</video>";
								if (plugin.settings.list) var l = '<div class="clear"><div class="col-xs-3">' + l + "</div></div>";
								el.append(l)
							}
							plugin.settings.max_id = self.getMaxId(t.data), plugin.settings.success.call(this)
						} else plugin.settings.error.call(this, t.meta.code, t.meta.error_message)
					},
					error: function() {
						plugin.settings.error.call(this)
					}
				})
			}) : alert("An Instagram Access Token is required to display Instagram profile images.")
		}
	}(jQuery), "undefined" == typeof Shopify && (Shopify = {}), Shopify.money_format = "$ {{amount}}", Shopify.onError = function(t, e) {
		var i = jQuery.parseJSON(t.responseText).description;
		"function" != typeof $().magnificPopup ? alert(i) : ($(".product-item-caption-white").append('<div class="error cart-bottom-wrap"><h3>Sorry, looks like something went wrong. Please correct the following and submit again:</h3>' + i + "</div>"), setTimeout(function() {
			$(".product-item-caption-white .error.cart-bottom-wrap").remove()
		}, 8e3))
	}, Shopify.fullMessagesFromErrors = function(t) {
		var e = [];
		return jQuery.each(t, function(t, i) {
			jQuery.each(i, function(i, s) {
				e.push(t + " " + s)
			})
		}), e
	}, Shopify.onCartUpdate = function(t) {
		void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (t = window.BOLD.common.cartDoctor.fix(t)), alert("There are now " + t.item_count + " items in the cart.")
	}, Shopify.onCartShippingRatesUpdate = function(t, e) {
		var i = "";
		e.zip && (i += e.zip + ", "), e.province && (i += e.province + ", "), i += e.country, alert("There are " + t.length + " shipping rates available for " + i + ", starting at " + Shopify.formatMoney(t[0].price) + ".")
	}, Shopify.onItemAdded = function(t) {
		alert(t.title + " was added to your shopping cart.")
	}, Shopify.onProduct = function(t) {
		alert("Received everything we ever wanted to know about " + t.title)
	}, Shopify.formatMoney = function(t, e) {
		"string" == typeof t && (t = t.replace(".", ""));
		var i = "",
			s = /\{\{\s*(\w+)\s*\}\}/,
			n = e || this.money_format;

		function a(t) {
			return t.replace(/(\d+)(\d{3}[\.,]?)/, "$1,$2")
		}
		switch (n.match(s)[1]) {
			case "amount":
				i = a(floatToString(t / 100, 2));
				break;
			case "amount_no_decimals":
				i = a(floatToString(t / 100, 0));
				break;
			case "amount_with_comma_separator":
				i = floatToString(t / 100, 2).replace(/\./, ",");
				break;
			case "amount_no_decimals_with_comma_separator":
				i = a(floatToString(t / 100, 0)).replace(/\./, ",")
		}
		return n.replace(s, i)
	}, Shopify.resizeImage = function(t, e) {
		try {
			if ("original" == e) return t;
			var i = t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
			return i[1] + "_" + e + "." + i[2]
		} catch (e) {
			return t
		}
	}, Shopify.addItem = function(t, e, i) {
		var s = {
			type: "POST",
			url: "/cart/add.js",
			data: "quantity=" + (e = e || 1) + "&id=" + t,
			dataType: "json",
			success: function(t) {
				void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (t = window.BOLD.common.cartDoctor.fixItem(t)), "function" == typeof i ? i(t) : Shopify.onItemAdded(t)
			},
			error: function(t, e) {
				Shopify.onError(t, e)
			}
		};
		jQuery.ajax(s)
	}, Shopify.addItemFromForm = function(t, e) {
		var i = {
			type: "POST",
			url: "/cart/add.js",
			data: window.FormData ? new FormData(jQuery(t)[0]) : jQuery(t).serialize(),
			contentType: !1,
			processData: !1,
			dataType: "json",
			success: function(i) {
				void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (i = window.BOLD.common.cartDoctor.fixItem(i)), "function" == typeof e ? e(i, t) : (Shopify.getCart(Shopify.loadQuickCart), $("#shopify-section-accessories-recommendation").text().trim().length > 0 && setTimeout(function() {
					$("#container-accessories-modal").show(), $(".accessory-product-wrapper").hasClass("slick-initialized") || (console.log("slick inititalized"), $(".accessory-product-wrapper").slick({
						infinite: !0,
						slidesToShow: 3,
						slidesToScroll: 1
					})), $(".accessories-modal-inner").on("click", ".accessory-product-card .addtocart", function(t) {
                      alert("kkkjjj");
                      console.log("kkkkkkkkkkkkkkkkkkkkkkkkqqqqq");
						var e = {
							quantity: 1,
							id: $(this).attr("product-id")
						};
						$.ajax({
							type: "POST",
							url: "/cart/add.js",
							data: e,
							dataType: "json",
							success: function(t) {
								$(this).before("<p class='add-msg'>Product Added</p>")
							},
							error: function(t) {
								console.log(t)
							}
						})
					})
				}, 2e3))
			},
			error: function(t, e) {
				Shopify.onError(t, e)
			}
		};
		jQuery.ajax(i)
	}, Shopify.getCart = function(t) {
		jQuery.getJSON("/cart.js", function(e, i) {
			void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (e = window.BOLD.common.cartDoctor.fix(e)), "function" == typeof t ? t(e) : Shopify.onCartUpdate(e), window.BOLD && BOLD.common && BOLD.common.eventEmitter && "function" == typeof BOLD.common.eventEmitter.emit && BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded", e)
		})
	}, Shopify.getCartCustom = function() {
		jQuery.getJSON("/cart.js", function(t, e) {
			Shopify.updateQuickCart(t), Shopify.afterCartUpdate(t)
		})
	}, Shopify.getCartShippingRatesForDestination = function(t, e) {
		var i = {
			type: "GET",
			url: "/cart/shipping_rates.json",
			data: Shopify.param({
				shipping_address: t
			}),
			dataType: "json",
			success: function(i) {
				rates = i.shipping_rates, "function" == typeof e ? e(rates, t) : Shopify.onCartShippingRatesUpdate(rates, t)
			},
			error: function(t, e) {
				Shopify.onError(t, e)
			}
		};
		jQuery.ajax(i)
	}, Shopify.getProduct = function(t, e) {
		jQuery.getJSON("/products/" + t + ".js", function(t, i) {
			"function" == typeof e ? e(t) : Shopify.onProduct(t)
		})
	}, Shopify.changeItem = function(t, e, i) {
		console.log("Bold_Disabled"), document.querySelectorAll(".cart-line-item").forEach(function(t) {
			t.style = "pointer-events:none"
		});
		var s = {
			type: "POST",
			url: "/cart/change.js",
			data: "quantity=" + e + "&id=" + t,
			dataType: "json",
			success: function(t) {
				void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (t = window.BOLD.common.cartDoctor.fix(t)), "function" == typeof i ? i(t) : Shopify.onCartUpdate(t), window.BOLD && BOLD.common && BOLD.common.eventEmitter && "function" == typeof BOLD.common.eventEmitter.emit && BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded", t)
			},
			error: function(t, e) {
				Shopify.onError(t, e)
			}
		};
		jQuery.ajax(s)
	}, Shopify.removeItem = function(t, e) {
		console.log("Bold_Disabled"), document.querySelectorAll(".cart-line-item").forEach(function(t) {
			t.style = "pointer-events:none"
		});
		var i = {
			type: "POST",
			url: "/cart/change.js",
			data: "quantity=0&id=" + t,
			dataType: "json",
			success: function(t) {
				void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (t = window.BOLD.common.cartDoctor.fix(t)), "function" == typeof e ? e(t) : Shopify.onCartUpdate(t), window.BOLD && BOLD.common && BOLD.common.eventEmitter && "function" == typeof BOLD.common.eventEmitter.emit && BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded", t)
			},
			error: function(t, e) {
				Shopify.onError(t, e)
			}
		};
		jQuery.ajax(i)
	}, Shopify.clear = function(t) {
		var e = {
			type: "POST",
			url: "/cart/clear.js",
			data: "",
			dataType: "json",
			success: function(e) {
				void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (e = window.BOLD.common.cartDoctor.fix(e)), "function" == typeof t ? t(e) : Shopify.onCartUpdate(e)
			},
			error: function(t, e) {
				Shopify.onError(t, e)
			}
		};
		jQuery.ajax(e)
	}, Shopify.updateCartFromForm = function(t, e) {
		var i = {
			type: "POST",
			url: "/cart/update.js",
			data: jQuery(t).serialize(),
			dataType: "json",
			success: function(i) {
				void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (i = window.BOLD.common.cartDoctor.fix(i)), "function" == typeof e ? e(i, t) : Shopify.onCartUpdate(i, t)
			},
			error: function(t, e) {
				Shopify.onError(t, e)
			}
		};
		jQuery.ajax(i)
	}, Shopify.updateCartAttributes = function(t, e) {
		var i = "";
		jQuery.isArray(t) ? jQuery.each(t, function(t, e) {
			var s = attributeToString(e.key);
			"" !== s && (i += "attributes[" + s + "]=" + attributeToString(e.value) + "&")
		}) : "object" == typeof t && null !== t && jQuery.each(t, function(t, e) {
			i += "attributes[" + attributeToString(t) + "]=" + attributeToString(e) + "&"
		});
		var s = {
			type: "POST",
			url: "/cart/update.js",
			data: i,
			dataType: "json",
			success: function(t) {
				void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (t = window.BOLD.common.cartDoctor.fix(t)), "function" == typeof e ? e(t) : Shopify.onCartUpdate(t), window.BOLD && BOLD.common && BOLD.common.eventEmitter && "function" == typeof BOLD.common.eventEmitter.emit && BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded", t)
			},
			error: function(t, e) {
				Shopify.onError(t, e)
			}
		};
		jQuery.ajax(s)
	}, Shopify.updateCartNote = function(t, e) {
		var i = {
			type: "POST",
			url: "/cart/update.js",
			data: "note=" + attributeToString(t),
			dataType: "json",
			success: function(t) {
				void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (t = window.BOLD.common.cartDoctor.fix(t)), "function" == typeof e && e(t)
			},
			error: function(t, e) {
				Shopify.onError(t, e)
			}
		};
		jQuery.ajax(i)
	}, jQuery.fn.jquery >= "1.4" ? Shopify.param = jQuery.param : (Shopify.param = function(t) {
		var e = [],
			i = function(t, i) {
				i = jQuery.isFunction(i) ? i() : i, e[e.length] = encodeURIComponent(t) + "=" + encodeURIComponent(i)
			};
		if (jQuery.isArray(t) || t.jquery) jQuery.each(t, function() {
			i(this.name, this.value)
		});
		else
			for (var s in t) Shopify.buildParams(s, t[s], i);
		return e.join("&").replace(/%20/g, "+")
	}, Shopify.buildParams = function(t, e, i) {
		jQuery.isArray(e) && e.length ? jQuery.each(e, function(e, s) {
			rbracket.test(t) ? i(t, s) : Shopify.buildParams(t + "[" + ("object" == typeof s || jQuery.isArray(s) ? e : "") + "]", s, i)
		}) : null != e && "object" == typeof e ? Shopify.isEmptyObject(e) ? i(t, "") : jQuery.each(e, function(e, s) {
			Shopify.buildParams(t + "[" + e + "]", s, i)
		}) : i(t, e)
	}, Shopify.isEmptyObject = function(t) {
		for (var e in t) return !1;
		return !0
	}),
	function(t) {
		var e = {
			url: !1,
			callback: !1,
			target: !1,
			duration: 120,
			on: "mouseover",
			touch: !0,
			onZoomIn: !1,
			onZoomOut: !1,
			magnify: 1
		};
		t.zoom = function(e, i, s, n) {
			var a, o, r, l, d, c, h, u = t(e).css("position"),
				p = t(i);
			return e.style.position = /(absolute|fixed)/.test(u) ? u : "relative", e.style.overflow = "hidden", s.style.width = s.style.height = "", t(s).addClass("zoomImg").css({
				position: "absolute",
				top: 0,
				left: 0,
				opacity: 0,
				width: s.width * n,
				height: s.height * n,
				border: "none",
				maxWidth: "none",
				maxHeight: "none"
			}).appendTo(e), {
				init: function() {
					o = t(e).outerWidth(), a = t(e).outerHeight(), i === e ? (l = o, r = a) : (l = p.outerWidth(), r = p.outerHeight()), d = (s.width - o) / l, c = (s.height - a) / r, h = p.offset()
				},
				move: function(t) {
					var e = t.pageX - h.left,
						i = t.pageY - h.top;
					i = Math.max(Math.min(i, r), 0), e = Math.max(Math.min(e, l), 0), s.style.left = e * -d + "px", s.style.top = i * -c + "px"
				}
			}
		}, t.fn.zoom = function(i) {
			return this.each(function() {
				var s, n = t.extend({}, e, i || {}),
					a = n.target || this,
					o = this,
					r = t(o),
					l = document.createElement("img"),
					d = t(l),
					c = "mousemove.zoom",
					h = !1,
					u = !1;
				(n.url || ((s = r.find("img"))[0] && (n.url = s.data("src") || s.attr("src")), n.url)) && (function() {
					var t = a.style.position,
						e = a.style.overflow;
					r.one("zoom.destroy", function() {
						r.off(".zoom"), a.style.position = t, a.style.overflow = e, d.remove()
					})
				}(), l.onload = function() {
					function e(e) {
						s.init(), s.move(e), d.stop().fadeTo(t.support.opacity ? n.duration : 0, 1, !!t.isFunction(n.onZoomIn) && n.onZoomIn.call(l))
					}

					function i() {
						d.stop().fadeTo(n.duration, 0, !!t.isFunction(n.onZoomOut) && n.onZoomOut.call(l))
					}
					var s = t.zoom(a, o, l, n.magnify);
					"grab" === n.on ? r.on("mousedown.zoom", function(n) {
						1 === n.which && (t(document).one("mouseup.zoom", function() {
							i(), t(document).off(c, s.move)
						}), e(n), t(document).on(c, s.move), n.preventDefault())
					}) : "click" === n.on ? r.on("click.zoom", function(n) {
						return h ? void 0 : (h = !0, e(n), t(document).on(c, s.move), t(document).one("click.zoom", function() {
							i(), h = !1, t(document).off(c, s.move)
						}), !1)
					}) : "toggle" === n.on ? r.on("click.zoom", function(t) {
						h ? i() : e(t), h = !h
					}) : "mouseover" === n.on && (s.init(), r.on("mouseenter.zoom", e).on("mouseleave.zoom", i).on(c, s.move)), n.touch && r.on("touchstart.zoom", function(t) {
						t.preventDefault(), u ? (u = !1, i()) : (u = !0, e(t.originalEvent.touches[0] || t.originalEvent.changedTouches[0]))
					}).on("touchmove.zoom", function(t) {
						t.preventDefault(), s.move(t.originalEvent.touches[0] || t.originalEvent.changedTouches[0])
					}), t.isFunction(n.callback) && n.callback.call(l)
				}, l.src = n.url)
			})
		}, t.fn.zoom.defaults = e
	}(window.jQuery);




















                  